require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0d21bcaaf9225eaf120e4006b08f507d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0d21bcaaf9225eaf120e4006b08f507d'] = async function fn_0d21bcaaf9225eaf120e4006b08f507d(listToModify) {
  await (async function(array) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.reverse(array)
  })(listToModify);

}

})
define('./functions/0ea1d65b7a2db5c48adc82f4f78b00c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0ea1d65b7a2db5c48adc82f4f78b00c1'] = async function fn_0ea1d65b7a2db5c48adc82f4f78b00c1(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/1267066de2422c12925c26939abeee74/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74'] = async function fn_1267066de2422c12925c26939abeee74(tableName, objectId) {
function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  await (getChannelInstance('default')).send((String('reload-table-records:') + String(tableName)), ({ [`ids`]: [objectId] }));

}

})
define('./functions/137d340f119a283f5c3768d727019038/code.js', () => { 

BackendlessUI.Functions.Custom['fn_137d340f119a283f5c3768d727019038'] = function fn_137d340f119a283f5c3768d727019038(obj, propertiesToKeep) {
var key;


  var key_list = (Object.keys(obj));
  for (var key_index in key_list) {
    key = key_list[key_index];
    if (!(propertiesToKeep.includes(key))) {
      delete obj[key];
    }
  }

}

})
define('./functions/15ca0e8cc5e67ed6b62edeb5642db8ca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ca0e8cc5e67ed6b62edeb5642db8ca'] = async function fn_15ca0e8cc5e67ed6b62edeb5642db8ca(listToCompact) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.compact(array)
})(listToCompact))
}

})
define('./functions/15ceddbd38db9429a0f97a454e8b367a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ceddbd38db9429a0f97a454e8b367a'] = async function fn_15ceddbd38db9429a0f97a454e8b367a(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.take(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/16424e16271fba19226ae38e9f473baa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_16424e16271fba19226ae38e9f473baa'] = async function fn_16424e16271fba19226ae38e9f473baa(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.head(array)
})(listToQuery))
}

})
define('./functions/1c281acb3a51cd63d152afb639d9a49f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1c281acb3a51cd63d152afb639d9a49f'] = async function fn_1c281acb3a51cd63d152afb639d9a49f(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.dropRight(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/26770edb32d2692ee1c4754a799e58cf/code.js', () => { 

BackendlessUI.Functions.Custom['fn_26770edb32d2692ee1c4754a799e58cf'] = async function fn_26770edb32d2692ee1c4754a799e58cf(appData) {
var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  console.log(currentUser);
  if (currentUser == null) {
    (function (message) { alert(message) })('You must be logged in to view this page.');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    return false;
  } else {
    appData['currentUser'] = currentUser;
    // This block gets the ridecare role and permission level
    // for the logged-in user and adds them to the currentUser
    // property in AppData so they can be used elsewhere.
    (getObjectProperty(appData, 'currentUser'))['rideCareUserAttributes'] = (await BackendlessUI.Functions.Custom['fn_839edc5af7af51fbdc87a427321d61a1']((await Backendless.UserService.getUserRoles())));
  }

return true
}

})
define('./functions/26d5effe010a024af594e7ea0151369e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_26d5effe010a024af594e7ea0151369e'] = async function fn_26d5effe010a024af594e7ea0151369e(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/27a3d5b5fe9f5c3e7f0c16ee16cd7b55/code.js', () => { 

BackendlessUI.Functions.Custom['fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55'] = async function fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55(propertyNamePathsList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObjectDeep(props, values)
})(propertyNamePathsList, propertyValuesList))
}

})
define('./functions/2a1538e41c7c2966c613c5082d9cc4a6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2a1538e41c7c2966c613c5082d9cc4a6'] = async function fn_2a1538e41c7c2966c613c5082d9cc4a6(listOfGroupedElements, combinerFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzipWith(array, iteratee)
})(listOfGroupedElements, combinerFunction))
}

})
define('./functions/2ad9e12e9a6364556fe108e7941e302e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2ad9e12e9a6364556fe108e7941e302e'] = async function fn_2ad9e12e9a6364556fe108e7941e302e(newFacilityRecord, dataContainer) {
var facility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dataContainer['existingFacilities'] = (await Backendless.Data.of('Facility').find(Backendless.DataQueryBuilder.create().setWhereClause((['zipcode = \'',(getObjectProperty(newFacilityRecord, 'zipcode')),'\''].join(''))).setPageSize(10)));
  console.log(getObjectProperty(dataContainer, 'existingFacilities'));
  if ((getObjectProperty(dataContainer, 'existingFacilities')).length == 0) {
    console.log('No existing facilities were found in this zip code.');
    return false;
  }
  var facility_list = (getObjectProperty(dataContainer, 'existingFacilities'));
  for (var facility_index in facility_list) {
    facility = facility_list[facility_index];
    facility['geographicDistance'] = (await (async function(lat1, lon1, lat2, lon2) {

    	  const earthRadiusMiles = 3959; // Earth radius in miles

    	  const lat1Rad = lat1 * Math.PI / 180; // Convert degrees to radians
    	  const lat2Rad = lat2 * Math.PI / 180;

    	  const dLat = lat2Rad - lat1Rad;
    	  const dLon = (lon2 - lon1) * Math.PI / 180;

    	  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    	            Math.cos(lat1Rad) * Math.cos(lat2Rad) *
    	            Math.sin(dLon / 2) * Math.sin(dLon / 2);

    	  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    	  const distance = earthRadiusMiles * c;

    	  console.log("Distance Calculated: ", distance);

    	  return distance;

    })((getObjectProperty(newFacilityRecord, 'latitude')), (getObjectProperty(newFacilityRecord, 'longitude')), (getObjectProperty(facility, 'latitude')), (getObjectProperty(facility, 'longitude'))));
    console.log(getObjectProperty(facility, 'geographicDistance'));
    if ((getObjectProperty(facility, 'geographicDistance')) <= 0.5) {
      console.log(String('newFacilityRecord was found to match the existing facility: ') + String(getObjectProperty(facility, 'googleFormattedAddress')));
      dataContainer[newFacilityRecord] = facility;
      return true;
    } else {
      console.log('No matches were found.  newFacilityRecord will be added to the Facility table.');
      return false;
    }
  }

return 
}

})
define('./functions/2bab1b7406627074e9c73f97d5958322/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2bab1b7406627074e9c73f97d5958322'] = async function fn_2bab1b7406627074e9c73f97d5958322(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.initial(array)
})(listToQuery))
}

})
define('./functions/2bca3fcbfcf61fd799e8885f6b51eeb1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2bca3fcbfcf61fd799e8885f6b51eeb1'] = function fn_2bca3fcbfcf61fd799e8885f6b51eeb1(container) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  container['nearbyExistingFacilities'] = [];
  container['selectedNearbyExistingFacility'] = null;
  if ((getObjectProperty(container, 'locationType')) == 'pickUp') {
    container['showNewPickUpFacilityMessage'] = true;
    container['pickUpFacilityAddressMessage'] = 'This address will be added to our Facility database.';
  }
  if ((getObjectProperty(container, 'locationType')) == 'destination') {
    container['showNewDestinationFacilityMessage'] = true;
    container['destinationFacilityAddressMessage'] = 'This address will be added to our Facility database.';
  }
  if ((getObjectProperty(container, 'locationType')) == 'newFacility' || (getObjectProperty(container, 'locationType')) == 'updateFacility') {
    container['showNewFacilityMessage'] = true;
    container['facilityAddressMessage'] = 'This address will be added to our Facility database.';
  }
  container['showSelectExistingFacilityModal'] = false;

}

})
define('./functions/33f4c01b8e8eda17aee5c5294b33b8fc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_33f4c01b8e8eda17aee5c5294b33b8fc'] = async function fn_33f4c01b8e8eda17aee5c5294b33b8fc(listsToProcess) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zip(...arrays)
})(listsToProcess))
}

})
define('./functions/353440ef7fa2e9257227e5c5351d9062/code.js', () => { 

BackendlessUI.Functions.Custom['fn_353440ef7fa2e9257227e5c5351d9062'] = async function fn_353440ef7fa2e9257227e5c5351d9062(newFacilityRecord, dataContainer) {
var nearbyExistingFacilities, uniqueFacilities, j, uniqueKeys, i, key, foundDuplicate, existingKey, existingItem, address, existingAddress, lng, existingLng, lat, existingLat, keys, facility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dataContainer['existingFacilities'] = (await Backendless.Data.of('Facility').find(Backendless.DataQueryBuilder.create().setWhereClause((['zipcode = \'',(getObjectProperty(newFacilityRecord, 'zipcode')),'\''].join(''))).setPageSize(100)));
  nearbyExistingFacilities = [];
  uniqueFacilities = ({  });
  var i_list = (await asyncListFilter((getObjectProperty(dataContainer, 'existingFacilities')), async (facility) => {


   return ((await (async function(lat1, lon1, lat2, lon2) {

  	  const earthRadiusMiles = 3959; // Earth radius in miles

  	  const lat1Rad = lat1 * Math.PI / 180; // Convert degrees to radians
  	  const lat2Rad = lat2 * Math.PI / 180;

  	  const dLat = lat2Rad - lat1Rad;
  	  const dLon = (lon2 - lon1) * Math.PI / 180;

  	  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  	            Math.cos(lat1Rad) * Math.cos(lat2Rad) *
  	            Math.sin(dLon / 2) * Math.sin(dLon / 2);

  	  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  	  const distance = earthRadiusMiles * c;

  	  console.log("Distance Calculated: ", distance);

  	  return distance;

  })((getObjectProperty(newFacilityRecord, 'latitude')), (getObjectProperty(newFacilityRecord, 'longitude')), (getObjectProperty(facility, 'latitude')), (getObjectProperty(facility, 'longitude')))) <= 1);
  }));
  for (var i_index in i_list) {
    i = i_list[i_index];
    key = (getObjectProperty(i, 'googlePlaceId'));
    lat = (Number.parseFloat((getObjectProperty(i, 'latitude'))).toFixed(3));
    lng = (Number.parseFloat((getObjectProperty(i, 'longitude'))).toFixed(3));
    address = (getObjectProperty(i, 'googleFormattedAddress'));
    foundDuplicate = false;
    if (getObjectProperty(uniqueFacilities, key)) {
      if ((getObjectProperty((getObjectProperty(uniqueFacilities, key)), 'created')) > (getObjectProperty(i, 'created'))) {
        uniqueFacilities[key] = i;
      }
      foundDuplicate = true;
    } else {
      keys = (Object.keys(uniqueFacilities));
      for (var existingKey_index in keys) {
        existingKey = keys[existingKey_index];
        existingItem = (getObjectProperty(uniqueFacilities, existingKey));
        existingLat = (Number.parseFloat((getObjectProperty(existingItem, 'latitude'))).toFixed(3));
        existingLng = (Number.parseFloat((getObjectProperty(existingItem, 'longitude'))).toFixed(3));
        existingAddress = (getObjectProperty(existingItem, 'googleFormattedAddress'));
        if (existingLat == lat && existingLng == lng && existingAddress == address) {
          if ((getObjectProperty(existingItem, 'created')) > (getObjectProperty(i, 'created'))) {
            uniqueFacilities[existingKey] = i;
          }
          foundDuplicate = true;
          break;
        }
      }
    }
    if (!foundDuplicate) {
      uniqueFacilities[key] = i;
    }
    console.log('uniq');
    console.log(uniqueFacilities);
  }
  uniqueKeys = (Object.keys(uniqueFacilities));
  console.log(JSON.parse((JSON.stringify(newFacilityRecord))));
  for (var j_index in uniqueKeys) {
    j = uniqueKeys[j_index];
    if ((getObjectProperty(newFacilityRecord, 'googleFormattedAddress')) == (getObjectProperty((getObjectProperty(uniqueFacilities, j)), 'googleFormattedAddress')) && (Number.parseFloat((getObjectProperty(newFacilityRecord, 'latitude'))).toFixed(3)) == (Number.parseFloat((getObjectProperty((getObjectProperty(uniqueFacilities, j)), 'latitude'))).toFixed(3)) && (Number.parseFloat((getObjectProperty(newFacilityRecord, 'longitude'))).toFixed(3)) == (Number.parseFloat((getObjectProperty((getObjectProperty(uniqueFacilities, j)), 'longitude'))).toFixed(3))) {
      return (getObjectProperty(uniqueFacilities, j));
    }
    addItemToList(nearbyExistingFacilities, (getObjectProperty(uniqueFacilities, j)));
  }

return nearbyExistingFacilities
}

})
define('./functions/3585a9c2fce2fe3521c9afc37ef5f2d7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3585a9c2fce2fe3521c9afc37ef5f2d7'] = async function fn_3585a9c2fce2fe3521c9afc37ef5f2d7(dateString) {
return (await (async function(dateString) {
	// Get current timezone offset in minutes
	return Math.floor(new Date(dateString).getTimezoneOffset())/60
	/*
	// Get current timezone offset in minutes
	let timezoneOffset = new Date().getTimezoneOffset();

	// Convert it to hours and minutes
	let offsetHours = Math.floor(timezoneOffset / 60);
	let offsetMinutes = timezoneOffset % 60;
	*/
})(dateString))
}

})
define('./functions/3626f4a1aac8092dc66553f6b0eebbc8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8'] = function fn_3626f4a1aac8092dc66553f6b0eebbc8(fullURLstring, blDirAfterRoot) {
return (fullURLstring.slice(((fullURLstring.indexOf(blDirAfterRoot) + 1) - 1), fullURLstring.length))
}

})
define('./functions/37a70893d34d348151130eb779d90624/code.js', () => { 

BackendlessUI.Functions.Custom['fn_37a70893d34d348151130eb779d90624'] = async function fn_37a70893d34d348151130eb779d90624(listsToProcess, combinerFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipWith(...arrays, iteratee)
})(listsToProcess, combinerFunction))
}

})
define('./functions/38c2ffe50d0e5cca36f20903850cc95a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_38c2ffe50d0e5cca36f20903850cc95a'] = async function fn_38c2ffe50d0e5cca36f20903850cc95a(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.last(array)
})(listToQuery))
}

})
define('./functions/3a17163a8ed3566b1d770b133f9e456c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3a17163a8ed3566b1d770b133f9e456c'] = async function fn_3a17163a8ed3566b1d770b133f9e456c(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/3b22bf56ea095bef299e80632005db52/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3b22bf56ea095bef299e80632005db52'] = async function fn_3b22bf56ea095bef299e80632005db52(listToProcess, chunkLength) {
return (await (async function(array, size) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (size == null) {
	  size = 1
	}

	return _.chunk(array, size)
})(listToProcess, chunkLength))
}

})
define('./functions/3da675c9560df4688c120284991f799e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3da675c9560df4688c120284991f799e'] = async function fn_3da675c9560df4688c120284991f799e(listToInspect, valuesToExclude, comparatorFunction) {
return (await (async function(array, values, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceWith(array, values, comparator)
})(listToInspect, valuesToExclude, comparatorFunction))
}

})
define('./functions/4305c6b3c9678eaff3f213c4ef4213e4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4305c6b3c9678eaff3f213c4ef4213e4'] = async function fn_4305c6b3c9678eaff3f213c4ef4213e4(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.tail(array)
})(listToQuery))
}

})
define('./functions/454c6bd355d3e44aa4bcfde8e1611028/code.js', () => { 

BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028'] = function fn_454c6bd355d3e44aa4bcfde8e1611028(rawPhoneString) {
return (['(',rawPhoneString.slice(0, 3),') ',rawPhoneString.slice(3, 6),'-',rawPhoneString.slice(6, rawPhoneString.length)].join(''))
}

})
define('./functions/45e840d979f666875cfc9d9849ef3d28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_45e840d979f666875cfc9d9849ef3d28'] = async function fn_45e840d979f666875cfc9d9849ef3d28(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/461d17e665f8b6391823125f6307ab14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_461d17e665f8b6391823125f6307ab14'] = async function fn_461d17e665f8b6391823125f6307ab14(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniq(array)
})(listToInspect))
}

})
define('./functions/486ef78363267883c1df0cc331fd1a59/code.js', () => { 

BackendlessUI.Functions.Custom['fn_486ef78363267883c1df0cc331fd1a59'] = async function fn_486ef78363267883c1df0cc331fd1a59(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.without(array, ...values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/4a82504ac5a365b515498484f6caee02/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'] = async function fn_4a82504ac5a365b515498484f6caee02(tableName, whereClause, propertiesToInclude, propertiesToExclude, propertiesToSortBy, relations) {
var allCustomers, loading, currentBatch, offset;


  loading = true;
  allCustomers = [];
  offset = 0;
  while (loading) {
    currentBatch = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties(propertiesToInclude).excludeProperties(propertiesToExclude).setRelated(relations).setSortBy(propertiesToSortBy).setPageSize(100).setOffset(offset)));
    allCustomers = (allCustomers.concat(currentBatch));
    offset = offset + 100;
    if (currentBatch.length < 100) {
      loading = false;
    }
  }

return allCustomers
}

})
define('./functions/4cb910622f862deed7d75d5b7699dd27/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27'] = async function fn_4cb910622f862deed7d75d5b7699dd27(record) {
var errorMessage, emptyFields, zipcode, stateCode, city, streetNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('record');
  console.log(record);
  streetNumber = (getObjectProperty(record, 'streetNumber'));
  city = (getObjectProperty(record, 'city'));
  stateCode = (getObjectProperty(record, 'stateCode'));
  zipcode = (getObjectProperty(record, 'zipcode'));
  if (!city || !stateCode || !streetNumber || !zipcode) {
    emptyFields = [];
    if (!streetNumber) {
      addItemToList(emptyFields, 'Street Number');
    }
    if (!city) {
      addItemToList(emptyFields, 'City');
    }
    if (!stateCode) {
      addItemToList(emptyFields, 'State Code');
    }
    if (!zipcode) {
      addItemToList(emptyFields, 'Zipcode');
    }
    errorMessage = ['The selected address is incorrect because it is missing the following field(s): ',emptyFields.join(', '),'. Please select a different address.'].join('');
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (message) { alert(message) })(errorMessage);
    await new Promise(r => setTimeout(r, 100 || 0));
    record['googleFormattedAddress'] = '';
    record['name'] = '';
    record['googleName'] = '';
    record['isPrivateResidence'] = null;
    return false;
  }
  delete record['streetNumber'];

return true
}

})
define('./functions/4cf12a1449b890f2c42b8fe2a753bc14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4cf12a1449b890f2c42b8fe2a753bc14'] = async function fn_4cf12a1449b890f2c42b8fe2a753bc14(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/520e5b11f44ee8f88266875f0285766e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_520e5b11f44ee8f88266875f0285766e'] = async function fn_520e5b11f44ee8f88266875f0285766e(propertyNamesList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObject(props, values)
})(propertyNamesList, propertyValuesList))
}

})
define('./functions/52fdb524073bbad39dd107b4c7541e2d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_52fdb524073bbad39dd107b4c7541e2d'] = async function fn_52fdb524073bbad39dd107b4c7541e2d(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/56599adc54c74c9fdbc667193c854a77/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56599adc54c74c9fdbc667193c854a77'] = async function fn_56599adc54c74c9fdbc667193c854a77(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.drop(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/56884591a118bc7af84daa6bfc0ea942/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56884591a118bc7af84daa6bfc0ea942'] = async function fn_56884591a118bc7af84daa6bfc0ea942(listToModify, valuesToRemove, filterFunction) {
  await (async function(array, values, iteratee) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllBy(array, values, iteratee)
  })(listToModify, valuesToRemove, filterFunction);

}

})
define('./functions/58ac96052b6cbe4266b47f18e18aecef/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58ac96052b6cbe4266b47f18e18aecef'] = async function fn_58ac96052b6cbe4266b47f18e18aecef(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/58b599fc79a1984718ac68445dc7b9e6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58b599fc79a1984718ac68445dc7b9e6'] = async function fn_58b599fc79a1984718ac68445dc7b9e6(listToFill, valueToFillListWith, startPosition, endPosition) {
  await (async function(array, value, start, end) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	if (start == null) {
  	  start = 0
  	}
  	if (end == null) {
  	  end = array.length
  	}

  	_.fill(array, value, start, end)
  })(listToFill, valueToFillListWith, startPosition, endPosition);

}

})
define('./functions/58db38bddf2dcf8f42d5e5214a01acc1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58db38bddf2dcf8f42d5e5214a01acc1'] = async function fn_58db38bddf2dcf8f42d5e5214a01acc1(listOfGroupedElements) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzip(array)
})(listOfGroupedElements))
}

})
define('./functions/58f43615b3a18b74c5b8d439a61e9b2d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58f43615b3a18b74c5b8d439a61e9b2d'] = async function fn_58f43615b3a18b74c5b8d439a61e9b2d(pageData, tableName, recordItem, ___arguments) {
var waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3c59f53370959bfeb083a46455c7659c');
  waitCount = 0;
  while ((getObjectProperty(pageData, 'deleteRecord')) == null && waitCount <= 20) {
    await new Promise(r => setTimeout(r, 1000 || 0));
    waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
  }
  // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
  if ((getObjectProperty(pageData, 'deleteRecord')) == null) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3c59f53370959bfeb083a46455c7659c');
    if (waitCount >= 20) {
      (function (message) { alert(message) })('Delete operation timed out after 30s.');
    }
    return ;
  } else if ((getObjectProperty(pageData, 'deleteRecord')) == true) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3c59f53370959bfeb083a46455c7659c');
    await Backendless.Data.of(tableName).remove( recordItem );
    // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
    pageData['deleteRecord'] = null;
  }

return 
}

})
define('./functions/5aa80c3936bd19c8f14dd135542b64be/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5aa80c3936bd19c8f14dd135542b64be'] = async function fn_5aa80c3936bd19c8f14dd135542b64be(listsTonspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorBy(...arrays, iteratee)
})(listsTonspect, filterFunction))
}

})
define('./functions/5e3d747678a122a896439d3f05f6fb88/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5e3d747678a122a896439d3f05f6fb88'] = async function fn_5e3d747678a122a896439d3f05f6fb88(gridApi, fileName) {
  await (async function(gridApi, fileName) {
  	// Get current date and time
  	const now = new Date();
  	const formattedDate =
  	  ('0' + (now.getMonth() + 1)).slice(-2) + '-' +     // Month
  	  ('0' + now.getDate()).slice(-2) + '-' +            // Day
  	  now.getFullYear() +                               // Year
  	  '(' + ('0' + now.getHours()).slice(-2) + '-' +     // Hour
  	  ('0' + now.getMinutes()).slice(-2) + '-' +         // Minutes
  	  ('0' + now.getSeconds()).slice(-2) + ')';          // Seconds

  	// Update params to include formatted date and time in the file name
  	const params = {
  	  fileName: (fileName),    // Name of the exported CSV file with date and time
  	  onlySelected: false,          // If true, only selected rows will be exported
  	  allColumns: true,             // If true, all columns (including hidden ones) will be exported
  	  columnSeparator: ';',         // Separator used between columns in the CSV file (default is a comma)
  	  skipHeader: false,            // If true, headers will be skipped in the CSV export
  	}

  	// Use the ag-Grid API to export data as CSV
  	gridApi.exportDataAsCsv(params);
  })(gridApi, fileName);

}

})
define('./functions/601f96e6c6e413ff585a05b78783325d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_601f96e6c6e413ff585a05b78783325d'] = async function fn_601f96e6c6e413ff585a05b78783325d(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/638eba35877693befcc18599a2221a2d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_638eba35877693befcc18599a2221a2d'] = async function fn_638eba35877693befcc18599a2221a2d(textToCopy) {
  await (async function(textToCopy) {
  	navigator.clipboard.writeText(textToCopy);
  })(textToCopy);

return 
}

})
define('./functions/6b8a6ab24cb2d274311c9db97caaf605/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6b8a6ab24cb2d274311c9db97caaf605'] = function fn_6b8a6ab24cb2d274311c9db97caaf605(obj) {
var key;


  var key_list = (Object.keys(obj));
  for (var key_index in key_list) {
    key = key_list[key_index];
    obj[key] = null;
  }

return obj
}

})
define('./functions/7255f85fc6a82072e01d2b1fe97e5234/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234'] = function fn_7255f85fc6a82072e01d2b1fe97e5234(obj) {
var key;


  var key_list = (Object.keys(obj));
  for (var key_index in key_list) {
    key = key_list[key_index];
    delete obj[key];
  }

return 
}

})
define('./functions/74c621ab98a12163bece4cad7be292b9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_74c621ab98a12163bece4cad7be292b9'] = async function fn_74c621ab98a12163bece4cad7be292b9(listToConcatenate, valuesToConcatenate) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.concat(array, ...values)
})(listToConcatenate, valuesToConcatenate))
}

})
define('./functions/7508d2443aea24ba74d73b27671a9829/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7508d2443aea24ba74d73b27671a9829'] = async function fn_7508d2443aea24ba74d73b27671a9829(listToModify, indexesOfElementsToRemove) {
return (await (async function(array, indexes) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.pullAt(array, ...indexes)
})(listToModify, indexesOfElementsToRemove))
}

})
define('./functions/77bed231064ec0e2a7d4ac07f751667a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_77bed231064ec0e2a7d4ac07f751667a'] = async function fn_77bed231064ec0e2a7d4ac07f751667a(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.findIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/79a6f77258336011dee2ccdfcf062c76/code.js', () => { 

BackendlessUI.Functions.Custom['fn_79a6f77258336011dee2ccdfcf062c76'] = async function fn_79a6f77258336011dee2ccdfcf062c76(listToInspect, valuesToExclude, filterFunction) {
return (await (async function(array, values, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceBy(array, values, iteratee)
})(listToInspect, valuesToExclude, filterFunction))
}

})
define('./functions/7a189d46e174c168a4eaf19ed0aca19c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7a189d46e174c168a4eaf19ed0aca19c'] = async function fn_7a189d46e174c168a4eaf19ed0aca19c(filePath, Object1, Object2, Object3, Object4, Object5, Object6) {
function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}



return (await Backendless.Files.saveFile(encodePath(filePath), ((String((new Date()).valueOf()) + String('.txt')).replace((new RegExp('\\s', 'g')), '-')), ([((JSON.stringify(Object1)).replace((new RegExp(',\\s?', 'g')), '\n')),'\n \n',Object2 ? ((JSON.stringify(Object2)).replace((new RegExp(',\\s?', 'g')), '\n')) : '','\n \n',Object3 ? ((JSON.stringify(Object3)).replace((new RegExp(',\\s?', 'g')), '\n')) : '','\n \n',Object4 ? ((JSON.stringify(Object4)).replace((new RegExp(',\\s?', 'g')), '\n')) : '','\n \n',Object5 ? ((JSON.stringify(Object5)).replace((new RegExp(',\\s?', 'g')), '\n')) : '','\n \n',Object6 ? ((JSON.stringify(Object6)).replace((new RegExp(',\\s?', 'g')), '\n')) : ''].join('')), false))
}

})
define('./functions/7a7432436e1adb89603731f3376be10c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7a7432436e1adb89603731f3376be10c'] = function fn_7a7432436e1adb89603731f3376be10c(number, decimals) {
var factor, returnVar;


  if (!(typeof number === 'undefined')) {
    factor = Math.pow(10,decimals);
    returnVar = Math.round(number * factor) / factor;
  } else {
    returnVar = null;
  }

return returnVar
}

})
define('./functions/7bd98f3e8e1d5a6571e78cd4492f75a8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7bd98f3e8e1d5a6571e78cd4492f75a8'] = async function fn_7bd98f3e8e1d5a6571e78cd4492f75a8(listToModify, valuesToRemove, comparatorFunction) {
  await (async function(array, values, comparator) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllWith(array, values, comparator)
  })(listToModify, valuesToRemove, comparatorFunction);

}

})
define('./functions/7e649ea1525e52829e82c43fc4f84e2f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7e649ea1525e52829e82c43fc4f84e2f'] = async function fn_7e649ea1525e52829e82c43fc4f84e2f(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flatten(array)
})(listToFlatten))
}

})
define('./functions/839edc5af7af51fbdc87a427321d61a1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_839edc5af7af51fbdc87a427321d61a1'] = function fn_839edc5af7af51fbdc87a427321d61a1(currentUserRoles) {
var permissionLevel, role;


  if (currentUserRoles.includes('SuperAdmin')) {
    role = 'Super Admin';
    permissionLevel = 8;
  } else if (currentUserRoles.includes('HumanResources')) {
    role = 'Human Resources';
    permissionLevel = 7;
  } else if (currentUserRoles.includes('Accounting')) {
    role = 'Accounting';
    permissionLevel = 6;
  } else if (currentUserRoles.includes('Admin')) {
    role = 'Admin';
    permissionLevel = 5;
  } else if (currentUserRoles.includes('FleetManager')) {
    role = 'Fleet Manager';
    permissionLevel = 4;
  } else if (currentUserRoles.includes('Manager')) {
    role = 'Manager';
    permissionLevel = 3;
  } else if (currentUserRoles.includes('Dispatcher')) {
    role = 'Dispatcher';
    permissionLevel = 2;
  } else if (currentUserRoles.includes('Driver')) {
    role = 'Driver';
    permissionLevel = 1;
  } else {
    role = 'None';
    permissionLevel = 0;
  }

return ({ [`role`]: role,[`permissionLevel`]: permissionLevel })
}

})
define('./functions/84c352dcf0d18e7fa2ca41bb0fa92c91/code.js', () => { 

BackendlessUI.Functions.Custom['fn_84c352dcf0d18e7fa2ca41bb0fa92c91'] = async function fn_84c352dcf0d18e7fa2ca41bb0fa92c91(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/854e825608123b86707265b1cfb74f87/code.js', () => { 

BackendlessUI.Functions.Custom['fn_854e825608123b86707265b1cfb74f87'] = async function fn_854e825608123b86707265b1cfb74f87(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/85a179468c6dd16157c81f324fd775ca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_85a179468c6dd16157c81f324fd775ca'] = async function fn_85a179468c6dd16157c81f324fd775ca(origin, duplicate) {
var error, duplicate, originFacility, j, transportRequestsPickup, transportRequestsDestination, origin;


  try {
    transportRequestsPickup = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['relPickup_Facility.objectId = \'',duplicate,'\''].join(''))).setRelationsDepth(1).setPageSize(100)));
    transportRequestsDestination = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['relDestination_Facility.objectId = \'',duplicate,'\''].join(''))).setRelationsDepth(1).setPageSize(100)));
    originFacility = (await Backendless.Data.of('Facility').findById(origin, ));
    console.log('%c>> ' + 'pickup', 'color: #f06292', transportRequestsPickup);
    console.log('%c>> ' + 'destination', 'color: #ab47bc', transportRequestsDestination);
    console.log('%c>> ' + 'origin', 'color: #4caf50', originFacility);
    for (var j_index in transportRequestsDestination) {
      j = transportRequestsDestination[j_index];
      await Backendless.Data.of('TransportRequest').setRelation(j, 'relDestination_Facility', [originFacility]);
    }
    for (var j_index2 in transportRequestsPickup) {
      j = transportRequestsPickup[j_index2];
      await Backendless.Data.of('TransportRequest').setRelation(j, 'relPickup_Facility', [originFacility]);
    }
    await Backendless.Data.of('Facility').remove( duplicate );

  } catch (error) {
    console.log(error);

  }

return true
}

})
define('./functions/8a3a501e691a2d6b06396f7b66987467/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467'] = async function fn_8a3a501e691a2d6b06396f7b66987467() {
var x, test, test2;



return (await (async function() {
	const ns = window.dataGridSharedNamespace = window.dataGridSharedNamespace || {}
	
	
	// Renders Checkboxes into YES / NO Text
	if (!ns.checkboxYesNoCellRenderer) {
	  ns.checkboxYesNoCellRenderer = ({ value }) => {
	    return value ? 'YES' : 'NO'
	  }
	}
	
	
	// Renders Checkboxes as VOID or blank text
	if (!ns.checkboxVoidCellRenderer) {
	  ns.checkboxVoidCellRenderer = ({ value }) => {
	    return value ? 'VOID' : ''
	  }
	}
	
	
	// Renders Checkboxes where true will be a green check mark
	if (!ns.checkboxCheckmarkCellRenderer) {
	  ns.checkboxCheckmarkCellRenderer = ({ value }) => {
	    if(value) {
	      return React.createElement('img', {
	        src:'https://app.okridecare.com/api/files/Images/Icons/GreenCheckMark-Transparent.png', 
	        style: {
	          // default is height and width: '27px',
	          height: '24px'
	        }
	      })
	    }
	    return null
	  }
	}
	
	// Renders Checkboxes where true will be a red exclamation point
	if (!ns.checkboxExclamationCheckCellRenderer) {
	  ns.checkboxExclamationCheckCellRenderer = ({ value }) => {
	    if(value) {
	      return React.createElement('img', {
	        src:'https://app.okridecare.com/api/files/Images/Icons/RedExclamationPoint-Transparent.png', 
	        style: {
	          // default is height and width: '27px',
	          height: '24px'
	        }
	      })
	    }
	    return null
	  }
	}
	
	
	// Renders Checkboxes where true will be a red warning triangle
	if (!ns.checkboxWarningTriangleCellRenderer) {
	  ns.checkboxWarningTriangleCellRenderer = ({ value }) => {
	    if(value) {
	      return React.createElement('img', {
	        src:'https://app.okridecare.com/api/files/Images/Icons/RedWarningTriangle-Transparent.png', 
	        style: {
	          // default is height and width: '27px',
	          height: '24px'
	        }
	      })
	    }
	    return null
	  }
	}
	
	// valueGetter for formatting strings to two decimal places
	if (!ns.stringToFixedValueGetter) {
	  ns.stringToFixedValueGetter = (params, precision = 2) => {
	    const value = params.data[params.colDef.field];
	
	    return value != null ? parseFloat(value).toFixed(precision) : '';
	  }
	}
	
	// valueGetter for trimming milliseconds and seconds from a time string, keeping only hours and minutes
	if (!ns.trimTimeStringValueGetter) {
	  ns.trimTimeStringValueGetter = (params) => {
	    const value = params.data[params.colDef.field];
	    
	    if (!value || !value.includes(':')) {
	      return '';
	    }
	
	    const parts = value.split(':');
	
	    return parts[0] + ':' + parts[1];
	  }
	}
	
	if (!ns.phoneNumberValueFormatter) {
	  ns.phoneNumberValueFormatter = (params) => {
	    const value = params.value;
	    
	    if (!value) {
	      return '';
	    }
	
	    const digits = value.replace(/\D/g, '');
	
	    if (digits.length < 10) {
	      return value;
	    }
	
	    // (XXX) XXX-XXXX
	    const formatted = digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	    
	    return formatted;
	  }
	}
	
	if (!ns.dateTimeValueFormatter) {
	  ns.dateTimeValueFormatter = (params) => {
	    const timestamp = params.value;
	
	    if (!timestamp) {
	      return '';
	    }
	
	    // Convert timestamp to milliseconds and create a Date object
	    const date = new Date(Number(timestamp));
	
	    // Get the individual date components
	    const year = date.getFullYear();
	    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
	    const day = String(date.getDate()).padStart(2, '0');
	    const hours = String(date.getHours()).padStart(2, '0');
	    const minutes = String(date.getMinutes()).padStart(2, '0');
	    const seconds = String(date.getSeconds()).padStart(2, '0');
	
	    // Format the date string
	    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	    
	    return formattedDate;
	  }
	}
	
	if (!ns.ssnValueFormatter) {
	  ns.ssnValueFormatter = (params) => {
	    const value = params.value;
	    
	    if (!value) {
	      return '';
	    }
	
	    const digits = value.replace(/\D/g, '');
	
	    if (digits.length < 9) {
	      return value;
	    }
	
	    // XXX-XXX-XXXX
	    const formatted = digits.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
	    
	    return formatted;
	  }
	}
	
	if (!ns.currencyValueFormatter) {
	  ns.currencyValueFormatter = params => {
	    const value = params.value;
	    
	    if (value !== undefined && value !== null && !isNaN(value)) {
	      return '$' + parseFloat(value).toFixed(2);
	    }
	    
	    return value;
	  }
	}
	
	if (!ns.numberWithCommasValueFormatter) {
	  ns.numberWithCommasValueFormatter = params => {
	    const value = params.value;
	    
	    if (value !== undefined && value !== null && !isNaN(value)) {
	      return parseInt(value, 10).toLocaleString('en-US');
	    }
	    
	    return value;
	  }
	}
	
	
	return ns
})())
}

})
define('./functions/8c6afca1481cdc048f1c296a77be1975/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8c6afca1481cdc048f1c296a77be1975'] = async function fn_8c6afca1481cdc048f1c296a77be1975(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flattenDeep(array)
})(listToFlatten))
}

})
define('./functions/8f4b34774e84b8b3681c852e49ed1ac5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8f4b34774e84b8b3681c852e49ed1ac5'] = async function fn_8f4b34774e84b8b3681c852e49ed1ac5(listToSlice, startPosition, endPosition) {
return (await (async function(array, start, end) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (start == null) {
	  start = 0
	}

	if (end == null) {
	  end = array.length
	}

	return _.slice(array, start, end)
})(listToSlice, startPosition, endPosition))
}

})
define('./functions/9339eea9fc6cd4337ba30a3da3c59d69/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9339eea9fc6cd4337ba30a3da3c59d69'] = async function fn_9339eea9fc6cd4337ba30a3da3c59d69(selector, attributeName) {
  await (async function(selector, attributeName) {
  	const elem = document.querySelector(selector)

  	elem.removeAttribute(attributeName)
  })(selector, attributeName);

}

})
define('./functions/9458f55be4fb02eee2e72e0b6b1c347c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9458f55be4fb02eee2e72e0b6b1c347c'] = async function fn_9458f55be4fb02eee2e72e0b6b1c347c(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/95a8a1ed4f6da56382e43a6149f25d0c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_95a8a1ed4f6da56382e43a6149f25d0c'] = async function fn_95a8a1ed4f6da56382e43a6149f25d0c(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeRightWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/9743fcc6f0cc18c8ec28a5f4d0d17e34/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9743fcc6f0cc18c8ec28a5f4d0d17e34'] = async function fn_9743fcc6f0cc18c8ec28a5f4d0d17e34(listToModify, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.remove(array, predicate)
})(listToModify, valuePickerFunction))
}

})
define('./functions/9ef225438f774527c9eb1feb6044ce26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9ef225438f774527c9eb1feb6044ce26'] = async function fn_9ef225438f774527c9eb1feb6044ce26(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/a1856c74d27745ecf1c18a8269e6103d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a1856c74d27745ecf1c18a8269e6103d'] = async function fn_a1856c74d27745ecf1c18a8269e6103d(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	    fromIndex = array.length - 1
	}

	return _.findLastIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/a376d7d6007e9dbebe6eea15750b4b61/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a376d7d6007e9dbebe6eea15750b4b61'] = async function fn_a376d7d6007e9dbebe6eea15750b4b61(listToInspect, comparatorFunction) {
return (await (async function(array, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqWith(array, comparator)
})(listToInspect, comparatorFunction))
}

})
define('./functions/a5192a777a680f84b6613b2412fed827/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a5192a777a680f84b6613b2412fed827'] = async function fn_a5192a777a680f84b6613b2412fed827(pageData, tableName, recordItem, ___arguments) {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('169ad7e294137753d4096be151976102');

return 
}

})
define('./functions/a868a6a4f6678dfcdaf2fbd8ee89f031/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a868a6a4f6678dfcdaf2fbd8ee89f031'] = async function fn_a868a6a4f6678dfcdaf2fbd8ee89f031(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAll(array, values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/b10683b89d3a8232328807d905aa7ecc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b10683b89d3a8232328807d905aa7ecc'] = async function fn_b10683b89d3a8232328807d905aa7ecc(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/b26ba78feceb903690c215dd3b5a4627/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b26ba78feceb903690c215dd3b5a4627'] = async function fn_b26ba78feceb903690c215dd3b5a4627(selector, attributeName, attributeValue) {
  await (async function(selector, attributeName, attributeValue) {
  	const elem = document.querySelector(selector)

  	elem.setAttribute(attributeName, attributeValue)
  })(selector, attributeName, attributeValue);

}

})
define('./functions/b55a0b2dad43d733ad63285e237240c8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b55a0b2dad43d733ad63285e237240c8'] = async function fn_b55a0b2dad43d733ad63285e237240c8(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropRightWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b665c075565aa28862ac1e9374ca2b96/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b665c075565aa28862ac1e9374ca2b96'] = async function fn_b665c075565aa28862ac1e9374ca2b96(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b8d6305d8b24558eb58f8fe7c0212833/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b8d6305d8b24558eb58f8fe7c0212833'] = async function fn_b8d6305d8b24558eb58f8fe7c0212833(listToFlatten, maxRecursionDepth) {
return (await (async function(array, depth) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (depth == null) {
	  depth = 1
	}

	return _.flattenDepth(array, depth)
})(listToFlatten, maxRecursionDepth))
}

})
define('./functions/b93bcd5de56aa56928854fbb554683b1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b93bcd5de56aa56928854fbb554683b1'] = async function fn_b93bcd5de56aa56928854fbb554683b1(listToQuery, elementIndex) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 0
	}

	return _.nth(array, n)
})(listToQuery, elementIndex))
}

})
define('./functions/be5159274106e4112278e8648d164788/code.js', () => { 

BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'] = async function fn_be5159274106e4112278e8648d164788(object) {
return (await (async function(object) {
	return JSON.stringify(object, null, 3)
})(object))
}

})
define('./functions/c0ec24bc31d97a37ccf5fe7b144f4fab/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab'] = async function fn_c0ec24bc31d97a37ccf5fe7b144f4fab(objectId) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// ObjectId property is optional.  It should be used when we call this function from a situation where we're manually sending the RT command and have opened a record in a UI viewer for editing.

return ({ [`id`]: objectId,[`color`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'color')),[`userName`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')),[`editorEmployeeObjectId`]: (await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause((['relEmail_Users.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setProperties('objectId').setRelationsDepth(2).setPageSize(10)))[0] })
}

})
define('./functions/c1083dfc958bfce9f511282469f18202/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c1083dfc958bfce9f511282469f18202'] = async function fn_c1083dfc958bfce9f511282469f18202(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.union(...arrays)
})(listsToInspect))
}

})
define('./functions/c58e08966457701101ab34279f33af6d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c58e08966457701101ab34279f33af6d'] = async function fn_c58e08966457701101ab34279f33af6d(keyValuePairsList) {
return (await (async function(pairs) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.fromPairs(pairs)
})(keyValuePairsList))
}

})
define('./functions/cab97651610a7df89b05dbc568adb257/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cab97651610a7df89b05dbc568adb257'] = async function fn_cab97651610a7df89b05dbc568adb257(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = array.length - 1
	}

	return _.lastIndexOf(array, value, fromIndex);
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./functions/ce6a7744410fa122d5ca861572a6cbf6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6'] = async function fn_ce6a7744410fa122d5ca861572a6cbf6(tableName, dataModel, whereClause, propertiesToInclude, propertiesToExclude, propertiesToSortBy, relations) {
var loadedData, offset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function init_offset_var() {
  offset = (getObjectProperty(dataModel, 'offset'));
  if (offset == null) {
    offset = 0;
  }
}

/**
 * Describe this function...
 */
async function load_data() {
  loadedData = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties(propertiesToInclude).excludeProperties(propertiesToExclude).setRelated(relations).setSortBy(propertiesToSortBy).setPageSize(100).setOffset(offset)));
}

/**
 * Describe this function...
 */
async function adjust_page_data_state() {
  if (loadedData.length < 100) {
    dataModel['loadingData'] = false;
  } else {
    dataModel['offset'] = (offset + loadedData.length);
  }
}


  await init_offset_var();
  await load_data();
  await adjust_page_data_state();

return loadedData
}

})
define('./functions/cf0cee815db7c56daa3d4a3f0704a8ac/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cf0cee815db7c56daa3d4a3f0704a8ac'] = async function fn_cf0cee815db7c56daa3d4a3f0704a8ac(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersection(...arrays)
})(listsToInspect))
}

})
define('./functions/d535622b38bb7a25aa31ae757fe6869c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d535622b38bb7a25aa31ae757fe6869c'] = async function fn_d535622b38bb7a25aa31ae757fe6869c(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.takeRight(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/d813cd0b8767bda332b7d73f1ea8155b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d813cd0b8767bda332b7d73f1ea8155b'] = async function fn_d813cd0b8767bda332b7d73f1ea8155b(listToConvert, elementSeparator) {
return (await (async function(array, separator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.join(array, separator)
})(listToConvert, elementSeparator))
}

})
define('./functions/dbb18f7b7e65bc5c2574571a1002ebaa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'] = async function fn_dbb18f7b7e65bc5c2574571a1002ebaa(dataContainer) {
var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  dataContainer['tribeOptions'] = (await Promise.all((await Backendless.Data.of('TribeAffiliationOptions').find(Backendless.DataQueryBuilder.create().setSortBy('tribes').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'tribes')),[`label`]: (getObjectProperty(item, 'tribes')) });})));

return 
}

})
define('./functions/dfe6f4741626a11429b6777d44ba18e7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfe6f4741626a11429b6777d44ba18e7'] = async function fn_dfe6f4741626a11429b6777d44ba18e7(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.difference(array, values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/dfef9391c409b8519db2242d696ca08c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfef9391c409b8519db2242d696ca08c'] = async function fn_dfef9391c409b8519db2242d696ca08c(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniq(array)
})(listToInspect))
}

})
define('./functions/e04783eefccc55279cd3ffc580231f28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e04783eefccc55279cd3ffc580231f28'] = async function fn_e04783eefccc55279cd3ffc580231f28(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/eab6964cdd451a9c2dbbbeb2cbcc36de/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eab6964cdd451a9c2dbbbeb2cbcc36de'] = async function fn_eab6964cdd451a9c2dbbbeb2cbcc36de(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pull(array, ...values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/ec97791f4918eb07b6dff2a5bfec059a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ec97791f4918eb07b6dff2a5bfec059a'] = async function fn_ec97791f4918eb07b6dff2a5bfec059a(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xor(...arrays)
})(listsToInspect))
}

})
define('./functions/eede1373849ef1ddf61fa8d154f26d66/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66'] = async function fn_eede1373849ef1ddf61fa8d154f26d66(filePath, error, notesBreakpoint, nameLocalParentContainer, dataLocalParentContainer, dataPage, dataLayout, dataApp, nameAltObject, dataAltObject, nameAltObject2, dataAltObject2, nameAltObject3, dataAltObject3) {
function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}



return (await Backendless.Files.saveFile(encodePath(filePath), ((String((new Date()).valueOf()) + String('json.txt')).replace((new RegExp('\\s', 'g')), '-')), ([['Error: {',error,'}.','\n \n'].join(''),['Breakpoint: ',notesBreakpoint,'\n \n'].join(''),['User:','\n',(await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788']((await Backendless.UserService.getCurrentUser(false)))),'\n \n'].join(''),[nameLocalParentContainer,':\n',(await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'](dataLocalParentContainer)),'\n \n'].join(''),['Page Data Container:','\n',(await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'](dataPage)),'\n \n'].join(''),['Layout Data Container:','\n',(await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'](dataLayout)),'\n \n'].join(''),['App Data Container:','\n',(await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'](dataApp)),'\n \n'].join(''),nameAltObject ? [nameAltObject,':\n',(await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'](dataAltObject)),'\n \n'].join('') : '',nameAltObject2 ? [nameAltObject2,':\n',(await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'](dataAltObject2)),'\n \n'].join('') : '',nameAltObject3 ? [nameAltObject3,':\n',(await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'](dataAltObject3)),'\n \n'].join('') : ''].join('')), false))
}

})
define('./functions/ef8e0b29f86598cb7952fbb6554552da/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'] = async function fn_ef8e0b29f86598cb7952fbb6554552da(changedValue, dataContainer, targetObject) {
var trimmedZipCode, error, zipcode, stateCode, city, streetNumber, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  console.log(changedValue);
  if (!changedValue) {
    Object.assign(targetObject, ({ [`googlePlaceId`]: undefined,[`googleFormattedAddress`]: undefined,[`formattedLocation`]: undefined,[`googleName`]: undefined,[`googleTypes`]: undefined,[`latitude`]: undefined,[`longitude`]: undefined,[`isPrivateResidence`]: undefined,[`address`]: undefined,[`city`]: undefined,[`stateCode`]: undefined,[`zipcode`]: undefined,[`okrcRegion`]: undefined }));
    return ;
  }
  targetObject['googlePlaceId'] = (getObjectProperty(changedValue, 'place_id'));
  dataContainer['googlePlaceDetails'] = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(targetObject, 'googlePlaceId')), ['formatted_address', 'address_components', 'geometry', 'name', 'business_status', 'types']));
  console.log('Print Place Details Returned from Search in getGoogleAutoCompletePlaceDetails:');
  console.log(getObjectProperty(dataContainer, 'googlePlaceDetails'));
  targetObject['googleFormattedAddress'] = (getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'formatted_address'));
  // If an entry is not a business ("establishment")
  // then set it as a private residence and adjust it's
  // name to indicate that it's a residence. Otherwise set
  // isPrivateResidence=false and use the name returned by Google.
  if (!((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'types')).includes('establishment'))) {
    targetObject['googleName'] = (String('Private Residence - ') + String(getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'name')));
    targetObject['isPrivateResidence'] = true;
  } else {
    targetObject['googleName'] = (getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'name'));
    targetObject['isPrivateResidence'] = false;
  }
  targetObject['googleTypes'] = (getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'types'));
  targetObject['latitude'] = (getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'location.lat'));
  targetObject['longitude'] = (getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'location.lng'));
  // Sometimes google places records don't have street_number.  This tests for that before committing to pulling it to avoid errors.  This may end up being true with other places fields as well, but I've only found it for this property so far.
  // Sometimes google places records don't have street_number.  This tests for that before committing to pulling it to avoid errors.  This may end up being true with other places fields as well, but I've only found it for this property so far.
  targetObject['address'] = ([(await asyncListFilter((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'address_components')), async (item) => {


   return ((getObjectProperty(item, 'types')).includes('street_number'));
  }))[0] ? (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'address_components')), async (item) => {


   return ((getObjectProperty(item, 'types')).includes('street_number'));
  }))[0]), 'short_name')) : null,' ',(await asyncListFilter((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'address_components')), async (item) => {


   return ((getObjectProperty(item, 'types')).includes('route'));
  }))[0] ? (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'address_components')), async (item) => {


   return ((getObjectProperty(item, 'types')).includes('route'));
  }))[0]), 'short_name')) : null].join(''));
  streetNumber = (await asyncListFilter((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'address_components')), async (item) => {


   return ((getObjectProperty(item, 'types')).includes('street_number'));
  }))[0] || ({  });
  city = (await asyncListFilter((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'address_components')), async (item) => {


   return ((getObjectProperty(item, 'types')).includes('locality'));
  }))[0] || ({  });
  stateCode = (await asyncListFilter((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'address_components')), async (item) => {


   return ((getObjectProperty(item, 'types')).includes('administrative_area_level_1'));
  }))[0] || ({  });
  zipcode = (await asyncListFilter((getObjectProperty((getObjectProperty(dataContainer, 'googlePlaceDetails')), 'address_components')), async (item) => {


   return ((getObjectProperty(item, 'types')).includes('postal_code'));
  }))[0] || ({  });
  targetObject['streetNumber'] = (getObjectProperty(streetNumber, 'short_name'));
  targetObject['city'] = (getObjectProperty(city, 'short_name'));
  targetObject['stateCode'] = (getObjectProperty(stateCode, 'short_name'));
  trimmedZipCode = (getObjectProperty(zipcode, 'short_name')) ? (getObjectProperty(zipcode, 'short_name')).slice(0, 5) : '';
  targetObject['zipcode'] = trimmedZipCode;
  // On very rare occasions, it is possible for an address to return no zip
  // code. If this occurs, the if statement will prevent a hard failure.
  if (trimmedZipCode) {
    try {
      // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
      targetObject['okrcRegion'] = (trimmedZipCode ? (getObjectProperty(((await Backendless.Data.of('OkrcRegionLookup').find(Backendless.DataQueryBuilder.create().setWhereClause((['zipcode = \'',trimmedZipCode,'\''].join(''))).setProperties(['okrcRegion']).setPageSize(10)))[0]), 'okrcRegion')) : null);

    } catch (error) {
      console.log(error);
      console.log('Attempt to find the zip code in okrcRegion was unsuccessful.  Moving forward without populating okrcRegion.');
      await Backendless.Messaging.sendEmail('A Zipcode Produced an Error in the Ride Care App', new Backendless.Bodyparts({ textmessage: (['The following zipcode had an issue: ','\n\n',trimmedZipCode].join('')) }), ensureArray('jkhereford@gmail.com'), undefined);

    }
  }
  console.log('Print targetObject in getGoogleAutoCompletePlaceDetails:  ');
  console.log(targetObject);

return targetObject
}

})
define('./functions/f1c97833e26b0995f236b863812bfed2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f1c97833e26b0995f236b863812bfed2'] = async function fn_f1c97833e26b0995f236b863812bfed2(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.indexOf(array, value, fromIndex)
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./functions/f5c478d108d507959b8f86a30abaef57/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f5c478d108d507959b8f86a30abaef57'] = async function fn_f5c478d108d507959b8f86a30abaef57(appData) {
var appData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  appData['employeeRecord'] = ((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause((['relEmail_Users.objectId = \'',(getObjectProperty(appData, 'currentUser.objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(10)))[0]);
  appData['employeeVehicle'] = ((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause((['relCurrentlyAssignedTo_Employee.objectId = \'',(getObjectProperty(appData, 'employeeRecord.objectId')),'\''].join(''))).setPageSize(10)))[0]);
  console.log(getObjectProperty(appData, 'employeeVehicle'));

return 
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('welcome', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/DavidTestPage2/components/fff15a7eb464ab67adb4779702cdc3ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['driverStatus'] = (await Backendless.Request.get(`${Backendless.appPath}/services/driverVehicleAwareness/DriverAvailability`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('21cf2052d10aa3916cc23e219ef6675b', (getObjectProperty(___arguments.context.pageData, 'driverStatus')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DavidTestPage2/components/9513ea51e7497bc5070e45e5029e4c62/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['driverStatus'] = (await Backendless.Request.get(`${Backendless.appPath}/services/driverVehicleAwareness/DriverAvailability`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dfccec81b83ca8385fb9ca5316fc02e7', (getObjectProperty(___arguments.context.pageData, 'driverStatus')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MaintenanceNotification/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('welcome', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/___alex-map/components/ed46c9238221eda3c74dcc75829251bb/bundle.js', [], () => ({
  /* content */
  /* handler:routeLogic */
  async ['routeLogic'](___arguments) {
      return (await (async function() {
	return [
	  {
	    "location": { "lat": 48.858135, "lng": 2.293723 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Eiffel Tower",
	    "label": {
	      "text": "Eiffel Tower",
	      "color": "red",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.860406, "lng": 2.337068 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Louvre",
	    "label": {
	      "text": "Louvre",
	      "color": "green",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.886557, "lng": 2.344619 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "The Basilica of the Sacré Cœur",
	    "label": {
	      "text": "The Basilica of the Sacré Cœur",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  }
	]

	return [
	  {
	    "location": { "lat": 35.44857096, "lng": -97.52116703 },
	    "title": "Start",
	    "label": {
	      "text": "START",
	      "color": "white",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 35.4227066, "lng": -97.5321882 },
	    "title": "Pickup",
	    "label": {
	      "text": "Pickup",
	      "color": "white",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 35.6112329, "lng": -95.9522883 },
	    "title": "Dropoff",
	    "label": {
	      "text": "Dropoff",
	      "color": "white",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  }
	]
})())

  },
  /* handler:routeLogic */
  /* handler:additionalMarkersLogic */
  async ['additionalMarkersLogic'](___arguments) {
      return (await (async function() {
	return [
	  {
	    "location": { "lat": 35.44857096, "lng": -97.52116703 },
	    "title": "Start",
	    "label": {
	      "text": "START",
	      "color": "white",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 35.4227066, "lng": -97.5321882 },
	    "title": "Pickup",
	    "label": {
	      "text": "Pickup",
	      "color": "white",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 35.6112329, "lng": -95.9522883 },
	    "title": "Dropoff",
	    "label": {
	      "text": "Dropoff",
	      "color": "white",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  }
	]
})())

  },
  /* handler:additionalMarkersLogic */
  /* handler:onMarkerClick */
  ['onMarkerClick'](___arguments) {
      console.log('%c>> ' + '!!Click', 'color: #ffee58', ___arguments['point']);

  },
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/___migration-tool-1table/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      console.log('%c>> ' + 'App Data', 'color: #f06292', ___arguments.context.appData);

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      console.log('%c>> 🔒 ' + 'App Data', 'color: #3f51b5', JSON.parse(JSON.stringify(___arguments.context.appData)));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/___migration-tool-1table/components/ec7c9c98e0fccf79fb26144fd168916f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['tableName'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/___migration-tool-1table/components/4b4562419bfe2f4ff90c95b764e11df9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'tableName')) || (getObjectProperty(___arguments.context.pageData, 'loading')) || (getObjectProperty(___arguments.context.pageData, 'showSecondTableField')) && !(getObjectProperty(___arguments.context.pageData, 'secondTableName')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, secondFieldOptions, firstFieldRelationMap, firstFieldOptions, secondTableSchema, tableSchema, fields, i, j, relColumnId, tableSchemaForFirstField, tableData, pageSize, offset, records, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['loading'] = true;
    ___arguments.context.pageData['loadData'] = false;
    tableSchema = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.pageData, 'tableName')) ));
    console.log('%c>> ' + 'Schema', 'color: #f06292', tableSchema);
    if (tableSchema.length > 0) {
      secondFieldOptions = (await asyncListSort((await Promise.all((await asyncListFilter(tableSchema, async (item) => {


       return ((getObjectProperty(item, 'type')) != 'RELATION');
      })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });}))), 1, async (item) => {


       return (getObjectProperty(item, 'label'));
      }));
      firstFieldRelationMap = ({  });
      if (getObjectProperty(___arguments.context.pageData, 'secondTableName')) {
        secondTableSchema = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.pageData, 'secondTableName')) ));
        if (secondTableSchema.length > 0) {
          tableSchemaForFirstField = secondTableSchema;
        }
      } else {
        tableSchemaForFirstField = tableSchema;
      }
      firstFieldOptions = (await asyncListSort((await Promise.all(tableSchemaForFirstField.map(async item => {  if ((getObjectProperty(item, 'type')) == 'RELATION') {
          firstFieldRelationMap[(getObjectProperty(item, 'name'))] = [];
          console.log(await Backendless.Data.describe( (getObjectProperty(item, 'relatedTable')) ));
          var j_list = (await asyncListSort((await Backendless.Data.describe( (getObjectProperty(item, 'relatedTable')) )), 1, async (item) => {


           return (getObjectProperty(item, 'name'));
          }));
          for (var j_index in j_list) {
            j = j_list[j_index];
            addItemToList((getObjectProperty(firstFieldRelationMap, (getObjectProperty(item, 'name')))), ({ [`value`]: (getObjectProperty(j, 'name')),[`label`]: (getObjectProperty(j, 'name')) }));
          }
        }
      ; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });}))), 1, async (item) => {


       return (getObjectProperty(item, 'label'));
      }));
      ___arguments.context.pageData['tableSchema'] = tableSchema;
      ___arguments.context.pageData['secondTableSchema'] = secondTableSchema;
      ___arguments.context.pageData['firstFieldOptions'] = firstFieldOptions;
      ___arguments.context.pageData['firstFieldRelationMap'] = firstFieldRelationMap;
      ___arguments.context.pageData['secondFieldOptions'] = secondFieldOptions;
      ___arguments.context.pageData['loadData'] = true;
    }
    ___arguments.context.pageData['showInput'] = false;
    ___arguments.context.pageData['inputValue'] = null;
    ___arguments.context.pageData['firstField'] = null;
    ___arguments.context.pageData['firstFieldHasRelation'] = false;
    ___arguments.context.pageData['secondField'] = null;
    ___arguments.context.pageData['firstFieldRelationOptions'] = [];

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);

  } finally {
    ___arguments.context.pageData['loading'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'loading')) ? 'Loading...' : 'Load Data')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/0052de31ede30a8e4371615c8f640197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['whereClause'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/___migration-tool-1table/components/f95a0fe712cd378cb25969bb12a25ff2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loadData'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/cbdac03b8153d0efba4d7a75e8f1db53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'firstFieldOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['firstField'] = ___arguments.value;
  console.log('%c>> ' + 'RelationOptions', 'color: #4caf50', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value)));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value)) {
    ___arguments.context.pageData['firstFieldRelationOptions'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value));
    ___arguments.context.pageData['firstFieldHasRelation'] = true;
  } else {
    ___arguments.context.pageData['firstFieldHasRelation'] = false;
    ___arguments.context.pageData['firstFieldRelationOptions'] = [];
  }
  console.log('%c>> ' + 'CHANGED VALUE', 'color: #26a69a', ___arguments.value);

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBusy'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/630be754a69d98f3610e65ff6516e899/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'secondFieldOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['secondField'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBusy'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/c3975a83fa12ee888f9452f7853bbbdb/bundle.js', [], () => ({
  /* content */
  /* handler:tableNameLogic */
  ['tableNameLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')) ? (getObjectProperty(___arguments.context.pageData, 'tableName')) : null)

  },
  /* handler:tableNameLogic */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:onDisplayAssignment */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    var columns, item, columnNames;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  columns = [];
  if (getObjectProperty(___arguments.context.pageData, 'tableSchema')) {
    if (((getObjectProperty(___arguments.context.pageData, 'firstField')) || (getObjectProperty(___arguments.context.pageData, 'showInput'))) && (getObjectProperty(___arguments.context.pageData, 'secondField'))) {
      columnNames = [({ [`name`]: 'objectId' }), ({ [`name`]: 'created' }), ({ [`name`]: 'updated' })];
      if (!(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && !(getObjectProperty(___arguments.context.pageData, 'showInput'))) {
        addItemToList(columnNames, ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'tableSchema')), async (item) => {


         return ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')));
        }))[0]));
      }
      addItemToList(columnNames, ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'tableSchema')), async (item) => {


       return ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'secondField')));
      }))[0]));
      columns = (await Promise.all(columnNames.map(async item => {; return ({ [`field`]: !(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(item, 'name')),[`headerName`]: !(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(item, 'name')),[`flex`]: 1 });})));
    } else {
      columns = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'tableSchema')).map(async item => {; return ({ [`field`]: (getObjectProperty(item, 'name')),[`headerName`]: (getObjectProperty(item, 'name')),[`flex`]: 1 });})));
    }
    columns = (await (async function(columns) {
    	const columnTypes = {
    	  "datetimeColumn": {
    	    "sortable"          : true,
    	    "width"             : 180,
    	    "type"              : "datetimeColumn",
    	    "cellRendererParams": {
    	      "dayjsFormat": "MM/DD/YYYY HH:mm:ss",
    	      "withSeconds": true
    	      },
    	  },
    	}

    	return columns.map(column => {
    	  if (column.field === 'created' || column.field === 'updated') {
    	    return { ...column, ...columnTypes.datetimeColumn }
    	  }

    	  return column
    	})
    })(columns));
  }
  console.log('%c>> ' + 'COLUMNS', 'color: #26a69a', columns);

  return columns

  },
  /* handler:columnDefsLogic */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
      return (await (async function(pageData) {
	return {
	  where: pageData.loadData ? pageData.whereClause : '',
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/___migration-tool-1table/components/89ca2a827828ee538c24bb3ce0aa2eb3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'firstField')) && !(getObjectProperty(___arguments.context.pageData, 'showInput')) || !(getObjectProperty(___arguments.context.pageData, 'secondField')) || (getObjectProperty(___arguments.context.pageData, 'isBusy')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, message, result, transactionLimit, batchIndex, copyDataTx, j, batchesToProcess, updatedRecords, pageSize, offset, item, tableData, firstFieldValue, records, updatedRecordsBatch, changes, value, firstFieldName, count, testObj;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  ___arguments.context.pageData['isBusy'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('0be22fe4f87510dbb34497a84e14d7e1');
  updatedRecords = [];
  try {
    count = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'tableName'))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'whereClause')))));
    pageSize = 100;
    offset = 0;
    tableData = [];
    while (offset < count) {
      records = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'tableName'))).find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'whereClause')) ? String(getObjectProperty(___arguments.context.pageData, 'whereClause')) + String(' AND migrated = false') : 'migrated = false')).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
      updatedRecordsBatch = [];
      for (var j_index in records) {
        j = records[j_index];
        changes = ({  });
        value = null;
        if (getObjectProperty(___arguments.context.pageData, 'showInput')) {
          value = (await (async function(value) {
          	return value !== undefined
          })((getObjectProperty(___arguments.context.pageData, 'inputValue')))) ? (getObjectProperty(___arguments.context.pageData, 'inputValue')) : null;
        } else {
          firstFieldName = (getObjectProperty(___arguments.context.pageData, 'firstField'));
          if (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) {
            firstFieldName = [(getObjectProperty(___arguments.context.pageData, 'firstField')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('');
          }
          value = (await (async function(value) {
          	return value !== undefined
          })((getObjectProperty(j, firstFieldName)))) ? (getObjectProperty(j, firstFieldName)) : null;
        }
        changes['objectId'] = (getObjectProperty(j, 'objectId'));
        changes[(getObjectProperty(___arguments.context.pageData, 'secondField'))] = value;
        changes['migrated'] = true;
        addItemToList(updatedRecordsBatch, changes);
      }
      if (updatedRecordsBatch.length > 0) {
        addItemToList(updatedRecords, [updatedRecordsBatch]);
      }
      offset = offset + pageSize;
    }

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);
    ___arguments.context.pageData['isBusy'] = false;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0be22fe4f87510dbb34497a84e14d7e1');
    return ;

  }
  try {
    batchIndex = 0;
    transactionLimit = 15;
    while (batchIndex < updatedRecords.length) {
      batchesToProcess = updatedRecords.slice(((batchIndex + 1) - 1), batchIndex + transactionLimit);
      copyDataTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      for (var j_index2 in batchesToProcess) {
        j = batchesToProcess[j_index2];
        await ( async () => {
          const _uow = copyDataTx;

          _uow.bulkUpsert((getObjectProperty(___arguments.context.pageData, 'tableName')), j).setOpResultId((String('CopyData: ') + String(generateUUID().short())));

        })();

      }
      result = (await copyDataTx.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      batchIndex = batchIndex + transactionLimit;
    }
    if (result && (getObjectProperty(result, 'success'))) {
      message = (getObjectProperty(___arguments.context.pageData, 'showInput')) ? ['Value "',(getObjectProperty(___arguments.context.pageData, 'inputValue')),'" has been successfully copied to field "',(getObjectProperty(___arguments.context.pageData, 'secondField')),'".'].join('') : ['Data has been successfully copied from field "',(getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) ? [(getObjectProperty(___arguments.context.pageData, 'firstField')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(___arguments.context.pageData, 'firstField')),'" to field "',(getObjectProperty(___arguments.context.pageData, 'secondField')),'".'].join('');
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('c3975a83fa12ee888f9452f7853bbbdb');
      await new Promise(r => setTimeout(r, 2000 || 0));
      console.log('%c>> ' + 'BULK UPDATE', 'color: #f06292', (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'tableName'))).bulkUpdate( 'objectId != null', ({ [`migrated`]: false }) )));
      (function (message) { alert(message) })(message);
    } else {
      (function (message) { alert(message) })('No records were migrated.');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);

  } finally {
    ___arguments.context.pageData['isBusy'] = false;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0be22fe4f87510dbb34497a84e14d7e1');

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isBusy')) ? 'Copying..' : 'Copy Data')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/2a0fd867dcaf54bb04678ecda7cc9eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/e0e5fd28d8086e07c74e47d7adbef80a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationOptions')) ? (getObjectProperty(___arguments.context.pageData, 'firstFieldRelationOptions')) : [])

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['firstFieldRelation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isBusy')) || !(getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/fb5de794ea719d2858b505a96f057a81/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showInput'] = ___arguments.value;
  ___arguments.context.pageData['firstField'] = null;
  if (!___arguments.value) {
    ___arguments.context.pageData['inputValue'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/___migration-tool-1table/components/11f7c908b5c5714f3f234f47c7715016/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['inputValue'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/___migration-tool-1table/components/fcd569ae593c2f4204f777053a56c0e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showInput')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/2fda31cbd606adaed0e3d44c4fcb1cd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showInput')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/___migration-tool-1table/components/20849406cd997d7d5c01ed9895782b35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showSecondTableField'] = ___arguments.value;
  ___arguments.context.pageData['firstField'] = null;
  ___arguments.context.pageData['secondField'] = null;
  if (!___arguments.value) {
    ___arguments.context.pageData['secondTableName'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/___migration-tool-1table/components/067a6c36c848e622a39375817f09469b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['secondTableName'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/___migration-tool-1table/components/449720ef993809e27118c1fc797642b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__alex-billing-test/components/6a6c294bc0c45e0e3c33bdef5d3a2178/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    var waitMilliseconds;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'strWhereClauseBase', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')));
  console.log('%c>> ' + 'strWhereClauseModifier', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));
  ___arguments.context.pageData['relations'] = 'datetimeScheduledStart';
  waitMilliseconds = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')) != null && (getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) != null) {
    ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));
    console.log('%c>> ' + '1111111111111111', 'color: #26c6da', undefined);
  }

  return (await (async function(pageData) {
	console.log('!!!!!!!!!!!!!!!!!', pageData.strWhereClause)

	return {
	  where: pageData.strWhereClause,
	  relations: "rel_TransportRequest.rel_Client",
	  //properties: ["typeStatus"]//

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // This was broken into two different colDef's because
  // we couldn't hide typeAdjudicationStatus based on page
  // data while maintaining separate column settings.
  if ((getObjectProperty(___arguments.context.pageData, 'resetBillingFilter')) == true) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	    {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },   
    	      {
    	        "field": "billingExportBatchId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },   
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	   {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	     /* {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "valueFormatterParams": {
    	         "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	         },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },*/
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	         
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesFlat",
    	        "headerName": "Flat Rate Charge",
    	        "headerTooltip": "Total flat rate charge.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	         "filterParams": {
    	             "defaultOption": "equals",
    	             "defaultFilter": "--",
    	           },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "billingExportBatchId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },        
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },  
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },      
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['initialRecordItem'], 'notesBilling')) != (getObjectProperty(___arguments['changedRecordItem'], 'notesBilling'))) {
    console.log('Change in notesBilling found during On Before Update Event');
    ___arguments['changedRecordItem']['hasNewBillingNote'] = true;
  }

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/__alex-billing-test/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', false);
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/__alex-billing-test/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__alex-billing-test/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'billingData','tableOptions': ({ [`where`]: '',[`sortBy`]: 'datetimeScheduledStart asc',[`relationsDepth`]: 2 }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Submission Code', 'Transport Date', 'Status', 'Client Name', 'Client DoB', 'SoonerCare ID', 'Medicare ID', 'Start to Dropoff Distance', 'Start to End of Day Distance', 'Total Transport Distance'] }) }));
  console.log(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'));
  console.log(Backendless.appPath);
  await (async function(url) {
  	window.open(url, "_blank");
  })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'))));

  },
  /* handler:onSubmit */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showFilters'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__alex-billing-test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var billingEntityList, millisecondsPerDay;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['reviewOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];
  ___arguments.context.pageData['transportStatusOptionsFilter'] = [({ [`label`]: 'Completed',[`value`]: 'Completed' }), ({ [`label`]: 'Voided',[`value`]: 'Voided' }), ({ [`label`]: 'Canceled',[`value`]: 'Canceled' })];
  ___arguments.context.pageData['reviewOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare (XIX)', 'Medicaid (MCO)', 'Private Insurance', 'Department of Mental Health (DMH)', 'Medicare', 'Other'];
  ___arguments.context.pageData['earliestUnbilledRecord'] = ((await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause('typeAdjudicationStatus IS NULL && datetimeScheduledStart >=  \'1719810000000\'').setSortBy('datetimeScheduledStart asc').setPageSize(1)))[0]);
  console.log('earliestUnbilledRecord:');
  console.log(getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord'));
  ___arguments.context.pageData['dateEarliestUnbilledRecord'] = (getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord.datetimeScheduledStart'));
  ___arguments.context.pageData['startDate'] = (getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  console.log('dateEarliestUnbilledRecord');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  millisecondsPerDay = 86400000;
  ___arguments.context.pageData['queryEndDate'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord')), 'datetimeScheduledStart')) + 2 * millisecondsPerDay);
  console.log('queryEndDate:');
  console.log(getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['endDate'] = (getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['strWhereClauseBase'] = (['datetimeScheduledStart >= \'1719810000000\' ',' && rel_TransportRequest.rel_Client.nameFirst NOT LIKE \'%test%\'',' && typeStatus != \'Voided\''].join(''));
  ___arguments.context.pageData['showFilters'] = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))) {
    console.log('NO data from pervious page found');
    ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\'','',''].join(''));
    ___arguments.context.pageData['resetBillingFilter'] = false;
  }
  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));
  ___arguments.context.pageData['adjudicationStatusOptions'] = [null, 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Hold', 'Non-Billable'];
  ___arguments.context.pageData['adjudicationStatusOptionsFilter'] = ['--', 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Exported', 'Hold', 'Non-Billable'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Ride Care', 'Client', 'Facility'];
  console.log('Date of Birth Page Data');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['dateOfBirth'] = (getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ___arguments.context.pageData['billingEntityList'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: (getObjectProperty(billingEntityList, 'requesterEntityName')),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));
  ___arguments.context.pageData['typeInsuranceList'] = ((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true))).map(item => item['typeInsurance']));
  console.log('Type Insurance List');
  console.log(getObjectProperty(___arguments.context.pageData, 'typeInsuranceList'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/__alex-billing-test/components/44b62d41ca14d86eec4cbb56f37f4da2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['csvInProcess'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', true);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['fileName'] = (['/export/billing-data/',(new Date()),'.csv'].join(''));
  try {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'fileName')),'tableName': 'Transport','tableOptions': ({ [`where`]: String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')),[`properties`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimId', 'depositId', 'accountNumber', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'rel_TransportRequest.rel_Client.nameFull', 'rel_TransportRequest.rel_Client.datestringDateOfBirth', 'rel_TransportRequest.rel_Client.soonerCareId', 'rel_TransportRequest.rel_Client.medicareId', 'rel_TransportRequest.destinationLocationName', 'rel_TransportRequest.destinationAddress', 'rel_TransportRequest.pickupLocationName', 'rel_TransportRequest.pickupAddress', 'rel_TransportRequest.rel_Client.isFedRecognizedTribal', 'rel_TransportRequest.rel_Client.tribeAffiliations', 'rel_TransportRequest.rel_Client.tribeMemberZipcode'],[`sortBy`]: ['datestringScheduledStart asc'],[`relations`]: 'rel_TransportRequest.rel_Client',[`relationsDepth`]: undefined,[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'nameFull', 'datestringDateOfBirth', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimID', 'depositID', 'accountNumber', 'soonerCareId', 'medicareId', 'isFedRecognizedTribal', 'tribeAffiliations', 'tribeMemberZipcode', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'pickupLocationName', 'pickupAddress', 'destinationLocationName', 'destinationAddress'] }) }));
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'csvExportPath'))), true, undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  } catch (error) {
    (function (message) { alert(message) })((['We were unable to export the CSV due to error:','\n\n',error].join('')));
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/39e365d67c5a48e46c04bb4ee34e25e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'7\', \'DAY\')';
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/54fa8aace31ff4cfba1fc772bacc00e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'1\', \'MONTH\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/6e2a4327a30943ef134a4b5e1efd7b86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is 7/1/24
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart > \'',((new Date(1719817200000)).toISOString()),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/08084838717a0617b0cd23d541e42bdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, whereClauseModifier, billingEntity, millisecoundsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = (new Date((new Date())).getFullYear());
  if ((new Date((new Date())).getMonth() + 1) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth'))) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')) - 1);
  }
  console.log('Year');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year'));
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';
  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecoundsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getMinutes()) * 60000;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.submissionCode LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& billingExportBatchId LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')),'%\' '].join(''));
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != null && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.insurancePolicyNumber ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'policyNumberStatus')),' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\'',' && datetimeScheduledStart <= DATEADD (\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\', \'1\', \'MONTH\')'].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')),' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(item => item['value'])))) == '["--"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& typeAdjudicationStatus IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(async item => {; return (['typeAdjudicationStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')).map(async item => {; return (['typeReviewStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')).map(async item => {; return (['typeStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(item => item['value'])))) == '["Blank"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.typeInsurance IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(async item => {; return (['rel_TransportRequest.typeInsurance LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')).map(async billingEntity => {; return (getObjectProperty(billingEntity, 'value'));}))).join(' OR '),')'].join(''));
  }
  ___arguments.context.pageData['strWhereClauseModifier'] = whereClauseModifier;
  console.log('strWhereClause Output');
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  console.log('Client Last Name');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName'));
  console.log('Last Name Output');
  console.log((await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4ff9ebf86b3a60f36dd749efbd8ec46', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44b62d41ca14d86eec4cbb56f37f4da2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/e4136efaaad65953e87a4243889408c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showMileages'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__alex-billing-test/components/b97f0c9eb5d23ee4d006eacfeae2571c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['resetBillingFilter'] = false;
  console.log('print in button click');
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));
  Object.assign(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ({ [`multiSelectLastName`]: '',[`dateOfBirth`]: '',[`clientLastName`]: '',[`startDate`]: '',[`endDate`]: '' }));
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\' '].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/c26917096589e0a14db3293321637ec1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showFilters'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__alex-billing-test/components/343f2cb520ed2518d80dd138bf6e7cd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showFilters')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__alex-billing-test/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['maxDate'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dataOfBirth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'dateOfBirth'))));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['clientLastName'] = (getObjectProperty(___arguments.context.pageData, 'clientLastName'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['adjudicationStatusOptionsFilter'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['reviewStatusOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = (getObjectProperty(___arguments.context.pageData, 'startDate'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = (getObjectProperty(___arguments.context.pageData, 'endDate'));
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', 'SoonerCare');

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/__alex-billing-test/components/cdc24d17ae93332a77b903f552274347/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = null;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__alex-billing-test/components/46ce3f5d5e3b99aa135e87b85d13df39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('09acfa4cea2b703b9641ac79a72b2dee', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('6168ed5360bb182655333af9a587272a', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('d1ea2e346bd628b531a5b461669edc7f', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('28a4bef5fc489676119b8982815222e8', null);
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/c681a3c14dcb6416b42c3306d11a1018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__alex-billing-test/components/09acfa4cea2b703b9641ac79a72b2dee/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var billingEntityList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: ['billingEntityName LIKE \'%',(getObjectProperty(billingEntityList, 'requesterEntityName')),'%\''].join(''),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/__alex-billing-test/components/cd6ddbc9993163514f93f17e38e7e876/bundle.js', [], () => ({
  /* content */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirthReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirth'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/__alex-billing-test/components/6168ed5360bb182655333af9a587272a/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/__alex-billing-test/components/86169d7c1d8718541355ee42264ced8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await BackendlessUI.Functions.Custom['fn_5e3d747678a122a896439d3f05f6fb88']((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getAGGridAPI() })('6a6c294bc0c45e0e3c33bdef5d3a2178')), (String('Billing-export-') + String(new Date())))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/498d32ff46e565767f3840a29373bd73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var my_213ExportId, claimRecords, counter1, dataErrorFound, error, errorWhereClause, existingClaimRecord, exportDataForTransportRecords, item, j, loopClient, newEntry, pageOffset, payerItem, PayerName, payerTable, sampleClient, transactionErrorData, transactionUpdateExportedRecords, transportDataError, transportRecordCount, transportRecords;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function reviewTransportForError_updateClaim() {
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Exported]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function reviewTransportForError_addClaim() {
  if (!(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Insurance Policy #]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  } else if (getValueLength((getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'dateOfBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Date of Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'assignedSexAtBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Sex Assigned at Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client/Transport Destination address are both empty] ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'rel_TransportRequest.typeInsurance'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "typeInsurance" value is missing or incorrectly formatted for the "PayerName" value in 213 export]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  try {
    transportRecordCount = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))))));
    if (transportRecordCount > 100) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'More that 100 record in export',[`content`]: '213 Exports are temporarily limited to 100 records. Please update your search',[`submit`]: '' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
      return ;
    }
    pageOffset = Math.ceil(transportRecordCount / 100) * 100;
    transportRecords = [];
    while (!(pageOffset == 0)) {
      pageOffset = pageOffset - 100;
      addItemToList(transportRecords, (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100).setOffset(pageOffset))));
    }
    payerTable = (await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true)));
    console.log(payerTable);
    console.log('abc');
    transportRecords = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
    console.log('Lenght of transport record');
    console.log(transportRecords.length);
    my_213ExportId = ((new Date()).valueOf());
    console.log('Transport Records From Query');
    console.log(transportRecords);
    claimRecords = [];
    exportDataForTransportRecords = [];
    transportDataError = [];
    dataErrorFound = false;
    console.log(getObjectProperty((getObjectProperty((transportRecords[0]), 'rel_TransportRequest')), 'rel_Client.objectId'));
    sampleClient = transportRecords[0];
    for (var j_index in transportRecords) {
      j = transportRecords[j_index];
      loopClient = (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'rel_Client'));
      if (((claimRecords.map(item => item['clientObjectId'])).includes((getObjectProperty(loopClient, 'objectId')))) == true) {
        for (var existingClaimRecord_index in claimRecords) {
          existingClaimRecord = claimRecords[existingClaimRecord_index];
          if ((getObjectProperty(existingClaimRecord, 'clientObjectId')) == (getObjectProperty(loopClient, 'objectId'))) {
            await reviewTransportForError_updateClaim();
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceFromDatetime')) > (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceFrom_2`]: (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')) || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')),[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceToDatetime')) < (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceTo_2`]: (getObjectProperty(existingClaimRecord, 'Units_2')) > 0 || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : (getObjectProperty(existingClaimRecord, 'ServiceTo_2')),[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            Object.assign(existingClaimRecord, ({ [`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : (getObjectProperty(existingClaimRecord, 'ProcCode_2')),[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1||||' : '||||',[`Charge_1`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_1')))) + 160)).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_2')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) : (getObjectProperty(existingClaimRecord, 'Charge_2')),[`Units_1`]: (getObjectProperty(existingClaimRecord, 'Units_1')) + 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (getObjectProperty(existingClaimRecord, 'Units_2')) + (Number((getObjectProperty(j, 'distanceBillable')))) : (getObjectProperty(existingClaimRecord, 'Units_2')),[`TotalCharges`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'TotalCharges')))) + (Number((getObjectProperty(j, 'chargesTotal')))))).toFixed(2)),[`submissionCodes`]: ((getObjectProperty(existingClaimRecord, 'submissionCodes')).concat((getObjectProperty(j, 'transportCode_copy')))) }));
            addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: (getObjectProperty(existingClaimRecord, 'ClaimRef')),[`typeAdjudicationStatus`]: 'Exported' }));
            console.log('Claim edited');
            console.log(existingClaimRecord);
          }
        }
      } else {
        console.log('Info of new client');
        console.log([[(getObjectProperty(loopClient, 'nameLast')),', ',(getObjectProperty(loopClient, 'nameFirst'))].join(''),[(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),'DateTime',(getObjectProperty(j, 'datetimeScheduledStart'))].join(''));
        if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
          Object.assign(loopClient, ({ [`address`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.address')),[`city`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.city')),[`stateCode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.stateCode')),[`zipcode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.zipcode')) }));
        }
        PayerName = null;
        for (var payerItem_index in payerTable) {
          payerItem = payerTable[payerItem_index];
          if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(payerItem, 'typeInsurance'))) {
            PayerName = (getObjectProperty(payerItem, 'payerName'));
          } else {
          }
        }
        await reviewTransportForError_addClaim();
        newEntry = ({ [`SbrID`]: !(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) ? (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) : (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')).trim(),[`PatName`]: [(getObjectProperty(loopClient, 'nameLast')).trim(),', ',(getObjectProperty(loopClient, 'nameFirst')).trim()].join(''),[`PatBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate()),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear())].join(''),[`PatMale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'X' : null,[`PatFemale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Female' ? 'X' : null,[`Pipes1_1`]: '',[`SbrName`]: [(getObjectProperty(loopClient, 'nameLast')).trim(),', ',(getObjectProperty(loopClient, 'nameFirst')).trim()].join(''),[`PatientAddr`]: (getObjectProperty(loopClient, 'address')),[`PatientCity`]: (getObjectProperty(loopClient, 'city')),[`PatState`]: (getObjectProperty(loopClient, 'stateCode')),[`PatZip`]: (getObjectProperty(loopClient, 'zipcode')),[`PatRelSelf`]: '|X|||',[`SbrAddr`]: (getObjectProperty(loopClient, 'address')),[`SbrCity`]: (getObjectProperty(loopClient, 'city')),[`SbrState`]: (getObjectProperty(loopClient, 'stateCode')),[`SbrZip`]: (getObjectProperty(loopClient, 'zipcode')),[`Pipes2_24`]: '|||||||||||||||||||||||',[`SbrBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate()),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear())].join(''),[`SbrMale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'X' : null,[`SbrFemale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Female' ? 'X' : null,[`PatSignature`]: '||Signature on File|||||||||||||||',[`DiagCode1`]: 'Z1330',[`Pipes3_10`]: '|||||||||',[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceFrom_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : null,[`Pipes4_4`]: '|||',[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceTo_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : null,[`POS_1`]: '||||99|||||||||||',[`ProcCode_1`]: 'T2003',[`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : null,[`DiagPtrs_1`]: '||||||||||1',[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1||||' : '||||',[`Charge_1`]: (Number.parseFloat(160).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : null,[`Pipes5_4`]: '|||',[`Units_1`]: 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : null,[`BillTin`]: PayerName == 'Oklahoma Health Care Authority' ? '||||||||||||||||||||||||||||||||||||||||53AC||||||460868747||X' : '||||||||||||||||||||||||||||||||||||||||||||||460868747||X',[`ClaimRef`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`AcceptAssignmentYesNo`]: '||Y',[`TotalCharges`]: (Number.parseFloat((Number((getObjectProperty(j, 'chargesTotal'))))).toFixed(2)),[`BillNPI`]: '||Signature on file|||||||||||||||405-237-3043|OK Ride Care|2402 Westport Dr||Norman, OK 73069||||1699554634|',[`BillProvNum`]: '',[`PayerName`]: PayerName,[`Pipes6_4`]: '|||',[`submissionCodes`]: [(getObjectProperty(j, 'transportCode_copy'))],[`clientObjectId`]: (getObjectProperty(loopClient, 'objectId')),[`rel_Client`]: loopClient,[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) });
        addItemToList(claimRecords, newEntry);
        addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`typeAdjudicationStatus`]: 'Exported' }));
        console.log('New Client Added');
        console.log(newEntry);
        counter1 = (typeof counter1 == 'number' ? counter1 : 0) + 1;
        console.log(counter1);
      }
    }

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Creation of Claim Records]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
    return ;

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  console.log('Transport Records Filtered');
  console.log(claimRecords);
  console.log('Errors in the Transport Data?');
  console.log(dataErrorFound);
  console.log('Transport Database Errors?');
  console.log(transportDataError);
  errorWhereClause = ['&& objectId IN (',(await Promise.all(transportDataError.map(async item => {; return (['\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(', '),')'].join('');
  console.log('Errors Where Clause');
  console.log(errorWhereClause);
  console.log('Updated Transport Record');
  console.log(transportRecords);
  if (dataErrorFound == true) {
    try {
      transactionErrorData = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionErrorData;

        _uow.bulkUpsert('Transport', transportDataError);

      })();

      await transactionErrorData.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Data Review Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    } finally {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: String(transportDataError.length) + String(' Error(s) Were Found in Export Data'),[`content`]: 'The export was not able to complete due to errors. Export error flags have been added to these records in the billing table. Please review the "Billing Notes" field for each record to learn more information about the error.',[`submit`]: 'Review Errors' });
      ___arguments.context.pageData['strWhereClauseModifier'] = errorWhereClause;
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
      return ;

    }
  } else {
    console.log(exportDataForTransportRecords);
    try {
      transactionUpdateExportedRecords = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionUpdateExportedRecords;

        _uow.bulkDelete('Waystar2', 'objectId IS NOT NULL');
        _uow.bulkUpsert('Transport', exportDataForTransportRecords);
        _uow.bulkCreate('Waystar2', claimRecords);

      })();

      await transactionUpdateExportedRecords.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      ___arguments.context.pageData['fileName'] = (['/export/test-export/','Billing_213_Export_',my_213ExportId,'.csv'].join(''));
      ___arguments.context.pageData['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(___arguments.context.pageData, 'fileName')),'tableName': 'Waystar2','csvOptions': ({ [`header`]: false,[`delimiter`]: '|',[`columns`]: (await (async function() {
      	let jsonList = ["SbrID",
      	"PatName",
      	"PatBirthdate",
      	"PatMale",
      	"PatFemale",
      	"Pipes1_1",
      	"SbrName",
      	"PatientAddr",
      	"PatientCity",
      	"PatState",
      	"PatZip",
      	"PatRelSelf",
      	"SbrAddr",
      	"SbrCity",
      	"SbrState",
      	"SbrZip",
      	"Pipes2_24",
      	"SbrBirthdate",
      	"SbrMale",
      	"SbrFemale",
      	"PatSignature",
      	"DiagCode1",
      	"Pipes3_10",
      	"ServiceFrom_1",
      	"ServiceFrom_2",
      	"Pipes4_4",
      	"ServiceTo_1",
      	"ServiceTo_2",
      	"POS_1",
      	"ProcCode_1",
      	"ProcCode_2",
      	"DiagPtrs_1",
      	"DiagPtrs_2",
      	"Charge_1",
      	"Charge_2",
      	"Pipes5_4",
      	"Units_1",
      	"Units_2",
      	"BillTin",
      	"ClaimRef",
      	"AcceptAssignmentYesNo",
      	"TotalCharge",
      	"BillNPI",
      	"BillProvNum",
      	"PayerName",
      	"Pipes6_4"
      	]

      	// Return the array
      	return jsonList;
      })()),[`quoted_string`]: false,[`quoted_empty`]: false,[`quoted`]: false,[`quote`]: '' }) }));
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.pageData, 'csvExportPath'))), true, undefined);

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Export Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    } finally {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: ['Successfully Exported ',claimRecords.length,' Claim Record(s)! (213 Format)'].join(''),[`content`]: 'Your Waystar - 213 format export was successful!',[`submit`]: '' });

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/522dc7060cd65724883e5a986e3d1739/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/__alex-billing-test/components/d1ea2e346bd628b531a5b461669edc7f/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'reviewOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/__alex-billing-test/components/241bc1fe06a400c1ed56139f3961072a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var editedObjects, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval'));
    editedObjects = (await Backendless.Data.of('Transport').bulkUpdate( (['billingExportBatchId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval')),'\''].join('')), ({ [`billingExportBatchId`]: '',[`billing213ClaimId`]: '',[`typeAdjudicationStatus`]: null }) ));
    console.log(editedObjects);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';

  } finally {
    if (editedObjects > 0) {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Was Successful';
    } else {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';
    }

  }
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['batchIdForRemoval'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/da5b585829cd86722fc8bc4eae6c6b0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'batchRemovalText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/__alex-billing-test/components/8736a3c1ee57347115f5b27f038f5677/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/76c262ad8625102e90a91d165d869a88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-billing-test/components/28a4bef5fc489676119b8982815222e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportStatusOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/__alex-billing-test/components/b5014ea78681a9e8de0b416863ff9896/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var typeInsurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setPageSize(10).setDistinct(true))).map(async typeInsurance => {; return ({ [`value`]: (getObjectProperty(typeInsurance, 'typeInsurance')),[`label`]: (getObjectProperty(typeInsurance, 'typeInsurance')) });}))).concat(({ [`value`]: 'Blank',[`label`]: '[Blank]' })))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/__alex-billing-test/components/f49f7336484273cfc88227e47c77c2dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'strWhereClause')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/6a6c294bc0c45e0e3c33bdef5d3a2178/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'strWhereClauseBase', 'color: null', (getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')));
  console.log('%c>> ' + 'strWhereClauseModifier', 'color: null', (getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));
  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClause'));

  return (await (async function(pageData) {
	console.log('pageData.strWhereClause', pageData.strWhereClause)
	return {
	  //where: pageData.strWhereClause,
	  relationsDepth: 2
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [
	  {
	    "type": "actions",
	    "field": "actions",
	    "headerName": "",
	    "headerClass": "header-title",
	    "width": 75,
	    "meta": { "align": "left" },
	    "checkboxSelection": true,
	    "headerCheckboxSelection": true
	  },
	  {
	    "field": "patFirstName",
	    "headerName": "Patient First Name",
	    "headerTooltip": "First name of the Patient.",
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "field": "patLastName",
	    "headerName": "Patient Last Name",
	    "headerTooltip": "Last name of the Patient.",
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "field": "patBirthdate",
	    "headerName": "Patient DoB",
	    "headerTooltip": "Patient's Date of Birth.",
	    "valueFormatter": (params) => {
	      if (!params.value) return '';
	      return `${params.value.slice(4, 6)}/${params.value.slice(6, 8)}/${params.value.slice(0, 4)}`;
	    },

	    "meta": { "align": "center" },
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "field": "typeInsurance",
	    "headerName": "Type Insurance",
	    "headerTooltip": "Patient's Insurance Type.",
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "field": "sbrID",
	    "headerName": "Policy Number",
	    "headerTooltip": "Patient's Policy Number / Subscriber ID.",
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "headerName": "Claim Information",
	    "children": [
	      {
	        "field": "claimStatus",
	        "headerName": "Claim Status",
	        "headerTooltip": "Current status for the given claim (paid, unpaid, etc).",
	        "cellEditor": "agSelectCellEditor",
	        "cellEditorParams": {
	          "values": ["Billed", "Partially Paid", "Re-Billed", "Hold", "Non-billable", "Paid"]
	        },
	            "onCellValueChanged": event => {
	          console.log('Event:', event);
	          console.log('Data:', event.data);
	        },
	        "sortable": true,
	        "editable": true,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "claimId",
	        "headerName": "Claim ID",
	        "headerTooltip": "ID For the Claim",
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "exportId",
	        "headerName": "Export ID",
	        "headerTooltip": "ID for the export",
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "created",
	        "headerName": "Claim Creation Date",
	        "headerTooltip": "Date which the claim was created",
	        "type": "dateColumn",
	        "cellRendererParams": {
	          "dayjsFormat": "MM/DD/YYYY"
	        },
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "totalCharges",
	        "headerName": "Total Charges",
	        "headerTooltip": "Total charges of a given claim",
	        "cellEditor": "agSelectCellEditor",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "totalReceived",
	        "headerName": "Total Received",
	        "headerTooltip": "Amount paid to the claim so far",
	        // "cellEditor": "agSelectCellEditor",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": true,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "totalBalance",
	        "headerName": "Balance Remaining",
	        "headerTooltip": "Remaining Balance of the Claim",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "serviceFrom_1",
	        "headerName": "Transport Date Start",
	        "headerTooltip": "First transport date in the claim",

	        "valueFormatter": (params) => {
	          if (!params.value) return '';
	          return `${params.value.slice(4, 6)}/${params.value.slice(6, 8)}/${params.value.slice(0, 4)}`;
	        },
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "serviceTo_1",
	        "headerName": "Transport Date End",
	        "headerTooltip": "Last transport date in the claim",
	        "valueFormatter": (params) => {
	          if (!params.value) return '';
	          return `${params.value.slice(4, 6)}/${params.value.slice(6, 8)}/${params.value.slice(0, 4)}`;
	        },
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "charge_1",
	        "headerName": "Flat Rate Charges",
	        "headerTooltip": "Base charges",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "charge_2",
	        "headerName": "Charges Over 30 Miles",
	        "headerTooltip": "Charges for miles driven above 30",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "claimNotes",
	        "headerName": "Claim Notes",
	        "headerTooltip": "Notes for the claim",
	        "sortable": true,
	        "editable": true,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      }
	    ]
	  }
	]
})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var modifier, line, claim;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function viewServiceLine() {
  console.log(___arguments['eventName']);
  console.log('RecordItem:');
  console.log(___arguments['recordItem']);
  if (___arguments['eventName'] == 'viewServiceLines') {
    console.log('entered view service lines');
    claim = (await Backendless.Data.of('Claim').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments['recordItem'], 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
    claim = claim[0];
    console.log('record item:');
    console.log(___arguments['recordItem']);
    console.log(getObjectProperty(claim, 'rel_ServiceLine'));
    modifier = ' && objectId IN (';
    var line_list = (getObjectProperty(claim, 'rel_ServiceLine'));
    for (var line_index in line_list) {
      line = line_list[line_index];
      console.log(getObjectProperty(line, 'objectId'));
      modifier = String(modifier) + String(['\'',(getObjectProperty(line, 'objectId')),'\''].join(''));
      modifier = String(modifier) + String(',');
    }
    modifier = (await (async function(str) {
    	str = str.slice(0, -1);
    	return str;
    })(modifier));
    modifier = String(modifier) + String(')');
    console.log('modifier:');
    console.log(modifier);
    ___arguments.context.pageData['serviceLineWhereModifier'] = modifier;
    console.log('serviceLineBase + Where');
    console.log(getObjectProperty(___arguments.context.pageData, 'serviceLineWhereBase'));
    console.log(getObjectProperty(___arguments.context.pageData, 'serviceLineWhereModifier'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbd8cd8905233485424cae8009b40d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94186078177d9bdd2a69883ebee89768', true);
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('e33cd49807e8ffe811eff7485b0a9df5');
  }
}


  await viewServiceLine();

  },
  /* handler:onActionIconClick */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    var claim, item, j, k, transport;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments['changedRecordItem']);
  var j_list = (getObjectProperty(___arguments['changedRecordItem'], 'rel_ServiceLine'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('ServiceLine');
    console.log(j);
    var k_list = (getObjectProperty(___arguments['changedRecordItem'], 'rel_Transport'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      console.log('Transport');
      console.log(k);
    }
  }

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* handler:onAfterUpdate */
  async ['onAfterUpdate'](___arguments) {
      console.log('%c>> ' + 'After', 'color: #f06292', undefined);
  await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');

  },
  /* handler:onAfterUpdate */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', false);
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'billingData','tableOptions': ({ [`where`]: '',[`sortBy`]: 'datetimeScheduledStart asc',[`relationsDepth`]: 2 }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Submission Code', 'Transport Date', 'Status', 'Client Name', 'Client DoB', 'SoonerCare ID', 'Medicare ID', 'Start to Dropoff Distance', 'Start to End of Day Distance', 'Total Transport Distance'] }) }));
  console.log(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'));
  console.log(Backendless.appPath);
  await (async function(url) {
  	window.open(url, "_blank");
  })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'))));

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var exportItem, insurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClauseBase'] = (String('patLastName IS NOT NULL'));
  ___arguments.context.pageData['serviceLineWhereBase'] = (String('rel_Transport IS NOT NULL'));
  ___arguments.context.pageData['payerList'] = (await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setSortBy('typeInsurance').setPageSize(100))).map(async insurance => {; return ({ [`value`]: (getObjectProperty(insurance, 'typeInsurance')),[`label`]: (getObjectProperty(insurance, 'typeInsurance')) });})));
  ___arguments.context.pageData['billingExportList'] = (await Promise.all((await Backendless.Data.of('BillingExport').find(Backendless.DataQueryBuilder.create().setWhereClause('rel_Claim is NOT NULL').setSortBy('exportId DESC').setPageSize(100))).map(async exportItem => {; return ({ [`value`]: (getObjectProperty(exportItem, 'exportId')),[`label`]: [(getObjectProperty(exportItem, 'exportId')),' - ',(new Date((getObjectProperty(exportItem, 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(exportItem, 'created'))).getDate()),'/',(new Date((getObjectProperty(exportItem, 'created'))).getFullYear())].join('') });})));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/08084838717a0617b0cd23d541e42bdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var whereClauseModifier, item, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& created >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& created <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& patLastName LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'claimsValue')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'claimsValue')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& claimStatus LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'claimsValue')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'insuranceValue')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'insuranceValue')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& payerName LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'insuranceValue')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportValue')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportValue')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& claimId LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportValue')),'%\' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('be38f4188332d7b88a4bf602eb2b224f')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('be38f4188332d7b88a4bf602eb2b224f')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('be38f4188332d7b88a4bf602eb2b224f')).map(async item => {; return (['claimStatus LIKE \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('c358a998c78829f67038f34b71987c37')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('c358a998c78829f67038f34b71987c37')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('c358a998c78829f67038f34b71987c37')).map(async item => {; return (['typeInsurance LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  ___arguments.context.pageData['strWhereClauseModifier'] = whereClauseModifier;
  console.log('strWhereClause Output');
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  console.log('Client Last Name');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = (getObjectProperty(___arguments.context.pageData, 'startDate'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = (getObjectProperty(___arguments.context.pageData, 'endDate'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/cdc24d17ae93332a77b903f552274347/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/46ce3f5d5e3b99aa135e87b85d13df39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['claimsValue'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['insuranceValue'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['clientLastName'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['claimsValue'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['insuranceValue'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['exportValue'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/c681a3c14dcb6416b42c3306d11a1018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/522dc7060cd65724883e5a986e3d1739/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/4718bdf6745898f8c072cf58fc376028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var claimList, originalClaimValueMap, error, markedRows, trx, transportObjectIdList, serviceLineObjectIdList, claim, transport, serviceLine, claimObjectIdList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function do_something() {
  markedRows = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('6a6c294bc0c45e0e3c33bdef5d3a2178'));
  trx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = trx;

    // For each item in the claims list, want to modify
    // the claim AND modify the the associated transport
    // requests that it is related to. MODIFY TOTAL BALANCE
    for (var claim_index5 in markedRows) {
      claim = markedRows[claim_index5];
      _uow.bulkUpdate('Claim', (['claimId = \'',(getObjectProperty(claim, 'claimId')),'\''].join('')), ({ [`totalReceived`]: (getObjectProperty(claim, 'totalCharges')),[`claimStatus`]: 'Paid' }));
    }

  })();

  // For each item in the claims list, want to modify the claim AND
  // modify the the associated transport requests that it is related to
  for (var claim_index6 in markedRows) {
    claim = markedRows[claim_index6];
    console.log(getObjectProperty(claim, 'totalBalance'));
  }
  console.log((await trx.execute().then(function(result) {
      const error = result && result.error

      if (error) {
        throw error
      }

    return result
    })));
  await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
}

/**
 * Describe this function...
 */
async function errorReport() {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');
  await new Promise(r => setTimeout(r, 300 || 0));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
  ___arguments.context.pageData['modal'] = ({ [`title`]: String('Error') + String(''),[`content`]: 'Error Updating Claims -  An error report has been sent to the system admin.',[`submit`]: '' });
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
  ___arguments.context.pageData['modal'] = ({ [`title`]: String('Processing') + String(' Selected Claim(s)'),[`content`]: 'Marking Selected Claim(s) and their Service Lines as Paid',[`submit`]: '' });
  markedRows = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('6a6c294bc0c45e0e3c33bdef5d3a2178'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
  ___arguments.context.pageData['modal'] = ({ [`title`]: ['Processing',markedRows.length,' Selected Claim(s)'].join(''),[`content`]: 'Marking Selected Claim(s) and their Service Lines as Paid',[`submit`]: '' });
  console.log(markedRows);
  claimObjectIdList = [];
  serviceLineObjectIdList = [];
  transportObjectIdList = [];
  // For each item in the claims list, want to modify
  // the claim AND modify the the associated transport
  // requests that it is related to. MODIFY TOTAL BALANCE
  for (var claim_index in markedRows) {
    claim = markedRows[claim_index];
    addItemToList(claimObjectIdList, (getObjectProperty(claim, 'objectId')));
  }
  console.log((await (async function(claimList) {
  	let res = []

  	res.push("(")

  	for (let i = 0; i < claimList.length; i++) {
  	  res.push(claimList[i])
  	  res.push(",")
  	}
  	res.pop();
  	res.push(")");
  	res = res.join("");

  	return "objectId IN " + res;
  })(claimObjectIdList)));
  try {
    claimList = (await Backendless.Data.of('Claim').find(Backendless.DataQueryBuilder.create().setWhereClause((await (async function(claimList) {
    	let res = []

    	res.push("(")

    	for (let i = 0; i < claimList.length; i++) {
    	  res.push('\'')
    	  res.push(claimList[i])
    	  res.push('\'')
    	  res.push(",")
    	}
    	res.pop();
    	res.push(")");
    	res = res.join("");

    	return "objectId IN " + res;
    })(claimObjectIdList))).setRelationsDepth(5).setPageSize(100)));
    // For each item in the claims list, want to modify
    // the claim AND modify the the associated transport
    // requests that it is related to. MODIFY TOTAL BALANCE
    for (var claim_index2 in claimList) {
      claim = claimList[claim_index2];
      var serviceLine_list = (getObjectProperty(claim, 'rel_ServiceLine'));
      for (var serviceLine_index in serviceLine_list) {
        serviceLine = serviceLine_list[serviceLine_index];
        addItemToList(serviceLineObjectIdList, (getObjectProperty(serviceLine, 'objectId')));
        var transport_list = (getObjectProperty(serviceLine, 'rel_Transport'));
        for (var transport_index in transport_list) {
          transport = transport_list[transport_index];
          addItemToList(transportObjectIdList, (getObjectProperty(transport, 'objectId')));
        }
      }
    }
    originalClaimValueMap = (await (async function(claimList) {
    	let map = new Map();

    	for (let i = 0; i < claimList.length; i++ ) {
    	  map.set(claimList[i].objectId, {
    	    totalReceived : claimList[i].totalReceived,
    	    claimStatus : claimList[i].claimStatus
    	  });
    	}

    	return map;
    })(claimList));
    console.log(originalClaimValueMap);

  } catch (error) {
    console.log(error);
    await errorReport();
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Claims Page', new Backendless.Bodyparts({ textmessage: 'An error occurred in Claims' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the Claims Page') + String('[Failed During Iterative Update of Claims]')), 'Changes attempting to be saved in this step', ({ [`originalValues`]: originalClaimValueMap,[`claimRecords`]: claimList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    return ;

  }
  console.log('claimList');
  console.log(claimList);
  console.log('serviceLineObjectIdList');
  console.log(serviceLineObjectIdList);
  console.log(transportObjectIdList);
  try {
    // For each item in the claims list, want to modify
    // the claim AND modify the the associated transport
    // requests that it is related to. MODIFY TOTAL BALANCE
    for (var claim_index3 in claimList) {
      claim = claimList[claim_index3];
      await Backendless.Data.of('Claim').bulkUpdate( (['objectId = \'',(getObjectProperty(claim, 'objectId')),'\''].join('')), ({ [`totalReceived`]: (getObjectProperty(claim, 'totalCharges')),[`claimStatus`]: 'Paid' }) );
    }

  } catch (error) {
    console.log(error);
    // For each item in the claims list, want to modify
    // the claim AND modify the the associated transport
    // requests that it is related to. MODIFY TOTAL BALANCE
    for (var claim_index4 in claimList) {
      claim = claimList[claim_index4];
      console.log((await (async function(currClaimObjectId, claimMap) {
      	const obj = claimMap.get(currClaimObjectId)

      	return obj.totalReceived;
      })((getObjectProperty(claim, 'objectId')), originalClaimValueMap)));
      console.log((await (async function(currClaimObjectId, claimMap) {
      	const obj = claimMap.get(currClaimObjectId)

      	return obj.claimStatus;
      })((getObjectProperty(claim, 'objectId')), originalClaimValueMap)));
      await Backendless.Data.of('Claim').bulkUpdate( (['objectId = \'',(getObjectProperty(claim, 'objectId')),'\''].join('')), ({ [`totalReceived`]: (await (async function(currClaimObjectId, claimMap) {
      	const obj = claimMap.get(currClaimObjectId)

      	return obj.totalReceived;
      })((getObjectProperty(claim, 'objectId')), originalClaimValueMap)),[`claimStatus`]: (await (async function(currClaimObjectId, claimMap) {
      	const obj = claimMap.get(currClaimObjectId)

      	return obj.claimStatus;
      })((getObjectProperty(claim, 'objectId')), originalClaimValueMap)) }) );
    }
    await errorReport();
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Claims Page', new Backendless.Bodyparts({ textmessage: 'An error occurred Marking all as Paid' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the Claims Page') + String('[Failed During Iterative Update of Claims]')), 'Changes attempting to be saved in this step', ({ [`originalValues`]: originalClaimValueMap,[`claimRecords`]: claimList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    return ;

  }
  try {
    trx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = trx;

      _uow.bulkUpdate('ServiceLine', (await (async function(claimList) {
      	let res = []

      	res.push("(")

      	for (let i = 0; i < claimList.length; i++) {
      	  res.push('\'')
      	  res.push(claimList[i])
      	  res.push('\'')
      	  res.push(",")
      	}
      	res.pop();
      	res.push(")");
      	res = res.join("");

      	return "objectId IN " + res;
      })(serviceLineObjectIdList)), ({ [`paidStatus`]: 'Paid' }));

    })();

    console.log((await trx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
    ___arguments.context.pageData['modal'] = ({ [`title`]: ['Processed',markedRows.length,' Selected Claim(s)'].join(''),[`content`]: 'Claim(s), ServiceLine(s), and Transport(s) have been marked as Paid!',[`submit`]: '' });
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6bbd8cd8905233485424cae8009b40d8')), 'Visibilty')) == true) {
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('e33cd49807e8ffe811eff7485b0a9df5');
    }

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Claims Page', new Backendless.Bodyparts({ textmessage: 'An error occurred Marking all as Paid' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the Claims Page') + String('[Failed During Data ServiceLine and Transport Transaction]')), 'Changes attempting to be saved in this step', ({ [`originalValues`]: originalClaimValueMap,[`claimRecords`]: claimList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    await errorReport();
    return ;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/e33cd49807e8ffe811eff7485b0a9df5/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  while (!((getObjectProperty(___arguments.context.pageData, 'serviceLineWhereBase')) != null && (getObjectProperty(___arguments.context.pageData, 'serviceLineWhereModifier')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  ___arguments.context.pageData['serviceLineWhere'] = (String(getObjectProperty(___arguments.context.pageData, 'serviceLineWhereBase')) + String(getObjectProperty(___arguments.context.pageData, 'serviceLineWhereModifier')));
  console.log(getObjectProperty(___arguments.context.pageData, 'serviceLineWhere'));
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClause'));

  return (await (async function(pageData) {
	return {
	  where: pageData.serviceLineWhere,
	  // relations: "rel_TransportRequest.rel_Client", TODO: Modify to include rel export
	  //properties: ["typeStatus"]//

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [

	    {
	      "field": "charge_1",
	      "headerName": "Base Charges",
	      "sortable": true,
	      "editable": false,
	      "valueFormatter": ns.currencyValueFormatter,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "width" : 250
	    },
	    {
	      "field": "charge_2",
	      "headerName": "Charges for Mileage Over 30",
	      "sortable": true,
	      "editable": false,
	      "valueFormatter": ns.currencyValueFormatter,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "width" : 250
	    },

	    {
	        "field": "totalCharges",
	        "headerName": "Total Charges for Claim",
	        "headerTooltip": "Total charges for ALL Service Lines for this claim",
	        "cellEditor": "agSelectCellEditor",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 250
	    },
	        {
	        "field": "serviceLineTotal",
	        "headerName": "Total Charges for Service Line",
	        "headerTooltip": "Total charges for this service line",
	        "cellEditor": "agSelectCellEditor",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 250
	    },
	    {
	        "field": "units_1",
	        "headerName": "Number of Transports",
	        "headerTooltip": "Total number of transports for this service line.",
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 250
	    },
	    {
	        "field": "units_2",
	        "headerName": "Total Miles above 30",
	        "headerTooltip": "Total number of miles above 30 for this service line.",
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 250
	    },
	    {
	      "field": "paidStatus",
	      "headerName": "Paid status",
	      "headerTooltip": "Paid status for this service line.",
	      "cellEditor": "agSelectCellEditor",
	      "cellEditorParams": {
	        "values": ["Billed", "Paid", "Partially Paid", "Re-Billed", "Hold", "Non-billable"]
	      },
	      "sortable": true,
	      "editable": true,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "width" : 250
	    },
	    {
	    "field": "serviceFrom",
	    "headerName": "Transport Date",
	    "valueFormatter": (params) => {
	        if (!params.value) return '';
	        return `${params.value.slice(4, 6)}/${params.value.slice(6, 8)}/${params.value.slice(0, 4)}`;
	    },
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 250
	    }
	  ]
})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/abe8a13efe4b6a58a6f82758f9cd27e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94186078177d9bdd2a69883ebee89768', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbd8cd8905233485424cae8009b40d8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/be38f4188332d7b88a4bf602eb2b224f/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Billed',[`value`]: 'Billed' }), ({ [`label`]: 'Paid',[`value`]: 'Paid' }), ({ [`label`]: 'Partially Paid',[`value`]: 'Partially Paid' }), ({ [`label`]: 'Re-Billed',[`value`]: 'Re-Billed' }), ({ [`label`]: 'Hold',[`value`]: 'Hold' }), ({ [`label`]: 'Non-billable',[`value`]: 'Non-billable' })]

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/c358a998c78829f67038f34b71987c37/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'payerList'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/__alex-claims-page-test/components/9679f189adffe468e10cf8a93a0161e8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var claim;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'billingExportList'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/__alex-datetime-picker-test/components/288957716782f2763af2592f3a1a2067/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
      return 1738693596000

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/__alex-datetime-picker-test/components/6e6c9e62da27fab62a343cbe229321a4/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
      return '02/04/2025, 02:31 pm'

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/__alex-test/components/b9b74a623a0fdb8a68ebbc3d4211e7a9/bundle.js', [], () => ({
  /* content */
  /* handler:additionalMarkersLogic */
  async ['additionalMarkersLogic'](___arguments) {
      return (await (async function() {
	return [
	    {
	    "location": { "lat": 48.852968, "lng": 2.349902 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Notre-Dame Cathedral",
	    "label": {
	      "text": "Notre-Dame Cathedral",
	      "color": "red",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.863777, "lng": 2.325000 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Place Vendôme",
	    "label": {
	      "text": "Place Vendôme",
	      "color": "green",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.879814, "lng": 2.357665 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Canal Saint-Martin",
	    "label": {
	      "text": "Canal Saint-Martin",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  }]
})())

  },
  /* handler:additionalMarkersLogic */
  /* content */
}))

define('./pages/__alex-test1/components/4ca2510b3077fff64f961286ac9b863e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}



  ;(function() {
    const callback = async () => {
        console.log('%c>> ' + 'second', 'color: #ffee58', (getObjectProperty(___arguments.context.appData, 'test')));

    };

    const timerId = 'second';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  ___arguments.context.appData['test'] = 'second';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__alex-test1/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('first');

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/__bug-fix/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['test'] = (await (async function() {
  	return [
  	    {
  	        "notesPickup": "",
  	        "city": "Oklahoma City",
  	        "typeEntity": "",
  	        "latitude": 35.4825264,
  	        "phoneIntake": "405-821-2293",
  	        "googleFormattedAddress": "1200 NE 13th St, Oklahoma City, OK 73152, USA",
  	        "ownerId": null,
  	        "okrcRegion": "OKC metro",
  	        "isPrivateResidence": false,
  	        "phoneNurse": "405-248-9368",
  	        "googleName": "(OCRU) Oklahoma Crisis Recovery Unit",
  	        "___class": "Facility",
  	        "objectId": "A090E646-3CCB-493F-B726-3A16933CC66C",
  	        "longitude": -97.4907654,
  	        "phoneMain": "405-248-9375",
  	        "address": "1200 NE 13th St",
  	        "googlePlaceId": "ChIJn79dmg0XsocR-WEsISnFIQw",
  	        "created": 1713568480000,
  	        "formattedLocation": "(OCRU) Oklahoma Crisis Recovery Unit, 1200 NE 13th St, Oklahoma City, OK 73152, USA",
  	        "zipcode": "73152",
  	        "notesDropoff": "",
  	        "googleTypes": null,
  	        "name": "OCRU",
  	        "stateCode": "OK",
  	        "updated": 1729337650389
  	    },
  	    {
  	        "notesPickup": null,
  	        "city": "Prague",
  	        "typeEntity": "",
  	        "latitude": 35.4704332,
  	        "phoneIntake": "",
  	        "googleFormattedAddress": "719 S Jim Thorpe Blvd, Prague, OK 74864, USA",
  	        "ownerId": null,
  	        "okrcRegion": "Northeast",
  	        "isPrivateResidence": false,
  	        "phoneNurse": "",
  	        "googleName": "3 Cs Boarding",
  	        "___class": "Facility",
  	        "objectId": "C23A9475-6E86-410B-91D9-C07178056A86",
  	        "longitude": -96.6791868,
  	        "phoneMain": "",
  	        "address": "719 S Jim Thorpe Blvd",
  	        "googlePlaceId": "Eiw3MTkgUyBKaW0gVGhvcnBlIEJsdmQsIFByYWd1ZSwgT0sgNzQ4NjQsIFVTQSIxEi8KFAoSCb3xpc9Y6bOHEa-jfDRrGR1nEM8FKhQKEglJ8427XemzhxFeJ8nZaOM7Aw",
  	        "created": 1713568480000,
  	        "formattedLocation": "3 Cs Boarding, 719 S Jim Thorpe Blvd, Prague, OK 74864, USA",
  	        "zipcode": "74864",
  	        "notesDropoff": "",
  	        "googleTypes": null,
  	        "name": "3 Cs Boarding",
  	        "stateCode": "OK",
  	        "updated": 1717805164219
  	    }
  	]
  })());

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/__bug-fix/components/44d42f8b064c83e2fad3d3ef52e3a4d7/bundle.js', [], () => ({
  /* content */
  /* handler:zoomLogic */
  ['zoomLogic'](___arguments) {
      return 19

  },
  /* handler:zoomLogic */
  /* handler:routeLogic */
  async ['routeLogic'](___arguments) {
      return (await (async function() {
	return [
	  {
	    "location": { "lat": 48.8584, "lng": 2.2945 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Eiffel Tower",
	    "label": {
	      "text": "Eiffel Tower",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8606, "lng": 2.3376 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Louvre Museum",
	    "label": {
	      "text": "Louvre Museum",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8867, "lng": 2.3431 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Montmartre",
	    "label": {
	      "text": "Montmartre",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8534, "lng": 2.3488 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Notre-Dame Cathedral",
	    "label": {
	      "text": "Notre-Dame Cathedral",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8608, "lng": 2.3270 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Sainte-Chapelle",
	    "label": {
	      "text": "Sainte-Chapelle",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8792, "lng": 2.3315 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Palais Garnier",
	    "label": {
	      "text": "Palais Garnier",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8638, "lng": 2.3348 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Tuileries Garden",
	    "label": {
	      "text": "Tuileries Garden",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8638, "lng": 2.3300 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Place de la Concorde",
	    "label": {
	      "text": "Place de la Concorde",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8521, "lng": 2.3490 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Musée d'Orsay",
	    "label": {
	      "text": "Musée d'Orsay",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8852, "lng": 2.3373 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Sacré-Cœur Basilica",
	    "label": {
	      "text": "Sacré-Cœur Basilica",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8721, "lng": 2.2988 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Champs-Élysées",
	    "label": {
	      "text": "Champs-Élysées",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8708, "lng": 2.3108 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Arc de Triomphe",
	    "label": {
	      "text": "Arc de Triomphe",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8742, "lng": 2.2950 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Jardin des Tuileries",
	    "label": {
	      "text": "Jardin des Tuileries",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8425, "lng": 2.2978 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Luxembourg Gardens",
	    "label": {
	      "text": "Luxembourg Gardens",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8738, "lng": 2.3210 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Pont Alexandre III",
	    "label": {
	      "text": "Pont Alexandre III",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8746, "lng": 2.2910 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Les Invalides",
	    "label": {
	      "text": "Les Invalides",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8625, "lng": 2.3322 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Conciergerie",
	    "label": {
	      "text": "Conciergerie",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8534, "lng": 2.3488 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Île de la Cité",
	    "label": {
	      "text": "Île de la Cité",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8741, "lng": 2.3103 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Place Charles de Gaulle",
	    "label": {
	      "text": "Place Charles de Gaulle",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8853, "lng": 2.3443 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Place du Tertre",
	    "label": {
	      "text": "Place du Tertre",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  }
	]

})())

  },
  /* handler:routeLogic */
  /* handler:onMarkerClick */
  async ['onMarkerClick'](___arguments) {
      console.log('%c>> ' + 'CLICK', 'color: #f06292', ___arguments['point']);
  await ( async function (componentUid, marker, popupContent) {  ___arguments.context.getComponentByUid(componentUid).showPopup(marker, popupContent) })('44d42f8b064c83e2fad3d3ef52e3a4d7', ___arguments['point'], (['<p><strong>PICKUP: </strong>','HELLO','</p> <p><a href="https://www.google.com/maps/search/?api=1&query=','WORLD','">','WORLD LKJSDFLKSDFLKSD FSDFSD F SDF SD F SD F SDF SD F SD F SDF SDF','</a></p> <p>&nbsp;</p>'].join('')));

  },
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/__chat-test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var command, obj;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'currentUser', 'color: #f06292', (getObjectProperty(___arguments.context.appData, 'currentUser')));
  console.log('%c>> ' + 'appData', 'color: #f06292', ___arguments.context.appData);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
      console.log('%c>> ' + 'leave', 'color: null', undefined);

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/__chat-test/components/b9ce81f9db36761ec3b563c8732ac4d9/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('24a342e3ffb1e2fa44885f379954d912'), 'profileImage'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/__chat-test/components/e7dd73fb7dd99c4d9dbfa161f5671171/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'usersStatus')) ? (await (async function(userObj) {
	return result = Object.entries(userObj).map(([userId, userInfo]) => {
	    return typeof userInfo === 'object'
	        ? { userId, ...userInfo }
	        : { userId, value: userInfo }
	})
})((getObjectProperty(___arguments.context.appData, 'usersStatus')))) : [])

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/__chat-test/components/f9fcf5623a8be4bf8098e5aa0cfa712b/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  if (___arguments.keyCode == 13) {
    await (getChannelInstance('chat')).send('msg', ({ [`senderId`]: (getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),[`senderName`]: (getObjectProperty(___arguments.context.appData, 'currentEmployeeData.nameFull')),[`message`]: (getObjectProperty(___arguments.context.pageData, 'message')),[`time`]: ((new Date()).toLocaleTimeString()) }));
    ___arguments.context.pageData['message'] = '';
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      console.log('%c>> ' + 'App Data', 'color: #f06292', ___arguments.context.appData);

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      console.log('%c>> 🔒 ' + 'App Data', 'color: #3f51b5', JSON.parse(JSON.stringify(___arguments.context.appData)));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/ec7c9c98e0fccf79fb26144fd168916f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['tableName'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/4b4562419bfe2f4ff90c95b764e11df9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'tableName')) || (getObjectProperty(___arguments.context.pageData, 'loading')) || (getObjectProperty(___arguments.context.pageData, 'showSecondTableField')) && !(getObjectProperty(___arguments.context.pageData, 'secondTableName')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, secondFieldOptions, firstFieldRelationMap, firstFieldOptions, secondTableSchema, tableSchema, fields, item, j, relColumnId, tableSchemaForFirstField, tableData, pageSize, offset, records, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['loading'] = true;
    ___arguments.context.pageData['loadData'] = false;
    tableSchema = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.pageData, 'tableName')) ));
    console.log('%c>> ' + 'Schema', 'color: #f06292', tableSchema);
    if (tableSchema.length > 0) {
      secondFieldOptions = (await Promise.all((await asyncListFilter(tableSchema, async (item) => {


       return ((getObjectProperty(item, 'type')) != 'RELATION');
      })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });})));
      firstFieldRelationMap = ({  });
      if (getObjectProperty(___arguments.context.pageData, 'secondTableName')) {
        secondTableSchema = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.pageData, 'secondTableName')) ));
        if (secondTableSchema.length > 0) {
          tableSchemaForFirstField = secondTableSchema;
        }
      } else {
        tableSchemaForFirstField = tableSchema;
      }
      firstFieldOptions = (await Promise.all(tableSchemaForFirstField.map(async item => {  if ((getObjectProperty(item, 'type')) == 'RELATION') {
          firstFieldRelationMap[(getObjectProperty(item, 'name'))] = [];
          var j_list = (await Backendless.Data.describe( (getObjectProperty(item, 'relatedTable')) ));
          for (var j_index in j_list) {
            j = j_list[j_index];
            addItemToList((getObjectProperty(firstFieldRelationMap, (getObjectProperty(item, 'name')))), ({ [`value`]: (getObjectProperty(j, 'name')),[`label`]: (getObjectProperty(j, 'name')) }));
          }
        }
      ; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });})));
      console.log('%c>> ' + 'FirstFieldOptions', 'color: #ab47bc', firstFieldOptions);
      console.log('%c>> ' + 'SecondtFieldOptions', 'color: #ab47bc', secondFieldOptions);
      ___arguments.context.pageData['tableSchema'] = tableSchema;
      ___arguments.context.pageData['secondTableSchema'] = secondTableSchema;
      ___arguments.context.pageData['firstFieldOptions'] = firstFieldOptions;
      ___arguments.context.pageData['firstFieldRelationMap'] = firstFieldRelationMap;
      ___arguments.context.pageData['secondFieldOptions'] = secondFieldOptions;
      ___arguments.context.pageData['loadData'] = true;
    }
    ___arguments.context.pageData['showInput'] = false;
    ___arguments.context.pageData['inputValue'] = null;
    ___arguments.context.pageData['firstField'] = null;
    ___arguments.context.pageData['firstFieldHasRelation'] = false;
    ___arguments.context.pageData['secondField'] = null;
    ___arguments.context.pageData['firstFieldRelationOptions'] = [];

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);

  } finally {
    ___arguments.context.pageData['loading'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'loading')) ? 'Loading...' : 'Load Data')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/0052de31ede30a8e4371615c8f640197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['whereClause'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/f95a0fe712cd378cb25969bb12a25ff2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loadData'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/cbdac03b8153d0efba4d7a75e8f1db53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'firstFieldOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['firstField'] = ___arguments.value;
  console.log('%c>> ' + 'RelationOptions', 'color: #4caf50', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value)));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value)) {
    ___arguments.context.pageData['firstFieldRelationOptions'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value));
    ___arguments.context.pageData['firstFieldHasRelation'] = true;
  } else {
    ___arguments.context.pageData['firstFieldHasRelation'] = false;
    ___arguments.context.pageData['firstFieldRelationOptions'] = [];
  }
  console.log('%c>> ' + 'CHANGED VALUE', 'color: #26a69a', ___arguments.value);

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBusy'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/630be754a69d98f3610e65ff6516e899/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'secondFieldOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['secondField'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBusy'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/c3975a83fa12ee888f9452f7853bbbdb/bundle.js', [], () => ({
  /* content */
  /* handler:tableNameLogic */
  ['tableNameLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')) ? (getObjectProperty(___arguments.context.pageData, 'tableName')) : 'Loggers')

  },
  /* handler:tableNameLogic */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:onDisplayAssignment */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    var columns, item, columnNames;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  columns = [];
  if ((getObjectProperty(___arguments.context.pageData, 'tableSchema')) && ((getObjectProperty(___arguments.context.pageData, 'firstField')) || (getObjectProperty(___arguments.context.pageData, 'showInput'))) && (getObjectProperty(___arguments.context.pageData, 'secondField'))) {
    columnNames = [({ [`name`]: 'objectId' }), ({ [`name`]: 'created' }), ({ [`name`]: 'updated' })];
    if (!(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && !(getObjectProperty(___arguments.context.pageData, 'showInput'))) {
      addItemToList(columnNames, ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'tableSchema')), async (item) => {
         console.log('%c>> ' + '11', 'color: #26a69a', item);


       return ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')));
      }))[0]));
    }
    addItemToList(columnNames, ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'tableSchema')), async (item) => {


     return ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'secondField')));
    }))[0]));
    columns = (await Promise.all(columnNames.map(async item => {  console.log('%c>> ' + '222', 'color: #26a69a', item);
    ; return ({ [`field`]: !(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(item, 'name')),[`headerName`]: !(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(item, 'name')),[`flex`]: 1 });})));
  }
  console.log('%c>> ' + 'COLUMNS', 'color: #26a69a', columns);

  return columns

  },
  /* handler:columnDefsLogic */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
      return (await (async function(pageData) {
	return {
	  where: pageData.loadData ? pageData.whereClause : '',
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/89ca2a827828ee538c24bb3ce0aa2eb3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'firstField')) && !(getObjectProperty(___arguments.context.pageData, 'showInput')) || !(getObjectProperty(___arguments.context.pageData, 'secondField')) || (getObjectProperty(___arguments.context.pageData, 'isBusy')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, message, result, transactionLimit, batchIndex, copyDataTx, j, batchesToProcess, updatedRecords, pageSize, offset, item, tableData, firstFieldValue, records, updatedRecordsBatch, value, firstFieldName, count, testObj;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  ___arguments.context.pageData['isBusy'] = true;
  updatedRecords = [];
  try {
    count = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'tableName'))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'whereClause')))));
    pageSize = 100;
    offset = 0;
    tableData = [];
    while (offset < count) {
      records = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'tableName'))).find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'whereClause')) ? String(getObjectProperty(___arguments.context.pageData, 'whereClause')) + String(' AND migrated = false') : 'migrated = false')).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
      console.log('%c>> ' + 'records', 'color: #ffee58', records);
      updatedRecordsBatch = (await Promise.all(records.map(async item => {  value = null;
        console.log('%c>> ' + 'SHOW', 'color: #4caf50', (getObjectProperty(___arguments.context.pageData, 'showInput')));
        if (getObjectProperty(___arguments.context.pageData, 'showInput')) {
          value = (await (async function(value) {
          	return value !== undefined
          })((getObjectProperty(___arguments.context.pageData, 'inputValue')))) ? (getObjectProperty(___arguments.context.pageData, 'inputValue')) : null;
        } else {
          firstFieldName = (getObjectProperty(___arguments.context.pageData, 'firstField'));
          if (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) {
            firstFieldName = [(getObjectProperty(___arguments.context.pageData, 'firstField')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('');
          }
          value = (await (async function(value) {
          	return value !== undefined
          })((getObjectProperty(item, firstFieldName)))) ? (getObjectProperty(item, firstFieldName)) : null;
          console.log('%c>> ' + 'firstFieldName', 'color: #42a5f5', firstFieldName);
          console.log('%c>> ' + 'firstFieldValue', 'color: #42a5f5', value);
        }
        console.log('%c>> ' + 'VALUE', 'color: #4caf50', value);
        item[(getObjectProperty(___arguments.context.pageData, 'secondField'))] = value;
        item['migrated'] = true;
      ; return item;})));
      if (updatedRecordsBatch.length > 0) {
        addItemToList(updatedRecords, [updatedRecordsBatch]);
      }
      console.log('%c>> 🔒 ' + 'UPDATED RECORDS', 'color: #26c6da', JSON.parse(JSON.stringify(updatedRecords)));
      offset = offset + pageSize;
    }
    console.log('%c>> 🔒 ' + 'UPDATED RECORDS', 'color: #42a5f5', JSON.parse(JSON.stringify(updatedRecords)));

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);
    ___arguments.context.pageData['isBusy'] = false;
    return ;

  }
  try {
    batchIndex = 0;
    transactionLimit = 15;
    while (batchIndex < updatedRecords.length) {
      batchesToProcess = updatedRecords.slice(((batchIndex + 1) - 1), batchIndex + transactionLimit);
      copyDataTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      console.log('%c>> ' + 'BATCHES', 'color: #26a69a', batchesToProcess);
      for (var j_index in batchesToProcess) {
        j = batchesToProcess[j_index];
        console.log('%c>> ' + 'JJJJJJ', 'color: #ffee58', j);
        await ( async () => {
          const _uow = copyDataTx;

          _uow.bulkUpsert((getObjectProperty(___arguments.context.pageData, 'tableName')), j).setOpResultId((String('CopyData: ') + String(generateUUID().short())));

        })();

      }
      result = (await copyDataTx.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      console.log('%c>> ' + 'RESULT: ', 'color: #f06292', result);
      batchIndex = batchIndex + transactionLimit;
    }
    if (result && (getObjectProperty(result, 'success'))) {
      message = (getObjectProperty(___arguments.context.pageData, 'showInput')) ? ['Value "',(getObjectProperty(___arguments.context.pageData, 'inputValue')),'" has been successfully copied to field "',(getObjectProperty(___arguments.context.pageData, 'secondField')),'".'].join('') : ['Data has been successfully copied from field "',(getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) ? [(getObjectProperty(___arguments.context.pageData, 'firstField')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(___arguments.context.pageData, 'firstField')),'" to field "',(getObjectProperty(___arguments.context.pageData, 'secondField')),'".'].join('');
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('c3975a83fa12ee888f9452f7853bbbdb');
      (function (message) { alert(message) })(message);
    } else {
      (function (message) { alert(message) })('No records were migrated.');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);

  } finally {
    ___arguments.context.pageData['isBusy'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isBusy')) ? 'Copying..' : 'Copy Data')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/2a0fd867dcaf54bb04678ecda7cc9eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/e0e5fd28d8086e07c74e47d7adbef80a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationOptions')) ? (getObjectProperty(___arguments.context.pageData, 'firstFieldRelationOptions')) : [])

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['firstFieldRelation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isBusy')) || !(getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/fb5de794ea719d2858b505a96f057a81/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showInput'] = ___arguments.value;
  ___arguments.context.pageData['firstField'] = null;
  if (!___arguments.value) {
    ___arguments.context.pageData['inputValue'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/11f7c908b5c5714f3f234f47c7715016/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['inputValue'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/fcd569ae593c2f4204f777053a56c0e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showInput')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/2fda31cbd606adaed0e3d44c4fcb1cd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showInput')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/20849406cd997d7d5c01ed9895782b35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showSecondTableField'] = ___arguments.value;
  ___arguments.context.pageData['firstField'] = null;
  ___arguments.context.pageData['secondField'] = null;
  if (!___arguments.value) {
    ___arguments.context.pageData['secondTableName'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/067a6c36c848e622a39375817f09469b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['secondTableName'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__data_migration_tool-backup/components/a9adcce7aef6c4144a92defee49d0b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'secondTableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:onDisplayAssignment */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:disabledLogic */
  /* handler:tableNameLogic */
  ['tableNameLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'secondTableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')) ? (getObjectProperty(___arguments.context.pageData, 'secondTableName')) : '')

  },
  /* handler:tableNameLogic */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
      return (await (async function(pageData) {
	return {
	  where: pageData.loadData ? pageData.whereClause : '',
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    var columns, item, columnNames;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  columns = [];
  if ((getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(___arguments.context.pageData, 'firstField'))) {
    columnNames = [({ [`name`]: 'objectId' }), ({ [`name`]: 'created' }), ({ [`name`]: 'updated' })];
    if (getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) {
      addItemToList(columnNames, ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'secondTableSchema')), async (item) => {


       return ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')));
      }))[0]));
    }
    columns = (await Promise.all(columnNames.map(async item => {; return ({ [`field`]: (getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(item, 'name')),[`headerName`]: (getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(item, 'name')),[`flex`]: 1 });})));
  }

  return columns

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/__google-map-test/components/5f04ff07a48caec8ddad635bb04a387a/bundle.js', [], () => ({
  /* content */
  /* handler:routeLogic */
  async ['routeLogic'](___arguments) {
      return (await (async function() {
	return [
	  {
	    "location": { "lat": 48.8584, "lng": 2.2945 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Eiffel Tower",
	    "label": {
	      "text": "START",
	      "color": "white",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8606, "lng": 2.3376 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "color": "red",
	    "title": "Louvre Museum",


	    "label": {
	      //"text": "Louvre Museum",
	      "text": "2",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8867, "lng": 2.3431 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",

	    "title": "Montmartre",
	    "label": {
	      "text": "30",
	      "color": "black",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8534, "lng": 2.3488 },
	    // "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Notre-Dame Cathedral",
	    "label": {
	      "text": "Notre-Dame Cathedral",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8608, "lng": 2.3270 },
	    // "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Sainte-Chapelle",
	    "label": {
	      "text": "Sainte-Chapelle",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8792, "lng": 2.3315 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Palais Garnier",
	    "label": {
	      "text": "Palais Garnier",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8638, "lng": 2.3348 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Tuileries Garden",
	    "label": {
	      "text": "Tuileries Garden",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8638, "lng": 2.3300 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Place de la Concorde",
	    "label": {
	      "text": "Place de la Concorde",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8521, "lng": 2.3490 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Musée d'Orsay",
	    "label": {
	      "text": "Musée d'Orsay",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8852, "lng": 2.3373 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Sacré-Cœur Basilica",
	    "label": {
	      "text": "Sacré-Cœur Basilica",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8721, "lng": 2.2988 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Champs-Élysées",
	    "label": {
	      "text": "Champs-Élysées",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8708, "lng": 2.3108 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Arc de Triomphe",
	    "label": {
	      "text": "Arc de Triomphe",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8742, "lng": 2.2950 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Jardin des Tuileries",
	    "label": {
	      "text": "Jardin des Tuileries",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8425, "lng": 2.2978 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Luxembourg Gardens",
	    "label": {
	      "text": "Luxembourg Gardens",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8738, "lng": 2.3210 },
	    //"icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Pont Alexandre III",
	    "label": {
	      "text": "Pont Alexandre III",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8746, "lng": 2.2910 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    //"title": "Les Invalides",
	    "label": {
	      "text": "Les Invalides",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8625, "lng": 2.3322 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Conciergerie",
	    "label": {
	      "text": "Conciergerie",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8534, "lng": 2.3488 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Île de la Cité",
	    "label": {
	      "text": "Île de la Cité",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8741, "lng": 2.3103 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Place Charles de Gaulle",
	    "label": {
	      "text": "Place Charles de Gaulle",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": 48.8853, "lng": 2.3443 },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Place du Tertre",
	    "label": {
	      "text": "Place du Tertre",
	      "color": "blue",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  }
	]

})())

  },
  /* handler:routeLogic */
  /* handler:trafficLogic */
  ['trafficLogic'](___arguments) {
      return true

  },
  /* handler:trafficLogic */
  /* handler:onMarkerClick */
  ['onMarkerClick'](___arguments) {
    
  },
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/__test--grouping/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Vehicles',[`pageName`]: 'vehicles' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/__test--grouping/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData) {
	return [
	  {"type":"actions", "field": "actions", "width": 75, "minWidth": 75, "pinned": "left", meta: { align: "center"}},
	  {
	    headerName: "Vehicle Info",
	    children: [
	      {
	        "field": "vehicleName",
	        "headerName": "Vehicle Name",
	        "sort": "asc",
	        "sortable": true,
	        "width": 130,
	        "pinned": "left"
	      },
	      {"field": "relCurrentlyAssignedTo_Employee.nameFull", "headerName":"Assignee", "sortable": true, "width": 180, "editable": false},
	      {"field": "samsaraVehicleId", "headerName":"Samsara Vehicle Id", "sortable": true, "width": 160, "editable": true},
	    ]
	  },
	  {
	    headerName: "Vehicle Details",
	    children: [
	      {
	        "type"            : "selectColumn",
	        "field"           : "status",
	        "headerName"      : "Status",
	        "columnGroupShow" : "open",
	        "editable"        : true,
	        "cellEditorParams": { "values": pageData.statusOptions || [] }
	      },
	      {
	        "type"              : "selectColumn",
	        "field"             : "type",
	        "headerName"        : "Type",
	        "columnGroupShow" : "open",
	        "isMulti"           : true,
	        "editable"          : true,
	        "cellRendererParams": { "withChips": true },
	        "cellEditorParams"  : { "values": pageData.typeOptions || [] }
	      },
	      {"field": "make", "headerName":"Make", "columnGroupShow" : "open", "sortable": true, "width": 160, "editable": true},
	      {"field": "model", "headerName":"Model", "columnGroupShow" : "open", "sortable": true, "width": 160, "editable": true},
	      {"field": "VIN", "headerName":"VIN", "sortable": true, "width": 160, "editable": true},
	    ]
	  },
	  {
	    headerName: "Service",
	    children: [
	      {"field": "vehicleServiceArea", "headerName":"Vehicle Service Area", "sortable": true, "width": 400, "editable": true},
	    ]
	  }
	]
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'updateVehicleInformation') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088')), 'vehicleRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
    } else {
      ___arguments['recordItem']['employee'] = (getObjectProperty(___arguments['recordItem'], 'relCurrentlyAssignedTo_Employee.objectId'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', true);
      // If the change address action is clicked then we show
      // the form to update the facility address and pass the
      // chosen item record over into the form's data container.
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088'))['vehicleRecord'] = ___arguments['recordItem'];
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    }
  } else if (___arguments['eventName'] == 'delete') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Delete operation timed out after 30s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      await Backendless.Data.of('Vehicle').remove( ___arguments['recordItem'] );
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    }
  }

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/__test--grouping/components/45bee23a419ff7c9e93a5842096578f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__test--grouping/components/f0b47b283a4ee883d73e9f978666c0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // Save the new facility into the Facility table and put
  // the returned objectId into the newFacility object
  (getObjectProperty(___arguments.context.dataModel, 'newVehicle'))['objectId'] = (getObjectProperty((await Backendless.Data.of('Vehicle').save( (getObjectProperty(___arguments.context.dataModel, 'newVehicle')) )), 'objectId'));
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Vehicle').setRelation((getObjectProperty(___arguments.context.dataModel, 'newVehicle')), 'relCurrentlyAssignedTo_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'newVehicle.employee')),'\''].join('')));
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'newVehicle.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/__test--grouping/components/4c44230b6b5983a3743bfdf3e943e3a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // Need to put this here since the submit button for the form is
  // set to default to avoid the 'submit on enter key press' issue.
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__test--grouping/components/9ec5c52d7fa4ba838d0cdea8a1291ee3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__test--grouping/components/87350f9abd387e213ce27961eb166986/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__test--grouping/components/46868346d41eb8e9a1f7c20627239776/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/__test--grouping/components/00af44ca02488116c8749b36734af088/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  console.log(___arguments.context.dataModel);
  console.log(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord'));
  await Backendless.Data.of('Vehicle').save( (getObjectProperty(___arguments.context.dataModel, 'vehicleRecord')) );
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Vehicle').setRelation((getObjectProperty(___arguments.context.dataModel, 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord.employee')),'\''].join('')));
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);
  await new Promise(r => setTimeout(r, 5000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/__test--grouping/components/a5bd36dd116f46b49f03aaecf7e57d51/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/__test--grouping/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['employeeOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['statusOptions'] = ['In Service', 'In Maintenance', 'Decommissioned', 'Sold'];
  ___arguments.context.pageData['typeOptions'] = ['Caged', 'ADA Сompliant', 'Fortified', 'Large'];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/__test--grouping/components/3daf61199bab46d90c369c21d968085f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/__test--grouping/components/8b0a3cd24b587bf41911242b3303771c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/__test--grouping/components/c32f417bdd5245a45ef5dbc53554d74e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'statusOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/__test--grouping/components/e733f9d6b8371e62a95380a18b14ce7c/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['samsaraVehicleIdUnmasked'] = ___arguments['unmaskedValue'];
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['samsaraVehicleId'] = (___arguments['value'] == '____-___-___' ? '' : ___arguments['value']);

  },
  /* handler:onChangeValue */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* content */
}))

define('./pages/__test--grouping/components/e59bdb1229974e4dd2743d3649c6dec9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  await Backendless.Data.of('Vehicle').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee', [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee'))]);
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord.objectId'))] }));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['employee'] = null;
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['relCurrentlyAssignedTo_Employee'] = null;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', true);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', false);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord.relCurrentlyAssignedTo_Employee')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/__test--grouping/components/83d65071b39727b56fda392efeee9ba5/bundle.js', [], () => ({
  /* content */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['VIN'] = ___arguments['unmaskedValue'];

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/__test--grouping/components/e4a692caa25369e243a869b4927bf9f6/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(',');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['type'] = (value || null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/__test--grouping/components/79ab6c2de1ff6ea8f7cdc907eab25915/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(',');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['type'] = (value || null);

  },
  /* handler:onChange */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle.type')) || (getObjectProperty(___arguments.context.pageData, 'typeOptions'))[0])

  },
  /* handler:valueLogic */
  /* content */
}))

define('./pages/_alex-test123/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Vehicles',[`pageName`]: 'vehicles' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/_alex-test123/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData) {
	return [

	  {
	    "field": "exportId",
	    "headerName": "Export Id",
	    "sort": "asc",
	    "sortable": true,
	    "width": 150,
	    "pinned": "left"
	  },

	]
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var waitCount, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'updateVehicleInformation') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088')), 'vehicleRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
    } else {
      ___arguments['recordItem']['employee'] = (getObjectProperty(___arguments['recordItem'], 'relCurrentlyAssignedTo_Employee.objectId'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', true);
      // If the change address action is clicked then we show
      // the form to update the facility address and pass the
      // chosen item record over into the form's data container.
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088'))['vehicleRecord'] = ___arguments['recordItem'];
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    }
  } else if (___arguments['eventName'] == 'delete') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Delete operation timed out after 30s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      await Backendless.Data.of('Vehicle').remove( ___arguments['recordItem'] );
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'getSamsaraVehicleId') {
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/getVehicleId/matchVehicleToSamsara`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments['recordItem'], 'objectId'))));

    } catch (error) {
      console.log(error);
      (function (message) { alert(message) })(error);

    } finally {
      return ;

    }
  }

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/_alex-test123/components/45bee23a419ff7c9e93a5842096578f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/_alex-test123/components/f0b47b283a4ee883d73e9f978666c0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // Save the new facility into the Facility table and put
  // the returned objectId into the newFacility object
  (getObjectProperty(___arguments.context.dataModel, 'newVehicle'))['objectId'] = (getObjectProperty((await Backendless.Data.of('Vehicle').save( (getObjectProperty(___arguments.context.dataModel, 'newVehicle')) )), 'objectId'));
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Vehicle').setRelation((getObjectProperty(___arguments.context.dataModel, 'newVehicle')), 'relCurrentlyAssignedTo_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'newVehicle.employee')),'\''].join('')));
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'newVehicle.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/_alex-test123/components/4c44230b6b5983a3743bfdf3e943e3a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // Need to put this here since the submit button for the form is
  // set to default to avoid the 'submit on enter key press' issue.
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/_alex-test123/components/9ec5c52d7fa4ba838d0cdea8a1291ee3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/_alex-test123/components/87350f9abd387e213ce27961eb166986/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/_alex-test123/components/46868346d41eb8e9a1f7c20627239776/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/_alex-test123/components/00af44ca02488116c8749b36734af088/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  console.log(___arguments.context.dataModel);
  console.log(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord'));
  await Backendless.Data.of('Vehicle').save( (getObjectProperty(___arguments.context.dataModel, 'vehicleRecord')) );
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Vehicle').setRelation((getObjectProperty(___arguments.context.dataModel, 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord.employee')),'\''].join('')));
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);
  await new Promise(r => setTimeout(r, 5000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/_alex-test123/components/a5bd36dd116f46b49f03aaecf7e57d51/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/_alex-test123/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['employeeOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['statusOptions'] = ['In Service', 'In Maintenance', 'Decommissioned', 'Sold'];
  ___arguments.context.pageData['typeOptions'] = ['Caged', 'ADA Сompliant', 'Fortified', 'Large'];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/_alex-test123/components/3daf61199bab46d90c369c21d968085f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/_alex-test123/components/8b0a3cd24b587bf41911242b3303771c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/_alex-test123/components/c32f417bdd5245a45ef5dbc53554d74e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'statusOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/_alex-test123/components/e733f9d6b8371e62a95380a18b14ce7c/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['samsaraVehicleIdUnmasked'] = ___arguments['unmaskedValue'];
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['samsaraVehicleId'] = (___arguments['value'] == '____-___-___' ? '' : ___arguments['value']);

  },
  /* handler:onChangeValue */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* content */
}))

define('./pages/_alex-test123/components/e59bdb1229974e4dd2743d3649c6dec9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  await Backendless.Data.of('Vehicle').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee', [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee'))]);
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord.objectId'))] }));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['employee'] = null;
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['relCurrentlyAssignedTo_Employee'] = null;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', true);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', false);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord.relCurrentlyAssignedTo_Employee')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/_alex-test123/components/83d65071b39727b56fda392efeee9ba5/bundle.js', [], () => ({
  /* content */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['VIN'] = ___arguments['unmaskedValue'];

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/_alex-test123/components/e4a692caa25369e243a869b4927bf9f6/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(',');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['type'] = (value || null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/_alex-test123/components/79ab6c2de1ff6ea8f7cdc907eab25915/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(',');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['type'] = (value || null);

  },
  /* handler:onChange */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle.type')) || (getObjectProperty(___arguments.context.pageData, 'typeOptions'))[0])

  },
  /* handler:valueLogic */
  /* content */
}))

define('./pages/billing/components/6a6c294bc0c45e0e3c33bdef5d3a2178/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    var waitMilliseconds;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'));
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  ___arguments.context.pageData['relations'] = 'datetimeScheduledStart';
  waitMilliseconds = 0;
  while (!((getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')) != null && (getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
    waitMilliseconds = (typeof waitMilliseconds == 'number' ? waitMilliseconds : 0) + 100;
    console.log(waitMilliseconds);
  }
  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relations: "rel_TransportRequest.rel_Client",
	  //properties: ["typeStatus"]//

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // This was broken into two different colDef's because
  // we couldn't hide typeAdjudicationStatus based on page
  // data while maintaining separate column settings.
  if ((getObjectProperty(___arguments.context.pageData, 'resetBillingFilter')) == true) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	    {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },   
    	      {
    	        "field": "exportId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },   
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	   {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	     /* {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "valueFormatterParams": {
    	         "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	         },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },*/
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	         
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesFlat",
    	        "headerName": "Flat Rate Charge",
    	        "headerTooltip": "Total flat rate charge.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	         "filterParams": {
    	             "defaultOption": "equals",
    	             "defaultFilter": "--",
    	           },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "exportId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },        
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },  
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },      
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['initialRecordItem'], 'notesBilling')) != (getObjectProperty(___arguments['changedRecordItem'], 'notesBilling'))) {
    console.log('Change in notesBilling found during On Before Update Event');
    ___arguments['changedRecordItem']['hasNewBillingNote'] = true;
  }

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/billing/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', false);
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/billing/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate'))

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/billing/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'billingData','tableOptions': ({ [`where`]: '',[`sortBy`]: 'datetimeScheduledStart asc',[`relationsDepth`]: 2 }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Submission Code', 'Transport Date', 'Status', 'Client Name', 'Client DoB', 'SoonerCare ID', 'Medicare ID', 'Start to Dropoff Distance', 'Start to End of Day Distance', 'Total Transport Distance'] }) }));
  console.log(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'));
  console.log(Backendless.appPath);
  await (async function(url) {
  	window.open(url, "_blank");
  })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'))));

  },
  /* handler:onSubmit */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showFilters'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var billingEntityList, millisecondsPerDay, typeInsurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['testingToggle'] = false;
  ___arguments.context.pageData['typeInsuranceSelectOptions'] = ((await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setPageSize(10).setDistinct(true))).map(async typeInsurance => {; return ({ [`value`]: (getObjectProperty(typeInsurance, 'typeInsurance')),[`label`]: (getObjectProperty(typeInsurance, 'typeInsurance')) });}))).concat(({ [`value`]: 'Blank',[`label`]: '[Blank]' })));
  ___arguments.context.pageData['billingEntitySelectOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: ['billingEntityName LIKE \'%',(getObjectProperty(billingEntityList, 'requesterEntityName')),'%\''].join(''),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));
  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['reviewOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];
  ___arguments.context.pageData['transportStatusOptionsFilter'] = [({ [`label`]: 'Completed',[`value`]: 'Completed' }), ({ [`label`]: 'Voided',[`value`]: 'Voided' }), ({ [`label`]: 'Canceled',[`value`]: 'Canceled' })];
  ___arguments.context.pageData['reviewOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare (XIX)', 'Medicaid (MCO)', 'Private Insurance', 'Department of Mental Health (DMH)', 'Medicare', 'Other'];
  ___arguments.context.pageData['earliestUnbilledRecord'] = ((await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause('typeAdjudicationStatus IS NULL && datetimeScheduledStart >=  \'1719810000000\'').setSortBy('datetimeScheduledStart asc').setPageSize(1)))[0]);
  console.log('earliestUnbilledRecord:');
  console.log(getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord'));
  ___arguments.context.pageData['dateEarliestUnbilledRecord'] = (getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord.datetimeScheduledStart'));
  console.log('dateEarliestUnbilledRecord');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  millisecondsPerDay = 86400000;
  ___arguments.context.pageData['queryEndDate'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord')), 'datetimeScheduledStart')) + 2 * millisecondsPerDay);
  console.log('queryEndDate:');
  console.log(getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['strWhereClauseBase'] = (['rel_TransportRequest.rel_Client.nameFirst NOT LIKE \'%test%\'',' && typeStatus != \'Voided\'',''].join(''));
  ___arguments.context.pageData['showFilters'] = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))) {
    console.log('NO data from pervious page found');
    ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',((new Date((new Date()).getTime() - (604800 * 1000))).valueOf()),'','','\'','',''].join(''));
    ___arguments.context.pageData['resetBillingFilter'] = false;
  }
  ___arguments.context.pageData['adjudicationStatusOptions'] = [null, 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Hold', 'Non-Billable', 'Exported'];
  ___arguments.context.pageData['adjudicationStatusOptionsFilter'] = ['--', 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Exported', 'Hold', 'Non-Billable'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Ride Care', 'Client', 'Facility'];
  console.log('Date of Birth Page Data');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['dateOfBirth'] = (getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ___arguments.context.pageData['billingEntityList'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: (getObjectProperty(billingEntityList, 'requesterEntityName')),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));
  ___arguments.context.pageData['typeInsuranceList'] = ((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true))).map(item => item['typeInsurance']));
  console.log('Type Insurance List');
  console.log(getObjectProperty(___arguments.context.pageData, 'typeInsuranceList'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/billing/components/44b62d41ca14d86eec4cbb56f37f4da2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['csvInProcess'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', true);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['fileName'] = (['/export/billing-data/',(new Date()),'.csv'].join(''));
  try {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'fileName')),'tableName': 'Transport','tableOptions': ({ [`where`]: String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')),[`properties`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimId', 'depositId', 'accountNumber', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'rel_TransportRequest.rel_Client.nameFull', 'rel_TransportRequest.rel_Client.datestringDateOfBirth', 'rel_TransportRequest.rel_Client.soonerCareId', 'rel_TransportRequest.rel_Client.medicareId', 'rel_TransportRequest.destinationLocationName', 'rel_TransportRequest.destinationAddress', 'rel_TransportRequest.pickupLocationName', 'rel_TransportRequest.pickupAddress', 'rel_TransportRequest.rel_Client.isFedRecognizedTribal', 'rel_TransportRequest.rel_Client.tribeAffiliations', 'rel_TransportRequest.rel_Client.tribeMemberZipcode'],[`sortBy`]: ['datestringScheduledStart asc'],[`relations`]: 'rel_TransportRequest.rel_Client',[`relationsDepth`]: undefined,[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'nameFull', 'datestringDateOfBirth', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimID', 'depositID', 'accountNumber', 'soonerCareId', 'medicareId', 'isFedRecognizedTribal', 'tribeAffiliations', 'tribeMemberZipcode', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'pickupLocationName', 'pickupAddress', 'destinationLocationName', 'destinationAddress'] }) }));
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'csvExportPath'))), true, undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  } catch (error) {
    (function (message) { alert(message) })((['We were unable to export the CSV due to error:','\n\n',error].join('')));
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/39e365d67c5a48e46c04bb4ee34e25e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'7\', \'DAY\')';
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/54fa8aace31ff4cfba1fc772bacc00e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'1\', \'MONTH\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/6e2a4327a30943ef134a4b5e1efd7b86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is 7/1/24
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart > \'',((new Date(1719817200000)).toISOString()),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/08084838717a0617b0cd23d541e42bdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, whereClauseModifier, billingEntity, millisecoundsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = (new Date((new Date())).getFullYear());
  if ((new Date((new Date())).getMonth() + 1) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth'))) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')) - 1);
  }
  console.log('Year');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year'));
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';
  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecoundsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getMinutes()) * 60000;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.submissionCode LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& exportId LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')),'%\' '].join(''));
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != null && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.insurancePolicyNumber ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'policyNumberStatus')),' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\'',' && datetimeScheduledStart <= DATEADD (\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\', \'1\', \'MONTH\')'].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')),' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(item => item['value'])))) == '["--"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& typeAdjudicationStatus IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(async item => {; return (['typeAdjudicationStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')).map(async item => {; return (['typeReviewStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')).map(async item => {; return (['typeStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(item => item['value'])))) == '["Blank"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.typeInsurance IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(async item => {; return (['rel_TransportRequest.typeInsurance LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')).map(async billingEntity => {; return (getObjectProperty(billingEntity, 'value'));}))).join(' OR '),')'].join(''));
  }
  ___arguments.context.pageData['strWhereClauseModifier'] = whereClauseModifier;
  console.log('strWhereClause Output');
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  console.log('Client Last Name');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName'));
  console.log('Last Name Output');
  console.log((await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4ff9ebf86b3a60f36dd749efbd8ec46', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44b62d41ca14d86eec4cbb56f37f4da2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/e4136efaaad65953e87a4243889408c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showMileages'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing/components/b97f0c9eb5d23ee4d006eacfeae2571c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['resetBillingFilter'] = false;
  console.log('print in button click');
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));
  Object.assign(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ({ [`multiSelectLastName`]: '',[`dateOfBirth`]: '',[`clientLastName`]: '',[`startDate`]: '',[`endDate`]: '' }));
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\' '].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['maxDate'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dataOfBirth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'dateOfBirth'))));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['clientLastName'] = (getObjectProperty(___arguments.context.pageData, 'clientLastName'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['adjudicationStatusOptionsFilter'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['reviewStatusOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = (getObjectProperty(___arguments.context.pageData, 'startDate'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = (getObjectProperty(___arguments.context.pageData, 'endDate'));
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', 'SoonerCare');

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/billing/components/cdc24d17ae93332a77b903f552274347/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = null;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing/components/46ce3f5d5e3b99aa135e87b85d13df39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('09acfa4cea2b703b9641ac79a72b2dee', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('6168ed5360bb182655333af9a587272a', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('d1ea2e346bd628b531a5b461669edc7f', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('28a4bef5fc489676119b8982815222e8', null);
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/c681a3c14dcb6416b42c3306d11a1018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing/components/09acfa4cea2b703b9641ac79a72b2dee/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var billingEntityList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'billingEntitySelectOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing/components/cd6ddbc9993163514f93f17e38e7e876/bundle.js', [], () => ({
  /* content */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirthReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirth'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/billing/components/6168ed5360bb182655333af9a587272a/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing/components/498d32ff46e565767f3840a29373bd73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var claimRecords, exportDataForTransportRecords, transportDataError, transportRecords, error, my_213ExportId, transactionUpdateExportedRecords, errorWhereClause, transactionErrorData, dataErrorFound, item, counter1, newEntry, loopClient, j, PayerName, payerItem, payerTable, existingClaimRecord, sampleClient, pageOffset, transportRecordCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function reviewTransportForError_updateClaim() {
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Exported]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function reviewTransportForError_addClaim() {
  if (!(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Insurance Policy #]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  } else if (getValueLength((getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'dateOfBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Date of Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'assignedSexAtBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Sex Assigned at Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client/Transport Destination address are both empty] ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'rel_TransportRequest.typeInsurance'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "typeInsurance" value is missing or incorrectly formatted for the "PayerName" value in 213 export]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  try {
    transportRecordCount = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))))));
    if (transportRecordCount > 100) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'More that 100 record in export',[`content`]: '213 Exports are temporarily limited to 100 records. Please update your search',[`submit`]: '' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
      return ;
    }
    pageOffset = Math.ceil(transportRecordCount / 100) * 100;
    transportRecords = [];
    while (!(pageOffset == 0)) {
      pageOffset = pageOffset - 100;
      addItemToList(transportRecords, (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100).setOffset(pageOffset))));
    }
    payerTable = (await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true)));
    console.log(payerTable);
    console.log('abc');
    transportRecords = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
    console.log('Lenght of transport record');
    console.log(transportRecords.length);
    my_213ExportId = ((new Date()).valueOf());
    console.log('Transport Records From Query');
    console.log(transportRecords);
    claimRecords = [];
    exportDataForTransportRecords = [];
    transportDataError = [];
    dataErrorFound = false;
    console.log(getObjectProperty((getObjectProperty((transportRecords[0]), 'rel_TransportRequest')), 'rel_Client.objectId'));
    sampleClient = transportRecords[0];
    for (var j_index in transportRecords) {
      j = transportRecords[j_index];
      loopClient = (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'rel_Client'));
      if (((claimRecords.map(item => item['clientObjectId'])).includes((getObjectProperty(loopClient, 'objectId')))) == true) {
        for (var existingClaimRecord_index in claimRecords) {
          existingClaimRecord = claimRecords[existingClaimRecord_index];
          if ((getObjectProperty(existingClaimRecord, 'clientObjectId')) == (getObjectProperty(loopClient, 'objectId'))) {
            await reviewTransportForError_updateClaim();
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceFromDatetime')) > (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceFrom_2`]: (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')) || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')),[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceToDatetime')) < (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceTo_2`]: (getObjectProperty(existingClaimRecord, 'Units_2')) > 0 || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : (getObjectProperty(existingClaimRecord, 'ServiceTo_2')),[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            Object.assign(existingClaimRecord, ({ [`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : (getObjectProperty(existingClaimRecord, 'ProcCode_2')),[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1||||' : '||||',[`Charge_1`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_1')))) + 160)).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_2')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) : (getObjectProperty(existingClaimRecord, 'Charge_2')),[`Units_1`]: (getObjectProperty(existingClaimRecord, 'Units_1')) + 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (getObjectProperty(existingClaimRecord, 'Units_2')) + (Number((getObjectProperty(j, 'distanceBillable')))) : (getObjectProperty(existingClaimRecord, 'Units_2')),[`TotalCharges`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'TotalCharges')))) + (Number((getObjectProperty(j, 'chargesTotal')))))).toFixed(2)),[`submissionCodes`]: ((getObjectProperty(existingClaimRecord, 'submissionCodes')).concat((getObjectProperty(j, 'transportCode_copy')))) }));
            addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: (getObjectProperty(existingClaimRecord, 'ClaimRef')),[`typeAdjudicationStatus`]: 'Exported' }));
            console.log('Claim edited');
            console.log(existingClaimRecord);
          }
        }
      } else {
        console.log('Info of new client');
        console.log([[(getObjectProperty(loopClient, 'nameLast')),', ',(getObjectProperty(loopClient, 'nameFirst'))].join(''),[(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),'DateTime',(getObjectProperty(j, 'datetimeScheduledStart'))].join(''));
        if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
          Object.assign(loopClient, ({ [`address`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.address')),[`city`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.city')),[`stateCode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.stateCode')),[`zipcode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.zipcode')) }));
        }
        PayerName = null;
        for (var payerItem_index in payerTable) {
          payerItem = payerTable[payerItem_index];
          if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(payerItem, 'typeInsurance'))) {
            PayerName = (getObjectProperty(payerItem, 'payerName'));
          } else {
          }
        }
        await reviewTransportForError_addClaim();
        newEntry = ({ [`SbrID`]: !(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) ? (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) : (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')).trim(),[`PatName`]: [(getObjectProperty(loopClient, 'nameLast')).trim(),', ',(getObjectProperty(loopClient, 'nameFirst')).trim()].join(''),[`PatBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate()),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear())].join(''),[`PatMale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'X' : null,[`PatFemale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Female' ? 'X' : null,[`Pipes1_1`]: '',[`SbrName`]: [(getObjectProperty(loopClient, 'nameLast')).trim(),', ',(getObjectProperty(loopClient, 'nameFirst')).trim()].join(''),[`PatientAddr`]: (getObjectProperty(loopClient, 'address')),[`PatientCity`]: (getObjectProperty(loopClient, 'city')),[`PatState`]: (getObjectProperty(loopClient, 'stateCode')),[`PatZip`]: (getObjectProperty(loopClient, 'zipcode')),[`PatRelSelf`]: '|X|||',[`SbrAddr`]: (getObjectProperty(loopClient, 'address')),[`SbrCity`]: (getObjectProperty(loopClient, 'city')),[`SbrState`]: (getObjectProperty(loopClient, 'stateCode')),[`SbrZip`]: (getObjectProperty(loopClient, 'zipcode')),[`Pipes2_24`]: '|||||||||||||||||||||||',[`SbrBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate()),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear())].join(''),[`SbrMale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'X' : null,[`SbrFemale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Female' ? 'X' : null,[`PatSignature`]: '||Signature on File|||||||||||||||',[`DiagCode1`]: 'Z1330',[`Pipes3_10`]: '|||||||||',[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceFrom_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : null,[`Pipes4_4`]: '|||',[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceTo_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : null,[`POS_1`]: '||||99|||||||||||',[`ProcCode_1`]: 'T2003',[`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : null,[`DiagPtrs_1`]: '||||||||||1',[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1||||' : '||||',[`Charge_1`]: (Number.parseFloat(160).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : null,[`Pipes5_4`]: '|||',[`Units_1`]: 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : null,[`BillTin`]: PayerName == 'Oklahoma Health Care Authority' ? '||||||||||||||||||||||||||||||||||||||||53AC||||||460868747||X' : '||||||||||||||||||||||||||||||||||||||||||||||460868747||X',[`ClaimRef`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`AcceptAssignmentYesNo`]: '||Y',[`TotalCharges`]: (Number.parseFloat((Number((getObjectProperty(j, 'chargesTotal'))))).toFixed(2)),[`BillNPI`]: '||Signature on file|||||||||||||||405-237-3043|OK Ride Care|2402 Westport Dr||Norman, OK 73069||||1699554634|',[`BillProvNum`]: '',[`PayerName`]: PayerName,[`Pipes6_4`]: '|||',[`submissionCodes`]: [(getObjectProperty(j, 'transportCode_copy'))],[`clientObjectId`]: (getObjectProperty(loopClient, 'objectId')),[`rel_Client`]: loopClient,[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) });
        addItemToList(claimRecords, newEntry);
        addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`typeAdjudicationStatus`]: 'Exported' }));
        console.log('New Client Added');
        console.log(newEntry);
        counter1 = (typeof counter1 == 'number' ? counter1 : 0) + 1;
        console.log(counter1);
      }
    }

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Creation of Claim Records]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
    return ;

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  console.log('Transport Records Filtered');
  console.log(claimRecords);
  console.log('Errors in the Transport Data?');
  console.log(dataErrorFound);
  console.log('Transport Database Errors?');
  console.log(transportDataError);
  errorWhereClause = ['&& objectId IN (',(await Promise.all(transportDataError.map(async item => {; return (['\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(', '),')'].join('');
  console.log('Errors Where Clause');
  console.log(errorWhereClause);
  console.log('Updated Transport Record');
  console.log(transportRecords);
  if (dataErrorFound == true) {
    try {
      transactionErrorData = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionErrorData;

        _uow.bulkUpsert('Transport', transportDataError);

      })();

      await transactionErrorData.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Data Review Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    } finally {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: String(transportDataError.length) + String(' Error(s) Were Found in Export Data'),[`content`]: 'The export was not able to complete due to errors. Export error flags have been added to these records in the billing table. Please review the "Billing Notes" field for each record to learn more information about the error.',[`submit`]: 'Review Errors' });
      ___arguments.context.pageData['strWhereClauseModifier'] = errorWhereClause;
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
      return ;

    }
  } else {
    console.log(exportDataForTransportRecords);
    try {
      transactionUpdateExportedRecords = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionUpdateExportedRecords;

        _uow.bulkDelete('Waystar2', 'objectId IS NOT NULL');
        _uow.bulkUpsert('Transport', exportDataForTransportRecords);
        _uow.bulkCreate('Waystar2', claimRecords);

      })();

      await transactionUpdateExportedRecords.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      ___arguments.context.pageData['fileName'] = (['/export/test-export/','Billing_213_Export_',my_213ExportId,'.csv'].join(''));
      ___arguments.context.pageData['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(___arguments.context.pageData, 'fileName')),'tableName': 'Waystar2','csvOptions': ({ [`header`]: false,[`delimiter`]: '|',[`columns`]: (await (async function() {
      	let jsonList = ["SbrID",
      	"PatName",
      	"PatBirthdate",
      	"PatMale",
      	"PatFemale",
      	"Pipes1_1",
      	"SbrName",
      	"PatientAddr",
      	"PatientCity",
      	"PatState",
      	"PatZip",
      	"PatRelSelf",
      	"SbrAddr",
      	"SbrCity",
      	"SbrState",
      	"SbrZip",
      	"Pipes2_24",
      	"SbrBirthdate",
      	"SbrMale",
      	"SbrFemale",
      	"PatSignature",
      	"DiagCode1",
      	"Pipes3_10",
      	"ServiceFrom_1",
      	"ServiceFrom_2",
      	"Pipes4_4",
      	"ServiceTo_1",
      	"ServiceTo_2",
      	"POS_1",
      	"ProcCode_1",
      	"ProcCode_2",
      	"DiagPtrs_1",
      	"DiagPtrs_2",
      	"Charge_1",
      	"Charge_2",
      	"Pipes5_4",
      	"Units_1",
      	"Units_2",
      	"BillTin",
      	"ClaimRef",
      	"AcceptAssignmentYesNo",
      	"TotalCharge",
      	"BillNPI",
      	"BillProvNum",
      	"PayerName",
      	"Pipes6_4"
      	]

      	// Return the array
      	return jsonList;
      })()),[`quoted_string`]: false,[`quoted_empty`]: false,[`quoted`]: false,[`quote`]: '' }) }));
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.pageData, 'csvExportPath'))), true, undefined);

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Export Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    } finally {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: ['Successfully Exported ',claimRecords.length,' Claim Record(s)! (213 Format)'].join(''),[`content`]: 'Your Waystar - 213 format export was successful!',[`submit`]: '' });

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/522dc7060cd65724883e5a986e3d1739/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/billing/components/d1ea2e346bd628b531a5b461669edc7f/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'reviewOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing/components/241bc1fe06a400c1ed56139f3961072a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var editedObjects, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval'));
    editedObjects = (await Backendless.Data.of('Transport').bulkUpdate( (['billingExportBatchId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval')),'\''].join('')), ({ [`billingExportBatchId`]: '',[`billing213ClaimId`]: '',[`typeAdjudicationStatus`]: null }) ));
    console.log(editedObjects);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';

  } finally {
    if (editedObjects > 0) {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Was Successful';
    } else {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';
    }

  }
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['batchIdForRemoval'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/da5b585829cd86722fc8bc4eae6c6b0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'batchRemovalText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/billing/components/8736a3c1ee57347115f5b27f038f5677/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/76c262ad8625102e90a91d165d869a88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/28a4bef5fc489676119b8982815222e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportStatusOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing/components/b5014ea78681a9e8de0b416863ff9896/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var typeInsurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'typeInsuranceSelectOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing/components/315d486a12b83a58edd34668d80b8e58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var billingExportEntry, serviceLineList, exportDataForTransportRecords, transportDataError, claimRecords, transportRecords, error, my_837data, fileName, billingExportId, transactionUpdateExportedRecords, serviceLineObjectIds, claimObjectIds, transportObjectId, currServiceLineObject, transportMap, serviceLineCounterId, currClaimObject, claimIdToServiceLineIdList, objectId, tx, trimmedServiceLines, trimmedClaimRecords, errorWhereClause, transactionErrorData, dataErrorFound, item, counter1, newEntry, loopClient, j, serviceEntry, serviceLineMap, currentServiceLineId, claimCounterId, payerName, my_213ExportId, contractCode, payerId, existingClaimRecord, formattedDateTime, serviceItem, isSameDay, subItem, sampleClient, payerTable, pageOffset, transportRecordCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function export837() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  try {
    transportRecordCount = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))))));
    if (transportRecordCount > 100) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'More that 100 record in export',[`content`]: '213 Exports are temporarily limited to 100 records. Please update your search',[`submit`]: '' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
    ___arguments.context.pageData['modal'] = ({ [`title`]: String('Processing') + String(' Claim Record(s) (837 Format)'),[`content`]: 'Processing Claim Records - Please do not leave page - This could take a few minutes',[`submit`]: '' });
    pageOffset = Math.ceil(transportRecordCount / 100) * 100;
    transportRecords = [];
    while (!(pageOffset == 0)) {
      pageOffset = pageOffset - 100;
      addItemToList(transportRecords, (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100).setOffset(pageOffset))));
    }
    payerTable = (await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true)));
    console.log(payerTable);
    transportRecords = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
    await set837StaticDataInPageData();
    console.log('Lenght of transport record');
    console.log(transportRecords.length);
    my_213ExportId = ((new Date()).valueOf());
    console.log('Transport Records From Query');
    console.log(transportRecords);
    transportMap = ({  });
    serviceLineMap = ({  });
    claimIdToServiceLineIdList = ({  });
    await Backendless.Counters.addAndGet('serviceLineIds', 0);
    await Backendless.Counters.addAndGet('claimIds', 0);
    tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    billingExportEntry = (await Backendless.Data.of('BillingExport').save( ({ [`exportId`]: null }) ));
    await (async function(arg) {
    	console.info(arg);
    })(billingExportEntry);
    billingExportId = (getObjectProperty(billingExportEntry, 'exportId'));
    claimRecords = [];
    exportDataForTransportRecords = [];
    transportDataError = [];
    serviceLineList = [];
    dataErrorFound = false;
    sampleClient = transportRecords[0];
    for (var j_index in transportRecords) {
      j = transportRecords[j_index];
      formattedDateTime = [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
      	return str.padStart(2, '0');

      })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
      	return str.padStart(2, '0');

      })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('');
      loopClient = (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'rel_Client'));
      if ((claimRecords.map(item => item['clientId'])).includes((getObjectProperty(loopClient, 'objectId')))) {
        for (var serviceItem_index in serviceLineList) {
          serviceItem = serviceLineList[serviceItem_index];
          await (async function(arg) {
          	console.info(arg);
          })('Entered service item for loop with service item: ');
          await (async function(arg) {
          	console.info(arg);
          })(serviceItem);
          if ((getObjectProperty((serviceItem[0]), 'clientId')) == (getObjectProperty(loopClient, 'objectId'))) {
            isSameDay = false;
            for (var subItem_index in serviceItem) {
              subItem = serviceItem[subItem_index];
              if ((getObjectProperty(subItem, 'procCode')) == 'T2003' && (getObjectProperty(subItem, 'serviceFrom')) == formattedDateTime) {
                await (async function(arg) {
                	console.info(arg);
                })('Service Item case 1');
                isSameDay = true;
                Object.assign(subItem, ({ [`charge`]: (Number.parseFloat(((Number((getObjectProperty(subItem, 'charge')))) + 160)).toFixed(2)),[`units`]: (Number((getObjectProperty(subItem, 'units')))) + 1 }));
                Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + 160)).toFixed(2)) }));
                addItemToList((getObjectProperty(transportMap, (getObjectProperty(subItem, 'serviceLineId')))), (getObjectProperty(j, 'objectId')));
              }
              if ((getObjectProperty(subItem, 'procCode')) == 'S0215' && (getObjectProperty(subItem, 'serviceFrom')) == formattedDateTime) {
                if ((getObjectProperty(j, 'distanceBillable')) > '0') {
                  await (async function(arg) {
                  	console.info(arg);
                  })('Service Item case 2');
                  isSameDay = true;
                  Object.assign(subItem, ({ [`charge`]: (Number.parseFloat(((Number((getObjectProperty(subItem, 'charge')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)),[`units`]: (Number((getObjectProperty(subItem, 'units')))) + (Number((getObjectProperty(j, 'distanceBillable')))) }));
                  Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) }));
                }
              }
            }
            if (isSameDay == false) {
              await (async function(arg) {
              	console.info(arg);
              })('Service Item Case 3');
              currentServiceLineId = (await Backendless.Counters.addAndGet('serviceLineIds', 1));
              addItemToList(serviceItem, ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'T2003',[`charge`]: (Number.parseFloat(160).toFixed(2)),[`units`]: 1,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }));
              addItemToList(serviceItem, ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'S0215',[`charge`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : 0,[`units`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : 0,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }));
              addItemToList((getObjectProperty(claimIdToServiceLineIdList, (getObjectProperty((serviceItem[0]), 'parentClaimCounterId')))), currentServiceLineId);
              Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + 160)).toFixed(2)) }));
              Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) }));
              transportMap[currentServiceLineId] = [];
              addItemToList((getObjectProperty(transportMap, currentServiceLineId)), (getObjectProperty(j, 'objectId')));
              await (async function(arg) {
              	console.info(arg);
              })('Service Item After Case 3');
              await (async function(arg) {
              	console.info(arg);
              })(serviceItem);
            }
          }
        }
        for (var existingClaimRecord_index in claimRecords) {
          existingClaimRecord = claimRecords[existingClaimRecord_index];
          if ((getObjectProperty(existingClaimRecord, 'clientId')) == (getObjectProperty(loopClient, 'objectId'))) {
            await (async function(arg) {
            	console.info(arg);
            })('Entered claim record modifications');
            await reviewTransportForError_updateClaim();
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'serviceFromDatetime')) > (getObjectProperty(j, 'datetimeScheduledStart'))) {
              await (async function(arg) {
              	console.info(arg);
              })('entered service from block');
              Object.assign(existingClaimRecord, ({ [`serviceFrom_2`]: (getObjectProperty(existingClaimRecord, 'serviceFrom_2')) || (getObjectProperty(j, 'distanceBillable')) > 0 ? formattedDateTime : (getObjectProperty(existingClaimRecord, 'serviceFrom_2')),[`serviceFrom_1`]: formattedDateTime,[`serviceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'serviceToDatetime')) < (getObjectProperty(j, 'datetimeScheduledStart'))) {
              await (async function(arg) {
              	console.info(arg);
              })('entered service to block');
              Object.assign(existingClaimRecord, ({ [`serviceTo_2`]: (getObjectProperty(existingClaimRecord, 'units_2')) > 0 || (getObjectProperty(j, 'distanceBillable')) > 0 ? formattedDateTime : (getObjectProperty(existingClaimRecord, 'serviceTo_2')),[`serviceTo_1`]: formattedDateTime }));
            }
            await (async function(arg) {
            	console.info(arg);
            })('entrered cost mods');
            Object.assign(existingClaimRecord, ({ [`charge_1`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'charge_1')))) + 160)).toFixed(2)),[`charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'charge_2')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) : (getObjectProperty(existingClaimRecord, 'charge_2')),[`units_1`]: (getObjectProperty(existingClaimRecord, 'units_1')) + 1,[`units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (getObjectProperty(existingClaimRecord, 'units_2')) + (Number((getObjectProperty(j, 'distanceBillable')))) : (getObjectProperty(existingClaimRecord, 'units_2')),[`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesTotal')))))).toFixed(2)) }));
            addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: (getObjectProperty(existingClaimRecord, 'ClaimRef')),[`typeAdjudicationStatus`]: 'Exported' }));
            await (async function(arg) {
            	console.info(arg);
            })('Claim Edited');
            await (async function(arg) {
            	console.info(arg);
            })(existingClaimRecord);
          }
        }
      } else {
        console.log('Info of new client');
        console.log([[(getObjectProperty(loopClient, 'nameLast')),', ',(getObjectProperty(loopClient, 'nameFirst'))].join(''),[(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),'DateTime',(getObjectProperty(j, 'datetimeScheduledStart'))].join(''));
        if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
          Object.assign(loopClient, ({ [`address`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.address')),[`city`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.city')),[`stateCode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.stateCode')),[`zipcode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.zipcode')) }));
        }
        payerName = 'MissingName';
        payerId = 'MissingID';
        await setPayerName();
        await setPayerId();
        await setContractCode();
        await reviewTransportForError_addClaim();
        claimCounterId = (await Backendless.Counters.addAndGet('claimIds', 1));
        newEntry = ({ [`exportId`]: billingExportId,[`typeInsurance`]: (getObjectProperty(j, 'rel_TransportRequest.typeInsurance')),[`counterId`]: claimCounterId,[`claimId`]: [(getObjectProperty(loopClient, 'nameFirst')).trim().slice(0, 3),'.',(getObjectProperty(loopClient, 'nameLast')).trim().slice(0, 3),'.',billingExportId].join(''),[`claimStatus`]: 'Billed',[`clientId`]: (getObjectProperty(loopClient, 'objectId')),[`interchangeControlNumber`]: (getObjectProperty(___arguments.context.pageData, 'interchangeControlNumber')),[`acknowledgementRequested`]: (getObjectProperty(___arguments.context.pageData, 'acknowledgementRequested')),[`usageIndicator`]: (getObjectProperty(___arguments.context.pageData, 'usageIndicator')),[`groupControlNumber`]: (getObjectProperty(___arguments.context.pageData, 'groupControlNumber')),[`referenceIdentification`]: (getObjectProperty(___arguments.context.pageData, 'referenceID')),[`currentYear`]: (new Date(((new Date()).toLocaleString())).getFullYear()),[`currentMonth`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMonth() + 1))))),[`currentDay`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getDate()))))),[`currentHour`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getHours()))))),[`currentMinute`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMinutes()))))),[`clientAccountName`]: 'OK RIDE CARE',[`clientAccountID`]: 'DRC9521',[`receiverETINCode`]: 'H1270',[`payerID`]: payerId,[`contractCode`]: contractCode,[`patientAccountNumber`]: (getObjectProperty(j, 'transportCode_copy')),[`placeOfServiceCode`]: '99',[`facilityCodeQualifier`]: 'B',[`claimFrequencyCode`]: '1',[`providerSignatureIndicator`]: 'Y',[`medicareAssignmentCode`]: 'A',[`benefitsAssignmentCertificationIndicator`]: 'Y',[`releaseOfInformationCode`]: 'Y',[`facilityNPICode`]: '1234567893',[`sbrID`]: !(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) ? (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) : (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')).trim(),[`patFirstName`]: (getObjectProperty(loopClient, 'nameFirst')).trim(),[`patLastName`]: (getObjectProperty(loopClient, 'nameLast')).trim(),[`patBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate())))))].join(''),[`patAssignedSex`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'M' : 'F',[`patientAddr`]: (getObjectProperty(loopClient, 'address')),[`patientCity`]: (getObjectProperty(loopClient, 'city')),[`patState`]: (getObjectProperty(loopClient, 'stateCode')),[`patZip`]: (getObjectProperty(loopClient, 'zipcode')),[`patRelSelf`]: 'X',[`patSignature`]: 'Signature on File',[`diagCode1`]: 'Z1330',[`serviceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`serviceFrom_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : null,[`serviceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`serviceTo_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : null,[`serviceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`serviceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`procCode_1`]: 'T2003',[`procCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : null,[`diagPtrs_1`]: '1',[`diagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1' : '',[`charge_1`]: (Number.parseFloat(160).toFixed(2)),[`charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : null,[`units_1`]: 1,[`units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : null,[`billTin`]: '460868747',[`billZip`]: '730696336',[`claimRef`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`acceptAssignmentYesNo`]: 'Y',[`totalReceived`]: '0',[`totalCharges`]: (Number.parseFloat((Number((getObjectProperty(j, 'chargesTotal'))))).toFixed(2)),[`billNPI`]: '1699554634',[`payerName`]: payerName,[`renProvSignature`]: 'SIGNATURE ON FILE',[`billPhone`]: '4052373043',[`billName`]: 'OK Ride Care',[`billAdd`]: '2404 Westport Dr',[`billCity`]: 'Norman',[`billState`]: 'OK' });
        currentServiceLineId = (await Backendless.Counters.addAndGet('serviceLineIds', 1));
        serviceEntry = [({ [`clientId`]: (getObjectProperty(loopClient, 'objectId')),[`totalCharges`]: (Number.parseFloat((160 + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)),[`parentClaimCounterId`]: claimCounterId }), ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'T2003',[`charge`]: (Number.parseFloat(160).toFixed(2)),[`units`]: 1,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }), ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'S0215',[`charge`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : 0,[`units`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : 0,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') })];
        await (async function(parentList, childList) {
        	parentList.push(childList)
        })(serviceLineList, serviceEntry);
        transportMap[currentServiceLineId] = [];
        claimIdToServiceLineIdList[claimCounterId] = [];
        addItemToList((getObjectProperty(claimIdToServiceLineIdList, claimCounterId)), currentServiceLineId);
        addItemToList((getObjectProperty(transportMap, currentServiceLineId)), (getObjectProperty(j, 'objectId')));
        serviceLineMap[(getObjectProperty(loopClient, 'objectId'))] = serviceEntry;
        addItemToList(claimRecords, newEntry);
        addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: billingExportId,[`billing213ClaimId`]: [(getObjectProperty(loopClient, 'nameFirst')).trim().slice(0, 3),'.',(getObjectProperty(loopClient, 'nameLast')).trim().slice(0, 3),'.',billingExportId].join(''),[`typeAdjudicationStatus`]: 'Exported',[`exportId`]: billingExportId }));
        console.log('New Client Added');
        console.log(newEntry);
        counter1 = (typeof counter1 == 'number' ? counter1 : 0) + 1;
        console.log(counter1);
      }
    }
    trimmedClaimRecords = [];
    trimmedServiceLines = [];
    await (async function(arg) {
    	console.info(arg);
    })(serviceLineList);
    for (var item_index in claimRecords) {
      item = claimRecords[item_index];
      addItemToList(trimmedClaimRecords, (await (async function(claim) {
      	const copy = JSON.parse(JSON.stringify(claim));

      	delete copy.serviceFromDatetime;
      	delete copy.serviceToDatetime;
      	delete copy.clientId;

      	return copy;
      })(item)));
    }
    for (var item_index2 in serviceLineList) {
      item = serviceLineList[item_index2];
      addItemToList(trimmedServiceLines, (await (async function(lineList) {
      	const copy = JSON.parse(JSON.stringify(lineList));

      	let result = [];

      	for (let i = 1; i < copy.length; i += 2) {
      	  let curr = {
      	    counterId : copy[i].serviceLineId,
      	    totalCharges : copy[0].totalCharges,
      	    charge_1 : copy[i].charge,
      	    charge_2 : copy[i + 1].charge,
      	    units_1 : copy[i].units,
      	    units_2 : copy[i + 1].units,
      	    serviceFrom : copy[i].serviceFrom,
      	    paidStatus : "Billed"
      	  };
      	  result.push(curr)
      	}

      	return result;
      })(item)));
    }
    await (async function(arg) {
    	console.info(arg);
    })('trimmed service lines:');
    await (async function(arg) {
    	console.info(arg);
    })(trimmedServiceLines);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('errors-rc@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Creation of Claim Records and Service Lines]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    try {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

    } catch (error) {

    }
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
    ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
    await Backendless.Data.of('BillingExport').remove( billingExportEntry );
    return ;

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  console.log('Transport Records Filtered');
  console.log(claimRecords);
  console.log('Errors in the Transport Data?');
  console.log(dataErrorFound);
  console.log('Transport Database Errors?');
  console.log(transportDataError);
  errorWhereClause = ['&& objectId IN (',(await Promise.all(transportDataError.map(async item => {; return (['\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(', '),')'].join('');
  console.log('Errors Where Clause');
  console.log(errorWhereClause);
  console.log('Updated Transport Record');
  console.log(transportRecords);
  if (dataErrorFound == true) {
    try {
      transactionErrorData = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionErrorData;

        _uow.bulkUpsert('Transport', transportDataError);

      })();

      await transactionErrorData.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('errors-rc@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Data Review Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      try {
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

      } catch (error) {

      }
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      return ;

    } finally {
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      try {
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

      } catch (error) {

      }
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: String(transportDataError.length) + String(' Error(s) Were Found in Export Data'),[`content`]: 'The export was not able to complete due to errors. Export error flags have been added to these records in the billing table. Please review the "Billing Notes" field for each record to learn more information about the error.',[`submit`]: 'Review Errors' });
      ___arguments.context.pageData['strWhereClauseModifier'] = errorWhereClause;
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
      return ;

    }
  } else {
    try {
      await ( async () => {
        const _uow = tx;

        claimObjectIds = (_uow.bulkCreate('Claim', trimmedClaimRecords));
        serviceLineObjectIds = (_uow.bulkCreate('ServiceLine', trimmedServiceLines));
        _uow.setRelation('BillingExport', (getObjectProperty(billingExportEntry, 'objectId')), 'rel_Claim', claimObjectIds);

      })();

      await tx.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      await (async function(arg) {
      	console.info(arg);
      })('pre set');
      await (async function(arg) {
      	console.info(arg);
      })(claimObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })(serviceLineObjectIds);
      claimObjectIds = (claimObjectIds.getResult());
      serviceLineObjectIds = (serviceLineObjectIds.getResult());
      ___arguments.context.pageData['serviceLineObjectIdList'] = serviceLineObjectIds;
      ___arguments.context.pageData['claimObjectIdList'] = claimObjectIds;
      await (async function(arg) {
      	console.info(arg);
      })('post set');
      await (async function(arg) {
      	console.info(arg);
      })(claimObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })(serviceLineObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })('done');
      for (var objectId_index in claimObjectIds) {
        objectId = claimObjectIds[objectId_index];
        currClaimObject = (await Backendless.Data.of('Claim').findById(objectId, ));
        var serviceLineCounterId_list = (getObjectProperty(claimIdToServiceLineIdList, (getObjectProperty(currClaimObject, 'counterId'))));
        for (var serviceLineCounterId_index in serviceLineCounterId_list) {
          serviceLineCounterId = serviceLineCounterId_list[serviceLineCounterId_index];
          currServiceLineObject = (await Backendless.Data.of('ServiceLine').find(Backendless.DataQueryBuilder.create().setWhereClause((String('counterId = ') + String(serviceLineCounterId))).setPageSize(1)));
          await Backendless.Data.of('Claim').addRelation(currClaimObject, 'rel_ServiceLine', currServiceLineObject);
          var transportObjectId_list = (getObjectProperty(transportMap, serviceLineCounterId));
          for (var transportObjectId_index in transportObjectId_list) {
            transportObjectId = transportObjectId_list[transportObjectId_index];
            transportObjectId = (await (async function(arg) {
            	if (Array.isArray(arg) && arg.length > 0) {
            	  return arg[0]
            	}
            	return arg
            })(transportObjectId));
            currServiceLineObject = (await (async function(arg) {
            	if (Array.isArray(arg) && arg.length > 0) {
            	  return arg[0]
            	}
            	return arg
            })(currServiceLineObject));
            await Backendless.Data.of('ServiceLine').addRelation(currServiceLineObject, 'rel_Transport', [transportObjectId]);
          }
        }
      }
      try {
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

      } catch (error) {

      }

    } catch (error) {
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( claimObjectIds )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( serviceLineObjectIds )));
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('errors-rc@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Database Interactions - Committing to Database and Setting Relations]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      try {
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

      } catch (error) {

      }
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    }
    console.log(exportDataForTransportRecords);
    try {
      transactionUpdateExportedRecords = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionUpdateExportedRecords;

        _uow.bulkUpsert('Transport', exportDataForTransportRecords);

      })();

      await transactionUpdateExportedRecords.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('errors-rc@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Updating Transaction Data]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'claimObjectIdList')) )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'serviceLineObjectIdList')) )));
      return ;

    }
    try {
      if (claimRecords == null) {
        throw (new Error('[ERROR] - Claim records null'))
      } else {
        console.log(claimRecords);
        my_837data = (await Backendless.Request.post(`${Backendless.appPath}/services/createX12Transaction/create837FromClaimList`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'claims': claimRecords,'claimInformationList': serviceLineList }));
        fileName = ['837-',billingExportId,'.CLP'].join('');
        await Backendless.Request.post(`${Backendless.appPath}/services/sftpUtils/sendFileOverSFTP`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'fileData': my_837data,'fileName': fileName });
        console.log(fileName);
        await Backendless.Files.saveFile(encodePath('/export/edi-files'), fileName, my_837data, false);
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
        ___arguments.context.pageData['modal'] = ({ [`title`]: ['Successfully Exported ',claimRecords.length,' Claim Record(s)! (837 Format)'].join(''),[`content`]: 'Your 837 File is successfully submitted to Waystar!',[`submit`]: '' });
      }

    } catch (error) {
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('errors-rc@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Upload to Waystar]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'claimObjectIdList')) )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'serviceLineObjectIdList')) )));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });

    }
  }
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function setContractCode() {
  contractCode = 'MissingCode';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      if ((getObjectProperty(item, 'contractCode')) != null && (getObjectProperty(item, 'contractCode')) != '') {
        contractCode = (getObjectProperty(item, 'contractCode'));
      }
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function setPayerId() {
  payerId = 'MissingId';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      payerId = (getObjectProperty(item, 'payerId'));
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function setPayerName() {
  payerName = 'MissingName';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      payerName = (getObjectProperty(item, 'payerName'));
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function set837StaticDataInPageData() {
  ___arguments.context.pageData['interchangeControlNumber'] = '123456789';
  ___arguments.context.pageData['acknowledgementRequested'] = '1';
  ___arguments.context.pageData['usageIndicator'] = 'T';
  ___arguments.context.pageData['groupControlNumber'] = '12345';
  ___arguments.context.pageData['referenceID'] = 'ReferenceID';
}

/**
 * Describe this function...
 */
async function reviewTransportForError_updateClaim() {
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Resubmitted') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Exported]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Suspended' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Denied') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Suspended / Denied]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'chargesTotal')) == null || (getObjectProperty(j, 'chargesTotal')) == 0) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "totalCharges" missing or formatted incorrectly ]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'typeReviewStatus')) || (getObjectProperty(j, 'typeReviewStatus')) != 'Processed') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Value for Review Status is Missing or not Processed]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function reviewTransportForError_addClaim() {
  if (!(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Insurance Policy #]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  } else if (getValueLength((getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'dateOfBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Date of Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'assignedSexAtBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Sex Assigned at Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client/Transport Destination address are both empty] ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record already Exported]',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'rel_TransportRequest.typeInsurance'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "typeInsurance" value is missing or incorrectly formatted for the "PayerName" value in 837 export]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Suspended' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Denied') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Suspended / Denied]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'chargesTotal')) == null || (getObjectProperty(j, 'chargesTotal')) == 0) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "totalCharges" missing or formatted incorrectly ]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'typeReviewStatus')) || (getObjectProperty(j, 'typeReviewStatus')) != 'Processed') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Value for Review Status is Missing or not Processed]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}


  await export837();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing/components/663d84dcc8987dd23dcccd46db3d66cb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showFilters'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing/components/12885108b5dca9082902d42166e88b08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showFilters')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing/components/97b68f28bb0b42c6446dc2388d683428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await BackendlessUI.Functions.Custom['fn_5e3d747678a122a896439d3f05f6fb88']((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getAGGridAPI() })('6a6c294bc0c45e0e3c33bdef5d3a2178')), (String('Billing-export-') + String(new Date())))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/6a6c294bc0c45e0e3c33bdef5d3a2178/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    var waitMilliseconds;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'));
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  ___arguments.context.pageData['relations'] = 'datetimeScheduledStart';
  waitMilliseconds = 0;
  while (!((getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')) != null && (getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
    waitMilliseconds = (typeof waitMilliseconds == 'number' ? waitMilliseconds : 0) + 100;
    console.log(waitMilliseconds);
  }
  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relations: "rel_TransportRequest.rel_Client",
	  //properties: ["typeStatus"]//

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // This was broken into two different colDef's because
  // we couldn't hide typeAdjudicationStatus based on page
  // data while maintaining separate column settings.
  if ((getObjectProperty(___arguments.context.pageData, 'resetBillingFilter')) == true) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	    {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },   
    	      {
    	        "field": "billingExportBatchId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },   
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	   {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	     /* {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "valueFormatterParams": {
    	         "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	         },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },*/
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	         
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesFlat",
    	        "headerName": "Flat Rate Charge",
    	        "headerTooltip": "Total flat rate charge.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	         "filterParams": {
    	             "defaultOption": "equals",
    	             "defaultFilter": "--",
    	           },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "billingExportBatchId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },        
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },  
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },      
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['initialRecordItem'], 'notesBilling')) != (getObjectProperty(___arguments['changedRecordItem'], 'notesBilling'))) {
    console.log('Change in notesBilling found during On Before Update Event');
    ___arguments['changedRecordItem']['hasNewBillingNote'] = true;
  }

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', false);
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'billingData','tableOptions': ({ [`where`]: '',[`sortBy`]: 'datetimeScheduledStart asc',[`relationsDepth`]: 2 }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Submission Code', 'Transport Date', 'Status', 'Client Name', 'Client DoB', 'SoonerCare ID', 'Medicare ID', 'Start to Dropoff Distance', 'Start to End of Day Distance', 'Total Transport Distance'] }) }));
  console.log(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'));
  console.log(Backendless.appPath);
  await (async function(url) {
  	window.open(url, "_blank");
  })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'))));

  },
  /* handler:onSubmit */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showFilters'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var billingEntityList, millisecondsPerDay, typeInsurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['typeInsuranceSelectOptions'] = ((await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setPageSize(10).setDistinct(true))).map(async typeInsurance => {; return ({ [`value`]: (getObjectProperty(typeInsurance, 'typeInsurance')),[`label`]: (getObjectProperty(typeInsurance, 'typeInsurance')) });}))).concat(({ [`value`]: 'Blank',[`label`]: '[Blank]' })));
  ___arguments.context.pageData['billingEntitySelectOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: ['billingEntityName LIKE \'%',(getObjectProperty(billingEntityList, 'requesterEntityName')),'%\''].join(''),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));
  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['reviewOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];
  ___arguments.context.pageData['transportStatusOptionsFilter'] = [({ [`label`]: 'Completed',[`value`]: 'Completed' }), ({ [`label`]: 'Voided',[`value`]: 'Voided' }), ({ [`label`]: 'Canceled',[`value`]: 'Canceled' })];
  ___arguments.context.pageData['reviewOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare (XIX)', 'Medicaid (MCO)', 'Private Insurance', 'Department of Mental Health (DMH)', 'Medicare', 'Other'];
  ___arguments.context.pageData['earliestUnbilledRecord'] = ((await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause('typeAdjudicationStatus IS NULL && datetimeScheduledStart >=  \'1719810000000\'').setSortBy('datetimeScheduledStart asc').setPageSize(1)))[0]);
  console.log('earliestUnbilledRecord:');
  console.log(getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord'));
  ___arguments.context.pageData['dateEarliestUnbilledRecord'] = (getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord.datetimeScheduledStart'));
  ___arguments.context.pageData['startDate'] = (getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  console.log('dateEarliestUnbilledRecord');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  millisecondsPerDay = 86400000;
  ___arguments.context.pageData['queryEndDate'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord')), 'datetimeScheduledStart')) + 2 * millisecondsPerDay);
  console.log('queryEndDate:');
  console.log(getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['endDate'] = (getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['strWhereClauseBase'] = (['datetimeScheduledStart >= \'1719810000000\' ',' && rel_TransportRequest.rel_Client.nameFirst NOT LIKE \'%test%\'',' && typeStatus != \'Voided\''].join(''));
  ___arguments.context.pageData['showFilters'] = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))) {
    console.log('NO data from pervious page found');
    ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\'','',''].join(''));
    ___arguments.context.pageData['resetBillingFilter'] = false;
  }
  ___arguments.context.pageData['adjudicationStatusOptions'] = [null, 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Hold', 'Non-Billable'];
  ___arguments.context.pageData['adjudicationStatusOptionsFilter'] = ['--', 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Exported', 'Hold', 'Non-Billable'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Ride Care', 'Client', 'Facility'];
  console.log('Date of Birth Page Data');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['dateOfBirth'] = (getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ___arguments.context.pageData['billingEntityList'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: (getObjectProperty(billingEntityList, 'requesterEntityName')),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));
  ___arguments.context.pageData['typeInsuranceList'] = ((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true))).map(item => item['typeInsurance']));
  console.log('Type Insurance List');
  console.log(getObjectProperty(___arguments.context.pageData, 'typeInsuranceList'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/44b62d41ca14d86eec4cbb56f37f4da2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['csvInProcess'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', true);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['fileName'] = (['/export/billing-data/',(new Date()),'.csv'].join(''));
  try {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'fileName')),'tableName': 'Transport','tableOptions': ({ [`where`]: String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')),[`properties`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimId', 'depositId', 'accountNumber', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'rel_TransportRequest.rel_Client.nameFull', 'rel_TransportRequest.rel_Client.datestringDateOfBirth', 'rel_TransportRequest.rel_Client.soonerCareId', 'rel_TransportRequest.rel_Client.medicareId', 'rel_TransportRequest.destinationLocationName', 'rel_TransportRequest.destinationAddress', 'rel_TransportRequest.pickupLocationName', 'rel_TransportRequest.pickupAddress', 'rel_TransportRequest.rel_Client.isFedRecognizedTribal', 'rel_TransportRequest.rel_Client.tribeAffiliations', 'rel_TransportRequest.rel_Client.tribeMemberZipcode'],[`sortBy`]: ['datestringScheduledStart asc'],[`relations`]: 'rel_TransportRequest.rel_Client',[`relationsDepth`]: undefined,[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'nameFull', 'datestringDateOfBirth', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimID', 'depositID', 'accountNumber', 'soonerCareId', 'medicareId', 'isFedRecognizedTribal', 'tribeAffiliations', 'tribeMemberZipcode', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'pickupLocationName', 'pickupAddress', 'destinationLocationName', 'destinationAddress'] }) }));
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'csvExportPath'))), true, undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  } catch (error) {
    (function (message) { alert(message) })((['We were unable to export the CSV due to error:','\n\n',error].join('')));
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/39e365d67c5a48e46c04bb4ee34e25e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'7\', \'DAY\')';
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/54fa8aace31ff4cfba1fc772bacc00e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'1\', \'MONTH\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/6e2a4327a30943ef134a4b5e1efd7b86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is 7/1/24
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart > \'',((new Date(1719817200000)).toISOString()),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/08084838717a0617b0cd23d541e42bdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, whereClauseModifier, billingEntity, millisecoundsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = (new Date((new Date())).getFullYear());
  if ((new Date((new Date())).getMonth() + 1) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth'))) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')) - 1);
  }
  console.log('Year');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year'));
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';
  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecoundsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getMinutes()) * 60000;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.submissionCode LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& billingExportBatchId LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')),'%\' '].join(''));
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != null && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.insurancePolicyNumber ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'policyNumberStatus')),' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\'',' && datetimeScheduledStart <= DATEADD (\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\', \'1\', \'MONTH\')'].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')),' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(item => item['value'])))) == '["--"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& typeAdjudicationStatus IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(async item => {; return (['typeAdjudicationStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')).map(async item => {; return (['typeReviewStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')).map(async item => {; return (['typeStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(item => item['value'])))) == '["Blank"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.typeInsurance IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(async item => {; return (['rel_TransportRequest.typeInsurance LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')).map(async billingEntity => {; return (getObjectProperty(billingEntity, 'value'));}))).join(' OR '),')'].join(''));
  }
  ___arguments.context.pageData['strWhereClauseModifier'] = whereClauseModifier;
  console.log('strWhereClause Output');
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  console.log('Client Last Name');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName'));
  console.log('Last Name Output');
  console.log((await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4ff9ebf86b3a60f36dd749efbd8ec46', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44b62d41ca14d86eec4cbb56f37f4da2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/e4136efaaad65953e87a4243889408c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showMileages'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/b97f0c9eb5d23ee4d006eacfeae2571c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['resetBillingFilter'] = false;
  console.log('print in button click');
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));
  Object.assign(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ({ [`multiSelectLastName`]: '',[`dateOfBirth`]: '',[`clientLastName`]: '',[`startDate`]: '',[`endDate`]: '' }));
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\' '].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/c26917096589e0a14db3293321637ec1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showFilters'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/343f2cb520ed2518d80dd138bf6e7cd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showFilters')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['maxDate'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dataOfBirth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'dateOfBirth'))));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['clientLastName'] = (getObjectProperty(___arguments.context.pageData, 'clientLastName'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['adjudicationStatusOptionsFilter'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['reviewStatusOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = (getObjectProperty(___arguments.context.pageData, 'startDate'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = (getObjectProperty(___arguments.context.pageData, 'endDate'));
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', 'SoonerCare');

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/cdc24d17ae93332a77b903f552274347/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = null;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/46ce3f5d5e3b99aa135e87b85d13df39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('09acfa4cea2b703b9641ac79a72b2dee', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('6168ed5360bb182655333af9a587272a', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('d1ea2e346bd628b531a5b461669edc7f', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('28a4bef5fc489676119b8982815222e8', null);
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/c681a3c14dcb6416b42c3306d11a1018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/09acfa4cea2b703b9641ac79a72b2dee/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var billingEntityList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'billingEntitySelectOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/cd6ddbc9993163514f93f17e38e7e876/bundle.js', [], () => ({
  /* content */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirthReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirth'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/6168ed5360bb182655333af9a587272a/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/86169d7c1d8718541355ee42264ced8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await BackendlessUI.Functions.Custom['fn_5e3d747678a122a896439d3f05f6fb88']((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getAGGridAPI() })('6a6c294bc0c45e0e3c33bdef5d3a2178')), (String('Billing-export-') + String(new Date())))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/498d32ff46e565767f3840a29373bd73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var claimRecords, exportDataForTransportRecords, transportDataError, transportRecords, error, my_213ExportId, transactionUpdateExportedRecords, errorWhereClause, transactionErrorData, dataErrorFound, item, counter1, newEntry, loopClient, j, PayerName, payerItem, payerTable, existingClaimRecord, sampleClient, pageOffset, transportRecordCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function reviewTransportForError_updateClaim() {
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Exported]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function reviewTransportForError_addClaim() {
  if (!(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Insurance Policy #]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  } else if (getValueLength((getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'dateOfBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Date of Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'assignedSexAtBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Sex Assigned at Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client/Transport Destination address are both empty] ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'rel_TransportRequest.typeInsurance'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "typeInsurance" value is missing or incorrectly formatted for the "PayerName" value in 213 export]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  try {
    transportRecordCount = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))))));
    if (transportRecordCount > 100) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'More that 100 record in export',[`content`]: '213 Exports are temporarily limited to 100 records. Please update your search',[`submit`]: '' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
      return ;
    }
    pageOffset = Math.ceil(transportRecordCount / 100) * 100;
    transportRecords = [];
    while (!(pageOffset == 0)) {
      pageOffset = pageOffset - 100;
      addItemToList(transportRecords, (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100).setOffset(pageOffset))));
    }
    payerTable = (await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true)));
    console.log(payerTable);
    console.log('abc');
    transportRecords = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
    console.log('Lenght of transport record');
    console.log(transportRecords.length);
    my_213ExportId = ((new Date()).valueOf());
    console.log('Transport Records From Query');
    console.log(transportRecords);
    claimRecords = [];
    exportDataForTransportRecords = [];
    transportDataError = [];
    dataErrorFound = false;
    console.log(getObjectProperty((getObjectProperty((transportRecords[0]), 'rel_TransportRequest')), 'rel_Client.objectId'));
    sampleClient = transportRecords[0];
    for (var j_index in transportRecords) {
      j = transportRecords[j_index];
      loopClient = (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'rel_Client'));
      if (((claimRecords.map(item => item['clientObjectId'])).includes((getObjectProperty(loopClient, 'objectId')))) == true) {
        for (var existingClaimRecord_index in claimRecords) {
          existingClaimRecord = claimRecords[existingClaimRecord_index];
          if ((getObjectProperty(existingClaimRecord, 'clientObjectId')) == (getObjectProperty(loopClient, 'objectId'))) {
            await reviewTransportForError_updateClaim();
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceFromDatetime')) > (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceFrom_2`]: (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')) || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')),[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceToDatetime')) < (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceTo_2`]: (getObjectProperty(existingClaimRecord, 'Units_2')) > 0 || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : (getObjectProperty(existingClaimRecord, 'ServiceTo_2')),[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            Object.assign(existingClaimRecord, ({ [`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : (getObjectProperty(existingClaimRecord, 'ProcCode_2')),[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1||||' : '||||',[`Charge_1`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_1')))) + 160)).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_2')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) : (getObjectProperty(existingClaimRecord, 'Charge_2')),[`Units_1`]: (getObjectProperty(existingClaimRecord, 'Units_1')) + 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (getObjectProperty(existingClaimRecord, 'Units_2')) + (Number((getObjectProperty(j, 'distanceBillable')))) : (getObjectProperty(existingClaimRecord, 'Units_2')),[`TotalCharges`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'TotalCharges')))) + (Number((getObjectProperty(j, 'chargesTotal')))))).toFixed(2)),[`submissionCodes`]: ((getObjectProperty(existingClaimRecord, 'submissionCodes')).concat((getObjectProperty(j, 'transportCode_copy')))) }));
            addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: (getObjectProperty(existingClaimRecord, 'ClaimRef')),[`typeAdjudicationStatus`]: 'Exported' }));
            console.log('Claim edited');
            console.log(existingClaimRecord);
          }
        }
      } else {
        console.log('Info of new client');
        console.log([[(getObjectProperty(loopClient, 'nameLast')),', ',(getObjectProperty(loopClient, 'nameFirst'))].join(''),[(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),'DateTime',(getObjectProperty(j, 'datetimeScheduledStart'))].join(''));
        if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
          Object.assign(loopClient, ({ [`address`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.address')),[`city`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.city')),[`stateCode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.stateCode')),[`zipcode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.zipcode')) }));
        }
        PayerName = null;
        for (var payerItem_index in payerTable) {
          payerItem = payerTable[payerItem_index];
          if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(payerItem, 'typeInsurance'))) {
            PayerName = (getObjectProperty(payerItem, 'payerName'));
          } else {
          }
        }
        await reviewTransportForError_addClaim();
        newEntry = ({ [`SbrID`]: !(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) ? (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) : (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')).trim(),[`PatName`]: [(getObjectProperty(loopClient, 'nameLast')).trim(),', ',(getObjectProperty(loopClient, 'nameFirst')).trim()].join(''),[`PatBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate()),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear())].join(''),[`PatMale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'X' : null,[`PatFemale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Female' ? 'X' : null,[`Pipes1_1`]: '',[`SbrName`]: [(getObjectProperty(loopClient, 'nameLast')).trim(),', ',(getObjectProperty(loopClient, 'nameFirst')).trim()].join(''),[`PatientAddr`]: (getObjectProperty(loopClient, 'address')),[`PatientCity`]: (getObjectProperty(loopClient, 'city')),[`PatState`]: (getObjectProperty(loopClient, 'stateCode')),[`PatZip`]: (getObjectProperty(loopClient, 'zipcode')),[`PatRelSelf`]: '|X|||',[`SbrAddr`]: (getObjectProperty(loopClient, 'address')),[`SbrCity`]: (getObjectProperty(loopClient, 'city')),[`SbrState`]: (getObjectProperty(loopClient, 'stateCode')),[`SbrZip`]: (getObjectProperty(loopClient, 'zipcode')),[`Pipes2_24`]: '|||||||||||||||||||||||',[`SbrBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate()),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear())].join(''),[`SbrMale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'X' : null,[`SbrFemale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Female' ? 'X' : null,[`PatSignature`]: '||Signature on File|||||||||||||||',[`DiagCode1`]: 'Z1330',[`Pipes3_10`]: '|||||||||',[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceFrom_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : null,[`Pipes4_4`]: '|||',[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceTo_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : null,[`POS_1`]: '||||99|||||||||||',[`ProcCode_1`]: 'T2003',[`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : null,[`DiagPtrs_1`]: '||||||||||1',[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1||||' : '||||',[`Charge_1`]: (Number.parseFloat(160).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : null,[`Pipes5_4`]: '|||',[`Units_1`]: 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : null,[`BillTin`]: PayerName == 'Oklahoma Health Care Authority' ? '||||||||||||||||||||||||||||||||||||||||53AC||||||460868747||X' : '||||||||||||||||||||||||||||||||||||||||||||||460868747||X',[`ClaimRef`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`AcceptAssignmentYesNo`]: '||Y',[`TotalCharges`]: (Number.parseFloat((Number((getObjectProperty(j, 'chargesTotal'))))).toFixed(2)),[`BillNPI`]: '||Signature on file|||||||||||||||405-237-3043|OK Ride Care|2402 Westport Dr||Norman, OK 73069||||1699554634|',[`BillProvNum`]: '',[`PayerName`]: PayerName,[`Pipes6_4`]: '|||',[`submissionCodes`]: [(getObjectProperty(j, 'transportCode_copy'))],[`clientObjectId`]: (getObjectProperty(loopClient, 'objectId')),[`rel_Client`]: loopClient,[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) });
        addItemToList(claimRecords, newEntry);
        addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`typeAdjudicationStatus`]: 'Exported' }));
        console.log('New Client Added');
        console.log(newEntry);
        counter1 = (typeof counter1 == 'number' ? counter1 : 0) + 1;
        console.log(counter1);
      }
    }

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Creation of Claim Records]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
    return ;

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  console.log('Transport Records Filtered');
  console.log(claimRecords);
  console.log('Errors in the Transport Data?');
  console.log(dataErrorFound);
  console.log('Transport Database Errors?');
  console.log(transportDataError);
  errorWhereClause = ['&& objectId IN (',(await Promise.all(transportDataError.map(async item => {; return (['\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(', '),')'].join('');
  console.log('Errors Where Clause');
  console.log(errorWhereClause);
  console.log('Updated Transport Record');
  console.log(transportRecords);
  if (dataErrorFound == true) {
    try {
      transactionErrorData = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionErrorData;

        _uow.bulkUpsert('Transport', transportDataError);

      })();

      await transactionErrorData.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Data Review Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    } finally {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: String(transportDataError.length) + String(' Error(s) Were Found in Export Data'),[`content`]: 'The export was not able to complete due to errors. Export error flags have been added to these records in the billing table. Please review the "Billing Notes" field for each record to learn more information about the error.',[`submit`]: 'Review Errors' });
      ___arguments.context.pageData['strWhereClauseModifier'] = errorWhereClause;
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
      return ;

    }
  } else {
    console.log(exportDataForTransportRecords);
    try {
      transactionUpdateExportedRecords = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionUpdateExportedRecords;

        _uow.bulkDelete('Waystar2', 'objectId IS NOT NULL');
        _uow.bulkUpsert('Transport', exportDataForTransportRecords);
        _uow.bulkCreate('Waystar2', claimRecords);

      })();

      await transactionUpdateExportedRecords.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      ___arguments.context.pageData['fileName'] = (['/export/test-export/','Billing_213_Export_',my_213ExportId,'.csv'].join(''));
      ___arguments.context.pageData['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(___arguments.context.pageData, 'fileName')),'tableName': 'Waystar2','csvOptions': ({ [`header`]: false,[`delimiter`]: '|',[`columns`]: (await (async function() {
      	let jsonList = ["SbrID",
      	"PatName",
      	"PatBirthdate",
      	"PatMale",
      	"PatFemale",
      	"Pipes1_1",
      	"SbrName",
      	"PatientAddr",
      	"PatientCity",
      	"PatState",
      	"PatZip",
      	"PatRelSelf",
      	"SbrAddr",
      	"SbrCity",
      	"SbrState",
      	"SbrZip",
      	"Pipes2_24",
      	"SbrBirthdate",
      	"SbrMale",
      	"SbrFemale",
      	"PatSignature",
      	"DiagCode1",
      	"Pipes3_10",
      	"ServiceFrom_1",
      	"ServiceFrom_2",
      	"Pipes4_4",
      	"ServiceTo_1",
      	"ServiceTo_2",
      	"POS_1",
      	"ProcCode_1",
      	"ProcCode_2",
      	"DiagPtrs_1",
      	"DiagPtrs_2",
      	"Charge_1",
      	"Charge_2",
      	"Pipes5_4",
      	"Units_1",
      	"Units_2",
      	"BillTin",
      	"ClaimRef",
      	"AcceptAssignmentYesNo",
      	"TotalCharge",
      	"BillNPI",
      	"BillProvNum",
      	"PayerName",
      	"Pipes6_4"
      	]

      	// Return the array
      	return jsonList;
      })()),[`quoted_string`]: false,[`quoted_empty`]: false,[`quoted`]: false,[`quote`]: '' }) }));
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.pageData, 'csvExportPath'))), true, undefined);

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Export Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    } finally {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: ['Successfully Exported ',claimRecords.length,' Claim Record(s)! (213 Format)'].join(''),[`content`]: 'Your Waystar - 213 format export was successful!',[`submit`]: '' });

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/522dc7060cd65724883e5a986e3d1739/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/d1ea2e346bd628b531a5b461669edc7f/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'reviewOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/241bc1fe06a400c1ed56139f3961072a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var editedObjects, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval'));
    editedObjects = (await Backendless.Data.of('Transport').bulkUpdate( (['billingExportBatchId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval')),'\''].join('')), ({ [`billingExportBatchId`]: '',[`billing213ClaimId`]: '',[`typeAdjudicationStatus`]: null }) ));
    console.log(editedObjects);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';

  } finally {
    if (editedObjects > 0) {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Was Successful';
    } else {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';
    }

  }
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['batchIdForRemoval'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/da5b585829cd86722fc8bc4eae6c6b0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'batchRemovalText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/8736a3c1ee57347115f5b27f038f5677/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/76c262ad8625102e90a91d165d869a88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/28a4bef5fc489676119b8982815222e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportStatusOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-retired-2-14-2025/components/b5014ea78681a9e8de0b416863ff9896/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var typeInsurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'typeInsuranceSelectOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/6a6c294bc0c45e0e3c33bdef5d3a2178/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    var waitMilliseconds;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'));
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  ___arguments.context.pageData['relations'] = 'datetimeScheduledStart';
  waitMilliseconds = 0;
  while (!((getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')) != null && (getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
    waitMilliseconds = (typeof waitMilliseconds == 'number' ? waitMilliseconds : 0) + 100;
    console.log(waitMilliseconds);
  }
  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relations: "rel_TransportRequest.rel_Client",
	  //properties: ["typeStatus"]//

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // This was broken into two different colDef's because
  // we couldn't hide typeAdjudicationStatus based on page
  // data while maintaining separate column settings.
  if ((getObjectProperty(___arguments.context.pageData, 'resetBillingFilter')) == true) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	    {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProvider",
    	        "headerName": "Insurance Co.",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },   
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },  
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },   
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	   {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	     /* {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "valueFormatterParams": {
    	         "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	         },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },*/
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	         
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProvider",
    	        "headerName": "Insurance Co.",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesFlat",
    	        "headerName": "Flat Rate Charge",
    	        "headerTooltip": "Total flat rate charge.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	         "filterParams": {
    	             "defaultOption": "equals",
    	             "defaultFilter": "--",
    	           },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },        
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },   
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },  
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },      
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['initialRecordItem'], 'notesBilling')) != (getObjectProperty(___arguments['changedRecordItem'], 'notesBilling'))) {
    console.log('Change in notesBilling found during On Before Update Event');
    ___arguments['changedRecordItem']['hasNewBillingNote'] = true;
  }

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', false);
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'billingData','tableOptions': ({ [`where`]: '',[`sortBy`]: 'datetimeScheduledStart asc',[`relationsDepth`]: 2 }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Submission Code', 'Transport Date', 'Status', 'Client Name', 'Client DoB', 'SoonerCare ID', 'Medicare ID', 'Start to Dropoff Distance', 'Start to End of Day Distance', 'Total Transport Distance'] }) }));
  console.log(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'));
  console.log(Backendless.appPath);
  await (async function(url) {
  	window.open(url, "_blank");
  })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'))));

  },
  /* handler:onSubmit */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showFilters'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var billingEntityList, millisecondsPerDay;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['reviewOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];
  ___arguments.context.pageData['reviewOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare (XIX)', 'Medicaid (MCO)', 'Private Insurance', 'Department of Mental Health (DMH)', 'Medicare', 'Other'];
  ___arguments.context.pageData['earliestUnbilledRecord'] = ((await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause('typeAdjudicationStatus IS NULL && datetimeScheduledStart >=  \'1719810000000\'').setSortBy('datetimeScheduledStart asc').setPageSize(1)))[0]);
  console.log('earliestUnbilledRecord:');
  console.log(getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord'));
  ___arguments.context.pageData['dateEarliestUnbilledRecord'] = (getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord.datetimeScheduledStart'));
  ___arguments.context.pageData['startDate'] = (getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  console.log('dateEarliestUnbilledRecord');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  millisecondsPerDay = 86400000;
  ___arguments.context.pageData['queryEndDate'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord')), 'datetimeScheduledStart')) + 2 * millisecondsPerDay);
  console.log('queryEndDate:');
  console.log(getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['endDate'] = (getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['strWhereClauseBase'] = (String('datetimeScheduledStart >= \'1719810000000\' ') + String(' && rel_TransportRequest.rel_Client.nameFirst NOT LIKE \'%test%\''));
  ___arguments.context.pageData['showFilters'] = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))) {
    console.log('NO data from pervious page found');
    ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\'','',''].join(''));
    ___arguments.context.pageData['resetBillingFilter'] = false;
  }
  ___arguments.context.pageData['adjudicationStatusOptions'] = [null, 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid'];
  ___arguments.context.pageData['adjudicationStatusOptionsFilter'] = ['--', 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Exported'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Ride Care', 'Client', 'Facility'];
  console.log('Date of Birth Page Data');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['dateOfBirth'] = (getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ___arguments.context.pageData['billingEntityList'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: (getObjectProperty(billingEntityList, 'requesterEntityName')),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/44b62d41ca14d86eec4cbb56f37f4da2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['csvInProcess'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', true);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['fileName'] = (['/export/billing-data/',(new Date()),'.csv'].join(''));
  try {
    console.log((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'fileName')),'tableName': 'Transport','tableOptions': ({ [`where`]: String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')),[`properties`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimId', 'depositId', 'accountNumber', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'rel_TransportRequest.rel_Client.nameFull', 'rel_TransportRequest.rel_Client.datestringDateOfBirth', 'rel_TransportRequest.rel_Client.soonerCareId', 'rel_TransportRequest.rel_Client.medicareId', 'rel_TransportRequest.destinationLocationName', 'rel_TransportRequest.destinationAddress', 'rel_TransportRequest.pickupLocationName', 'rel_TransportRequest.pickupAddress', 'rel_TransportRequest.rel_Client.isFedRecognizedTribal', 'rel_TransportRequest.rel_Client.tribeAffiliations', 'rel_TransportRequest.rel_Client.tribeMemberZipcode'],[`sortBy`]: ['datestringScheduledStart asc'],[`relations`]: 'rel_TransportRequest.rel_Client',[`relationsDepth`]: undefined,[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'nameFull', 'datestringDateOfBirth', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimID', 'depositID', 'accountNumber', 'soonerCareId', 'medicareId', 'isFedRecognizedTribal', 'tribeAffiliations', 'tribeMemberZipcode', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'pickupLocationName', 'pickupAddress', 'destinationLocationName', 'destinationAddress'] }) })));
    await new Promise(r => setTimeout(r, 1000 || 0));
    console.log(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'csvExportPath'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  } catch (error) {
    (function (message) { alert(message) })((['We were unable to export the CSV due to error:','\n\n',error].join('')));
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/39e365d67c5a48e46c04bb4ee34e25e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'7\', \'DAY\')';
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/54fa8aace31ff4cfba1fc772bacc00e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'1\', \'MONTH\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/6e2a4327a30943ef134a4b5e1efd7b86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is 7/1/24
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart > \'',((new Date(1719817200000)).toISOString()),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/08084838717a0617b0cd23d541e42bdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, whereClauseModifier, billingEntity, millisecoundsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = (new Date((new Date())).getFullYear());
  if ((new Date((new Date())).getMonth() + 1) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth'))) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')) - 1);
  }
  console.log('Year');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year'));
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';
  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecoundsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getMinutes()) * 60000;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.submissionCode LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& billingExportBatchId LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')),'%\' '].join(''));
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != null && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.insurancePolicyNumber ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'policyNumberStatus')),' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\'',' && datetimeScheduledStart <= DATEADD (\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\', \'1\', \'MONTH\')'].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')),' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(item => item['value'])))) == '["--"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& typeAdjudicationStatus IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(async item => {; return (['typeAdjudicationStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')).map(async item => {; return (['typeReviewStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(async item => {; return (['rel_TransportRequest.rel_Client.typeInsurance LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')).map(async billingEntity => {; return (getObjectProperty(billingEntity, 'value'));}))).join(' OR '),')'].join(''));
  }
  ___arguments.context.pageData['strWhereClauseModifier'] = whereClauseModifier;
  console.log('strWhereClause Output');
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  console.log('Client Last Name');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName'));
  console.log('Last Name Output');
  console.log((await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4ff9ebf86b3a60f36dd749efbd8ec46', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44b62d41ca14d86eec4cbb56f37f4da2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/e4136efaaad65953e87a4243889408c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showMileages'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/b97f0c9eb5d23ee4d006eacfeae2571c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['resetBillingFilter'] = false;
  console.log('print in button click');
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));
  Object.assign(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ({ [`multiSelectLastName`]: '',[`dateOfBirth`]: '',[`clientLastName`]: '',[`startDate`]: '',[`endDate`]: '' }));
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\' '].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/c26917096589e0a14db3293321637ec1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showFilters'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/343f2cb520ed2518d80dd138bf6e7cd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showFilters')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['maxDate'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dataOfBirth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'dateOfBirth'))));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['clientLastName'] = (getObjectProperty(___arguments.context.pageData, 'clientLastName'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['adjudicationStatusOptionsFilter'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['reviewStatusOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = (getObjectProperty(___arguments.context.pageData, 'startDate'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = (getObjectProperty(___arguments.context.pageData, 'endDate'));
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', 'SoonerCare');

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/cdc24d17ae93332a77b903f552274347/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = null;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/46ce3f5d5e3b99aa135e87b85d13df39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('09acfa4cea2b703b9641ac79a72b2dee', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('6168ed5360bb182655333af9a587272a', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('d1ea2e346bd628b531a5b461669edc7f', null);
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/c681a3c14dcb6416b42c3306d11a1018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/09acfa4cea2b703b9641ac79a72b2dee/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var billingEntityList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: ['billingEntityName LIKE \'%',(getObjectProperty(billingEntityList, 'requesterEntityName')),'%\''].join(''),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/cd6ddbc9993163514f93f17e38e7e876/bundle.js', [], () => ({
  /* content */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirthReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirth'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/6168ed5360bb182655333af9a587272a/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/86169d7c1d8718541355ee42264ced8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await BackendlessUI.Functions.Custom['fn_5e3d747678a122a896439d3f05f6fb88']((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getAGGridAPI() })('6a6c294bc0c45e0e3c33bdef5d3a2178')), (String('Billing-export-') + String(new Date())))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/498d32ff46e565767f3840a29373bd73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var my_213ExportId, my_837data, claimRecords, counter1, dataErrorFound, error, errorWhereClause, existingClaimRecord, exportDataForTransportRecords, fileName, item, j, loopClient, newEntry, payerId, payerName, payerTable, sampleClient, transactionErrorData, transactionUpdateExportedRecords, transportDataError, transportRecords;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function reviewTransportForError_updateClaim() {
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Exported]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function reviewTransportForError_addClaim() {
  if (!(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Insurance Policy #]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  } else if (getValueLength((getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'dateOfBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Date of Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'assignedSexAtBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Sex Assigned at Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client/Transport Destination address are both empty] ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!payerName) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "typeInsurance" value is missing or incorrectly formatted for the "PayerName" value in 213 export]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (getValueLength((getObjectProperty(loopClient, 'insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'interchangeControlNumber'))) != 9 || (await (async function(str) {
  	for (char of str) {
  	  if (isNaN(char)) {
  	    return true
  	  }
  	}
  	return false
  })((getObjectProperty(___arguments.context.pageData, 'interchangeControlNumber'))))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Interchange Control Number needs to be a string consisting of exactly 9 numbers]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'acknowledgementRequested')) != '0' && (getObjectProperty(___arguments.context.pageData, 'acknowledgementRequested')) != '1') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: acknowledgementRequested needs to be set to the string "0" or "1" ]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'usageIndicator')) != 'T' && (getObjectProperty(___arguments.context.pageData, 'usageIndicator')) != 'P') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: usageIndicatorneeds to be set to the string "T" or "P" ]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'groupControlNumber'))) < 1 || getValueLength((getObjectProperty(___arguments.context.pageData, 'groupControlNumber'))) > 9 || (await (async function(str) {
  	for (char of str) {
  	  if (isNaN(char)) {
  	    return true
  	  }
  	}
  	return false
  })((getObjectProperty(___arguments.context.pageData, 'groupControlNumber'))))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: groupControlNumber needs to be a string of numbers with a length between 1 and 9]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'referenceID'))) > 50) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: referenceID exceeds 50 characters]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

/**
 * Describe this function...
 */
async function set837StaticDataInPageData() {
  ___arguments.context.pageData['interchangeControlNumber'] = '123456789';
  ___arguments.context.pageData['acknowledgementRequested'] = '1';
  ___arguments.context.pageData['usageIndicator'] = 'T';
  ___arguments.context.pageData['groupControlNumber'] = '12345';
  ___arguments.context.pageData['referenceID'] = 'ReferenceID';
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function setPayerName() {
  payerName = 'MissingName';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      payerName = (getObjectProperty(item, 'payerName'));
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function setPayerId() {
  payerId = 'MissingId';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      payerId = (getObjectProperty(item, 'payerId'));
    }


   return ;
  }));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  try {
    if ((await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))))) > 100) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'More that 100 record in export',[`content`]: '213 Exports are temporarily limited to 100 records. Please update your search',[`submit`]: '' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
      return ;
    }
    transportRecords = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
    payerTable = (await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100)));
    await set837StaticDataInPageData();
    console.log('Lenght of transport record');
    console.log(transportRecords.length);
    my_213ExportId = ((new Date()).valueOf());
    console.log('Transport Records From Query');
    console.log(transportRecords);
    claimRecords = [];
    exportDataForTransportRecords = [];
    transportDataError = [];
    dataErrorFound = false;
    console.log(getObjectProperty((getObjectProperty((transportRecords[0]), 'rel_TransportRequest')), 'rel_Client.objectId'));
    sampleClient = transportRecords[0];
    for (var j_index in transportRecords) {
      j = transportRecords[j_index];
      loopClient = (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'rel_Client'));
      if (((claimRecords.map(item => item['clientObjectId'])).includes((getObjectProperty(loopClient, 'objectId')))) == true) {
        for (var existingClaimRecord_index in claimRecords) {
          existingClaimRecord = claimRecords[existingClaimRecord_index];
          if ((getObjectProperty(existingClaimRecord, 'clientObjectId')) == (getObjectProperty(loopClient, 'objectId'))) {
            console.log('checkpoint a');
            await reviewTransportForError_updateClaim();
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceFromDatetime')) > (getObjectProperty(j, 'datetimeScheduledStart'))) {
              console.log('checkpoint b');
              Object.assign(existingClaimRecord, ({ [`ServiceFrom_2`]: (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')) || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')),[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            console.log('checkpoint c');
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceToDatetime')) < (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceTo_2`]: (getObjectProperty(existingClaimRecord, 'Units_2')) > 0 || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : (getObjectProperty(existingClaimRecord, 'ServiceTo_2')),[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            console.log('checkpoint d');
            Object.assign(existingClaimRecord, ({ [`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : (getObjectProperty(existingClaimRecord, 'ProcCode_2')),[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1' : '',[`Charge_1`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_1')))) + 160)).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_2')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) : (getObjectProperty(existingClaimRecord, 'Charge_2')),[`Units_1`]: (getObjectProperty(existingClaimRecord, 'Units_1')) + 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (getObjectProperty(existingClaimRecord, 'Units_2')) + (Number((getObjectProperty(j, 'distanceBillable')))) : (getObjectProperty(existingClaimRecord, 'Units_2')),[`TotalCharges`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'TotalCharges')))) + (Number((getObjectProperty(j, 'chargesTotal')))))).toFixed(2)),[`submissionCodes`]: ((getObjectProperty(existingClaimRecord, 'submissionCodes')).concat((getObjectProperty(j, 'transportCode_copy')))) }));
            console.log('checkpoint e');
            addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: (getObjectProperty(existingClaimRecord, 'ClaimRef')),[`typeAdjudicationStatus`]: 'Exported' }));
            console.log('Claim edited');
            console.log(existingClaimRecord);
          }
        }
      } else {
        console.log('checkpoint f');
        console.log('Info of new client');
        console.log([[(getObjectProperty(loopClient, 'nameLast')),', ',(getObjectProperty(loopClient, 'nameFirst'))].join(''),[(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),'DateTime',(getObjectProperty(j, 'datetimeScheduledStart'))].join(''));
        if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
          console.log('checkpoint g');
          Object.assign(loopClient, ({ [`address`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.address')),[`city`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.city')),[`stateCode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.stateCode')),[`zipcode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.zipcode')) }));
        }
        console.log(loopClient);
        payerName = 'MissingName';
        payerId = 'MissingID';
        await setPayerName();
        await setPayerId();
        await reviewTransportForError_addClaim();
        console.log(j);
        newEntry = ({ [`interchangeControlNumber`]: (getObjectProperty(___arguments.context.pageData, 'interchangeControlNumber')),[`acknowledgementRequested`]: (getObjectProperty(___arguments.context.pageData, 'acknowledgementRequested')),[`usageIndicator`]: (getObjectProperty(___arguments.context.pageData, 'usageIndicator')),[`groupControlNumber`]: (getObjectProperty(___arguments.context.pageData, 'groupControlNumber')),[`referenceIdentification`]: (getObjectProperty(___arguments.context.pageData, 'referenceID')),[`currentYear`]: (new Date(((new Date()).toLocaleString())).getFullYear()),[`currentMonth`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMonth() + 1))))),[`currentDay`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getDate()))))),[`currentHour`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getHours()))))),[`currentMinute`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMinutes()))))),[`clientAccountName`]: 'OK RIDE CARE',[`clientAccountID`]: 'DRC9521',[`receiverETINCode`]: 'H1270',[`payerID`]: payerId,[`patientAccountNumber`]: (getObjectProperty(j, 'transportCode_copy')),[`placeOfServiceCode`]: '99',[`facilityCodeQualifier`]: 'B',[`claimFrequencyCode`]: '1',[`providerSignatureIndicator`]: 'Y',[`medicareAssignmentCode`]: 'A',[`benefitsAssignmentCertificationIndicator`]: 'Y',[`releaseOfInformationCode`]: 'Y',[`facilityNPICode`]: '1234567893',[`sbrID`]: !(getObjectProperty(loopClient, 'insurancePolicyNumber')) ? (getObjectProperty(loopClient, 'insurancePolicyNumber')) : (getObjectProperty(loopClient, 'insurancePolicyNumber')).trim(),[`patFirstName`]: (getObjectProperty(loopClient, 'nameFirst')).trim(),[`patLastName`]: (getObjectProperty(loopClient, 'nameLast')).trim(),[`patBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate())))))].join(''),[`patAssignedSex`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'M' : 'F',[`patientAddr`]: (getObjectProperty(loopClient, 'address')),[`patientCity`]: (getObjectProperty(loopClient, 'city')),[`patState`]: (getObjectProperty(loopClient, 'stateCode')),[`patZip`]: (getObjectProperty(loopClient, 'zipcode')),[`patRelSelf`]: 'X',[`patSignature`]: 'Signature on File',[`diagCode1`]: 'Z1330',[`serviceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`serviceFrom_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : null,[`serviceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`serviceTo_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : null,[`procCode_1`]: 'T2003',[`procCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : null,[`diagPtrs_1`]: '1',[`diagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1' : '',[`charge_1`]: (Number.parseFloat(160).toFixed(2)),[`charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : null,[`units_1`]: 1,[`units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : null,[`billTin`]: '460868747',[`billZip`]: '730696336',[`claimRef`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`acceptAssignmentYesNo`]: 'Y',[`totalCharges`]: (Number.parseFloat((Number((getObjectProperty(j, 'chargesTotal'))))).toFixed(2)),[`billNPI`]: '1699554634',[`payerName`]: payerName,[`renProvSignature`]: 'SIGNATURE ON FILE',[`billPhone`]: '4052373043',[`billName`]: 'OK Ride Care',[`billAdd`]: '2404 Westport Dr',[`billCity`]: 'Norman',[`billState`]: 'OK' });
        await Backendless.Data.of('Claim').save( newEntry );
        addItemToList(claimRecords, newEntry);
        addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`typeAdjudicationStatus`]: 'Exported' }));
        console.log('New Client Added');
        console.log(newEntry);
        counter1 = (typeof counter1 == 'number' ? counter1 : 0) + 1;
        console.log(counter1);
      }
    }

  } catch (error) {
    console.log(error);
    console.log('entered block 1');
    ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
    return ;

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  console.log('Transport Records Filtered');
  if (claimRecords == null) {
    await new Promise(r => setTimeout(r, 1000 || 0));
    console.log('[ERROR] - Claim records null');
  } else {
    console.log('else branch');
    console.log(claimRecords);
    console.log((await Backendless.Request.post(`${Backendless.appPath}/services/createX12Transaction/create837FromClaimList`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(claimRecords))));
    my_837data = (await Backendless.Request.post(`${Backendless.appPath}/services/createX12Transaction/create837FromClaimList`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(claimRecords)));
    fileName = ['837-',(new Date()),'.CLP'].join('');
    console.log(fileName);
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Files.saveFile(encodePath('/export/edi-files'), fileName, my_837data, false)), true, undefined);
  }
  console.log(claimRecords);
  console.log('Errors in the Transport Data?');
  console.log(dataErrorFound);
  console.log('Transport Database Errors?');
  console.log(transportDataError);
  errorWhereClause = ['&& objectId IN (',(await Promise.all(transportDataError.map(async item => {; return (['\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(', '),')'].join('');
  console.log('Errors Where Clause');
  console.log(errorWhereClause);
  console.log('Updated Transport Record');
  console.log(transportRecords);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/522dc7060cd65724883e5a986e3d1739/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/c729372630936928e30c904f7191f95d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(160);
  console.log(Number((Number.parseFloat(160).toFixed(2))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/d1ea2e346bd628b531a5b461669edc7f/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'reviewOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/241bc1fe06a400c1ed56139f3961072a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var editedObjects, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval'));
    editedObjects = (await Backendless.Data.of('Transport').bulkUpdate( (['billingExportBatchId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval')),'\''].join('')), ({ [`billingExportBatchId`]: '',[`billing213ClaimId`]: '',[`typeAdjudicationStatus`]: null }) ));
    console.log(editedObjects);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';

  } finally {
    if (editedObjects > 0) {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Was Successful';
    } else {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';
    }

  }
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['batchIdForRemoval'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/da5b585829cd86722fc8bc4eae6c6b0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'batchRemovalText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/8736a3c1ee57347115f5b27f038f5677/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-11-25/components/76c262ad8625102e90a91d165d869a88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/6a6c294bc0c45e0e3c33bdef5d3a2178/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    var waitMilliseconds;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['relations'] = 'datetimeScheduledStart';
  waitMilliseconds = 0;
  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relations: ["rel_TransportRequest.rel_Client, ServiceLine[rel_Transport].Claim[rel_ServiceLine]"],
	  // properties: ["ServiceLine[rel_Transport].Claim[rel_ServiceLine].exportId as claimExportId"]

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // This was broken into two different colDef's because
  // we couldn't hide typeAdjudicationStatus based on page
  // data while maintaining separate column settings.
  if ((getObjectProperty(___arguments.context.pageData, 'resetBillingFilter')) == true) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  {
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	    {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },   
    	      {
    	        "field": "exportId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },   
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  {
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	   {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	     /* {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "valueFormatterParams": {
    	         "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	         },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },*/
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	         
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesFlat",
    	        "headerName": "Flat Rate Charge",
    	        "headerTooltip": "Total flat rate charge.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	         "filterParams": {
    	             "defaultOption": "equals",
    	             "defaultFilter": "--",
    	           },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "exportId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },        
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },  
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },      
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['initialRecordItem'], 'notesBilling')) != (getObjectProperty(___arguments['changedRecordItem'], 'notesBilling'))) {
    console.log('Change in notesBilling found during On Before Update Event');
    ___arguments['changedRecordItem']['hasNewBillingNote'] = true;
  }

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments['eventName'] == 'copy') {
    console.log('RECORD TO COPY -');
    console.log(___arguments['recordItem']);
    console.log('COPIED RECORD -');
    console.log((await Backendless.Data.of('CopyTransport').save((await (async function(record, transportObjectId) {
    	const copy = JSON.parse(JSON.stringify(record))

    	copy.transportObjectId = transportObjectId;

    	return copy
    })(___arguments['recordItem'], (getObjectProperty(___arguments['recordItem'], 'objectId')))), true)));
  }
  if (___arguments['eventName'] == 'restore') {
    data = (await Backendless.Data.of('CopyTransport').find(Backendless.DataQueryBuilder.create().setWhereClause((['transportObjectId = \'',(getObjectProperty(___arguments['recordItem'], 'objectId')),'\''].join(''))).setPageSize(10)));
    data = (await (async function(arg) {
    	return arg[0]
    })(data));
    console.log('COPIED RECORD FROM DB- ');
    console.log(data);
    console.log('INSERTING TRANSPORT RESULT - ');
    console.log((await Backendless.Data.of('Transport').save((await (async function(record, transportObjectId) {
    	const copy = JSON.parse(JSON.stringify(record))

    	delete copy.transportObjectId;
    	copy.objectId = transportObjectId;

    	return copy
    })(data, (getObjectProperty(___arguments['recordItem'], 'objectId')))), true)));
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
  }

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', false);
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'billingData','tableOptions': ({ [`where`]: '',[`sortBy`]: 'datetimeScheduledStart asc',[`relationsDepth`]: 2 }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Submission Code', 'Transport Date', 'Status', 'Client Name', 'Client DoB', 'SoonerCare ID', 'Medicare ID', 'Start to Dropoff Distance', 'Start to End of Day Distance', 'Total Transport Distance'] }) }));
  console.log(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'));
  console.log(Backendless.appPath);
  await (async function(url) {
  	window.open(url, "_blank");
  })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'))));

  },
  /* handler:onSubmit */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showFilters'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var billingEntityList, millisecondsPerDay;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['reviewOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];
  ___arguments.context.pageData['transportStatusOptionsFilter'] = [({ [`label`]: 'Completed',[`value`]: 'Completed' }), ({ [`label`]: 'Voided',[`value`]: 'Voided' }), ({ [`label`]: 'Canceled',[`value`]: 'Canceled' })];
  ___arguments.context.pageData['reviewOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare (XIX)', 'Medicaid (MCO)', 'Private Insurance', 'Department of Mental Health (DMH)', 'Medicare', 'Other'];
  ___arguments.context.pageData['earliestUnbilledRecord'] = ((await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause('typeAdjudicationStatus IS NULL && datetimeScheduledStart >=  \'1719810000000\'').setSortBy('datetimeScheduledStart asc').setPageSize(1)))[0]);
  console.log('earliestUnbilledRecord:');
  console.log(getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord'));
  ___arguments.context.pageData['dateEarliestUnbilledRecord'] = (getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord.datetimeScheduledStart'));
  ___arguments.context.pageData['startDate'] = (getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  console.log('dateEarliestUnbilledRecord');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  millisecondsPerDay = 86400000;
  ___arguments.context.pageData['queryEndDate'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord')), 'datetimeScheduledStart')) + 2 * millisecondsPerDay);
  console.log('queryEndDate:');
  console.log(getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['endDate'] = (getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['strWhereClauseBase'] = (['datetimeScheduledStart >= \'1719810000000\' ',' && rel_TransportRequest.rel_Client.nameFirst NOT LIKE \'%test%\'',' && typeStatus != \'Voided\''].join(''));
  ___arguments.context.pageData['showFilters'] = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))) {
    console.log('NO data from pervious page found');
    ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\'','',''].join(''));
    ___arguments.context.pageData['resetBillingFilter'] = false;
  }
  ___arguments.context.pageData['adjudicationStatusOptions'] = [null, 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid'];
  ___arguments.context.pageData['adjudicationStatusOptionsFilter'] = ['--', 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Exported'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Ride Care', 'Client', 'Facility'];
  console.log('Date of Birth Page Data');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['dateOfBirth'] = (getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ___arguments.context.pageData['billingEntityList'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: (getObjectProperty(billingEntityList, 'requesterEntityName')),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));
  ___arguments.context.pageData['typeInsuranceList'] = ((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true))).map(item => item['typeInsurance']));
  console.log('Type Insurance List');
  console.log(getObjectProperty(___arguments.context.pageData, 'typeInsuranceList'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/44b62d41ca14d86eec4cbb56f37f4da2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['csvInProcess'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', true);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['fileName'] = (['/export/billing-data/',(new Date()),'.csv'].join(''));
  try {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'fileName')),'tableName': 'Transport','tableOptions': ({ [`where`]: String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')),[`properties`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimId', 'depositId', 'accountNumber', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'rel_TransportRequest.rel_Client.nameFull', 'rel_TransportRequest.rel_Client.datestringDateOfBirth', 'rel_TransportRequest.rel_Client.soonerCareId', 'rel_TransportRequest.rel_Client.medicareId', 'rel_TransportRequest.destinationLocationName', 'rel_TransportRequest.destinationAddress', 'rel_TransportRequest.pickupLocationName', 'rel_TransportRequest.pickupAddress', 'rel_TransportRequest.rel_Client.isFedRecognizedTribal', 'rel_TransportRequest.rel_Client.tribeAffiliations', 'rel_TransportRequest.rel_Client.tribeMemberZipcode'],[`sortBy`]: ['datestringScheduledStart asc'],[`relations`]: 'rel_TransportRequest.rel_Client',[`relationsDepth`]: undefined,[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'nameFull', 'datestringDateOfBirth', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimID', 'depositID', 'accountNumber', 'soonerCareId', 'medicareId', 'isFedRecognizedTribal', 'tribeAffiliations', 'tribeMemberZipcode', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'pickupLocationName', 'pickupAddress', 'destinationLocationName', 'destinationAddress'] }) }));
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'csvExportPath'))), true, undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  } catch (error) {
    (function (message) { alert(message) })((['We were unable to export the CSV due to error:','\n\n',error].join('')));
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/39e365d67c5a48e46c04bb4ee34e25e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'7\', \'DAY\')';
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/54fa8aace31ff4cfba1fc772bacc00e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'1\', \'MONTH\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/6e2a4327a30943ef134a4b5e1efd7b86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is 7/1/24
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart > \'',((new Date(1719817200000)).toISOString()),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/08084838717a0617b0cd23d541e42bdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, whereClauseModifier, billingEntity, millisecoundsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = (new Date((new Date())).getFullYear());
  if ((new Date((new Date())).getMonth() + 1) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth'))) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')) - 1);
  }
  console.log('Year');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year'));
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';
  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecoundsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getMinutes()) * 60000;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.submissionCode LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& billingExportBatchId LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')),'%\' '].join(''));
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != null && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != '') {
    console.log('POLICY STATUS');
    console.log(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')));
    whereClauseModifier = String(whereClauseModifier) + String(String('&& rel_TransportRequest.insurancePolicyNumber ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'policyNumberStatus')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\'',' && datetimeScheduledStart <= DATEADD (\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\', \'1\', \'MONTH\')'].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')),' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(item => item['value'])))) == '["--"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& typeAdjudicationStatus IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(async item => {; return (['typeAdjudicationStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')).map(async item => {; return (['typeReviewStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')).map(async item => {; return (['typeStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(item => item['value'])))) == '["Blank"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.typeInsurance IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(async item => {; return (['rel_TransportRequest.typeInsurance LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')).map(async billingEntity => {; return (getObjectProperty(billingEntity, 'value'));}))).join(' OR '),')'].join(''));
  }
  ___arguments.context.pageData['strWhereClauseModifier'] = whereClauseModifier;
  console.log('strWhereClause Output');
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  console.log('Client Last Name');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName'));
  console.log('Last Name Output');
  console.log((await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4ff9ebf86b3a60f36dd749efbd8ec46', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44b62d41ca14d86eec4cbb56f37f4da2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/e4136efaaad65953e87a4243889408c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showMileages'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/b97f0c9eb5d23ee4d006eacfeae2571c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['resetBillingFilter'] = false;
  console.log('print in button click');
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));
  Object.assign(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ({ [`multiSelectLastName`]: '',[`dateOfBirth`]: '',[`clientLastName`]: '',[`startDate`]: '',[`endDate`]: '' }));
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\' '].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/c26917096589e0a14db3293321637ec1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showFilters'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/343f2cb520ed2518d80dd138bf6e7cd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showFilters')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['maxDate'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dataOfBirth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'dateOfBirth'))));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['clientLastName'] = (getObjectProperty(___arguments.context.pageData, 'clientLastName'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['adjudicationStatusOptionsFilter'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['reviewStatusOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = (getObjectProperty(___arguments.context.pageData, 'startDate'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = (getObjectProperty(___arguments.context.pageData, 'endDate'));
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', 'SoonerCare');

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/cdc24d17ae93332a77b903f552274347/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/46ce3f5d5e3b99aa135e87b85d13df39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('09acfa4cea2b703b9641ac79a72b2dee', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('6168ed5360bb182655333af9a587272a', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('d1ea2e346bd628b531a5b461669edc7f', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('28a4bef5fc489676119b8982815222e8', null);
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/c681a3c14dcb6416b42c3306d11a1018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/09acfa4cea2b703b9641ac79a72b2dee/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var billingEntityList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: ['billingEntityName LIKE \'%',(getObjectProperty(billingEntityList, 'requesterEntityName')),'%\''].join(''),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/cd6ddbc9993163514f93f17e38e7e876/bundle.js', [], () => ({
  /* content */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirthReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirth'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/6168ed5360bb182655333af9a587272a/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/86169d7c1d8718541355ee42264ced8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await BackendlessUI.Functions.Custom['fn_5e3d747678a122a896439d3f05f6fb88']((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getAGGridAPI() })('6a6c294bc0c45e0e3c33bdef5d3a2178')), (String('Billing-export-') + String(new Date())))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/498d32ff46e565767f3840a29373bd73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var billingExportEntry, serviceLineList, exportDataForTransportRecords, transportDataError, claimRecords, transportRecords, error, my_837data, fileName, billingExportId, transactionUpdateExportedRecords, serviceLineObjectIds, claimObjectIds, transportObjectId, currServiceLineObject, transportMap, serviceLineCounterId, currClaimObject, claimIdToServiceLineIdList, objectId, tx, trimmedServiceLines, trimmedClaimRecords, errorWhereClause, transactionErrorData, dataErrorFound, item, counter1, newEntry, loopClient, j, serviceEntry, serviceLineMap, currentServiceLineId, claimCounterId, payerName, my_213ExportId, contractCode, payerId, existingClaimRecord, formattedDateTime, serviceItem, isSameDay, subItem, sampleClient, payerTable, pageOffset, transportRecordCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function export837() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  try {
    transportRecordCount = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))))));
    if (transportRecordCount > 100) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'More that 100 record in export',[`content`]: '213 Exports are temporarily limited to 100 records. Please update your search',[`submit`]: '' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
    ___arguments.context.pageData['modal'] = ({ [`title`]: String('Processing') + String(' Claim Record(s) (837 Format)'),[`content`]: 'Processing Claim Records - Please do not leave page - This could take a few minutes',[`submit`]: '' });
    pageOffset = Math.ceil(transportRecordCount / 100) * 100;
    transportRecords = [];
    while (!(pageOffset == 0)) {
      pageOffset = pageOffset - 100;
      addItemToList(transportRecords, (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100).setOffset(pageOffset))));
    }
    payerTable = (await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true)));
    console.log(payerTable);
    transportRecords = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
    await set837StaticDataInPageData();
    console.log('Lenght of transport record');
    console.log(transportRecords.length);
    my_213ExportId = ((new Date()).valueOf());
    console.log('Transport Records From Query');
    console.log(transportRecords);
    transportMap = ({  });
    serviceLineMap = ({  });
    claimIdToServiceLineIdList = ({  });
    await Backendless.Counters.addAndGet('serviceLineIds', 0);
    await Backendless.Counters.addAndGet('claimIds', 0);
    tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    billingExportEntry = (await Backendless.Data.of('BillingExport').save( ({ [`exportId`]: null }) ));
    await (async function(arg) {
    	console.info(arg);
    })(billingExportEntry);
    billingExportId = (getObjectProperty(billingExportEntry, 'exportId'));
    claimRecords = [];
    exportDataForTransportRecords = [];
    transportDataError = [];
    serviceLineList = [];
    dataErrorFound = false;
    sampleClient = transportRecords[0];
    for (var j_index in transportRecords) {
      j = transportRecords[j_index];
      formattedDateTime = [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
      	return str.padStart(2, '0');

      })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
      	return str.padStart(2, '0');

      })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('');
      loopClient = (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'rel_Client'));
      if ((claimRecords.map(item => item['clientId'])).includes((getObjectProperty(loopClient, 'objectId')))) {
        for (var serviceItem_index in serviceLineList) {
          serviceItem = serviceLineList[serviceItem_index];
          await (async function(arg) {
          	console.info(arg);
          })('Entered service item for loop with service item: ');
          await (async function(arg) {
          	console.info(arg);
          })(serviceItem);
          if ((getObjectProperty((serviceItem[0]), 'clientId')) == (getObjectProperty(loopClient, 'objectId'))) {
            isSameDay = false;
            for (var subItem_index in serviceItem) {
              subItem = serviceItem[subItem_index];
              if ((getObjectProperty(subItem, 'procCode')) == 'T2003' && (getObjectProperty(subItem, 'serviceFrom')) == formattedDateTime) {
                await (async function(arg) {
                	console.info(arg);
                })('Service Item case 1');
                isSameDay = true;
                Object.assign(subItem, ({ [`charge`]: (Number.parseFloat(((Number((getObjectProperty(subItem, 'charge')))) + 160)).toFixed(2)),[`units`]: (Number((getObjectProperty(subItem, 'units')))) + 1 }));
                Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + 160)).toFixed(2)) }));
                addItemToList((getObjectProperty(transportMap, (getObjectProperty(subItem, 'serviceLineId')))), (getObjectProperty(j, 'objectId')));
              }
              if ((getObjectProperty(subItem, 'procCode')) == 'S0215' && (getObjectProperty(subItem, 'serviceFrom')) == formattedDateTime) {
                if ((getObjectProperty(j, 'distanceBillable')) > '0') {
                  await (async function(arg) {
                  	console.info(arg);
                  })('Service Item case 2');
                  isSameDay = true;
                  Object.assign(subItem, ({ [`charge`]: (Number.parseFloat(((Number((getObjectProperty(subItem, 'charge')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)),[`units`]: (Number((getObjectProperty(subItem, 'units')))) + (Number((getObjectProperty(j, 'distanceBillable')))) }));
                  Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) }));
                }
              }
            }
            if (isSameDay == false) {
              await (async function(arg) {
              	console.info(arg);
              })('Service Item Case 3');
              currentServiceLineId = (await Backendless.Counters.addAndGet('serviceLineIds', 1));
              addItemToList(serviceItem, ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'T2003',[`charge`]: (Number.parseFloat(160).toFixed(2)),[`units`]: 1,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }));
              addItemToList(serviceItem, ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'S0215',[`charge`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : 0,[`units`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : 0,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }));
              addItemToList((getObjectProperty(claimIdToServiceLineIdList, (getObjectProperty((serviceItem[0]), 'parentClaimCounterId')))), currentServiceLineId);
              Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + 160)).toFixed(2)) }));
              Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) }));
              transportMap[currentServiceLineId] = [];
              addItemToList((getObjectProperty(transportMap, currentServiceLineId)), (getObjectProperty(j, 'objectId')));
              await (async function(arg) {
              	console.info(arg);
              })('Service Item After Case 3');
              await (async function(arg) {
              	console.info(arg);
              })(serviceItem);
            }
          }
        }
        for (var existingClaimRecord_index in claimRecords) {
          existingClaimRecord = claimRecords[existingClaimRecord_index];
          if ((getObjectProperty(existingClaimRecord, 'clientId')) == (getObjectProperty(loopClient, 'objectId'))) {
            await (async function(arg) {
            	console.info(arg);
            })('Entered claim record modifications');
            await reviewTransportForError_updateClaim();
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'serviceFromDatetime')) > (getObjectProperty(j, 'datetimeScheduledStart'))) {
              await (async function(arg) {
              	console.info(arg);
              })('entered service from block');
              Object.assign(existingClaimRecord, ({ [`serviceFrom_2`]: (getObjectProperty(existingClaimRecord, 'serviceFrom_2')) || (getObjectProperty(j, 'distanceBillable')) > 0 ? formattedDateTime : (getObjectProperty(existingClaimRecord, 'serviceFrom_2')),[`serviceFrom_1`]: formattedDateTime,[`serviceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'serviceToDatetime')) < (getObjectProperty(j, 'datetimeScheduledStart'))) {
              await (async function(arg) {
              	console.info(arg);
              })('entered service to block');
              Object.assign(existingClaimRecord, ({ [`serviceTo_2`]: (getObjectProperty(existingClaimRecord, 'units_2')) > 0 || (getObjectProperty(j, 'distanceBillable')) > 0 ? formattedDateTime : (getObjectProperty(existingClaimRecord, 'serviceTo_2')),[`serviceTo_1`]: formattedDateTime }));
            }
            await (async function(arg) {
            	console.info(arg);
            })('entrered cost mods');
            Object.assign(existingClaimRecord, ({ [`charge_1`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'charge_1')))) + 160)).toFixed(2)),[`charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'charge_2')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) : (getObjectProperty(existingClaimRecord, 'charge_2')),[`units_1`]: (getObjectProperty(existingClaimRecord, 'units_1')) + 1,[`units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (getObjectProperty(existingClaimRecord, 'units_2')) + (Number((getObjectProperty(j, 'distanceBillable')))) : (getObjectProperty(existingClaimRecord, 'units_2')),[`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesTotal')))))).toFixed(2)) }));
            addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: (getObjectProperty(existingClaimRecord, 'ClaimRef')),[`typeAdjudicationStatus`]: 'Exported' }));
            await (async function(arg) {
            	console.info(arg);
            })('Claim Edited');
            await (async function(arg) {
            	console.info(arg);
            })(existingClaimRecord);
          }
        }
      } else {
        console.log('Info of new client');
        console.log([[(getObjectProperty(loopClient, 'nameLast')),', ',(getObjectProperty(loopClient, 'nameFirst'))].join(''),[(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),'DateTime',(getObjectProperty(j, 'datetimeScheduledStart'))].join(''));
        if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
          Object.assign(loopClient, ({ [`address`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.address')),[`city`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.city')),[`stateCode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.stateCode')),[`zipcode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.zipcode')) }));
        }
        payerName = 'MissingName';
        payerId = 'MissingID';
        await setPayerName();
        await setPayerId();
        await setContractCode();
        await reviewTransportForError_addClaim();
        claimCounterId = (await Backendless.Counters.addAndGet('claimIds', 1));
        newEntry = ({ [`counterId`]: claimCounterId,[`claimId`]: [(getObjectProperty(loopClient, 'nameFirst')).trim().slice(0, 3),'.',(getObjectProperty(loopClient, 'nameLast')).trim().slice(0, 3),'.',billingExportId].join(''),[`claimStatus`]: 'Billed',[`clientId`]: (getObjectProperty(loopClient, 'objectId')),[`interchangeControlNumber`]: (getObjectProperty(___arguments.context.pageData, 'interchangeControlNumber')),[`acknowledgementRequested`]: (getObjectProperty(___arguments.context.pageData, 'acknowledgementRequested')),[`usageIndicator`]: (getObjectProperty(___arguments.context.pageData, 'usageIndicator')),[`groupControlNumber`]: (getObjectProperty(___arguments.context.pageData, 'groupControlNumber')),[`referenceIdentification`]: (getObjectProperty(___arguments.context.pageData, 'referenceID')),[`currentYear`]: (new Date(((new Date()).toLocaleString())).getFullYear()),[`currentMonth`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMonth() + 1))))),[`currentDay`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getDate()))))),[`currentHour`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getHours()))))),[`currentMinute`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMinutes()))))),[`clientAccountName`]: 'OK RIDE CARE',[`clientAccountID`]: 'DRC9521',[`receiverETINCode`]: 'H1270',[`payerID`]: payerId,[`contractCode`]: contractCode,[`patientAccountNumber`]: (getObjectProperty(j, 'transportCode_copy')),[`placeOfServiceCode`]: '99',[`facilityCodeQualifier`]: 'B',[`claimFrequencyCode`]: '1',[`providerSignatureIndicator`]: 'Y',[`medicareAssignmentCode`]: 'A',[`benefitsAssignmentCertificationIndicator`]: 'Y',[`releaseOfInformationCode`]: 'Y',[`facilityNPICode`]: '1234567893',[`sbrID`]: !(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) ? (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) : (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')).trim(),[`patFirstName`]: (getObjectProperty(loopClient, 'nameFirst')).trim(),[`patLastName`]: (getObjectProperty(loopClient, 'nameLast')).trim(),[`patBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate())))))].join(''),[`patAssignedSex`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'M' : 'F',[`patientAddr`]: (getObjectProperty(loopClient, 'address')),[`patientCity`]: (getObjectProperty(loopClient, 'city')),[`patState`]: (getObjectProperty(loopClient, 'stateCode')),[`patZip`]: (getObjectProperty(loopClient, 'zipcode')),[`patRelSelf`]: 'X',[`patSignature`]: 'Signature on File',[`diagCode1`]: 'Z1330',[`serviceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`serviceFrom_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : null,[`serviceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`serviceTo_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : null,[`serviceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`serviceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`procCode_1`]: 'T2003',[`procCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : null,[`diagPtrs_1`]: '1',[`diagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1' : '',[`charge_1`]: (Number.parseFloat(160).toFixed(2)),[`charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : null,[`units_1`]: 1,[`units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : null,[`billTin`]: '460868747',[`billZip`]: '730696336',[`claimRef`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`acceptAssignmentYesNo`]: 'Y',[`totalReceived`]: '0',[`totalCharges`]: (Number.parseFloat((Number((getObjectProperty(j, 'chargesTotal'))))).toFixed(2)),[`billNPI`]: '1699554634',[`payerName`]: payerName,[`renProvSignature`]: 'SIGNATURE ON FILE',[`billPhone`]: '4052373043',[`billName`]: 'OK Ride Care',[`billAdd`]: '2404 Westport Dr',[`billCity`]: 'Norman',[`billState`]: 'OK' });
        currentServiceLineId = (await Backendless.Counters.addAndGet('serviceLineIds', 1));
        serviceEntry = [({ [`clientId`]: (getObjectProperty(loopClient, 'objectId')),[`totalCharges`]: (Number.parseFloat((160 + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)),[`parentClaimCounterId`]: claimCounterId }), ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'T2003',[`charge`]: (Number.parseFloat(160).toFixed(2)),[`units`]: 1,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }), ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'S0215',[`charge`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : 0,[`units`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : 0,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') })];
        await (async function(parentList, childList) {
        	parentList.push(childList)
        })(serviceLineList, serviceEntry);
        transportMap[currentServiceLineId] = [];
        claimIdToServiceLineIdList[claimCounterId] = [];
        addItemToList((getObjectProperty(claimIdToServiceLineIdList, claimCounterId)), currentServiceLineId);
        addItemToList((getObjectProperty(transportMap, currentServiceLineId)), (getObjectProperty(j, 'objectId')));
        serviceLineMap[(getObjectProperty(loopClient, 'objectId'))] = serviceEntry;
        addItemToList(claimRecords, newEntry);
        addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: billingExportId,[`billing213ClaimId`]: [(getObjectProperty(loopClient, 'nameFirst')).trim().slice(0, 3),'.',(getObjectProperty(loopClient, 'nameLast')).trim().slice(0, 3),'.',billingExportId].join(''),[`typeAdjudicationStatus`]: 'Exported',[`propName`]: billingExportId }));
        console.log('New Client Added');
        console.log(newEntry);
        counter1 = (typeof counter1 == 'number' ? counter1 : 0) + 1;
        console.log(counter1);
      }
    }
    trimmedClaimRecords = [];
    trimmedServiceLines = [];
    await (async function(arg) {
    	console.info(arg);
    })(serviceLineList);
    for (var item_index in claimRecords) {
      item = claimRecords[item_index];
      addItemToList(trimmedClaimRecords, (await (async function(claim) {
      	const copy = JSON.parse(JSON.stringify(claim));

      	delete copy.serviceFromDatetime;
      	delete copy.serviceToDatetime;
      	delete copy.clientId;

      	return copy;
      })(item)));
    }
    for (var item_index2 in serviceLineList) {
      item = serviceLineList[item_index2];
      addItemToList(trimmedServiceLines, (await (async function(lineList) {
      	const copy = JSON.parse(JSON.stringify(lineList));

      	let result = [];

      	for (let i = 1; i < copy.length; i += 2) {
      	  let curr = {
      	    counterId : copy[i].serviceLineId,
      	    totalCharges : copy[0].totalCharges,
      	    charge_1 : copy[i].charge,
      	    charge_2 : copy[i + 1].charge,
      	    units_1 : copy[i].units,
      	    units_2 : copy[i + 1].units,
      	    serviceFrom : copy[i].serviceFrom,
      	    paidStatus : "Billed"
      	  };
      	  result.push(curr)
      	}

      	return result;
      })(item)));
    }
    await (async function(arg) {
    	console.info(arg);
    })('trimmed service lines:');
    await (async function(arg) {
    	console.info(arg);
    })(trimmedServiceLines);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Creation of Claim Records and Service Lines]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
    ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
    await Backendless.Data.of('BillingExport').remove( billingExportEntry );
    return ;

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  console.log('Transport Records Filtered');
  console.log(claimRecords);
  console.log('Errors in the Transport Data?');
  console.log(dataErrorFound);
  console.log('Transport Database Errors?');
  console.log(transportDataError);
  errorWhereClause = ['&& objectId IN (',(await Promise.all(transportDataError.map(async item => {; return (['\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(', '),')'].join('');
  console.log('Errors Where Clause');
  console.log(errorWhereClause);
  console.log('Updated Transport Record');
  console.log(transportRecords);
  if (dataErrorFound == true) {
    try {
      transactionErrorData = (new Backendless.UnitOfWork('REPEATABLE_READ'));

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Data Review Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      return ;

    } finally {
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: String(transportDataError.length) + String(' Error(s) Were Found in Export Data'),[`content`]: 'The export was not able to complete due to errors. Export error flags have been added to these records in the billing table. Please review the "Billing Notes" field for each record to learn more information about the error.',[`submit`]: 'Review Errors' });
      ___arguments.context.pageData['strWhereClauseModifier'] = errorWhereClause;
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
      return ;

    }
  } else {
    try {
      await ( async () => {
        const _uow = tx;

        claimObjectIds = (_uow.bulkCreate('Claim', trimmedClaimRecords));
        serviceLineObjectIds = (_uow.bulkCreate('ServiceLine', trimmedServiceLines));
        _uow.setRelation('BillingExport', (getObjectProperty(billingExportEntry, 'objectId')), 'rel_Claim', claimObjectIds);

      })();

      await tx.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      await (async function(arg) {
      	console.info(arg);
      })('pre set');
      await (async function(arg) {
      	console.info(arg);
      })(claimObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })(serviceLineObjectIds);
      claimObjectIds = (claimObjectIds.getResult());
      serviceLineObjectIds = (serviceLineObjectIds.getResult());
      ___arguments.context.pageData['serviceLineObjectIdList'] = serviceLineObjectIds;
      ___arguments.context.pageData['claimObjectIdList'] = claimObjectIds;
      await (async function(arg) {
      	console.info(arg);
      })('post set');
      await (async function(arg) {
      	console.info(arg);
      })(claimObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })(serviceLineObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })('done');
      for (var objectId_index in claimObjectIds) {
        objectId = claimObjectIds[objectId_index];
        currClaimObject = (await Backendless.Data.of('Claim').findById(objectId, ));
        var serviceLineCounterId_list = (getObjectProperty(claimIdToServiceLineIdList, (getObjectProperty(currClaimObject, 'counterId'))));
        for (var serviceLineCounterId_index in serviceLineCounterId_list) {
          serviceLineCounterId = serviceLineCounterId_list[serviceLineCounterId_index];
          currServiceLineObject = (await Backendless.Data.of('ServiceLine').find(Backendless.DataQueryBuilder.create().setWhereClause((String('counterId = ') + String(serviceLineCounterId))).setPageSize(1)));
          await Backendless.Data.of('Claim').addRelation(currClaimObject, 'rel_ServiceLine', currServiceLineObject);
          var transportObjectId_list = (getObjectProperty(transportMap, serviceLineCounterId));
          for (var transportObjectId_index in transportObjectId_list) {
            transportObjectId = transportObjectId_list[transportObjectId_index];
            transportObjectId = (await (async function(arg) {
            	if (Array.isArray(arg) && arg.length > 0) {
            	  return arg[0]
            	}
            	return arg
            })(transportObjectId));
            currServiceLineObject = (await (async function(arg) {
            	if (Array.isArray(arg) && arg.length > 0) {
            	  return arg[0]
            	}
            	return arg
            })(currServiceLineObject));
            await Backendless.Data.of('ServiceLine').addRelation(currServiceLineObject, 'rel_Transport', [transportObjectId]);
          }
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

    } catch (error) {
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( claimObjectIds )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( serviceLineObjectIds )));
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Database Interactions - Committing to Database and Setting Relations]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    }
    console.log(exportDataForTransportRecords);
    try {
      transactionUpdateExportedRecords = (new Backendless.UnitOfWork('REPEATABLE_READ'));

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Updating Transaction Data]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'claimObjectIdList')) )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'serviceLineObjectIdList')) )));
      return ;

    }
    try {
      if (claimRecords == null) {
        throw (new Error('[ERROR] - Claim records null'))
      } else {
        console.log(claimRecords);
        my_837data = (await Backendless.Request.post(`${Backendless.appPath}/services/createX12Transaction/create837FromClaimList`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'claims': claimRecords,'claimInformationList': serviceLineList }));
        fileName = ['837-',billingExportId,'.CLP'].join('');
        await Backendless.Request.post(`${Backendless.appPath}/services/sftpUtils/sendFileOverSFTP`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'fileData': my_837data,'fileName': fileName });
        console.log(fileName);
        await Backendless.Files.saveFile(encodePath('/export/edi-files'), fileName, my_837data, false);
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
        ___arguments.context.pageData['modal'] = ({ [`title`]: ['Successfully Exported ',claimRecords.length,' Claim Record(s)! (837 Format)'].join(''),[`content`]: 'Your 837 File is successfully submitted to Waystar!',[`submit`]: '' });
      }

    } catch (error) {
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Upload to Waystar]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'claimObjectIdList')) )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'serviceLineObjectIdList')) )));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });

    }
  }
}

/**
 * Describe this function...
 */
async function reviewTransportForError_updateClaim() {
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Resubmitted') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Exported]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Suspended' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Denied') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Suspended / Denied]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'chargesTotal')) == null || (getObjectProperty(j, 'chargesTotal')) == 0) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "totalCharges" missing or formatted incorrectly ]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'typeReviewStatus')) || (getObjectProperty(j, 'typeReviewStatus')) != 'Processed') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Value for Review Status is Missing or not Processed]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function reviewTransportForError_addClaim() {
  if (!(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Insurance Policy #]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  } else if (getValueLength((getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'dateOfBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Date of Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'assignedSexAtBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Sex Assigned at Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client/Transport Destination address are both empty] ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'rel_TransportRequest.typeInsurance'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "typeInsurance" value is missing or incorrectly formatted for the "PayerName" value in 837 export]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Suspended' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Denied') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Suspended / Denied]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'chargesTotal')) == null || (getObjectProperty(j, 'chargesTotal')) == 0) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "totalCharges" missing or formatted incorrectly ]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'typeReviewStatus')) || (getObjectProperty(j, 'typeReviewStatus')) != 'Processed') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Value for Review Status is Missing or not Processed]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

/**
 * Describe this function...
 */
async function set837StaticDataInPageData() {
  ___arguments.context.pageData['interchangeControlNumber'] = '123456789';
  ___arguments.context.pageData['acknowledgementRequested'] = '1';
  ___arguments.context.pageData['usageIndicator'] = 'T';
  ___arguments.context.pageData['groupControlNumber'] = '12345';
  ___arguments.context.pageData['referenceID'] = 'ReferenceID';
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function setPayerName() {
  payerName = 'MissingName';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      payerName = (getObjectProperty(item, 'payerName'));
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function setPayerId() {
  payerId = 'MissingId';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      payerId = (getObjectProperty(item, 'payerId'));
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function setContractCode() {
  contractCode = 'MissingCode';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      if ((getObjectProperty(item, 'contractCode')) != null && (getObjectProperty(item, 'contractCode')) != '') {
        contractCode = (getObjectProperty(item, 'contractCode'));
      }
    }


   return ;
  }));
}

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/522dc7060cd65724883e5a986e3d1739/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/d1ea2e346bd628b531a5b461669edc7f/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'reviewOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/241bc1fe06a400c1ed56139f3961072a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var editedObjects, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval'));
    editedObjects = (await Backendless.Data.of('Transport').bulkUpdate( (['billingExportBatchId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval')),'\''].join('')), ({ [`billingExportBatchId`]: '',[`billing213ClaimId`]: '',[`typeAdjudicationStatus`]: null }) ));
    console.log(editedObjects);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';

  } finally {
    if (editedObjects > 0) {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Was Successful';
    } else {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';
    }

  }
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['batchIdForRemoval'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/da5b585829cd86722fc8bc4eae6c6b0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'batchRemovalText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/8736a3c1ee57347115f5b27f038f5677/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/76c262ad8625102e90a91d165d869a88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/28a4bef5fc489676119b8982815222e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportStatusOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton2/components/b5014ea78681a9e8de0b416863ff9896/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var typeInsurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setPageSize(10).setDistinct(true))).map(async typeInsurance => {; return ({ [`value`]: (getObjectProperty(typeInsurance, 'typeInsurance')),[`label`]: (getObjectProperty(typeInsurance, 'typeInsurance')) });}))).concat(({ [`value`]: 'Blank',[`label`]: '[Blank]' })))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/6a6c294bc0c45e0e3c33bdef5d3a2178/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    var waitMilliseconds;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'));
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  ___arguments.context.pageData['relations'] = 'datetimeScheduledStart';
  waitMilliseconds = 0;
  while (!((getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')) != null && (getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
    waitMilliseconds = (typeof waitMilliseconds == 'number' ? waitMilliseconds : 0) + 100;
    console.log(waitMilliseconds);
  }
  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relations: "rel_TransportRequest.rel_Client",
	  //properties: ["typeStatus"]//

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // This was broken into two different colDef's because
  // we couldn't hide typeAdjudicationStatus based on page
  // data while maintaining separate column settings.
  if ((getObjectProperty(___arguments.context.pageData, 'resetBillingFilter')) == true) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	    {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },   
    	      {
    	        "field": "exportId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	      /*
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },   
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	  /*{
    	     "type": "actions", 
    	     "headerName": "",
    	     "headerTooltip": "Actions",
    	     "field": "actions", 
    	     "width": 40, 
    	     "minWidth": 40, 
    	     "pinned": "left", 
    	     "meta": { "align": "center" }
    	   },*/   
    	   { 
    	     "field": "hasNewBillingNote",
    	     "headerName": "❗",
    	     "headerTooltip": "This record's Billing notes have been changed!  Please clear this flag after reviewing.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	   
    	   {
    	     "field": "hasBillingExportError",
    	     "headerName": "🔺", 
    	     "headerTooltip": "This record's has an export error, please review billing notes for more details.", 
    	     "minWidth": 40,
    	     "maxWidth": 40,
    	     "pinned": "left", 
    	     "meta": { "align": "center" },
    	     "filter": false,
    	     "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
    	                     meta: { align: "center" }, 
    	     "editable": true,
    	     "wrapHeaderText": true,
    	     "autoHeaderHeight": true
    	   },
    	  
    	  {
    	    headerName: "Transport Record",
    	    "openByDefault": true,
    	    children: [
    	     /* {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	        },
    	        "valueFormatterParams": {
    	         "dayjsFormat": "MM/DD/YYYY HH:mm", 
    	          "withSeconds": false
    	         },
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },*/
    	      {
    	        "field": "datetimeScheduledStart",
    	        "headerName": "Transport Date",
    	        "headerTooltip": "Date & Time the transport is scheduled to start.",
    	        "type": "datetimeColumn",
    	        
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "width": 120,
    	        "sortable": true,
    	        "editable": true,
    	        "sort": "asc",
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	         
    	      {
    	        "field": "rel_TransportRequest.rel_Client.nameFull",
    	        "headerName": "Client Name",
    	        "headerTooltip": "Name of client being transported.",
    	        "pinned": "left",
    	        "width": 115, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true      
    	      },    
    	      {
    	        "field": "rel_TransportRequest.rel_Client.dateOfBirth",
    	        "headerName": "Client DoB",
    	        "headerTooltip": "Client's Date of Birth.",
    	        "type": "dateColumn",
    	        "cellRendererParams": { 
    	          "dayjsFormat": "MM/DD/YYYY", 
    	          //"withSeconds": false
    	        },
    	        "valueFormatter": ns.dateTimeValueFormatter,
    	        "pinned": "left",
    	        "meta": { "align": "center" },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Insurance Type",
    	        "headerTooltip": "Client's primary insurance company.",
    	        "pinned": "left",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceList || []
    	        },
    	        "width": 90, 
    	        "minWidth": 90, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.insurancePolicyNumber",
    	        "headerName": "Policy #",
    	        "headerTooltip": "Policy Number for Client's primary insurance.",
    	        "pinned": "left",
    	        "width": 90, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesFlat",
    	        "headerName": "Flat Rate Charge",
    	        "headerTooltip": "Total flat rate charge.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceBillable",
    	        "headerName": "Billable Distance 'Over 30'",
    	        "headerTooltip": "This is the total distance for the transportthat is billable.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesOver30Mileage",
    	        "headerName": "Charges Over 30 Miles",
    	        "headerTooltip": "Charge for total distance beyond 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "chargesTotal",
    	        "headerName": "Total Charges",
    	        "headerTooltip": "Total charge includes the flat rate + charges over 30 miles.",
    	        "columnGroupShow" : "open",
    	        "pinned": "left", 
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },      
    	  // *************************************
    	  // *****  END LEFT PINNED COLUMNS  *****
    	  // *************************************
    	
    	  {
    	    headerName: "Billing Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "typeStatus",
    	        "headerName": "Transport Status",
    	        "headerTooltip": "Current status of the ride in Samsara.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.statusOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {
    	        "field": "typeReviewStatus",
    	        "headerName": "Review Status",
    	        "headerTooltip": "Current review status of transport record details.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.reviewOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      
    	      {        
    	        "field": "typeAdjudicationStatus",
    	        "headerName": "Billing Status",
    	        "headerTooltip": "Current status of billing adjudication.",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.adjudicationStatusOptions || []
    	        },
    	         "filterParams": {
    	             "defaultOption": "equals",
    	             "defaultFilter": "--",
    	           },
    	        "valueGetter": params => params.data?.typeAdjudicationStatus || '--',
    	        "width": 100 ,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta":  { "align": "center" }    
    	      },      
    	      {
    	        "field": "claimId",
    	        "headerName": "Claim ID",
    	        "headerTooltip": "Claim ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "exportId",
    	        "headerName": "Export ID",
    	        "headerTooltip": "Export ID for billing submission.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field": "paymentAmountReceived",
    	        "headerName": "Payment Amt Received",
    	        "headerTooltip": "Total payment amount that has been received.",
    	        "columnGroupShow" : "open",
    	        "valueFormatter": ns.currencyValueFormatter,
    	        "width": 80, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "isMultiStop",
    	        "headerName": "MultiStop?",
    	        "headerTooltip": "These are duplicated in an excel spreadsheet for July and likely August Sept.  Recommend not processing here.",
    	        "columnGroupShow" : "open",
    	        "type": "booleanColumn",
    	        "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	        "meta": { 
    	          "align": "center" 
    	        },
    	        "width": 60,
    	        "sortable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "editable": true
    	      },      
    	      {
    	        "field": "typeCancelationReason",
    	        "headerName": "Cancelation Reason",
    	        "headerTooltip": "Who is responsible for the cancelation?",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeCancelationReasonOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" }
    	      },
    	      {
    	        "field": "notesTransport",
    	        "headerName": "Transport Notes",
    	        "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400,
    	        "sortable": false,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "notesBilling",
    	        "headerName": "Billing Notes",
    	        "headerTooltip": "Use for any notes necessary during the billing process.",
    	        "columnGroupShow" : "open",
    	        "type": "largeTextColumn",
    	        "cellEditorParams": {
    	          "maxLength": 2000, 
    	          "rows": 5, 
    	          "cols": 30,
    	        },
    	        "width": 400, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "depositId",
    	        "headerName": "Deposit ID",
    	        "headerTooltip": "Client's Deposit ID.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "accountNumber",
    	        "headerName": "Account #",
    	        "headerTooltip": "Client's Account Number.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	      {
    	        "field": "billingEntityName",
    	        "headerName": "Billing Entity Name",
    	        "headerTooltip": "Billing Entity Name",
    	        "width": 100, 
    	        "minWidth": 80, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },
    	    ]
    	  },
    	
    	  {
    	    headerName: "Client Information",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.typeInsurance",
    	        "headerName": "Primary Insurance Type",
    	        "headerTooltip": "Type of primary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },        
    	      {
    	        "field": "rel_TransportRequest.rel_Client.soonerCareId",
    	        "headerName": "(OLD) SoonerCare ID",
    	        "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "paymentRecipient",
    	        "headerName": "(OLD) Payment Recipient",
    	        "headerTooltip": "Payment Recipient.  This is an older field and should not be used for new records.",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      }, 
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
    	        "headerName"        : "Tribal?",
    	        "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true,
    	        "meta"              : { "align": "center"},
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
    	        "headerName"        : "Tribe Member Zipcode",
    	        "headerTooltip"     : "Zipcode for the tribe member",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
    	        "headerName"        : "Tribes",
    	        "headerTooltip"     : "Which tribes are this Client affiliated with?",
    	        "width"             : 150, 
    	        "minWidth"          : 40, 
    	        "sortable"          : false,
    	        "editable"          : true, 
    	        "type"              : "selectColumn",
    	        "isMulti"           : true,
    	        "cellRendererParams": { "withChips": true },
    	        "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      /*
    	      {
    	        "field": "rel_TransportRequest.rel_Client.typeInsuranceSecondary",
    	        "headerName": "Secondary Insurance Type",
    	        "headerTooltip": "Type of secondary insurance of the client being transported.",
    	        "columnGroupShow" : "open",
    	        "cellEditor": "agSelectCellEditor",
    	        "cellEditorParams": {
    	          "values": pageData.typeInsuranceOptions || []
    	        },
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "meta": { "align": "center" },
    	      },
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insuranceProviderSecondary",
    	        "headerName": "Secondary Insurance Co.",
    	        "headerTooltip": "Client's secondary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "rel_TransportRequest.rel_Client.insurancePolicyNumberSecondary",
    	        "headerName": "Secondary Policy #",
    	        "headerTooltip": "Policy Number for Client's secondary insurance.",
    	        "columnGroupShow" : "open",
    	        "width": 100, 
    	        "minWidth": 40, 
    	        "sortable": true,
    	        "editable": true, 
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },  
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.typeInsuranceTertiary",
    	        "headerName"        : "Tertiary Insurance Type",
    	        "headerTooltip"     : "Type of tertiary insurance of the client being transported.",
    	        "columnGroupShow"   : "open",
    	        "cellEditor"        : "agSelectCellEditor",
    	        "cellEditorParams"  : {
    	                               "values": pageData.typeInsuranceOptions || []
    	                            },
    	        "width"             : 100,
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true,
    	        "meta"              : { "align": "center" },
    	      },    
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insuranceProviderTertiary",
    	        "headerName"        : "Tertiary Insurance",
    	        "headerTooltip"     : "Client's tertiary insurance company.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },      
    	      {
    	        "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumberTertiary",
    	        "headerName"        : "Tertiary Policy #",
    	        "headerTooltip"     : "Policy Number for Client's tertiary insurance.",
    	        "columnGroupShow" : "open",
    	        "width"             : 100, 
    	        "minWidth"          : 40, 
    	        "sortable"          : true,
    	        "editable"          : true, 
    	        "wrapHeaderText"    : true,
    	        "autoHeaderHeight"  : true
    	      },
    	      */
    	    ]
    	  },
    	  
    	  {
    	    headerName: "Transport Details",
    	    "openByDefault": true,
    	    children: [
    	      {
    	        "field": "rel_TransportRequest.destinationLocationName",
    	        "headerName": "Destination Location Name",
    	        "headerTooltip": "Destination Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.destinationAddress",
    	        "headerName": "Destination Address",
    	        "headerTooltip": "Destination Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupLocationName",
    	        "headerName": "Pickup Location Name",
    	        "headerTooltip": "Pickup Location Name",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },      
    	      {
    	        "field": "rel_TransportRequest.pickupAddress",
    	        "headerName": "Pickup Address",
    	        "headerTooltip": "Pickup Location Address",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "distanceTotalTransport",
    	        "headerName": "Total Transport Distance",
    	        "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "distancePickupToDropoff",
    	        "headerName": "Distance Facility to Facility",
    	        "headerTooltip": "This is the distance from the pickup location to the dropoff location.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToDropoff",
    	        "headerName": "Start to Dropoff Distance",
    	        "headerTooltip": "This is distance in miles from start to dropoff.",
    	        "columnGroupShow" : "open",
    	        "width": 80, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },      
    	      {
    	        "field": "distanceStartToEndOfDay",
    	        "headerName": "Start to End of Route Or Day Distance",
    	        "headerTooltip": "This is distance in miles from start to the end of the route or day.",
    	        "columnGroupShow" : "open",
    	        "width": 110, 
    	        "sortable": true,
    	        "editable": false,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true
    	      },    
    	      {
    	        "field": "mileageStart",
    	        "headerName": "Mileage at Start",
    	        "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileagePickup",
    	        "headerName": "Mileage at Pickup",
    	        "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageDropoff",
    	        "headerName": "Mileage at Dropoff",
    	        "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },
    	      {
    	        "field": "mileageEndOfDay",
    	        "headerName": "Mileage at End of Day",
    	        "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
    	        "columnGroupShow" : "open",
    	        "width": 100,
    	        "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
    	        "sortable": true,
    	        "editable": true,
    	        "wrapHeaderText": true,
    	        "autoHeaderHeight": true,
    	        // "editable": false,
    	        //"hide": !pageData.showMileages
    	      },      
    	    ]
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['initialRecordItem'], 'notesBilling')) != (getObjectProperty(___arguments['changedRecordItem'], 'notesBilling'))) {
    console.log('Change in notesBilling found during On Before Update Event');
    ___arguments['changedRecordItem']['hasNewBillingNote'] = true;
  }

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', false);
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate'))

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'billingData','tableOptions': ({ [`where`]: '',[`sortBy`]: 'datetimeScheduledStart asc',[`relationsDepth`]: 2 }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Submission Code', 'Transport Date', 'Status', 'Client Name', 'Client DoB', 'SoonerCare ID', 'Medicare ID', 'Start to Dropoff Distance', 'Start to End of Day Distance', 'Total Transport Distance'] }) }));
  console.log(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'));
  console.log(Backendless.appPath);
  await (async function(url) {
  	window.open(url, "_blank");
  })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'))));

  },
  /* handler:onSubmit */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showFilters'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var billingEntityList, millisecondsPerDay, typeInsurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['testingToggle'] = false;
  ___arguments.context.pageData['typeInsuranceSelectOptions'] = ((await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setPageSize(10).setDistinct(true))).map(async typeInsurance => {; return ({ [`value`]: (getObjectProperty(typeInsurance, 'typeInsurance')),[`label`]: (getObjectProperty(typeInsurance, 'typeInsurance')) });}))).concat(({ [`value`]: 'Blank',[`label`]: '[Blank]' })));
  ___arguments.context.pageData['billingEntitySelectOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: ['billingEntityName LIKE \'%',(getObjectProperty(billingEntityList, 'requesterEntityName')),'%\''].join(''),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));
  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['reviewOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];
  ___arguments.context.pageData['transportStatusOptionsFilter'] = [({ [`label`]: 'Completed',[`value`]: 'Completed' }), ({ [`label`]: 'Voided',[`value`]: 'Voided' }), ({ [`label`]: 'Canceled',[`value`]: 'Canceled' })];
  ___arguments.context.pageData['reviewOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare (XIX)', 'Medicaid (MCO)', 'Private Insurance', 'Department of Mental Health (DMH)', 'Medicare', 'Other'];
  ___arguments.context.pageData['earliestUnbilledRecord'] = ((await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause('typeAdjudicationStatus IS NULL && datetimeScheduledStart >=  \'1719810000000\'').setSortBy('datetimeScheduledStart asc').setPageSize(1)))[0]);
  console.log('earliestUnbilledRecord:');
  console.log(getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord'));
  ___arguments.context.pageData['dateEarliestUnbilledRecord'] = (getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord.datetimeScheduledStart'));
  console.log('dateEarliestUnbilledRecord');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord'));
  millisecondsPerDay = 86400000;
  ___arguments.context.pageData['queryEndDate'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'earliestUnbilledRecord')), 'datetimeScheduledStart')) + 2 * millisecondsPerDay);
  console.log('queryEndDate:');
  console.log(getObjectProperty(___arguments.context.pageData, 'queryEndDate'));
  ___arguments.context.pageData['strWhereClauseBase'] = (['rel_TransportRequest.rel_Client.nameFirst NOT LIKE \'%test%\'',' && typeStatus != \'Voided\'',''].join(''));
  ___arguments.context.pageData['showFilters'] = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))) {
    console.log('NO data from pervious page found');
    ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',((new Date((new Date()).getTime() - (604800 * 1000))).valueOf()),'','','\'','',''].join(''));
    ___arguments.context.pageData['resetBillingFilter'] = false;
  }
  ___arguments.context.pageData['adjudicationStatusOptions'] = [null, 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Hold', 'Non-Billable', 'Exported'];
  ___arguments.context.pageData['adjudicationStatusOptionsFilter'] = ['--', 'In Process', 'Suspended', 'Denied', 'Resubmitted', 'Paid', 'Exported', 'Hold', 'Non-Billable'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Ride Care', 'Client', 'Facility'];
  console.log('Date of Birth Page Data');
  console.log(getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['dateOfBirth'] = (getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  ___arguments.context.pageData['billingEntityList'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setPageSize(100).setDistinct(true))).map(async billingEntityList => {; return ({ [`value`]: (getObjectProperty(billingEntityList, 'requesterEntityName')),[`label`]: (getObjectProperty(billingEntityList, 'requesterEntityName')) });})));
  ___arguments.context.pageData['typeInsuranceList'] = ((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true))).map(item => item['typeInsurance']));
  console.log('Type Insurance List');
  console.log(getObjectProperty(___arguments.context.pageData, 'typeInsuranceList'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/44b62d41ca14d86eec4cbb56f37f4da2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['csvInProcess'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', true);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['fileName'] = (['/export/billing-data/',(new Date()),'.csv'].join(''));
  try {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6'))['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'fileName')),'tableName': 'Transport','tableOptions': ({ [`where`]: String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')),[`properties`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimId', 'depositId', 'accountNumber', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'rel_TransportRequest.rel_Client.nameFull', 'rel_TransportRequest.rel_Client.datestringDateOfBirth', 'rel_TransportRequest.rel_Client.soonerCareId', 'rel_TransportRequest.rel_Client.medicareId', 'rel_TransportRequest.destinationLocationName', 'rel_TransportRequest.destinationAddress', 'rel_TransportRequest.pickupLocationName', 'rel_TransportRequest.pickupAddress', 'rel_TransportRequest.rel_Client.isFedRecognizedTribal', 'rel_TransportRequest.rel_Client.tribeAffiliations', 'rel_TransportRequest.rel_Client.tribeMemberZipcode'],[`sortBy`]: ['datestringScheduledStart asc'],[`relations`]: 'rel_TransportRequest.rel_Client',[`relationsDepth`]: undefined,[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datestringScheduledStart', 'typeStatus', 'typeAdjudicationStatus', 'isMultiStop', 'nameFull', 'datestringDateOfBirth', 'hasInvoiceBeenSent', 'hasPaymentBeenReceived', 'claimID', 'depositID', 'accountNumber', 'soonerCareId', 'medicareId', 'isFedRecognizedTribal', 'tribeAffiliations', 'tribeMemberZipcode', 'distanceStartToDropoff', 'distanceStartToEndOfDay', 'distancePickupToDropoff', 'distanceTotalTransport', 'distanceBillable', 'chargesOver30Mileage', 'chargesFlat', 'chargesTotal', 'paymentAmountReceived', 'paymentRecipient', 'pickupLocationName', 'pickupAddress', 'destinationLocationName', 'destinationAddress'] }) }));
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fea7bd71964ac0c82cea059ece9506f6')), 'csvExportPath'))), true, undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  } catch (error) {
    (function (message) { alert(message) })((['We were unable to export the CSV due to error:','\n\n',error].join('')));
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/39e365d67c5a48e46c04bb4ee34e25e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'7\', \'DAY\')';
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/54fa8aace31ff4cfba1fc772bacc00e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseModifier'] = '&& datetimeScheduledStart > DATESUB(NOW(), \'1\', \'MONTH\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/6e2a4327a30943ef134a4b5e1efd7b86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is 7/1/24
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart > \'',((new Date(1719817200000)).toISOString()),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/08084838717a0617b0cd23d541e42bdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, whereClauseModifier, billingEntity, millisecoundsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = (new Date((new Date())).getFullYear());
  if ((new Date((new Date())).getMonth() + 1) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth'))) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['year'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')) - 1);
  }
  console.log('Year');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year'));
  ___arguments.context.pageData['resetBillingFilter'] = 'empty';
  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecoundsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth'))).getMinutes()) * 60000;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.submissionCode LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'submissionCode')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& exportId LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportBatchId')),'%\' '].join(''));
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != null && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('da86445205445b157ea2dc52947b4d26')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.insurancePolicyNumber ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'policyNumberStatus')),' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\'',' && datetimeScheduledStart <= DATEADD (\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'year')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'selectMonth')),'-1\', \'1\', \'MONTH\')'].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirth')) - millisecoundsSinceDayStartDOB) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'isFedRecognizedTribal')),' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(item => item['value'])))) == '["--"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& typeAdjudicationStatus IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('6168ed5360bb182655333af9a587272a')).map(async item => {; return (['typeAdjudicationStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('d1ea2e346bd628b531a5b461669edc7f')).map(async item => {; return (['typeReviewStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('28a4bef5fc489676119b8982815222e8')).map(async item => {; return (['typeStatus LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(item => item['value'])))) == '["Blank"]') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.typeInsurance IS NULL','',''].join(''));
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('b5014ea78681a9e8de0b416863ff9896')).map(async item => {; return (['rel_TransportRequest.typeInsurance LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('09acfa4cea2b703b9641ac79a72b2dee')).map(async billingEntity => {; return (getObjectProperty(billingEntity, 'value'));}))).join(' OR '),')'].join(''));
  }
  ___arguments.context.pageData['strWhereClauseModifier'] = whereClauseModifier;
  console.log('strWhereClause Output');
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  console.log('Client Last Name');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName'));
  console.log('Last Name Output');
  console.log((await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('4ed9d2bc853a1128bd76c1b4ec07c801')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(' OR '));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4ff9ebf86b3a60f36dd749efbd8ec46', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44b62d41ca14d86eec4cbb56f37f4da2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/e4136efaaad65953e87a4243889408c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showMileages'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/b97f0c9eb5d23ee4d006eacfeae2571c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['resetBillingFilter'] = false;
  console.log('print in button click');
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));
  Object.assign(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ({ [`multiSelectLastName`]: '',[`dateOfBirth`]: '',[`clientLastName`]: '',[`startDate`]: '',[`endDate`]: '' }));
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['strWhereClauseModifier'] = (['&& datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.pageData, 'dateEarliestUnbilledRecord')),'\' && datetimeScheduledStart <= \'',(getObjectProperty(___arguments.context.pageData, 'queryEndDate')),'\' '].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/c26917096589e0a14db3293321637ec1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showFilters'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['maxDate'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dataOfBirth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'dateOfBirth'))));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['clientLastName'] = (getObjectProperty(___arguments.context.pageData, 'clientLastName'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['adjudicationStatusOptionsFilter'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['reviewStatusOptionsFilter'] = [({ [`label`]: 'Pending',[`value`]: 'Pending' }), ({ [`label`]: 'Processed',[`value`]: 'Processed' }), ({ [`label`]: 'Needs Attention',[`value`]: 'Needs Attention' })];

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = (getObjectProperty(___arguments.context.pageData, 'startDate'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = (getObjectProperty(___arguments.context.pageData, 'endDate'));
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', 'SoonerCare');

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/cdc24d17ae93332a77b903f552274347/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = null;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/46ce3f5d5e3b99aa135e87b85d13df39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('4ed9d2bc853a1128bd76c1b4ec07c801', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('09acfa4cea2b703b9641ac79a72b2dee', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('6168ed5360bb182655333af9a587272a', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('b5014ea78681a9e8de0b416863ff9896', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('d1ea2e346bd628b531a5b461669edc7f', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('28a4bef5fc489676119b8982815222e8', null);
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/c681a3c14dcb6416b42c3306d11a1018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/09acfa4cea2b703b9641ac79a72b2dee/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var billingEntityList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'billingEntitySelectOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/cd6ddbc9993163514f93f17e38e7e876/bundle.js', [], () => ({
  /* content */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'dateOfBirthReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirthReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['dateOfBirth'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/6168ed5360bb182655333af9a587272a/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'adjudicationStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/86169d7c1d8718541355ee42264ced8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await BackendlessUI.Functions.Custom['fn_5e3d747678a122a896439d3f05f6fb88']((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getAGGridAPI() })('6a6c294bc0c45e0e3c33bdef5d3a2178')), (String('Billing-export-') + String(new Date())))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/498d32ff46e565767f3840a29373bd73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var claimRecords, exportDataForTransportRecords, transportDataError, transportRecords, error, my_213ExportId, transactionUpdateExportedRecords, errorWhereClause, transactionErrorData, dataErrorFound, item, counter1, newEntry, loopClient, j, PayerName, payerItem, payerTable, existingClaimRecord, sampleClient, pageOffset, transportRecordCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function reviewTransportForError_updateClaim() {
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Exported]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function reviewTransportForError_addClaim() {
  if (!(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Insurance Policy #]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  } else if (getValueLength((getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'dateOfBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Date of Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'assignedSexAtBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Sex Assigned at Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client/Transport Destination address are both empty] ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'rel_TransportRequest.typeInsurance'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "typeInsurance" value is missing or incorrectly formatted for the "PayerName" value in 213 export]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  try {
    transportRecordCount = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))))));
    if (transportRecordCount > 100) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'More that 100 record in export',[`content`]: '213 Exports are temporarily limited to 100 records. Please update your search',[`submit`]: '' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
      return ;
    }
    pageOffset = Math.ceil(transportRecordCount / 100) * 100;
    transportRecords = [];
    while (!(pageOffset == 0)) {
      pageOffset = pageOffset - 100;
      addItemToList(transportRecords, (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100).setOffset(pageOffset))));
    }
    payerTable = (await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true)));
    console.log(payerTable);
    console.log('abc');
    transportRecords = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
    console.log('Lenght of transport record');
    console.log(transportRecords.length);
    my_213ExportId = ((new Date()).valueOf());
    console.log('Transport Records From Query');
    console.log(transportRecords);
    claimRecords = [];
    exportDataForTransportRecords = [];
    transportDataError = [];
    dataErrorFound = false;
    console.log(getObjectProperty((getObjectProperty((transportRecords[0]), 'rel_TransportRequest')), 'rel_Client.objectId'));
    sampleClient = transportRecords[0];
    for (var j_index in transportRecords) {
      j = transportRecords[j_index];
      loopClient = (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'rel_Client'));
      if (((claimRecords.map(item => item['clientObjectId'])).includes((getObjectProperty(loopClient, 'objectId')))) == true) {
        for (var existingClaimRecord_index in claimRecords) {
          existingClaimRecord = claimRecords[existingClaimRecord_index];
          if ((getObjectProperty(existingClaimRecord, 'clientObjectId')) == (getObjectProperty(loopClient, 'objectId'))) {
            await reviewTransportForError_updateClaim();
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceFromDatetime')) > (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceFrom_2`]: (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')) || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : (getObjectProperty(existingClaimRecord, 'ServiceFrom_2')),[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'ServiceToDatetime')) < (getObjectProperty(j, 'datetimeScheduledStart'))) {
              Object.assign(existingClaimRecord, ({ [`ServiceTo_2`]: (getObjectProperty(existingClaimRecord, 'Units_2')) > 0 || (getObjectProperty(j, 'distanceBillable')) > 0 ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : (getObjectProperty(existingClaimRecord, 'ServiceTo_2')),[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            Object.assign(existingClaimRecord, ({ [`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : (getObjectProperty(existingClaimRecord, 'ProcCode_2')),[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1||||' : '||||',[`Charge_1`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_1')))) + 160)).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'Charge_2')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) : (getObjectProperty(existingClaimRecord, 'Charge_2')),[`Units_1`]: (getObjectProperty(existingClaimRecord, 'Units_1')) + 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (getObjectProperty(existingClaimRecord, 'Units_2')) + (Number((getObjectProperty(j, 'distanceBillable')))) : (getObjectProperty(existingClaimRecord, 'Units_2')),[`TotalCharges`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'TotalCharges')))) + (Number((getObjectProperty(j, 'chargesTotal')))))).toFixed(2)),[`submissionCodes`]: ((getObjectProperty(existingClaimRecord, 'submissionCodes')).concat((getObjectProperty(j, 'transportCode_copy')))) }));
            addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: (getObjectProperty(existingClaimRecord, 'ClaimRef')),[`typeAdjudicationStatus`]: 'Exported' }));
            console.log('Claim edited');
            console.log(existingClaimRecord);
          }
        }
      } else {
        console.log('Info of new client');
        console.log([[(getObjectProperty(loopClient, 'nameLast')),', ',(getObjectProperty(loopClient, 'nameFirst'))].join(''),[(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),'DateTime',(getObjectProperty(j, 'datetimeScheduledStart'))].join(''));
        if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
          Object.assign(loopClient, ({ [`address`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.address')),[`city`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.city')),[`stateCode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.stateCode')),[`zipcode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.zipcode')) }));
        }
        PayerName = null;
        for (var payerItem_index in payerTable) {
          payerItem = payerTable[payerItem_index];
          if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(payerItem, 'typeInsurance'))) {
            PayerName = (getObjectProperty(payerItem, 'payerName'));
          } else {
          }
        }
        await reviewTransportForError_addClaim();
        newEntry = ({ [`SbrID`]: !(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) ? (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) : (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')).trim(),[`PatName`]: [(getObjectProperty(loopClient, 'nameLast')).trim(),', ',(getObjectProperty(loopClient, 'nameFirst')).trim()].join(''),[`PatBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate()),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear())].join(''),[`PatMale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'X' : null,[`PatFemale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Female' ? 'X' : null,[`Pipes1_1`]: '',[`SbrName`]: [(getObjectProperty(loopClient, 'nameLast')).trim(),', ',(getObjectProperty(loopClient, 'nameFirst')).trim()].join(''),[`PatientAddr`]: (getObjectProperty(loopClient, 'address')),[`PatientCity`]: (getObjectProperty(loopClient, 'city')),[`PatState`]: (getObjectProperty(loopClient, 'stateCode')),[`PatZip`]: (getObjectProperty(loopClient, 'zipcode')),[`PatRelSelf`]: '|X|||',[`SbrAddr`]: (getObjectProperty(loopClient, 'address')),[`SbrCity`]: (getObjectProperty(loopClient, 'city')),[`SbrState`]: (getObjectProperty(loopClient, 'stateCode')),[`SbrZip`]: (getObjectProperty(loopClient, 'zipcode')),[`Pipes2_24`]: '|||||||||||||||||||||||',[`SbrBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate()),'/',(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear())].join(''),[`SbrMale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'X' : null,[`SbrFemale`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Female' ? 'X' : null,[`PatSignature`]: '||Signature on File|||||||||||||||',[`DiagCode1`]: 'Z1330',[`Pipes3_10`]: '|||||||||',[`ServiceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceFrom_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : null,[`Pipes4_4`]: '|||',[`ServiceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),[`ServiceTo_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join('') : null,[`POS_1`]: '||||99|||||||||||',[`ProcCode_1`]: 'T2003',[`ProcCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : null,[`DiagPtrs_1`]: '||||||||||1',[`DiagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1||||' : '||||',[`Charge_1`]: (Number.parseFloat(160).toFixed(2)),[`Charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : null,[`Pipes5_4`]: '|||',[`Units_1`]: 1,[`Units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : null,[`BillTin`]: PayerName == 'Oklahoma Health Care Authority' ? '||||||||||||||||||||||||||||||||||||||||53AC||||||460868747||X' : '||||||||||||||||||||||||||||||||||||||||||||||460868747||X',[`ClaimRef`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`AcceptAssignmentYesNo`]: '||Y',[`TotalCharges`]: (Number.parseFloat((Number((getObjectProperty(j, 'chargesTotal'))))).toFixed(2)),[`BillNPI`]: '||Signature on file|||||||||||||||405-237-3043|OK Ride Care|2402 Westport Dr||Norman, OK 73069||||1699554634|',[`BillProvNum`]: '',[`PayerName`]: PayerName,[`Pipes6_4`]: '|||',[`submissionCodes`]: [(getObjectProperty(j, 'transportCode_copy'))],[`clientObjectId`]: (getObjectProperty(loopClient, 'objectId')),[`rel_Client`]: loopClient,[`ServiceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`ServiceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) });
        addItemToList(claimRecords, newEntry);
        addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`typeAdjudicationStatus`]: 'Exported' }));
        console.log('New Client Added');
        console.log(newEntry);
        counter1 = (typeof counter1 == 'number' ? counter1 : 0) + 1;
        console.log(counter1);
      }
    }

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Creation of Claim Records]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
    return ;

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  console.log('Transport Records Filtered');
  console.log(claimRecords);
  console.log('Errors in the Transport Data?');
  console.log(dataErrorFound);
  console.log('Transport Database Errors?');
  console.log(transportDataError);
  errorWhereClause = ['&& objectId IN (',(await Promise.all(transportDataError.map(async item => {; return (['\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(', '),')'].join('');
  console.log('Errors Where Clause');
  console.log(errorWhereClause);
  console.log('Updated Transport Record');
  console.log(transportRecords);
  if (dataErrorFound == true) {
    try {
      transactionErrorData = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionErrorData;

        _uow.bulkUpsert('Transport', transportDataError);

      })();

      await transactionErrorData.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Data Review Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    } finally {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: String(transportDataError.length) + String(' Error(s) Were Found in Export Data'),[`content`]: 'The export was not able to complete due to errors. Export error flags have been added to these records in the billing table. Please review the "Billing Notes" field for each record to learn more information about the error.',[`submit`]: 'Review Errors' });
      ___arguments.context.pageData['strWhereClauseModifier'] = errorWhereClause;
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
      return ;

    }
  } else {
    console.log(exportDataForTransportRecords);
    try {
      transactionUpdateExportedRecords = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transactionUpdateExportedRecords;

        _uow.bulkDelete('Waystar2', 'objectId IS NOT NULL');
        _uow.bulkUpsert('Transport', exportDataForTransportRecords);
        _uow.bulkCreate('Waystar2', claimRecords);

      })();

      await transactionUpdateExportedRecords.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      ___arguments.context.pageData['fileName'] = (['/export/test-export/','Billing_213_Export_',my_213ExportId,'.csv'].join(''));
      ___arguments.context.pageData['csvExportPath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (getObjectProperty(___arguments.context.pageData, 'fileName')),'tableName': 'Waystar2','csvOptions': ({ [`header`]: false,[`delimiter`]: '|',[`columns`]: (await (async function() {
      	let jsonList = ["SbrID",
      	"PatName",
      	"PatBirthdate",
      	"PatMale",
      	"PatFemale",
      	"Pipes1_1",
      	"SbrName",
      	"PatientAddr",
      	"PatientCity",
      	"PatState",
      	"PatZip",
      	"PatRelSelf",
      	"SbrAddr",
      	"SbrCity",
      	"SbrState",
      	"SbrZip",
      	"Pipes2_24",
      	"SbrBirthdate",
      	"SbrMale",
      	"SbrFemale",
      	"PatSignature",
      	"DiagCode1",
      	"Pipes3_10",
      	"ServiceFrom_1",
      	"ServiceFrom_2",
      	"Pipes4_4",
      	"ServiceTo_1",
      	"ServiceTo_2",
      	"POS_1",
      	"ProcCode_1",
      	"ProcCode_2",
      	"DiagPtrs_1",
      	"DiagPtrs_2",
      	"Charge_1",
      	"Charge_2",
      	"Pipes5_4",
      	"Units_1",
      	"Units_2",
      	"BillTin",
      	"ClaimRef",
      	"AcceptAssignmentYesNo",
      	"TotalCharge",
      	"BillNPI",
      	"BillProvNum",
      	"PayerName",
      	"Pipes6_4"
      	]

      	// Return the array
      	return jsonList;
      })()),[`quoted_string`]: false,[`quoted_empty`]: false,[`quoted`]: false,[`quote`]: '' }) }));
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.pageData, 'csvExportPath'))), true, undefined);

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 213 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 213 Billing Export') + String('[Failed During Export Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    } finally {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: ['Successfully Exported ',claimRecords.length,' Claim Record(s)! (213 Format)'].join(''),[`content`]: 'Your Waystar - 213 format export was successful!',[`submit`]: '' });

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/522dc7060cd65724883e5a986e3d1739/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/d1ea2e346bd628b531a5b461669edc7f/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'reviewOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/241bc1fe06a400c1ed56139f3961072a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var editedObjects, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval'));
    editedObjects = (await Backendless.Data.of('Transport').bulkUpdate( (['billingExportBatchId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'batchIdForRemoval')),'\''].join('')), ({ [`billingExportBatchId`]: '',[`billing213ClaimId`]: '',[`typeAdjudicationStatus`]: null }) ));
    console.log(editedObjects);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';

  } finally {
    if (editedObjects > 0) {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Was Successful';
    } else {
      ___arguments.context.pageData['batchRemovalText'] = 'Batch ID Removal Failed!!!';
    }

  }
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['batchIdForRemoval'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/da5b585829cd86722fc8bc4eae6c6b0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'batchRemovalText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/8736a3c1ee57347115f5b27f038f5677/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/76c262ad8625102e90a91d165d869a88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b30a9bf92c774f99245a256bee0f6e69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/28a4bef5fc489676119b8982815222e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportStatusOptionsFilter'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/b5014ea78681a9e8de0b416863ff9896/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var typeInsurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'typeInsuranceSelectOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/315d486a12b83a58edd34668d80b8e58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var billingExportEntry, serviceLineList, exportDataForTransportRecords, transportDataError, claimRecords, transportRecords, error, my_837data, fileName, billingExportId, transactionUpdateExportedRecords, serviceLineObjectIds, claimObjectIds, transportObjectId, currServiceLineObject, transportMap, serviceLineCounterId, currClaimObject, claimIdToServiceLineIdList, objectId, tx, trimmedServiceLines, trimmedClaimRecords, errorWhereClause, transactionErrorData, dataErrorFound, item, counter1, newEntry, loopClient, j, serviceEntry, serviceLineMap, currentServiceLineId, claimCounterId, payerName, my_213ExportId, contractCode, payerId, existingClaimRecord, formattedDateTime, serviceItem, isSameDay, subItem, sampleClient, payerTable, pageOffset, transportRecordCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function export837() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  try {
    transportRecordCount = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'))))));
    if (transportRecordCount > 100) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'More that 100 record in export',[`content`]: '213 Exports are temporarily limited to 100 records. Please update your search',[`submit`]: '' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
    ___arguments.context.pageData['modal'] = ({ [`title`]: String('Processing') + String(' Claim Record(s) (837 Format)'),[`content`]: 'Processing Claim Records - Please do not leave page - This could take a few minutes',[`submit`]: '' });
    pageOffset = Math.ceil(transportRecordCount / 100) * 100;
    transportRecords = [];
    while (!(pageOffset == 0)) {
      pageOffset = pageOffset - 100;
      addItemToList(transportRecords, (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100).setOffset(pageOffset))));
    }
    payerTable = (await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true)));
    console.log(payerTable);
    transportRecords = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')))).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
    await set837StaticDataInPageData();
    console.log('Lenght of transport record');
    console.log(transportRecords.length);
    my_213ExportId = ((new Date()).valueOf());
    console.log('Transport Records From Query');
    console.log(transportRecords);
    transportMap = ({  });
    claimIdToServiceLineIdList = ({  });
    await Backendless.Counters.addAndGet('serviceLineIds', 0);
    await Backendless.Counters.addAndGet('claimIds', 0);
    tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    billingExportEntry = (await Backendless.Data.of('BillingExport').save( ({ [`exportId`]: null }) ));
    await (async function(arg) {
    	console.info(arg);
    })(billingExportEntry);
    billingExportId = (getObjectProperty(billingExportEntry, 'exportId'));
    claimRecords = [];
    exportDataForTransportRecords = [];
    transportDataError = [];
    serviceLineList = [];
    dataErrorFound = false;
    sampleClient = transportRecords[0];
    for (var j_index in transportRecords) {
      j = transportRecords[j_index];
      formattedDateTime = [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
      	return str.padStart(2, '0');

      })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
      	return str.padStart(2, '0');

      })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('');
      loopClient = (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'rel_Client'));
      if ((claimRecords.map(item => item['clientId'])).includes((getObjectProperty(loopClient, 'objectId')))) {
        for (var serviceItem_index in serviceLineList) {
          serviceItem = serviceLineList[serviceItem_index];
          await (async function(arg) {
          	console.info(arg);
          })('Entered service item for loop with service item: ');
          await (async function(arg) {
          	console.info(arg);
          })(serviceItem);
          if ((getObjectProperty((serviceItem[0]), 'clientId')) == (getObjectProperty(loopClient, 'objectId'))) {
            isSameDay = false;
            for (var subItem_index in serviceItem) {
              subItem = serviceItem[subItem_index];
              if ((getObjectProperty(subItem, 'procCode')) == 'T2003' && (getObjectProperty(subItem, 'serviceFrom')) == formattedDateTime) {
                await (async function(arg) {
                	console.info(arg);
                })('Service Item case 1');
                isSameDay = true;
                Object.assign(subItem, ({ [`charge`]: (Number.parseFloat(((Number((getObjectProperty(subItem, 'charge')))) + 160)).toFixed(2)),[`units`]: (Number((getObjectProperty(subItem, 'units')))) + 1 }));
                Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + 160)).toFixed(2)) }));
                addItemToList((getObjectProperty(transportMap, (getObjectProperty(subItem, 'serviceLineId')))), (getObjectProperty(j, 'objectId')));
              }
              if ((getObjectProperty(subItem, 'procCode')) == 'S0215' && (getObjectProperty(subItem, 'serviceFrom')) == formattedDateTime) {
                if ((getObjectProperty(j, 'distanceBillable')) > '0') {
                  await (async function(arg) {
                  	console.info(arg);
                  })('Service Item case 2');
                  isSameDay = true;
                  Object.assign(subItem, ({ [`charge`]: (Number.parseFloat(((Number((getObjectProperty(subItem, 'charge')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)),[`units`]: (Number((getObjectProperty(subItem, 'units')))) + (Number((getObjectProperty(j, 'distanceBillable')))) }));
                  Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) }));
                }
              }
            }
            if (isSameDay == false) {
              await (async function(arg) {
              	console.info(arg);
              })('Service Item Case 3');
              currentServiceLineId = (await Backendless.Counters.addAndGet('serviceLineIds', 1));
              addItemToList(serviceItem, ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'T2003',[`charge`]: (Number.parseFloat(160).toFixed(2)),[`units`]: 1,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }));
              addItemToList(serviceItem, ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'S0215',[`charge`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : 0,[`units`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : 0,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
              	return str.padStart(2, '0');

              })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }));
              addItemToList((getObjectProperty(claimIdToServiceLineIdList, (getObjectProperty((serviceItem[0]), 'parentClaimCounterId')))), currentServiceLineId);
              Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + 160)).toFixed(2)) }));
              Object.assign((serviceItem[0]), ({ [`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty((serviceItem[0]), 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) }));
              transportMap[currentServiceLineId] = [];
              addItemToList((getObjectProperty(transportMap, currentServiceLineId)), (getObjectProperty(j, 'objectId')));
              await (async function(arg) {
              	console.info(arg);
              })('Service Item After Case 3');
              await (async function(arg) {
              	console.info(arg);
              })(serviceItem);
            }
          }
        }
        for (var existingClaimRecord_index in claimRecords) {
          existingClaimRecord = claimRecords[existingClaimRecord_index];
          if ((getObjectProperty(existingClaimRecord, 'clientId')) == (getObjectProperty(loopClient, 'objectId'))) {
            await (async function(arg) {
            	console.info(arg);
            })('Entered claim record modifications');
            await reviewTransportForError_updateClaim();
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'serviceFromDatetime')) > (getObjectProperty(j, 'datetimeScheduledStart'))) {
              await (async function(arg) {
              	console.info(arg);
              })('entered service from block');
              Object.assign(existingClaimRecord, ({ [`serviceFrom_2`]: (getObjectProperty(existingClaimRecord, 'serviceFrom_2')) || (getObjectProperty(j, 'distanceBillable')) > 0 ? formattedDateTime : (getObjectProperty(existingClaimRecord, 'serviceFrom_2')),[`serviceFrom_1`]: formattedDateTime,[`serviceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')) }));
            }
            // Checks to see if new record "service from" date
            // was BEFORE current records "service from" date
            if ((getObjectProperty(existingClaimRecord, 'serviceToDatetime')) < (getObjectProperty(j, 'datetimeScheduledStart'))) {
              await (async function(arg) {
              	console.info(arg);
              })('entered service to block');
              Object.assign(existingClaimRecord, ({ [`serviceTo_2`]: (getObjectProperty(existingClaimRecord, 'units_2')) > 0 || (getObjectProperty(j, 'distanceBillable')) > 0 ? formattedDateTime : (getObjectProperty(existingClaimRecord, 'serviceTo_2')),[`serviceTo_1`]: formattedDateTime }));
            }
            await (async function(arg) {
            	console.info(arg);
            })('entrered cost mods');
            Object.assign(existingClaimRecord, ({ [`charge_1`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'charge_1')))) + 160)).toFixed(2)),[`charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'charge_2')))) + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)) : (getObjectProperty(existingClaimRecord, 'charge_2')),[`units_1`]: (getObjectProperty(existingClaimRecord, 'units_1')) + 1,[`units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (getObjectProperty(existingClaimRecord, 'units_2')) + (Number((getObjectProperty(j, 'distanceBillable')))) : (getObjectProperty(existingClaimRecord, 'units_2')),[`totalCharges`]: (Number.parseFloat(((Number((getObjectProperty(existingClaimRecord, 'totalCharges')))) + (Number((getObjectProperty(j, 'chargesTotal')))))).toFixed(2)) }));
            addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: my_213ExportId,[`billing213ClaimId`]: (getObjectProperty(existingClaimRecord, 'ClaimRef')),[`typeAdjudicationStatus`]: 'Exported' }));
            await (async function(arg) {
            	console.info(arg);
            })('Claim Edited');
            await (async function(arg) {
            	console.info(arg);
            })(existingClaimRecord);
          }
        }
      } else {
        console.log('Info of new client');
        console.log([[(getObjectProperty(loopClient, 'nameLast')),', ',(getObjectProperty(loopClient, 'nameFirst'))].join(''),[(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear())].join(''),'DateTime',(getObjectProperty(j, 'datetimeScheduledStart'))].join(''));
        if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
          Object.assign(loopClient, ({ [`address`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.address')),[`city`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.city')),[`stateCode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.stateCode')),[`zipcode`]: (getObjectProperty((getObjectProperty(j, 'rel_TransportRequest')), 'relDestination_Facility.zipcode')) }));
        }
        payerName = 'MissingName';
        payerId = 'MissingID';
        await setPayerName();
        await setPayerId();
        await setContractCode();
        await reviewTransportForError_addClaim();
        claimCounterId = (await Backendless.Counters.addAndGet('claimIds', 1));
        newEntry = ({ [`exportId`]: billingExportId,[`typeInsurance`]: (getObjectProperty(j, 'rel_TransportRequest.typeInsurance')),[`counterId`]: claimCounterId,[`claimId`]: [(getObjectProperty(loopClient, 'nameFirst')).trim().slice(0, 3),'.',(getObjectProperty(loopClient, 'nameLast')).trim().slice(0, 3),'.',billingExportId].join(''),[`claimStatus`]: 'Billed',[`clientId`]: (getObjectProperty(loopClient, 'objectId')),[`interchangeControlNumber`]: (getObjectProperty(___arguments.context.pageData, 'interchangeControlNumber')),[`acknowledgementRequested`]: (getObjectProperty(___arguments.context.pageData, 'acknowledgementRequested')),[`usageIndicator`]: (getObjectProperty(___arguments.context.pageData, 'usageIndicator')),[`groupControlNumber`]: (getObjectProperty(___arguments.context.pageData, 'groupControlNumber')),[`referenceIdentification`]: (getObjectProperty(___arguments.context.pageData, 'referenceID')),[`currentYear`]: (new Date(((new Date()).toLocaleString())).getFullYear()),[`currentMonth`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMonth() + 1))))),[`currentDay`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getDate()))))),[`currentHour`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getHours()))))),[`currentMinute`]: (await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMinutes()))))),[`clientAccountName`]: 'OK RIDE CARE',[`clientAccountID`]: 'DRC9521',[`receiverETINCode`]: 'H1270',[`payerID`]: payerId,[`contractCode`]: contractCode,[`patientAccountNumber`]: (getObjectProperty(j, 'transportCode_copy')),[`placeOfServiceCode`]: '99',[`facilityCodeQualifier`]: 'B',[`claimFrequencyCode`]: '1',[`providerSignatureIndicator`]: 'Y',[`medicareAssignmentCode`]: 'A',[`benefitsAssignmentCertificationIndicator`]: 'Y',[`releaseOfInformationCode`]: 'Y',[`facilityNPICode`]: '1234567893',[`sbrID`]: !(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) ? (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')) : (getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber')).trim(),[`patFirstName`]: (getObjectProperty(loopClient, 'nameFirst')).trim(),[`patLastName`]: (getObjectProperty(loopClient, 'nameLast')).trim(),[`patBirthdate`]: [(new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(loopClient, 'dateOfBirth'))))).getDate())))))].join(''),[`patAssignedSex`]: (getObjectProperty(loopClient, 'assignedSexAtBirth')) == 'Male' ? 'M' : 'F',[`patientAddr`]: (getObjectProperty(loopClient, 'address')),[`patientCity`]: (getObjectProperty(loopClient, 'city')),[`patState`]: (getObjectProperty(loopClient, 'stateCode')),[`patZip`]: (getObjectProperty(loopClient, 'zipcode')),[`patRelSelf`]: 'X',[`patSignature`]: 'Signature on File',[`diagCode1`]: 'Z1330',[`serviceFrom_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`serviceFrom_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : null,[`serviceTo_1`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join(''),[`serviceTo_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') : null,[`serviceFromDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`serviceToDatetime`]: (getObjectProperty(j, 'datetimeScheduledStart')),[`procCode_1`]: 'T2003',[`procCode_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? 'S0215' : null,[`diagPtrs_1`]: '1',[`diagPtrs_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? '1' : '',[`charge_1`]: (Number.parseFloat(160).toFixed(2)),[`charge_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : null,[`units_1`]: 1,[`units_2`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : null,[`billTin`]: '460868747',[`billZip`]: '730696336',[`claimRef`]: [(getObjectProperty(j, 'transportCode_copy')).slice(0, 8),(getObjectProperty(loopClient, 'rideCareId')),'.',my_213ExportId].join(''),[`acceptAssignmentYesNo`]: 'Y',[`totalReceived`]: '0',[`totalCharges`]: (Number.parseFloat((Number((getObjectProperty(j, 'chargesTotal'))))).toFixed(2)),[`billNPI`]: '1699554634',[`payerName`]: payerName,[`renProvSignature`]: 'SIGNATURE ON FILE',[`billPhone`]: '4052373043',[`billName`]: 'OK Ride Care',[`billAdd`]: '2404 Westport Dr',[`billCity`]: 'Norman',[`billState`]: 'OK' });
        currentServiceLineId = (await Backendless.Counters.addAndGet('serviceLineIds', 1));
        serviceEntry = [({ [`clientId`]: (getObjectProperty(loopClient, 'objectId')),[`totalCharges`]: (Number.parseFloat((160 + (Number((getObjectProperty(j, 'chargesOver30Mileage')))))).toFixed(2)),[`parentClaimCounterId`]: claimCounterId }), ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'T2003',[`charge`]: (Number.parseFloat(160).toFixed(2)),[`units`]: 1,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') }), ({ [`serviceLineId`]: currentServiceLineId,[`procCode`]: 'S0215',[`charge`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number.parseFloat((Number((getObjectProperty(j, 'chargesOver30Mileage'))))).toFixed(2)) : 0,[`units`]: (getObjectProperty(j, 'distanceBillable')) > '0' ? (Number((getObjectProperty(j, 'distanceBillable')))) : 0,[`diagPtr`]: '1',[`serviceFrom`]: [(new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getFullYear()),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getMonth() + 1))))),(await (async function(str) {
        	return str.padStart(2, '0');

        })((JSON.stringify((new Date((new Date((getObjectProperty(j, 'datetimeScheduledStart'))))).getDate())))))].join('') })];
        await (async function(parentList, childList) {
        	parentList.push(childList)
        })(serviceLineList, serviceEntry);
        transportMap[currentServiceLineId] = [];
        claimIdToServiceLineIdList[claimCounterId] = [];
        addItemToList((getObjectProperty(claimIdToServiceLineIdList, claimCounterId)), currentServiceLineId);
        addItemToList((getObjectProperty(transportMap, currentServiceLineId)), (getObjectProperty(j, 'objectId')));
        addItemToList(claimRecords, newEntry);
        addItemToList(exportDataForTransportRecords, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`billingExportBatchId`]: billingExportId,[`billing213ClaimId`]: [(getObjectProperty(loopClient, 'nameFirst')).trim().slice(0, 3),'.',(getObjectProperty(loopClient, 'nameLast')).trim().slice(0, 3),'.',billingExportId].join(''),[`typeAdjudicationStatus`]: 'Exported',[`exportId`]: billingExportId }));
        console.log('New Client Added');
        console.log(newEntry);
        counter1 = (typeof counter1 == 'number' ? counter1 : 0) + 1;
        console.log(counter1);
      }
    }
    trimmedClaimRecords = [];
    trimmedServiceLines = [];
    await (async function(arg) {
    	console.info(arg);
    })(serviceLineList);
    for (var item_index in claimRecords) {
      item = claimRecords[item_index];
      addItemToList(trimmedClaimRecords, (await (async function(claim) {
      	const copy = JSON.parse(JSON.stringify(claim));

      	delete copy.serviceFromDatetime;
      	delete copy.serviceToDatetime;
      	delete copy.clientId;

      	return copy;
      })(item)));
    }
    for (var item_index2 in serviceLineList) {
      item = serviceLineList[item_index2];
      addItemToList(trimmedServiceLines, (await (async function(lineList) {
      	const copy = JSON.parse(JSON.stringify(lineList));

      	let result = [];

      	for (let i = 1; i < copy.length; i += 2) {
      	  let curr = {
      	    counterId : copy[i].serviceLineId,
      	    totalCharges : copy[0].totalCharges,
      	    charge_1 : copy[i].charge,
      	    charge_2 : copy[i + 1].charge,
      	    units_1 : copy[i].units,
      	    units_2 : copy[i + 1].units,
      	    serviceFrom : copy[i].serviceFrom,
      	    paidStatus : "Billed"
      	  };
      	  result.push(curr)
      	}

      	return result;
      })(item)));
    }
    await (async function(arg) {
    	console.info(arg);
    })('trimmed service lines:');
    await (async function(arg) {
    	console.info(arg);
    })(trimmedServiceLines);

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Creation of Claim Records and Service Lines]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    try {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

    } catch (error) {

    }
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
    ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
    await Backendless.Data.of('BillingExport').remove( billingExportEntry );
    return ;

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6685699fdb8a6c371545b029b7271005', undefined);
  console.log('Transport Records Filtered');
  console.log(claimRecords);
  console.log('Errors in the Transport Data?');
  console.log(dataErrorFound);
  console.log('Transport Database Errors?');
  console.log(transportDataError);
  errorWhereClause = ['&& objectId IN (',(await Promise.all(transportDataError.map(async item => {; return (['\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(', '),')'].join('');
  console.log('Errors Where Clause');
  console.log(errorWhereClause);
  console.log('Updated Transport Record');
  console.log(transportRecords);
  if (dataErrorFound == true) {
    try {
      transactionErrorData = (new Backendless.UnitOfWork('REPEATABLE_READ'));

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Data Review Transaction]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      try {
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

      } catch (error) {

      }
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      return ;

    } finally {
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      try {
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

      } catch (error) {

      }
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: String(transportDataError.length) + String(' Error(s) Were Found in Export Data'),[`content`]: 'The export was not able to complete due to errors. Export error flags have been added to these records in the billing table. Please review the "Billing Notes" field for each record to learn more information about the error.',[`submit`]: 'Review Errors' });
      ___arguments.context.pageData['strWhereClauseModifier'] = errorWhereClause;
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
      return ;

    }
  } else {
    try {
      await ( async () => {
        const _uow = tx;

        claimObjectIds = (_uow.bulkCreate('Claim', trimmedClaimRecords));
        serviceLineObjectIds = (_uow.bulkCreate('ServiceLine', trimmedServiceLines));
        _uow.setRelation('BillingExport', (getObjectProperty(billingExportEntry, 'objectId')), 'rel_Claim', claimObjectIds);

      })();

      await tx.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      await (async function(arg) {
      	console.info(arg);
      })('pre set');
      await (async function(arg) {
      	console.info(arg);
      })(claimObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })(serviceLineObjectIds);
      claimObjectIds = (claimObjectIds.getResult());
      serviceLineObjectIds = (serviceLineObjectIds.getResult());
      ___arguments.context.pageData['serviceLineObjectIdList'] = serviceLineObjectIds;
      ___arguments.context.pageData['claimObjectIdList'] = claimObjectIds;
      await (async function(arg) {
      	console.info(arg);
      })('post set');
      await (async function(arg) {
      	console.info(arg);
      })(claimObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })(serviceLineObjectIds);
      await (async function(arg) {
      	console.info(arg);
      })('done - setting relations');
      for (var objectId_index in claimObjectIds) {
        objectId = claimObjectIds[objectId_index];
        currClaimObject = (await Backendless.Data.of('Claim').findById(objectId, ));
        var serviceLineCounterId_list = (getObjectProperty(claimIdToServiceLineIdList, (getObjectProperty(currClaimObject, 'counterId'))));
        for (var serviceLineCounterId_index in serviceLineCounterId_list) {
          serviceLineCounterId = serviceLineCounterId_list[serviceLineCounterId_index];
          currServiceLineObject = (await Backendless.Data.of('ServiceLine').find(Backendless.DataQueryBuilder.create().setWhereClause((String('counterId = ') + String(serviceLineCounterId))).setPageSize(1)));
          await Backendless.Data.of('Claim').addRelation(currClaimObject, 'rel_ServiceLine', currServiceLineObject);
          var transportObjectId_list = (getObjectProperty(transportMap, serviceLineCounterId));
          for (var transportObjectId_index in transportObjectId_list) {
            transportObjectId = transportObjectId_list[transportObjectId_index];
            transportObjectId = (await (async function(arg) {
            	if (Array.isArray(arg) && arg.length > 0) {
            	  return arg[0]
            	}
            	return arg
            })(transportObjectId));
            currServiceLineObject = (await (async function(arg) {
            	if (Array.isArray(arg) && arg.length > 0) {
            	  return arg[0]
            	}
            	return arg
            })(currServiceLineObject));
            await Backendless.Data.of('ServiceLine').addRelation(currServiceLineObject, 'rel_Transport', [transportObjectId]);
          }
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

    } catch (error) {
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( claimObjectIds )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( serviceLineObjectIds )));
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Database Interactions - Committing to Database and Setting Relations]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      try {
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

      } catch (error) {

      }
      await new Promise(r => setTimeout(r, 300 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      return ;

    }
    console.log(exportDataForTransportRecords);
    try {
      transactionUpdateExportedRecords = (new Backendless.UnitOfWork('REPEATABLE_READ'));

    } catch (error) {
      console.log(error);
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Updating Transaction Data]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'claimObjectIdList')) )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'serviceLineObjectIdList')) )));
      return ;

    }
    try {
      if (claimRecords == null) {
        throw (new Error('[ERROR] - Claim records null'))
      } else {
        console.log(claimRecords);
        my_837data = (await Backendless.Request.post(`${Backendless.appPath}/services/createX12Transaction/create837FromClaimList`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'claims': claimRecords,'claimInformationList': serviceLineList }));
        fileName = ['837-',billingExportId,'.CLP'].join('');
        await Backendless.Request.post(`${Backendless.appPath}/services/sftpUtils/sendFileOverSFTP`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'fileData': my_837data,'fileName': fileName });
        console.log(fileName);
        await Backendless.Files.saveFile(encodePath('/export/edi-files'), fileName, my_837data, false);
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
        ___arguments.context.pageData['modal'] = ({ [`title`]: ['Successfully Exported ',claimRecords.length,' Claim Record(s)! (837 Format)'].join(''),[`content`]: 'Your 837 File is successfully submitted to Waystar!',[`submit`]: '' });
      }

    } catch (error) {
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the 837 Billing Export', new Backendless.Bodyparts({ textmessage: 'An error occurred in billing export' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the 837 Billing Export') + String('[Failed During Upload to Waystar]')), 'Changes attempting to be saved in this step', ({ [`transportRecords`]: transportRecords,[`claimRecords`]: claimRecords,[`transportErrorData`]: transportDataError,[`transportRecordUpdates`]: exportDataForTransportRecords,[`serviceLines`]: serviceLineList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await Backendless.Data.of('BillingExport').remove( billingExportEntry );
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('Claim').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'claimObjectIdList')) )));
      await (async function(arg) {
      	console.info(arg);
      })((await Backendless.Data.of('ServiceLine').bulkDelete( (getObjectProperty(___arguments.context.pageData, 'serviceLineObjectIdList')) )));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
      ___arguments.context.pageData['modal'] = ({ [`title`]: 'Export Failed',[`content`]: 'The export was unsuccessful. An error report has been send to the system admin.',[`submit`]: '' });

    }
  }
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function setContractCode() {
  contractCode = 'MissingCode';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      if ((getObjectProperty(item, 'contractCode')) != null && (getObjectProperty(item, 'contractCode')) != '') {
        contractCode = (getObjectProperty(item, 'contractCode'));
      }
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function setPayerId() {
  payerId = 'MissingId';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      payerId = (getObjectProperty(item, 'payerId'));
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function setPayerName() {
  payerName = 'MissingName';
  console.log(await asyncListFind(payerTable, async (item) => {
     if ((getObjectProperty(j, 'rel_TransportRequest.typeInsurance')) == (getObjectProperty(item, 'typeInsurance'))) {
      payerName = (getObjectProperty(item, 'payerName'));
    }


   return ;
  }));
}

/**
 * Describe this function...
 */
async function reviewTransportForError_updateClaim() {
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Resubmitted') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Exported]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Suspended' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Denied') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Suspended / Denied]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'chargesTotal')) == null || (getObjectProperty(j, 'chargesTotal')) == 0) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "totalCharges" missing or formatted incorrectly ]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'typeReviewStatus')) || (getObjectProperty(j, 'typeReviewStatus')) != 'Processed') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Value for Review Status is Missing or not Processed]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}

/**
 * Describe this function...
 */
async function set837StaticDataInPageData() {
  ___arguments.context.pageData['interchangeControlNumber'] = '123456789';
  ___arguments.context.pageData['acknowledgementRequested'] = '1';
  if (getObjectProperty(___arguments.context.pageData, 'testingToggle')) {
    ___arguments.context.pageData['usageIndicator'] = 'T';
  } else {
    ___arguments.context.pageData['usageIndicator'] = 'T';
  }
  ___arguments.context.pageData['groupControlNumber'] = '12345';
  ___arguments.context.pageData['referenceID'] = 'ReferenceID';
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function reviewTransportForError_addClaim() {
  if (!(getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Insurance Policy #]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  } else if (getValueLength((getObjectProperty(j, 'rel_TransportRequest.insurancePolicyNumber'))) < 9) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Insurance policy# is less that 9 digits]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'dateOfBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Date of Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'assignedSexAtBirth'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client Missing Sex Assigned at Birth]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(loopClient, 'address')) || !(getObjectProperty(loopClient, 'city'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Client/Transport Destination address are both empty] ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'datetimeScheduledStart'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Exported') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Missing value for datetimeScheduledStart]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Paid' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'In Process') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport has already been Paid / In Process!]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'rel_TransportRequest.typeInsurance'))) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "typeInsurance" value is missing or incorrectly formatted for the "PayerName" value in 837 export]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'typeAdjudicationStatus')) == 'Suspended' || (getObjectProperty(j, 'typeAdjudicationStatus')) == 'Denied') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Transport Record Already Suspended / Denied]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if ((getObjectProperty(j, 'chargesTotal')) == null || (getObjectProperty(j, 'chargesTotal')) == 0) {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: "totalCharges" missing or formatted incorrectly ]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
  if (!(getObjectProperty(j, 'typeReviewStatus')) || (getObjectProperty(j, 'typeReviewStatus')) != 'Processed') {
    dataErrorFound = true;
    addItemToList(transportDataError, ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`notesBilling`]: ['[EXPORT ERROR: Value for Review Status is Missing or not Processed]  ',((new Date()).toLocaleDateString()),(getObjectProperty(j, 'notesBilling'))].join(''),[`hasBillingExportError`]: true }));
  }
}


  await export837();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/billing-sandbox-braxton3/components/7e483688669868e85a08e688db48d425/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['testingToggle'] = ___arguments.value;
  if (___arguments.value) {
    console.log('--- TESTING ON ---');
  } else {
    console.log('--- TESTING OFF ---');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bradd-testing/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Test Client Data');
  ___arguments.context.pageData['transportRecords'] = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause('rel_TransportRequest.rel_Client.objectId = \'007BDBB1-CF5D-4E6A-8BC9-021B3B0E4640\'').setPageSize(10)));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecords'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/bradd_test_11_29/components/11cec25fb6280e48bd896565a57cbbcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j, queryRecords, pageOffset, queryRecordCount;


  try {
    console.log(await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((String('created > \'1733016854000\'') + String(''))).setPageSize(10)));
    console.log(await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['created > \'1733016854000\'',' && typeInsurance IS NULL',' && rel_Client.typeInsurance = \'SoonerCare (XIX)\''].join('')))));

  } catch (error) {
    console.log(error);

  } finally {
    console.log('Success');

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bradd_test_11_29/components/67cf910e3e077b176f73f9b9f39b7e97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'sqlQuery')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bradd_test_11_29/components/83cdb57cc075383316ed0c6151ada2ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ID;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ID = (await Backendless.Data.of('').find(Backendless.DataQueryBuilder.create().setPageSize(10)));
  ___arguments.context.pageData['samsaraVehicle'] = (getObjectProperty(ID, 'samsaraVehicleId'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/change-password/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },
  /* handler:onEnter *//* content */
}));

define('./pages/change-password/components/58ecb77e91b7d9dd5c99075111c91c64/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['result'] = '';
  ___arguments.context.pageData['error'] = '';
  if ((getObjectProperty(___arguments.context.dataModel, 'password')) == (getObjectProperty(___arguments.context.dataModel, 'confirm_password'))) {
    try {
      ___arguments.context.pageData['result'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(Backendless.appPath),'/change_password/',(getObjectProperty(___arguments.context.pageData, 'token'))].join('')))).setEncoding('utf8').send(({ [`password`]: (getObjectProperty(___arguments.context.dataModel, 'password')) })));

    } catch (error) {
      ___arguments.context.pageData['error'] = ((typeof (getObjectProperty(error, 'message')) === 'string') ? (getObjectProperty(error, 'message')) : error);

    }
  } else {
    ___arguments.context.pageData['error'] = 'Passwords do not match';
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/change-password/components/9c0e75137e04bad6e50940e30ee54426/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },  
/* handler:onChange *//* content */
}));

define('./pages/change-password/components/1e3bdf67c1f295ed344408cd7f1dba1d/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },  
/* handler:onChange *//* content */
}));

define('./pages/claims/components/6a6c294bc0c45e0e3c33bdef5d3a2178/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (String('patLastName IS NOT NULL') + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  // relations: ["rel_ServiceLine", "rel_ServiceLine.rel_Transport"],
	   relationsDepth: 2
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [
	  {
	    "type": "actions",
	    "field": "actions",
	    "headerName": "",
	    "headerClass": "header-title",
	    "width": 75,
	    "meta": { "align": "left" },
	    "checkboxSelection": true,
	    "headerCheckboxSelection": true
	  },
	  {
	    "field": "patFirstName",
	    "headerName": "Patient First Name",
	    "headerTooltip": "First name of the Patient.",
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "field": "patLastName",
	    "headerName": "Patient Last Name",
	    "headerTooltip": "Last name of the Patient.",
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "field": "patBirthdate",
	    "headerName": "Patient DoB",
	    "headerTooltip": "Patient's Date of Birth.",
	    "valueFormatter": (params) => {
	      if (!params.value) return '';
	      return `${params.value.slice(4, 6)}/${params.value.slice(6, 8)}/${params.value.slice(0, 4)}`;
	    },

	    "meta": { "align": "center" },
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "field": "typeInsurance",
	    "headerName": "Type Insurance",
	    "headerTooltip": "Patient's Insurance Type.",
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "field": "sbrID",
	    "headerName": "Policy Number",
	    "headerTooltip": "Patient's Policy Number / Subscriber ID.",
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 100
	  },
	  {
	    "headerName": "Claim Information",
	    "children": [
	      {
	        "field": "claimStatus",
	        "headerName": "Claim Status",
	        "headerTooltip": "Current status for the given claim (paid, unpaid, etc).",
	        "cellEditor": "agSelectCellEditor",
	        "cellEditorParams": {
	          "values": ["Billed", "Partially Paid", "Re-Billed", "Hold", "Non-billable", "Paid"]
	        },
	        "sortable": true,
	        "editable": true,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "claimId",
	        "headerName": "Claim ID",
	        "headerTooltip": "ID For the Claim",
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "exportId",
	        "headerName": "Export ID",
	        "headerTooltip": "ID for the export",
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "created",
	        "headerName": "Claim Creation Date",
	        "headerTooltip": "Date which the claim was created",
	        "type": "dateColumn",
	        "cellRendererParams": {
	          "dayjsFormat": "MM/DD/YYYY"
	        },
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "totalCharges",
	        "headerName": "Total Charges",
	        "headerTooltip": "Total charges of a given claim",
	        "cellEditor": "agSelectCellEditor",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "totalReceived",
	        "headerName": "Total Received",
	        "headerTooltip": "Amount paid to the claim so far",
	        // "cellEditor": "agSelectCellEditor",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": true,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "totalBalance",
	        "headerName": "Balance Remaining",
	        "headerTooltip": "Remaining Balance of the Claim",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "serviceFrom_1",
	        "headerName": "Transport Date Start",
	        "headerTooltip": "First transport date in the claim",

	        "valueFormatter": (params) => {
	          if (!params.value) return '';
	          return `${params.value.slice(4, 6)}/${params.value.slice(6, 8)}/${params.value.slice(0, 4)}`;
	        },
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "serviceTo_1",
	        "headerName": "Transport Date End",
	        "headerTooltip": "Last transport date in the claim",
	        "valueFormatter": (params) => {
	          if (!params.value) return '';
	          return `${params.value.slice(4, 6)}/${params.value.slice(6, 8)}/${params.value.slice(0, 4)}`;
	        },
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "charge_1",
	        "headerName": "Flat Rate Charges",
	        "headerTooltip": "Base charges",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "charge_2",
	        "headerName": "Charges Over 30 Miles",
	        "headerTooltip": "Charges for miles driven above 30",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      },
	      {
	        "field": "claimNotes",
	        "headerName": "Claim Notes",
	        "headerTooltip": "Notes for the claim",
	        "sortable": true,
	        "editable": true,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 100
	      }
	    ]
	  }
	]
})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var modifier, line, claim;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function viewServiceLine() {
  console.log(___arguments['eventName']);
  console.log('RecordItem:');
  console.log(___arguments['recordItem']);
  if (___arguments['eventName'] == 'viewServiceLines') {
    console.log('entered view service lines');
    claim = (await Backendless.Data.of('Claim').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments['recordItem'], 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
    claim = claim[0];
    console.log('record item:');
    console.log(___arguments['recordItem']);
    console.log(getObjectProperty(claim, 'rel_ServiceLine'));
    modifier = ' && objectId IN (';
    var line_list2 = (getObjectProperty(claim, 'rel_ServiceLine'));
    for (var line_index2 in line_list2) {
      line = line_list2[line_index2];
      console.log(getObjectProperty(line, 'objectId'));
      modifier = String(modifier) + String(['\'',(getObjectProperty(line, 'objectId')),'\''].join(''));
      modifier = String(modifier) + String(',');
    }
    modifier = (await (async function(str) {
    	str = str.slice(0, -1);
    	return str;
    })(modifier));
    modifier = String(modifier) + String(')');
    console.log('modifier:');
    console.log(modifier);
    ___arguments.context.pageData['serviceLineWhereModifier'] = modifier;
    console.log('serviceLineBase + Where');
    console.log(getObjectProperty(___arguments.context.pageData, 'serviceLineWhereBase'));
    console.log(getObjectProperty(___arguments.context.pageData, 'serviceLineWhereModifier'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbd8cd8905233485424cae8009b40d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94186078177d9bdd2a69883ebee89768', true);
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('e33cd49807e8ffe811eff7485b0a9df5');
  }
}


  if (___arguments['eventName'] == 'viewServiceLines') {
    modifier = ' && objectId IN (';
    var line_list = (getObjectProperty(___arguments['recordItem'], 'rel_ServiceLine'));
    for (var line_index in line_list) {
      line = line_list[line_index];
      console.log(getObjectProperty(line, 'objectId'));
      modifier = String(modifier) + String(['\'',(getObjectProperty(line, 'objectId')),'\''].join(''));
      modifier = String(modifier) + String(',');
    }
    modifier = (await (async function(str) {
    	str = str.slice(0, -1);
    	return str + ")";
    })(modifier));
    ___arguments.context.pageData['serviceLineWhereModifier'] = modifier;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbd8cd8905233485424cae8009b40d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94186078177d9bdd2a69883ebee89768', true);
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('e33cd49807e8ffe811eff7485b0a9df5');
  }

  },
  /* handler:onActionIconClick */
  /* handler:onBeforeUpdate */
  async ['onBeforeUpdate'](___arguments) {
    var transport, item, claim;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function modifyStatus() {
  if ((getObjectProperty(___arguments['initialRecordItem'], 'claimStatus')) != (getObjectProperty(___arguments['changedRecordItem'], 'claimStatus'))) {
    if (getObjectProperty(___arguments['changedRecordItem'], 'claimStatus')) {
      ___arguments['changedRecordItem']['totalReceived'] = (getObjectProperty(___arguments['changedRecordItem'], 'totalCharges'));
    }
    console.log('Entered On Before Update Event!');
    var item_list = (getObjectProperty(___arguments['changedRecordItem'], 'rel_ServiceLine'));
    for (var item_index in item_list) {
      item = item_list[item_index];
      item['paidStatus'] = (getObjectProperty(___arguments['changedRecordItem'], 'claimStatus'));
      if ((getObjectProperty(___arguments['changedRecordItem'], 'claimStatus')) == 'Paid') {
        var transport_list = (getObjectProperty(item, 'rel_Transport'));
        for (var transport_index in transport_list) {
          transport = transport_list[transport_index];
          console.log(getObjectProperty(transport, 'objectId'));
          console.log(getObjectProperty(transport, 'typeAdjudicationStatus'));
          transport['typeAdjudicationStatus'] = (getObjectProperty(___arguments['changedRecordItem'], 'claimStatus'));
        }
      }
    }
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  console.log(___arguments['changedRecordItem']);
  if ((getObjectProperty(___arguments['initialRecordItem'], 'claimStatus')) != (getObjectProperty(___arguments['changedRecordItem'], 'claimStatus'))) {
    console.log('Entered On Before Update Event!');
    console.log(___arguments['initialRecordItem']);
    console.log(___arguments['changedRecordItem']);
    console.log(___arguments['changes']);
    claim = (await Backendless.Data.of('Claim').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments['changedRecordItem'], 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(1)));
    console.log('post claim');
    claim = claim[0];
    console.log(claim);
    var item_list2 = (getObjectProperty(claim, 'rel_ServiceLine'));
    for (var item_index2 in item_list2) {
      item = item_list2[item_index2];
      console.log(getObjectProperty(item, 'objectId'));
      console.log((await Backendless.Data.of('ServiceLine').bulkUpdate( (['objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join('')), ({ [`paidStatus`]: (getObjectProperty(___arguments['changedRecordItem'], 'claimStatus')) }) )));
      if ((getObjectProperty(___arguments['changedRecordItem'], 'claimStatus')) == 'Paid') {
        var transport_list2 = (getObjectProperty(item, 'rel_Transport'));
        for (var transport_index2 in transport_list2) {
          transport = transport_list2[transport_index2];
          console.log(getObjectProperty(transport, 'objectId'));
          console.log((await Backendless.Data.of('Transport').bulkUpdate( (['objectId = \'',(getObjectProperty(transport, 'objectId')),'\''].join('')), ({ [`typeAdjudicationStatus`]: (getObjectProperty(___arguments['changedRecordItem'], 'claimStatus')) }) )));
        }
      }
    }
    if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e33cd49807e8ffe811eff7485b0a9df5')), 'Visibilty')) {
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('e33cd49807e8ffe811eff7485b0a9df5');
    }
  }
}


  await modifyStatus();

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* handler:onAfterUpdate */
  async ['onAfterUpdate'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'serviceLineVisible')) {
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('e33cd49807e8ffe811eff7485b0a9df5');
  }

  },
  /* handler:onAfterUpdate */
  /* content */
}))

define('./pages/claims/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fa3ed4a1e63f46abf09fc19a19a8bc5', false);
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/claims/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/claims/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'billingData','tableOptions': ({ [`where`]: '',[`sortBy`]: 'datetimeScheduledStart asc',[`relationsDepth`]: 2 }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Submission Code', 'Transport Date', 'Status', 'Client Name', 'Client DoB', 'SoonerCare ID', 'Medicare ID', 'Start to Dropoff Distance', 'Start to End of Day Distance', 'Total Transport Distance'] }) }));
  console.log(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'));
  console.log(Backendless.appPath);
  await (async function(url) {
  	window.open(url, "_blank");
  })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.dataModel, 'csvFilePath'))));

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/claims/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var exportItem, insurance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClauseBase'] = (String('patLastName IS NOT NULL'));
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['serviceLineWhereBase'] = (String('rel_Transport IS NOT NULL'));
  ___arguments.context.pageData['payerList'] = (await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setSortBy('typeInsurance').setPageSize(100))).map(async insurance => {; return ({ [`value`]: (getObjectProperty(insurance, 'typeInsurance')),[`label`]: (getObjectProperty(insurance, 'typeInsurance')) });})));
  ___arguments.context.pageData['billingExportList'] = (await Promise.all((await Backendless.Data.of('BillingExport').find(Backendless.DataQueryBuilder.create().setWhereClause('rel_Claim is NOT NULL').setSortBy('exportId DESC').setPageSize(100))).map(async exportItem => {; return ({ [`value`]: (getObjectProperty(exportItem, 'exportId')),[`label`]: [(getObjectProperty(exportItem, 'exportId')),' - ',(new Date((getObjectProperty(exportItem, 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(exportItem, 'created'))).getDate()),'/',(new Date((getObjectProperty(exportItem, 'created'))).getFullYear())].join('') });})));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/claims/components/08084838717a0617b0cd23d541e42bdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var whereClauseModifier, item, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& created >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& created <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& patLastName LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'claimsValue')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'claimsValue')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& claimStatus LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'claimsValue')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'insuranceValue')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'insuranceValue')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& payerName LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'insuranceValue')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportValue')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportValue')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& claimId LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'exportValue')),'%\' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('be38f4188332d7b88a4bf602eb2b224f')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('be38f4188332d7b88a4bf602eb2b224f')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('be38f4188332d7b88a4bf602eb2b224f')).map(async item => {; return (['claimStatus LIKE \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),')'].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('c358a998c78829f67038f34b71987c37')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('c358a998c78829f67038f34b71987c37')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('c358a998c78829f67038f34b71987c37')).map(async item => {; return (['typeInsurance LIKE \'%',(getObjectProperty(item, 'value')),'%\''].join(''));}))).join(' OR '),')'].join(''));
  }
  console.log(whereClauseModifier);
  ___arguments.context.pageData['strWhereClauseModifier'] = whereClauseModifier;
  console.log('strWhereClause Output');
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClauseModifier'));
  console.log('Client Last Name');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientLastName'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/claims/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = (getObjectProperty(___arguments.context.pageData, 'startDate'));
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = (getObjectProperty(___arguments.context.pageData, 'endDate'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/claims/components/cdc24d17ae93332a77b903f552274347/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/claims/components/46ce3f5d5e3b99aa135e87b85d13df39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['claimsValue'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['insuranceValue'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['clientLastName'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['claimsValue'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['insuranceValue'] = null;
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['exportValue'] = null;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('be38f4188332d7b88a4bf602eb2b224f', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('c358a998c78829f67038f34b71987c37', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/claims/components/c681a3c14dcb6416b42c3306d11a1018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/claims/components/522dc7060cd65724883e5a986e3d1739/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/claims/components/4718bdf6745898f8c072cf58fc376028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var claimList, originalClaimValueMap, error, markedRows, trx, transportObjectIdList, serviceLineObjectIdList, claim, transport, serviceLine, claimObjectIdList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function do_something() {
  markedRows = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('6a6c294bc0c45e0e3c33bdef5d3a2178'));
  trx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = trx;

    // For each item in the claims list, want to modify
    // the claim AND modify the the associated transport
    // requests that it is related to. MODIFY TOTAL BALANCE
    for (var claim_index5 in markedRows) {
      claim = markedRows[claim_index5];
      _uow.bulkUpdate('Claim', (['claimId = \'',(getObjectProperty(claim, 'claimId')),'\''].join('')), ({ [`totalReceived`]: (getObjectProperty(claim, 'totalCharges')),[`claimStatus`]: 'Paid' }));
    }

  })();

  // For each item in the claims list, want to modify the claim AND
  // modify the the associated transport requests that it is related to
  for (var claim_index6 in markedRows) {
    claim = markedRows[claim_index6];
    console.log(getObjectProperty(claim, 'totalBalance'));
  }
  console.log((await trx.execute().then(function(result) {
      const error = result && result.error

      if (error) {
        throw error
      }

    return result
    })));
  await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
}

/**
 * Describe this function...
 */
async function errorReport() {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');
  await new Promise(r => setTimeout(r, 300 || 0));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
  ___arguments.context.pageData['modal'] = ({ [`title`]: String('Error') + String(''),[`content`]: 'Error Updating Claims -  An error report has been sent to the system admin.',[`submit`]: '' });
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
  ___arguments.context.pageData['modal'] = ({ [`title`]: String('Processing') + String(' Selected Claim(s)'),[`content`]: 'Marking Selected Claim(s) and their Service Lines as Paid',[`submit`]: '' });
  markedRows = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('6a6c294bc0c45e0e3c33bdef5d3a2178'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
  ___arguments.context.pageData['modal'] = ({ [`title`]: ['Processing ',markedRows.length,' Selected Claim(s)'].join(''),[`content`]: 'Marking Selected Claim(s) and their Service Lines as Paid',[`submit`]: '' });
  console.log(markedRows);
  claimObjectIdList = [];
  serviceLineObjectIdList = [];
  transportObjectIdList = [];
  // For each item in the claims list, want to modify
  // the claim AND modify the the associated transport
  // requests that it is related to. MODIFY TOTAL BALANCE
  for (var claim_index in markedRows) {
    claim = markedRows[claim_index];
    addItemToList(claimObjectIdList, (getObjectProperty(claim, 'objectId')));
  }
  console.log((await (async function(claimList) {
  	let res = []

  	res.push("(")

  	for (let i = 0; i < claimList.length; i++) {
  	  res.push(claimList[i])
  	  res.push(",")
  	}
  	res.pop();
  	res.push(")");
  	res = res.join("");

  	return "objectId IN " + res;
  })(claimObjectIdList)));
  try {
    claimList = (await Backendless.Data.of('Claim').find(Backendless.DataQueryBuilder.create().setWhereClause((await (async function(claimList) {
    	let res = []

    	res.push("(")

    	for (let i = 0; i < claimList.length; i++) {
    	  res.push('\'')
    	  res.push(claimList[i])
    	  res.push('\'')
    	  res.push(",")
    	}
    	res.pop();
    	res.push(")");
    	res = res.join("");

    	return "objectId IN " + res;
    })(claimObjectIdList))).setRelationsDepth(5).setPageSize(100)));
    // For each item in the claims list, want to modify
    // the claim AND modify the the associated transport
    // requests that it is related to. MODIFY TOTAL BALANCE
    for (var claim_index2 in claimList) {
      claim = claimList[claim_index2];
      var serviceLine_list = (getObjectProperty(claim, 'rel_ServiceLine'));
      for (var serviceLine_index in serviceLine_list) {
        serviceLine = serviceLine_list[serviceLine_index];
        addItemToList(serviceLineObjectIdList, (getObjectProperty(serviceLine, 'objectId')));
        var transport_list = (getObjectProperty(serviceLine, 'rel_Transport'));
        for (var transport_index in transport_list) {
          transport = transport_list[transport_index];
          addItemToList(transportObjectIdList, (getObjectProperty(transport, 'objectId')));
        }
      }
    }
    originalClaimValueMap = (await (async function(claimList) {
    	let map = new Map();

    	for (let i = 0; i < claimList.length; i++ ) {
    	  map.set(claimList[i].objectId, {
    	    totalReceived : claimList[i].totalReceived,
    	    claimStatus : claimList[i].claimStatus
    	  });
    	}

    	return map;
    })(claimList));
    console.log(originalClaimValueMap);

  } catch (error) {
    console.log(error);
    await errorReport();
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Claims Page', new Backendless.Bodyparts({ textmessage: 'An error occurred in Claims' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the Claims Page') + String('[Failed During Iterative Update of Claims]')), 'Changes attempting to be saved in this step', ({ [`originalValues`]: originalClaimValueMap,[`claimRecords`]: claimList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    return ;

  }
  console.log('claimList');
  console.log(claimList);
  console.log('serviceLineObjectIdList');
  console.log(serviceLineObjectIdList);
  console.log(transportObjectIdList);
  try {
    // For each item in the claims list, want to modify
    // the claim AND modify the the associated transport
    // requests that it is related to. MODIFY TOTAL BALANCE
    for (var claim_index3 in claimList) {
      claim = claimList[claim_index3];
      await Backendless.Data.of('Claim').bulkUpdate( (['objectId = \'',(getObjectProperty(claim, 'objectId')),'\''].join('')), ({ [`totalReceived`]: (getObjectProperty(claim, 'totalCharges')),[`claimStatus`]: 'Paid' }) );
    }

  } catch (error) {
    console.log(error);
    // For each item in the claims list, want to modify
    // the claim AND modify the the associated transport
    // requests that it is related to. MODIFY TOTAL BALANCE
    for (var claim_index4 in claimList) {
      claim = claimList[claim_index4];
      console.log((await (async function(currClaimObjectId, claimMap) {
      	const obj = claimMap.get(currClaimObjectId)

      	return obj.totalReceived;
      })((getObjectProperty(claim, 'objectId')), originalClaimValueMap)));
      console.log((await (async function(currClaimObjectId, claimMap) {
      	const obj = claimMap.get(currClaimObjectId)

      	return obj.claimStatus;
      })((getObjectProperty(claim, 'objectId')), originalClaimValueMap)));
      await Backendless.Data.of('Claim').bulkUpdate( (['objectId = \'',(getObjectProperty(claim, 'objectId')),'\''].join('')), ({ [`totalReceived`]: (await (async function(currClaimObjectId, claimMap) {
      	const obj = claimMap.get(currClaimObjectId)

      	return obj.totalReceived;
      })((getObjectProperty(claim, 'objectId')), originalClaimValueMap)),[`claimStatus`]: (await (async function(currClaimObjectId, claimMap) {
      	const obj = claimMap.get(currClaimObjectId)

      	return obj.claimStatus;
      })((getObjectProperty(claim, 'objectId')), originalClaimValueMap)) }) );
    }
    await errorReport();
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Claims Page', new Backendless.Bodyparts({ textmessage: 'An error occurred Marking all as Paid' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the Claims Page') + String('[Failed During Iterative Update of Claims]')), 'Changes attempting to be saved in this step', ({ [`originalValues`]: originalClaimValueMap,[`claimRecords`]: claimList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    return ;

  }
  try {
    trx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = trx;

      _uow.bulkUpdate('ServiceLine', (await (async function(claimList) {
      	let res = []

      	res.push("(")

      	for (let i = 0; i < claimList.length; i++) {
      	  res.push('\'')
      	  res.push(claimList[i])
      	  res.push('\'')
      	  res.push(",")
      	}
      	res.pop();
      	res.push(")");
      	res = res.join("");

      	return "objectId IN " + res;
      })(serviceLineObjectIdList)), ({ [`paidStatus`]: 'Paid' }));
      _uow.bulkUpdate('Transport', (await (async function(claimList) {
      	let res = []

      	res.push("(")

      	for (let i = 0; i < claimList.length; i++) {
      	  res.push('\'')
      	  res.push(claimList[i])
      	  res.push('\'')
      	  res.push(",")
      	}
      	res.pop();
      	res.push(")");
      	res = res.join("");

      	return "objectId IN " + res;
      })(transportObjectIdList)), ({ [`typeAdjudicationStatus`]: 'Paid' }));

    })();

    console.log((await trx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('522dc7060cd65724883e5a986e3d1739');
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('522dc7060cd65724883e5a986e3d1739');
    ___arguments.context.pageData['modal'] = ({ [`title`]: ['Processed',markedRows.length,' Selected Claim(s)'].join(''),[`content`]: 'Claim(s), ServiceLine(s), and Transport(s) have been marked as Paid!',[`submit`]: '' });
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('6a6c294bc0c45e0e3c33bdef5d3a2178');
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6bbd8cd8905233485424cae8009b40d8')), 'Visibilty')) == true) {
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('e33cd49807e8ffe811eff7485b0a9df5');
    }

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Claims Page', new Backendless.Bodyparts({ textmessage: 'An error occurred Marking all as Paid' }), ensureArray('bkinney@pvragon.com'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/billing-export-errors', error, (String('An Error Has Occurred in the Claims Page') + String('[Failed During Data ServiceLine and Transport Transaction]')), 'Changes attempting to be saved in this step', ({ [`originalValues`]: originalClaimValueMap,[`claimRecords`]: claimList }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    await errorReport();
    return ;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/claims/components/e33cd49807e8ffe811eff7485b0a9df5/bundle.js', [], () => ({
  /* content */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  while (!((getObjectProperty(___arguments.context.pageData, 'serviceLineWhereBase')) != null && (getObjectProperty(___arguments.context.pageData, 'serviceLineWhereModifier')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  ___arguments.context.pageData['serviceLineWhere'] = (String(getObjectProperty(___arguments.context.pageData, 'serviceLineWhereBase')) + String(getObjectProperty(___arguments.context.pageData, 'serviceLineWhereModifier')));
  console.log(getObjectProperty(___arguments.context.pageData, 'serviceLineWhere'));
  console.log(getObjectProperty(___arguments.context.pageData, 'strWhereClause'));

  return (await (async function(pageData) {
	return {
	  where: pageData.serviceLineWhere,
	  // relations: "rel_TransportRequest.rel_Client", TODO: Modify to include rel export
	  //properties: ["typeStatus"]//

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [

	    {
	      "field": "charge_1",
	      "headerName": "Base Charges",
	      "sortable": true,
	      "editable": false,
	      "valueFormatter": ns.currencyValueFormatter,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "width" : 250
	    },
	    {
	      "field": "charge_2",
	      "headerName": "Charges for Mileage Over 30",
	      "sortable": true,
	      "editable": false,
	      "valueFormatter": ns.currencyValueFormatter,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "width" : 250
	    },

	    {
	        "field": "totalCharges",
	        "headerName": "Total Charges for Claim",
	        "headerTooltip": "Total charges for ALL Service Lines for this claim",
	        "cellEditor": "agSelectCellEditor",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 250
	    },
	        {
	        "field": "serviceLineTotal",
	        "headerName": "Total Charges for Service Line",
	        "headerTooltip": "Total charges for this service line",
	        "cellEditor": "agSelectCellEditor",
	        "valueFormatter": ns.currencyValueFormatter,
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 250
	    },
	    {
	        "field": "units_1",
	        "headerName": "Number of Transports",
	        "headerTooltip": "Total number of transports for this service line.",
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 250
	    },
	    {
	        "field": "units_2",
	        "headerName": "Total Miles above 30",
	        "headerTooltip": "Total number of miles above 30 for this service line.",
	        "sortable": true,
	        "editable": false,
	        "wrapHeaderText": true,
	        "autoHeaderHeight": true,
	        "width" : 250
	    },
	    {
	      "field": "paidStatus",
	      "headerName": "Paid status",
	      "headerTooltip": "Paid status for this service line.",
	      "cellEditor": "agSelectCellEditor",
	      "cellEditorParams": {
	        "values": ["Billed", "Paid", "Partially Paid", "Re-Billed", "Hold", "Non-billable"]
	      },
	      "sortable": true,
	      "editable": true,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "width" : 250
	    },
	    {
	    "field": "serviceFrom",
	    "headerName": "Transport Date",
	    "valueFormatter": (params) => {
	        if (!params.value) return '';
	        return `${params.value.slice(4, 6)}/${params.value.slice(6, 8)}/${params.value.slice(0, 4)}`;
	    },
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "width" : 250
	    }
	  ]
})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    var transport, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['initialRecordItem'], 'paidStatus')) != (getObjectProperty(___arguments['changedRecordItem'], 'paidStatus'))) {
    if ((getObjectProperty(___arguments['changedRecordItem'], 'paidStatus')) == 'Paid') {
      var transport_list = (getObjectProperty(item, 'rel_Transport'));
      for (var transport_index in transport_list) {
        transport = transport_list[transport_index];
        console.log(getObjectProperty(transport, 'objectId'));
        console.log(getObjectProperty(transport, 'typeAdjudicationStatus'));
        transport['typeAdjudicationStatus'] = (getObjectProperty(___arguments['changedRecordItem'], 'paidStatus'));
      }
    }
  }

  return ___arguments['changedRecordItem']

  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/claims/components/abe8a13efe4b6a58a6f82758f9cd27e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94186078177d9bdd2a69883ebee89768', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbd8cd8905233485424cae8009b40d8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/claims/components/be38f4188332d7b88a4bf602eb2b224f/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Billed',[`value`]: 'Billed' }), ({ [`label`]: 'Paid',[`value`]: 'Paid' }), ({ [`label`]: 'Partially Paid',[`value`]: 'Partially Paid' }), ({ [`label`]: 'Re-Billed',[`value`]: 'Re-Billed' }), ({ [`label`]: 'Hold',[`value`]: 'Hold' }), ({ [`label`]: 'Non-billable',[`value`]: 'Non-billable' })]

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/claims/components/c358a998c78829f67038f34b71987c37/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'payerList'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/claims/components/9679f189adffe468e10cf8a93a0161e8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var claim;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'billingExportList'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/clients/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'landing' }), ({ [`label`]: 'Clients',[`pageName`]: 'clients' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/clients/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [
	  {
	    "type": "actions",
	    "field": "actions",
	    "width": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8 ? 125 : 95,
	    "minWidth": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8 ? 125 : 95,
	    "pinned": "left",
	    "meta": { "align": "center"},
	    "checkboxSelection": true
	  },

	  {
	    "field": "nameFull",
	    "headerName": "Client Name",
	    "sort": "asc",
	    "sortable": true,
	    "width": 250,
	    "pinned": "left",
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },


	  {"field": "dateOfBirth", "headerName":"Date Of Birth", "type": "dateColumn", "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY" }, "sortable": true, "width": 200, "editable": true},

	  {
	    "field": "SSN",
	    "headerName": "Social Security Number",
	    "headerTooltip": "Client Social Security Number",
	    "width": 100,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "valueFormatter": ns.ssnValueFormatter,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  /*
	  {
	    "field": "insuranceProvider",
	    "headerName": "Insurance Company",
	    "headerTooltip": "Client's primary insurance company.",
	    "width": 100,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "insurancePolicyNumber",
	    "headerName": "Policy #",
	    "headerTooltip": "Policy Number for Client's primary insurance.",
	    "width": 100,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  */
	  {
	    "field": "rel_TransportRequest_insurancePolicyNumber",
	    "headerName": "Policy #",
	    "headerTooltip": "Policy Number for Client's primary insurance.",
	    "width": 100,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  /*
	  {
	    "field": "typeInsurance",
	    "headerName": "Insurance Type",
	    "headerTooltip": "Insurance Type",
	    "width": 100,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  */
	  {
	    "field": "rel_TransportRequest_typeInsurance",
	    "headerName": "Insurance Type",
	    "headerTooltip": "Insurance Type",
	    "width": 100,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "soonerCareId",
	    "headerName": "SoonerCare ID",
	    "headerTooltip": "Client's SoonerCare ID.  This is an older field and should not be used for new records.",
	    "width": 100,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },


	  {"field": "is18", "headerName":"Is 18", "sortable": true, "width": 50, "editable": false, "type": "booleanColumn", "meta": { "align": "center"}, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {"field": "height", "headerName":"Height", "sortable": true, "width": 100, "editable": true, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {"field": "weight", "headerName":"Weight", "sortable": true, "width": 100, "editable": true, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},

	  {
	    "field"             : "isFedRecognizedTribal",
	    "headerName"        : "Tribal?",
	    "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
	    "width"             : 100,
	    "minWidth"          : 40,
	    "sortable"          : true,
	    "editable"          : true,
	    "meta"              : { "align": "center"},
	    "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true
	  },

	  {
	    "field"             : "tribeAffiliations",
	    "headerName"        : "Tribes",
	    "headerTooltip"     : "Which tribes are this Client affiliated with?",
	    "width"             : 120,
	    "minWidth"          : 40,
	    "sortable"          : true,
	    "type"              : "selectColumn",
	    "editable"          : false,
	    "cellRendererParams": { "withChips": true },
	    //"cellEditorParams"  : { "values": pageData.typeOptions || [] },
	    "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true
	  },

	  {
	    "field"             : "phone",
	    "headerName"        : "Phone",
	    "sortable"          : true,
	    "width"             : 120,
	    "editable"          : true,
	    "valueFormatter"    : ns.phoneNumberValueFormatter,
	    "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true
	  },
	  {"field": "email", "headerName":"Email", "sortable": true, "width": 200, "editable": true, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {"field": "googleFormattedAddress", "headerName":"Address", "sortable": true, "width": 400, "editable": false, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {"field": "hasHistoryOfViolence", "headerName":"Has History Of Violence", "sortable": true, "width": 100, "editable": true, "type": "booleanColumn", "meta": { "align": "center"}, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {"field": "hasSpecialPrecautionsOrMedicalNeeds", "headerName":"Has Special Precautions Or Medical Needs", "sortable": true, "width": 100, "editable": true, "type": "booleanColumn", "meta": { "align": "center"}, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {"field": "isElopementRisk", "headerName":"Is Elopement Risk", "sortable": true, "width": 100, "editable": true, "type": "booleanColumn", "meta": { "align": "center"}, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {"field": "isVeteran", "headerName":"Is Veteran", "sortable": true, "width": 100, "editable": true, "type": "booleanColumn", "meta": { "align": "center"}, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {"field": "specialPrecautionsOrMedicalNeeds", "headerName":"Special Precautions Or Medical Needs", "sortable": true, "width": 400, "editable": true, "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true},
	  {
	    "field"             : "created",
	    "headerName"        :"Created",
	    "sortable"          : true,
	    "width"             : 180,
	    "type"              : "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat"       : "MM/DD/YYYY HH:mm:ss",
	      "withSeconds"       : true
	      },
	    "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true
	  },


	  // {"field": "age", "headerName":"Age", "sortable": true, "width": 50, "editable": true},
	  // {"field": "address", "headerName":"Address", "sortable": true, "width": 200, "editable": false},
	  // {"field": "city", "headerName":"City", "sortable": true, "width": 200, "editable": false},
	  // {"field": "emailAlt", "headerName":"Alternative Email", "sortable": true, "width": 200, "editable": false},
	  // {"field": "emergencyContactName", "headerName":"Emergency Contact Name", "sortable": true, "width": 200, "editable": false},
	  // {"field": "emergencyContactPhone", "headerName":"Emergency Contact Phone", "sortable": true, "width": 200, "editable": false},
	  // {"field": "emergencyContactNameAlt", "headerName":"Alternative Emergency Contact Name", "sortable": true, "width": 200, "editable": false},
	  // {"field": "emergencyContactPhoneAlt", "headerName":"Alternative Emergency Contact Phone", "sortable": true, "width": 200, "editable": false},
	  // {"field": "googlePlaceId", "headerName":"Google Place Id", "sortable": true, "width": 200, "editable": false},
	  // {"field": "medicareId", "headerName":"Medicare Id", "sortable": true, "width": 200, "editable": false},
	  // {"field": "nameFirst", "headerName":"Name First", "sortable": true, "width": 200, "editable": false},
	  // {"field": "nameLast", "headerName":"Name Last", "sortable": true, "width": 200, "editable": false},
	  // {"field": "nameMiddle", "headerName":"Name Middle", "sortable": true, "width": 200, "editable": false},
	  // {"field": "nickname", "headerName":"Nickname", "sortable": true, "width": 200, "editable": false},
	  // {"field": "otherNotes", "headerName":"Other Notes", "sortable": true, "width": 200, "editable": false},
	  // {"field": "phoneAlt", "headerName":"Alternative Phone", "sortable": true, "width": 200, "editable": false},
	  // {"field": "relZipcode_OkrcRegionLookup.zipcode", "headerName":"Zipcode", "sortable": true, "width": 200, "editable": false},
	  // {"field": "rideCareId", "headerName":"Ride Care Id", "sortable": true, "width": 200, "editable": false},
	  // {"field": "soonerCareId", "headerName":"Sooner Care Id", "sortable": true, "width": 200, "editable": false},
	  // {"field": "stateCode", "headerName":"State Code", "sortable": true, "width": 200, "editable": false},
	  // {"field": "tribeAffiliations", "headerName":"Tribe Affiliations", "sortable": true, "width": 200, "editable": false},
	  // {"field": "tribeMemberZipcode", "headerName":"Tribe Member Zipcode", "sortable": true, "width": 200, "editable": false},
	  // {"field": "zipcode", "headerName":"Zipcode", "sortable": true, "width": 200, "editable": false},
	]
})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'changeAddress') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088')), 'clientRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', true);
      // If the change address action is clicked then we show
      // the form to update the facility address and pass the
      // chosen item record over into the form's data container.
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088'))['clientRecord'] = ___arguments['recordItem'];
    }
  } else if (___arguments['eventName'] == 'viewAndEditRecord') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f0b47b283a4ee883d73e9f978666c0f9')), 'clientRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', true);
    } else {
      // If the change address action is clicked then we show
      // the form to update the facility address and pass the
      // chosen item record over into the form's data container.
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f0b47b283a4ee883d73e9f978666c0f9'))['clientRecord'] = ___arguments['recordItem'];
      // If the change address action is clicked then we show
      // the form to update the facility address and pass the
      // chosen item record over into the form's data container.
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f0b47b283a4ee883d73e9f978666c0f9'))['isNewClient'] = false;
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', false);
    }
  } else if (___arguments['eventName'] == 'delete') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Delete operation timed out after 30s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      await Backendless.Data.of('Client').remove( ___arguments['recordItem'] );
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'viewBilling') {
    console.log(['rel_TransportRequest.rel_Client.objectId = \'',(getObjectProperty(___arguments['recordItem'], 'objectId')),'\''].join(''));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('billing', ({ [`strWhereClauseModifier`]: ['&& rel_TransportRequest.rel_Client.objectId LIKE \'%',(getObjectProperty(___arguments['recordItem'], 'objectId')),'%\''].join(''),[`dateOfBirth`]: ((getObjectProperty(___arguments['recordItem'], 'dateOfBirth')).valueOf()),[`clientLastName`]: (getObjectProperty(___arguments['recordItem'], 'nameLast')),[`resetBillingFilter`]: true }));
  }

  },
  /* handler:onActionIconClick */
  /* handler:actionsIconsLogic */
  async ['actionsIconsLogic'](___arguments) {
      return (await (async function(appData) {
	return appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 7
	? [
	    {"eventName": "viewAndEditRecord", "icon": "edit", "className": "view-details", "title":"Edit Client"},
	    {"eventName": "viewBilling", "icon": "attach_money", "className": "view-billing", "title":"View Billing"},
	    {"eventName":"delete","icon":"delete_forever", "className":"delete-icon", "title":"Delete Client"}
	  ]
	: [{"eventName": "viewAndEditRecord", "icon": "edit", "className": "view-details", "title":"Edit Client"}]
})(___arguments.context.appData))

  },
  /* handler:actionsIconsLogic */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
      return (await (async function(appData) {
	return {
	  "loadAll": true,
	  "where": appData.currentUser?.rideCareUserAttributes?.permissionLevel < 8 ? "LOWER(nameFull) NOT LIKE '%test%'" : "",
	  //"where": "objectId = '007BDBB1-CF5D-4E6A-8BC9-021B3B0E4640'",
	  //"groupBy": "objectId",
	  //"relationsDepth": 2,
	  //"relations": "TransportRequest",
	  "properties":["objectId",
	                "nameFirst",
	                "nameFull",
	                "nameLast",
	                "dateOfBirth",
	                "SSN",
	                //"insuranceProvider",
	                //"insurancePolicyNumber",
	                //"typeInsurance",
	                "created",
	                "soonerCareId",
	                "is18",
	                "height",
	                "weight",
	                "phone",
	                "isFedRecognizedTribal",
	                "tribeAffiliations",
	                "email",
	                "googleFormattedAddress",
	                "hasHistoryOfViolence",
	                "hasSpecialPrecautionsOrMedicalNeeds",
	                "isElopementRisk",
	                "isVeteran",
	                "specialPrecautionsOrMedicalNeeds",
	                "TransportRequest[rel_Client].typeInsurance as rel_TransportRequest_typeInsurance",
	                "TransportRequest[rel_Client].insurancePolicyNumber as rel_TransportRequest_insurancePolicyNumber",
	                "TransportRequest[rel_Client].Transport[rel_TransportRequest].typeStatus as rel_Transport_typeStatus",
	                "TransportRequest[rel_Client].Transport[rel_TransportRequest].created as rel_Transport_created"
	                ],
	  "pageSize": 100,
	  "processRelations": true
	}
})(___arguments.context.appData))

  },
  /* handler:queryLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
      console.log('%c>> 🔒 ' + 'Initial Record Item', 'color: #f06292', JSON.parse(JSON.stringify(___arguments['initialRecordItem'])));
  console.log('%c>> 🔒 ' + 'Changed Record Item', 'color: #3f51b5', JSON.parse(JSON.stringify(___arguments['changedRecordItem'])));
  console.log('%c>> 🔒 ' + 'Changes', 'color: #26a69a', JSON.parse(JSON.stringify(___arguments['changes'])));

  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/clients/components/45bee23a419ff7c9e93a5842096578f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', false);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f0b47b283a4ee883d73e9f978666c0f9'))['isNewClient'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clients/components/f0b47b283a4ee883d73e9f978666c0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var filteredClientRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  filteredClientRecord = (await (async function(record) {
  	const excludedKeys = [
  	  'rel_TransportRequest_insurancePolicyNumber',
  	  'rel_TransportRequest_typeInsurance',
  	  'rel_Transport_created',
  	  'rel_Transport_typeStatus'
  	]

  	return Object.fromEntries(
  	  Object.entries(record).filter(([key]) => !excludedKeys.includes(key))
  	)
  })((getObjectProperty(___arguments.context.dataModel, 'clientRecord'))));
  // Save the new facility into the Facility table and put
  // the returned objectId into the newFacility object
  (getObjectProperty(___arguments.context.dataModel, 'clientRecord'))['objectId'] = (getObjectProperty((await Backendless.Data.of('Client').deepSave( filteredClientRecord )), 'objectId'));
  await (getChannelInstance('default')).send('reload-table-records:Client', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'clientRecord.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/clients/components/4c44230b6b5983a3743bfdf3e943e3a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var errors;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  errors = ({  });
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.dateOfBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['dateOfBirth'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.is18')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.emergencyContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['emergencyContactName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.is18')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.emergencyContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['emergencyContactPhone'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.assignedSexAtBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['assignedSexAtBirth'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.SSN'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['SSN'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.heightFt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['heightFt'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.heightIn'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['heightIn'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.weight'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['weight'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.email')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.email'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['email'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.emailAlt')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'clientRecord.emailAlt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['emailAlt'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    // Need to put this here since the submit button for the form is
    // set to default to avoid the 'submit on enter key press' issue.
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('f0b47b283a4ee883d73e9f978666c0f9');
  } else {
    console.log(errors);
    ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['errors'] = errors;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clients/components/9ec5c52d7fa4ba838d0cdea8a1291ee3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clients/components/87350f9abd387e213ce27961eb166986/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clients/components/46868346d41eb8e9a1f7c20627239776/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clients/components/ad746135a58df2e756b14f1fbca20e94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'clientRecord')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clients/components/00af44ca02488116c8749b36734af088/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Client').save( (getObjectProperty(___arguments.context.dataModel, 'clientRecord')) );
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Client').setRelation((getObjectProperty(___arguments.context.dataModel, 'clientRecord')), 'relZipcode_OkrcRegionLookup', (['zipcode = \'',(getObjectProperty(___arguments.context.dataModel, 'clientRecord.zipcode')),'\''].join('')));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);
  await new Promise(r => setTimeout(r, 5000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/clients/components/a5bd36dd116f46b49f03aaecf7e57d51/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/clients/components/9d0d50765d552901b619fe5db659c827/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Data Model of Client RUC');
  console.log(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f0b47b283a4ee883d73e9f978666c0f9'))['tribeOptions'] = (getObjectProperty(___arguments.context.pageData, 'tribeOptions'));

  return ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/clients/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  ___arguments.context.pageData['tribeOptions'] = (await Promise.all((await Backendless.Data.of('TribeAffiliationOptions').find(Backendless.DataQueryBuilder.create().setSortBy('tribes').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'tribes')),[`label`]: (getObjectProperty(item, 'tribes')) });})));
  ___arguments.context.pageData['typeInsuranceOptions'] = ((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setSortBy('typeInsurance').setPageSize(100))).map(item => item['typeInsurance']));
  ___arguments.context.pageData['clientsPageData'] = ({ [`clientRecord`]: ({ [`numberInsurancePolicies`]: 1 }),[`errors`]: ({  }) });
  ___arguments.context.pageData['mergeClientsData'] = ({  });

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/clients/components/7b8265f99ba66e5562462ef639210a46/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'isNewClient')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clients/components/008e279970e6b3053d0ab136d41a0084/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, maxRelations, preferredRecord, duplicate, count, pageSize, offset, selectedRows, transportRequestsToUpdate, operationsLimit;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedRows = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5ace80b8ec397e9c5c0b03221b61217d'));
  operationsLimit = 8;
  if (selectedRows.length > operationsLimit) {
    (function (message) { alert(message) })((['We are unable to merge more than ',operationsLimit,' records in a single operation. Please choose up to ',operationsLimit,' records, merge those, and then merge the remainder in a second step.'].join('')));
    return ;
  }
  (getObjectProperty(___arguments.context.pageData, 'mergeClientsData'))['selectedClients'] = selectedRows;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a2852c4b79b6c8eb98850c41825d120e');
  transportRequestsToUpdate = [];
  try {
    (getObjectProperty(___arguments.context.pageData, 'mergeClientsData'))['loading'] = true;
    (getObjectProperty(___arguments.context.pageData, 'mergeClientsData'))['loadingMessage'] = 'Loading, please wait...';
    maxRelations = 0;
    preferredRecord = null;
    for (var duplicate_index in selectedRows) {
      duplicate = selectedRows[duplicate_index];
      count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['rel_Client.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join('')))));
      offset = 0;
      pageSize = 100;
      if (count > maxRelations) {
        maxRelations = count;
        preferredRecord = duplicate;
      }
    }
    (getObjectProperty(___arguments.context.pageData, 'mergeClientsData'))['preferredRecord'] = preferredRecord;
    (getObjectProperty(___arguments.context.pageData, 'mergeClientsData'))['maxRelations'] = maxRelations;

  } catch (error) {
    console.log(error);
    return ;

  } finally {
    (getObjectProperty(___arguments.context.pageData, 'mergeClientsData'))['loading'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clients/components/64e7c32b458641bd45a13539428aac3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'mergeClientsData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/clients/components/b086d9e22ec69c7ddeb6168505161a8e/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label, error, consoleError, errMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClients')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClients')) : []).map(async item => {  label = ['Client Name: ',(getObjectProperty(item, 'nameFull')),', ','DoB:',((new Date((getObjectProperty(item, 'dateOfBirth')))).toLocaleDateString()),', ','SSN:',(await (async function(SSN) {
  	if (!SSN || typeof SSN !== 'string') {
  	    return 'N/A'
  	}

  	if (!/^\d{9}$/.test(SSN)) {
  	  return SSN;
  	}

  	return `${SSN.slice(0, 3)}-${SSN.slice(3, 5)}-${SSN.slice(5, 9)}`;
  })((getObjectProperty(item, 'SSN')))),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','ObjectId: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c')['selectedClient'] = ___arguments['value'];
  console.log(___arguments['value']);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clients/components/a2852c4b79b6c8eb98850c41825d120e/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['mergeClientsData'] = ({  });

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/clients/components/9525b03cf3a1eada25a36f91e26e9d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClients')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClients')).length > 0 ? 'Please choose the client to use as the main record. The remaining duplicates will be removed.' : 'Please select the clients in the table that you would like to merge')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clients/components/a7f5019f00ac838425de1195d26698d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['mergeClientsData'] = ({  });
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2852c4b79b6c8eb98850c41825d120e');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clients/components/bcd995af75279dd424ff48492378a357/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clients/components/76ac42b5ca6f9f034475396fc79d4a23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, duplicatesToRemove, message, result, removeDuplicatesTx, whereClauseDuplicates, duplicatesToRemoveMap, j, transportRequestsToUpdate, pageSize, offset, transportRequest, transportRequests, duplicate, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  console.log('MERGE:');
  ___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c')['mergeClientsError'] = false;
  duplicatesToRemove = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClients')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClient.objectId')) != (getObjectProperty(item, 'objectId')));
  }));
  console.log('ToRemove:');
  console.log(duplicatesToRemove);
  duplicatesToRemoveMap = ({  });
  whereClauseDuplicates = '';
  for (var duplicate_index in duplicatesToRemove) {
    duplicate = duplicatesToRemove[duplicate_index];
    if (!(getObjectProperty(duplicatesToRemoveMap, (getObjectProperty(duplicate, 'objectId'))))) {
      duplicatesToRemoveMap[(getObjectProperty(duplicate, 'objectId'))] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClient'));
    }
    if (whereClauseDuplicates != '') {
      whereClauseDuplicates = String(whereClauseDuplicates) + String(' OR ');
    }
    whereClauseDuplicates = String(whereClauseDuplicates) + String(['objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join(''));
  }
  console.log('ToRemoveMap:');
  console.log(duplicatesToRemoveMap);
  console.log(whereClauseDuplicates);
  transportRequestsToUpdate = [];
  try {
    ___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c')['loading'] = true;
    ___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c')['loadingMessage'] = 'Merging Clients, please wait...';
    for (var duplicate_index2 in duplicatesToRemove) {
      duplicate = duplicatesToRemove[duplicate_index2];
      count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['rel_Client.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join('')))));
      offset = 0;
      pageSize = 100;
      while (offset < count) {
        transportRequests = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['rel_Client.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
        for (var transportRequest_index in transportRequests) {
          transportRequest = transportRequests[transportRequest_index];
          addItemToList(transportRequestsToUpdate, transportRequest);
        }
        offset = offset + pageSize;
      }
    }
    transportRequestsToUpdate = (await (async function(arr) {
    	const seen = new Set()


    	return arr.filter(item => {
    	  const isDuplicate = seen.has(item.objectId)

    	  seen.add(item.objectId)

    	  return !isDuplicate
    	})

    })(transportRequestsToUpdate));
    console.log('TransportRequestsToUpdate:');
    console.log(transportRequestsToUpdate);

  } catch (error) {
    console.log(error);
    ___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c')['loading'] = false;
    return ;

  }
  try {
    console.log(transportRequestsToUpdate.length);
    removeDuplicatesTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    if (transportRequestsToUpdate.length > 0) {
      for (var j_index in transportRequestsToUpdate) {
        j = transportRequestsToUpdate[j_index];
        if (getObjectProperty(duplicatesToRemoveMap, (getObjectProperty(j, 'rel_Client.objectId')))) {
          console.log('rel_Client');
          console.log(j);
          await ( async () => {
            const _uow = removeDuplicatesTx;

            _uow.setRelation('TransportRequest', j, 'rel_Client', (getObjectProperty(duplicatesToRemoveMap, (getObjectProperty(j, 'rel_Client.objectId'))))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(j, 'objectId'))));

          })();

        }
      }
    }
    await ( async () => {
      const _uow = removeDuplicatesTx;

      _uow.bulkDelete('Client', whereClauseDuplicates).setOpResultId('ClientDeleteDuplicates');

    })();

    console.log('RUN:');
    result = (await removeDuplicatesTx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));
    console.log(result);
    if (getObjectProperty(result, 'success')) {
      message = [(getObjectProperty(result, 'results.ClientDeleteDuplicates.result')),' records have been deleted from the Client table table, and ',(Object.keys((getObjectProperty(result, 'results')))).length - 1,' relations have been updated in the TransportRequest table.'].join('');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).deselectRows() })('5ace80b8ec397e9c5c0b03221b61217d');
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2852c4b79b6c8eb98850c41825d120e');
      (function (message) { alert(message) })(message);
      await (getChannelInstance('default')).send((String('reload-table-records:') + String('Client')), ({ [`ids`]: (await Promise.all(duplicatesToRemove.map(async item => {; return (getObjectProperty(item, 'objectId'));}))) }));
    }

  } catch (error) {
    console.log(error);
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'preferredRecord')) {
      ___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c')['mergeClientsError'] = true;
    }
    ___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c')['loading'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'loading')) || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClient')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'selectedClients')).length > 1))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clients/components/69f89a16afc93766a621b829bc1d061e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'preferredRecord')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'maxRelations')) > 1 ? ['For the best results, please consider choosing the record with objectId: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'preferredRecord.objectId')),'. This record has the most references (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'maxRelations')),'), making it the optimal choice for merging.'].join('') : '')

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'preferredRecord')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'maxRelations')) > 1 && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('64e7c32b458641bd45a13539428aac3c'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clients/components/9b8d77f7daae32f96758254dfa7d2904/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientRecord, dateOfBirth, existingClients, nameLast, SSN, whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  clientRecord = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5ace80b8ec397e9c5c0b03221b61217d'));
  if (clientRecord.length != 1) {
    (function (message) { alert(message) })('Please select 1 record');
    return ;
  }
  existingClients = [];
  if (clientRecord) {
    SSN = (getObjectProperty(clientRecord, 'SSN'));
    dateOfBirth = (getObjectProperty(clientRecord, 'datestringDateOfBirth'));
    nameLast = (getObjectProperty(clientRecord, 'nameLast'));
    whereClause = (await (async function(dateOfBirth, nameLast, objectId, SSN) {
    	const conditions = [];

    	if (SSN && SSN !== '999999999') {
    	  conditions.push(`SSN = '${ SSN }'`);
    	}

    	if (dateOfBirth && nameLast) {
    	  conditions.push(`(datestringDateOfBirth = '${ dateOfBirth }' AND nameLast = '${ nameLast.replace(/'/g, "''") }')`);
    	}


    	let whereClause = conditions.length > 0 ? conditions.join(' OR ') : '';

    	if (whereClause) {
    	  whereClause = `(${ whereClause }) AND `;
    	}

    	whereClause += `objectId != '${ objectId }'`;

    	return whereClause;

    })(dateOfBirth, nameLast, (getObjectProperty(clientRecord, 'objectId')), SSN));
    console.log('%c>> ' + 'CLIENT', 'color: #f06292', clientRecord);
    console.log(whereClause);
    console.log('ExistingClients');
    console.log(existingClients);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/comingsoon/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('welcome', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/confirmation-confirmed/components/b1cfb8e9ae25b445f99ef1429693e77b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-rides/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('App Data');
  console.log(___arguments.context.appData);
  console.log('Current user object id');
  console.log(getObjectProperty(___arguments.context.appData, 'currentUser.objectId'));
  ___arguments.context.pageData['transportRecord'] = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['relDriver1_Employee.relEmail_Users.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')),'\' && tripLogTransportStatus != \'Complete\' && typeStatus != \'Voided\''].join(''))).setRelated(['rel_TransportRequest.rel_Client', 'rel_TransportRequest.relDestination_Facility', 'rel_TransportRequest.relPickup_Facility', 'relDispatcher1_Employee', null]).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7584216dff336da681119ee9a04ccab3', false);
  console.log('transports');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord'));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(async () => {
      // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
    ___arguments.context.appData['insuranceTypeOptions'] = (await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setSortBy('typeInsurance').setPageSize(100).setDistinct(true))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'typeInsurance')),[`label`]: (getObjectProperty(item, 'typeInsurance')) });})));
    ___arguments.context.appData['tribalStatusOptions'] = [({ [`label`]: 'Yes',[`value`]: true }), ({ [`label`]: 'No/Unknown',[`value`]: false })];
    ___arguments.context.appData['tribeAffiliationOptions'] = (await Promise.all((await Backendless.Data.of('TribeAffiliationOptions').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'tribes')),[`value`]: (getObjectProperty(item, 'tribes')) });})));

  })();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/current-rides/components/c15501fe259858379dcf8ae8561ceeaf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Transport: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.rel_Client.nameFull')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-rides/components/561d7fb2e9029349f01fff52097117a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientSuicideOrSelfHarmRiskToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-rides/components/91a798d5b4c7782d2846f7bbfe06478f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientAggressiveOrViolentToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-rides/components/184f9d6cb531ac2924b27ef3495d351d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientElopementRiskToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-rides/components/1646184623d83f7c9ce8e24a71b2e102/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'typeStatus')) == 'Canceled') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1646184623d83f7c9ce8e24a71b2e102'))['color'] = 'Red';
    return 'RIDE CANCELED';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1646184623d83f7c9ce8e24a71b2e102'))['color'] = '';
    return (['Scheduled Start: ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'datetimeScheduledStart')))).toLocaleDateString()),'  ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'datetimeScheduledStart')))).toLocaleTimeString())].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-rides/components/14bf660624e7b1b911234b63a127abcb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('current-transport', ({ [`transportRecord`]: ___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'),[`lastPage`]: 'current-rides' }));

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'tripLogTransportStatus')) == 'In Progress' ? 'View In Progress Transport' : 'View Transport')

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'tripLogTransportStatus')) == 'In Progress') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14bf660624e7b1b911234b63a127abcb'))['background'] = '#2BC25C';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14bf660624e7b1b911234b63a127abcb'))['background'] = '#2B46C2';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14bf660624e7b1b911234b63a127abcb'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-rides/components/ba44f0d6e5e650432ee8b3c71a480d7b/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  ['onPointsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ [`lat`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')))),[`lng`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')))) }), ({ [`lat`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),[`lng`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))) })]

  },
  /* handler:onPointsAssignment */
  /* handler:onMapCenterAssignment */
  ['onMapCenterAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`lat`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude'))) / 2,[`lng`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude'))) / 2 })

  },
  /* handler:onMapCenterAssignment */
  /* handler:onMapZoomAssignment */
  ['onMapZoomAssignment'](___arguments) {
    var markerDistance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  if ((roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),2)) > (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))),2))) {
    markerDistance = (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),2));
  } else {
    markerDistance = (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))),2));
  }
  if (markerDistance <= 0.04) {
    return 13;
  } else if (markerDistance <= 0.09) {
    return 12;
  } else if (markerDistance <= 0.14) {
    return 11;
  } else if (markerDistance <= 0.3) {
    return 10;
  } else if (markerDistance <= 0.8) {
    return 9;
  } else if (markerDistance <= 1.6) {
    return 8;
  } else if (markerDistance <= 2.5) {
    return 7;
  } else {
    return 6;
  }

  },
  /* handler:onMapZoomAssignment */
  /* handler:onMarkerClick */
  ['onMarkerClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.point, 'lat')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude'))) {
    (function (componentUid, marker, popupContent) { ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('ba44f0d6e5e650432ee8b3c71a480d7b', ___arguments.point, (['<p><strong>PICKUP: </strong>',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.googleName')),'</p> <p><a href="https://www.google.com/maps/search/?api=1&query=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.pickupAddress')),'">',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.pickupAddress')),'</a></p> <p>&nbsp;</p>'].join('')));
  } else {
    (function (componentUid, marker, popupContent) { ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('ba44f0d6e5e650432ee8b3c71a480d7b', ___arguments.point, (['<p><strong>DROPOFF: </strong>',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.googleName')),'</p> <p><a href="https://www.google.com/maps/search/?api=1&query=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.destinationAddress')),'">',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.destinationAddress')),'</a></p> <p>&nbsp;</p>'].join('')));
  }

  },
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/current-rides/components/781283713a168d38d5e7eaac18c99fbf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.length')) == 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-rides/components/8f669b05e8a6265a67b98543fe78e0f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Lat Diff: ',Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude'))),'Lng Diff: ',Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-rides/components/a69547c24da70959fade4d9a3f96969e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Transport Code: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'transportCode_copy')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-rides/components/91b6e19c4c472a31e67c6af2eedda827/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Pickup - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.pickupLocationName')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-rides/components/e8918b7f3726e56ee7a934b39966a7a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Dropoff - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.destinationLocationName')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/61814fc304af1ea1214a6bd85a03beef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('681d6715b2c9c8ee9e076ea7d26489ce', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61814fc304af1ea1214a6bd85a03beef', undefined);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart')) || !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('61814fc304af1ea1214a6bd85a03beef'))['background'] = '#F6EC98';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('61814fc304af1ea1214a6bd85a03beef'))['background'] = '#E5E5E5';
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/7b3f0a0e21ac45dac915d724f95fd1d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var typeStatus, error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function isInputEmpty() {
  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogMilageStart'] = ['inputError'];
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogDatetimeActualStart'] = ['inputError'];
    return true;
  } else {
    return false;
  }
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecOne')) && await isInputEmpty() == true) {
    ___arguments.context.pageData['stateSecOne'] = 'Error';
    return ;
  } else {
    console.log('Save the fields');
    if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 1) {
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 2;
    }
    try {
      transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transaction;

        _uow.update('transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogMilageStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart')),[`tripLogDatetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart')) })).setOpResultId('updateTransportStepTwo');

      })();

      await transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      typeStatus = ((await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),'\''].join(''))).setProperties('typeStatus').setPageSize(10))).map(item => item['typeStatus'])).join(',');

    } catch (error) {
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: 'An error occurred in the driver trip log flow' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Has Occurred in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogMilageStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart')),[`tripLogDatetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart')) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));

    } finally {
      console.log('Trip Started - Counter = 2');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('681d6715b2c9c8ee9e076ea7d26489ce', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61814fc304af1ea1214a6bd85a03beef', undefined);

    }
    if (typeStatus == 'Canceled') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', undefined);
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 10;
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed1f4d07d7f83667268b0502d493d46d')));
    } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 2 && (getObjectProperty(___arguments.context.pageData, 'stateSecOne')) != 'Submitted') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f2b0db2d1e961c9b1b966be9d6bf134', undefined);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5f2b0db2d1e961c9b1b966be9d6bf134')));
    }
    ___arguments.context.pageData['stateSecOne'] = 'Submitted';
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecOne'))) {
    return 'Save and Submit';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecOne')) == 'Error') {
    return 'Submit With Missing Data';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecOne')) == 'Submitted') {
    return 'Save Edits';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/76c49e01e38dcf3ccffe2da9e3f5e9e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transaction, typeStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 3;
  try {
    transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = transaction;

      _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) })).setOpResultId('updateTransportStepThree');

    })();

    await transaction.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      });
    typeStatus = ((await Backendless.Data.of('transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),'\''].join(''))).setProperties('typeStatus').setPageSize(10))).map(item => item['typeStatus'])).join(',');

  } catch (error) {
    console.log(error);

  } finally {
    console.log('Counter = 3');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f2b0db2d1e961c9b1b966be9d6bf134', undefined);

  }
  if (typeStatus == 'Canceled') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', undefined);
    ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 10;
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed1f4d07d7f83667268b0502d493d46d')));
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b88615159ff744ce57262c3ce59c8a2c', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function applySectionValues() {
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) >= 2) {
    ___arguments.context.pageData['stateSecOne'] = 'Submitted';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) >= 4) {
    ___arguments.context.pageData['stateSecTwo'] = 'Submitted';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) >= 5) {
    ___arguments.context.pageData['stateSecThree'] = 'Submitted';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) >= 7) {
    ___arguments.context.pageData['stateSecFour'] = 'Submitted';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) >= 8) {
    ___arguments.context.pageData['stateSecFive'] = 'Submitted';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) >= 9) {
    ___arguments.context.pageData['stateSecSix'] = 'Submitted';
  }
  console.log('stateSecOne Value');
  console.log(getObjectProperty(___arguments.context.pageData, 'stateSecOne'));
}


  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('current-rides', undefined);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.typeStatus')) == 'Canceled' && (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogTransportStatus')) != 'Complete') {
    ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 10;
  }
  ___arguments.context.pageData['readOnlyState'] = ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogTransportStatus')) == 'Complete' ? true : false);
  await applySectionValues();
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) == true) {
    ___arguments.context.pageData['pageLoad.isDriversLastRoute'] = (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) == true) {
    ___arguments.context.pageData['pageLoad.isDriversLastRoute'] = (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute'));
  }
  ___arguments.context.pageData['tribeAffiliations'] = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations'));
  console.log('transportRecord');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord'));
  console.log('relPickup_Facility.latitude');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.latitude'));
  console.log('App info data!!!');
  console.log(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('VIEWER'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/current-transport/components/c15501fe259858379dcf8ae8561ceeaf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Transport: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.nameFull')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/1646184623d83f7c9ce8e24a71b2e102/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.typeStatus')) == 'Canceled') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1646184623d83f7c9ce8e24a71b2e102'))['color'] = 'Red';
    return 'RIDE CANCELED';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1646184623d83f7c9ce8e24a71b2e102'))['color'] = '';
    return (['Scheduled Start: ',((new Date((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')))).toLocaleDateString()),'  ',((new Date((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')))).toLocaleTimeString())].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/561d7fb2e9029349f01fff52097117a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.isClientSuicideOrSelfHarmRiskToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/91a798d5b4c7782d2846f7bbfe06478f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.isClientAggressiveOrViolentToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/184f9d6cb531ac2924b27ef3495d351d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.isClientElopementRiskToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/f7f197fd121cb63491191ef9b6d66e3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var phoneNumber, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  phoneNumber = String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupContactPhone'));

  return ([(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupContactName')),' - ',['(',phoneNumber.slice(0, 3),') ',phoneNumber.slice(3, 6),'-',phoneNumber.slice(6, 10)].join('')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/109fecb68ccaf498a8e2ef96c337adaf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('tel:') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupContactPhone'))), false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/af1f1fef0b76422520a899c531e1a0f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var phoneNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  phoneNumber = String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationContactPhone'));

  return ([(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationContactName')),' - ',['(',phoneNumber.slice(0, 3),') ',phoneNumber.slice(3, 6),'-',phoneNumber.slice(6, 10)].join('')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/4dae33c6e5bc89a2289e0fefb611c22f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('tel:') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationContactPhone'))), false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/4995134e96eba62a4fd6df63a6b73e84/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fa92c0662d1f1f74a0e32081dfa321cf')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/58780b09b524e7853cb26e6249a66e93/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fa92c0662d1f1f74a0e32081dfa321cf')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/fa92c0662d1f1f74a0e32081dfa321cf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'tribalStatusOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    
  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/1f84d8f7c4d39d18433590cd30d5d69b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'insuranceTypeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['transportRecord.rel_TransportRequest.insuranceProvider'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.typeInsurance'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/10ea9bb8b8e48d9ee2afae7b65ea540c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['transportRecord.tripLogDatetimeActualPickupDeparture'] = (new Date());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/a99a8e0cc38ac4626bf63c8e25c635de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
      return [({ [`label`]: 'Yes',[`value`]: true }), ({ [`label`]: 'No',[`value`]: false })]

  },
  /* handler:onOptionsAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != null && (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == null) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/a5a157ea5c2b0d674fdca7beeb99276a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/fa8905fea9c741aea82982b1cd3776cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var phoneNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  phoneNumber = String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupContactPhone'));

  return ([(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupContactName')),' - ',['(',phoneNumber.slice(0, 3),') ',phoneNumber.slice(3, 6),'-',phoneNumber.slice(6, 10)].join('')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/57e75f89f169b36dc692557c3fd2c2ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var phoneNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  phoneNumber = String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationContactPhone'));

  return ([(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationContactName')),' - ',['(',phoneNumber.slice(0, 3),') ',phoneNumber.slice(3, 6),'-',phoneNumber.slice(6, 10)].join('')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/8ed136b61ca7baf84dac82ac416b6781/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['transportRecord.tripLogDatetimeActualDropoff'] = (new Date());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/e01a2e5eb11a67ec8dfb5f8f1f1bcda7/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
      return [({ [`label`]: 'Yes',[`value`]: true }), ({ [`label`]: 'No',[`value`]: false })]

  },
  /* handler:onOptionsAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecFive')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/fa56a90c277665b772843642a68bdc17/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/fae685fed4c5772462036b0a46c82fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/e74ac2d597a185fe725af3c4c077f86d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['transportRecord.tripLogDatetimeActualDropoffDeparture'] = (new Date());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/460f52d29fa965155cc7418f5bedaec3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 1;
  try {
    transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = transaction;

      _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogTransportStatus`]: 'In Progress' })).setOpResultId('updateTransportStepOne');

    })();

    await transaction.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      });

  } catch (error) {
    console.log(error);

  } finally {
    console.log('Trip Started - Counter = 1');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7764fc4c2956fac86b85db5fb4b29d29', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('030106155dd862df886104d23aadd774', undefined);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7764fc4c2956fac86b85db5fb4b29d29')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/541427a690a47b9d8e983e9d6362791d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['transportRecord.tripLogDatetimeActualStart'] = (new Date());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/5f2b0db2d1e961c9b1b966be9d6bf134/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f2b0db2d1e961c9b1b966be9d6bf134', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f2b0db2d1e961c9b1b966be9d6bf134', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/030106155dd862df886104d23aadd774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('030106155dd862df886104d23aadd774', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('030106155dd862df886104d23aadd774', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/b88615159ff744ce57262c3ce59c8a2c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b88615159ff744ce57262c3ce59c8a2c', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b88615159ff744ce57262c3ce59c8a2c', true);
    ___arguments.context.pageData['stateSecTwo'] = 'Submitted';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b88615159ff744ce57262c3ce59c8a2c', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/681d6715b2c9c8ee9e076ea7d26489ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('681d6715b2c9c8ee9e076ea7d26489ce', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('681d6715b2c9c8ee9e076ea7d26489ce', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61814fc304af1ea1214a6bd85a03beef', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('681d6715b2c9c8ee9e076ea7d26489ce', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61814fc304af1ea1214a6bd85a03beef', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/7764fc4c2956fac86b85db5fb4b29d29/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7764fc4c2956fac86b85db5fb4b29d29', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7764fc4c2956fac86b85db5fb4b29d29', true);
    ___arguments.context.pageData['stateSecOne'] = 'Submitted';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7764fc4c2956fac86b85db5fb4b29d29', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/49b500ca5c341bab377d07e48edf066f/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecTwo'))) {
    return 'Save and Submit';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecTwo')) == 'Error') {
    return 'Submit With Missing Data';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecTwo')) == 'Submitted') {
    return 'Save Edits';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var typeStatus, error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function isInputEmpty() {
  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogDatetimeActualPickup'] = ['inputError'];
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogMileagePickup'] = ['inputError'];
    return true;
  } else {
    return false;
  }
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecTwo')) && await isInputEmpty() == true) {
    ___arguments.context.pageData['stateSecTwo'] = 'Error';
    return ;
  } else {
    console.log('Save the fields');
    if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 3) {
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 4;
    }
    try {
      transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transaction;

        _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogDatetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup')),[`tripLogMileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup')) })).setOpResultId('updateTransportStepFour');

      })();

      await transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      typeStatus = ((await Backendless.Data.of('transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),'\''].join(''))).setProperties('typeStatus').setPageSize(10))).map(item => item['typeStatus'])).join(',');

    } catch (error) {
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: 'An error occurred in the driver trip log flow' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Has Occurred in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogDatetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup')),[`tripLogMileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup')) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));

    } finally {
      console.log('Counter = 4');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b5452c31c26bca5dcc586ea39131ec6', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f60dce85d789b0de08d9b62dafd99f34', undefined);

    }
    if (typeStatus == 'Canceled') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', undefined);
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 10;
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed1f4d07d7f83667268b0502d493d46d')));
    } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 4 && (getObjectProperty(___arguments.context.pageData, 'stateSecTwo')) != 'Submitted') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e52980766ea5f8a4596c2fc91b6f5eec', undefined);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    }
    ___arguments.context.pageData['stateSecTwo'] = 'Submitted';
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/8b5452c31c26bca5dcc586ea39131ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b5452c31c26bca5dcc586ea39131ec6', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b5452c31c26bca5dcc586ea39131ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f60dce85d789b0de08d9b62dafd99f34', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b5452c31c26bca5dcc586ea39131ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f60dce85d789b0de08d9b62dafd99f34', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/c1c3ee75915213fd7e25bd35fea37047/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['transportRecord.tripLogDatetimeActualPickup'] = (new Date());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/e52980766ea5f8a4596c2fc91b6f5eec/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e52980766ea5f8a4596c2fc91b6f5eec', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e52980766ea5f8a4596c2fc91b6f5eec', true);
    ___arguments.context.pageData['stateSecThree'] = 'Submitted';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e52980766ea5f8a4596c2fc91b6f5eec', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/00730aa40b93b9d6b33b45e794bcb5df/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00730aa40b93b9d6b33b45e794bcb5df', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00730aa40b93b9d6b33b45e794bcb5df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ab3241eb6681f87e3c3030d28f46f96', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00730aa40b93b9d6b33b45e794bcb5df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ab3241eb6681f87e3c3030d28f46f96', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/f60dce85d789b0de08d9b62dafd99f34/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup')) || !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f60dce85d789b0de08d9b62dafd99f34'))['background'] = '#F6EC98';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f60dce85d789b0de08d9b62dafd99f34'))['background'] = '#E5E5E5';
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b5452c31c26bca5dcc586ea39131ec6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f60dce85d789b0de08d9b62dafd99f34', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/9282312455e56a8cb43d8145ac3c7e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecThree'))) {
    return 'Save and Submit';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) == 'Error') {
    return 'Submit With Missing Data';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) == 'Submitted') {
    return 'Save Edits';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var typeStatus, error, transaction, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function isInputEmpty() {
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == null) {
    ___arguments.context.pageData['error.transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal'] = ['inputError'];
    return true;
  } else if (false) {
    ___arguments.context.pageData['error.transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations'] = ['inputError'];
    return true;
  } else if (false) {
    ___arguments.context.pageData['error.transportRecord.rel_TransportRequest.rel_Client.tribeMemberZipcode'] = ['inputError'];
    return true;
  } else if (false) {
    ___arguments.context.pageData['error.transportRecord.rel_TransportRequest.rel_Client.SSN'] = ['inputError'];
    return true;
  } else if (false) {
    ___arguments.context.pageData['error.transportRecord.rel_TransportRequest.rel_Client.typeInsurance'] = ['inputError'];
    return true;
  } else if (false) {
    ___arguments.context.pageData['error.transportRecord.rel_TransportRequest.rel_Client.insuranceProvider'] = ['inputError'];
    return true;
  } else if (false) {
    ___arguments.context.pageData['error.transportRecord.rel_TransportRequest.rel_Client.insurancePolicyNumber'] = ['inputError'];
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == null) {
    ___arguments.context.pageData['error.transportRecord.isTripLogPersonalItems'] = ['inputError'];
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogPersonalItemsNotes'] = ['inputError'];
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogDatetimeActualPickupDeparture'] = ['inputError'];
    return true;
  } else {
    return false;
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == true) {
    ___arguments.context.pageData['transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations'] = ((await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('0445247c39560737186f1cb251718fd4')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(','));
  }
  console.log('Tribal values');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations'));
  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecThree')) && await isInputEmpty() == true) {
    ___arguments.context.pageData['stateSecThree'] = 'Error';
    return ;
  } else {
    console.log('Save the fields');
    if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 4) {
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 5;
    }
    try {
      transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transaction;

        _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`isTripLogPersonalItems`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')),[`tripLogPersonalItemsNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes')),[`tripLogDatetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture')) })).setOpResultId('updateTransportStepFive');
        _uow.update('Client', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.objectId')),[`isFedRecognizedTribal`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')),[`tribeAffiliations`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations')),[`tribeMemberZipcode`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeMemberZipcode')),[`SSN`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.SSN')) })).setOpResultId('updateClientStepFive');
        _uow.update('TransportRequest', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.objectId')),[`typeInsurance`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.typeInsurance')),[`insurancePolicyNumber`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.insurancePolicyNumber')) })).setOpResultId('updateTransportRequestStepFive');

      })();

      await transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      typeStatus = ((await Backendless.Data.of('transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),'\''].join(''))).setProperties('typeStatus').setPageSize(10))).map(item => item['typeStatus'])).join(',');

    } catch (error) {
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: 'An error occurred in the driver trip log flow' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Has Occurred in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`transport`]: ({ [`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`isTripLogPersonalItems`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')),[`tripLogPersonalItemsNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes')),[`tripLogDatetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture')) }),[`client`]: ({ [`isFedRecognizedTribal`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')),[`tribeAffiliations`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations')),[`tribeMemberZipcode`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeMemberZipcode')),[`SSN`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.SSN')) }),[`transportRequest`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.objectId')),[`typeInsurance`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.typeInsurance')),[`insurancePolicyNumber`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.insurancePolicyNumber')) }) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));

    } finally {
      console.log('Counter = 4');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00730aa40b93b9d6b33b45e794bcb5df', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ab3241eb6681f87e3c3030d28f46f96', undefined);

    }
    if (typeStatus == 'Canceled') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', undefined);
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 10;
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed1f4d07d7f83667268b0502d493d46d')));
    } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 5 && (getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != 'Submitted') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('044bb1f7d8a25fe1b96b7cbd5fc2b684', undefined);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('044bb1f7d8a25fe1b96b7cbd5fc2b684')));
    }
    ___arguments.context.pageData['stateSecThree'] = 'Submitted';
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/7aca72f395e1291b39dbbccad347dac2/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecFour'))) {
    return 'Save and Submit';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecFour')) == 'Error') {
    return 'Submit With Missing Data';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecFour')) == 'Submitted') {
    return 'Save Edits';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var typeStatus, error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function isInputEmpty() {
  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogDatetimeActualDropoff'] = ['inputError'];
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogMileageDropoff'] = ['inputError'];
    return true;
  } else {
    return false;
  }
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecFour')) && await isInputEmpty() == true) {
    ___arguments.context.pageData['stateSecFour'] = 'Error';
    return ;
  } else {
    console.log('Save the fields');
    if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 6) {
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 7;
      console.log('Counter = 7');
    }
    try {
      transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transaction;

        _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogDatetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff')),[`tripLogMileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff')) })).setOpResultId('updateTransportStepSeven');

      })();

      await transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      typeStatus = ((await Backendless.Data.of('transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),'\''].join(''))).setProperties('typeStatus').setPageSize(10))).map(item => item['typeStatus'])).join(',');

    } catch (error) {
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: 'An error occurred in the driver trip log flow' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Has Occurred in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogDatetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff')),[`tripLogMileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff')) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));

    } finally {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9771cc9e0fb5e5a65b6ade558797a941', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d19a794fb7b9d194018f79fe1f4f8fb1', undefined);

    }
    if (typeStatus == 'Canceled') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', undefined);
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 10;
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed1f4d07d7f83667268b0502d493d46d')));
    } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 7 && (getObjectProperty(___arguments.context.pageData, 'stateSecFour')) != 'Submitted') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec226a2d9a3bd11286bc266f7a598461', undefined);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ec226a2d9a3bd11286bc266f7a598461')));
    }
    ___arguments.context.pageData['stateSecFour'] = 'Submitted';
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/4958d91bb9a56036b3bff0fd3f2dd72b/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecFive'))) {
    return 'Save and Submit';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecFive')) == 'Error') {
    return 'Submit With Missing Data';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecFive')) == 'Submitted') {
    return 'Save Edits';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var typeStatus, error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function isInputEmpty() {
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered'))) {
    ___arguments.context.pageData['error.transportRecord.isTripLogPersonalItemsDelivered'] = ['inputError'];
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsDeliveredNotes'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogPersonalItemsDeliveredNotes'] = ['inputError'];
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogDatetimeActualDropoffDeparture'] = ['inputError'];
    return true;
  } else {
    return false;
  }
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecFive')) && await isInputEmpty() == true) {
    ___arguments.context.pageData['stateSecFive'] = 'Error';
    return ;
  } else {
    console.log('Save the fields');
    if (((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 7) == ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) == true)) {
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 8;
      console.log('Counter = 8');
    } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 7) {
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 9;
      console.log('Counter = 9');
    }
    try {
      transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transaction;

        _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`isTripLogPersonalItemsDelivered`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered')),[`tripLogPersonalItemsDeliveredNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsDeliveredNotes')),[`tripLogDatetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture')),[`tripLogDriverNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDriverNotes')),[`isDriversLastRoute`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) })).setOpResultId('updateTransportStepEight');

      })();

      await transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });
      typeStatus = ((await Backendless.Data.of('transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),'\''].join(''))).setProperties('typeStatus').setPageSize(10))).map(item => item['typeStatus'])).join(',');

    } catch (error) {
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: 'An error occurred in the driver trip log flow' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Has Occurred in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`isTripLogPersonalItemsDelivered`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered')),[`tripLogPersonalItemsDeliveredNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsDeliveredNotes')),[`tripLogDatetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture')),[`tripLogDriverNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDriverNotes')),[`isDriversLastRoute`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));

    } finally {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f688031722f3592022d7bbcc3244d86', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b2e4b5412462e4c667110ea3b6dae14', undefined);

    }
    if (typeStatus == 'Canceled') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', undefined);
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 10;
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed1f4d07d7f83667268b0502d493d46d')));
    } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 8 && (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) == true && (getObjectProperty(___arguments.context.pageData, 'stateSecFive')) != 'Submitted') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3ccbd473d89e46fb525ed84ef835804', undefined);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b3ccbd473d89e46fb525ed84ef835804')));
    } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 && (getObjectProperty(___arguments.context.pageData, 'stateSecFive')) != 'Submitted') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('681d6715b2c9c8ee9e076ea7d26489ce', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b5452c31c26bca5dcc586ea39131ec6', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00730aa40b93b9d6b33b45e794bcb5df', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9771cc9e0fb5e5a65b6ade558797a941', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f688031722f3592022d7bbcc3244d86', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7affc237bb3bb7c7e061146b3fa75009', undefined);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7affc237bb3bb7c7e061146b3fa75009')));
    }
    ___arguments.context.pageData['stateSecFive'] = 'Submitted';
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/d19a794fb7b9d194018f79fe1f4f8fb1/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff')) || !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d19a794fb7b9d194018f79fe1f4f8fb1'))['background'] = '#F6EC98';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d19a794fb7b9d194018f79fe1f4f8fb1'))['background'] = '#E5E5E5';
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9771cc9e0fb5e5a65b6ade558797a941', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d19a794fb7b9d194018f79fe1f4f8fb1', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/6b2e4b5412462e4c667110ea3b6dae14/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function isInputEmpty() {
  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture'))) {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered'))) {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsDeliveredNotes'))) {
    return true;
  } else {
    return false;
  }
}


  if (await isInputEmpty() == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6b2e4b5412462e4c667110ea3b6dae14'))['background'] = '#F6EC98';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6b2e4b5412462e4c667110ea3b6dae14'))['background'] = '#E5E5E5';
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f688031722f3592022d7bbcc3244d86', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b2e4b5412462e4c667110ea3b6dae14', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/6ab3241eb6681f87e3c3030d28f46f96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00730aa40b93b9d6b33b45e794bcb5df', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ab3241eb6681f87e3c3030d28f46f96', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function isInputEmpty() {
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == null) {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations'))) {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeMemberZipcode'))) {
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.SSN'))) {
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.typeInsurance'))) {
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.insuranceProvider'))) {
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.insurancePolicyNumber'))) {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == null) {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes'))) {
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture'))) {
    return true;
  } else {
    return false;
  }
}


  if (await isInputEmpty() == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ab3241eb6681f87e3c3030d28f46f96'))['background'] = '#F6EC98';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ab3241eb6681f87e3c3030d28f46f96'))['background'] = '#E5E5E5';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ab3241eb6681f87e3c3030d28f46f96'))

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/ff2ab48312c130c61476dd2d6eef2e34/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var typeStatus, error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 6;
  console.log('Counter = 6');
  try {
    transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = transaction;

      _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) })).setOpResultId('updateTransportStepSix');

    })();

    await transaction.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      });
    typeStatus = ((await Backendless.Data.of('transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),'\''].join(''))).setProperties('typeStatus').setPageSize(10))).map(item => item['typeStatus'])).join(',');

  } catch (error) {
    console.log(error);

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('044bb1f7d8a25fe1b96b7cbd5fc2b684', undefined);

  }
  if (typeStatus == 'Canceled') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', undefined);
    ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 10;
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed1f4d07d7f83667268b0502d493d46d')));
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d817c9c6cc5eb31edf711185451b99fc', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/d817c9c6cc5eb31edf711185451b99fc/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d817c9c6cc5eb31edf711185451b99fc', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d817c9c6cc5eb31edf711185451b99fc', true);
    ___arguments.context.pageData['stateSecFour'] = 'Submitted';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d817c9c6cc5eb31edf711185451b99fc', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/9771cc9e0fb5e5a65b6ade558797a941/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9771cc9e0fb5e5a65b6ade558797a941', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9771cc9e0fb5e5a65b6ade558797a941', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d19a794fb7b9d194018f79fe1f4f8fb1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9771cc9e0fb5e5a65b6ade558797a941', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d19a794fb7b9d194018f79fe1f4f8fb1', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/2f688031722f3592022d7bbcc3244d86/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f688031722f3592022d7bbcc3244d86', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 7) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f688031722f3592022d7bbcc3244d86', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b2e4b5412462e4c667110ea3b6dae14', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f688031722f3592022d7bbcc3244d86', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b2e4b5412462e4c667110ea3b6dae14', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/ec226a2d9a3bd11286bc266f7a598461/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 7) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec226a2d9a3bd11286bc266f7a598461', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 7) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec226a2d9a3bd11286bc266f7a598461', true);
    ___arguments.context.pageData['stateSecFive'] = 'Submitted';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec226a2d9a3bd11286bc266f7a598461', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/b3ccbd473d89e46fb525ed84ef835804/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 8) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3ccbd473d89e46fb525ed84ef835804', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) > 8 && (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3ccbd473d89e46fb525ed84ef835804', true);
    ___arguments.context.pageData['stateSecSix'] = 'Submitted';
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogTransportStatus')) == 'Complete' && (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3ccbd473d89e46fb525ed84ef835804', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3ccbd473d89e46fb525ed84ef835804', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/76b207b1fd33f3d4c976e2fae6e37017/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecSix'))) {
    return 'Save and Submit';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecSix')) == 'Error') {
    return 'Submit With Missing Data';
  } else if ((getObjectProperty(___arguments.context.pageData, 'stateSecSix')) == 'Submitted') {
    return 'Save Edits';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function isInputEmpty() {
  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay'))) {
    ___arguments.context.pageData['error.transportRecord.tripLogMileageEndOfDay'] = ['inputError'];
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay'))) {
    ___arguments.context.pageData['transportRecord.tripLogDatetimeEndOfRouteOrDay'] = ['inputError'];
    return true;
  } else {
    return false;
  }
}


  if (!(getObjectProperty(___arguments.context.pageData, 'stateSecSix')) && await isInputEmpty() == true) {
    ___arguments.context.pageData['stateSecSix'] = 'Error';
    return ;
  } else {
    console.log('Save the fields');
    if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 8) {
      ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 9;
      console.log('Counter = 9');
    }
    try {
      transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transaction;

        _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogMileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay')),[`tripLogDatetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay')),[`isDriversLastRoute`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) })).setOpResultId('updateTrnasportStepNine');

      })();

      await transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    } catch (error) {
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: 'An error occurred in the driver trip log flow' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Has Occurred in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogMileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay')),[`tripLogDatetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay')),[`isDriversLastRoute`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));

    } finally {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c64962290c66de3cd9b8c65ab26bfbce', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f99ee1ca91ccb054c6161df42d022951', undefined);

    }
    if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 && (getObjectProperty(___arguments.context.pageData, 'stateSecSix')) != 'Submitted') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('681d6715b2c9c8ee9e076ea7d26489ce', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b5452c31c26bca5dcc586ea39131ec6', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00730aa40b93b9d6b33b45e794bcb5df', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9771cc9e0fb5e5a65b6ade558797a941', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f688031722f3592022d7bbcc3244d86', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c64962290c66de3cd9b8c65ab26bfbce', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7affc237bb3bb7c7e061146b3fa75009', undefined);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7affc237bb3bb7c7e061146b3fa75009')));
    }
    ___arguments.context.pageData['stateSecSix'] = 'Submitted';
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/f99ee1ca91ccb054c6161df42d022951/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay')) || !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f99ee1ca91ccb054c6161df42d022951'))['background'] = '#F6EC98';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f99ee1ca91ccb054c6161df42d022951'))['background'] = '#E5E5E5';
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c64962290c66de3cd9b8c65ab26bfbce', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f99ee1ca91ccb054c6161df42d022951', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/7affc237bb3bb7c7e061146b3fa75009/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 && (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogTransportStatus')) != 'Complete') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7affc237bb3bb7c7e061146b3fa75009', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7affc237bb3bb7c7e061146b3fa75009', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/00b7a8531321d95ec938b444601a1529/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    var error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = transaction;

      ___arguments.context.pageData['transportRecord.tripLogSignatureFile'] = (await Backendless.Files.saveFile(encodePath('/Images/Signatures/Trip-Log'), (String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.submissionNumber')) + String('.png')), ___arguments['signature'], true));

    })();


  } catch (error) {
    console.log(error);

  } finally {
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogSignatureFile'));

  }

  },
  /* handler:onSaveSignatureClick */
  /* handler:saveSignatureButtonVisibilityLogic */
  ['saveSignatureButtonVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogSignatureFile')) ? true : false)

  },
  /* handler:saveSignatureButtonVisibilityLogic */
  /* handler:onClearClick */
  ['onClearClick'](___arguments) {
      ___arguments.context.pageData['transportRecord.tripLogSignatureFile'] = '';

  },
  /* handler:onClearClick */
  /* content */
}))

define('./pages/current-transport/components/0062b56bd89d616ff334fb58a079062c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'lastPage')), undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/059ae41cac37202da4a65af9f6e2600d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecOne')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('059ae41cac37202da4a65af9f6e2600d'))['border-bottom'] = '1px solid #D52941';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('059ae41cac37202da4a65af9f6e2600d'))['border-bottom'] = '';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('059ae41cac37202da4a65af9f6e2600d'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-transport/components/4419ae1de0c1e5eedc644fb2095b55fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('tel:') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupContactPhone'))), false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/6d2d798df5614b1e6059e2be801a6e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://www.google.com/maps/search/?api=1&query=') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupAddress'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/7a3a6e3d49c1c3f5232960c9a7a86b03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://www.google.com/maps/search/?api=1&query=') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationAddress'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/1026a83f94fc51b690232d5e3a837af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('tel:') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationContactPhone'))), false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/044bb1f7d8a25fe1b96b7cbd5fc2b684/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('044bb1f7d8a25fe1b96b7cbd5fc2b684', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('044bb1f7d8a25fe1b96b7cbd5fc2b684', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/26ff726e5f7f1461358165e8eeff8096/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'pageLoad.isDriversLastRoute')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/current-transport/components/7242c2dab1e2a80315cdbc2998e94543/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 8) {
    ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 7;
    ___arguments.context.pageData['transportRecord.tripLogDatetimeEndOfRouteOrDay'] = null;
    ___arguments.context.pageData['transportRecord.tripLogMileageEndOfDay'] = null;
    ___arguments.context.pageData['stateSecFive'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3ccbd473d89e46fb525ed84ef835804', false);
    console.log('Last Trip Logic Reverted');
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9 && ___arguments.value == false) {
    ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 7;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7affc237bb3bb7c7e061146b3fa75009', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3ccbd473d89e46fb525ed84ef835804', false);
    ___arguments.context.pageData['transportRecord.tripLogDatetimeEndOfRouteOrDay'] = null;
    ___arguments.context.pageData['transportRecord.tripLogMileageEndOfDay'] = null;
    ___arguments.context.pageData['stateSecFive'] = null;
    ___arguments.context.pageData['stateSecSix'] = null;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 9) {
    ___arguments.context.pageData['transportRecord.tripLogActiveStep'] = 8;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7affc237bb3bb7c7e061146b3fa75009', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3ccbd473d89e46fb525ed84ef835804', true);
    ___arguments.context.pageData['stateSecSix'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/current-transport/components/bae5fa03fffaa096b7a8e666c43a7fcb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['transportRecord.tripLogDatetimeEndOfRouteOrDay'] = (new Date());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/8d0e6a35b9c9aee555097223d852c6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transaction, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function finsMissingFields() {
  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7764fc4c2956fac86b85db5fb4b29d29')));
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7764fc4c2956fac86b85db5fb4b29d29')));
    return true;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b88615159ff744ce57262c3ce59c8a2c')));
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b88615159ff744ce57262c3ce59c8a2c')));
    return true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == null) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if (false) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if (false) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if (false) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if (false) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if (false) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if (false) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == null) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e52980766ea5f8a4596c2fc91b6f5eec')));
    return true;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d817c9c6cc5eb31edf711185451b99fc')));
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d817c9c6cc5eb31edf711185451b99fc')));
    return true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ec226a2d9a3bd11286bc266f7a598461')));
    return true;
  } else if (false) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ec226a2d9a3bd11286bc266f7a598461')));
    return true;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ec226a2d9a3bd11286bc266f7a598461')));
    return true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b3ccbd473d89e46fb525ed84ef835804')));
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')) == true && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b3ccbd473d89e46fb525ed84ef835804')));
    return true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogDriverCertified')) != true || !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogSignatureFile'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogDriverCertified')) != true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37261fc51ea888bbb99d9a1c87a9da63', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37261fc51ea888bbb99d9a1c87a9da63', false);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogSignatureFile'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b24d5059ac25d65a0c6fe8add9b1232', true);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('00b7a8531321d95ec938b444601a1529'))['border-bottom'] = '1px solid #D52941';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b24d5059ac25d65a0c6fe8add9b1232', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('00b7a8531321d95ec938b444601a1529'))['border-bottom'] = '';
    }
    return true;
  }
  return false
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if (await finsMissingFields() == true) {
    return ;
  } else {
    try {
      if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations')) == true) {
        ___arguments.context.pageData['transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations'] = ((await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('0445247c39560737186f1cb251718fd4')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(','));
      }
      transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = transaction;

        _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogTransportStatus`]: 'Complete',[`tripLogMilageStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart')),[`tripLogDatetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart')),[`tripLogDatetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup')),[`tripLogMileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup')),[`isTripLogPersonalItems`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')),[`tripLogPersonalItemsNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes')),[`tripLogDatetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture')),[`tripLogDatetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff')),[`tripLogMileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff')),[`isTripLogPersonalItemsDelivered`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered')),[`tripLogPersonalItemsDeliveredNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsDeliveredNotes')),[`tripLogDatetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture')),[`tripLogDriverNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDriverNotes')),[`isDriversLastRoute`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')),[`tripLogMileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay')),[`tripLogDatetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay')),[`tripLogSignatureFile`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogSignatureFile')) })).setOpResultId('updateTransportCompleteTrip');
        _uow.update('Client', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.objectId')),[`isFedRecognizedTribal`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')),[`tribeAffiliations`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations')),[`tribeMemberZipcode`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeMemberZipcode')),[`SSN`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.SSN')) })).setOpResultId('updateClientCompleteTrip');
        _uow.update('TransportRequest', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.objectId')),[`typeInsurance`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.typeInsurance')),[`insurancePolicyNumber`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.insurancePolicyNumber')) })).setOpResultId('updateTransportRequestCompleteTrip');

      })();

      await transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    } catch (error) {
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: 'An error occurred in the driver trip log flow' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Has Occurred in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`transport`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogTransportStatus`]: 'Complete',[`tripLogMilageStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart')),[`tripLogDatetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart')),[`tripLogDatetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup')),[`tripLogMileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup')),[`isTripLogPersonalItems`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')),[`tripLogPersonalItemsNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes')),[`tripLogDatetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture')),[`tripLogDatetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff')),[`tripLogMileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff')),[`isTripLogPersonalItemsDelivered`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered')),[`tripLogPersonalItemsDeliveredNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsDeliveredNotes')),[`tripLogDatetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture')),[`tripLogDriverNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDriverNotes')),[`isDriversLastRoute`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')),[`tripLogMileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay')),[`tripLogDatetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay')),[`tripLogSignatureFile`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogSignatureFile')) }),[`client`]: ({ [`isFedRecognizedTribal`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == 'Unknown' ? null : (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')),[`tribeAffiliations`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations')),[`tribeMemberZipcode`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeMemberZipcode')),[`SSN`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.SSN')) }),[`transportRequest`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.objectId')),[`typeInsurance`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.typeInsurance')),[`insurancePolicyNumber`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.insurancePolicyNumber')) }) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 5000 || 0));

    } finally {
      console.log('Trip Completed');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('current-rides', undefined);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/df45a28833ca016f0932d64fcbba4a86/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecOne')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/43097762e4e30d1262d7c8c597772cef/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecTwo')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/c81ffa55d79460bd681babd1ad1422e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeMemberZipcode'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/4cafa8be33817e1b11275e77377aa2ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.SSN'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/2292d805d80f7495511d4dbe8b6bca91/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.insurancePolicyNumber'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/24cca7dd4dcbd71c5f5407b85013145c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecTwo')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('24cca7dd4dcbd71c5f5407b85013145c'))['border-bottom'] = '1px solid #D52941';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('24cca7dd4dcbd71c5f5407b85013145c'))['border-bottom'] = '';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-transport/components/f3f8593c5983b07799fc421a3bad3209/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3f8593c5983b07799fc421a3bad3209'))['border-bottom'] = '1px solid #D52941';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3f8593c5983b07799fc421a3bad3209'))['border-bottom'] = '';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-transport/components/6ed9987222a45b0bc75d7b85f7167819/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ed9987222a45b0bc75d7b85f7167819'))['border-bottom'] = '1px solid #D52941';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ed9987222a45b0bc75d7b85f7167819'))['border-bottom'] = '';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-transport/components/acc5ac556e5555a56b331c1d526b83ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecFour')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/e39daacdc061a059d28f1f07d193048c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecSix')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/current-transport/components/5109b27d040f6e65b185722439484767/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecFour')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5109b27d040f6e65b185722439484767'))['border-bottom'] = '1px solid #D52941';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5109b27d040f6e65b185722439484767'))['border-bottom'] = '';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-transport/components/79a4f21630ef1a2d31374cbe690be588/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecFive')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsDeliveredNotes'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79a4f21630ef1a2d31374cbe690be588'))['border-bottom'] = '1px solid #D52941';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79a4f21630ef1a2d31374cbe690be588'))['border-bottom'] = '';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-transport/components/daf999f24bf8a458c5ad6c88d64f483b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecFive')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('daf999f24bf8a458c5ad6c88d64f483b'))['border-bottom'] = '1px solid #D52941';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('daf999f24bf8a458c5ad6c88d64f483b'))['border-bottom'] = '';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-transport/components/040ce26316ebf98d819667431323b818/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecSix')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('040ce26316ebf98d819667431323b818'))['border-bottom'] = '1px solid #D52941';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('040ce26316ebf98d819667431323b818'))['border-bottom'] = '';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/current-transport/components/4f930ac5f41faf784b25cae4bffc210a/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  ['onPointsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ [`lat`]: (Number((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.latitude')))),[`lng`]: (Number((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.longitude')))) }), ({ [`lat`]: (Number((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.latitude')))),[`lng`]: (Number((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.longitude')))) })]

  },
  /* handler:onPointsAssignment */
  /* handler:onMapCenterAssignment */
  ['onMapCenterAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`lat`]: ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.latitude')) + (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.latitude'))) / 2,[`lng`]: ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.longitude')) + (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.longitude'))) / 2 })

  },
  /* handler:onMapCenterAssignment */
  /* handler:onMapZoomAssignment */
  ['onMapZoomAssignment'](___arguments) {
    var markerDistance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  if ((roundDecimals((Math.abs((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.latitude')))),2)) > (roundDecimals((Math.abs((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.longitude')))),2))) {
    markerDistance = (roundDecimals((Math.abs((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.latitude')))),2));
  } else {
    markerDistance = (roundDecimals((Math.abs((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.longitude')))),2));
  }
  if (markerDistance <= 0.04) {
    return 13;
  } else if (markerDistance <= 0.09) {
    return 12;
  } else if (markerDistance <= 0.14) {
    return 11;
  } else if (markerDistance <= 0.3) {
    return 10;
  } else if (markerDistance <= 0.8) {
    return 9;
  } else if (markerDistance <= 1.6) {
    return 8;
  } else if (markerDistance <= 2.5) {
    return 7;
  } else {
    return 6;
  }

  },
  /* handler:onMapZoomAssignment */
  /* handler:onMarkerClick */
  ['onMarkerClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.point, 'lat')) == (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.latitude'))) {
    (function (componentUid, marker, popupContent) { ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('4f930ac5f41faf784b25cae4bffc210a', ___arguments.point, (['<p><strong>PICKUP: </strong>',(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relPickup_Facility.googleName')),'</p> <p><a href="https://www.google.com/maps/search/?api=1&query=',(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupAddress')),'">',(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupAddress')),'</a></p> <p>&nbsp;</p>'].join('')));
  } else {
    (function (componentUid, marker, popupContent) { ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('4f930ac5f41faf784b25cae4bffc210a', ___arguments.point, (['<p><strong>DROPOFF: </strong>',(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.googleName')),'</p> <p><a href="https://www.google.com/maps/search/?api=1&query=',(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationAddress')),'">',(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationAddress')),'</a></p> <p>&nbsp;</p>'].join('')));
  }

  },
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/current-transport/components/9789fb4c8d445749cfc1cc7a40310744/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d6b55da444ce5dbddead1f62f6621dd1');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/current-transport/components/285be911015d7e3f9d6360bbf728c522/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('d6b55da444ce5dbddead1f62f6621dd1');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/56f3f129b0658d15ffa45eb226b2ee28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/6aae14cdd012318c231e45abcffbf577/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Report Has Been Submitted in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: (String('An Error Report Has Been Submitted: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9789fb4c8d445749cfc1cc7a40310744'), 'errorNotes'))) }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Report Has Been Submitted in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`transport`]: ({ [`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogTransportStatus`]: 'Complete',[`tripLogMilageStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMilageStart')),[`tripLogDatetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualStart')),[`tripLogDatetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickup')),[`tripLogMileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup')),[`isTripLogPersonalItems`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItems')),[`tripLogPersonalItemsNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsNotes')),[`tripLogDatetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualPickupDeparture')),[`tripLogDatetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoff')),[`tripLogMileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageDropoff')),[`isTripLogPersonalItemsDelivered`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isTripLogPersonalItemsDelivered')),[`tripLogPersonalItemsDeliveredNotes`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogPersonalItemsDeliveredNotes')),[`tripLogDatetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeActualDropoffDeparture')),[`isDriversLastRoute`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.isDriversLastRoute')),[`tripLogMileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileageEndOfDay')),[`tripLogDatetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogDatetimeEndOfRouteOrDay')),[`tripLogSignatureFile`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogSignatureFile')) }),[`client`]: ({ [`isFedRecognizedTribal`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')) == 'Unknown' ? null : (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.isFedRecognizedTribal')),[`tribeAffiliations`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations')),[`tribeMemberZipcode`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeMemberZipcode')),[`SSN`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.SSN')) }),[`transportRequest`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.objectId')),[`typeInsurance`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.typeInsurance')),[`insurancePolicyNumber`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.insurancePolicyNumber')) }) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/0445247c39560737186f1cb251718fd4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'tribeAffiliationOptions'))

  },
  /* handler:optionsLogic */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'stateSecThree')) != null && !(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations'))) {
    return ['inputError'];
  } else {
    return ;
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Multi Select Value');
  console.log(JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('0445247c39560737186f1cb251718fd4')).map(item => item['value']))));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.tribeAffiliations'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/current-transport/components/d80e9881fdf5b6569934fe498e9bc0aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var phoneNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  phoneNumber = String(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee.phone'));

  return ([(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee.nameFull')),' - ','(800) 690-4305'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/1337feda6a15b906acb94378c1b6df85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('tel:') + String('8006904305')), false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/ed1f4d07d7f83667268b0502d493d46d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')) == 10 && (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogTransportStatus')) != 'Complete') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed1f4d07d7f83667268b0502d493d46d', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/current-transport/components/7327f3198af69d2cabab6d5299d82c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if (!(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d97f5575db1a1a33d8d8ef59bd25e50b', true);
    ___arguments.context.pageData['error.inputMileageCancelation'] = ['inputError'];
    return ;
  }
  try {
    transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = transaction;

      _uow.update('Transport', ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.objectId')),[`tripLogActiveStep`]: 9,[`tripLogTransportStatus`]: 'Complete',[`tripLogMileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup')) })).setOpResultId('updateTransportCancelRide');

    })();

    await transaction.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      });

  } catch (error) {
    console.log(error);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2493adea59b8abac0ea3db0dca68e92b');
    ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the Driver-Trip-Log', new Backendless.Bodyparts({ textmessage: 'An error occurred in the driver trip log flow' }), ensureArray('jamesk@davidrobertsconsulting.com, bradd@alphadesign.us'), ensureArray((await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/trip-log-errors', error, (String('An Error Has Occurred in the Driver-Trip-Log - tripLogActiveStep = ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep'))), 'Changes attempting to be saved in this step', ({ [`tripLogActiveStep`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogActiveStep')),[`tripLogTransportStatus`]: 'Complete',[`tripLogMileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'transportRecord.tripLogMileagePickup')) }), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))).filter(item => !!item)));
    await new Promise(r => setTimeout(r, 5000 || 0));

  } finally {
    console.log('Trip Completed');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('current-rides', undefined);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/current-transport/components/00b276c2b0c5baaa9282670dd683dc65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'lastPage')) == 'current-rides') {
    return 'Back to Current Rides';
  } else if ((getObjectProperty(___arguments.context.pageData, 'lastPage')) == 'past-rides') {
    return 'Back to Past Rides';
  } else {
    return 'Back to All Rides';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/f5875ff8d54467397fee90c243d978f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Transport Code: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.transportCode_copy')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/91b6e19c4c472a31e67c6af2eedda827/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Pickup - ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.pickupLocationName')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/e8918b7f3726e56ee7a934b39966a7a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Dropoff - ') + String(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.destinationLocationName')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/current-transport/components/2ff96c166635d894bde2dd6117bae6d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var phoneNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  phoneNumber = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.followUpContactPhone'));

  return (['A confirmation call is required after this client is dropped off.   Please contact ',(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.followUpContactName')) ? (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.followUpContactName')) : '[Unknown Contact Name]',' at ',phoneNumber ? ['(',phoneNumber.slice(0, 3),') ',phoneNumber.slice(3, 6),'-',phoneNumber.slice(6, 10)].join('') : '[Unknown Contact Phone Number]',' after the transport is complete.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      console.log('%c>> ' + 'App Data', 'color: #f06292', ___arguments.context.appData);

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      console.log('%c>> 🔒 ' + 'App Data', 'color: #3f51b5', JSON.parse(JSON.stringify(___arguments.context.appData)));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/data-migration-tool/components/ec7c9c98e0fccf79fb26144fd168916f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['tableName'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/data-migration-tool/components/4b4562419bfe2f4ff90c95b764e11df9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'tableName')) || (getObjectProperty(___arguments.context.pageData, 'loading')) || (getObjectProperty(___arguments.context.pageData, 'showSecondTableField')) && !(getObjectProperty(___arguments.context.pageData, 'secondTableName')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, secondFieldOptions, secondFieldRelationMap, firstFieldRelationMap, firstFieldOptions, secondTableSchema, tableSchema, fields, item, j, relColumnId, tableSchemaForFirstField, tableData, pageSize, offset, records, count, depth, relationSchema, i, schema;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function createRelationsMap(schema, depth) {
  if (depth >= 4) {
    return ;
  }
  for (var j_index2 in schema) {
    j = schema[j_index2];
    if ((getObjectProperty(j, 'type')) == 'RELATION') {
      if (!(getObjectProperty(secondFieldRelationMap, (getObjectProperty(j, 'name'))))) {
        secondFieldRelationMap[(getObjectProperty(j, 'name'))] = ({ [`tableName`]: (getObjectProperty(j, 'relatedTable')),[`options`]: [] });
        relationSchema = (await Backendless.Data.describe( (getObjectProperty(j, 'relatedTable')) ));
        var i_list = (await asyncListSort((await Backendless.Data.describe( (getObjectProperty(j, 'relatedTable')) )), 1, async (item) => {


         return (getObjectProperty(item, 'name'));
        }));
        for (var i_index in i_list) {
          i = i_list[i_index];
          addItemToList((getObjectProperty((getObjectProperty(secondFieldRelationMap, (getObjectProperty(j, 'name')))), 'options')), ({ [`value`]: (getObjectProperty(i, 'name')),[`label`]: (getObjectProperty(i, 'name')) }));
        }
      }
      console.log('%c>> ' + 'NAME', 'color: #ab47bc', (getObjectProperty(j, 'name')));
      await createRelationsMap(relationSchema, depth + 1);
    }
  }
}


  try {
    ___arguments.context.pageData['loading'] = true;
    ___arguments.context.pageData['loadData'] = false;
    tableSchema = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.pageData, 'tableName')) ));
    console.log('%c>> ' + 'Schema', 'color: #f06292', tableSchema);
    ___arguments.context.pageData['tableScema'] = tableSchema;
    if (tableSchema.length > 0) {
      firstFieldRelationMap = ({  });
      secondFieldRelationMap = ({  });
      if (getObjectProperty(___arguments.context.pageData, 'secondTableName')) {
        secondTableSchema = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.pageData, 'secondTableName')) ));
        if (secondTableSchema.length > 0) {
          tableSchemaForFirstField = secondTableSchema;
        }
      } else {
        tableSchemaForFirstField = tableSchema;
      }
      secondFieldOptions = (await asyncListSort((await Promise.all(tableSchemaForFirstField.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });}))), 1, async (item) => {


       return (getObjectProperty(item, 'label'));
      }));
      await createRelationsMap(tableSchemaForFirstField, 1);
      firstFieldOptions = (await asyncListSort((await Promise.all(tableSchemaForFirstField.map(async item => {  if ((getObjectProperty(item, 'type')) == 'RELATION') {
          firstFieldRelationMap[(getObjectProperty(item, 'name'))] = [];
          console.log(await Backendless.Data.describe( (getObjectProperty(item, 'relatedTable')) ));
          var j_list = (await asyncListSort((await Backendless.Data.describe( (getObjectProperty(item, 'relatedTable')) )), 1, async (item) => {


           return (getObjectProperty(item, 'name'));
          }));
          for (var j_index in j_list) {
            j = j_list[j_index];
            addItemToList((getObjectProperty(firstFieldRelationMap, (getObjectProperty(item, 'name')))), ({ [`value`]: (getObjectProperty(j, 'name')),[`label`]: (getObjectProperty(j, 'name')) }));
          }
        }
      ; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });}))), 1, async (item) => {


       return (getObjectProperty(item, 'label'));
      }));
      console.log('%c>> ' + 'RELATIONS MAp', 'color: #26a69a', secondFieldRelationMap);
      ___arguments.context.pageData['tableSchema'] = tableSchema;
      ___arguments.context.pageData['secondTableSchema'] = secondTableSchema;
      ___arguments.context.pageData['firstFieldOptions'] = firstFieldOptions;
      ___arguments.context.pageData['firstFieldRelationMap'] = firstFieldRelationMap;
      ___arguments.context.pageData['secondFieldRelationMap'] = secondFieldRelationMap;
      ___arguments.context.pageData['secondFieldOptions'] = secondFieldOptions;
      ___arguments.context.pageData['loadData'] = true;
    }
    ___arguments.context.pageData['showInput'] = false;
    ___arguments.context.pageData['inputValue'] = null;
    ___arguments.context.pageData['firstField'] = null;
    ___arguments.context.pageData['firstFieldHasRelation'] = false;
    ___arguments.context.pageData['firstFieldRelation'] = undefined;
    ___arguments.context.pageData['secondField'] = null;
    ___arguments.context.pageData['firstFieldRelationOptions'] = [];
    ___arguments.context.pageData['secondFieldRelationOptions'] = [];
    ___arguments.context.pageData['secondFieldHasRelation'] = false;
    ___arguments.context.pageData['targetTable'] = null;
    ___arguments.context.pageData['targetFieldHasSecondRelation'] = false;
    ___arguments.context.pageData['targetFieldSecondRelationOptions'] = [];
    ___arguments.context.pageData['targetFieldSecondRelation'] = undefined;
    ___arguments.context.pageData['targetFieldThirdRelation'] = undefined;
    console.log('%c>> 🔒 ' + 'PAGE DATA', 'color: #ab47bc', JSON.parse(JSON.stringify(___arguments.context.pageData)));

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);
    ___arguments.context.pageData['showInput'] = false;
    ___arguments.context.pageData['inputValue'] = null;
    ___arguments.context.pageData['firstField'] = null;
    ___arguments.context.pageData['firstFieldHasRelation'] = false;
    ___arguments.context.pageData['firstFieldRelation'] = undefined;
    ___arguments.context.pageData['secondField'] = null;
    ___arguments.context.pageData['firstFieldRelationOptions'] = [];
    ___arguments.context.pageData['secondFieldRelationOptions'] = [];
    ___arguments.context.pageData['secondFieldHasRelation'] = false;
    ___arguments.context.pageData['targetTable'] = null;
    ___arguments.context.pageData['targetFieldHasSecondRelation'] = false;
    ___arguments.context.pageData['targetFieldSecondRelationOptions'] = [];
    ___arguments.context.pageData['targetFieldSecondRelation'] = undefined;
    ___arguments.context.pageData['targetFieldThirdRelation'] = undefined;

  } finally {
    ___arguments.context.pageData['loading'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'loading')) ? 'Loading...' : 'Load Data')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/0052de31ede30a8e4371615c8f640197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['whereClause'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;
  ___arguments.context.pageData['showInput'] = false;
  ___arguments.context.pageData['inputValue'] = null;
  ___arguments.context.pageData['firstField'] = null;
  ___arguments.context.pageData['firstFieldHasRelation'] = false;
  ___arguments.context.pageData['firstFieldRelation'] = undefined;
  ___arguments.context.pageData['secondField'] = null;
  ___arguments.context.pageData['firstFieldRelationOptions'] = [];
  ___arguments.context.pageData['secondFieldRelationOptions'] = [];
  ___arguments.context.pageData['secondFieldHasRelation'] = false;
  ___arguments.context.pageData['targetTable'] = null;
  ___arguments.context.pageData['targetFieldHasSecondRelation'] = false;
  ___arguments.context.pageData['targetFieldSecondRelationOptions'] = [];
  ___arguments.context.pageData['targetFieldSecondRelation'] = undefined;
  ___arguments.context.pageData['targetFieldThirdRelation'] = undefined;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/data-migration-tool/components/f95a0fe712cd378cb25969bb12a25ff2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loadData'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/cbdac03b8153d0efba4d7a75e8f1db53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'firstFieldOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['firstField'] = ___arguments.value;
  console.log('%c>> ' + 'RelationOptions', 'color: #4caf50', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value)));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value)) {
    ___arguments.context.pageData['firstFieldRelationOptions'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationMap')), ___arguments.value));
    ___arguments.context.pageData['firstFieldHasRelation'] = true;
  } else {
    ___arguments.context.pageData['firstFieldHasRelation'] = false;
    ___arguments.context.pageData['firstFieldRelationOptions'] = [];
    ___arguments.context.pageData['firstFieldRelation'] = undefined;
  }
  console.log('%c>> ' + 'CHANGED VALUE', 'color: #26a69a', ___arguments.value);

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBusy'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/630be754a69d98f3610e65ff6516e899/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'secondFieldOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['secondField'] = ___arguments.value;
  console.log('%c>> ' + 'test', 'color: #42a5f5', (getObjectProperty(___arguments.context.pageData, 'secondFieldRelationMap')));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'secondFieldRelationMap')), ___arguments.value)) {
    ___arguments.context.pageData['secondFieldRelationOptions'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'secondFieldRelationMap')), ___arguments.value)), 'options'));
    ___arguments.context.pageData['targetTable'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'secondFieldRelationMap')), ___arguments.value)), 'tableName'));
    ___arguments.context.pageData['secondFieldHasRelation'] = true;
  } else {
    ___arguments.context.pageData['secondFieldHasRelation'] = false;
    ___arguments.context.pageData['secondFieldRelationOptions'] = [];
    ___arguments.context.pageData['targetTable'] = null;
    ___arguments.context.pageData['targetFieldHasSecondRelation'] = false;
    ___arguments.context.pageData['targetFieldSecondRelationOptions'] = [];
    ___arguments.context.pageData['targetFieldSecondRelation'] = undefined;
    ___arguments.context.pageData['targetFieldThirdRelation'] = undefined;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBusy'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/c3975a83fa12ee888f9452f7853bbbdb/bundle.js', [], () => ({
  /* content */
  /* handler:tableNameLogic */
  ['tableNameLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')) ? (getObjectProperty(___arguments.context.pageData, 'tableName')) : null)

  },
  /* handler:tableNameLogic */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:onDisplayAssignment */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    var columns, item, columnNames;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  columns = [];
  if (getObjectProperty(___arguments.context.pageData, 'tableSchema')) {
    if (((getObjectProperty(___arguments.context.pageData, 'firstField')) || (getObjectProperty(___arguments.context.pageData, 'showInput'))) && (getObjectProperty(___arguments.context.pageData, 'secondField'))) {
      columnNames = [({ [`name`]: 'objectId' }), ({ [`name`]: 'created' }), ({ [`name`]: 'updated' })];
      if (!(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && !(getObjectProperty(___arguments.context.pageData, 'showInput'))) {
        addItemToList(columnNames, ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'tableSchema')), async (item) => {


         return ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')));
        }))[0]));
      }
      addItemToList(columnNames, ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'tableSchema')), async (item) => {


       return ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'secondField')));
      }))[0]));
      columns = (await Promise.all(columnNames.map(async item => {  console.log(getObjectProperty(item, 'name'));
      ; return ({ [`field`]: !(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'secondField')) && (getObjectProperty(___arguments.context.pageData, 'secondFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation')) ? ((getObjectProperty(___arguments.context.pageData, 'targetFieldHasSecondRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation')),'.',(getObjectProperty(___arguments.context.pageData, 'targetFieldThirdRelation'))].join('') : [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation'))].join('')) : (getObjectProperty(item, 'name'))),[`headerName`]: !(getObjectProperty(___arguments.context.pageData, 'secondTableSchema')) && (getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'firstField')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'firstFieldRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'secondField')) && (getObjectProperty(___arguments.context.pageData, 'secondFieldHasRelation')) && (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation')) ? ((getObjectProperty(___arguments.context.pageData, 'targetFieldHasSecondRelation')) ? [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation')),'.',(getObjectProperty(___arguments.context.pageData, 'targetFieldThirdRelation'))].join('') : [(getObjectProperty(item, 'name')),'.',(getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation'))].join('')) : (getObjectProperty(item, 'name'))),[`flex`]: 1 });})));
    } else {
      columns = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'tableSchema')).map(async item => {; return ({ [`field`]: (getObjectProperty(item, 'name')),[`headerName`]: (getObjectProperty(item, 'name')),[`flex`]: 1 });})));
    }
    columns = (await (async function(columns) {
    	const columnTypes = {
    	  "datetimeColumn": {
    	    "sortable"          : true,
    	    "width"             : 180,
    	    "type"              : "datetimeColumn",
    	    "cellRendererParams": {
    	      "dayjsFormat": "MM/DD/YYYY HH:mm:ss",
    	      "withSeconds": true
    	      },
    	  },
    	}

    	return columns.map(column => {
    	  if (column.field === 'created' || column.field === 'updated') {
    	    return { ...column, ...columnTypes.datetimeColumn }
    	  }

    	  return column
    	})
    })(columns));
    console.log('%c>> ' + 'ColDefs', 'color: #f06292', columns);
  }
  console.log('%c>> ' + 'COLUMNS', 'color: #26a69a', columns);

  return columns

  },
  /* handler:columnDefsLogic */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
      return (await (async function(pageData) {
	return {
	  where: pageData.loadData ? pageData.whereClause : '',
	  relationsDepth: 2
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/data-migration-tool/components/89ca2a827828ee538c24bb3ce0aa2eb3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'firstField')) && !(getObjectProperty(___arguments.context.pageData, 'showInput')) || !(getObjectProperty(___arguments.context.pageData, 'secondField')) || (getObjectProperty(___arguments.context.pageData, 'isBusy')) || (getObjectProperty(___arguments.context.pageData, 'secondFieldHasRelation')) && !(getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation')) || (getObjectProperty(___arguments.context.pageData, 'targetFieldHasSecondRelation')) && !(getObjectProperty(___arguments.context.pageData, 'targetFieldThirdRelation')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, message, result, transactionLimit, batchIndex, copyDataTx, j, batchesToProcess, updatedRecords, pageSize, offset, item, tableData, firstFieldValue, records, updatedRecordsBatch, changes, value, firstFieldName, secondFieldName, recordToChange, fieldName, requiredFields, count, testObj;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  ___arguments.context.pageData['isBusy'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('0be22fe4f87510dbb34497a84e14d7e1');
  updatedRecords = [];
  try {
    count = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'tableName'))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'whereClause')))));
    pageSize = 100;
    offset = 0;
    tableData = [];
    while (offset < count) {
      records = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'tableName'))).find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'whereClause')) ? String(getObjectProperty(___arguments.context.pageData, 'whereClause')) + String(' AND migrated = false') : 'migrated = false')).setRelationsDepth(2).setPageSize(pageSize).setOffset(offset)));
      updatedRecordsBatch = [];
      console.log('%c>> ' + 'RECORDS', 'color: #3f51b5', records);
      requiredFields = (await Promise.all((await asyncListFilter((await Backendless.Data.describe( ((getObjectProperty(___arguments.context.pageData, 'secondFieldHasRelation')) ? (getObjectProperty(___arguments.context.pageData, 'targetTable')) : (getObjectProperty(___arguments.context.pageData, 'tableName'))) )), async (item) => {


       return (getObjectProperty(item, 'required'));
      })).map(async item => {; return (getObjectProperty(item, 'name'));})));
      console.log('%c>> ' + 'Required', 'color: #26a69a', requiredFields);
      for (var j_index in records) {
        j = records[j_index];
        changes = ({  });
        value = null;
        if (getObjectProperty(___arguments.context.pageData, 'showInput')) {
          value = (await (async function(value) {
          	return value !== undefined
          })((getObjectProperty(___arguments.context.pageData, 'inputValue')))) ? (getObjectProperty(___arguments.context.pageData, 'inputValue')) : null;
        } else {
          firstFieldName = (getObjectProperty(___arguments.context.pageData, 'firstField'));
          if (getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) {
            firstFieldName = [(getObjectProperty(___arguments.context.pageData, 'firstField')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('');
          }
          value = (await (async function(value) {
          	return value !== undefined
          })((getObjectProperty(j, firstFieldName)))) ? (getObjectProperty(j, firstFieldName)) : null;
        }
        recordToChange = j;
        secondFieldName = (getObjectProperty(___arguments.context.pageData, 'secondField'));
        console.log('%c>> ' + 'recordToChange', 'color: #4caf50', recordToChange);
        if (getObjectProperty(___arguments.context.pageData, 'secondFieldHasRelation')) {
          console.log('%c>> ' + 'FIRST!', 'color: #ffee58', (getObjectProperty(j, (getObjectProperty(___arguments.context.pageData, 'secondField')))));
          if ((getObjectProperty(j, (getObjectProperty(___arguments.context.pageData, 'secondField')))) !== null && !Array.isArray((getObjectProperty(j, (getObjectProperty(___arguments.context.pageData, 'secondField'))))) && (typeof (getObjectProperty(j, (getObjectProperty(___arguments.context.pageData, 'secondField')))) === 'object')) {
            recordToChange = (getObjectProperty(j, (getObjectProperty(___arguments.context.pageData, 'secondField'))));
            secondFieldName = (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation'));
            if (getObjectProperty(___arguments.context.pageData, 'targetFieldHasSecondRelation')) {
              console.log('%c>> ' + 'SECOND!', 'color: #f06292', (getObjectProperty(recordToChange, (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation')))));
              if ((getObjectProperty(recordToChange, (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation')))) !== null && !Array.isArray((getObjectProperty(recordToChange, (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation'))))) && (typeof (getObjectProperty(recordToChange, (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation')))) === 'object')) {
                recordToChange = (getObjectProperty(recordToChange, (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelation'))));
                secondFieldName = (getObjectProperty(___arguments.context.pageData, 'targetFieldThirdRelation'));
                changes['objectId'] = (getObjectProperty(recordToChange, 'objectId'));
                changes[secondFieldName] = value;
                for (var fieldName_index in requiredFields) {
                  fieldName = requiredFields[fieldName_index];
                  changes[fieldName] = (getObjectProperty(recordToChange, fieldName));
                }
                addItemToList(updatedRecordsBatch, changes);
              }
            } else {
              changes['objectId'] = (getObjectProperty(recordToChange, 'objectId'));
              changes[secondFieldName] = value;
              for (var fieldName_index2 in requiredFields) {
                fieldName = requiredFields[fieldName_index2];
                changes[fieldName] = (getObjectProperty(recordToChange, fieldName));
              }
              addItemToList(updatedRecordsBatch, changes);
            }
          }
        } else {
          changes['objectId'] = (getObjectProperty(recordToChange, 'objectId'));
          changes[secondFieldName] = value;
          changes['migrated'] = true;
          for (var fieldName_index3 in requiredFields) {
            fieldName = requiredFields[fieldName_index3];
            changes[fieldName] = (getObjectProperty(recordToChange, fieldName));
          }
          addItemToList(updatedRecordsBatch, changes);
        }
        console.log('%c>> ' + 'CHANGES!!!!!!!!!!!', 'color: #4caf50', changes);
      }
      console.log('%c>> ' + 'UPDATED', 'color: #42a5f5', updatedRecordsBatch);
      if (updatedRecordsBatch.length > 0) {
        addItemToList(updatedRecords, [updatedRecordsBatch]);
      }
      offset = offset + pageSize;
    }

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);
    ___arguments.context.pageData['isBusy'] = false;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0be22fe4f87510dbb34497a84e14d7e1');
    return ;

  }
  try {
    batchIndex = 0;
    transactionLimit = 15;
    while (batchIndex < updatedRecords.length) {
      batchesToProcess = updatedRecords.slice(((batchIndex + 1) - 1), batchIndex + transactionLimit);
      copyDataTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      for (var j_index2 in batchesToProcess) {
        j = batchesToProcess[j_index2];
        await ( async () => {
          const _uow = copyDataTx;

          _uow.bulkUpsert(((getObjectProperty(___arguments.context.pageData, 'secondFieldHasRelation')) ? (getObjectProperty(___arguments.context.pageData, 'targetTable')) : (getObjectProperty(___arguments.context.pageData, 'tableName'))), j).setOpResultId((String('CopyData: ') + String(generateUUID().short())));

        })();

      }
      result = (await copyDataTx.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      batchIndex = batchIndex + transactionLimit;
    }
    if (result && (getObjectProperty(result, 'success'))) {
      message = (getObjectProperty(___arguments.context.pageData, 'showInput')) ? ['Value "',(getObjectProperty(___arguments.context.pageData, 'inputValue')),'" has been successfully copied to field "',(getObjectProperty(___arguments.context.pageData, 'secondField')),'".'].join('') : ['Data has been successfully copied from field "',(getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')) ? [(getObjectProperty(___arguments.context.pageData, 'firstField')),'.',(getObjectProperty(___arguments.context.pageData, 'firstFieldRelation'))].join('') : (getObjectProperty(___arguments.context.pageData, 'firstField')),'" to field "',(getObjectProperty(___arguments.context.pageData, 'secondField')),'".'].join('');
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('c3975a83fa12ee888f9452f7853bbbdb');
      await new Promise(r => setTimeout(r, 2000 || 0));
      console.log('%c>> ' + 'BULK UPDATE', 'color: #f06292', (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'tableName'))).bulkUpdate( 'objectId != null', ({ [`migrated`]: false }) )));
      (function (message) { alert(message) })(message);
    } else {
      (function (message) { alert(message) })('No records were migrated.');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);

  } finally {
    ___arguments.context.pageData['isBusy'] = false;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0be22fe4f87510dbb34497a84e14d7e1');

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isBusy')) ? 'Copying..' : 'Copy Data')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/2a0fd867dcaf54bb04678ecda7cc9eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/e0e5fd28d8086e07c74e47d7adbef80a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'firstFieldRelationOptions')) ? (getObjectProperty(___arguments.context.pageData, 'firstFieldRelationOptions')) : [])

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['firstFieldRelation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isBusy')) || !(getObjectProperty(___arguments.context.pageData, 'firstFieldHasRelation')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/fb5de794ea719d2858b505a96f057a81/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showInput'] = ___arguments.value;
  ___arguments.context.pageData['firstField'] = null;
  if (!___arguments.value) {
    ___arguments.context.pageData['inputValue'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/data-migration-tool/components/11f7c908b5c5714f3f234f47c7715016/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['inputValue'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/data-migration-tool/components/fcd569ae593c2f4204f777053a56c0e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showInput')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/20849406cd997d7d5c01ed9895782b35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showSecondTableField'] = ___arguments.value;
  ___arguments.context.pageData['firstField'] = null;
  ___arguments.context.pageData['secondField'] = null;
  if (!___arguments.value) {
    ___arguments.context.pageData['secondTableName'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/data-migration-tool/components/067a6c36c848e622a39375817f09469b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['secondTableName'] = ___arguments.value;
  ___arguments.context.pageData['loadData'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/data-migration-tool/components/449720ef993809e27118c1fc797642b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tableName')) && (getObjectProperty(___arguments.context.pageData, 'loadData')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/1245c15889035c434b7d1063f023e61b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'secondFieldRelationOptions')) ? (getObjectProperty(___arguments.context.pageData, 'secondFieldRelationOptions')) : [])

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['targetFieldSecondRelation'] = ___arguments.value;
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'secondFieldRelationMap')), ___arguments.value)) {
    ___arguments.context.pageData['targetFieldSecondRelationOptions'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'secondFieldRelationMap')), ___arguments.value)), 'options'));
    ___arguments.context.pageData['targetTable'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'secondFieldRelationMap')), ___arguments.value)), 'tableName'));
    ___arguments.context.pageData['targetFieldHasSecondRelation'] = true;
  } else {
    ___arguments.context.pageData['targetFieldHasSecondRelation'] = false;
    ___arguments.context.pageData['targetFieldSecondRelationOptions'] = [];
    ___arguments.context.pageData['targetTable'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'secondFieldRelationMap')), (getObjectProperty(___arguments.context.pageData, 'secondField')))), 'tableName'));
    ___arguments.context.pageData['targetFieldThirdRelation'] = undefined;
  }
  console.log('%c>> ' + 'PageData', 'color: #26a69a', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'secondFieldHasRelation')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/data-migration-tool/components/79e5caed84247b730c64b1d8275c3494/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['targetFieldThirdRelation'] = ___arguments.value;
  console.log('%c>> ' + 'PageData', 'color: #26a69a', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelationOptions')) ? (getObjectProperty(___arguments.context.pageData, 'targetFieldSecondRelationOptions')) : [])

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'targetFieldHasSecondRelation')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/davidTestPage/components/29ba5a3dea1868a18ad411835658601a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['driverStatus'] = (await Backendless.Request.get(`${Backendless.appPath}/services/driverVehicleAwareness/DriverAvailability`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1909ed1d2fc3a3332c47e05e274a9747', (getObjectProperty(___arguments.context.pageData, 'driverStatus')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/davidTestPage/components/099e2a44af6b7ae957b53bd6628c0c7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['driverData'] = (await Backendless.Request.post(`${Backendless.appPath}/services/samsaraAPI/fetchAllDriverVehicleAssignments`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ab0fc42873b62abc88ad73a3f62a04a6', (getObjectProperty(___arguments.context.pageData, 'driverData')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/davidTestPage/components/50c9d663d7d508874c4d64bd1cf1e80d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aa020ea92fc6cf01227523dfdc2b52fa', (await Backendless.Request.post(`${Backendless.appPath}/services/samsaraAPI/fetchVehicleStats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/directory/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'User Directory',[`pageName`]: 'directory' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/directory/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      console.log(___arguments.context.appData);

  return (await (async function(appData, pageData) {
	return [
	  {"type":"actions", "field": "actions", "headerName": "", "width": 80, "minWidth": 80, "pinned": "left", meta: { align: "center"}},

	  {
	    "field": "nameFull",
	    "headerName": "Name",
	    "sort": "asc",
	    "sortable": true,
	    "flex": 1
	  },

	  {
	    "field": "jobTitle",
	    "headerName":"Job Title",
	    "sortable": true,
	    "flex": 1,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5
	  },
	  {"field": "relEmail_Users.email", "headerName":"Email", "sortable": true, "flex": 1},
	  {"field": "phone", "headerName":"Phone", "sortable": true, "flex": 1},
	  {"field": "standardHours", "headerName":"Normal Hours", "sortable": true, "flex": 1},
	  {"field": "city", "headerName":"Location", "sortable": true, "flex": 1},
	  {
	    "field": "samsaraDriverId",
	    "headerName":"Samsara Driver ID",
	    "sortable": true,
	    "flex": 1,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5
	  }
	]
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  ['onActionIconClick'](___arguments) {
      if (___arguments['eventName'] == 'viewProfile') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile', ({ [`selectedUser`]: ___arguments['recordItem'],[`viewAnotherUser`]: true }));
  }
  console.log(___arguments['recordItem']);

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/download-trip-logs/components/49ab9f9a0195f7abe879992b176e7524/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.pageData['startTime'] = ((new Date(___arguments.value)).toISOString());
  console.log((await (async function(timestamp) {

  	    const date = new Date(timestamp);
  	    return date.toISOString().replace(/\.\d{3}Z$/, "Z");
  })(___arguments.prevValue)));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/download-trip-logs/components/17da5fec86916dd80afcea1aff3aa0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'startTime')) && (getObjectProperty(___arguments.context.pageData, 'endTime')) && !(getObjectProperty(___arguments.context.pageData, 'loading'))))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, zipURL, pdfs, uploadedURL, i, date, url, documents;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['loading'] = true;
    documents = (await Backendless.Request.get(`${Backendless.appPath}/services/SamsaraAPIs/documents`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'startTime': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'startTime'))),'endTime': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'endTime'))) }).send());
    pdfs = [];
    date = ((new Date()).toLocaleDateString());
    console.log('%c>> ' + 'docs', 'color: #f06292', documents);
    for (var i_index in documents) {
      i = documents[i_index];
      if (i) {
        console.log('%c>> ' + 'documentId', 'color: #42a5f5', (getObjectProperty(i, 'id')));
        url = (await Backendless.Request.get(`${Backendless.appPath}/services/SamsaraAPIs/create-pdf`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'documentId': JSON.stringify((getObjectProperty(i, 'id'))) }).send());
        console.log('%c>> ' + 'pdf', 'color: #4caf50', url);
        uploadedURL = (await Backendless.Files.upload(
            url,
            encodePath((['trip-logs-tmp/',date,'/',(getObjectProperty(i, 'id')),'/'].join(''))),
            true
          ).then(result => result.fileURL));
        console.log('%c>> ' + 'uploaded', 'color: #ab47bc', uploadedURL);
        addItemToList(pdfs, uploadedURL);
      }
    }
    if (pdfs.length > 0) {
      zipURL = (await (async function(urls, zipName) {
      	async function createAndUploadZip(pdfUrls, zipName) {
      	    const JSZip = await BackendlessUI.requireModule('https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js');
      	    const zip = new JSZip();

      	    for (let i = 0; i < pdfUrls.length; i++) {
      	        const url = pdfUrls[i];
      	        try {
      	            const response = await fetch(url);
      	            const blob = await response.blob();

      	            const originalName = url.split('/').pop()?.split('?')[0] || `document.pdf`;
      	            const timestamp = Date.now();
      	            const fileName = `${originalName.replace(/\.pdf$/, '')}_${timestamp}.pdf`;

      	            zip.file(fileName, blob);
      	            console.log(`✅ Added: ${fileName}`);
      	        } catch (error) {
      	            console.error(`❌ Error ${url}:`, error);
      	        }
      	    }

      	    const zipBlob = await zip.generateAsync({ type: "blob" });
      	    const zipFile = new File([zipBlob], `${zipName}.zip`, { type: "application/zip" });

      	    const uploadedFile = await Backendless.Files.upload(zipFile, "/zipped-files/", true);
      	    console.log("✅  uploaded", uploadedFile.fileURL);

      	    return uploadedFile.fileURL;
      	}


      	return await createAndUploadZip(urls, zipName)
      })(pdfs, ([(getObjectProperty(___arguments.context.pageData, 'startTime')),'-',(getObjectProperty(___arguments.context.pageData, 'endTime'))].join(''))));
      console.log('%c>> ' + 'ZIP URL', 'color: #26c6da', zipURL);
      await (async function(url) {
      	    const a = document.createElement("a");
      	    a.href = url;
      	    a.download = url.split('/').pop(); // Оставляем имя файла из URL
      	    document.body.appendChild(a);
      	    a.click();
      	    document.body.removeChild(a);
      })(zipURL);
      await new Promise(r => setTimeout(r, 1000 || 0));
      await Backendless.Files.removeDirectory(encodePath('trip-logs-tmp'));
      await Backendless.Files.removeDirectory(encodePath('zipped-files'));
    }

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['loading'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/download-trip-logs/components/5c15d4b2ff361c46c0cecafdfa6ee657/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.pageData['endTime'] = ((new Date(___arguments.value)).toISOString());
  console.log((await (async function(timestamp) {

  	    const date = new Date(timestamp);
  	    return date.toISOString().replace(/\.\d{3}Z$/, "Z");
  })(___arguments.value)));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/download-trip-logs/components/7b9fb7832c83288bdacba0cdd12af64b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loading'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/driver-dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('App Data');
  console.log(___arguments.context.appData);
  console.log('Current user object id');
  console.log(getObjectProperty(___arguments.context.appData, 'currentUser.objectId'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/driver-dashboard/components/f9bc669952cbbe373e177014abbea5db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('current-rides', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/driver-dashboard/components/894a06171d7689accd79e994510661c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('past-rides', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/export-id-cleanup-tool/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['toggle'] = false;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/export-id-cleanup-tool/components/11cec25fb6280e48bd896565a57cbbcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    data = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((['exportId = \'',(getObjectProperty(___arguments.context.pageData, 'exportId')),'\''].join(''))).setPageSize(100)));
    console.log(data);
    data = (await (async function(obj) {
    	for (const t in obj) {
    	  obj[t].notesBilling = null;
    	  obj[t].hasBillingExportError = null;
    	  obj[t].billingExportBatchId = null;
    	  obj[t].exportId = null;
    	  obj[t].billing213ClaimId = null;
    	  obj[t].typeAdjudicationStatus = null;
    	}
    	return obj;
    })(data));
    console.log(data);
    console.log((await Backendless.Data.of('Transport').bulkUpsert( data )));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/export-id-cleanup-tool/components/67cf910e3e077b176f73f9b9f39b7e97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log(getObjectProperty(___arguments.context.pageData, 'toggle'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('30a7c4a2a112c663099b8d988d68b738');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/export-id-cleanup-tool/components/83cdb57cc075383316ed0c6151ada2ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ID;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ID = (await Backendless.Data.of('').find(Backendless.DataQueryBuilder.create().setPageSize(10)));
  ___arguments.context.pageData['samsaraVehicle'] = (getObjectProperty(ID, 'samsaraVehicleId'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/export-id-cleanup-tool/components/ad68e29895588648cc8148c800887518/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['toggle'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facilities/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'landing' }), ({ [`label`]: 'Facilities',[`pageName`]: 'facilities' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/facilities/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData) {
	return [
	  {
	    "type": "actions",
	    "field": "actions",
	    "headerName": "",
	    "width": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8 ? 105 : 75,
	    "minWidth": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8 ? 105 : 75,
	    "pinned": "left",
	    "meta": { align: "center"},
	    "checkboxSelection": true,
	    "headerCheckboxSelection": true,
	  },

	  {
	    "field": "googleName",
	    "headerName": "Name",
	    "sort": "asc",
	    "sortable": true,
	    "width": 250,
	    "pinned": "left",
	    //"cellClass": params => params.data.phoneMain === '42' ? 'ag-cell-highlighted-green' : '', // TODO: remove me
	  },

	  {"field": "googleFormattedAddress", "headerName":"Address", "sortable": true, "width": 400, "editable": false},
	  {"field": "isPrivateResidence", "headerName":"Pivate Residence?", "sortable": true, "width": 100, "editable": false},
	  {"field": "phoneMain", "headerName":"Main Phone", "sortable": true, "width": 110},
	  {"field": "phoneNurse", "headerName":"Nurse Phone", "sortable": true, "width": 110},
	  {"field": "phoneIntake", "headerName":"Intake Phone", "sortable": true, "width": 110},
	  //{"field": "relZipcode_OkrcRegionLookup.okrcRegion", "headerName":"Region", "sortable": true, "width": 100, "editable": false},
	  {
	    "field": "notesPickup",
	    "headerName":"Pickup Notes",
	    "sortable": true,
	    "width": 400,
	    "wrapText": true,
	    "autoHeight": true,
	    "type": "largeTextColumn",
	    "cellEditorParams": {
	      "maxLength": 2000,
	      "rows": 5,
	      "cols": 50,
	    }
	  },
	  {
	    "field": "notesDropoff",
	    "headerName":"Dropoff Notes",
	    "sortable": true,
	    "width": 400,
	    "wrapText": true,
	    "autoHeight": true,
	    "type": "largeTextColumn",
	    "cellEditorParams": {
	      "maxLength": 2000,
	      "rows": 5,
	      "cols": 50,
	    }
	  },
	  {"field": "created", "headerName":"Created", "sortable": true, "width": 180, "type": "datetimeColumn",
	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true }}
	  /*{
	    "field": "zipcode",
	    "headerName": "Test Select",
	    "flex": 1,
	    "cellEditorParams": { "values": pageData.testDictionary||[] }
	  },
	  */
	]
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'changeAddress') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
    // If the change address action is clicked then we show
    // the form to update the facility address and pass the
    // chosen item record over into the form's data container.
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088'))['facilityRecord'] = ___arguments['recordItem'];
  } else if (___arguments['eventName'] == 'delete') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null && waitCount <= 200) {
      await new Promise(r => setTimeout(r, 100 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Delete operation timed out after 30s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      await Backendless.Data.of('Facility').remove( ___arguments['recordItem'] );
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'showTransportRequests') {
    console.log('%c>> ' + 'recordItem', 'color: #f06292', ___arguments['recordItem']);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-requests', ({ [`strWhereClauseBase`]: ['(relPickup_Facility.objectId = \'',(getObjectProperty(___arguments['recordItem'], 'objectId')),'\'',' OR ','relDestination_Facility.objectId = \'',(getObjectProperty(___arguments['recordItem'], 'objectId')),'\')'].join('') }));
  }

  },
  /* handler:onActionIconClick */
  /* handler:actionsIconsLogic */
  async ['actionsIconsLogic'](___arguments) {
      return (await (async function(appData) {
	return appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8
	? [
	   {"eventName": "delete", "icon": "delete_forever", "className": "delete-icon", "title": "Delete Facility" },
	   {"eventName": "changeAddress", "icon": "pin_drop", "className": "changeAddress", "title": "Change Address"},
	   {"eventName": "showTransportRequests", "icon": "list", "className": "showTransportRequests", "title": "Show Transport Requests" },
	  ]
	: [
	    {"eventName": "changeAddress","icon": "pin_drop", "className": "changeAddress", "title": "Change Address" },
	    {"eventName": "showTransportRequests", "icon": "list", "className": "showTransportRequests", "title": "Show Transport Requests" },
	  ]
})(___arguments.context.appData))

  },
  /* handler:actionsIconsLogic */
  /* handler:cellClassLogicHandler */
  ['cellClassLogicHandler'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (___arguments['columnName'] == 'googleName' && (getObjectProperty(___arguments['rowData'], 'phoneMain')) == '42' ? 'ag-cell-highlighted' : null)

  },
  /* handler:cellClassLogicHandler */
  /* handler:rowClassLogicHandler */
  ['rowClassLogicHandler'](___arguments) {
    
  },
  /* handler:rowClassLogicHandler */
  /* content */
}))

define('./pages/facilities/components/45bee23a419ff7c9e93a5842096578f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  // Initialize the newFacility object if it doesn't already exist.
  // This avoids undefined errors if someone hops to the address lookup.
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f0b47b283a4ee883d73e9f978666c0f9')), 'newFacility'))) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f0b47b283a4ee883d73e9f978666c0f9'))['newFacility'] = ({  });
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facilities/components/b5df55495a24508cde61454d1f936b87/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var nearbyExistingFacilities;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'errors.googleFormattedAddress')) {
    delete (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'errors'))['googleFormattedAddress'];
  }
  ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['showSpinner'] = true;
  await BackendlessUI.Functions.Custom['fn_137d340f119a283f5c3768d727019038']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility')), ['name', 'notesDropoff', 'notesPickup', 'phoneIntake', 'phoneMain', 'phoneNurse']);
  ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['facilityAddressMessage'] = null;
  ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['showNewFacilityMessage'] = false;
  ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['showExectMatchFacilityMessage'] = false;
  ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['locationType'] = 'newFacility';
  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility')));
  if (___arguments.value && (await BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility'))))) {
    nearbyExistingFacilities = (await BackendlessUI.Functions.Custom['fn_353440ef7fa2e9257227e5c5351d9062']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility')), ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')));
    console.log(JSON.stringify(nearbyExistingFacilities));
    ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['nearbyExistingFacilities'] = nearbyExistingFacilities;
    ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['selectedNearbyExistingFacility'] = ((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'nearbyExistingFacilities')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'nearbyExistingFacilities'))[0] : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'nearbyExistingFacilities')));
    if (Array.isArray(nearbyExistingFacilities)) {
      if (nearbyExistingFacilities.length >= 1) {
        ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['showSelectExistingFacilityModal'] = true;
      } else {
        ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['showNewFacilityMessage'] = true;
        ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['facilityAddressMessage'] = 'This address will be added to our Facility database.';
      }
    } else {
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility')));
      Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'selectedNearbyExistingFacility')));
      ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['facilityAddressMessage'] = 'We found an exact match to this facility in our records.';
    }
  }
  ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['showSpinner'] = false;
  console.log(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'));

  },
  /* handler:onChange */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('b5df55495a24508cde61454d1f936b87', undefined, ({ [`country`]: 'us' }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facilities/components/f0b47b283a4ee883d73e9f978666c0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Save the new facility into the Facility table and put
  // the returned objectId into the newFacility object
  (getObjectProperty(___arguments.context.dataModel, 'newFacility'))['objectId'] = (getObjectProperty((await Backendless.Data.of('Facility').save( (getObjectProperty(___arguments.context.dataModel, 'newFacility')) )), 'objectId'));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/facilities/components/4c44230b6b5983a3743bfdf3e943e3a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var errors;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  errors = ({  });
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility.city')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility.stateCode')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['googleFormattedAddress'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    // Need to put this here since the submit button for the form is
    // set to default to avoid the 'submit on enter key press' issue.
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('f0b47b283a4ee883d73e9f978666c0f9');
  } else {
    ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')['errors'] = errors;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility.objectId'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility.objectId')) ? 'This Facility already exists in our database.' : '')

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/facilities/components/9ec5c52d7fa4ba838d0cdea8a1291ee3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facilities/components/87350f9abd387e213ce27961eb166986/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facilities/components/46868346d41eb8e9a1f7c20627239776/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var errors;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  errors = ({  });
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'facilityRecord.city')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'facilityRecord.stateCode')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'facilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    errors['googleFormattedAddress'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('00af44ca02488116c8749b36734af088');
  } else {
    ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['errors'] = errors;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'selectedNearbyExistingFacility'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/facilities/components/ad746135a58df2e756b14f1fbca20e94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var nearbyExistingFacilities;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'errors.googleFormattedAddress')) {
    delete (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'errors'))['googleFormattedAddress'];
  }
  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'facilityRecord')));
  ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['locationType'] = 'updateFacility';
  ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['facilityAddressMessage'] = null;
  ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['selectedNearbyExistingFacility'] = null;
  if (___arguments.value && (await BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'facilityRecord'))))) {
    nearbyExistingFacilities = (await BackendlessUI.Functions.Custom['fn_353440ef7fa2e9257227e5c5351d9062']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'facilityRecord')), ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')));
    ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['nearbyExistingFacilities'] = nearbyExistingFacilities;
    ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['selectedNearbyExistingFacility'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'nearbyExistingFacilities'))[0]);
    if (nearbyExistingFacilities.length == 1) {
      ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['facilityAddressMessage'] = 'We found an exact match to this facility in our records.';
    } else if (nearbyExistingFacilities.length > 1) {
      ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['showSelectExistingFacilityModal'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')['facilityAddressMessage'] = 'This address will be added to our Facility database.';
    }
  }

  },
  /* handler:onChange */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('ad746135a58df2e756b14f1fbca20e94', undefined, ({ [`country`]: 'us' }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facilities/components/00af44ca02488116c8749b36734af088/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Facility').save( (getObjectProperty(___arguments.context.dataModel, 'facilityRecord')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);
  await new Promise(r => setTimeout(r, 5000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/facilities/components/a5bd36dd116f46b49f03aaecf7e57d51/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/facilities/components/eeb1ca5eba47c6bd8363490ec36215fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility')) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility'))['phoneMain'] = ___arguments['unmaskedValue'];
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/facilities/components/25ebd76f022a5f7a1924385419aacfbe/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility')) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility'))['phoneNurse'] = ___arguments['unmaskedValue'];
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/facilities/components/182bded5d9cc1b29804600c84235ff18/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility')) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newFacility'))['phoneIntake'] = ___arguments['unmaskedValue'];
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/facilities/components/61aed15cacd3cb9b005908649c947915/bundle.js', [], () => ({
  /* content */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'showSelectExistingFacilityModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2bca3fcbfcf61fd799e8885f6b51eeb1'](___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'));

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/facilities/components/7daf98bb29d4ed7e609701b9013576f3/bundle.js', [], () => ({
  /* content */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'showSelectExistingFacilityModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2bca3fcbfcf61fd799e8885f6b51eeb1'](___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'));

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/facilities/components/9595b7b8b05b45625cb661c4c7f641c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/facilities/components/121c98da5b89824ab1eb5345eb1edb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/facilities/components/0056aa9f461b30edbc4cfa88256ffcfb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'facilityAddressMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'facilityAddressMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facilities/components/cd13bf1db076bb198c68a533c477140f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'facilityAddressMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'facilityAddressMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facilities/components/04616b7646a76df8438f6be134e37684/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, maxRelations, preferredRecord, duplicate, count, pageSize, offset, countDestination, countPickUp, selectedRows, transportRequestsToUpdate, operationsLimit;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedRows = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5ace80b8ec397e9c5c0b03221b61217d'));
  operationsLimit = 6;
  if (selectedRows.length > operationsLimit) {
    (function (message) { alert(message) })((['We are unable to merge more than ',operationsLimit,' records in a single operation. Please choose up to ',operationsLimit,' records, merge those, and then merge the remainder in a second step.'].join('')));
    return ;
  }
  (getObjectProperty(___arguments.context.pageData, 'mergeFacilitiesData'))['selectedFacilities'] = selectedRows;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('5cdc6f6e0fb26aa83582c1b9f1d36838');
  transportRequestsToUpdate = [];
  try {
    (getObjectProperty(___arguments.context.pageData, 'mergeFacilitiesData'))['loading'] = true;
    (getObjectProperty(___arguments.context.pageData, 'mergeFacilitiesData'))['loadingMessage'] = 'Loading, please wait...';
    maxRelations = 0;
    preferredRecord = null;
    for (var duplicate_index in selectedRows) {
      duplicate = selectedRows[duplicate_index];
      countPickUp = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['relDestination_Facility.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join('')))));
      countDestination = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['relDestination_Facility.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join('')))));
      count = countPickUp + countDestination;
      offset = 0;
      pageSize = 100;
      if (count > maxRelations) {
        maxRelations = count;
        preferredRecord = duplicate;
      }
    }
    (getObjectProperty(___arguments.context.pageData, 'mergeFacilitiesData'))['preferredRecord'] = preferredRecord;
    (getObjectProperty(___arguments.context.pageData, 'mergeFacilitiesData'))['maxRelations'] = maxRelations;

  } catch (error) {
    console.log(error);
    return ;

  } finally {
    (getObjectProperty(___arguments.context.pageData, 'mergeFacilitiesData'))['loading'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facilities/components/b207998a5cb6b6374c662e376dd1fb33/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacilities')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacilities')) : []).map(async item => {  label = ['Formatted Location: ',(getObjectProperty(item, 'formattedLocation')),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','Latitude: ',(getObjectProperty(item, 'latitude')),', ','Longitude: ',(getObjectProperty(item, 'longitude')),', ','Google Place ID: ',(getObjectProperty(item, 'googlePlaceId')),', ','Object ID: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889')['selectedFacility'] = ___arguments['value'];
  console.log(___arguments['value']);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facilities/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    var selectedRows;


  ___arguments.context.pageData['mergeFacilitiesData'] = ({  });
  ___arguments.context.pageData['hardMergeFacilitiesData'] = ({  });

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/facilities/components/4c71b3e5041d363171c2bfd7da1f28d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, duplicatesToRemove, message, result, removeDuplicatesTx, whereClauseDuplicates, duplicatesToRemoveMap, j, transportRequestsToUpdate, pageSize, offset, transportRequest, transportRequests, duplicate, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  console.log('MERGE:');
  ___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889')['mergeFacilitiesError'] = false;
  duplicatesToRemove = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacilities')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacility.objectId')) != (getObjectProperty(item, 'objectId')));
  }));
  console.log('ToRemove:');
  console.log(duplicatesToRemove);
  duplicatesToRemoveMap = ({  });
  whereClauseDuplicates = '';
  for (var duplicate_index in duplicatesToRemove) {
    duplicate = duplicatesToRemove[duplicate_index];
    if (!(getObjectProperty(duplicatesToRemoveMap, (getObjectProperty(duplicate, 'objectId'))))) {
      duplicatesToRemoveMap[(getObjectProperty(duplicate, 'objectId'))] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacility'));
    }
    if (whereClauseDuplicates != '') {
      whereClauseDuplicates = String(whereClauseDuplicates) + String(' OR ');
    }
    whereClauseDuplicates = String(whereClauseDuplicates) + String(['objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join(''));
  }
  console.log('ToRemoveMap:');
  console.log(duplicatesToRemoveMap);
  console.log(whereClauseDuplicates);
  transportRequestsToUpdate = [];
  try {
    ___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889')['loading'] = true;
    ___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889')['loadingMessage'] = 'Merging Facilities, please wait...';
    for (var duplicate_index2 in duplicatesToRemove) {
      duplicate = duplicatesToRemove[duplicate_index2];
      count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['relPickup_Facility.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\'',' OR ','relDestination_Facility.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join('')))));
      offset = 0;
      pageSize = 100;
      while (offset < count) {
        transportRequests = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['relPickup_Facility.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\'',' OR ','relDestination_Facility.objectId = \'',(getObjectProperty(duplicate, 'objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
        for (var transportRequest_index in transportRequests) {
          transportRequest = transportRequests[transportRequest_index];
          addItemToList(transportRequestsToUpdate, transportRequest);
        }
        offset = offset + pageSize;
      }
    }
    transportRequestsToUpdate = (await (async function(arr) {
    	const seen = new Set()


    	return arr.filter(item => {
    	  const isDuplicate = seen.has(item.objectId)

    	  seen.add(item.objectId)

    	  return !isDuplicate
    	})

    })(transportRequestsToUpdate));
    console.log('TransportRequestsToUpdate:');
    console.log(transportRequestsToUpdate);

  } catch (error) {
    console.log(error);
    ___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889')['loading'] = false;
    return ;

  }
  try {
    console.log(transportRequestsToUpdate.length);
    removeDuplicatesTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    if (transportRequestsToUpdate.length > 0) {
      for (var j_index in transportRequestsToUpdate) {
        j = transportRequestsToUpdate[j_index];
        if (getObjectProperty(duplicatesToRemoveMap, (getObjectProperty(j, 'relPickup_Facility.objectId')))) {
          console.log('pickUp:Add');
          console.log(j);
          await ( async () => {
            const _uow = removeDuplicatesTx;

            _uow.setRelation('TransportRequest', j, 'relPickup_Facility', (getObjectProperty(duplicatesToRemoveMap, (getObjectProperty(j, 'relPickup_Facility.objectId'))))).setOpResultId((String('TransportRequestsSetRelationPickUpFacility: ') + String(getObjectProperty(j, 'objectId'))));

          })();

        }
        if (getObjectProperty(duplicatesToRemoveMap, (getObjectProperty(j, 'relDestination_Facility.objectId')))) {
          console.log('Destination:Add');
          console.log(j);
          await ( async () => {
            const _uow = removeDuplicatesTx;

            _uow.setRelation('TransportRequest', j, 'relDestination_Facility', (getObjectProperty(duplicatesToRemoveMap, (getObjectProperty(j, 'relDestination_Facility.objectId'))))).setOpResultId((String('TransportRequestsSetRelationDestinationFacility: ') + String(getObjectProperty(j, 'objectId'))));

          })();

        }
      }
    }
    await ( async () => {
      const _uow = removeDuplicatesTx;

      _uow.bulkDelete('Facility', whereClauseDuplicates).setOpResultId('FacilityDeleteDuplicates');

    })();

    console.log('RUN:');
    result = (await removeDuplicatesTx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));
    console.log(result);
    if (getObjectProperty(result, 'success')) {
      message = [(getObjectProperty(result, 'results.FacilityDeleteDuplicates.result')),' records have been deleted from the Facility table table, and ',(Object.keys((getObjectProperty(result, 'results')))).length - 1,' relations have been updated in the TransportRequest table.'].join('');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).deselectRows() })('5ace80b8ec397e9c5c0b03221b61217d');
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5cdc6f6e0fb26aa83582c1b9f1d36838');
      (function (message) { alert(message) })(message);
      await (getChannelInstance('default')).send((String('reload-table-records:') + String('Facility')), ({ [`ids`]: (await Promise.all(duplicatesToRemove.map(async item => {; return (getObjectProperty(item, 'objectId'));}))) }));
    }

  } catch (error) {
    console.log(error);
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'preferredRecord')) {
      ___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889')['mergeFacilitiesError'] = true;
    }
    ___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889')['loading'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'loading')) || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacility')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacilities')).length > 1))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/facilities/components/9435db21552db035f454f1bf544c8a66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['mergeFacilitiesData'] = ({  });
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5cdc6f6e0fb26aa83582c1b9f1d36838');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facilities/components/5cdc6f6e0fb26aa83582c1b9f1d36838/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['mergeFacilitiesData'] = ({  });

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/facilities/components/8c49ffdcbe3dd30c5e165a6cf63d533c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facilities/components/7b89830c8c9eabe26d152aac9ed1634b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'preferredRecord')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'maxRelations')) > 1 ? ['For the best results, please consider choosing the record with objectId: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'preferredRecord.objectId')),'. This record has the most references (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'maxRelations')),'), making it the optimal choice for merging.'].join('') : '')

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'preferredRecord')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'maxRelations')) > 1 && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facilities/components/a746d6ccd411957c224f64519efd73eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedRows;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'Selected', 'color: #f06292', (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5ace80b8ec397e9c5c0b03221b61217d')));
  selectedRows = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5ace80b8ec397e9c5c0b03221b61217d'));
  if (selectedRows.length < 2) {
    (function (message) { alert(message) })('Please select two records that need to be merged.');
    return ;
  }
  if (selectedRows.length > 2) {
    (function (message) { alert(message) })('Please select only two records that need to be merged.');
    return ;
  }
  (getObjectProperty(___arguments.context.pageData, 'hardMergeFacilitiesData'))['selectedFacilities'] = selectedRows;
  console.log('%c>> ' + '333', 'color: #f06292', ___arguments.context.pageData);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('913737f4867aebaac88b7e9fabf8fff2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facilities/components/e28451f329c2752bd16ffd328e7b4f6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacilities')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6a516535e916ec44027159112f1d7889'), 'selectedFacilities')).length > 0 ? 'Please choose the facility to use as the main record. The remaining duplicates will be removed.' : 'Please select the facilities in the table that you would like to merge')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facilities/components/913737f4867aebaac88b7e9fabf8fff2/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['hardMergeFacilitiesData'] = ({  });

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/facilities/components/4b29f4813dd3fa4ec34c1c521a7b96b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'hardMergeFacilitiesData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/facilities/components/0c1af01e5f7e6fbb26e372db486ab81c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'hardMergeFacilitiesData.loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facilities/components/4d46dd179c461a28e80dfe5673913cea/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5'), 'selectedFacilities')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5'), 'selectedFacilities')) : []).map(async item => {  label = ['Formatted Location: ',(getObjectProperty(item, 'formattedLocation')),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','Latitude: ',(getObjectProperty(item, 'latitude')),', ','Longitude: ',(getObjectProperty(item, 'longitude')),', ','Google Place ID: ',(getObjectProperty(item, 'googlePlaceId')),', ','Object ID: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5')['selectedFacility'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facilities/components/6e53c171e21f670db07d4b51a6a7a6ba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'hardMergeFacilitiesData.loading'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facilities/components/4834b6bbdddbbc1b7f8a991eb58802f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, originId, duplicateId, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  console.log('MERGE:');
  originId = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5'), 'selectedFacility.objectId'));
  duplicateId = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5'), 'selectedFacilities')), async (item) => {


   return (originId != (getObjectProperty(item, 'objectId')));
  })), 'objectId'));
  console.log('%c>> ' + 'origin', 'color: #f06292', originId);
  console.log('%c>> ' + 'duplicate', 'color: #ffee58', duplicateId);
  try {
    ___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5')['loading'] = true;
    ___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5')['loadingMessage'] = 'Merging Facilities, please wait...';
    if ((await BackendlessUI.Functions.Custom['fn_85a179468c6dd16157c81f324fd775ca'](originId, duplicateId))) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).deselectRows() })('5ace80b8ec397e9c5c0b03221b61217d');
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('913737f4867aebaac88b7e9fabf8fff2');
      (function (message) { alert(message) })('Merge successful! The selected facility has been set as the main record, and the duplicate has been removed.');
      await (getChannelInstance('default')).send((String('reload-table-records:') + String('Facility')), ({ [`ids`]: [originId] }));
    }

  } catch (error) {
    console.log(error);
    ___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5')['loading'] = false;
    return ;

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5'), 'loading')) || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5'), 'selectedFacility')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b29f4813dd3fa4ec34c1c521a7b96b5'), 'selectedFacilities')).length == 2))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/facilities/components/72cc257e83fe0f13a30368a7c81980ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['hardMergeFacilitiesData'] = ({  });
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('913737f4867aebaac88b7e9fabf8fff2');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'hardMergeFacilitiesData.loading'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/facilities/components/6a516535e916ec44027159112f1d7889/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'data', 'color: null', (getObjectProperty(___arguments.context.pageData, 'mergeFacilitiesData')));

  return (getObjectProperty(___arguments.context.pageData, 'mergeFacilitiesData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/feedback/components/adf5ca7555bb8b911c3928870da48383/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
      return (['Give us your feedback or suggestions!','\n\n','If you found a bug, please provide as much information as you can about the issue.  What did you observe?  Where did you encounter the bug?  What were you doing when it was encountered?  Can you reproduce the issue?  Did you receive any error message or warnings? '].join(''))

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/feedback/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      // Create a blank object to hold the values input in the form.
  ___arguments.context.dataModel['feedbackRecord'] = ({ [`category`]: undefined,[`title`]: undefined,[`description`]: undefined,[`fileUpload`]: undefined });

  },
  /* handler:onBeforeMount */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  console.log(JSON.parse((JSON.stringify(___arguments.context.dataModel))));
  console.log([subsequenceFromStartLast((getObjectProperty(___arguments.context.dataModel, 'feedbackRecord.fileUpload')), (((getObjectProperty(___arguments.context.dataModel, 'feedbackRecord.fileUpload')).indexOf('/Images') + 1) - 1))]);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fea7bd71964ac0c82cea059ece9506f6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('808c3b9aee9cd67f0208172efd31e23f', undefined);
  try {
    await Backendless.Data.of('feedback').save( (getObjectProperty(___arguments.context.dataModel, 'feedbackRecord')) );
    ___arguments.context.dataModel['messageResponse'] = (await Backendless.Messaging.sendEmailFromTemplate('Feedback Notification', Backendless.EmailEnvelope.create({ addresses: ['jamesk@davidrobertsconsulting.com'], ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`category`]: (getObjectProperty(___arguments.context.dataModel, 'feedbackRecord.category')),[`title`]: (getObjectProperty(___arguments.context.dataModel, 'feedbackRecord.title')),[`description`]: (getObjectProperty(___arguments.context.dataModel, 'feedbackRecord.description')),[`submitterName`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')),[`submitterEmail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), [subsequenceFromStartLast((getObjectProperty(___arguments.context.dataModel, 'feedbackRecord.fileUpload')), (((getObjectProperty(___arguments.context.dataModel, 'feedbackRecord.fileUpload')).indexOf('/Images') + 1) - 1))]));
    await new Promise(r => setTimeout(r, 10000 || 0));
    console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.dataModel, 'messageResponse.messageId'))));
    (function (message) { alert(message) })('Thank you for your feedback!');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('feedback', undefined);

  } catch (error) {
    console.log(error);
    return ;

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('808c3b9aee9cd67f0208172efd31e23f', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fea7bd71964ac0c82cea059ece9506f6', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('83595415548c44c8f3ec7e5ca0da84c6');

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/feedback/components/83595415548c44c8f3ec7e5ca0da84c6/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.uploadedFiles);
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'feedbackRecord'))['fileUpload'] = ___arguments.uploadedFiles;

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.file, 'name')).replace((new RegExp('[^a-zA-Z0-9]', 'g')), '-'))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/feedback/components/3aad0ffca40bdc679d9fcda97dcf4849/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // Need to put this here since the submit button for the form is
  // set to default to avoid the 'submit on enter key press' issue.
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('fea7bd71964ac0c82cea059ece9506f6');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/feedback/components/a4899d0f896b8e7a444c222637076051/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Feedback',[`pageName`]: 'feedback' })]

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/logged-in/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
  }
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if (!currentUser) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    // This prevents the redirect to the landing page in the event
    // of a nonexistent user coming to this page without logging in
    return ;
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  (getObjectProperty(___arguments.context.appData, 'currentUser'))['rideCareUserAttributes'] = (await BackendlessUI.Functions.Custom['fn_839edc5af7af51fbdc87a427321d61a1']((await Backendless.UserService.getUserRoles())));
  console.log('Role:');
  console.log(getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.role'));
  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.role')) == 'Driver') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('driver-dashboard', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('welcome', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/login/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var buttonLogin, emloyeeData, employeeRecord, error, logging, password, redirectData, redirectToPageName, redirectToUrl, sendUserTokenAndId, stayLoggedIn, user, username;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, stayLoggedIn  ));

  } catch (error) {
    await setError(error);

  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}

/**
 * Describe this function...
 */
async function isUserEmployed(emloyeeData) {
  return (getObjectProperty(emloyeeData, 'employmentStatus')) == 'Employed'
}


  redirectToUrl = (getObjectProperty(___arguments.context.pageData, 'redirectToUrl'));
  redirectToPageName = (getObjectProperty(___arguments.context.pageData, 'redirectToPageName'));
  redirectData = (getObjectProperty(___arguments.context.pageData, 'redirectData'));
  sendUserTokenAndId = (getObjectProperty(___arguments.context.pageData, 'sendUserTokenAndId'));
  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    employeeRecord = (await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause((['relEmail_Users.objectId = \'',(getObjectProperty(user, 'objectId')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.appData['profileImage'] = (getObjectProperty(employeeRecord, 'profileImage'));
    ___arguments.context.appData['currentUserProfileImage'] = (getObjectProperty(employeeRecord, 'profileImage'));
    if (!await isUserEmployed(employeeRecord)) {
      (function (message) { alert(message) })('We were unable to log you in.  Please contact your manager for assistance. (el001)');
      await Backendless.UserService.logout();
      user = null;
      return ;
    }
    ___arguments.context.appData['currentUser'] = user;
    (getObjectProperty(___arguments.context.appData, 'currentUser'))['rideCareUserAttributes'] = (await BackendlessUI.Functions.Custom['fn_839edc5af7af51fbdc87a427321d61a1']((await Backendless.UserService.getUserRoles())));
    if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.role')) == 'Driver') {
      redirectToPageName = 'driver-dashboard';
    }
    if (redirectToUrl) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(redirectToUrl, false, (sendUserTokenAndId ? ({ [`userToken`]: (getObjectProperty(user, 'user-token')),[`userId`]: (getObjectProperty(user, 'objectId')),[`stayLoggedIn`]: stayLoggedIn }) : ''));
    } else if (redirectToPageName) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectToPageName, (redirectData ? (JSON.parse(redirectData)) : null));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('logged-in', undefined);
    }
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var redirectData, redirectToPageName, currentUser, sendUserTokenAndId, redirectToUrl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // This block checks for a flag called 'clearAllData'
  // that is assigned at the time of a LogOut request.
  // If it is present then we clear all the relevant data
  // containers for the application to ensure complete logout.
  if ((getObjectProperty(___arguments.context.appData, 'clearAllData')) == true) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234'](___arguments.context.appData);
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234'](___arguments.context.layoutData);
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234'](___arguments.context.pageData);
  }
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : ((await Backendless.UserService.isValidLogin()) ? (await Backendless.UserService.getCurrentUser(true)) : null);
  redirectToUrl = (getObjectProperty(___arguments.context.pageData, 'redirectToUrl'));
  redirectToPageName = (getObjectProperty(___arguments.context.pageData, 'redirectToPageName'));
  redirectData = (getObjectProperty(___arguments.context.pageData, 'redirectData'));
  sendUserTokenAndId = (getObjectProperty(___arguments.context.pageData, 'sendUserTokenAndId'));
  if (currentUser) {
    if (redirectToUrl) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(redirectToUrl, false, (sendUserTokenAndId ? ({ [`userToken`]: (await (async function() {
      	return Backendless.UserService.getCurrentUserToken()
      })()),[`userId`]: (getObjectProperty(currentUser, 'objectId')),[`stayLoggedIn`]: true }) : ''));
    } else if (redirectToPageName) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectToPageName, (redirectData ? (JSON.parse(redirectData)) : null));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('logged-in', undefined);
    }
  }
  console.log(___arguments.context.pageData);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/login/components/2febc31bca79a175d5230a1fab79c7a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await setError(null);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')) && ((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))))) {
    try {
      await Backendless.UserService.restorePassword((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')));
      (function (message) { alert(message) })('If the user exists in the system, they will receive an email');

    } catch (error) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;

    }
  } else {
    await setError((new Error('Please enter a valid email address')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/map-testing/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('App Data');
  console.log(___arguments.context.appData);
  console.log('Current user object id');
  console.log(getObjectProperty(___arguments.context.appData, 'currentUser.objectId'));
  ___arguments.context.pageData['transportRecord'] = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setRelated(['rel_TransportRequest.rel_Client', 'rel_TransportRequest.relDestination_Facility', 'rel_TransportRequest.relPickup_Facility', 'relDispatcher1_Employee']).setRelationsDepth(2).setSortBy('datetimeScheduledStart asc').setPageSize(100)));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7584216dff336da681119ee9a04ccab3', false);
  console.log('transports');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord'));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(async () => {
      ___arguments.context.appData['insuranceTypeOptions'] = [({ [`label`]: 'SoonerCare (XIX)',[`value`]: 'SoonerCare (XIX)' }), ({ [`label`]: 'Private Insurance',[`value`]: 'Private Insurance' }), ({ [`label`]: 'Medicaid (MCO)',[`value`]: 'Medicaid' }), ({ [`label`]: 'Medicare',[`value`]: 'Medicare' }), ({ [`label`]: 'Dept. Mental Health (DMH)',[`value`]: 'Dept. Mental Health (DMH)' }), ({ [`label`]: 'Other',[`value`]: 'Other' })];
    ___arguments.context.appData['tribalStatusOptions'] = [({ [`label`]: 'Yes',[`value`]: true }), ({ [`label`]: 'No/Unknown',[`value`]: false })];
    ___arguments.context.appData['tribeAffiliationOptions'] = (await Promise.all((await Backendless.Data.of('TribeAffiliationOptions').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'tribes')),[`value`]: (getObjectProperty(item, 'tribes')) });})));

  })();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/map-testing/components/c15501fe259858379dcf8ae8561ceeaf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Transport: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.rel_Client.nameFull')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/map-testing/components/561d7fb2e9029349f01fff52097117a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientSuicideOrSelfHarmRiskToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/map-testing/components/91a798d5b4c7782d2846f7bbfe06478f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientAggressiveOrViolentToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/map-testing/components/184f9d6cb531ac2924b27ef3495d351d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientElopementRiskToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/map-testing/components/1646184623d83f7c9ce8e24a71b2e102/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'typeStatus')) == 'Canceled') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1646184623d83f7c9ce8e24a71b2e102'))['color'] = 'Red';
    return 'RIDE CANCELED';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1646184623d83f7c9ce8e24a71b2e102'))['color'] = '';
    return (String('Scheduled Start: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'datestringScheduledStart')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/map-testing/components/14bf660624e7b1b911234b63a127abcb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('current-transport', ({ [`transportRecord`]: ___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'),[`lastPage`]: 'current-rides' }));

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'tripLogTransportStatus')) == 'In Progress' ? 'View In Progress Transport' : 'View Transport')

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'tripLogTransportStatus')) == 'In Progress') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14bf660624e7b1b911234b63a127abcb'))['background'] = '#2BC25C';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14bf660624e7b1b911234b63a127abcb'))['background'] = '#2B46C2';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14bf660624e7b1b911234b63a127abcb'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/map-testing/components/ba44f0d6e5e650432ee8b3c71a480d7b/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  ['onPointsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ [`lat`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')))),[`lng`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')))) }), ({ [`lat`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),[`lng`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))) })]

  },
  /* handler:onPointsAssignment */
  /* handler:onMapCenterAssignment */
  ['onMapCenterAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`lat`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude'))) / 2,[`lng`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude'))) / 2 })

  },
  /* handler:onMapCenterAssignment */
  /* handler:onMapZoomAssignment */
  ['onMapZoomAssignment'](___arguments) {
    var markerDistance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  if ((roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),2)) > (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))),2))) {
    markerDistance = (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),2));
  } else {
    markerDistance = (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))),2));
  }
  if (markerDistance <= 0.04) {
    return 13;
  } else if (markerDistance <= 0.09) {
    return 12;
  } else if (markerDistance <= 0.14) {
    return 11;
  } else if (markerDistance <= 0.3) {
    return 10;
  } else if (markerDistance <= 0.8) {
    return 9;
  } else if (markerDistance <= 1.6) {
    return 8;
  } else if (markerDistance <= 2.5) {
    return 7;
  } else {
    return 6;
  }

  },
  /* handler:onMapZoomAssignment */
  /* content */
}))

define('./pages/map-testing/components/781283713a168d38d5e7eaac18c99fbf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.length')) == 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/map-testing/components/8f669b05e8a6265a67b98543fe78e0f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Lat Diff: ',Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude'))),'Lng Diff: ',Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/map-testing/components/8b8b1b0eef357237db85fbbb6332b145/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Transport Code: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'transportCode_copy')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/map-testing/components/7625ba8e44096c24ac4c791295bc307e/bundle.js', [], () => ({
  /* content */
  /* handler:routeLogic */
  async ['routeLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(latPickup, lngPickup, latDropoff, lngDropoff) {
	return [
	  {
	    "location": { "lat": latPickup, "lng": lngPickup },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Eiffel Tower",
	    "label": {
	      "text": "Eiffel Tower",
	      "color": "red",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }
	  },
	  {
	    "location": { "lat": latDropoff, "lng": lngDropoff },
	    "icon": "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
	    "title": "Louvre",
	    "label": {
	      "text": "Louvre",
	      "color": "green",
	      "fontSize": "14px",
	      "fontWeight": "normal"
	    }


	  }
	]
})((Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')))), (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')))), (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))), (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude'))))))

  },
  /* handler:routeLogic */
  /* content */
}))

define('./pages/map-testing/components/785c412694ac89fe08fce80a683a31c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude'))));
  console.log(String(Number((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')))))) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/new-directory/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Request Forms Data',[`pageName`]: 'requester-entity' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/new-directory/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      console.log('Searching for Employees');
  ___arguments.context.pageData['userData'] = (await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setRelationsDepth(1).setSortBy('nameFull asc').setPageSize(100)));
  console.log('All Employees Found');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/new-directory/components/d1b27588ce796b5913251c9cd3e550e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile', ({ [`selectedUser`]: ___arguments.context.dataModel,[`viewAnotherUser`]: true }));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/new-directory/components/178ae57fbd9da566cdd2b4037cb77e7c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('178ae57fbd9da566cdd2b4037cb77e7c'))['background'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d1b27588ce796b5913251c9cd3e550e4'), 'relEmail_Users.color'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/new-directory/components/0c770af69512a18ee3dbe2bd9dfd5db3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26c7e03942997848fa0e5c124db75317', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7674cd6c44f6ff06c92b18e9e10a1ca4', true);
    ___arguments.context.pageData['userData'] = (await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'strWhereBase'))).setRelationsDepth(1).setSortBy((getObjectProperty(___arguments.context.pageData, 'strSortBase'))).setPageSize(100)));

  } catch (error) {
    console.log(error);

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7674cd6c44f6ff06c92b18e9e10a1ca4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26c7e03942997848fa0e5c124db75317', true);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/operations-report/components/a4899d0f896b8e7a444c222637076051/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Operations Report Generator',[`pageName`]: 'operations-report' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/operations-report/components/3aad0ffca40bdc679d9fcda97dcf4849/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updateDashboardDatabase() {
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'No Issues\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'noIssues')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'Submissions\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'submissions')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'Voided\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'voidedSubmissions')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'Canceled\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'cancellations')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'ETAs\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'exceededETA')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'Over 30 Mins\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'exceededETA')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'On Time\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'onTime')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'Facility\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'facilityETA')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'OKRC\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'orcETA')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'State\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'generalTransport')) }) );
  await Backendless.Data.of('OperationsDashboard').bulkUpdate( 'valueType = \'Private\'', ({ [`count`]: (getObjectProperty(___arguments.context.pageData, 'privateTransport')) }) );
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58736ccb4b8e6a8f069f3e923182ae28', true);
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate'));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'));
  ___arguments.context.pageData['reportHeader'] = (['Week of: ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')))).toDateString()),' - ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate')))).toDateString())].join(''));
  ___arguments.context.pageData['submissions'] = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['destinationContactName NOT LIKE \'%test%\' AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['voidedSubmissions'] = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['destinationContactName NOT LIKE \'%test%\' AND isVoided = TRUE AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['completedTransports'] = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['rel_TransportRequest.destinationContactName NOT LIKE \'%test%\' AND typeStatus = \'Completed\' AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['cancellations'] = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['rel_TransportRequest.destinationContactName NOT LIKE \'%test%\' AND typeStatus = \'Canceled\' AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['exceededETA'] = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['rel_TransportRequest.destinationContactName NOT LIKE \'%test%\' AND isLongETA = TRUE AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['onTime'] = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['rel_TransportRequest.destinationContactName NOT LIKE \'%test%\' AND isLongETA = FALSE AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['facilityETA'] = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['rel_TransportRequest.destinationContactName NOT LIKE \'%test%\' AND typeLongETAcause = \'Facility\' AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['orcETA'] = (await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['rel_TransportRequest.destinationContactName NOT LIKE \'%test%\' AND typeLongETAcause = \'Ride Care\' AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['generalTransport'] = (await Backendless.Data.of('EntityRequestingTransport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['TransportRequest[`rel_EntityRequestingTransport`].`destinationContactName` NOT LIKE \'%test%\' AND requesterEntityName LIKE \'%general%\' AND TransportRequest[`rel_EntityRequestingTransport`].`created` >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND TransportRequest[`rel_EntityRequestingTransport`].`created` <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['privateTransport'] = (await Backendless.Data.of('EntityRequestingTransport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['TransportRequest[`rel_EntityRequestingTransport`].`destinationContactName` NOT LIKE \'%test%\' AND requesterEntityName NOT LIKE \'%general%\' AND TransportRequest[`rel_EntityRequestingTransport`].`created` >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND TransportRequest[`rel_EntityRequestingTransport`].`created` <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join('')))));
  ___arguments.context.pageData['noIssues'] = ((getObjectProperty(___arguments.context.pageData, 'submissions')) - [(getObjectProperty(___arguments.context.pageData, 'voidedSubmissions')), (getObjectProperty(___arguments.context.pageData, 'cancellations')), (getObjectProperty(___arguments.context.pageData, 'exceededETA'))].reduce(function(x, y) {return x + y;}));
  console.log(['TransportRequest[`rel_EntityRequestingTransport`].`destinationContactName` NOT LIKE \'%test%\' AND requesterEntityName NOT LIKE \'%general%\' AND created >= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate')),' AND created <= ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'endDate'))].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'noIssues'));
  console.log(getObjectProperty(___arguments.context.pageData, 'onTime'));
  await updateDashboardDatabase();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58736ccb4b8e6a8f069f3e923182ae28', false);
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['reportVisible'] = true;
  ___arguments.context.pageData['reportVisible'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/operations-report/components/746ab9b1ebb10de1ca4db40634d11b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['reportVisible'] = false;
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75d2c3b4ae2d051a38b6136dee69efb1', false);
  }
  if (___arguments.value <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75d2c3b4ae2d051a38b6136dee69efb1', true);
  }
  if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75d2c3b4ae2d051a38b6136dee69efb1', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/operations-report/components/a4cd16d25c2ed04ec73f3853e8d3ddba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['reportVisible'] = false;
  if (___arguments.value) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75d2c3b4ae2d051a38b6136dee69efb1', false);
  }
  if (___arguments.value > (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1af3d783d3478b7aabd4e17f326816f', true);
  }
  if (___arguments.value <= (new Date())) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1af3d783d3478b7aabd4e17f326816f', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/operations-report/components/129510089012ae44ac229acb1eae1801/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = ((new Date((new Date()).getTime() - (604800 * 1000))).valueOf());
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = ((new Date((new Date()).getTime() - (86400 * 1000))).valueOf());
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'startDate'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/operations-report/components/ce84c5f6f37edb41273aad095b36437e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['startDate'] = ((new Date((new Date()).getTime() - (2592000 * 1000))).valueOf());
  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['endDate'] = ((new Date((new Date()).getTime() - (86400 * 1000))).valueOf());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/operations-report/components/497655cce4892ad2d0e8f3de0f9561ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((new Date()).toDateString());
  ___arguments.context.pageData['pdfInProcess'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e80e2b3b1521cd75a567d72ea3ab45b1', true);
  ___arguments.context.pageData['url_to_document'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CraftMyPDF/generate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`templateId`]: '21e77b2347ef8f72',[`data`]: ({ [`report_header`]: (getObjectProperty(___arguments.context.pageData, 'reportHeader')),[`submissions`]: (getObjectProperty(___arguments.context.pageData, 'submissions')),[`completed_transports`]: (getObjectProperty(___arguments.context.pageData, 'completedTransports')),[`voided_submissions`]: (getObjectProperty(___arguments.context.pageData, 'voidedSubmissions')),[`cancellations`]: (getObjectProperty(___arguments.context.pageData, 'cancellations')),[`exceeded_eta`]: (getObjectProperty(___arguments.context.pageData, 'exceededETA')),[`facility_eta`]: (getObjectProperty(___arguments.context.pageData, 'facilityETA')),[`orc_eta`]: (getObjectProperty(___arguments.context.pageData, 'orcETA')),[`submissions_chart`]: [({ [`sub_type`]: 'ETAs',[`quantity`]: (getObjectProperty(___arguments.context.pageData, 'exceededETA')) }), ({ [`sub_type`]: 'Canceled',[`quantity`]: (getObjectProperty(___arguments.context.pageData, 'cancellations')) }), ({ [`sub_type`]: 'No Issue',[`quantity`]: (getObjectProperty(___arguments.context.pageData, 'noIssues')) }), ({ [`sub_type`]: 'Voided',[`quantity`]: (getObjectProperty(___arguments.context.pageData, 'voidedSubmissions')) })],[`dispatch`]: [({ [`description`]: 'Over 30 Mins',[`quantity1`]: (getObjectProperty(___arguments.context.pageData, 'exceededETA')) }), ({ [`description`]: 'On Time',[`quantity1`]: (getObjectProperty(___arguments.context.pageData, 'onTime')) })],[`eta_type`]: [({ [`eta_type`]: 'OKRC',[`count`]: (getObjectProperty(___arguments.context.pageData, 'orcETA')) }), ({ [`eta_type`]: 'Facility',[`count`]: (getObjectProperty(___arguments.context.pageData, 'facilityETA')) })],[`transport_type`]: [({ [`transport_type`]: 'State',[`count1`]: (getObjectProperty(___arguments.context.pageData, 'generalTransport')) }), ({ [`transport_type`]: 'Private',[`count1`]: (getObjectProperty(___arguments.context.pageData, 'privateTransport')) })] }),[`outputFile`]: String(getObjectProperty(___arguments.context.pageData, 'reportHeader')) + String('.pdf'),[`isCmyk`]: false,[`imageResampleRes`]: 0 }))));
  console.log(getObjectProperty(___arguments.context.pageData, 'url_to_document'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/operations-report/components/3f58dfb3e71fd97d4f2c87c218a8db52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['url_to_pdf'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CraftMyPDF/generate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`templateId`]: '21e77b2347ef8f72',[`data`]: ({ [`report_header`]: 'Week of: Mon Jul 15 2024 - Sun Jul 21 2024' }),[`outputFile`]: 'test_file',[`isCmyk`]: false,[`imageResampleRes`]: 0 }))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/operations-report/components/e80e2b3b1521cd75a567d72ea3ab45b1/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pdfInProcess')) == true) {
    await new Promise(r => setTimeout(r, 8000 || 0));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://app.okridecare.com/api/files/export/pdf-export/',(getObjectProperty(___arguments.context.pageData, 'reportHeader')),'.pdf'].join('')), true, undefined);
    ___arguments.context.pageData['pdfInProcess'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e80e2b3b1521cd75a567d72ea3ab45b1', false);
  } else {
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/operations-report/components/66b783486cdca6d96fcdb51140d4cc61/bundle.js', [], () => ({
  /* content */
  /* handler:labelsLogic */
  ['labelsLogic'](___arguments) {
      return ['OKRC', 'Facility']

  },
  /* handler:labelsLogic */
  /* handler:datasetsLogic */
  ['datasetsLogic'](___arguments) {
      return [({ [`label`]: ['OKRC', 'Facility'],[`data`]: ['5', '10'],[`borderColor`]: '#008ffa',[`backgroundColor`]: ['#feaf1a', '#00e395'] })]

  },
  /* handler:datasetsLogic */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return ({ [`indexAxis`]: 'y' })

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/past-rides/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('App Data');
  console.log(___arguments.context.appData);
  console.log('Current user object id');
  console.log(getObjectProperty(___arguments.context.appData, 'currentUser.objectId'));
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  if (!(getObjectProperty(___arguments.context.appData, 'pastRidesStartDate'))) {
    ___arguments.context.appData['pastRidesStartDate'] = ((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf());
  }
  if (!(getObjectProperty(___arguments.context.appData, 'pastRidesEndDate'))) {
    ___arguments.context.appData['pastRidesEndDate'] = (new Date());
  }
  ___arguments.context.pageData['whereClauseBase'] = (['relDriver1_Employee.relEmail_Users.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')),'\' && tripLogTransportStatus = \'Complete\' &&  '].join(''));
  ___arguments.context.pageData['whereClause'] = (['datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.appData, 'pastRidesStartDate')) - millisecondsSinceDayStart,'\' && datetimeScheduledStart <= \'',((getObjectProperty(___arguments.context.appData, 'pastRidesEndDate')) - millisecondsSinceDayStart) + 86400000,'\''].join(''));
  ___arguments.context.pageData['pageSize'] = 10;
  ___arguments.context.pageData['pageCount'] = (Math.ceil((await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'whereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'whereClause')))))) / (getObjectProperty(___arguments.context.pageData, 'pageSize'))));
  console.log('pageCount');
  console.log(getObjectProperty(___arguments.context.pageData, 'pageCount'));
  ___arguments.context.pageData['transportRecord'] = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'whereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'whereClause')))).setRelated(['rel_TransportRequest.rel_Client', 'rel_TransportRequest.relDestination_Facility', 'rel_TransportRequest.relPickup_Facility', 'relDispatcher1_Employee']).setRelationsDepth(2).setSortBy('datetimeScheduledStart desc').setPageSize((getObjectProperty(___arguments.context.pageData, 'pageSize')))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7584216dff336da681119ee9a04ccab3', false);
  console.log('transports');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord'));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(async () => {
      ___arguments.context.appData['insuranceTypeOptions'] = [({ [`label`]: 'SoonerCare (XIX)',[`value`]: 'SoonerCare (XIX)' }), ({ [`label`]: 'Private Insurance',[`value`]: 'Private Insurance' }), ({ [`label`]: 'Medicaid (MCO)',[`value`]: 'Medicaid' }), ({ [`label`]: 'Medicare',[`value`]: 'Medicare' }), ({ [`label`]: 'Dept. Mental Health (DMH)',[`value`]: 'Dept. Mental Health (DMH)' }), ({ [`label`]: 'Other',[`value`]: 'Other' })];
    ___arguments.context.appData['tribalStatusOptions'] = [({ [`label`]: 'Yes',[`value`]: true }), ({ [`label`]: 'No',[`value`]: false }), ({ [`label`]: 'Unknown',[`value`]: 'Unknown' })];
    ___arguments.context.appData['tribeAffiliationOptions'] = (await Promise.all((await Backendless.Data.of('TribeAffiliationOptions').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'tribes')),[`value`]: (getObjectProperty(item, 'tribes')) });})));

  })();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/past-rides/components/c15501fe259858379dcf8ae8561ceeaf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Transport: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.rel_Client.nameFull')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/past-rides/components/561d7fb2e9029349f01fff52097117a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientSuicideOrSelfHarmRiskToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/past-rides/components/91a798d5b4c7782d2846f7bbfe06478f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientAggressiveOrViolentToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/past-rides/components/184f9d6cb531ac2924b27ef3495d351d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.isClientElopementRiskToday')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/past-rides/components/1646184623d83f7c9ce8e24a71b2e102/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'typeStatus')) == 'Canceled') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1646184623d83f7c9ce8e24a71b2e102'))['color'] = 'Red';
    return 'RIDE CANCELED';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1646184623d83f7c9ce8e24a71b2e102'))['color'] = '';
    return (String('Scheduled Start: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'datestringScheduledStart')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/past-rides/components/14bf660624e7b1b911234b63a127abcb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('current-transport', ({ [`transportRecord`]: ___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'),[`lastPage`]: 'past-rides' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/past-rides/components/ba44f0d6e5e650432ee8b3c71a480d7b/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  ['onPointsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ [`lat`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')))),[`lng`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')))) }), ({ [`lat`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),[`lng`]: (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))) })]

  },
  /* handler:onPointsAssignment */
  /* handler:onMapCenterAssignment */
  ['onMapCenterAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`lat`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude'))) / 2,[`lng`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude'))) / 2 })

  },
  /* handler:onMapCenterAssignment */
  /* handler:onMapZoomAssignment */
  ['onMapZoomAssignment'](___arguments) {
    var markerDistance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  if ((roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),2)) > (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))),2))) {
    markerDistance = (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude')))),2));
  } else {
    markerDistance = (roundDecimals((Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))),2));
  }
  if (markerDistance <= 0.04) {
    return 13;
  } else if (markerDistance <= 0.09) {
    return 12;
  } else if (markerDistance <= 0.14) {
    return 11;
  } else if (markerDistance <= 0.3) {
    return 10;
  } else if (markerDistance <= 0.8) {
    return 9;
  } else if (markerDistance <= 1.6) {
    return 8;
  } else if (markerDistance <= 2.5) {
    return 7;
  } else {
    return 6;
  }

  },
  /* handler:onMapZoomAssignment */
  /* handler:onMarkerClick */
  ['onMarkerClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.point, 'lat')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude'))) {
    (function (componentUid, marker, popupContent) { ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('ba44f0d6e5e650432ee8b3c71a480d7b', ___arguments.point, (['<p><strong>PICKUP: </strong>',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.googleName')),'</p> <p><a href="https://www.google.com/maps/search/?api=1&query=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.pickupAddress')),'">',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.pickupAddress')),'</a></p> <p>&nbsp;</p>'].join('')));
  } else {
    (function (componentUid, marker, popupContent) { ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('ba44f0d6e5e650432ee8b3c71a480d7b', ___arguments.point, (['<p><strong>DROPOFF: </strong>',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.googleName')),'</p> <p><a href="https://www.google.com/maps/search/?api=1&query=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.destinationAddress')),'">',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.destinationAddress')),'</a></p> <p>&nbsp;</p>'].join('')));
  }

  },
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/past-rides/components/781283713a168d38d5e7eaac18c99fbf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'transportRecord.length')) == 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/past-rides/components/8f669b05e8a6265a67b98543fe78e0f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Lat Diff: ',Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.latitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.latitude'))),'Lng Diff: ',Math.abs((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relPickup_Facility.longitude')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'rel_TransportRequest.relDestination_Facility.longitude')))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/past-rides/components/82ea0889564be37e15f43c47e333012d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['pageSize'] = 10;

  },
  /* handler:onMounted */
  /* handler:onPageChange */
  async ['onPageChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7584216dff336da681119ee9a04ccab3', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  ___arguments.context.pageData['transportRecord'] = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'whereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'whereClause')))).setRelated(['rel_TransportRequest.rel_Client', 'rel_TransportRequest.relDestination_Facility', 'rel_TransportRequest.relPickup_Facility', 'relDispatcher1_Employee']).setRelationsDepth(2).setSortBy('datetimeScheduledStart desc').setPageSize((getObjectProperty(___arguments.context.pageData, 'pageSize'))).setOffset(((___arguments['currentPage'] - 1) * (getObjectProperty(___arguments.context.pageData, 'pageSize'))))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7584216dff336da681119ee9a04ccab3', false);

  },
  /* handler:onPageChange */
  /* handler:onGoNext */
  async ['onGoNext'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextPage() })('82ea0889564be37e15f43c47e333012d');

  },
  /* handler:onGoNext */
  /* handler:onGoBack */
  async ['onGoBack'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goPreviousPage() })('82ea0889564be37e15f43c47e333012d');

  },
  /* handler:onGoBack */
  /* content */
}))

define('./pages/past-rides/components/d8516e9e558d2ecc21467c26182272ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7584216dff336da681119ee9a04ccab3', true);
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  ___arguments.context.pageData['whereClause'] = (['datetimeScheduledStart >= \'',(getObjectProperty(___arguments.context.appData, 'pastRidesStartDate')) - millisecondsSinceDayStart,'\' && datetimeScheduledStart <= \'',((getObjectProperty(___arguments.context.appData, 'pastRidesEndDate')) - millisecondsSinceDayStart) + 86400000,'\''].join(''));
  ___arguments.context.pageData['pageCount'] = (Math.ceil((await Backendless.Data.of('Transport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'whereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'whereClause')))))) / (getObjectProperty(___arguments.context.pageData, 'pageSize'))));
  ___arguments.context.pageData['transportRecord'] = (await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty(___arguments.context.pageData, 'whereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'whereClause')))).setRelated(['rel_TransportRequest.rel_Client', 'rel_TransportRequest.relDestination_Facility', 'rel_TransportRequest.relPickup_Facility', 'relDispatcher1_Employee']).setRelationsDepth(2).setSortBy('datetimeScheduledStart desc').setPageSize((getObjectProperty(___arguments.context.pageData, 'pageSize')))));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goFirstPage() })('82ea0889564be37e15f43c47e333012d');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7584216dff336da681119ee9a04ccab3', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/past-rides/components/14d989e659f199d1c73b89a46aea6166/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'pastRidesEndDate'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['pastRidesEndDate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/past-rides/components/eaaf1cbd4a899d5adbade0e14048990e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'pastRidesStartDate'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['pastRidesStartDate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/past-rides/components/b97ce5a4e1987675ecedee29b1586457/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'whereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'whereClause')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/past-rides/components/161556cc0bccfd5358c614194742632e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Transport Code: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3c9a4cd189e2ed10085831896ba3ff2'), 'transportCode_copy')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payers/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData) {
	return [
	  {"type":"actions", "field": "actions", "width": 75, "minWidth": 75, "pinned": "left", meta: { align: "center"}},
	  {
	    "field": "typeInsurance",
	    "headerName": "Insurance Type",
	    "sort": "asc",
	    "sortable": true,
	    "minWidth": 300,
	    "pinned": "left",
	    "editable"        : true,
	    "flex": 1
	  },
	  {
	    "field": "payerName",
	    "headerName": "Payer Name",
	    "sortable": true,
	    "minWidth": 300,
	    "pinned": "left",
	    "editable"        : true,
	    "flex": 1
	  },
	  {
	    "field": "payerId",
	    "headerName": "Payer Id",
	    "sortable": true,
	    "minWidth": 300,
	    "pinned": "left",
	    "editable"        : true,
	    "flex": 1
	  },
	  {
	    "field": "payerState",
	    "headerName": "State",
	    "sortable": true,
	    "minWidth": 300,
	    "pinned": "left",
	    "editable"        : true,
	    "flex": 1
	  },
	]
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'delete') {
    try {
      await Backendless.Data.of('Payer').remove( (getObjectProperty(___arguments['recordItem'], 'objectId')) );
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');

    } catch (error) {
      console.log(error);

    }
  } else if (false) {
  } else if (false) {
  }

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/payers/components/45bee23a419ff7c9e93a5842096578f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.Data.of('Payer').save( ({ [`typeInsurance`]: '' }) );
  await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['employeeOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['statusOptions'] = ['In Service', 'In Maintenance', 'Decommissioned', 'Sold'];
  ___arguments.context.pageData['typeOptions'] = ['Caged', 'ADA Сompliant', 'Fortified', 'Large'];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/profile/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Employees',[`pageName`]: 'directory' }), ({ [`label`]: 'User Profile',[`pageName`]: 'profile' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/profile/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error, targetUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.appData);
  // Look at the viewAnotherUser property, which will only be set
  // if this is coming from the User Directory. If it's true,
  // set targetUser to the person who was selected from the
  // directory. If it's false, set it to the current user.
  if ((getObjectProperty(___arguments.context.pageData, 'viewAnotherUser')) != true) {
    targetUser = (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'));
  } else {
    targetUser = (getObjectProperty(___arguments.context.pageData, 'selectedUser.relEmail_Users.objectId'));
  }
  try {
    // Get the record from the Employee table for the user in question
    ___arguments.context.pageData['employeeRecord'] = ((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause((['relEmail_Users.objectId = \'',targetUser,'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
    // Do a reverse lookup to get the vehicle they're assigned if they have one.
    ___arguments.context.pageData['employeeVehicle'] = ((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause((['relCurrentlyAssignedTo_Employee.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'employeeRecord.objectId')),'\''].join(''))).setPageSize(10)))[0]);
    ___arguments.context.layoutData['profileImage'] = (getObjectProperty(___arguments.context.pageData, 'employeeRecord.profileImage'));

  } catch (error) {
    console.log(error);
    (function (message) { alert(message) })('We\'re sorry.  The requested user was not found.  Please submit a feedback report.');
    (function () { window.history.back(); })();

  }
  try {
    // This block gets the ridecare role and permission
    // level for the selected user and adds them to the
    // selectedUser property passed into pageData on routing.
    (getObjectProperty(___arguments.context.pageData, 'employeeRecord'))['rideCareUserAttributes'] = (await BackendlessUI.Functions.Custom['fn_839edc5af7af51fbdc87a427321d61a1']((await Backendless.Request.get(`${Backendless.appPath}/services/UserService/UserRolesById`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'userObjectId': JSON.stringify(targetUser) }).send())));
    console.log(___arguments.context.pageData);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234'](___arguments.context.pageData);

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/profile/components/82dcaf12eb67d8eb1af9b518b6b38932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.pageData, 'employeeRecord.dateStart')))).toDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile/components/803bbe243f5f2966a3ba12f1c9daaed5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6624c49b08c2dec15d15fa7a2fc72696', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('803bbe243f5f2966a3ba12f1c9daaed5', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d9b80aff3c1795b88ff2c38322ea836', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/e25b5d29684e4b0d07797a95ff66452d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6624c49b08c2dec15d15fa7a2fc72696', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('803bbe243f5f2966a3ba12f1c9daaed5', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d9b80aff3c1795b88ff2c38322ea836', undefined);
  ___arguments.context.layoutData['profileImage'] = (getObjectProperty(___arguments.context.pageData, 'employeeRecord.profileImage'));
  ___arguments.context.layoutData['currentUserProfileImage'] = (getObjectProperty(___arguments.context.pageData, 'employeeRecord.profileImage'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/9b35086e16dfd28db903813d6ee3dcda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.dataModel, 'employeeRecord'));
  // The purpose of this object-text-object conversion is to force Backendless to make a copy of the data object instead of just establishing a pointer.  This is so that changes made in the edit window are done in a unique container and are not put into the main employeeRecord object until the Save button is hit.
  ___arguments.context.dataModel['employeeRecord'] = (JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'employeeRecord'))))));

  },
  /* handler:onBeforeMount */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.dataModel);
  // Save the new record into the Employee table
  await Backendless.Data.of('Employee').save( (getObjectProperty(___arguments.context.dataModel, 'employeeRecord')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6624c49b08c2dec15d15fa7a2fc72696', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('803bbe243f5f2966a3ba12f1c9daaed5', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d9b80aff3c1795b88ff2c38322ea836', undefined);
  // Pull the newly updated data from the database back into the
  // existing object in Page Data so that the display will update
  ___arguments.context.pageData['employeeRecord'] = ((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause((['relEmail_Users.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(10)))[0]);
  // Do the same thing as above for the form data container as well.
  // The purpose of this object-text-object conversion is to force Backendless to make a copy of the data object instead of just establishing a pointer.  This is so that changes made in the edit window are done in a unique container and are not put into the main employeeRecord object until the Save button is hit.
  ___arguments.context.dataModel['employeeRecord'] = (JSON.parse((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'employeeRecord'))))));
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.dataModel);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/profile/components/9b31daeadd97cd04b189ed0b276c634b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord')));
  if (___arguments.value) {
    await BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord')));
  }
  console.log(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'));
  console.log('>>>>>>>>prev version');
  if (null) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['googlePlaceId'] = (getObjectProperty(___arguments.value, 'place_id'));
    ___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda')['googlePlaceDetails'] = (await ( async function (placeId, fields) {
     if (!window.google || !window.google.maps || !window.google.maps.places) {
       return Promise.reject('Google Maps library was not initialized')
     }

     if (!placeId) {
       return Promise.reject('Place ID is empty')
     }

     const Status = google.maps.places.PlacesServiceStatus
     const StatusMessages = {
       [Status.INVALID_REQUEST] : 'The API request was malformed',
       [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
       [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
       [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
       [Status.UNKNOWN_ERROR]   : 'An unknown error.',
       [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
     }

     const enrichPlaceWithLocation = place => {
       if (place.geometry) {
         const lat = place.geometry.location.lat()
         const lng = place.geometry.location.lng()

         place.location = { lat, lng }
       }

       return place
     }

     const service = new google.maps.places.PlacesService(document.createElement('div'))
     const request = { placeId, fields }

     return new Promise((resolve, reject) => {
       service.getDetails(request, callback)

       function callback(place, status) {
         if (status === Status.OK) {
           resolve(enrichPlaceWithLocation(place))
         } else {
           const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
           const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

           reject(new Error(errorMessage))
         }
       }
     })
     })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord.googlePlaceId')), ['formatted_address', 'address_components']));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['googleFormattedAddress'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'googlePlaceDetails.formatted_address'));
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'googlePlaceDetails.address_components'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['address'] = (getObjectProperty((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'googlePlaceDetails.address_components')), async (item) => {


     return ((getObjectProperty(item, 'types')).includes('street_num'));
    })), 'short_name'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['city'] = (getObjectProperty((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'googlePlaceDetails.address_components')), async (item) => {


     return ((getObjectProperty(item, 'types')).includes('locality'));
    })), 'short_name'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['stateCode'] = (getObjectProperty((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'googlePlaceDetails.address_components')), async (item) => {


     return ((getObjectProperty(item, 'types')).includes('administrative_area_level_1'));
    })), 'short_name'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['zipcode'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'googlePlaceDetails.address_components')), async (item) => {


     return ((getObjectProperty(item, 'types')).includes('postal_code'));
    }))[0]), 'short_name'));
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'));
  }

  },
  /* handler:onChange */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('9b31daeadd97cd04b189ed0b276c634b', undefined, ({ [`country`]: 'us' }), undefined, undefined, undefined, undefined, undefined, ['address'], undefined, undefined, undefined, undefined);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/profile/components/52865bf94eda2fdef8cf218cfbe6e135/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}



  return ([(getObjectProperty(___arguments.context.appData, 'currentUser.email')).slice(0, (getObjectProperty(___arguments.context.appData, 'currentUser.email')).indexOf('@') + 1),'Profile Image',subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.uploadedFiles);
  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('9b35086e16dfd28db903813d6ee3dcda')), 'employeeRecord'))['profileImage'] = ___arguments.uploadedFiles;

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/profile/components/3e89002f7c3c0219700de6fa4fc2c77a/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      // These three blocks simply serve to initialize
  // properties that can hold the input values.
  ___arguments.context.dataModel['currentPassword'] = undefined;
  ___arguments.context.dataModel['newPassword'] = undefined;
  ___arguments.context.dataModel['newPasswordConfirmation'] = undefined;

  },
  /* handler:onMounted */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Only show the logout and edit profile buttons
  // if the user is viewing their own profile.
  if ((getObjectProperty(___arguments.context.pageData, 'viewAnotherUser')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile/components/aadd7c681f85876e274ede0e9bb545d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a'), 'newPasswordConfirmation')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a'), 'newPassword'))) {
    ___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a')['newPasswordConfirmed'] = false;
    return ['inputError'];
  } else {
    ___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a')['newPasswordConfirmed'] = true;
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profile/components/f2ef05cb7f3a85cfa1ae013892f249d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Don't attempt to change the password if the new password and the confirmation don't match.
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a'), 'newPasswordConfirmed')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1cac6cab903d35d4df8f4ef8e14bf497', true);
    return ;
  } else {
    try {
      // Hide all the warnings and confirmations when the new reset is attempted.
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1cac6cab903d35d4df8f4ef8e14bf497', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8fa02e68b472f4f45e3e8868fbd0f6', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e131413d566904ea9a1b68f8a0dc8f73', false);
      // Call the custom API service based on this video
      // to get change the password and return the user.
      // https://www.youtube.com/watch?v=hnlVR6jTXNM&list=PLWRqDbbT5r9B0NlVfXvk6o-Av-o_9-ATq&index=18&ab_channel=Backendless
      ___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a')['currentUser'] = (await Backendless.Request.post(`${Backendless.appPath}/services/UserService/changePassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'currentPassword': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a'), 'currentPassword')),'newPassword': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a'), 'newPassword')) }));
      // Inform user of success!
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e131413d566904ea9a1b68f8a0dc8f73', true);
      // Log the user back in with the new password
      // so that they can continue their session.
      await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a'), 'currentUser.email')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e89002f7c3c0219700de6fa4fc2c77a'), 'newPassword')), true  );

    } catch (error) {
      // Print out the error from the API method to the console if needed.
      console.log(error);
      // The main error that service will throw is that the current
      // password doesn't match so go ahead and toggle that on.
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8fa02e68b472f4f45e3e8868fbd0f6', true);
      return ;

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/c54a68b6fbe446a5c7db6f3711876b81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  ___arguments.context.appData['clearAllData'] = true;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/b84dd5575c934161409bc1bf98196575/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.layoutData['profileImage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord.profileImage'));
  ___arguments.context.layoutData['currentUserProfileImage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord.profileImage'));
  // Need to put this here since the submit button for the form is
  // set to default to avoid the 'submit on enter key press' issue.
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('9b35086e16dfd28db903813d6ee3dcda');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/c66496b808ae11db4ec4d106b52b953f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeRecord.rideCareUserAttributes.role'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile/components/e73f807bfff6fd6cfa48c2e7704f5e17/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    
  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile/components/6122d5690fd7e1019a62ae9bd52aa9a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Only show the logout and edit profile buttons
  // if the user is viewing their own profile.
  if ((getObjectProperty(___arguments.context.pageData, 'viewAnotherUser')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile/components/a0fefffb59893e12de5bafda7074e4ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'employeeVehicle.vehicleName')) == null) {
    return 'None';
  } else {
    return (getObjectProperty(___arguments.context.pageData, 'employeeVehicle.vehicleName'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile/components/77fd6f4c1b61d3e6ea53d39da1169819/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData) {
	return [
	  {
	  "type": "actions",
	  "width": 75,
	  "minWidth": 75,
	  "pinned": "left",
	  meta: { align: "center" }
	  },

	  {
	    "field": "datetimeIssue",
	    "headerName": "Date",
	    "cellDataType": "date"
	  },

	  {
	    "field": "typeRecord",
	    "headerName": "Record Type"
	  },

	  {
	    "field": "typeIssue",
	    "headerName": "Issue Type"
	  },

	  {
	    "field": "notesIssue",
	    "headerName": "Notes",
	    "width": 400,
	    "filter": false,
	    "cellEditor": "agLargeTextCellEditor",
	    "cellEditorPopup": true
	  },

	  {
	    "field": "notesResolution",
	    "headerName": "Resolution Notes",
	    "width": 400,
	    "filter": false,
	    "cellEditor": "agLargeTextCellEditor",
	    "cellEditorPopup": true
	  },

	  {
	    "field": "notesHR",
	    "headerName": "HR Notes",
	    "width": 400,
	    "filter": false,
	    "cellEditor": "agLargeTextCellEditor",
	    "cellEditorPopup": true
	  },

	  {
	    "field": "isResolved",
	    "headerName": "Resolved?",
	    "cellDataType": "boolean"
	  },
	]
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/profile/components/a8862f365c685e3dd6ceb9737aa190ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Govern the visibility of the HR Records
  // Show the HR log for all Directors as long as the permission level for that individual is below the directors.
  // Show the HR Log if the user is looking at the profile of one of their direct reports.  We are technically assuming that no one with permissions level under 3 can have direct reports.
  // NEED TO VERIFY.  Trying to compare the selected user's manager object ID (via the data pulled into employeeRecord) to the objectId of the current user (which should match if it's the manager.
  // NEED TO FIX THIS.  Likely need an HR role category that grants access to all HR Records, otherwise restrict viewability to people of lower rank.  Try setting criteria to currentUser permission level > selectedUser permission level.
  // Show the HR Log if the user is a Super Admin or Human Resources permission level.
  // Show the HR Log if the user is a Super Admin or Human Resources permission level.
  // Don't show the HR Log if the user is looking at their own profile.  This code is built on the assumption that when viewAnotherUser is set to true we're guaranteed to find another property called selectedUser.  We are also saying that you can only see an address if you are viewing your own profile.
  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5 && (getObjectProperty(___arguments.context.pageData, 'employeeRecord.rideCareUserAttributes.permissionLevel')) < 5) {
    console.log('IF #1');
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'employeeRecord.relManager_Employee.relEmail_Users.objectId')) == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
    console.log('IF #2');
    return true;
  } else if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.role')) == 'Human Resources' || (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.role')) == 'Super Admin') {
    console.log('IF #3');
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewAnotherUser')) == true) {
    console.log('IF #4');
    return false;
  } else {
    console.log('IF #5');
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile/components/0defc067f8ce86a3314a27d6dd548035/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Govern the visibility of the HR Records
  // Show the HR log for all Directors as long as the permission level for that individual is below the directors.
  // Show the HR Log if the user is looking at the profile of one of their direct reports.  We are technically assuming that no one with permissions level under 3 can have direct reports.
  // NEED TO VERIFY.  Trying to compare the selected user's manager object ID (via the data pulled into employeeRecord) to the objectId of the current user (which should match if it's the manager.
  // NEED TO FIX THIS.  Likely need an HR role category that grants access to all HR Records, otherwise restrict viewability to people of lower rank.  Try setting criteria to currentUser permission level > selectedUser permission level.
  // Show the HR Log if the user is a Super Admin or Human Resources permission level.
  // Show the HR Log if the user is a Super Admin or Human Resources permission level.
  // Don't show the HR Log if the user is looking at their own profile.  This code is built on the assumption that when viewAnotherUser is set to true we're guaranteed to find another property called selectedUser.  We are also saying that you can only see an address if you are viewing your own profile.
  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5 && (getObjectProperty(___arguments.context.pageData, 'employeeRecord.rideCareUserAttributes.permissionLevel')) < 5) {
    console.log('IF #1');
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'employeeRecord.relManager_Employee.relEmail_Users.objectId')) == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
    console.log('IF #2');
    return true;
  } else if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.role')) == 'Human Resources' || (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.role')) == 'Super Admin') {
    console.log('IF #3');
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewAnotherUser')) == true) {
    console.log('IF #4');
    return false;
  } else {
    console.log('IF #5');
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile/components/196b79784175cb6e5f11bdaa3834b21d/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['phoneUnmasked'] = ___arguments['unmaskedValue'];
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['phone'] = (___arguments['value'] == '(___) ___-____' ? '' : ___arguments['value']);

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/profile/components/ee9724c615c1694a8f662025512dabec/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['phoneAltUnmasked'] = ___arguments['unmaskedValue'];
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9b35086e16dfd28db903813d6ee3dcda'), 'employeeRecord'))['phoneAlt'] = (___arguments['value'] == '(___) ___-____' ? '' : ___arguments['value']);

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Request Forms Data',[`pageName`]: 'requester-entity' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      console.log(___arguments.context.appData);

  return (await (async function(appData, pageData) {
	return [
	  {"type":"actions", "field": "actions", "headerName": "", "width": 60, "minWidth": 60, "pinned": "left", meta: { align: "center"}},

	  {
	    "field": "requesterEntityName",
	    "headerName": "Entity Name",
	    "sort": "asc",
	    "headerTooltip": "Requester Entity Name",
	    "pinned": "left",
	    //"flex": 1,
	    "width": 220,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "wrapText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "requesterId",
	    "headerName":"Requester Id",
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8 ? true : false,
	    "headerTooltip": "Requester Id",
	    "pinned": "left",
	    //"flex": 1,
	    "width": 100,
	    "minWidth": 40,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "stateCode",
	    "headerName":"State",
	    "editable": false,
	    "headerTooltip": "State Code",
	    "pinned": "left",
	    "width": 60,
	    "minWidth": 40,
	    //"maxWidth": 60,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "requesterInsuranceTypes",
	    "headerName":"Usable Insurance Types",
	    //"flex": 1,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8 ? true : false,
	    "headerTooltip": "Insurances that users of this form can select.",
	    "width": 150,
	    "minWidth": 150,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "wrapText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	    {
	    "field": "presetPickupTimes",
	    "headerName":"Preset Pickup Times",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Preset Pickup Times",
	    "width": 150,
	    "minWidth": 150,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "wrapText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showChickasawJailTransport",
	    "headerName":"Chickasaw Jail Transport",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Chickasaw Jail Transport",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showChickasawSpecialty",
	    "headerName":"Chickasaw Specialty",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Chickasaw Specialty",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showCOVIDquestions",
	    "headerName":"COVID Questions",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "COVID Questions",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showCrisisResponse",
	    "headerName":"Crisis Response",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Crisis Response",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showDedicatedDriver",
	    "headerName":"Dedicated Driver",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Dedicated Driver",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showJusticeInvolvement",
	    "headerName":"Justice Involvement",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Justice Involvement",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showOCCICformat",
	    "headerName":"OCCIC format",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "OCCIC format",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showPresetPickupTimes",
	    "headerName":"Preset Pickup Times",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Preset Pickup Times",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showReturnTrip",
	    "headerName":"Return Trip",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Return Trip",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "showFollowUpContact",
	    "headerName":"Follow Up Contact",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Does this ride require a follow-up contact to be contacted after completion?",
	    "width": 120,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "requesterDispatchInstructions",
	    "headerName":"Dispatch Instructions",
	    "type": "largeTextColumn",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Dispatch Instructions",
	    "width": 600,
	    "minWidth": 350,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "wrapText": true,
	    "autoHeaderHeight": true,
	    "wrapFieldText": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "requesterNotes",
	    "headerName":"Requester Notes",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Requester Notes",
	    "width": 400,
	    "minWidth": 250,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "wrapText": true,
	    "autoHeaderHeight": true,
	    "wrapFieldText": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "requesterWarningNotes",
	    "headerName":"Warning Notes",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Warning Notes",
	    "width": 400,
	    "minWidth": 250,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "wrapText": true,
	    "autoHeaderHeight": true,
	    "wrapFieldText": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "requesterNotificationEmails",
	    "headerName":"Requester Notification Emails",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Requester Notification Emails",
	    "width": 200,
	    "minWidth": 200,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "wrapText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "requesterFormUrl",
	    "headerName":"Requester Form URL",
	    //"flex": 1,
	    "editable": false,
	    "headerTooltip": "Requester Form URL",
	    "width": 200,
	    "minWidth": 200,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "wrapText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	]


	/*

	"headerTooltip": "HIPAA compliant transport reference.  [first three letters of client's first name].[first three letters of client last name].[submission number].",
	    "pinned": "left",
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }

	    */
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  ['onActionIconClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments['eventName'] == 'editEntity') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bfc740c28995a8ce624eef8d8be9f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2c5b2fafe94eb896eec3afc2d6ddc7d1', true);
    ___arguments.context.pageData['entityFormType'] = 'Edit';
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['displayRequesterEntity'] = ({ [`header`]: 'Edit Requester Entity Details',[`subHeader`]: 'Modify the information below to update an active requester entity form.',[`button`]: 'Save Edits' });
    ___arguments.context.pageData['displayRequesterEntityPage'] = ({ [`header`]: 'Edit Requester Entity Details',[`subHeader`]: 'Modify the information below to update an active requester entity form.',[`button`]: 'Save Edits' });
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['requesterEntity'] = ___arguments['recordItem'];
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['requesterEntity.requesterId'] = (getObjectProperty(___arguments['recordItem'], 'requesterId'));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['oldRequesterId'] = (getObjectProperty(___arguments['recordItem'], 'requesterId'));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['showDeleteEntity'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['textDeleteEntity'] = 'Delete Entity';
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['containerUrl'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['requesterFormUrl'] = (getObjectProperty(___arguments['recordItem'], 'requesterFormUrl'));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['textHelp'] = 'Need Help?';
  } else if (false) {
  }

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/278f8d61e79781a8c016cc34146e2e11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bfc740c28995a8ce624eef8d8be9f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2c5b2fafe94eb896eec3afc2d6ddc7d1', true);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['displayRequesterEntity'] = ({ [`header`]: 'Add New Requester Entity',[`subHeader`]: 'Complete the details below to create a new requester entity form.',[`button`]: 'Add Requester Entity' });
  ___arguments.context.pageData['displayRequesterEntityPage'] = ({ [`header`]: 'Add New Requester Entity',[`subHeader`]: 'Complete the details below to create a new requester entity form.',[`button`]: 'Add Requester Entity' });
  ___arguments.context.pageData['entityFormType'] = 'New';
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['showDeleteEntity'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['containerUrl'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['textHelp'] = 'Need Help?';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/93164d4ef5dde5c6e5cb57f18817dfc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['requesterEntity'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['displayRequesterEntity'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['oldRequesterId'] = null;
  ___arguments.context.pageData['entityFormType'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['showDeleteEntity'] = false;
  ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['confirmDelete'] = null;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('2c5b2fafe94eb896eec3afc2d6ddc7d1');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bfc740c28995a8ce624eef8d8be9f43', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2c5b2fafe94eb896eec3afc2d6ddc7d1', false);
  await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/f926b21c996fe64859f1070bb145309b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/2c5b2fafe94eb896eec3afc2d6ddc7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, newRequesterEntity, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e4fef6e52130d4b77d5895770f93e9e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6747de34c593f5bb77b678a35fe82075', false);
  ___arguments.context.dataModel['textGreen'] = 'Requester Entity Created!';
  ___arguments.context.dataModel['duplicateRequesterId'] = (await Backendless.Data.of('EntityRequestingTransport').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['requesterId = \'',(getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterId')),'\''].join('')))));
  newRequesterEntity = ({ [`requesterEntityName`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterEntityName')),[`requesterId`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterId')),[`stateCode`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.stateCode')),[`presetPickupTimes`]: (await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('f926b21c996fe64859f1070bb145309b')).map(async item => {; return (getObjectProperty(item, 'value'));}))).join(','),[`requesterInsuranceTypes`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterInsuranceTypes')),[`requesterDispatchInstructions`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterDispatchInstructions')),[`requesterNotes`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterNotes')),[`requesterWarningNotes`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterWarningNotes')),[`requesterNotificationEmails`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterNotificationEmails')),[`showChickasawJailTransport`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showChickasawJailTransport')),[`showChickasawSpecialty`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showChickasawSpecialty')),[`showCOVIDquestions`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showCOVIDquestions')),[`showCrisisResponse`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showCrisisResponse')),[`showDedicatedDriver`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showDedicatedDriver')),[`showJusticeInvolvement`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showJusticeInvolvement')),[`showOCCICformat`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showOCCICformat')),[`showPresetPickupTimes`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showPresetPickupTimes')),[`showReturnTrip`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showReturnTrip')),[`showFollowUpContact`]: (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.showFollowUpContact')) });
  if ((getObjectProperty(newRequesterEntity, 'presetPickupTimes')) == '') {
    console.log('Null Value Added to Pickup Time');
    newRequesterEntity['presetPickupTimes'] = null;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterDispatchInstructions')) == null || (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterDispatchInstructions')) == '') {
    newRequesterEntity['requesterDispatchInstructions'] = 'This facility does not require specific dispatch instructions.  Please follow normal procedures.';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'entityFormType')) == 'New') {
    if ((getObjectProperty(___arguments.context.dataModel, 'duplicateRequesterId')) == 1) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6747de34c593f5bb77b678a35fe82075', true);
      ___arguments.context.dataModel['requesterEntity.requesterId'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e4fef6e52130d4b77d5895770f93e9e', false);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'duplicateRequesterId')) == 0) {
      try {
        await Backendless.Data.of('EntityRequestingTransport').save( newRequesterEntity );
        console.log('New Entity Added');
        console.log(newRequesterEntity);
        ___arguments.context.pageData['flagDelay'] = 1;
        ___arguments.context.dataModel['textGreen'] = 'Requester Entity Created!';
        ___arguments.context.dataModel['requesterFormUrl'] = (String('https://app.okridecare.com/?page=transport-request-form&requesterId=') + String(getObjectProperty(newRequesterEntity, 'requesterId')));
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['containerUrl'] = true;
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7781224b9944209b05cd1f6a6d62a99', true);
        console.log('Confirmation Text Shown');

      } catch (error) {
        console.log(error);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5478cb1e93f69b172082eca9c2323', true);

      } finally {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e4fef6e52130d4b77d5895770f93e9e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ccd59cf30fe077c9dd15a6eaabbb0be', false);
        ___arguments.context.dataModel['displayRequesterEntity'] = (getObjectProperty(___arguments.context.pageData, 'displayRequesterEntityPage'));
        await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('f926b21c996fe64859f1070bb145309b', null);

      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'entityFormType')) == 'Edit') {
    console.log('Old ID');
    console.log(getObjectProperty(___arguments.context.dataModel, 'oldRequesterId'));
    console.log('New ID');
    console.log(getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterId'));
    console.log('Duplicate Value');
    console.log(getObjectProperty(___arguments.context.dataModel, 'duplicateRequesterId'));
    if ((getObjectProperty(___arguments.context.dataModel, 'oldRequesterId')) != (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterId')) && (getObjectProperty(___arguments.context.dataModel, 'duplicateRequesterId')) == 1) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6747de34c593f5bb77b678a35fe82075', true);
      ___arguments.context.dataModel['requesterEntity.requesterId'] = (getObjectProperty(___arguments.context.dataModel, 'oldRequesterId'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e4fef6e52130d4b77d5895770f93e9e', false);
    } else {
      try {
        console.log(getObjectProperty(newRequesterEntity, 'presetPickupTimes'));
        await Backendless.Data.of('EntityRequestingTransport').bulkUpdate( (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'requesterEntity.objectId')),'\''].join('')), newRequesterEntity );
        console.log('Entity Updated');
        ___arguments.context.pageData['flagDelay'] = 1;
        ___arguments.context.dataModel['textGreen'] = 'Requester Entity Updated!';
        ___arguments.context.dataModel['requesterFormUrl'] = (String('https://app.okridecare.com/?page=transport-request-form&requesterId=') + String(getObjectProperty(newRequesterEntity, 'requesterId')));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7781224b9944209b05cd1f6a6d62a99', true);
        ___arguments.context.dataModel['oldRequesterId'] = (getObjectProperty(___arguments.context.dataModel, 'requesterEntity.requesterId'));

      } catch (error) {
        console.log(error);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5478cb1e93f69b172082eca9c2323', true);

      } finally {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e4fef6e52130d4b77d5895770f93e9e', false);
        ___arguments.context.dataModel['displayRequesterEntity'] = (getObjectProperty(___arguments.context.pageData, 'displayRequesterEntityPage'));

      }
    }
  }
  await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');

  },
  /* handler:onSubmit */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['displayRequesterEntity.header'] = (getObjectProperty(___arguments.context.pageData, 'displayRequesterEntity.header'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/a69b80bda304ec1ae4c4ce6bab2f9866/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['requesterEntity.requesterId'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1'), 'requesterEntity.requesterId')).toUpperCase());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/c7781224b9944209b05cd1f6a6d62a99/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'flagDelay')) == 1) {
    ___arguments.context.pageData['flagDelay'] = 0;
    await new Promise(r => setTimeout(r, 4000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7781224b9944209b05cd1f6a6d62a99', false);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/38b5478cb1e93f69b172082eca9c2323/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
      await new Promise(r => setTimeout(r, 7000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5478cb1e93f69b172082eca9c2323', false);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/6747de34c593f5bb77b678a35fe82075/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['displayDuplicateWarning'] = (['Requester ID "',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1'), 'requesterEntity.requesterId')),'" Already Exists!'].join(''));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/4c183b4b2ca77974217ef18ef9727afc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1'), 'confirmDelete')) == null) {
    ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['confirmDelete'] = true;
    ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['textDeleteEntity'] = 'Yes, Delete Entity';
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['displayRequesterEntity'] = ({ [`header`]: 'Delete Requester Entity',[`subHeader`]: 'Are you sure you would like to delete this requester entity? This will remove their transport request form.',[`button`]: 'null' });
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['containerUrl'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ccd59cf30fe077c9dd15a6eaabbb0be', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('be4c31011ff9fab50a8e86d2a639ca84', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd035134c1025b24b309734436cf4af5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20f32453714908dd14ec4bf8fd0b3c6b', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1'), 'confirmDelete')) == true) {
    try {
      await Backendless.Data.of('EntityRequestingTransport').remove( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1'), 'requesterEntity.objectId')) );
      console.log('Entity Deleted');
      ___arguments.context.pageData['flagDelay'] = 1;
      ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['textGreen'] = 'Requester Entity Deleted!';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7781224b9944209b05cd1f6a6d62a99', true);

    } catch (error) {
      console.log(error);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5478cb1e93f69b172082eca9c2323', true);

    } finally {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c183b4b2ca77974217ef18ef9727afc', false);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/4e1d59fde21abe2a23294651718b8599/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['requesterEntity'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['displayRequesterEntity'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['oldRequesterId'] = null;
  ___arguments.context.pageData['entityFormType'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c5b2fafe94eb896eec3afc2d6ddc7d1'))['showDeleteEntity'] = false;
  ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['confirmDelete'] = null;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('2c5b2fafe94eb896eec3afc2d6ddc7d1');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bfc740c28995a8ce624eef8d8be9f43', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2c5b2fafe94eb896eec3afc2d6ddc7d1', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/0fccf2ecd6be947e26df67b969ac6492/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1'), 'helpCounter')) == null) {
    ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['textHelp'] = 'Close Help';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32fc7504aa56757e5d494e8dff5f346b', true);
    ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['helpCounter'] = 1;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1'), 'helpCounter')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['textHelp'] = 'Need Help?';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32fc7504aa56757e5d494e8dff5f346b', false);
    ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['helpCounter'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/8ddf293b8ef1616db96ff7cdccc21492/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_638eba35877693befcc18599a2221a2d']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1'), 'requesterFormUrl')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb239272fd53eb178c423673a65f4b92', true);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb239272fd53eb178c423673a65f4b92', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/5d4ee19f8fd200bf04d3dbac22cf88b7/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'typeInsuranceList'))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('2c5b2fafe94eb896eec3afc2d6ddc7d1')['requesterEntity.requesterInsuranceTypes'] = ((await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(','));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/requester-entity-mgmt/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  ___arguments.context.pageData['typeInsuranceList'] = (await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setSortBy('typeInsurance').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'typeInsurance')),[`label`]: (getObjectProperty(item, 'typeInsurance')) });})));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/template_dataGridPages/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: '[set in options logic handler]',[`pageName`]: 'facilities' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/test11122/components/79e404d29afba0558b6caf4ce665279c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var claimRecords;


  ___arguments.context.pageData['modal'] = ({ [`title`]: 'Modal Title',[`content`]: 'Your 837 File is successfully submitted to Waystar!',[`submit`]: '' });
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('5408ec4856e873b825f8f1d876c83071');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test11122/components/7d19411d13c43cc9d08bbc8465411bc6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function readFileContent(encoding, result) {
    if (!encoding) {
      if (typeof Buffer !== 'undefined') {
        return result instanceof Buffer
          ? result.toJSON().data
          : Buffer.from(JSON.stringify(result)).toJSON().data
      }

      return result
    }

    if (result && typeof result === 'object') {
      return JSON.stringify(result)
    }

    return result
}


  await Backendless.Request.post(`${Backendless.appPath}/services/sftpUtils/sendFileOverSFTP`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'fileData': (await Backendless.Request.get((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(encodePath((await Backendless.Files.saveFile(encodePath('/export/edi-files'), 'testBackendless.CLP', 'ISA*00*          *00*          *ZZ*500000191      *ZZ*731476619      *241112*1717*^*00501*000557666*1*T*:~ GS*HC*500000191*731476619*20241112*1717*599248*X*005010X222A1~ ST*837*0001*005010X222A1~ BHT*0019*00*599298*20241112*171718*CH~ NM1*41*2*ZIRMED INC*****46*500000191~ PER*IC*EDI Operations*TE*8774947633*EX*7*EM*PRODUCTION@ZIRMED.COM~ NM1*40*2*OKLAHOMA MEDICAID*****46*731476619~ HL*1**20*1~ NM1*85*2*OK RIDE CARE*****XX*1699554634~ N3*2404 WESTPORT DR~ N4*NORMAN*OK*730696336~ REF*EI*460868747~ PER*IC*OK RIDE CARE*TE*4052373043~ HL*2*1*22*0~ SBR*P*18*******MC~ NM1*IL*1*SCARBOROUGH*CODY****MI*6669685~ N3*193461 E COUNTY RD 304~ N4*FORT SUPPLY*OK*73841~ DMG*D8*19770915*M~ NM1*PR*2*OKLAHOMA HEALTH CARE AUTHORITY*****PI*731476619~ CLM*5PYS56B-COD.SCA.1103*962.05***99:B:1*Y*A*Y*Y~ REF*D9*2201817586~ HI*ABK:Z1330~ NM1*82*2*SIGNATURE ON FILE*****XX*1234567893~ LX*1~ SV1*HC:T2003*1.6*UN*1***1~ DTP*472*D8*20241101~ REF*6R*2201817586Z1~ LX*2~ SV1*HC:S0215*960.45*UN*337***1~ DTP*472*D8*20241101~ REF*6R*2201817586Z2~ SE*31*0001~ GE*1*599248~ IEA*1*000557666~', true))))).setEncoding('utf8').then(result => readFileContent('utf8', result))),'fileName': 'testBackendless.CLP' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test11122/components/7ef87848fadcecd80c39e4bd05682eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list1, list2, listOfLists, map, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  map = ({  });
  if ((getObjectProperty(map, 'test')) == null) {
    console.log('null');
  }
  map['clientId'] = [];
  addItemToList((getObjectProperty(map, 'clientId')), 'entry1');
  addItemToList((getObjectProperty(map, 'clientId')), 'entry2');
  console.log(getObjectProperty(map, 'clientId'));
  if ((getObjectProperty(map, 'test')) == null) {
    console.log('null');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testDateOfBirth/components/737d35eda5bd0d37337a7f854b1d13d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var facilities, mapToOriginal, orig, dup, objectId, item2, item1, duplicates, originalId, k, original, iii, uniqueFacilitiesByCoordsMap, uniqueFacilitiesByAddressMap, coordKey, address, isDuplicate, lng, lat, tmp, invalidNames, validNames, invalidCoords, ii, validCoords, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  console.log('abc');
  facilities = [];
  count = 0;
  for (var count2 = 0; count2 < 11; count2++) {
    facilities = (facilities.concat((await Backendless.Data.of('Facility').find(Backendless.DataQueryBuilder.create().setPageSize(100).setOffset(count)))));
    count = count + 100;
  }
  invalidCoords = [];
  validCoords = [];
  invalidNames = [];
  validNames = [];
  console.log('11111111');
  console.log(invalidNames);
  console.log(validNames);
  console.log('22222222');
  console.log(facilities);
  uniqueFacilitiesByAddressMap = ({  });
  uniqueFacilitiesByCoordsMap = ({  });
  duplicates = [];
  mapToOriginal = ({  });
  for (var iii_index in facilities) {
    iii = facilities[iii_index];
    lat = (await (async function(coordinate) {
    	const factor = Math.pow(10, 3); // 10^3 = 1000
    	return Math.trunc(coordinate * factor) / factor;
    })((getObjectProperty(iii, 'latitude'))));
    lng = (await (async function(coordinate) {
    	const factor = Math.pow(10, 3); // 10^3 = 1000
    	return Math.trunc(coordinate * factor) / factor;
    })((getObjectProperty(iii, 'longitude'))));
    address = (getObjectProperty(iii, 'googleFormattedAddress'));
    coordKey = [lat,' ,',lng].join('');
    isDuplicate = false;
    original = null;
    if (!(getObjectProperty(uniqueFacilitiesByAddressMap, address)) || (getObjectProperty((getObjectProperty(uniqueFacilitiesByAddressMap, address)), 'created')) > (getObjectProperty(iii, 'created'))) {
      if (getObjectProperty(uniqueFacilitiesByAddressMap, address)) {
        addItemToList(duplicates, (getObjectProperty(uniqueFacilitiesByAddressMap, address)));
        mapToOriginal[(getObjectProperty((getObjectProperty(uniqueFacilitiesByAddressMap, address)), 'objectId'))] = (getObjectProperty(iii, 'objectId'));
      }
      uniqueFacilitiesByAddressMap[address] = iii;
      original = iii;
    } else {
      addItemToList(duplicates, iii);
      mapToOriginal[(getObjectProperty(iii, 'objectId'))] = (getObjectProperty((getObjectProperty(uniqueFacilitiesByAddressMap, address)), 'objectId'));
      original = (getObjectProperty(uniqueFacilitiesByAddressMap, address));
    }
    if (!(getObjectProperty(uniqueFacilitiesByCoordsMap, coordKey)) || (getObjectProperty((getObjectProperty(uniqueFacilitiesByCoordsMap, coordKey)), 'created')) > (getObjectProperty(iii, 'created'))) {
      if (getObjectProperty(uniqueFacilitiesByCoordsMap, coordKey)) {
        addItemToList(duplicates, (getObjectProperty(uniqueFacilitiesByCoordsMap, coordKey)));
        mapToOriginal[(getObjectProperty((getObjectProperty(uniqueFacilitiesByCoordsMap, coordKey)), 'objectId'))] = (getObjectProperty(iii, 'objectId'));
      }
      uniqueFacilitiesByCoordsMap[coordKey] = iii;
      original = original || iii;
    } else {
      addItemToList(duplicates, iii);
      mapToOriginal[(getObjectProperty(iii, 'objectId'))] = (getObjectProperty((getObjectProperty(uniqueFacilitiesByCoordsMap, coordKey)), 'objectId'));
      original = (getObjectProperty(uniqueFacilitiesByCoordsMap, coordKey));
    }
    console.log('abc');
  }
  console.log(uniqueFacilitiesByAddressMap);
  console.log(uniqueFacilitiesByCoordsMap);
  var k_list = (Object.keys(mapToOriginal));
  for (var k_index in k_list) {
    k = k_list[k_index];
    originalId = (getObjectProperty(mapToOriginal, k));
    while (getObjectProperty(mapToOriginal, originalId)) {
      originalId = (getObjectProperty(mapToOriginal, originalId));
    }
    mapToOriginal[k] = originalId;
  }
  console.log(duplicates.length);
  console.log(duplicates);
  console.log(mapToOriginal);
  console.log('');
  var objectId_list = (Object.keys(mapToOriginal));
  for (var objectId_index in objectId_list) {
    objectId = objectId_list[objectId_index];
    console.log('count');
    dup = (await asyncListFind(facilities, async (item1) => {


     return ((getObjectProperty(item1, 'objectId')) == objectId);
    }));
    orig = (await asyncListFind(facilities, async (item2) => {


     return ((getObjectProperty(item2, 'objectId')) == (getObjectProperty(mapToOriginal, objectId)));
    }));
    if ((getObjectProperty(dup, 'googleFormattedAddress')) != (getObjectProperty(orig, 'googleFormattedAddress')) && ((await (async function(coordinate) {
    	const factor = Math.pow(10, 3); // 10^3 = 1000
    	return Math.trunc(coordinate * factor) / factor;
    })((getObjectProperty(dup, 'latitude')))) != (await (async function(coordinate) {
    	const factor = Math.pow(10, 3); // 10^3 = 1000
    	return Math.trunc(coordinate * factor) / factor;
    })((getObjectProperty(orig, 'latitude')))) || (await (async function(coordinate) {
    	const factor = Math.pow(10, 3); // 10^3 = 1000
    	return Math.trunc(coordinate * factor) / factor;
    })((getObjectProperty(dup, 'longitude')))) != (await (async function(coordinate) {
    	const factor = Math.pow(10, 3); // 10^3 = 1000
    	return Math.trunc(coordinate * factor) / factor;
    })((getObjectProperty(orig, 'longitude'))))) || (getObjectProperty(dup, 'created')) < (getObjectProperty(orig, 'created'))) {
      console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
      console.log((getObjectProperty(dup, 'created')) < (getObjectProperty(orig, 'created')));
      console.log(Number.parseFloat((getObjectProperty(dup, 'latitude'))).toFixed(3));
      console.log((await (async function(coordinate) {
      	const factor = Math.pow(10, 3); // 10^3 = 1000
      	return Math.trunc(coordinate * factor) / factor;
      })((getObjectProperty(dup, 'latitude')))));
      console.log(Number.parseFloat((getObjectProperty(orig, 'latitude'))).toFixed(3));
      console.log((await (async function(coordinate) {
      	const factor = Math.pow(10, 3); // 10^3 = 1000
      	return Math.trunc(coordinate * factor) / factor;
      })((getObjectProperty(orig, 'latitude')))));
      console.log(Number.parseFloat((getObjectProperty(dup, 'longitude'))).toFixed(3));
      console.log((await (async function(coordinate) {
      	const factor = Math.pow(10, 3); // 10^3 = 1000
      	return Math.trunc(coordinate * factor) / factor;
      })((getObjectProperty(dup, 'longitude')))));
      console.log(Number.parseFloat((getObjectProperty(orig, 'longitude'))).toFixed(3));
      console.log((await (async function(coordinate) {
      	const factor = Math.pow(10, 3); // 10^3 = 1000
      	return Math.trunc(coordinate * factor) / factor;
      })((getObjectProperty(orig, 'longitude')))));
      console.log(dup);
      console.log(orig);
    }
  }
  console.log(Object.keys(mapToOriginal));
  console.log((await (async function(facilities) {
  	const formatCoords = (coordinate) => {
  	  const factor = Math.pow(10, 3); // 10^3 = 1000
  	  const truncated = Math.trunc(coordinate * factor) / factor;
  	  return truncated.toFixed(3);
  	}

  	// const findDuplicates = (facilities) => {
  	//   const originalMap = new Map();
  	//   const duplicateMap = new Map();

  	//   facilities.forEach((facility) => {
  	//     const addressKey = facility.googleFormattedAddress;
  	//     const coordsKey = `${formatCoords(facility.latitude)},${formatCoords(facility.longitude)}`;

  	//     // Найти оригиналы по обоим ключам
  	//     const existingOriginalByAddress = originalMap.get(addressKey);
  	//     const existingOriginalByCoords = originalMap.get(coordsKey);

  	//     let original = null;

  	//     if (existingOriginalByAddress && existingOriginalByCoords) {
  	//       // Выбираем самый старый оригинал из двух
  	//       original = existingOriginalByAddress.created <= existingOriginalByCoords.created ? existingOriginalByAddress : existingOriginalByCoords;
  	//     } else {
  	//       // Если один из оригиналов существует, используем его
  	//       original = existingOriginalByAddress || existingOriginalByCoords;
  	//     }

  	//     if (original) {
  	//       // Если найден оригинал, текущий объект помечается как дубликат
  	//       if (facility.created < original.created) {
  	//         // Если текущий объект создан раньше, он становится новым оригиналом
  	//         duplicateMap.set(original.objectId, facility.objectId);
  	//         originalMap.set(addressKey, facility);
  	//         originalMap.set(coordsKey, facility);

  	//         // Обновляем все предыдущие дубликаты, чтобы они ссылались на нового оригинала
  	//         duplicateMap.forEach((value, key) => {
  	//           if (value === original.objectId) {
  	//             duplicateMap.set(key, facility.objectId);
  	//           }
  	//         });

  	//       } else {
  	//         duplicateMap.set(facility.objectId, original.objectId);
  	//       }
  	//     } else {
  	//       // Если оригинала нет, текущий объект становится оригиналом
  	//       originalMap.set(addressKey, facility);
  	//       originalMap.set(coordsKey, facility);
  	//     }
  	//   });

  	//   return duplicateMap;
  	// };

  	const findDuplicates = (facilities) => {
  	  const duplicateMap = new Map();

  	  facilities.forEach((facility) => {
  	    let originalByCoords = null;
  	    let originalByAddress = null;

  	    // Первый проход: проверка по координатам
  	    facilities.forEach((candidate) => {
  	      if (
  	        formatCoords(facility.latitude) === formatCoords(candidate.latitude) &&
  	        formatCoords(facility.longitude) === formatCoords(candidate.longitude) &&
  	        facility.isPrivateResidence === candidate.isPrivateResidence &&
  	        (originalByCoords === null || candidate.created < originalByCoords.created)
  	      ) {
  	        originalByCoords = candidate;
  	      }
  	    });

  	    // Второй проход: проверка по адресу
  	    facilities.forEach((candidate) => {
  	      if (
  	        facility.googleFormattedAddress === candidate.googleFormattedAddress && facility.isPrivateResidence === candidate.isPrivateResidence &&
  	        (originalByAddress === null || candidate.created < originalByAddress.created)
  	      ) {
  	        originalByAddress = candidate;
  	      }
  	    });

  	    let finalOriginal = null;

  	    if (originalByCoords && originalByAddress) {
  	      // Если оба оригинала найдены, выбираем старший
  	      finalOriginal = originalByCoords.created <= originalByAddress.created ? originalByCoords : originalByAddress;
  	    } else {
  	      // Иначе выбираем тот, который найден
  	      finalOriginal = originalByCoords || originalByAddress;
  	    }

  	    if (finalOriginal && finalOriginal.objectId !== facility.objectId) {
  	      duplicateMap.set(facility.objectId, finalOriginal.objectId);
  	    }
  	  });

  	  return duplicateMap;
  	};

  	const duplicatesMap = findDuplicates(facilities);

  	console.log('!!!!!duplicatesMap', duplicatesMap)

  	const originalToDuplicatesMap = {};

  	// for (const [duplicate, original] of Object.entries(duplicatesMap
  	duplicatesMap.forEach((original, duplicate) => {
  	  if (!originalToDuplicatesMap[original]) {
  	    originalToDuplicatesMap[original] = [];
  	  }
  	  originalToDuplicatesMap[original].push(duplicate);
  	})

  	const formatDate = (timestamp) => {
  	  const date = new Date(timestamp);
  	  return date.toLocaleDateString('en-US', {
  	    year: 'numeric',
  	    month: '2-digit',
  	    day: '2-digit',
  	  }) + ', ' + date.toLocaleTimeString('en-US', {
  	    hour: '2-digit',
  	    minute: '2-digit',
  	    second: '2-digit',
  	    hour12: false
  	  }) + `.${date.getMilliseconds()}`;
  	};


  	const getFacilityDataById = (id) => {
  	  const facility = facilities.find(facility => facility.objectId === id);
  	  return `${facility.objectId} -- [googleFormattedAddress]: ${facility.googleFormattedAddress} -- [coordinates]: ${formatCoords(facility.latitude)} : ${formatCoords(facility.longitude)} -- [created]: ${formatDate(facility.created)}`;
  	};

  	let output = '';

  	for (const [original, duplicates] of Object.entries(originalToDuplicatesMap)) {
  	  const originalData = getFacilityDataById(original);
  	  output += `!Original: ${originalData}\n`;
  	  duplicates.forEach(duplicate => {
  	    const duplicateData = getFacilityDataById(duplicate);
  	    output += `Duplicate: ${duplicateData}\n`;
  	  });
  	  output += '\n';
  	}

  	console.log(output)
  	return output;
  })(facilities)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testDateOfBirth/components/63e33d0c8aeef13a2b3321b4df589b3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log(await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause((String('rel_TransportRequest.rel_Client.nameLast LIKE \'a%, b%\' '))).setPageSize(100)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testDateOfBirth/components/c1a15879062cb409b1e74ade4e2f02f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, testDatesWithTimeSummerTime, testDatesWithTime, testDatesSummerTime, testDates, savedObjectId, secondsPerHour, time;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Before Save');
  console.log(1 * 3600);
  console.log((await BackendlessUI.Functions.Custom['fn_3585a9c2fce2fe3521c9afc37ef5f2d7']((getObjectProperty(___arguments.context.pageData, 'dateOfBirth')))));
  console.log(getObjectProperty(___arguments.context.pageData, 'dateOfBirth'));
  console.log(new Date((getObjectProperty(___arguments.context.pageData, 'dateOfBirth'))));
  console.log(new Date());
  secondsPerHour = 0;
  savedObjectId = (await Backendless.Data.of('testTable1').save( ({ [`dateOfBirth`]: (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'dateOfBirth')))).getTime() + (((await BackendlessUI.Functions.Custom['fn_3585a9c2fce2fe3521c9afc37ef5f2d7']((getObjectProperty(___arguments.context.pageData, 'dateOfBirth')))) * 3600) * 1000))),[`DOB`]: (await (async function(dob) {


  	let birthDate = new Date(dob);
  	    const year = birthDate.getFullYear();
  	    const month = birthDate.getMonth();
  	    const day = birthDate.getDate();

  	    // Используем метод Date.UTC для создания времени без временной зоны (UTC), но на уровне даты
  	    // Таким образом, мы исключаем смещения на уровне часовых поясов
  	    const chicagoDate = Date.UTC(year, month, day, 0, 0, 0, 0);  // 00:00:00 времени

  	    // Корректируем для зоны America/Chicago (-6 часов по UTC или -5 в летнее время)
  	    const chicagoOffset = -6 * 60; // Смещение для CST (America/Chicago) в минутах
  	    const localTimestamp = new Date(chicagoDate).getTime() - (chicagoOffset * 60 * 1000);

  	    return localTimestamp;
  })((getObjectProperty(___arguments.context.pageData, 'dateOfBirth')))),[`DOB1`]: (await (async function(dateString) {
  	function isSummerTime(dateString) {
  	    // Create a date object from the date string
  	    const date = new Date(dateString)
  	    const year = date.getUTCFullYear() // Get the UTC year

  	    // Find the start and end of Daylight Saving Time (DST) for the given year
  	    let dstStart, dstEnd

  	    // DST rules for 1998 and onwards
  	    if (year >= 2007) {
  	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
  	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
  	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
  	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

  	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
  	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
  	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
  	    } else {
  	        // For years prior to 2007, including 1998
  	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
  	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
  	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

  	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
  	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
  	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
  	    }

  	    // Check if the date falls within the DST period
  	    return date >= dstStart && date < dstEnd
  	}

  	if (!dateString) {
  	  return null
  	}

  	const gmtOffset = isSummerTime(dateString) ? 'GMT-0500' : 'GMT-0600'
  	const dateInChicago = new Date(dateString + ' ' + gmtOffset)

  	return dateInChicago.getTime()

  })((getObjectProperty(___arguments.context.pageData, 'dateOfBirth')))) }) ));
  console.log('After Save');
  ___arguments.context.pageData['returnedObject'] = (await Backendless.Data.of('testTable1').findById(savedObjectId, ));
  console.log('After Load');
  console.log(getObjectProperty(___arguments.context.pageData, 'returnedObject.dateOfBirth'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f95f935ab1715cef30ad23c13265673', true);
  console.log('%c>> ' + 'DOB', 'color: #f06292', (new Date((await (async function(dob) {


  	let birthDate = new Date(dob);
  	    const year = birthDate.getFullYear();
  	    const month = birthDate.getMonth();
  	    const day = birthDate.getDate();

  	    // Используем метод Date.UTC для создания времени без временной зоны (UTC), но на уровне даты
  	    // Таким образом, мы исключаем смещения на уровне часовых поясов
  	    const chicagoDate = Date.UTC(year, month, day, 0, 0, 0, 0);  // 00:00:00 времени

  	    // Корректируем для зоны America/Chicago (-6 часов по UTC или -5 в летнее время)
  	    const chicagoOffset = -6 * 60; // Смещение для CST (America/Chicago) в минутах
  	    const localTimestamp = new Date(chicagoDate).getTime() - (chicagoOffset * 60 * 1000);

  	    return localTimestamp;
  })((getObjectProperty(___arguments.context.pageData, 'dateOfBirth')))))));
  console.log('%c>> ' + 'DOB1', 'color: #f06292', (new Date((await (async function(dateString) {
  	function isSummerTime(dateString) {
  	    // Create a date object from the date string
  	    const date = new Date(dateString)
  	    const year = date.getUTCFullYear() // Get the UTC year

  	    // Find the start and end of Daylight Saving Time (DST) for the given year
  	    let dstStart, dstEnd

  	    // DST rules for 1998 and onwards
  	    if (year >= 2007) {
  	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
  	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
  	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
  	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

  	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
  	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
  	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
  	    } else {
  	        // For years prior to 2007, including 1998
  	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
  	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
  	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

  	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
  	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
  	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
  	    }

  	    // Check if the date falls within the DST period
  	    return date >= dstStart && date < dstEnd
  	}

  	if (!dateString) {
  	  return null
  	}

  	const gmtOffset = isSummerTime(dateString) ? 'GMT-0500' : 'GMT-0600'
  	const dateInChicago = new Date(dateString + ' ' + gmtOffset)

  	return dateInChicago.getTime()

  })((getObjectProperty(___arguments.context.pageData, 'dateOfBirth')))))));
  testDates = ['02/01/2024', '11/15/2024', '12/01/2025', '03/03/2023', '11/03/2022', '10/31/2023', '11/22/1990', '12/31/1960'];
  testDatesSummerTime = ['06/15/2024', '07/10/2023', '09/30/2025', '03/10/2024', '03/15/2023', '05/01/2024', '08/05/2022', '03/31/1998'];
  testDatesWithTime = ['02/01/2024 12:00:00 ', '11/15/2024 09:00:00 ', '12/01/2025 15:30:00', '03/03/2023 11:00:00', '11/03/2022 03:30:00', '10/31/2023 13:45:00 ', '11/22/1990 12:15:22', '12/31/1960 16:33:29'];
  testDatesWithTimeSummerTime = ['06/15/2024 12:00:00 ', '7/10/2024 10:45:01 AM', '09/30/2025 18:45:00', '03/10/2024 03:00:00', '03/15/2022 14:00:00', '05/01/2023 10:15:00', '08/05/2022 20:30:00', '03/31/1998 17:10:00', '2024-09-26T09:25:51'];
  console.log('%c>> ' + '>>>>>TestDates:', 'color: #3f51b5', undefined);
  for (var j_index in testDates) {
    j = testDates[j_index];
    console.log('%c>> ' + 'Date String ----->', 'color: #f06292', j);
    console.log('%c>> ' + 'UTC ------------->', 'color: #26a69a', (new Intl.DateTimeFormat('en-US', ({ [`timeZone`]: 'UTC',[`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`second`]: '2-digit',[`hour12`]: false })).format((new Date((await (async function(dateString) {
    	function isSummerTime(dateString) {
    	    // Create a date object from the date string
    	    const date = new Date(dateString)
    	    const year = date.getUTCFullYear() // Get the UTC year

    	    // Find the start and end of Daylight Saving Time (DST) for the given year
    	    let dstStart, dstEnd

    	    // DST rules for 1998 and onwards
    	    if (year >= 2007) {
    	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
    	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
    	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    } else {
    	        // For years prior to 2007, including 1998
    	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
    	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    }

    	    // Check if the date falls within the DST period
    	    return date >= dstStart && date < dstEnd
    	}

    	if (!dateString) {
    	  return null
    	}

    	const gmtOffset = isSummerTime(dateString) ? '-05:00' : '-06:00'
    	const dateInChicago = new Date(dateString + gmtOffset)

    	return dateInChicago.getTime()

    })(j)))))));
    console.log('%c>> ' + 'America/Chicago ->', 'color: #4caf50', (new Intl.DateTimeFormat('en-US', ({ [`timeZone`]: 'America/Chicago',[`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`second`]: '2-digit',[`hour12`]: false })).format((new Date((await (async function(dateString) {
    	function isSummerTime(dateString) {
    	    // Create a date object from the date string
    	    const date = new Date(dateString)
    	    const year = date.getUTCFullYear() // Get the UTC year

    	    // Find the start and end of Daylight Saving Time (DST) for the given year
    	    let dstStart, dstEnd

    	    // DST rules for 1998 and onwards
    	    if (year >= 2007) {
    	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
    	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
    	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    } else {
    	        // For years prior to 2007, including 1998
    	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
    	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    }

    	    // Check if the date falls within the DST period
    	    return date >= dstStart && date < dstEnd
    	}

    	if (!dateString) {
    	  return null
    	}

    	const gmtOffset = isSummerTime(dateString) ? '-05:00' : '-06:00'
    	const dateInChicago = new Date(dateString + gmtOffset)

    	return dateInChicago.getTime()

    })(j)))))));
  }
  console.log('%c>> ' + '>>>>>TestDatesSummerTime:', 'color: #3f51b5', undefined);
  for (var j_index2 in testDatesSummerTime) {
    j = testDatesSummerTime[j_index2];
    console.log('%c>> ' + 'Date String ----->', 'color: #f06292', j);
    console.log('%c>> ' + 'UTC ------------->', 'color: #26a69a', (new Intl.DateTimeFormat('en-US', ({ [`timeZone`]: 'UTC',[`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`second`]: '2-digit',[`hour12`]: false })).format((new Date((await (async function(dateString) {
    	function isSummerTime(dateString) {
    	    // Create a date object from the date string
    	    const date = new Date(dateString)
    	    const year = date.getUTCFullYear() // Get the UTC year

    	    // Find the start and end of Daylight Saving Time (DST) for the given year
    	    let dstStart, dstEnd

    	    // DST rules for 1998 and onwards
    	    if (year >= 2007) {
    	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
    	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
    	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    } else {
    	        // For years prior to 2007, including 1998
    	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
    	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    }

    	    // Check if the date falls within the DST period
    	    return date >= dstStart && date < dstEnd
    	}

    	if (!dateString) {
    	  return null
    	}
    	console.log('dateString', dateString)
    	const gmtOffset = isSummerTime(dateString) ? '-05:00' : '-06:00'
    	const dateInChicago = new Date(dateString + gmtOffset)

    	return dateInChicago.getTime()

    })(j)))))));
    console.log('%c>> ' + 'America/Chicago ->', 'color: #4caf50', (new Intl.DateTimeFormat('en-US', ({ [`timeZone`]: 'America/Chicago',[`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`second`]: '2-digit',[`hour12`]: false })).format((new Date((await (async function(dateString) {
    	function isSummerTime(dateString) {
    	    // Create a date object from the date string
    	    const date = new Date(dateString)
    	    const year = date.getUTCFullYear() // Get the UTC year

    	    // Find the start and end of Daylight Saving Time (DST) for the given year
    	    let dstStart, dstEnd

    	    // DST rules for 1998 and onwards
    	    if (year >= 2007) {
    	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
    	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
    	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    } else {
    	        // For years prior to 2007, including 1998
    	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
    	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    }

    	    // Check if the date falls within the DST period
    	    return date >= dstStart && date < dstEnd
    	}

    	if (!dateString) {
    	  return null
    	}

    	const gmtOffset = isSummerTime(dateString) ? '-05:00' : '-06:00'
    	const dateInChicago = new Date(dateString + gmtOffset)

    	return dateInChicago.getTime()

    })(j)))))));
  }
  console.log('%c>> ' + '>>>>>TestDatesWithTime:', 'color: #3f51b5', undefined);
  for (var j_index3 in testDatesWithTime) {
    j = testDatesWithTime[j_index3];
    console.log('%c>> ' + 'Date String ----->', 'color: #f06292', j);
    console.log('%c>> ' + 'UTC ------------->', 'color: #26a69a', (new Intl.DateTimeFormat('en-US', ({ [`timeZone`]: 'UTC',[`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`second`]: '2-digit',[`hour12`]: false })).format((new Date((await (async function(dateString) {
    	function isSummerTime(dateString) {
    	    // Create a date object from the date string
    	    const date = new Date(dateString)
    	    const year = date.getUTCFullYear() // Get the UTC year

    	    // Find the start and end of Daylight Saving Time (DST) for the given year
    	    let dstStart, dstEnd

    	    // DST rules for 1998 and onwards
    	    if (year >= 2007) {
    	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
    	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
    	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    } else {
    	        // For years prior to 2007, including 1998
    	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
    	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    }

    	    // Check if the date falls within the DST period
    	    return date >= dstStart && date < dstEnd
    	}

    	if (!dateString) {
    	  return null
    	}

    	const gmtOffset = isSummerTime(dateString) ? '-05:00' : '-06:00'
    	const dateInChicago = new Date(dateString + gmtOffset)

    	return dateInChicago.getTime()

    })(j)))))));
    console.log('%c>> ' + 'America/Chicago ->', 'color: #4caf50', (new Intl.DateTimeFormat('en-US', ({ [`timeZone`]: 'America/Chicago',[`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`second`]: '2-digit',[`hour12`]: false })).format((new Date((await (async function(dateString) {
    	function isSummerTime(dateString) {
    	    // Create a date object from the date string
    	    const date = new Date(dateString)
    	    const year = date.getUTCFullYear() // Get the UTC year

    	    // Find the start and end of Daylight Saving Time (DST) for the given year
    	    let dstStart, dstEnd

    	    // DST rules for 1998 and onwards
    	    if (year >= 2007) {
    	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
    	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
    	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    } else {
    	        // For years prior to 2007, including 1998
    	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
    	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    }

    	    // Check if the date falls within the DST period
    	    return date >= dstStart && date < dstEnd
    	}

    	if (!dateString) {
    	  return null
    	}

    	const gmtOffset = isSummerTime(dateString) ? '-05:00' : '-06:00'
    	const dateInChicago = new Date(dateString + gmtOffset)

    	return dateInChicago.getTime()

    })(j)))))));
  }
  console.log('%c>> ' + '>>>>>TestDatesWithTimeSummerTime:', 'color: #3f51b5', undefined);
  for (var j_index4 in testDatesWithTimeSummerTime) {
    j = testDatesWithTimeSummerTime[j_index4];
    console.log('%c>> ' + 'Date String ----->', 'color: #f06292', j);
    console.log('%c>> ' + 'UTC ------------->', 'color: #26a69a', (new Intl.DateTimeFormat('en-US', ({ [`timeZone`]: 'UTC',[`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`second`]: '2-digit',[`hour12`]: false })).format((new Date((await (async function(dateString) {
    	function isSummerTime(dateString) {
    	    // Create a date object from the date string
    	    const date = new Date(dateString)
    	    const year = date.getUTCFullYear() // Get the UTC year

    	    // Find the start and end of Daylight Saving Time (DST) for the given year
    	    let dstStart, dstEnd

    	    // DST rules for 1998 and onwards
    	    if (year >= 2007) {
    	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
    	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
    	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    } else {
    	        // For years prior to 2007, including 1998
    	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
    	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    }

    	    // Check if the date falls within the DST period
    	    return date >= dstStart && date < dstEnd
    	}

    	if (!dateString) {
    	  return null
    	}

    	const gmtOffset = isSummerTime(dateString) ? '-05:00' : '-06:00'
    	const dateInChicago = new Date(dateString + gmtOffset)

    	return dateInChicago.getTime()

    })(j)))))));
    console.log('%c>> ' + 'America/Chicago ->', 'color: #4caf50', (new Intl.DateTimeFormat('en-US', ({ [`timeZone`]: 'America/Chicago',[`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`second`]: '2-digit',[`hour12`]: false })).format((new Date((await (async function(dateString) {
    	function isSummerTime(dateString) {
    	    // Create a date object from the date string
    	    const date = new Date(dateString)
    	    const year = date.getUTCFullYear() // Get the UTC year

    	    // Find the start and end of Daylight Saving Time (DST) for the given year
    	    let dstStart, dstEnd

    	    // DST rules for 1998 and onwards
    	    if (year >= 2007) {
    	        // From 2007 onwards: starts on the second Sunday in March and ends on the first Sunday in November
    	        dstStart = new Date(Date.UTC(year, 2, 1)) // March 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in March
    	        dstStart.setUTCDate(firstSunday + 7) // Move to the second Sunday

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    } else {
    	        // For years prior to 2007, including 1998
    	        dstStart = new Date(Date.UTC(year, 3, 1)) // April 1st
    	        const firstSunday = 1 + (7 - dstStart.getUTCDay()) % 7 // Find the first Sunday in April
    	        dstStart.setUTCDate(firstSunday) // Set to the first Sunday in April

    	        dstEnd = new Date(Date.UTC(year, 10, 1)) // November 1st
    	        const firstSundayEnd = 1 + (7 - dstEnd.getUTCDay()) % 7 // Find the first Sunday in November
    	        dstEnd.setUTCDate(firstSundayEnd) // Set to the first Sunday
    	    }

    	    // Check if the date falls within the DST period
    	    return date >= dstStart && date < dstEnd
    	}

    	if (!dateString) {
    	  return null
    	}

    	const gmtOffset = isSummerTime(dateString) ? '-05:00' : '-06:00'
    	const dateInChicago = new Date(dateString + gmtOffset)

    	return dateInChicago.getTime()

    })(j)))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testDateOfBirth/components/7f95f935ab1715cef30ad23c13265673/bundle.js', [], () => ({
  /* content */
  /* handler:initValueLogic */
  async ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Value Logic Handler:');
  console.log(___arguments.context.pageData);

  return (await (async function(timestamp) {
	if (!timestamp) {
	    return ''
	  }
	  
	  const date = new Date(timestamp);
	
	  const month = date.getMonth() + 1;
	  const day = date.getDate();
	  const year = date.getFullYear();
	
	  const monthString = month < 10 ? '0' + month : month.toString();
	  const dayString = day < 10 ? '0' + day : day.toString();
	
	  return `${monthString}${dayString}${year}`;
})((getObjectProperty(___arguments.context.pageData, 'returnedObject.dateOfBirth'))))

  },
  /* handler:initValueLogic */
  /* content */
}))

define('./pages/testDateOfBirth/components/7089fa23061f8271af0a107d330acbd7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f95f935ab1715cef30ad23c13265673', false);
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testDateOfBirth/components/e58b73728273a407db28cdaefef74237/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['testProperty'] = 'testValue';
  console.log(JSON.stringify(___arguments.context.pageData));
  console.log((await (async function(object) {
  	console.log(JSON.stringify(object, null, 3));
  })(___arguments.context.pageData)));
  console.log((await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788'](___arguments.context.pageData)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testSendRTChannelCommand/components/e5bb620c79d9c658b83a8f6c699978fa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  console.log('On Click Event.');
  await (getChannelInstance('default')).send((String('reload-table-records:') + String('TransportRequests')), ({ [`ids`]: ['0123C253-AE98-48F6-98C5-168ED27E98C9'] }));
  console.log('After RT Channel Command Sent.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_JHexport/components/3aad0ffca40bdc679d9fcda97dcf4849/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['csvFilePath'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/export/billing-data/',((new Date()).valueOf()),'.csv'].join('')),'tableName': 'Transport','tableOptions': ({ [`where`]: '',[`properties`]: ['datetimeScheduledStart', 'rel_TransportRequest.rel_Client.nameFull'],[`sortBy`]: 'datetimeScheduledStart asc' }),'csvOptions': ({ [`header`]: true,[`columns`]: undefined }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://app.okridecare.com/api/files') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'csvFilePath'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_X12/components/6089882a000474e2e8c48704cba76a59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var subZipCode, subState, subCity, subAddress, groupControlNum, transportRecord, whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function testFunction() {
  ___arguments.context.pageData['transportRecord'] = ((await Backendless.Data.of('Transport').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setRelationsDepth(2).setPageSize(10)))[0]);
}


  whereClause = 'transportCode_copy = ';
  whereClause = String(whereClause) + String((await (async function(str) {
  	return '\'' + str + '\''
  })((getObjectProperty(___arguments.context.pageData, 'record')))));
  await testFunction();
  groupControlNum = (await (async function(num) {
  	return num.toString().padStart(8, '0');

  })((getObjectProperty((await Backendless.Data.of('braxtonTestTable').save( ({ [`propName`]: undefined }) )), 'transactionNumbers'))));
  console.log(groupControlNum);
  subAddress = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.address'));
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.address')) == null) {
    subAddress = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.address'));
  }
  subZipCode = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.zipcode'));
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.zipcode')) == null) {
    subZipCode = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.zipcode'));
  }
  subCity = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.address'));
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.city')) == null) {
    subCity = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.city'));
  }
  subState = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.address'));
  if ((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.stateCode')) == null) {
    subState = (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.relDestination_Facility.stateCode'));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.age'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.age'));
  console.log(subAddress);
  console.log(subZipCode);
  console.log(subState);
  console.log(subCity);
  // Ask about where to get this value
  console.log((await Backendless.Request.post(`${Backendless.appPath}/services/createX12Transaction/create837Claim`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'groupControlNumber': groupControlNum,'referenceIdentifcation': 'UNKNOWN - String to track this 837 file','subscriberLastName': (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.nameLast')),'subscriberFirstName': (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.nameFirst')),'subscriberID': (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.insurancePolicyNumber')),'subscriberAddress': subAddress,'subscriberCity': subCity,'subscriberState': subState,'subscriberZip': subZipCode,'subscriberDOB': (await (async function(date) {
  	// returns date in "yyyy-mm-dd etcetcetc..." in yyyymmdd

  	const dates = date.split('-')
  	const yyyy = dates[0]
  	const mm = dates[1]
  	const dd = dates[2].substring(0, 3)

  	const res = yyyy + mm + dd

  	return res.slice(0, -1)


  })((getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.datestringDateOfBirth')))),'subscriberAssignedSex': (getObjectProperty(___arguments.context.pageData, 'transportRecord.rel_TransportRequest.rel_Client.assignedSexAtBirth')),'payerName': 'UNKNOWN_PAYER_NAME','payerID': 'UNKNOWN_PAYER_ID','claimFilingIndicatorCode': 'UNKNOWN_FILING_CODE','patientAccountNumber': (getObjectProperty(___arguments.context.pageData, 'transportRecord.transportCode_copy')),'totalCharges': (getObjectProperty(___arguments.context.pageData, 'transportRecord.chargesTotal')),'chargesFlat': (getObjectProperty(___arguments.context.pageData, 'transportRecord.chargesFlat')),'numberOfTrips': 1,'transportDate': (await (async function(date) {
  	// returns date in "yyyy-mm-dd etcetcetc..." in yyyymmdd

  	const dates = date.split('-')
  	const yyyy = dates[0]
  	const mm = dates[1]
  	const dd = dates[2].substring(0, 3)

  	const res = yyyy + mm + dd

  	return res.slice(0, -1)


  })((getObjectProperty(___arguments.context.pageData, 'transportRecord.datestringScheduledStart')))),'chargesOverThirtyMileage': (getObjectProperty(___arguments.context.pageData, 'transportRecord.chargesOver30Mileage')),'numberOfMilesAboveThirty': (getObjectProperty(___arguments.context.pageData, 'transportRecord.distanceBillable')),'currentYear': (JSON.stringify((new Date(((new Date()).toLocaleString())).getFullYear()))),'currentMonth': (await (async function(str) {
  	return str.padStart(2, '0');

  })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMonth() + 1))))),'currentDay': (await (async function(str) {
  	return str.padStart(2, '0');

  })((JSON.stringify((new Date(((new Date()).toLocaleString())).getDate()))))),'currentHour': (await (async function(str) {
  	return str.padStart(2, '0');

  })((JSON.stringify((new Date(((new Date()).toLocaleString())).getHours()))))),'currentMinute': (await (async function(str) {
  	return str.padStart(2, '0');

  })((JSON.stringify((new Date(((new Date()).toLocaleString())).getMinutes()))))),'interchangeControlNumber': '1','usageIndicator': 'T','submitterETINCode': 'UNKNOWN_ETIN','receiverETINCode': 'UNKNOWN_ETIN','billPhone': '4052373043','billNPI': '1699554634','billAddress': '2404 Westport Dr','billCity': 'Norman','billState': 'OK','billZip': '730696336','billTin': '460868747','placeOfServiceCode': '99','facilityCodeQualifier': 'B','claimFrequencyCode': '1','providerSignatureIndicator': 'Y','medicareAssignmentCode': 'A','benefitsAssignmentCertificationIndicator': 'Y','releaseOfInformationCode': 'Y','diagCode1': 'Z1330','facilityNPICode': '1234567893','procCode1': 'T2003','procCode2': 'S0215','diagPtr1': '1' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_X12/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['record'] = 'Enter transportCode_copy here';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/test_X12/components/bde6be786e6f874db083bab96058ea48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(new Date(((new Date()).toLocaleString())).getTime());
  console.log(new Date(((new Date()).toLocaleString())).getHours());
  console.log(new Date(((new Date()).toLocaleString())).getMinutes());
  console.log(new Date(((new Date()).toLocaleString())).getMonth() + 1);
  console.log(new Date(((new Date()).toLocaleString())).getDate());
  console.log(new Date(((new Date()).toLocaleString())).getFullYear());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_transports/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Transports',[`pageName`]: 'transports' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/test_transports/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [
	  {
	    "type": "actions",
	    "headerName": "",
	    "headerTooltip": "Actions",
	    "field": "actions",
	    "width": 75,
	    "minWidth": 75,
	    "pinned": "left",
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "rel_TransportRequest.submissionCode",
	    "headerName": "Transport Code",
	    "pinned": "left",
	    "width": 140,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "datetimeDispatch",
	    "headerName": "Dispatch Time",
	    "type": "datetimeColumn",
	    "sort": "asc",
	    "pinned": "left",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "typeStatus",
	    "headerName": "Status",
	    "pinned": "left",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.statusOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" }
	  },
	  {
	    "field": "relDispatcher1_Employee.nameFull",
	    "headerName": "Dispatcher",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.dispatcherOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false
	  },
	  {
	    "field": "relDriver1_Employee.nameFull",
	    "headerName": "Driver",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.driverOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false
	  },
	  {
	    "field": "relVehicle1_Vehicle.vehicleName",
	    "headerName": "Vehicle",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.vehicleOptions || []
	    // },
	    "width": 100,
	    "sortable": true,
	    // "editable": true
	    "editable": false
	  },

	  {
	    "field": "datetimeScheduledStart",
	    "headerName": "Scheduled Start Time",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true
	  },
	  {
	    "field": "datetimeScheduledPickup",
	    "headerName": "Scheduled Pickup Time",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true
	  },
	  {
	    "field": "durationSubmissionToScheduledPickup",
	    "headerName": "Est. Response Time",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "meta": { "align": "center" }
	  },
	  {
	    "field": "isLongETA",
	    "headerName": "Long ETA?",
	    "type": "booleanColumn",
	    "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
	    "meta": {
	      "align": "center"
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": false
	  },
	  {
	    "field": "typeLongETAcause",
	    "headerName": "Long ETA Cause",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.longETAcauseOptions || []
	    },
	    "width": 180,
	    "sortable": true,
	    "editable": true
	  },
	  {
	    "field": "datetimeScheduledDropoff",
	    "headerName": "Scheduled Dropoff Time",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true
	  },
	  {
	    "field": "notesTransport",
	    "headerName": "Transport Notes",
	    // "type": "largeTextColumn",
	    // "cellEditorParams": {
	    //   "maxLength": 400,
	    //   "rows": 10,
	    //   "cols": 50,
	    // },
	    "width": 400,
	    "sortable": false,
	    "editable": true
	  },
	  {
	    "field": "relDispatcher2_Employee.nameFull",
	    "headerName": "Alt. Dispatcher",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.dispatcherOptions || []
	    // },
	    "width": 180,
	    "sortable": true,
	    // "editable": true
	    "editable": false
	  },
	  {
	    "field": "relDriver2_Employee.nameFull",
	    "headerName": "Alt. Driver",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.driverOptions || []
	    // },
	    "width": 180,
	    "sortable": true,
	    // "editable": true
	    "editable": false
	  },
	  {
	    "field": "relVehicle2_Vehicle.vehicleName",
	    "headerName": "Alt. Vehicle",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.vehicleOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false
	  },
	  // hidden
	  {
	    "field": "datetimeActualStart",
	    "headerName": "Actual Start Time",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualPickup",
	    "headerName": "Actual Pickup Time",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualPickupDeparture",
	    "headerName": "Actual Pickup Departure Time",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualDropoff",
	    "headerName": "Actual Dropoff Time",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    // "field": "datetimeActualEndOfDay",
	    "field": "datetimeEndOfRouteOrDay",
	    "headerName": "Actual End of Route or Day Time",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "hide": !pageData.showAllColumns
	  },


	  //***THIS IS LOWER PRIORITY.  MAY NOT BE NEEDED BY CLIENT.  ALSO REQUIRES CODELESS CALC AFTER SAMSARA DATA.
	  //{
	    //"field": "durationSubmissionToActualPickup",
	    //"headerName": "Actual Response Time",
	    //"sortable": true,
	    ////"cellClass": "calculatedField",
	    //"editable": false,
	    //"hide": !pageData.showAllColumns
	  //},

	  //***THIS IS LOWER PRIORITY.  MAY NOT BE NEEDED BY CLIENT.
	  //{
	    //"field": "durationDispatchToActualPickup",
	    //"headerName": "Actual Dispatch to Pickup Time",
	    //"sortable": true,
	    ////"cellClass": "calculatedField",
	    //"editable": false,
	    //"hide": !pageData.showAllColumns
	  //},
	  {
	    "field": "mileageStart",
	    "headerName": "Mileage at Start",
	    "sortable": true,
	    "editable": true,
	    "valueGetter": ns.stringToFixedValueGetter,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileagePickup",
	    "headerName": "Mileage at Pickup",
	    "sortable": true,
	    "editable": true,
	    "valueGetter": ns.stringToFixedValueGetter,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileageDropoff",
	    "headerName": "Mileage at Dropoff",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": true,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileageEndOfDay",
	    "headerName": "Mileage at End of Day",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": true,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationSubmissionToDispatch",
	    "headerName": "Time to Dispatch",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationDispatchToScheduledStart",
	    "headerName": "Time to Start",
	    "sortable": true,
	    "editable": false,
	    "valueGetter": ns.trimTimeStringValueGetter,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationDispatchToActualStart",
	    "headerName": "Time to Actual Start",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    //"cellClass": "calculatedField",
	    "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationRequestedTransportToScheduledPickup",
	    "headerName": "Estimated Pickup Delay",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "durationPickupWaitTime",
	    "headerName": "Pickup Wait Time",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationStartToEndOfRouteOrDay",
	    "headerName": "Transport Duration",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distanceStartToPickup",
	    "headerName": "Start to Pickup Distance",
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distancePickupToDropoff",
	    "headerName": "Pickup to Dropoff Distance",
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distanceStartToDropoff",
	    "headerName": "Start to Dropoff Distance",
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distanceDropoffToEndOfRouteOrDay",
	    "headerName": "Dropoff to End Point Distance",
	    "sortable": true,
	    "editable": false,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "rel_TransportRequest.rel_EntityRequestingTransport.requesterEntityName",
	    "headerName": "Requesting Entity",
	    "width": 160,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "hasInvoiceBeenSent",
	    "headerName": "Invoiced?",
	    "type": "booleanColumn",
	    "cellRenderer": ns.checkboxCheckmarkCellRenderer,
	    "meta": {
	      "align": "center"
	    },
	    "width": 100,
	    "sortable": true,
	    //"editable": false
	  },
	]
})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  if (___arguments['eventName'] == 'view-submission') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`transportRequestRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  } else if (___arguments['eventName'] == 'set-transporters') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
      return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relationsDepth: 2
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:onCellDoubleClicked */
  async ['onCellDoubleClicked'](___arguments) {
    var setTranspotersFields;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  setTranspotersFields = ['relDispatcher1_Employee.nameFull', 'relDriver1_Employee.nameFull', 'relVehicle1_Vehicle.vehicleName', 'relDispatcher2_Employee.nameFull', 'relDriver2_Employee.nameFull', 'relVehicle2_Vehicle.vehicleName'];
  if (setTranspotersFields.includes((getObjectProperty(___arguments['columnDef'], 'field')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['rowData'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['rowData'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['rowData'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['rowData'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['rowData'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }
  if ((getObjectProperty(___arguments['columnDef'], 'field')) == 'rel_TransportRequest.submissionCode') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`transportRequestRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  }

  },
  /* handler:onCellDoubleClicked */
  /* content */
}))

define('./pages/test_transports/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  ___arguments.context.pageData['transportReusableData'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_transports/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClause'] = 'typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_transports/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClause'] = 'datetimeDispatch >= DATESUB(NOW(), \'2\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_transports/components/64b22f2e967708cd2f23f0118fe71b96/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      // Need to initialize this so that we can set properties in
  // it later as part of Action Item clicks in the data grid
  ___arguments.context.pageData['recordPaths'] = ({  });

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/test_transports/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClause'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_transports/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = 'typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL';
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['dispatcherOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('LOWER(jobTitle) LIKE \'%dispatch%\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled'];
  ___arguments.context.pageData['longETAcauseOptions'] = [null, 'Facility', 'Prescheduled', 'Ride Care'];
  ___arguments.context.pageData['isReadOnlyMode'] = true;
  console.log(___arguments.context.pageData);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/test_transports/components/89f36a5f06a88beb7a4168f8c62af8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showAllColumns'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/test_transports/components/1c94c69498936d6389d94b712646580d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClause'] = 'isLongETA = TRUE';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_transports/components/98a64a9922fd6a0fb02b2b1ca4e17e9f/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/test_transports/components/d3d664ba260c7449dd2c7b8510b7d64f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('d0542e2dcb86d77de41d3dad9db99522');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle1_Vehicle.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle2_Vehicle.objectId'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/test_transports/components/d0542e2dcb86d77de41d3dad9db99522/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var relations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  relations = ({  });
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher1_Employee.objectId'))) {
    relations['relDispatcher1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDriver1_Employee.objectId'))) {
    relations['relDriver1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relVehicle1_Vehicle.objectId'))) {
    relations['relVehicle1_Vehicle'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher2_Employee.objectId'))) {
    relations['relDispatcher2_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.driverAlt')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.driverAlt')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDriver2_Employee.objectId'))) {
    relations['relDriver2_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.driverAlt')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicleAlt')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicleAlt')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relVehicle2_Vehicle.objectId'))) {
    relations['relVehicle2_Vehicle'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicleAlt')) });
  }
  if ((Object.keys(relations)).length != 0) {
    await Backendless.Data.of('Transport').deepSave( (Object.assign(({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId')) }), relations)) );
    await (getChannelInstance('default')).send('reload-table-records:Transport', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId'))] }));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
    stopSetTimeout('transportUpdateTransporters');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', true);
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', false);
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/test_transports/components/f013363f1862d6245c6531da6e1a2084/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
  stopSetTimeout('transportUpdateTransporters');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_transports/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/test_transports/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/test_transports/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/test_transports/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/test_transports/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/testsupp/components/e8f3e7c148f7143e13f21fa1dc8faf85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fa223ee3eb4bee5f3e370e88482c866', (await Backendless.Request.get(`${Backendless.appPath}/services/driverVehicleAwareness/DriverAvailability`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testsupp/components/3d3bc36372361c4e0723ff41ba211995/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d98fbcdff0faeda82b4f7c1e6f31dec8'), 'driverName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [
	  {
	    "type": "actions",
	    "headerName": "",
	    "headerTooltip": "Actions",
	    "field": "actions",
	    "width": pageData.showAllColumns == true ? 120 : 75,
	    // "width" : 75,
	    "minWidth": 75,
	    "pinned": "left",
	    "meta": { "align": "center" },
	    // "hide": pageData.showAllColumns
	  },


	  // {
	  //   "type": "actions",
	  //   "headerName": "",
	  //   "headerTooltip": "Actions",
	  //   "field": "actions",
	  //   "width": 120,
	  //   "minWidth": 120,
	  //   "pinned": "left",
	  //   "meta": { "align": "center" },
	  //   "hide": !pageData.showAllColumns
	  // },


	  {
	    "field": "rel_TransportRequest.isEOD",
	    "headerName": "Crisis?",
	    "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
	    "minWidth": 40,
	    "maxWidth": 75,
	    "pinned": "left",
	    "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
	    meta: { align: "center" },
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	   // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

	  },

	  {
	    "field": "rel_TransportRequest.submissionCode",
	    "headerName": "Transport Code",
	    "headerTooltip": "HIPAA compliant transport reference.  [first three letters of client's first name].[first three letters of client last name].[submission number].",
	    "pinned": "left",
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },

	  {
	    // "field": "datetimeActualEndOfDay",
	    "field": "samsaraRouteId",
	    "headerName": "Samsara Route ID",
	    "headerTooltip": "Route ID in the Samsara system",
	    "pinned": "left",
	    "width": 100,
	    "sortable": false,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "datetimeSubmission_copy",
	    "headerName": "Submission Time",
	    "headerTooltip": "Date & Time when the transport request was received via ORC app form. NOTE: Changes to this value will impact ETA calculations but WILL NOT be reflected in the Transport Request itself.  Submission Datetime must be changed on the Transport Request page separately.",
	    "type": "datetimeColumn",
	    "sort": "desc",
	    "pinned": "left",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5 ? true : false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "typeStatus",
	    "headerName": "Status",
	    "headerTooltip": "Current status of the ride in Samsara.",
	    "pinned": "left",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.statusOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },
	  {
	    "field": "relDispatcher1_Employee.nameFull",
	    "headerName": "Dispatcher",
	    "headerTooltip": "Name of Employee who dispatched the transport.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.dispatcherOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "datetimeDispatch",
	    "headerName": "Dispatch Time",
	    "headerTooltip": "Date & Time the transport was dispatched.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5 ? true : false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "durationSubmissionToDispatch",
	    "headerName": "Time to Dispatch",
	    "headerTooltip": "Delay (hours:minutes) between submission time and dispatch time.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "width": 80,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "relDriver1_Employee.nameFull",
	    "headerName": "Driver",
	    "headerTooltip": "Primary driver for the transport.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.driverOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  {
	    "field": "relVehicle1_Vehicle.vehicleName",
	    "headerName": "Vehicle",
	    "headerTooltip": "Primary vehicle for the transport.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.vehicleOptions || []
	    // },
	    "width": 100,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "datetimeScheduledStart",
	    "headerName": "Scheduled Start Time",
	    "headerTooltip": "Date & Time the transport is scheduled to start.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "datetimeScheduledPickup",
	    "headerName": "Scheduled Pickup Time",
	    "headerTooltip": "Date & Time the pickup is scheduled for.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  /* REMOVED ONCE AUTOMATIC ETA CALCULATION WAS IN PLACE
	  {
	    "field": "durationSubmissionToScheduledPickup",
	    "headerName": "ETA (Est. Response Time)",
	    "headerTooltip": "This is the response time (often referred to as ETA) between submission and scheduled pickup time.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "meta": { "align": "center" }
	  },

	    {
	    "field": "isLongETA",
	    "headerName": "Long ETA?",
	    "headerTooltip": "Is the Est. Response Time (ETA) greater than three hours?",
	    "type": "booleanColumn",
	    "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
	    "meta": {
	      "align": "center"
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  */

	  {
	    "field": "durationResponseTime",
	    "headerName": "ETA (Response Time)",
	    "headerTooltip": "This is the response time (often referred to as ETA) between submission and pickup time.  It is estimated using the Scheduled Pickup Time initially but will automatically change to the Actual Response Time once an Actual Pickup Time is input.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "isLongETA_autoCalc",
	    "headerName": "Long ETA?",
	    "headerTooltip": "Is the Actual ETA (Response Time) greater than three hours?  This will use the Estimated ETA until the Actual Pickup Time is input and an Actual Response Time can be calculated.",
	    "type": "booleanColumn",
	    "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
	    "meta": {
	      "align": "center"
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "typeLongETAcause",
	    "headerName": "Long ETA Cause",
	    "headerTooltip": "What caused the long ETA",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.longETAcauseOptions || []
	    },
	    "width": 120,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  {
	    "field": "datetimeScheduledDropoff",
	    "headerName": "Scheduled Dropoff Time",
	    "headerTooltip": "Date & Time when we expect the client to be dropped off at the destination.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_EntityRequestingTransport.requesterEntityName",
	    "headerName": "Requester",
	    "headerTooltip": "This is the form that was used for the transport request.",
	    "width": 200,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "cellRendererParams": { "withChips": true },
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.nameFull",
	    "headerName": "Client Name",
	    "headerTooltip": "Name of client being transported.",
	    "width": 120,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.dateOfBirth",
	    "headerName": "DOB",
	    "headerTooltip": "Date & Time the pickup is scheduled for.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY",
	      "withSeconds": false
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.SSN",
	    "headerName": "SSN",
	    "headerTooltip": "Social Security Number of the client being transported.",
	    "width": 120,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "valueFormatter": ns.ssnValueFormatter,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.typeInsurance",
	    "headerName": "Insurance Type",
	    "headerTooltip": "Type of primary insurance of the client being transported.",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.typeInsuranceOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" },
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.insuranceProvider",
	    "headerName": "Insurance Provider",
	    "headerTooltip": "Primary insurance provider of the client being transported.",
	    "width": 120,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.insurancePolicyNumber",
	    "headerName": "Policy Number",
	    "headerTooltip": "Primary insurance policy number of the client being transported.",
	    "width": 120,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
	    "headerName"        : "Tribal?",
	    "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
	    "width"             : 100,
	    "minWidth"          : 40,
	    "sortable"          : true,
	    "editable"          : true,
	    "meta"              : { "align": "center"},
	    "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true
	  },

	  {
	    "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
	    "headerName"        : "Tribes",
	    "headerTooltip"     : "Which tribes are this Client affiliated with?",
	    "width"             : 150,
	    "minWidth"          : 40,
	    "sortable"          : false,
	    "editable"          : true,
	    "type"              : "selectColumn",
	    "isMulti"           : true,
	    "cellRendererParams": { "withChips": true },
	    "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
	    "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true
	  },

	  {
	    "field": "rel_TransportRequest.relPickup_Facility.formattedLocation",
	    "headerName": "Pickup Location",
	    "headerTooltip": "Location where the client will be picked up.",
	    "width": 400,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.relDestination_Facility.formattedLocation",
	    "headerName": "Destination Location",
	    "headerTooltip": "Location where the client will be dropped off.",
	    "width": 400,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "notesTransport",
	    "headerName": "Transport Notes",
	    "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
	    "type": "largeTextColumn",
	    "cellEditorParams": {
	      "maxLength": 2000,
	      "rows": 10,
	      "cols": 50,
	    },
	    "width": 400,
	    "sortable": false,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "typeCancelationReason",
	    "headerName": "Cancelation Reason",
	    "headerTooltip": "Who is responsible for the cancelation?",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.typeCancelationReasonOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "relDispatcher2_Employee.nameFull",
	    "headerName": "Alt. Dispatcher",
	    "headerTooltip": "Alternate dispatcher involved in the transport.  Use this when shifts change and someone takes over management of a ride.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.dispatcherOptions || []
	    // },
	    "width": 180,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  /*  ------- DEPRECATED WITH REMOVAL OF ALT VEHICLE AND DRIVER ------
	  {
	    "field": "relDriver2_Employee.nameFull",
	    "headerName": "Alt. Driver",
	    "headerTooltip": "Alternate driver assigned to the ride.  This is primarily for training situations, but could be needed in emergencies.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.driverOptions || []
	    // },
	    "width": 180,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "relVehicle2_Vehicle.vehicleName",
	    "headerName": "Alt. Vehicle",
	    "headerTooltip": "Alternate vehicle used for the ride.  Used rarely, probably due to maintenance.  Often better to redispatch the transport request under the new vehicle than use this field.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.vehicleOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  */

	    {
	    "field": "mileageStart",
	    "headerName": "Mileage at Start",
	    "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
	    "filter": "agNumberColumnFilter",
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	    "width": 120,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileagePickup",
	    "headerName": "Mileage at Pickup",
	    "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
	    "filter": "agNumberColumnFilter",
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	    "width": 120,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileageDropoff",
	    "headerName": "Mileage at Dropoff",
	    "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
	    "filter": "agNumberColumnFilter",
	    "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	    "width": 120,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileageEndOfDay",
	    "headerName": "Mileage at End of Day",
	    "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
	    "filter": "agNumberColumnFilter",
	    "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	    "width": 120,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },

	{
	  "field"             : "isDriversLastRoute",
	  "headerName"        : "Driver's Last Route?",
	  "headerTooltip"     : "Was this the driver's last route of the day (i.e. they returned home after this route)?",
	  "minWidth"          : 40,
	  "maxWidth"          : 90,
	  "cellRenderer"      : ns.checkboxCheckmarkCellRenderer,
	                        meta: { align: "center" },
	  "editable"          : true,
	  "wrapHeaderText"    : true,
	  "autoHeaderHeight"  : true
	},

	  {
	    "field": "distanceStartToPickup",
	    "headerName": "Start to Pickup Distance",
	    "headerTooltip": "This is distance in miles from start to pickup.",
	    "filter": "agNumberColumnFilter",
	    "width": 120,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distancePickupToDropoff",
	    "headerName": "Pickup to Dropoff Distance",
	    "headerTooltip": "This is distance in miles from pickup to dropoff.",
	    "filter": "agNumberColumnFilter",
	    "width": 120,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distanceStartToDropoff",
	    "headerName": "Start to Dropoff Distance",
	    "headerTooltip": "This is distance in miles from start to dropoff.",
	    "filter": "agNumberColumnFilter",
	    "width": 120,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distanceDropoffToEndOfRouteOrDay",
	    "headerName": "Dropoff to End Point Distance",
	    "headerTooltip": "This is distance in miles from dropoff to the end of the day location (i.e. driver's home).",
	    "filter": "agNumberColumnFilter",
	    "width": 120,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	 {
	   "field": "distanceTotalTransport",
	   "headerName": "Total Transport Distance",
	   "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
	   "filter": "agNumberColumnFilter",
	   "width": 120,
	   "sortable": true,
	   "editable": false,
	   "meta": { "align": "center" },
	   "wrapHeaderText": true,
	   "autoHeaderHeight": true,
	   //"cellClass": "calculatedField",
	   "hide": !pageData.showAllColumns
	 },

	  {
	    "field": "datetimeActualStart",
	    "headerName": "Actual Start Time",
	    "headerTooltip": "Date & Time when the driver actually started the transport according to Samsara.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualPickup",
	    "headerName": "Actual Pickup Time",
	    "headerTooltip": "Date & Time when the driver actually reached the client's location according to Samsara.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualPickupDeparture",
	    "headerName": "Actual Pickup Departure Time",
	    "headerTooltip": "Date & Time when the driver and the client departed their location according to Samsara.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualDropoff",
	    "headerName": "Actual Dropoff Time",
	    "headerTooltip": "Date & Time when the driver and the client reached the destination according to Samsara.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },

	  {
	    // "field": "datetimeActualEndOfDay",
	    "field": "datetimeEndOfRouteOrDay",
	    "headerName": "Actual End of Route or Day Time",
	    "headerTooltip": "Date & Time when the route was completed.  If it was the last route of the day for a driver, this will instead show the Date & Time when the driver returned home.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },

	  /* NO LONGER NEEDED SINCE WE MADE LongETA_AutoCalc and durationResponseTime
	  {
	    "field": "durationSubmissionToActualPickup",
	    "headerName": "Actual Response Time (ETA)",
	    "headerTooltip": "This is the actual time between when the driver arrived and when the transport request was submitted.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "valueGetter": ns.trimTimeStringValueGetter,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  */

	  {
	    "field": "durationDispatchToScheduledStart",
	    "headerName": "Est. Time to Start",
	    "headerTooltip": "This is the time between the Dispatch Time and the Scheduled Start Time.",
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "valueGetter": ns.trimTimeStringValueGetter,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationDispatchToActualStart",
	    "headerName": "Actual Time to Start",
	    "headerTooltip": "This is the time between the Dispatch Time and the Actual Start Time.",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "durationRequestedTransportToScheduledPickup",
	    "headerName": "Est. Pickup Delay vs. Request",
	    "headerTooltip": "This is the estimated delay between scheduled pickup and the requested pickup time, calculated as the requested transport time minus the scheduled pickup time.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "durationRequestedTransportToActualPickup",
	    "headerName": "Actual Pickup Delay vs. Request",
	    "headerTooltip": "This is the actual delay between scheduled pickup and the requested pickup time, calculated as the requested transport time minus the scheduled pickup time.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "durationPickupWaitTime",
	    "headerName": "Pickup Duration",
	    "headerTooltip": "This is how long the driver stayed at the pickup location.  i.e. The time between arriving and departing the pickup location.",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationStartToEndOfRouteOrDay",
	    "headerName": "Transport Duration",
	    "headerTooltip": "This is the total transport time.",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  //***THIS IS LOWER PRIORITY.  MAY NOT BE NEEDED BY CLIENT.  ALSO REQUIRES CODELESS CALC AFTER SAMSARA DATA.
	  //{
	    //"field": "durationSubmissionToActualPickup",
	    //"headerName": "Actual Response Time",
	    //"sortable": true,
	    ////"cellClass": "calculatedField",
	    //"editable": false,
	    //"hide": !pageData.showAllColumns
	  //},

	  //***THIS IS LOWER PRIORITY.  MAY NOT BE NEEDED BY CLIENT.
	  //{
	    //"field": "durationDispatchToActualPickup",
	    //"headerName": "Actual Dispatch to Pickup Time",
	    //"sortable": true,
	    ////"cellClass": "calculatedField",
	    //"editable": false,
	    //"hide": !pageData.showAllColumns
	  //},

	  {
	    "field": "typeReviewStatus",
	    "headerName": "Review Status",
	    "headerTooltip": "Current status of whether the ride has been fully processed and is ready for billing.",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.typeReviewStatusOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" },
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "billingEntityName",
	    "headerName": "Billing Entity",
	    "headerTooltip": "This is usually the form that was used for the transport request but can be manually selected.",
	    "type": "selectColumn",
	    "width": 200,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "cellRendererParams": { "withChips": true },
	    "cellEditorParams"  : { "values": pageData.requesterEntityNameOptions || [] },
	    "hide": !pageData.showAllColumns
	  }

	  /*,
	  {
	    "field": "hasInvoiceBeenSent",
	    "headerName": "Invoiced?",
	    "headerTooltip": "Has the transport already been invoiced?.",
	    "type": "booleanColumn",
	    "cellRenderer": ns.checkboxCheckmarkCellRenderer,
	    "meta": {
	      "align": "center"
	    },
	    "width": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"editable": false
	  },
	  */
	]
})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, samsaraRouteId, consoleError, errMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function handleErrorForGetMetrics(consoleError, errMessage) {
  if (errMessage != null) {
    (function (message) { alert(message) })('This route had over three stops in Samsara. We are not yet able to write data to the table automatically for these situations.  Please input these values manually.');
  }
  if ((JSON.stringify(consoleError)).indexOf('e-grid-001') !== -1) {
    (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 1') !== -1) {
    (function (message) { alert(message) })('We were unable to get the vehicle assignments fo rthe route.  Please ensure the Driver and their Driver ID is valid.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 2') !== -1) {
    (function (message) { alert(message) })('We were unable to fetch the address details.  Please double check the pickup and drop off locations, particularly their latitude and longitude relative to the locations chosen in Samsara.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 3') !== -1) {
    (function (message) { alert(message) })((String('A duplicate Route ID already exists in the Transport table.  This usually occurs due to a data entry error in the driver or route start time.  Please take a close look at the details of this record and it\'s conflicting record and change whichever is incorrect.  Data for this record has been cleared to avoid any duplication.  Duplicate Route ID:  ') + String(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'))));
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 4') !== -1) {
    (function (message) { alert(message) })('This record is marked as Voided in the Transport table.  It\'s data has been cleared to avoid any duplication or confusion for the billing team.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 5') !== -1) {
    (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 7') !== -1) {
    (function (message) { alert(message) })('We were unable to get details for the route.  Please ensure that the Samsara Route Id is valid.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 8') !== -1) {
    (function (message) { alert(message) })('Failed to fetch the vehicles trip data for the specified time frame. Double check the vehicle that was assigned to the route, as well as the scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 9') !== -1) {
    (function (message) { alert(message) })('Failed to fetch driver vehicle assignments. Ensure that the driverId is valid and that the scheduled start is close to the actual route start time.');
  } else {
    (function (message) { alert(message) })('Sorry, we were unable to retrieve the details for this route.  Please bear with us until we can pull all data automatically.  This route will need to be closed manually for now.');
  }
}


  console.log(___arguments.context.pageData);
  console.log(___arguments['recordItem']);
  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  if (___arguments['eventName'] == 'view-submission') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`transportRequestRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  } else if (___arguments['eventName'] == 'set-transporters') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else if (___arguments['eventName'] == 'get-metrics') {
    console.log('Print in the get-metrics On Action Item Click.  Record Item then getSamsaraRouteId return:');
    console.log(___arguments['recordItem']);
    if ((getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) == 'Processed') {
      console.log('This route has already been processed.  Alerting User and returning.');
      (function (message) { alert(message) })('This record has already been processed.  Please change the Review Status and try again if you need to pull new data from Samsara.');
      return ;
    }
    // Check for voided status and clear the record if typeStatus=Voided
    if ((getObjectProperty(___arguments['recordItem'], 'typeStatus')) == 'Voided') {
      console.log('Voided status was detected.  Clearing the record.');
      (function (message) { alert(message) })('This record has been voided, which means it was canceled before the driver started the route.  We will remove all data for the row.');
      try {
        ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: null,[`datetimeScheduledDropoff`]: null,[`datetimeActualStart`]: null,[`mileageStart`]: null,[`datetimeActualPickup`]: null,[`mileagePickup`]: null,[`datetimeActualPickupDeparture`]: null,[`datetimeActualDropoff`]: null,[`mileageDropoff`]: null,[`datetimeActualDropoffDeparture`]: null,[`datetimeEndOfRouteOrDay`]: null,[`mileageEndOfDay`]: null,[`errMessage`]: null });
        await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );

      } catch (error) {
        console.log('Error seen when trying to save blank values to the record item in the database.');
        console.log(error);

      }
      try {
        await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

      } catch (error) {
        console.log('An error was seen in the RT channel command in the get-metrics action when processing Voided.');
        console.log(error);

      }
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('78bead46690fede9532b99d7ad3a2b24');
    if (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId')) {
      console.log('RouteId already exists in the record item.  Calling handleRouteStopArrival.');
      samsaraRouteId = (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId'));
      try {
        ___arguments.context.pageData['routeMetrics'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getFinalRouteMetrics/handleRouteStopArrival`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': samsaraRouteId,'isDriversLastRoute': (getObjectProperty(___arguments['recordItem'], 'isDriversLastRoute')) }));
        if ((getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) != null) {
          throw (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'))
        }

      } catch (error) {
        console.log('Error encountered in getFinalRouteMetrics.  Printing Error, then errMessage.');
        console.log(error);
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'));
        await handleErrorForGetMetrics(error, (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
        return ;

      }
    } else {
      console.log('RouteId needed to be found.  getRouteId returned:');
      try {
        ___arguments.context.pageData['routeInformation'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments['recordItem'], 'datetimeScheduledStart')),'pickupFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.googleFormattedAddress')),'destinationFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.googleFormattedAddress')) }));
        // Throw an error if routeInformation (and hence routeId) is not found
        if (!(getObjectProperty(___arguments.context.pageData, 'routeInformation'))) {
          throw (new Error('getRouteId returned null.  (e-grid-001)'))
        }
        samsaraRouteId = (getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'));
        console.log(samsaraRouteId);
        ___arguments.context.pageData['routeMetrics'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getFinalRouteMetrics/handleRouteStopArrival`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': samsaraRouteId,'isDriversLastRoute': (getObjectProperty(___arguments['recordItem'], 'isDriversLastRoute')) }));
        if ((getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) != null) {
          throw (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'))
        }

      } catch (error) {
        console.log('Error Encountered in getRouteId or getFinalRouteMetrics.  Printing error and triggering alert.');
        console.log(error);
        await handleErrorForGetMetrics(error, (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
        return ;

      } finally {
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));

      }
    }
    try {
      console.log('handleRouteStopArrival returned routeMetrics:');
      console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
      // If the departure datetime is present that means that the getMetrics function was able to pull a routeId and all available data for the route.  This means that it has been completed and the status can be changed to completed.  In all other cases, we defer to the manual typeStatus setting and make no change.
      //
      // NOTE: This is prebuilt to also check for a status of "Processed", which indicates that the record has been manually reviewed and finalized.  If this is the case we should not override the record.
      ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: samsaraRouteId,[`datetimeScheduledDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeScheduledDropoff')),[`datetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualStart')),[`mileageStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageStart')),[`datetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualPickup')),[`mileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileagePickup')),[`datetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualPickupDeparture')),[`datetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoff')),[`mileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageDropoff')),[`datetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoffDeparture')),[`datetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.actualRouteEndTime')),[`mileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageEndOfDay')),[`errMessage`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')),[`typeStatus`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoffDeparture')) && (getObjectProperty(___arguments['recordItem'], 'typeStatus')) != 'Processed' ? 'Completed' : (getObjectProperty(___arguments['recordItem'], 'typeStatus')) });
      await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );
      console.log('These metrics were saved to the Transport Table:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics'));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');

    } catch (error) {
      console.log('Error encountered when saving record to the database.  Printing Error, then errMessage.');
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
      return ;

    }
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen in the RT channel command in the get-metrics action');
      console.log(error);

    }
  } else if (___arguments['eventName'] == 'cancel-route') {
    console.log('cancelRouteEvent Started');
    console.log(___arguments['recordItem']);
    if ((getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) == 'Processed') {
      console.log('This route has already been processed.  Alerting User and returning.');
      (function (message) { alert(message) })('This record has already been processed.  Please change the Review Status and try again if you need to cancel the Route here and in Samsara.');
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('639baad5eb1fc95ea19b0b8932c3237e');
    if (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId')) {
      samsaraRouteId = (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId'));
      console.log('RouteId already exists in the record item.  Calling handleRouteStopArrival.');
    } else {
      try {
        ___arguments.context.pageData['routeInformation'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments['recordItem'], 'datetimeScheduledStart')),'pickupFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.googleFormattedAddress')),'destinationFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.googleFormattedAddress')) }));
        // Throw an error if routeInformation (and hence routeId) is not found
        if (!(getObjectProperty(___arguments.context.pageData, 'routeInformation'))) {
          throw (new Error('getRouteId returned null.  (e-grid-001)'))
        }

      } catch (error) {
        console.log('Error Encountered in getRouteId:');
        console.log(error);
        if ((JSON.stringify(error)).indexOf('e-grid-001') !== -1) {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 1') !== -1) {
          (function (message) { alert(message) })('We were unable to get the vehicle assignments fo rthe route.  Please ensure the Driver and their Driver ID is valid.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 2') !== -1) {
          (function (message) { alert(message) })('We were unable to fetch the address details.  Please double check the pickup and drop off locations, particularly their latitude and longitude relative to the locations chosen in Samsara.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 3') !== -1) {
          (function (message) { alert(message) })((String('A duplicate Route ID already exists in the Transport table.  Data for this record has been cleared to avoid any duplication.  Duplicate Route ID:  ') + String(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'))));
        } else if ((JSON.stringify(error)).indexOf('Errorcode 4') !== -1) {
          (function (message) { alert(message) })('This record is marked as Voided in the Transport table.  It\'s data has been cleared to avoid any duplication or confusion for the billing team.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 5') !== -1) {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        } else {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        }
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('639baad5eb1fc95ea19b0b8932c3237e');
        return ;

      } finally {
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));

      }
    }
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/cancelRoute/cancelAndUpdateRoute`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(samsaraRouteId));
      console.log('Route canceled in Samsara successfully.');

    } catch (error) {
      console.log('Printing Error:');
      console.log(error);
      if ((JSON.stringify(error)).indexOf('Errorcode 10') !== -1) {
        (function (message) { alert(message) })('We were unable to fetch route details for the route.  Double check that the routeID is valid and that Samsara data can be pulled automatically here.');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 11') !== -1) {
        (function (message) { alert(message) })('We were unable to update the route in Samsara to show it as cancelled.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 12') !== -1) {
        (function (message) { alert(message) })('We were unable to save data to the Transport table after the cancelation.  Please double check that the route was canceled in Samsara and then change the record here to be \'Canceled\'.');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 13') !== -1) {
        (function (message) { alert(message) })('We were unable to cancel the route.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      } else {
        (function (message) { alert(message) })('We were unable to cancel the route.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      }

    }
    console.log('Changing typeStatus to Canceled in Transport table.');
    ___arguments.context.pageData['transportStatusUpdate'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`typeStatus`]: 'Canceled' });
    await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportStatusUpdate')) );
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen with the RT Channel command in the Cancel Route function');
      console.log(error);

    }
    console.log('typeStatus was updated in the table successfully.');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportStatusUpdate'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('639baad5eb1fc95ea19b0b8932c3237e');
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (['datetimeScheduledStart >= \'1719810000000\' ',(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')),(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier'))].join(''));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  //relationsDepth: 1,
	  //relations: ["rel_TransportRequest"],

	  //properties: ["relDispatcher1_Employee.nameFull"],

	  relations: ["rel_TransportRequest",
	              //"relDispatcher1_Employee",
	              //"relDispatcher2_Employee",
	              //"relDriver1_Employee",
	              //"relVehicle1_Vehicle",
	              "rel_TransportRequest.rel_EntityRequestingTransport",
	              "rel_TransportRequest.rel_Client",
	              "rel_TransportRequest.relPickup_Facility",
	              "rel_TransportRequest.relDestination_Facility"
	              ]

	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:onCellDoubleClicked */
  async ['onCellDoubleClicked'](___arguments) {
    var setTranspotersFields;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  setTranspotersFields = ['relDispatcher1_Employee.nameFull', 'relDriver1_Employee.nameFull', 'relVehicle1_Vehicle.vehicleName', 'relDispatcher2_Employee.nameFull', 'relDriver2_Employee.nameFull', 'relVehicle2_Vehicle.vehicleName'];
  if (setTranspotersFields.includes((getObjectProperty(___arguments['columnDef'], 'field')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['rowData'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['rowData'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['rowData'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['rowData'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['rowData'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }
  if ((getObjectProperty(___arguments['columnDef'], 'field')) == 'rel_TransportRequest.submissionCode') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`transportRequestRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  }

  },
  /* handler:onCellDoubleClicked */
  /* handler:actionsIconsLogic */
  async ['actionsIconsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'showAllColumns'))) {
    return (await (async function(appData, pageData) {
    	return [
    	  {
    	    "eventName":"view-submission",
    	    "icon":"assignment",
    	    "className":"view-submission",
    	    "title": "View Transport Request"
    	  },

    	  {
    	    "eventName":"set-transporters",
    	    "icon":"account_tree",
    	    "className":"set-transporters",
    	    "title": "Update Dispatcher(s), Drivers(s), or Vehicles(s)"
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData));
  } else {
    return (await (async function(appData, pageData) {
    	return [
    	  {
    	    "eventName":"view-submission",
    	    "icon":"assignment",
    	    "className":"view-submission",
    	    "title": "View Transport Request"
    	  },

    	  {
    	    "eventName":"set-transporters",
    	    "icon":"account_tree",
    	    "className":"set-transporters",
    	    "title": "Update Dispatcher(s), Drivers(s), or Vehicles(s)"
    	  },

    	  {
    	    "eventName":"get-metrics",
    	    "icon":"playlist_add_check",
    	    "className":"get-metrics",
    	    "title": "Get Route Metrics from Samsara"
    	  },

    	  {
    	    "eventName":"cancel-route",
    	    "icon":"cancel",
    	    "className":"delete-icon",
    	    "title": "Cancel Route in App & Samsara"
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData));
  }

  },
  /* handler:actionsIconsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    
  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  ___arguments.context.pageData['transportReusableData'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& (typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL)';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'2\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/64b22f2e967708cd2f23f0118fe71b96/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      // Need to initialize this so that we can set properties in
  // it later as part of Action Item clicks in the data grid
  ___arguments.context.pageData['recordPaths'] = ({  });

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to
  // return all values. It is here so that no errors
  // will occur when we add in the test data flag query.
  ___arguments.context.pageData['strWhereClauseBase'] = '&& rel_TransportRequest.submissionNumber != \'\'';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    ___arguments.context.pageData['strWhereClauseBase'] = '&& (typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL)';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_TransportRequest.rel_Client.nameFirst != \'test\' ';
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['showTestData'] = false;
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['dispatcherOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('LOWER(jobTitle) LIKE \'%dispatch%\' AND employmentStatus = \'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  // This one is only used in the data grid and we're not
  // establishing relations so we take only the value property.
  ___arguments.context.pageData['requesterEntityOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  // This one is only used in the data grid and we're not
  // establishing relations so we take only the value property.
  ___arguments.context.pageData['requesterEntityNameOptions'] = ((getObjectProperty(___arguments.context.pageData, 'requesterEntityOptions')).map(item => item['label']));
  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['longETAcauseOptions'] = [null, 'Facility', 'Prescheduled', 'Ride Care'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Facility', 'Client', 'Ride Care'];
  ___arguments.context.pageData['typeReviewStatusOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare', 'Private Insurance', 'Medicare', 'Medicaid', 'Other'];
  ___arguments.context.pageData['statusOptionsFilter'] = ['Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['longETAcauseOptionsFilter'] = ['Facility', 'Prescheduled', 'Ride Care'];
  ___arguments.context.pageData['typeCancelationReasonOptionsFilter'] = ['Facility', 'Client', 'Ride Care'];
  ___arguments.context.pageData['typeReviewStatusOptionsFilter'] = ['Pending', 'Needs Attention', 'Processed'];
  ___arguments.context.pageData['isReadOnlyMode'] = true;
  ___arguments.context.pageData['showDataQuery'] = true;
  ___arguments.context.pageData['showAdvancedFilters'] = false;
  console.log('On Before Page Enter print Page Data then App Data:');
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.appData);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/89f36a5f06a88beb7a4168f8c62af8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showAllColumns'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/1c94c69498936d6389d94b712646580d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& isLongETA = TRUE';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/98a64a9922fd6a0fb02b2b1ca4e17e9f/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/d3d664ba260c7449dd2c7b8510b7d64f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('d0542e2dcb86d77de41d3dad9db99522');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle1_Vehicle.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle2_Vehicle.objectId'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/d0542e2dcb86d77de41d3dad9db99522/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var relations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  relations = ({  });
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher1_Employee.objectId'))) {
    relations['relDispatcher1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDriver1_Employee.objectId'))) {
    relations['relDriver1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relVehicle1_Vehicle.objectId'))) {
    relations['relVehicle1_Vehicle'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher2_Employee.objectId'))) {
    relations['relDispatcher2_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) });
  }
  if ((Object.keys(relations)).length != 0) {
    await Backendless.Data.of('Transport').deepSave( (Object.assign(({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId')) }), relations)) );
    await (getChannelInstance('default')).send('reload-table-records:Transport', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId'))] }));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
    stopSetTimeout('transportUpdateTransporters');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', true);
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', false);
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/f013363f1862d6245c6531da6e1a2084/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
  stopSetTimeout('transportUpdateTransporters');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/835cf0dfbd76bcd30477cd090c163ad1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_TransportRequest.rel_Client.nameFirst != \'test\'';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/24fa74ce6999f63dead2abab11c8bf03/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/028571eba6567082fe2231fee0a1ce7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.pageData);
  console.log(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.objectId'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-requests', ({ [`strWhereClauseBase`]: ['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.objectId')),'\''].join('') }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/4226d63cdffccef288cb2f65bf76f254/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'30\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/376d2a86b3a13988f86809160d3fd53b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/f7f2b5cd664bdecb5b97e80d13ee8895/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == true) {
    ___arguments.context.pageData['showDataQuery'] = false;
  } else {
    ___arguments.context.pageData['showDataQuery'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/d507be9497133c7612b96c6652567b07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function clearFilterForm() {
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['endDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOBReset'] = true;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('5167732fd546fa76851fc54a54383039', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('898fa3fe0e5217cf830fd3da08dfbbcd', null);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == true) {
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('38acd20ba9687798ff0b0da2b48be7ce', null);
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('a745e768e561369ac481cf94c5117b81', null);
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('40d5fefc505cf947ae7bbc5608aff6d7', null);
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientNameLast'] = null;
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOB'] = null;
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('e0af5b42fdc13722ba86ec8a620602f9', null);
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['tribalStatus'] = null;
  }
}


  await clearFilterForm();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/b842acfb7d1c2b2f9f61e7566fefee64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var whereClauseModifier, item, millisecondsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecondsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB'))).getMinutes()) * 60000;
  console.log('timeEditor');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'timeEditor'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeDispatch >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeDispatch <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) != '') {
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) == 'Is Blank') {
      whereClauseModifier = String(whereClauseModifier) + String('typeStatus IS NULL');
    } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) == 'Is Not Blank') {
      whereClauseModifier = String(whereClauseModifier) + String('typeStatus IS NOT NULL');
    } else {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(async item => {; return (['typeStatus = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')).map(async item => {; return (['typeReviewStatus = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == true) {
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')).map(async item => {; return (['relDriver1_Employee.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')).map(async item => {; return (['relDispatcher1_Employee.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')).map(async item => {; return (['rel_TransportRequest.rel_EntityRequestingTransport.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')),'%\' '].join(''));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth > \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) - millisecondsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth < \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) - millisecondsSinceDayStartDOB) + 86400000,'\' '].join(''));
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')).map(async item => {; return (['typeCancelationReason = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')),' '].join(''));
    }
  }
  ___arguments.context.pageData['strWhereClauseBase'] = whereClauseModifier;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/973afdd6e8923de509b871483f0dda04/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/7bf48217c09c0cc64dcb4047fa78ffd7/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != null) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate'));
  }

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/6deca5e7f5a5471641d333d5843ba6ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  ___arguments.context.dataModel['driverOptions'] = (getObjectProperty(___arguments.context.pageData, 'driverOptions'));
  ___arguments.context.dataModel['dispatcherOptions'] = (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions'));
  ___arguments.context.dataModel['requesterEntityOptions'] = (getObjectProperty(___arguments.context.pageData, 'requesterEntityOptions'));
  ___arguments.context.dataModel['statusOptions'] = ((await Promise.all((getObjectProperty(___arguments.context.pageData, 'statusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });}))).slice().sort(listsGetSortCompare("TEXT", 1)));
  ___arguments.context.dataModel['typeReviewStatusOptions'] = ((await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeReviewStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });}))).slice().sort(listsGetSortCompare("TEXT", 1)));
  ___arguments.context.dataModel['typeCancelationReasonOptions'] = ((await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeCancelationReasonOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });}))).slice().sort(listsGetSortCompare("TEXT", 1)));
  ___arguments.context.dataModel['showAdvancedFilters'] = (getObjectProperty(___arguments.context.pageData, 'showAdvancedFilters'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/d5d47e662f92bcdc1f590b2c2b4c2038/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/60f77747b19d02ce877cc733ca2c7651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'7\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/df9f74a5ce78df823282503827938f31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& hasNegativeMileage = TRUE';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/569a9e12f37c7374aa114b16b4d9d5aa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == false) {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['showAdvancedFilters'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['showAdvancedFilters'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/c9e8f827c11368a40251f3c1702bdfa4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/01454469550a4e2baecc1e897a5b4b9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/8afda726fb882bbc843259d6be38ddb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& (hasMissingMilageOrActualDatetime = TRUE OR samsaraRouteId = NULL)';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/898fa3fe0e5217cf830fd3da08dfbbcd/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var list, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'typeReviewStatusOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/transport-backup-9-10-24/components/d2212b04bb760b2996f552e354d7330a/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var item;


  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOB'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOBReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOBReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:overwriteLogic */
  ['overwriteLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) == null) {
    return null;
  }

  },
  /* handler:overwriteLogic */
  /* content */
}))

define('./pages/transport-req-test/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Transport Requests',[`pageName`]: 'transport-requests' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/transport-req-test/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'showAllRecords')) == true)) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},
    	{
    	  "field": "isInformationVerified",
    	  "headerName": "",
    	  "headerTooltip": "Ready for Dispatch?",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxCheckmarkCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false,
    	  "filtering": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},
    	{
    	  "field": "isEOD",
    	  "headerName": "",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.stateCode",
    	  "headerName": "State",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "headerTooltip": "Date & Time when the transport request was received via ORC app form.",
    	  "type": "datetimeColumn",
    	  "cellRendererParams": {
    	    "dayjsFormat": "MM/DD/YYYY HH:mm",
    	    "withSeconds": false
    	  },
    	  "width": 155,
    	  "sortable": true,
    	  "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false,
    	  "wrapHeaderText": true,
    	  "autoHeaderHeight": true,
    	  "meta": { "align": "center" }
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "minWidth": 200,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "minWidth": 200,
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},

    	{
    	  "field": "isInformationVerified",
    	  "headerName": "",
    	  "headerTooltip": "Ready for Dispatch",
    	  "minWidth": 40,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxCheckmarkCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "isEOD",
    	  "headerName": "",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 20,
    	  "maxWidth": 55,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.stateCode",
    	  "headerName": "State",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  "editable": false
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, newTransportRequestRecord, submissionInfo, waitCount, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for use as both input forms and viewers.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'validateAndDispatchRecord') {
    console.log('Printing data containers at start of event validateAndDispatchRecord:');
    console.log(___arguments['recordItem']);
    console.log(___arguments.context.pageData);
    console.log(___arguments.context.layoutData);
    console.log(___arguments.context.appData);
    // Don't allow editing in the UI window if the record has already been dispatched, if the record is voided, or if another user is already editing it.
    // This was disabled when we made it so that transport requests could be edited after dispatch.  It can be removed at a later date.
    ___arguments.context.pageData['transportRequestRecordReusableData'] = ({ [`transportRequestRecord`]: ___arguments['recordItem'],[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`typeInsuranceList`]: (getObjectProperty(___arguments.context.pageData, 'typeInsuranceList')),[`pickupFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relPickup_Facility')),[`destinationFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relDestination_Facility')),[`requesterRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_EntityRequestingTransport')),[`selectExistingClientData`]: ({  }),[`isReadOnlyMode`]: false || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId')))) ? true : false });
    // This makes sure that the requester ID is present on page
    // Data here like it is on the Transport Request Form Page.
    ___arguments.context.pageData['requesterId'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterId'));
    console.log('Action Icon Click Event - PageData.requesterId:');
    console.log(getObjectProperty(___arguments.context.pageData, 'requesterId'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    // Only trigger the 'editing' command interval if the record is not read only.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == false) {
      try {

        ;(function() {
          const callback = async () => {
              await (getChannelInstance('default')).send('editing-table:TransportRequest', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

          };

          const timerId = 'transportRequestsVerifyAndDispatch';
          const timerDelay = 1000;

          runSetTimeout(timerId, callback, timerDelay)
        })()
        addItemToList((getObjectProperty(___arguments.context.appData, 'intervalIds')), 'transportRequestsVerifyAndDispatch');

      } catch (error) {
        console.log('An error was seen in the RT Channel Command for isReadOnlyMode');
        console.log(error);

      }
    }
  } else if (___arguments['eventName'] == 'voidRecord') {
    console.log(___arguments['recordItem']);
    // Don't allow voiding the record if it's in isReadOnlyMode
    // (i.e. if someone else is editing, if it's already
    // been dispatched, or if it's already been voided)
    if (((getObjectProperty(___arguments['recordItem'], 'isDispatched')) || (getObjectProperty(___arguments['recordItem'], 'isVoided')) || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId'))))) == true) {
      (function (message) { alert(message) })('This record is currently being edited by another user, or it has already been dispatched or voided.  It cannot be voided at this time.');
    } else {
      ___arguments['recordItem']['isVoided'] = true;
      // This is how we can save just a single property into
      // the database without updating the entire record.
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`isVoided`]: (getObjectProperty(___arguments['recordItem'], 'isVoided')),[`dispatchedBy`]: (getObjectProperty(___arguments.context.appData, 'currentUser.name')) }) );
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments['recordItem'], 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after voiding the record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    }
  } else if (___arguments['eventName'] == 'duplicateRecord') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a2d650eca1d6503c9121ca913c4c7045');
    console.log('!!!RECORD');
    console.log(___arguments['recordItem']);
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Duplicate operation timed out after 20s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a809fd2715c4f0babc542a2e8da9e97e');
      console.log('record1');
      console.log(___arguments['recordItem']);
      submissionInfo = ['THIS RECORD WAS DUPLICATED FROM TRANSPORT REQUEST #',(getObjectProperty(___arguments['recordItem'], 'submissionNumber')),'.'].join('');
      newTransportRequestRecord = (Object.assign(({  }), ___arguments['recordItem']));
      delete newTransportRequestRecord['objectId'];
      delete newTransportRequestRecord['created'];
      delete newTransportRequestRecord['updated'];
      delete newTransportRequestRecord['submissionNumber'];
      newTransportRequestRecord['submissionOtherInformation'] = submissionInfo;
      newTransportRequestRecord['isDispatched'] = false;
      newTransportRequestRecord['isVoided'] = false;
      newTransportRequestRecord['dispatchedBy'] = null;
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty((await Backendless.Data.of('TransportRequest').deepSave( newTransportRequestRecord )), 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after duplicating a transport request record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await new Promise(r => setTimeout(r, 200 || 0));
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
      // This wait is here to make sure that the relations data
      // arrives into the data grid before the waiting spinner closes.
      await new Promise(r => setTimeout(r, 1200 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a809fd2715c4f0babc542a2e8da9e97e');
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'delete') {
    await BackendlessUI.Functions.Custom['fn_58f43615b3a18b74c5b8d439a61e9b2d'](___arguments.context.pageData, 'TransportRequest', ___arguments['recordItem'], (await (async function() {
    	//"___arguments" is a specific property Backendless uses and in this case it contains the object for the modal itself.

    	return ___arguments
    })()));
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:editorInfoLogic */
  ['editorInfoLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo'))

  },
  /* handler:editorInfoLogic */
  /* content */
}))

define('./pages/transport-req-test/components/ff57ab8eb9b2e5bf2f5ff0d6e6df5fcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var errors, durationRequestedTripLeadTime, error, millisecondsPerHour, timeToValidate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function validateTruncatedFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationLocationName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * This function will check various fields of the form and
 * make sure that input is valid. If it is not, it will throw
 * and error and prevent the remainder of the submission.
 */
async function validateFullFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.dateOfBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['dateOfBirth'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactPhone'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.SSN'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['SSN'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['assignedSexAtBirth'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightFt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightFt'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightIn'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightIn'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['weight'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeAffiliations'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['tribeAffiliations'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeMemberZipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['clientRecord.tribeMemberZipcode'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['email'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emailAlt'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientMedicallyClearedForTransportToday')) != true) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9b47fd8cdd2f04219a2f7997f9e7586')));
    errors['isClientMedicallyClearedForTransportToday'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['typeCustodyExchange'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['pickupConfirmationNumber'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.detentionCenterPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['detentionCenterPhone'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.isCourtOrdered')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.nameCourtOrSystemOrJudge'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['nameCourtOrSystemOrJudge'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19TestRequired')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationAcceptingProviderName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85042b9acde90c9937b6240f234825ac')));
    errors['destinationAcceptingProviderName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * Describe this function...
 */
async function validateTripTime(timeToValidate) {
  millisecondsPerHour = 3600000;
  if (timeToValidate == null) {
    console.log('Trip Time was NULL but was required.');
    return false;
  }
  try {
    durationRequestedTripLeadTime = ((timeToValidate.valueOf()) - ((new Date()).valueOf())) / millisecondsPerHour;
    console.log('validatePickupTime Function');
    console.log(durationRequestedTripLeadTime);
    console.log(durationRequestedTripLeadTime > 4);

  } catch (error) {
    console.log('Try/Catch Block in the validatePickupTime Function');
    console.log(error);

  }
  return durationRequestedTripLeadTime > 4
}


  console.log(___arguments.context.pageData);
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) != true) {
    (function (message) { alert(message) })('You must check the box indicating you have verified all information before saving changes or dispatching transport.');
    return ;
  } else if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) {
    // first check whether it's a truncated submission. If so, skip validation
    // since we haven't built that yet. If not, then run normal validation.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) == true) {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateTruncatedFormSubmission() == true) {
        console.log('Truncated form submissions were validated.');
      } else {
        console.log('Else Block in Truncated Form Submission validation');
        return ;
      }
    } else {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateFullFormSubmission() == true) {
        console.log('Full form submissions were validated.');
      } else {
        console.log('Else Block in Full Form Submission validation');
        return ;
      }
    }
    console.log('ElseIf in On Click Event of the Dispatch button occurred.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('73b93b24382d41b884a9e1223fd5ceba');
    return ;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after cancel button click.');
    console.log(error);

  }
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  console.log('Page Data Cancel Button: ');
  console.log(___arguments.context.pageData);
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllRecords'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'2\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/8dad9c1d07152be824327a0a917b9be8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving edits to the record.');
    console.log(error);

  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/73b93b24382d41b884a9e1223fd5ceba/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var automaticTransportNotes, error, transportRecordObjectId, newTransport, samsaraRouteId, durationSubmissionToScheduledPickup, millisecondsPerHour, existingClients, whereClause, SSN, clientRecord, nameLast, dateOfBirth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function createTransportNotes() {
  automaticTransportNotes = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) ? 'Adult ' : 'Minor ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')) ? [' (',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')),') '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) + String(', ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) + String('lbs. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSuicideOrSelfHarmRiskToday')) == true ? 'SI/SH. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasHistoryOfViolence')) == true ? 'History of Violence. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientAggressiveOrViolentToday')) == true ? 'Aggressive or Violent Today. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isElopementRisk')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientElopementRiskToday')) == true ? 'Elopement Risk. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasSpecialPrecautionsOrMedicalNeeds')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSpecialNeedsOrPrecautionsToday')) == true ? ['Client has special precautions or medical needs: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) + String(' - ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) + String('"  ') : ''].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCourtOrdered')) ? 'Court Ordered Transport.  ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')) ? ['PU Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')) ? ['PU Confirmation #: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')) ? ['Destination Appt At: ',((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')))).toString()),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')) ? ['Destination Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isWarmHandOffNeeded')) == true ? 'Warm Hand Off Needed.' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19Positive')) == true ? 'Client is COVID19 Positive. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')) ? ['Other Client Notes: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')),'"'].join('') : ''].join('');
  return automaticTransportNotes
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function findExistingClients() {
  clientRecord = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'));
  existingClients = [];
  if (clientRecord) {
    SSN = (getObjectProperty(clientRecord, 'SSN'));
    dateOfBirth = (getObjectProperty(clientRecord, 'datestringDateOfBirth'));
    nameLast = (getObjectProperty(clientRecord, 'nameLast'));
    whereClause = (await (async function(dateOfBirth, nameLast, objectId, SSN) {
    	const conditions = [];

    	if (SSN && SSN !== '999999999') {
    	  conditions.push(`SSN = '${ SSN }'`);
    	}

    	if (dateOfBirth && nameLast) {
    	  conditions.push(`(datestringDateOfBirth = '${ dateOfBirth }' AND nameLast = '${ nameLast.replace(/'/g, "''") }')`);
    	}


    	let whereClause = conditions.length > 0 ? conditions.join(' OR ') : '';

    	if (whereClause) {
    	  whereClause = `(${ whereClause }) AND `;
    	}

    	whereClause += `objectId != '${ objectId }'`;

    	return whereClause;

    })(dateOfBirth, nameLast, (getObjectProperty(clientRecord, 'objectId')), SSN));
    console.log(whereClause);
    existingClients = (await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setPageSize(100)));
    console.log('ExistingClients');
    console.log(existingClients);
    if (existingClients.length > 0) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))['existingClients'] = existingClients;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    } else {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    }
  }
}


  console.log('Start On Submit Event for formValidateAndDispatch');
  console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
  ___arguments.context.pageData['transportRecord'] = ({ [`notesTransport`]: await createTransportNotes() });
  await findExistingClients();
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) == false) {
    console.log('Form submit mergeClientsReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit mergeClientsReady value false condition was triggered.  mergeClientsReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    return ;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isSamsaraDispatch')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0062b56bd89d616ff334fb58a079062c', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('471299f304aa4981e6d8acb7c65c9e9f', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8eab4df2633c49ad3de2fae1de2dc4d8', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86a866357db8ed92dd6132cb9135fe88', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('254f6d5df02ed53bc5adc766a34d843a', undefined);
    // We wait until finalDispatchReady takes a value, then proceed.
    while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) != null)) {
      await new Promise(r => setTimeout(r, 100 || 0));
    }
    // If the user cancels in the modalDispatchTransport finalDispatchReady
    // will go to FALSE and then we clean things up just before returning.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) == false) {
      console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
      console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value after cleanup:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0062b56bd89d616ff334fb58a079062c', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('471299f304aa4981e6d8acb7c65c9e9f', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8eab4df2633c49ad3de2fae1de2dc4d8', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86a866357db8ed92dd6132cb9135fe88', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('254f6d5df02ed53bc5adc766a34d843a', undefined);
      return ;
    }
    try {

    } catch (error) {
      console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).');
      console.log(error);
      // This is asynch so that the RT command doesn't have to wait
      // on the email send. The RT command has to be at the end due
      // to the intermittent error seen for non-authenticated users.
      ;(async () => {
          ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001a) An error occurred during the dispatch process.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001a) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
        await new Promise(r => setTimeout(r, 10000 || 0));
        console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

      })();
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
        stopSetTimeout('transportRequestsVerifyAndDispatch');

      } catch (error) {
        console.log('Error encountered in the RT Channel Command during cleanup after e001a.');
        console.log(error);
        await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001a.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

      }
      // Make sure the record doesn't get marked as dispatched if there was an error.
      Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
      (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001a).');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
      return ;

    }
    try {
      console.log('Calling getRouteId with the following Information:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart'));
      samsaraRouteId = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) })), 'routeId'));
      console.log(samsaraRouteId);

    } catch (error) {
      console.log('Method getRouteId resulted in an error:');
      console.log(error);
      samsaraRouteId = null;

    }
    console.log('Starting to create the Transport record...');
    try {
      millisecondsPerHour = 3600000;
      if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')) == null) {
        (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['datetimeRequestedPickup'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission'));
      }
      durationSubmissionToScheduledPickup = (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour;
      // This assigns the values that define the transport record
      // or that need to be calculated in Codeless and that aren't
      // established in the modal popup or later through an API call.
      Object.assign((getObjectProperty(___arguments.context.pageData, 'transportRecord')), ({ [`datetimeDispatch`]: (new Date()),[`relDispatcher1_Employee`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.editorEmployeeObjectId')),[`durationSubmissionToScheduledPickup`]: durationSubmissionToScheduledPickup,[`durationRequestedTransportToScheduledPickup`]: (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')).valueOf())) / millisecondsPerHour,[`durationSubmissionToDispatch`]: (((new Date()).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour,[`isLongETA`]: durationSubmissionToScheduledPickup > 3,[`samsaraRouteId`]: samsaraRouteId,[`typeStatus`]: samsaraRouteId ? 'Dispatched' : null,[`billingEntityName`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_EntityRequestingTransport.requesterEntityName')),[`datetimeSubmission_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')),[`transportCode_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')) }));
      console.log('Saving the Transport record and it\'s relations to the DB');
      newTransport = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = newTransport;

        _uow.create('Transport', (getObjectProperty(___arguments.context.pageData, 'transportRecord'))).setOpResultId('createTransport');
        console.log('createTransport Completed');
        _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'rel_TransportRequest', [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))]).setOpResultId('relateTransportToTransportRequest');
        console.log('relateTransportToTransportRequest Completed');
        _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDispatcher1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee'))]).setOpResultId('relateTransportToDispatcher1');
        console.log('relateTransportToDispatcher1 Completed');
        _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDriver1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'))]).setOpResultId('relateTransportToDriver1');
        console.log('relateTransportToDriver1 Completed');
        _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relVehicle1_Vehicle', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle'))]).setOpResultId('relateTransportToVehicle1');
        console.log('relateTransportToVehicle1 Completed');

      })();

      console.log((await newTransport.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        })));
      transportRecordObjectId = (getObjectProperty(((newTransport.getOpResultById('createTransport')).getResult()), 'objectId'));
      try {
        await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', transportRecordObjectId);

      } catch (error) {
        console.log('Error encountered in the RT Channel Command after completion of the Transport Transaction.');
        console.log(error);
        await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of the Transport Transaction.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

      }

    } catch (error) {
      console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).');
      console.log(error);
      ;(async () => {
          ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001b) An error occurred during the dispatch process. (e001b)', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001b) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
        await new Promise(r => setTimeout(r, 10000 || 0));
        console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

      })();
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
        stopSetTimeout('transportRequestsVerifyAndDispatch');

      } catch (error) {
        console.log('Error encountered in the RT Channel Command during cleanup after e001b error.');
        console.log(error);
        await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001b error.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

      }
      // Make sure the record doesn't get marked as dispatched if there was an error.
      Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
      (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001b).');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
      return ;

    }
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command after completion of all other dispatch processes.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of all other dispatch processes.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Blink the data grid block in order to force a re-query,
    // which will in turn hide the recently dispatched record.
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('03e1b3340c8c321818aeed148cf13308');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  console.log('Just after opening modalDispatchTransport in form submit.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) == false) {
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
    return ;
  }
  try {
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFirst')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameLast')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionNumber'))].join(''),[`isDispatched`]: true,[`dispatchedBy`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName')) }));
    console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    console.log(getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName'));
    await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).');
    console.log(error);
    // This is asynch so that the RT command doesn't have to wait
    // on the email send. The RT command has to be at the end due
    // to the intermittent error seen for non-authenticated users.
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001a) An error occurred during the dispatch process.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001a) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001a.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001a.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001a).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    console.log('Calling getRouteId with the following Information:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart'));
    samsaraRouteId = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) })), 'routeId'));
    console.log(samsaraRouteId);

  } catch (error) {
    console.log('Method getRouteId resulted in an error:');
    console.log(error);
    samsaraRouteId = null;

  }
  console.log('Starting to create the Transport record...');
  try {
    millisecondsPerHour = 3600000;
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')) == null) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['datetimeRequestedPickup'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission'));
    }
    durationSubmissionToScheduledPickup = (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour;
    // This assigns the values that define the transport record
    // or that need to be calculated in Codeless and that aren't
    // established in the modal popup or later through an API call.
    Object.assign((getObjectProperty(___arguments.context.pageData, 'transportRecord')), ({ [`datetimeDispatch`]: (new Date()),[`relDispatcher1_Employee`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.editorEmployeeObjectId')),[`durationSubmissionToScheduledPickup`]: durationSubmissionToScheduledPickup,[`durationRequestedTransportToScheduledPickup`]: (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')).valueOf())) / millisecondsPerHour,[`durationSubmissionToDispatch`]: (((new Date()).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour,[`isLongETA`]: durationSubmissionToScheduledPickup > 3,[`samsaraRouteId`]: samsaraRouteId,[`typeStatus`]: samsaraRouteId ? 'Dispatched' : null,[`billingEntityName`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_EntityRequestingTransport.requesterEntityName')),[`datetimeSubmission_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')),[`transportCode_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')) }));
    console.log('Saving the Transport record and it\'s relations to the DB');
    newTransport = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = newTransport;

      _uow.create('Transport', (getObjectProperty(___arguments.context.pageData, 'transportRecord'))).setOpResultId('createTransport');
      console.log('createTransport Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'rel_TransportRequest', [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))]).setOpResultId('relateTransportToTransportRequest');
      console.log('relateTransportToTransportRequest Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDispatcher1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee'))]).setOpResultId('relateTransportToDispatcher1');
      console.log('relateTransportToDispatcher1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDriver1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'))]).setOpResultId('relateTransportToDriver1');
      console.log('relateTransportToDriver1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relVehicle1_Vehicle', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle'))]).setOpResultId('relateTransportToVehicle1');
      console.log('relateTransportToVehicle1 Completed');

    })();

    console.log((await newTransport.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    transportRecordObjectId = (getObjectProperty(((newTransport.getOpResultById('createTransport')).getResult()), 'objectId'));
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', transportRecordObjectId);

    } catch (error) {
      console.log('Error encountered in the RT Channel Command after completion of the Transport Transaction.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of the Transport Transaction.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).');
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001b) An error occurred during the dispatch process. (e001b)', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001b) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001b error.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001b error.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001b).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('Error encountered in the RT Channel Command after completion of all other dispatch processes.');
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of all other dispatch processes.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

  }
  // Blink the data grid block in order to force a re-query,
  // which will in turn hide the recently dispatched record.
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('03e1b3340c8c321818aeed148cf13308');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));

  },
  /* handler:onSubmit */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_b26ba78feceb903690c215dd3b5a4627']('.bl-form', 'novalidate', true);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_9339eea9fc6cd4337ba30a3da3c59d69']('.bl-form', 'novalidate');
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/transport-req-test/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to return
  // all records. It is here so that an error won't occur
  // when we pair this query string with the test data flag.
  ___arguments.context.pageData['strWhereClauseBase'] = 'submissionNumber != \'\'';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = false;
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = false;
  ___arguments.context.pageData['transportRequesterOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause('').setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'requesterEntityName')),[`id`]: (getObjectProperty(item, 'requesterId')) });})));
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['currentEditorInfo'] = (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab'](null));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setSortBy('vehicleName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus=\'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')),[`samsaraDriverId`]: (getObjectProperty(item, 'samsaraDriverId')) });})));
  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  ___arguments.context.pageData['typeInsuranceList'] = (await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setSortBy('typeInsurance').setPageSize(100).setDistinct(true))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'typeInsurance')),[`label`]: (getObjectProperty(item, 'typeInsurance')) });})));

  },
  /* handler:onBeforeEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var intervalId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  if ((getObjectProperty(___arguments.context.appData, 'intervalIds')).length > 0) {
    var intervalId_list = (getObjectProperty(___arguments.context.appData, 'intervalIds'));
    for (var intervalId_index in intervalId_list) {
      intervalId = intervalId_list[intervalId_index];
      stopSetTimeout(intervalId);
    }
  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/transport-req-test/components/61a2dbca36c2a1c4c3e90bc66884e70d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var matchedRequester, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  // If there is a selection in the selectRequestForm,
  // then find the item in transportRequesterOptions that
  // matches the selection. Otherwise, create a blank object.
  if (getObjectProperty(___arguments.context.pageData, 'manualRequestForm')) {
    matchedRequester = (await asyncListFind((getObjectProperty(___arguments.context.pageData, 'transportRequesterOptions')), async (item) => {
       if ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.pageData, 'manualRequestForm'))) {
        console.log('Match Found in If Statement.  Returning:  ');
        console.log(item);
        return item;
      }


     return ;
    }));
  } else {
    matchedRequester = ({  });
  }
  // General Submissions has a "null" ID.  Check for this, if it's null then leave requester out.  If it's not, then make a requester ID and append it to the URL.  Same is true if nothing is selected in the drop down and manualRequestForm is empty.
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ((getObjectProperty(matchedRequester, 'id')) ? ({ [`requesterId`]: (getObjectProperty(matchedRequester, 'id')) }) : null));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/798ae65f7a5c716c91b159a9fb871a51/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Data Model for Client Info RUC');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord'));

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/d7a7974b30f168dcdeec7d77b0224b74/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'driverOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relDriver1_Employee'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['samsaraDriverId'] = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'driverOptions')), async (item) => {
     if ((getObjectProperty(item, 'value')) == ___arguments.value) {
      return item;
    }


   return ;
  })), 'samsaraDriverId'));
  console.log('Driver objectId and samsaraDriverId selected:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'));
  console.log('Full transportRecordReusableData at time of Selection:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/b2b30c2ba1897d0377e47dbaf0ed5a09/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vehicleOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relVehicle1_Vehicle'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/641efe0ed8775c4bb75880db2d67e3e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b9a7b642136d2dc472510391d36b61d1');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/cdbf241e6dd778235203fa7c7be289bf/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/4d1e20aa6af3ad57a1c9830180eb952b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/c641e4df2187580bc22281aec10f30de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been
  // voided or already dispatched or is read only.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/e6d1ddba6d572196bbe314d2a7dfd02d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been voided or already dispatched.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/531427c425c186d9710f7c2e205ea7e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = false;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  console.log('On Click Event of Cancel button in modalDispatchTransport.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'finalDispatchReady'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/8d1ba8a68826d30c4e0bd759d24e0973/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/a23c7906b1c25649f56dff288e438d11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('03e1b3340c8c321818aeed148cf13308');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/6aafb61d42cb9872ae777823391ff04a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/7f1913299f7463f4ff5d0517eebdcfdb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/2c8f6c12129b3164aa7c7031326e8774/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', ({ [`strWhereClauseBase`]: ['&& rel_TransportRequest.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\''].join('') }));
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// This button only makes sense to show if the record has been dispatched.

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/d9594a32d6c5d23c1382b6998baef31c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  }
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/0c757ba64a75ec64a5c6cde4b0ccd4a2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['submissionOtherInformation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/a199ac635af14cb3e08dcd92469903e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/9de76a5a0ff5fd5d72cfe67da6067954/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['notesTransport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRecord.notesTransport'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/a2d650eca1d6503c9121ca913c4c7045/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-req-test/components/8f1bef3521655b340ea3405cb7f72754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  console.log('Printing data containers after close:');
  console.log(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'));
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.layoutData);
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/131e3b99f5866c255e6df08e6aab9f41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/7169de853e2f49f261a78b784938060f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/dd9f6fdc6541ad623fafe6d10422b8f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // If someone saves and closes then reset the 'isInformationVerified'
  // so that they always have to attest to that before dispatch
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isInformationVerified'] = false;
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving changes to the record.');
    console.log(error);

  }
  (function (message) { alert(message) })('Changes have been saved!');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// We show the save changes button anytime the record is not in read only mode.

  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/92916f6859815d21ebccc33ba547a5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'30\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/a3d1808a775455748ad8706c5c9fed92/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/2fc510ebd655f892523b7bf476ab8a6b/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) : []).map(async item => {  label = ['Client Name: ',(getObjectProperty(item, 'nameFull')),', ','DoB: ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(item, 'dateOfBirth')))))),', ','SSN: ',(await (async function(SSN) {
  	if (!SSN || typeof SSN !== 'string') {
  	    return 'N/A'
  	}

  	if (!/^\d{9}$/.test(SSN)) {
  	  return SSN;
  	}

  	return `${SSN.slice(0, 3)}-${SSN.slice(3, 5)}-${SSN.slice(5, 9)}`;
  })((getObjectProperty(item, 'SSN')))),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','Object ID: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['selectedExistingClient'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/e6f4346a48f98663175a2f04d3970a94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['No matching Client was found in our records. This Transport Request will continue to use the new Client record created for client ',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.dateOfBirth')))))),'.'].join(''));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/2371be049f256a4bda2fbc6a45e12a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-req-test/components/e0cd4d5ad60949056c2b8265fc369f8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/7c8af31888b5d78a223db642a1571502/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, result, mergeClientTx, j, transportRequestsToUpdate, retainCertainClientInfo, pageSize, offset, transportRequest, transportRequests, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = true;
  try {
    transportRequestsToUpdate = [];
    count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join('')))));
    offset = 0;
    pageSize = 100;
    while (offset < count) {
      transportRequests = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
      for (var transportRequest_index in transportRequests) {
        transportRequest = transportRequests[transportRequest_index];
        addItemToList(transportRequestsToUpdate, transportRequest);
      }
      offset = offset + pageSize;
    }
    transportRequestsToUpdate = (await (async function(arr) {
    	const seen = new Set()


    	return arr.filter(item => {
    	  const isDuplicate = seen.has(item.objectId)

    	  seen.add(item.objectId)

    	  return !isDuplicate
    	})

    })(transportRequestsToUpdate));
    console.log('%c>> 🔒 ' + 'TransportRequestsToUpdate:', 'color: #f06292', JSON.parse(JSON.stringify(transportRequestsToUpdate)));

  } catch (error) {
    console.log('%c>> 🔒 ' + 'Error:', 'color: #ef5350', JSON.parse(JSON.stringify(error)));
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    return ;

  }
  console.log('%c>> 🔒 ' + 'selectedExistingClient', 'color: #4caf50', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))));
  try {
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #3f51b5', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    mergeClientTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    // This flag is used to determine whether the update operation
    // for selectedExistingClient needs to be added to the
    // transaction in order to preserve SSN or insurance information.
    retainCertainClientInfo = false;
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.SSN')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'))) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['SSN'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'));
      retainCertainClientInfo = true;
    }
    if (retainCertainClientInfo) {
      await ( async () => {
        const _uow = mergeClientTx;

        _uow.update('Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('UpdateClient: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.objectId'))));

      })();

    }
    if (transportRequestsToUpdate.length > 0) {
      for (var j_index in transportRequestsToUpdate) {
        j = transportRequestsToUpdate[j_index];
        await ( async () => {
          const _uow = mergeClientTx;

          _uow.setRelation('TransportRequest', j, 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(j, 'objectId'))));

        })();

      }
    }
    await ( async () => {
      const _uow = mergeClientTx;

      _uow.setRelation('TransportRequest', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')), 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))));
      _uow.delete('Client', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'))).setOpResultId((String('ClientObjectDelete: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId'))));

    })();

    result = (await mergeClientTx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));
    console.log(result);
    if (getObjectProperty(result, 'success')) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['clientRecord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['rel_Client'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
    }
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #f06292', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    await (getChannelInstance('default')).send((String('reload-table-records:') + String('TransportRequest')), ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['This Transport Request is now matched to existing client ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.dateOfBirth')))))),'.'].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  } catch (error) {
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/af16da7891b50db1a92c72c3cb02852a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/752113b5eb5a9ee55c96c7dcad88256b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/613926da2f8c51cf8e42ba2f953ed245/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/3d05686703fb302b56bc4968f8332998/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['isDriversLastRoute'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/7d0cc286017a265580b90576fa296c83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/cd416fb140f955bf17c52d7d4c9f7d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/33ef3456b45c06195036af6564a7ffd2/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, clientPasteDate, transportRequestPasteData, SpecialNeedsOrConcernsNotes, startNumber, listFromPaste, heightIn, heightFt, dateOfBirth, destinationLocationName, totalHeight, specialPrecautionso_MedicalConcerns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('No', 'g')), ''));
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('Yes', 'g')), 'TRUE'));
    listFromPaste = (getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).split(':');
    console.log('Value of #1 item on list');
    console.log(listFromPaste[0].trim());
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log(startNumber);
    console.log(listFromPaste[((startNumber + 32) - 1)]);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 32) - 1)].trim()) + String(':');
    console.log(SpecialNeedsOrConcernsNotes);
    specialPrecautionso_MedicalConcerns = subsequenceFirstFromEnd(listFromPaste[((startNumber + 29) - 1)], 19).trim();
    SpecialNeedsOrConcernsNotes = String(SpecialNeedsOrConcernsNotes) + String(String('  Special Precautions or Medical Concerns: ') + String(specialPrecautionso_MedicalConcerns));
    console.log('Special Precautions Notes');
    console.log(SpecialNeedsOrConcernsNotes);
    if ((specialPrecautionso_MedicalConcerns.indexOf('Suicide/Self Harm') !== -1) || (specialPrecautionso_MedicalConcerns.indexOf('Self-Harm Risk') !== -1)) {
      console.log('Suicide/Self Harm');
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Elopement Risk') !== -1) {
      console.log('Elopement Risk');
      ___arguments.context.dataModel['isElopementRisk'] = true;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isElopementRisk'] = false;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Disorganized Behavior') !== -1) {
      console.log('Disorganized Behavior');
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
    } else {
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Fall Risk') !== -1) {
      console.log('Fall Risk');
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
    }
    destinationLocationName = String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 23) - 1)], 20).trim()) + String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 24) - 1)], 28).trim());
    dateOfBirth = (new Date((new Date((subsequenceFirstFromEnd(listFromPaste[((startNumber + 9) - 1)], 10).trim()))).getTime() + ((19 * 3600) * 1000)));
    totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim();
    console.log('total height');
    console.log(totalHeight);
    if (totalHeight.indexOf('\'') !== -1) {
      totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim().split('\'');
      heightFt = totalHeight[0].trim();
      heightIn = totalHeight[1].trim().charAt(0);
    } else {
      heightFt = totalHeight;
      heightIn = 0;
    }
    console.log('listFromPaste');
    console.log(listFromPaste);
    transportRequestPasteData = ({ [`isContactedYMCR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 7) - 1)], 38).trim() == 'TRUE' ? true : false,[`isMCTR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 8) - 1)], 10).trim() == 'TRUE' ? true : false,[`isCOVID19Positive`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 14) - 1)], 24).trim() == 'TRUE' ? true : false,[`referringEntityName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 18) - 1)], 17).trim(),[`referringContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 19) - 1)], 30).trim(),[`referringContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 20) - 1)], 15).trim()).replace((new RegExp('-', 'g')), '')),[`pickupAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 21) - 1)], 66).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`isReferralToNearestUrcOrCc`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 22) - 1)], 14).trim() == 'TRUE' ? true : false,[`destinationLocationName`]: destinationLocationName,[`destinationAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 25) - 1)], 28).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`destinationContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 26) - 1)], 32).trim(),[`destinationContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 27) - 1)], 23).trim()).replace((new RegExp('-', 'g')), '')),[`isClientAggressiveOrViolentToday`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 31) - 1)], 22).trim() == 'TRUE' ? true : false,[`isClientElopementRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientElopementRiskToday')),[`isClientSuicideOrSelfHarmRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientSuicideOrSelfHarmRiskToday')),[`isClientFallRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientFallRiskToday')),[`stateSubmissionNumber`]: (getObjectProperty(___arguments.context.dataModel, 'stateSubmissionNumber')) });
    clientPasteDate = ({ [`nameFirst`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 5) - 1)], 19).trim(),[`is18`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 6) - 1)], 48).trim(),[`dateOfBirth`]: dateOfBirth,[`age`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 10) - 1)], 13).trim(),[`assignedSexAtBirth`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 11) - 1)], 13).trim(),[`heightFt`]: heightFt,[`heightIn`]: heightIn,[`weight`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 13) - 1)], 22).trim(),[`emergencyContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 15) - 1)], 31).trim(),[`emergencyContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 16) - 1)], 41).trim()).replace((new RegExp('-', 'g')), '')),[`hasHistoryOfViolence`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 30) - 1)], 28).trim() == 'TRUE' ? true : false,[`otherNotes`]: SpecialNeedsOrConcernsNotes,[`isElopementRisk`]: (getObjectProperty(___arguments.context.dataModel, 'isElopementRisk')),[`hasDisorganizedBehavior`]: (getObjectProperty(___arguments.context.dataModel, 'hasDisorganizedBehavior')) });
    console.log('Transport Request Data');
    console.log(transportRequestPasteData);
    console.log('Client Record Data');
    console.log(clientPasteDate);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ({ [`transportRequestRecord`]: transportRequestPasteData,[`clientRecord`]: clientPasteDate,[`requesterId`]: 'STATE' }));

  } catch (error) {
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An error occurred during the copy/paste of a submission record into the app.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the copy/paste of a submission record into the app.' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/copy-paste-errors', error, 'An error occurred during the copy/paste of a submission record into the app.', 'Form paste-state-submission Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));

    })();
    (function (message) { alert(message) })('We\'re sorry, there was an error when you attempted to copy/paste the record.  Please refresh your browser tab and try to copy/paste again.  Please be sure to paste from just before "RideCARE Submission Submission Date:" until the very end of the email after the "Special Needs/Concerns" section.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transport-req-test/components/a781341ea971861568c9bd1b125a5683/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['State Submission #',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')),(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.usedEmailParser')) ? ' automatically parsed from email.' : ''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/c5aeecbb7a7b29a5d767bc4a68e9c5a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['State Submission #',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')),(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.usedEmailParser')) ? ' automatically parsed from email.' : ''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/96375d9c8e896078c906901591a7205d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var endValid, startValid, SpecialNeedsOrConcernsNotes, firstListValue, error, startNumber, listFromPaste;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', false);
  try {
    listFromPaste = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33ef3456b45c06195036af6564a7ffd2'), 'textTransportPaste')).split(':');
    console.log('List From Paste');
    console.log(listFromPaste);
    firstListValue = listFromPaste[0].trim();
    console.log('Value of #1 item on list');
    console.log(firstListValue);
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log('Start Number = ');
    console.log(startNumber);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 31) - 1)].trim()) + String(':');
    console.log('Special Needs Or Concerns');
    console.log(SpecialNeedsOrConcernsNotes);

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', true);
    return ;

  }
  if ((firstListValue.indexOf('Name') !== -1) == true || (firstListValue.indexOf('Date') !== -1) == true) {
    startValid = true;
  } else {
    startValid = false;
  }
  if ((SpecialNeedsOrConcernsNotes.indexOf('Needs') !== -1) == true) {
    endValid = true;
  } else {
    endValid = false;
  }
  if (startValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', true);
    return ;
  } else if (endValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', true);
    return ;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/9476118d4077f7a10cb49bcb3cf3ca06/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = true;
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/f91e5188b16edf7dcaffed3466ff3187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/8c99e5feb0d40b950d6ebea30d19ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFull'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/8d5b50cbe9b5fe8b72bc4937d5f67042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/c9a812f721adb279f32f508e2ffaf36b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Simply sets the isDriverLastRoute property to be true or
  // false based on the checkbox. This value is used in cloud code
  // timers in order to get the "fourth leg" odometer readings
  // of routes that occur before a driver ends their shift.
  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['isDriversLastRoute'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/01358cac7395efffbd25fc9a66d725e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Create the submissionCode which is comprised of the
  // first 3 characters of clients first name, first 3
  // letters of clients last name, and the submissionNumber.
  // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
  Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFirst')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameLast')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionNumber'))].join(''),[`isDispatched`]: true,[`dispatchedBy`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName')) }));
  console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
  // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
  console.log(getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName'));
  console.log('Page Data');
  console.log(___arguments.context.pageData);
  console.log('Submission Code');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode'));
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  // For more detailed documentation see the postNewRoute
  // API service in the cloud code section under js
  // services. This method posts a route to Samsara.
  await Backendless.Request.post(`${Backendless.appPath}/services/postNewRoute/postRoute`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeName': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')),'driverId': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'routeNotes': 'Notes for transport','stops': [({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'startingLocation.address')),[`address`]: (getObjectProperty(___arguments.context.pageData, 'startingLocation.address')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'startingLocation.latitude')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'startingLocation.longitude')),[`scheduled_departure_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.0.scheduledDeparture')),[`notes`]: 'Notes for stop 1' }), ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.googleName')),[`address`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.googleFormattedAddress')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.latitude')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.longitude')),[`scheduled_arrival_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledArrival')),[`notes`]: 'Notes for stop 2' }), ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.googleName')),[`address`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.googleFormattedAddress')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.latitude')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.longitude')),[`scheduled_arrival_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledArrival')),[`notes`]: 'Notes for stop 3' })] });
  await new Promise(r => setTimeout(r, 2000 || 0));
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b9a7b642136d2dc472510391d36b61d1');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    
  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/8f8d5a83d40574cbd37a5dcd3d58859c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = false;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  console.log('On Click Event of Cancel button in davidDispatchBlock finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'finalDispatchReady'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/ddb9a3cd09d5a9b16e834196629549c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Page Data: ');
  console.log(___arguments.context.pageData);
  console.log('driver Id:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log('samsaraVehicleId: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'samsaraVehicleId.samsaraVehicleId'));
  try {
    // Set serviceTimes property in Page Data. serviceTimes is an
    // array of numbers corresponding to the inputs of the service
    // time select components in the davidDispatchBlock UI.
    ___arguments.context.pageData['serviceTimes'] = [(Number((getObjectProperty(___arguments.context.pageData, 'startServiceTime')))), (Number((getObjectProperty(___arguments.context.pageData, 'pickupServiceTime')))), (Number((getObjectProperty(___arguments.context.pageData, 'dropoffServiceTime'))))];
    console.log('%c>> ' + 'stops Array:', 'color: null', (getObjectProperty(___arguments.context.pageData, 'serviceTimes')));
    // set property in Page Data optimzedData which contains an
    // array of three indexes, each index has information such
    // as the scheduled departure and arrival time of that stop.
    ___arguments.context.pageData['optimizedData'] = (await Backendless.Request.get(`${Backendless.appPath}/services/DistanceMatrixService/TravelTimesFromStops`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'transportRecord': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))),'driverId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'))),'vehicleId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'samsaraVehicleId.samsaraVehicleId'))),'serviceTimes': (await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788']((getObjectProperty(___arguments.context.pageData, 'serviceTimes')))) }).send());
    // These set property blocks are here because the on change
    // event doesn't seem to be working for the datetime select
    // components. This ensures they are properly saved in transportRecord
    // since they need to be saved back to the database eventually
    (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.0.scheduledArrival'));
    (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledArrival'));
    (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledArrival'));
    console.log('optimizedData');
    console.log(getObjectProperty(___arguments.context.pageData, 'optimizedData'));
    console.log('Page data:');
    console.log(___arguments.context.pageData);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'samsaraVehicleId.samsaraVehicleId')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'))) == null)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/3e1a376133bb8697886ab35f318cff73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // This block creates a new property in Page Data which
  // holds a startingLocation object. This object contains the
  // address, latitude, and longitude of the starting location,
  // and these properties are used in other codeless blocks.
  ___arguments.context.pageData['startingLocation'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getRouteStartingLocation/StartingLocation`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'driverId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'))),'vehicleID': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'samsaraVehicleId.samsaraVehicleId'))) }).send());
  console.log('starting location');
  console.log(getObjectProperty(___arguments.context.pageData, 'startingLocation'));
  // It is important to keep this wait block. The API service
  // called below "createRoute" creates an object for our google
  // map custom component. It needs to know the latitude and
  // longitude of the starting location, which is only available
  // upon the button press. Therefore, the wait ensures that the
  // startingLocation object has rendered to avoid race conditions.
  await new Promise(r => setTimeout(r, 2000 || 0));
  // Set a property in page data called routeForMap, which
  // will later be passed as the return for our custom google
  // map component. This creates a JSON object which can be
  // viewed under the route logic return in alex map test.
  ___arguments.context.pageData['routeForMap'] = (await Backendless.Request.post(`${Backendless.appPath}/services/createRoute/constructRouteForMap`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.latitude')),'lng1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.longitude')),'lat2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.latitude')),'lng2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.longitude')),'lat3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.latitude')),'lng3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.longitude')),'title1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.address')),'title2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.googleFormattedAddress')),'title3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.googleFormattedAddress')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-req-test/components/a81aba8afd1edca9198be7e4692b28ed/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['notesTransport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRecord.notesTransport'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/e09107225bf919e23cfbc2f289183686/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.googleFormattedAddress'))

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/60a567eeab448b48cf8a6649fb057d3f/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.googleFormattedAddress'))

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/60c38f877efd93bfd2dc985b1cf18424/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.samsaraVehicleId')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.samsaraDriverId'))) == null)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/d2b9b9acb77b6f7511ef57c40ae6d019/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  // This sets the property relDriver1_Employee of
  // transportRecord of Page Data to be the changed value,
  // which happens to be an ObjectId rather than a name.
  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relDriver1_Employee'] = ___arguments.value;
  // This sets the samsaraDriverId property which will need to be used
  // with a variety of Samsara API calls in other codeless blocks.
  // We go through driverOptions of page data and match the ID.
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['samsaraDriverId'] = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'driverOptions')), async (item) => {
     if ((getObjectProperty(item, 'value')) == ___arguments.value) {
      return item;
    }


   return ;
  })), 'samsaraDriverId'));
  console.log('Driver objectId and samsaraDriverId selected: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'));
  console.log('Full transportRecordReusableData at time of selection');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// Page Data contains a property called driverOptions, which can be used as the options logic for this select component.

  return (getObjectProperty(___arguments.context.pageData, 'driverOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/a0342c222b7e99b33a0ef1853a319984/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vehicleOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relVehicle1_Vehicle'] = ___arguments.value;
  ___arguments.context.pageData['samsaraVehicleId'] = ((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle')),'\''].join(''))).setProperties('samsaraVehicleId').setPageSize(10)))[0]);
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/dce8c5058982a41bdd98c1615518f2ed/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.0.scheduledArrival'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/e4d94348eeca70a5be73f58c5fe8eb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledArrival'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/d51cbf841159e4b8f95dcf042b1dd09e/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledArrival'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-req-test/components/7be95ac92f778304352e589b79fc715a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['startServiceTime'] = ___arguments.value;
  console.log('Page data:');
  console.log(___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/e5c7e03a15937cc291fb6a1e3d11b3b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['pickupServiceTime'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/64fd22ff869d8401447c0bb8f77aac4b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['dropoffServiceTime'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/181fff18113a7b55e226de2a59db58d7/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.0.scheduledDeparture'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // These set property blocks are here because the on change
  // event doesn't seem to be working for the datetime select
  // components. This ensures they are properly saved in transportRecord
  // since they need to be saved back to the database eventually
  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/f1636a6f311b23172552ded102974ad5/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledDeparture'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledArrival'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/9f07a4b720987ef30d0df9f70284bb91/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledDeparture'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledArrival'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/40528ca5a234fa54bd4f40ace1b7a15b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Page Data: ');
  console.log(___arguments.context.pageData);
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isSamsaraDispatch'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-req-test/components/41bf9d1f9418a07dab6ff20623f2e22f/bundle.js', [], () => ({
  /* content */
  /* handler:routeLogic */
  ['routeLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'routeForMap'))

  },
  /* handler:routeLogic */
  /* handler:trafficLogic */
  ['trafficLogic'](___arguments) {
      return true

  },
  /* handler:trafficLogic */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Transport Requests',[`pageName`]: 'transport-requests' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'showAllRecords')) == true)) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},

    	{
    	  "field": "isEOD",
    	  "headerName": "Crisis?",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 40,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "headerTooltip": "Date & Time when the transport request was received via ORC app form.",
    	  "type": "datetimeColumn",
    	  "cellRendererParams": {
    	    "dayjsFormat": "MM/DD/YYYY HH:mm",
    	    "withSeconds": false
    	  },
    	  "width": 155,
    	  "sortable": true,
    	  "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false,
    	  "wrapHeaderText": true,
    	  "autoHeaderHeight": true,
    	  "meta": { "align": "center" }
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "minWidth": 200,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "minWidth": 200,
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},

    	{
    	  "field": "isEOD",
    	  "headerName": "Crisis?",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 40,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  "editable": false
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, newTransportRequestRecord, submissionInfo, waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for use as both input forms and viewers.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'validateAndDispatchRecord') {
    console.log('Printing data containers after close:');
    console.log(___arguments['recordItem']);
    console.log(___arguments.context.pageData);
    console.log(___arguments.context.layoutData);
    console.log(___arguments.context.appData);
    // Don't allow editing in the UI window if the record has already been dispatched, if the record is voided, or if another user is already editing it.
    // This was disabled when we made it so that transport requests could be edited after dispatch.  It can be removed at a later date.
    ___arguments.context.pageData['transportRequestRecordReusableData'] = ({ [`transportRequestRecord`]: ___arguments['recordItem'],[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`pickupFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relPickup_Facility')),[`destinationFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relDestination_Facility')),[`requesterRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_EntityRequestingTransport')),[`selectExistingClientData`]: ({  }),[`isReadOnlyMode`]: false || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId')))) ? true : false });
    // This makes sure that the requester ID is present on page
    // Data here like it is on the Transport Request Form Page.
    ___arguments.context.pageData['requesterId'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterId'));
    console.log('Action Icon Click Event - PageData.requesterId:');
    console.log(getObjectProperty(___arguments.context.pageData, 'requesterId'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    // Only trigger the 'editing' command interval if the record is not read only.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == false) {
      try {

        ;(function() {
          const callback = async () => {
              await (getChannelInstance('default')).send('editing-table:TransportRequest', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

          };

          const timerId = 'transportRequestsVerifyAndDispatch';
          const timerDelay = 1000;

          runSetTimeout(timerId, callback, timerDelay)
        })()

      } catch (error) {
        console.log('An error was seen in the RT Channel Command for isReadOnlyMode');
        console.log(error);

      }
    }
  } else if (___arguments['eventName'] == 'voidRecord') {
    console.log(___arguments['recordItem']);
    // Don't allow voiding the record if it's in isReadOnlyMode
    // (i.e. if someone else is editing, if it's already
    // been dispatched, or if it's already been voided)
    if (((getObjectProperty(___arguments['recordItem'], 'isDispatched')) || (getObjectProperty(___arguments['recordItem'], 'isVoided')) || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId'))))) == true) {
      (function (message) { alert(message) })('This record is currently being edited by another user, or it has already been dispatched or voided.  It cannot be voided at this time.');
    } else {
      ___arguments['recordItem']['isVoided'] = true;
      // This is how we can save just a single property into
      // the database without updating the entire record.
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`isVoided`]: (getObjectProperty(___arguments['recordItem'], 'isVoided')),[`dispatchedBy`]: (getObjectProperty(___arguments.context.appData, 'currentUser.name')) }) );
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments['recordItem'], 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after voiding the record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    }
  } else if (___arguments['eventName'] == 'duplicateRecord') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a2d650eca1d6503c9121ca913c4c7045');
    console.log('!!!RECORD');
    console.log(___arguments['recordItem']);
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Duplicate operation timed out after 20s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a809fd2715c4f0babc542a2e8da9e97e');
      console.log('record1');
      console.log(___arguments['recordItem']);
      submissionInfo = ['THIS RECORD WAS DUPLICATED FROM TRANSPORT REQUEST #',(getObjectProperty(___arguments['recordItem'], 'submissionNumber')),'.'].join('');
      newTransportRequestRecord = (Object.assign(({  }), ___arguments['recordItem']));
      delete newTransportRequestRecord['objectId'];
      delete newTransportRequestRecord['created'];
      delete newTransportRequestRecord['updated'];
      delete newTransportRequestRecord['submissionNumber'];
      newTransportRequestRecord['submissionOtherInformation'] = submissionInfo;
      newTransportRequestRecord['isDispatched'] = false;
      newTransportRequestRecord['isVoided'] = false;
      newTransportRequestRecord['dispatchedBy'] = null;
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty((await Backendless.Data.of('TransportRequest').deepSave( newTransportRequestRecord )), 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after duplicating a transport request record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await new Promise(r => setTimeout(r, 200 || 0));
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
      // This wait is here to make sure that the relations data
      // arrives into the data grid before the waiting spinner closes.
      await new Promise(r => setTimeout(r, 1200 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a809fd2715c4f0babc542a2e8da9e97e');
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'delete') {
    await BackendlessUI.Functions.Custom['fn_58f43615b3a18b74c5b8d439a61e9b2d'](___arguments.context.pageData, 'TransportRequest', ___arguments['recordItem'], (await (async function() {
    	//"___arguments" is a specific property Backendless uses and in this case it contains the object for the modal itself.

    	return ___arguments
    })()));
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:editorInfoLogic */
  ['editorInfoLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo'))

  },
  /* handler:editorInfoLogic */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/ff57ab8eb9b2e5bf2f5ff0d6e6df5fcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var errors, durationRequestedTripLeadTime, error, millisecondsPerHour, timeToValidate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function validateTruncatedFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationLocationName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * This function will check various fields of the form and
 * make sure that input is valid. If it is not, it will throw
 * and error and prevent the remainder of the submission.
 */
async function validateFullFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.dateOfBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['dateOfBirth'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactPhone'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.SSN'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['SSN'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['assignedSexAtBirth'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.typeInsurance'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['typeInsurance'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightFt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightFt'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightIn'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightIn'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['weight'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeAffiliations'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['tribeAffiliations'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeMemberZipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['clientRecord.tribeMemberZipcode'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['email'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emailAlt'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientMedicallyClearedForTransportToday')) != true) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9b47fd8cdd2f04219a2f7997f9e7586')));
    errors['isClientMedicallyClearedForTransportToday'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['typeCustodyExchange'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['pickupConfirmationNumber'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.detentionCenterPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['detentionCenterPhone'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.isCourtOrdered')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.nameCourtOrSystemOrJudge'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['nameCourtOrSystemOrJudge'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19TestRequired')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationAcceptingProviderName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85042b9acde90c9937b6240f234825ac')));
    errors['destinationAcceptingProviderName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * Describe this function...
 */
async function validateTripTime(timeToValidate) {
  millisecondsPerHour = 3600000;
  if (timeToValidate == null) {
    console.log('Trip Time was NULL but was required.');
    return false;
  }
  try {
    durationRequestedTripLeadTime = ((timeToValidate.valueOf()) - ((new Date()).valueOf())) / millisecondsPerHour;
    console.log('validatePickupTime Function');
    console.log(durationRequestedTripLeadTime);
    console.log(durationRequestedTripLeadTime > 4);

  } catch (error) {
    console.log('Try/Catch Block in the validatePickupTime Function');
    console.log(error);

  }
  return durationRequestedTripLeadTime > 4
}


  console.log(___arguments.context.pageData);
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) != true) {
    (function (message) { alert(message) })('You must check the box indicating you have verified all information before saving changes or dispatching transport.');
    return ;
  } else if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) {
    // first check whether it's a truncated submission. If so, skip validation
    // since we haven't built that yet. If not, then run normal validation.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) == true) {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateTruncatedFormSubmission() == true) {
        console.log('Truncated form submissions were validated.');
      } else {
        console.log('Else Block in Truncated Form Submission validation');
        return ;
      }
    } else {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateFullFormSubmission() == true) {
        console.log('Full form submissions were validated.');
      } else {
        console.log('Else Block in Full Form Submission validation');
        return ;
      }
    }
    console.log('ElseIf in On Click Event of the Dispatch button occurred.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('73b93b24382d41b884a9e1223fd5ceba');
    return ;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllRecords'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'2\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/8dad9c1d07152be824327a0a917b9be8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  // If someone saves and closes then reset the 'isInformationVerified'
  // so that they always have to attest to that before dispatch
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isInformationVerified'] = false;
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving edits to the record.');
    console.log(error);

  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/f8ebf058e8eb6ec9ce9672bd6caa3c0d/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified'))

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = ___arguments.value;
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/73b93b24382d41b884a9e1223fd5ceba/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var automaticTransportNotes, error, transportRecordObjectId, newTransport, samsaraRouteId, durationSubmissionToScheduledPickup, millisecondsPerHour, existingClients, whereClause, SSN, clientRecord, nameLast, dateOfBirth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function createTransportNotes() {
  automaticTransportNotes = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) ? 'Adult ' : 'Minor ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')) ? [' (',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')),') '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) + String(', ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) + String('lbs. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSuicideOrSelfHarmRiskToday')) == true ? 'SI/SH. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasHistoryOfViolence')) == true ? 'History of Violence. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientAggressiveOrViolentToday')) == true ? 'Aggressive or Violent Today. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isElopementRisk')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientElopementRiskToday')) == true ? 'Elopement Risk. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasSpecialPrecautionsOrMedicalNeeds')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSpecialNeedsOrPrecautionsToday')) == true ? ['Client has special precautions or medical needs: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) + String(' - ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) + String('"  ') : ''].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCourtOrdered')) ? 'Court Ordered Transport.  ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')) ? ['PU Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')) ? ['PU Confirmation #: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')) ? ['Destination Appt At: ',((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')))).toString()),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')) ? ['Destination Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isWarmHandOffNeeded')) == true ? 'Warm Hand Off Needed.' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19Positive')) == true ? 'Client is COVID19 Positive. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')) ? ['Other Client Notes: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')),'"'].join('') : ''].join('');
  return automaticTransportNotes
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function findExistingClients() {
  clientRecord = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'));
  existingClients = [];
  if (clientRecord) {
    SSN = (getObjectProperty(clientRecord, 'SSN'));
    dateOfBirth = (getObjectProperty(clientRecord, 'datestringDateOfBirth'));
    nameLast = (getObjectProperty(clientRecord, 'nameLast'));
    whereClause = (await (async function(dateOfBirth, nameLast, objectId, SSN) {
    	const conditions = [];

    	if (SSN && SSN !== '999999999') {
    	  conditions.push(`SSN = '${ SSN }'`);
    	}

    	if (dateOfBirth && nameLast) {
    	  conditions.push(`(datestringDateOfBirth = '${ dateOfBirth }' AND nameLast = '${ nameLast.replace(/'/g, "''") }')`);
    	}


    	let whereClause = conditions.length > 0 ? conditions.join(' OR ') : '';

    	if (whereClause) {
    	  whereClause = `(${ whereClause }) AND `;
    	}

    	whereClause += `objectId != '${ objectId }'`;

    	return whereClause;

    })(dateOfBirth, nameLast, (getObjectProperty(clientRecord, 'objectId')), SSN));
    console.log(whereClause);
    existingClients = (await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setPageSize(100)));
    console.log('ExistingClients');
    console.log(existingClients);
    if (existingClients.length > 0) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))['existingClients'] = existingClients;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    } else {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    }
  }
}


  console.log('Start On Submit Event for formValidateAndDispatch');
  ___arguments.context.pageData['transportRecord'] = ({ [`notesTransport`]: await createTransportNotes() });
  await findExistingClients();
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) == false) {
    console.log('Form submit mergeClientsReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit mergeClientsReady value false condition was triggered.  mergeClientsReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    return ;
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  console.log('Just after opening modalDispatchTransport in form submit.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) == false) {
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
    return ;
  }
  try {
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFirst')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameLast')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionNumber'))].join(''),[`isDispatched`]: true,[`dispatchedBy`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName')) }));
    console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    console.log(getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName'));
    await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).');
    console.log(error);
    // This is asynch so that the RT command doesn't have to wait
    // on the email send. The RT command has to be at the end due
    // to the intermittent error seen for non-authenticated users.
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001a) An error occurred during the dispatch process.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001a) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001a.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001a.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001a).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    console.log('Calling getRouteId with the following Information:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart'));
    samsaraRouteId = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) })), 'routeId'));
    console.log(samsaraRouteId);

  } catch (error) {
    console.log('Method getRouteId resulted in an error:');
    console.log(error);
    samsaraRouteId = null;

  }
  console.log('Starting to create the Transport record...');
  try {
    millisecondsPerHour = 3600000;
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')) == null) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['datetimeRequestedPickup'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission'));
    }
    durationSubmissionToScheduledPickup = (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour;
    // This assigns the values that define the transport record
    // or that need to be calculated in Codeless and that aren't
    // established in the modal popup or later through an API call.
    Object.assign((getObjectProperty(___arguments.context.pageData, 'transportRecord')), ({ [`datetimeDispatch`]: (new Date()),[`relDispatcher1_Employee`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.editorEmployeeObjectId')),[`durationSubmissionToScheduledPickup`]: durationSubmissionToScheduledPickup,[`durationRequestedTransportToScheduledPickup`]: (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')).valueOf())) / millisecondsPerHour,[`durationSubmissionToDispatch`]: (((new Date()).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour,[`isLongETA`]: durationSubmissionToScheduledPickup > 3,[`samsaraRouteId`]: samsaraRouteId,[`typeStatus`]: samsaraRouteId ? 'Dispatched' : null,[`billingEntityName`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_EntityRequestingTransport.requesterEntityName')),[`datetimeSubmission_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')),[`transportCode_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')) }));
    console.log('Saving the Transport record and it\'s relations to the DB');
    newTransport = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = newTransport;

      _uow.create('Transport', (getObjectProperty(___arguments.context.pageData, 'transportRecord'))).setOpResultId('createTransport');
      console.log('createTransport Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'rel_TransportRequest', [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))]).setOpResultId('relateTransportToTransportRequest');
      console.log('relateTransportToTransportRequest Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDispatcher1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee'))]).setOpResultId('relateTransportToDispatcher1');
      console.log('relateTransportToDispatcher1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDriver1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'))]).setOpResultId('relateTransportToDriver1');
      console.log('relateTransportToDriver1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relVehicle1_Vehicle', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle'))]).setOpResultId('relateTransportToVehicle1');
      console.log('relateTransportToVehicle1 Completed');

    })();

    console.log((await newTransport.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    transportRecordObjectId = (getObjectProperty(((newTransport.getOpResultById('createTransport')).getResult()), 'objectId'));
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', transportRecordObjectId);

    } catch (error) {
      console.log('Error encountered in the RT Channel Command after completion of the Transport Transaction.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of the Transport Transaction.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).');
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001b) An error occurred during the dispatch process. (e001b)', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001b) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001b error.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001b error.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001b).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('Error encountered in the RT Channel Command after completion of all other dispatch processes.');
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of all other dispatch processes.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

  }
  // Blink the data grid block in order to force a re-query,
  // which will in turn hide the recently dispatched record.
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('03e1b3340c8c321818aeed148cf13308');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));

  },
  /* handler:onSubmit */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_b26ba78feceb903690c215dd3b5a4627']('.bl-form', 'novalidate', true);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_9339eea9fc6cd4337ba30a3da3c59d69']('.bl-form', 'novalidate');
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to return
  // all records. It is here so that an error won't occur
  // when we pair this query string with the test data flag.
  ___arguments.context.pageData['strWhereClauseBase'] = 'submissionNumber != \'\'';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = false;
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = false;
  ___arguments.context.pageData['transportRequesterOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause('').setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'requesterEntityName')),[`id`]: (getObjectProperty(item, 'requesterId')) });})));
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['currentEditorInfo'] = (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab'](null));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setSortBy('vehicleName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus=\'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')),[`samsaraDriverId`]: (getObjectProperty(item, 'samsaraDriverId')) });})));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/61a2dbca36c2a1c4c3e90bc66884e70d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var matchedRequester, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  // If there is a selection in the selectRequestForm,
  // then find the item in transportRequesterOptions that
  // matches the selection. Otherwise, create a blank object.
  if (getObjectProperty(___arguments.context.pageData, 'manualRequestForm')) {
    matchedRequester = (await asyncListFind((getObjectProperty(___arguments.context.pageData, 'transportRequesterOptions')), async (item) => {
       if ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.pageData, 'manualRequestForm'))) {
        console.log('Match Found in If Statement.  Returning:  ');
        console.log(item);
        return item;
      }


     return ;
    }));
  } else {
    matchedRequester = ({  });
  }
  // General Submissions has a "null" ID.  Check for this, if it's null then leave requester out.  If it's not, then make a requester ID and append it to the URL.  Same is true if nothing is selected in the drop down and manualRequestForm is empty.
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ((getObjectProperty(matchedRequester, 'id')) ? ({ [`requesterId`]: (getObjectProperty(matchedRequester, 'id')) }) : null));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/798ae65f7a5c716c91b159a9fb871a51/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Data Model for Client Info RUC');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord'));

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/d7a7974b30f168dcdeec7d77b0224b74/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'driverOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relDriver1_Employee'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['samsaraDriverId'] = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'driverOptions')), async (item) => {
     if ((getObjectProperty(item, 'value')) == ___arguments.value) {
      return item;
    }


   return ;
  })), 'samsaraDriverId'));
  console.log('Driver objectId and samsaraDriverId selected:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'));
  console.log('Full transportRecordReusableData at time of Selection:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/b2b30c2ba1897d0377e47dbaf0ed5a09/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vehicleOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relVehicle1_Vehicle'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/641efe0ed8775c4bb75880db2d67e3e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b9a7b642136d2dc472510391d36b61d1');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/cdbf241e6dd778235203fa7c7be289bf/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/4d1e20aa6af3ad57a1c9830180eb952b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/c641e4df2187580bc22281aec10f30de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been
  // voided or already dispatched or is read only.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/e6d1ddba6d572196bbe314d2a7dfd02d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been voided or already dispatched.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/531427c425c186d9710f7c2e205ea7e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = false;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  console.log('On Click Event of Cancel button in modalDispatchTransport.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'finalDispatchReady'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/8d1ba8a68826d30c4e0bd759d24e0973/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/a23c7906b1c25649f56dff288e438d11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('03e1b3340c8c321818aeed148cf13308');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/6aafb61d42cb9872ae777823391ff04a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/7f1913299f7463f4ff5d0517eebdcfdb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/2c8f6c12129b3164aa7c7031326e8774/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', ({ [`strWhereClauseBase`]: ['&& rel_TransportRequest.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\''].join('') }));
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// This button only makes sense to show if the record has been dispatched.

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/d9594a32d6c5d23c1382b6998baef31c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/0c757ba64a75ec64a5c6cde4b0ccd4a2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['submissionOtherInformation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/a199ac635af14cb3e08dcd92469903e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/9de76a5a0ff5fd5d72cfe67da6067954/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['notesTransport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRecord.notesTransport'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/a2d650eca1d6503c9121ca913c4c7045/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/8f1bef3521655b340ea3405cb7f72754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  console.log('Printing data containers after close:');
  console.log(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'));
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.layoutData);
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/131e3b99f5866c255e6df08e6aab9f41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/7169de853e2f49f261a78b784938060f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/dd9f6fdc6541ad623fafe6d10422b8f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // If someone saves and closes then reset the 'isInformationVerified'
  // so that they always have to attest to that before dispatch
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isInformationVerified'] = false;
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving changes to the record.');
    console.log(error);

  }
  (function (message) { alert(message) })('Changes have been saved!');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// We show the save changes button anytime the record is not in read only mode.

  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/92916f6859815d21ebccc33ba547a5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'30\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/a3d1808a775455748ad8706c5c9fed92/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/2fc510ebd655f892523b7bf476ab8a6b/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) : []).map(async item => {  label = ['Client Name: ',(getObjectProperty(item, 'nameFull')),', ','DoB: ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(item, 'dateOfBirth')))))),', ','SSN: ',(await (async function(SSN) {
  	if (!SSN || typeof SSN !== 'string') {
  	    return 'N/A'
  	}

  	if (!/^\d{9}$/.test(SSN)) {
  	  return SSN;
  	}

  	return `${SSN.slice(0, 3)}-${SSN.slice(3, 5)}-${SSN.slice(5, 9)}`;
  })((getObjectProperty(item, 'SSN')))),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','Object ID: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['selectedExistingClient'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/e6f4346a48f98663175a2f04d3970a94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['No matching Client was found in our records. This Transport Request will continue to use the new Client record created for client ',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.dateOfBirth')))))),'.'].join(''));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/2371be049f256a4bda2fbc6a45e12a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });
  console.log('%c>> ' + 'close', 'color: #ab47bc', undefined);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/e0cd4d5ad60949056c2b8265fc369f8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/7c8af31888b5d78a223db642a1571502/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var count, error, j, mergeClientTx, offset, pageSize, result, retainCertainClientInfo, transportRequest, transportRequests, transportRequestsToUpdate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = true;
  try {
    transportRequestsToUpdate = [];
    count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join('')))));
    offset = 0;
    pageSize = 100;
    while (offset < count) {
      transportRequests = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
      for (var transportRequest_index in transportRequests) {
        transportRequest = transportRequests[transportRequest_index];
        addItemToList(transportRequestsToUpdate, transportRequest);
      }
      offset = offset + pageSize;
    }
    transportRequestsToUpdate = (await (async function(arr) {
    	const seen = new Set()


    	return arr.filter(item => {
    	  const isDuplicate = seen.has(item.objectId)

    	  seen.add(item.objectId)

    	  return !isDuplicate
    	})

    })(transportRequestsToUpdate));
    console.log('%c>> 🔒 ' + 'TransportRequestsToUpdate:', 'color: #f06292', JSON.parse(JSON.stringify(transportRequestsToUpdate)));

  } catch (error) {
    console.log('%c>> 🔒 ' + 'Error:', 'color: #ef5350', JSON.parse(JSON.stringify(error)));
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    return ;

  }
  console.log('%c>> 🔒 ' + 'selectedExistingClient', 'color: #4caf50', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))));
  try {
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #3f51b5', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    mergeClientTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    // This flag is used to determine whether the update operation
    // for selectedExistingClient needs to be added to the
    // transaction in order to preserve SSN or insurance information.
    retainCertainClientInfo = false;
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.SSN')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'))) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['SSN'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'));
      retainCertainClientInfo = true;
    }
    // Check if any of Primary typeInsurance, insuranceProvider, or insurancePolicyNumber are present in the newer record but not in the older record.  If so, copy the three as a set from the new record to the existing one.
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.typeInsurance')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.typeInsurance')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.insuranceProvider')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.insuranceProvider')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.insurancePolicyNumber')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.insurancePolicyNumber'))) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['typeInsurance'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.typeInsurance'));
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['insuranceProvider'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.insuranceProvider'));
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['insurancePolicyNumber'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.insurancePolicyNumber'));
      retainCertainClientInfo = true;
    }
    if (retainCertainClientInfo) {
      await ( async () => {
        const _uow = mergeClientTx;

        _uow.update('Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('UpdateClient: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.objectId'))));

      })();

    }
    if (transportRequestsToUpdate.length > 0) {
      for (var j_index in transportRequestsToUpdate) {
        j = transportRequestsToUpdate[j_index];
        await ( async () => {
          const _uow = mergeClientTx;

          _uow.setRelation('TransportRequest', j, 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(j, 'objectId'))));

        })();

      }
    }
    await ( async () => {
      const _uow = mergeClientTx;

      _uow.setRelation('TransportRequest', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')), 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))));
      _uow.delete('Client', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'))).setOpResultId((String('ClientObjectDelete: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId'))));

    })();

    result = (await mergeClientTx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));
    console.log(result);
    if (getObjectProperty(result, 'success')) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['clientRecord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['rel_Client'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
    }
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #f06292', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    await (getChannelInstance('default')).send((String('reload-table-records:') + String('TransportRequest')), ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['This Transport Request is now matched to existing client ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.dateOfBirth')))))),'.'].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  } catch (error) {
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/af16da7891b50db1a92c72c3cb02852a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/752113b5eb5a9ee55c96c7dcad88256b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/613926da2f8c51cf8e42ba2f953ed245/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/3d05686703fb302b56bc4968f8332998/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['isDriversLastRoute'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/7d0cc286017a265580b90576fa296c83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/cd416fb140f955bf17c52d7d4c9f7d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/33ef3456b45c06195036af6564a7ffd2/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, clientPasteDate, transportRequestPasteData, SpecialNeedsOrConcernsNotes, startNumber, listFromPaste, heightIn, heightFt, dateOfBirth, destinationLocationName, totalHeight, specialPrecautionso_MedicalConcerns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('No', 'g')), ''));
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('Yes', 'g')), 'TRUE'));
    listFromPaste = (getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).split(':');
    console.log('Value of #1 item on list');
    console.log(listFromPaste[0].trim());
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log(startNumber);
    console.log(listFromPaste[((startNumber + 32) - 1)]);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 32) - 1)].trim()) + String(':');
    console.log(SpecialNeedsOrConcernsNotes);
    specialPrecautionso_MedicalConcerns = subsequenceFirstFromEnd(listFromPaste[((startNumber + 29) - 1)], 19).trim();
    SpecialNeedsOrConcernsNotes = String(SpecialNeedsOrConcernsNotes) + String(String('  Special Precautions or Medical Concerns: ') + String(specialPrecautionso_MedicalConcerns));
    console.log('Special Precautions Notes');
    console.log(SpecialNeedsOrConcernsNotes);
    if ((specialPrecautionso_MedicalConcerns.indexOf('Suicide/Self Harm') !== -1) || (specialPrecautionso_MedicalConcerns.indexOf('Self-Harm Risk') !== -1)) {
      console.log('Suicide/Self Harm');
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Elopement Risk') !== -1) {
      console.log('Elopement Risk');
      ___arguments.context.dataModel['isElopementRisk'] = true;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isElopementRisk'] = false;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Disorganized Behavior') !== -1) {
      console.log('Disorganized Behavior');
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
    } else {
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Fall Risk') !== -1) {
      console.log('Fall Risk');
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
    }
    destinationLocationName = String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 23) - 1)], 20).trim()) + String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 24) - 1)], 28).trim());
    dateOfBirth = (new Date((new Date((subsequenceFirstFromEnd(listFromPaste[((startNumber + 9) - 1)], 10).trim()))).getTime() + ((19 * 3600) * 1000)));
    totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim();
    console.log('total height');
    console.log(totalHeight);
    if (totalHeight.indexOf('\'') !== -1) {
      totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim().split('\'');
      heightFt = totalHeight[0].trim();
      heightIn = totalHeight[1].trim().charAt(0);
    } else {
      heightFt = totalHeight;
      heightIn = 0;
    }
    console.log('listFromPaste');
    console.log(listFromPaste);
    transportRequestPasteData = ({ [`isContactedYMCR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 7) - 1)], 38).trim() == 'TRUE' ? true : false,[`isMCTR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 8) - 1)], 10).trim() == 'TRUE' ? true : false,[`isCOVID19Positive`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 14) - 1)], 24).trim() == 'TRUE' ? true : false,[`referringEntityName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 18) - 1)], 17).trim(),[`referringContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 19) - 1)], 30).trim(),[`referringContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 20) - 1)], 15).trim()).replace((new RegExp('-', 'g')), '')),[`pickupAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 21) - 1)], 66).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`isReferralToNearestUrcOrCc`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 22) - 1)], 14).trim() == 'TRUE' ? true : false,[`destinationLocationName`]: destinationLocationName,[`destinationAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 25) - 1)], 28).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`destinationContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 26) - 1)], 32).trim(),[`destinationContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 27) - 1)], 23).trim()).replace((new RegExp('-', 'g')), '')),[`isClientAggressiveOrViolentToday`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 31) - 1)], 22).trim() == 'TRUE' ? true : false,[`isClientElopementRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientElopementRiskToday')),[`isClientSuicideOrSelfHarmRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientSuicideOrSelfHarmRiskToday')),[`isClientFallRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientFallRiskToday')),[`stateSubmissionNumber`]: (getObjectProperty(___arguments.context.dataModel, 'stateSubmissionNumber')) });
    clientPasteDate = ({ [`nameFirst`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 5) - 1)], 19).trim(),[`is18`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 6) - 1)], 48).trim(),[`dateOfBirth`]: dateOfBirth,[`age`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 10) - 1)], 13).trim(),[`assignedSexAtBirth`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 11) - 1)], 13).trim(),[`heightFt`]: heightFt,[`heightIn`]: heightIn,[`weight`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 13) - 1)], 22).trim(),[`emergencyContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 15) - 1)], 31).trim(),[`emergencyContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 16) - 1)], 41).trim()).replace((new RegExp('-', 'g')), '')),[`hasHistoryOfViolence`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 30) - 1)], 28).trim() == 'TRUE' ? true : false,[`otherNotes`]: SpecialNeedsOrConcernsNotes,[`isElopementRisk`]: (getObjectProperty(___arguments.context.dataModel, 'isElopementRisk')),[`hasDisorganizedBehavior`]: (getObjectProperty(___arguments.context.dataModel, 'hasDisorganizedBehavior')) });
    console.log('Transport Request Data');
    console.log(transportRequestPasteData);
    console.log('Client Record Data');
    console.log(clientPasteDate);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ({ [`transportRequestRecord`]: transportRequestPasteData,[`clientRecord`]: clientPasteDate,[`requesterId`]: 'STATE' }));

  } catch (error) {
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An error occurred during the copy/paste of a submission record into the app.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the copy/paste of a submission record into the app.' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/copy-paste-errors', error, 'An error occurred during the copy/paste of a submission record into the app.', 'Form paste-state-submission Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));

    })();
    (function (message) { alert(message) })('We\'re sorry, there was an error when you attempted to copy/paste the record.  Please refresh your browser tab and try to copy/paste again.  Please be sure to paste from just before "RideCARE Submission Submission Date:" until the very end of the email after the "Special Needs/Concerns" section.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/a781341ea971861568c9bd1b125a5683/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('State Submission #: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/c5aeecbb7a7b29a5d767bc4a68e9c5a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('State Submission #: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-backup-11-4/components/96375d9c8e896078c906901591a7205d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var firstListValue, listFromPaste, startNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  listFromPaste = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33ef3456b45c06195036af6564a7ffd2'), 'textTransportPaste')).split(':');
  console.log('List From Paste');
  console.log(listFromPaste);
  firstListValue = listFromPaste[0].trim();
  console.log('Value of #1 item on list');
  console.log(firstListValue);
  if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
    startNumber = 0;
  } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
    startNumber = -3;
  }
  console.log('Start Number = ');
  console.log(startNumber);
  console.log(firstListValue.indexOf('Information') !== -1);
  if ((firstListValue.indexOf('Date') !== -1) == true || (firstListValue.indexOf('Information') !== -1) == true) {
  } else {
  }
  if (false) {
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-form/components/fea7bd71964ac0c82cea059ece9506f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['visibilityDataLoaded'] = false;
  ___arguments.context.dataModel['visibilityLogic'] = ({  });
  // Avoid Undefined errors by initializing the root object
  ___arguments.context.dataModel['transportRequestRecord'] = ({  });
  // Avoid Undefined errors by initializing the root object
  ___arguments.context.dataModel['clientRecord'] = ({  });
  console.log('form');
  console.log(___arguments.context.dataModel);
  console.log(getObjectProperty(___arguments.context.pageData, 'requesterId'));
  if ((getObjectProperty(___arguments.context.pageData, 'requesterId')) == null) {
    // If the requesterId isn't found then go to the generic form.
    ___arguments.context.dataModel['requesterRecord'] = ((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause('requesterId IS NULL').setPageSize(100)))[0]);
  } else {
    // Otherwise go to the form that matches the requesterId
    ___arguments.context.dataModel['requesterRecord'] = ((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause((['requesterId = \'',(getObjectProperty(___arguments.context.pageData, 'requesterId')),'\''].join(''))).setPageSize(100)))[0]);
  }
  // This handles situations where someone attempts a requesterId
  // that is invalid. Otherwise it will load whatever it finds that is
  // close and then the submission will fail on database transaction.
  if ((getObjectProperty(___arguments.context.dataModel, 'requesterRecord')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);
  }
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.dataModel);
  ___arguments.context.dataModel['visibilityDataLoaded'] = true;
  console.log('On Before Mount Handler of formTransportRequest');
  console.log(___arguments.context.dataModel);
  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  ___arguments.context.dataModel['typeInsuranceList'] = (await Promise.all(((getObjectProperty(___arguments.context.dataModel, 'requesterRecord.requesterInsuranceTypes')).split(',')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  console.log('clientRecordState');
  console.log(getObjectProperty(___arguments.context.pageData, 'clientRecordState'));
  console.log('clientRecordAge');
  console.log(getObjectProperty(___arguments.context.dataModel, 'clientRecord.age'));

  },
  /* handler:onBeforeMount */
  /* handler:onReset */
  async ['onReset'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['visibilityDataLoaded'] = false;
  // Avoid Undefined errors by initializing the root object
  ___arguments.context.dataModel['transportRequestRecord'] = ({  });
  // Avoid Undefined errors by initializing the root object
  ___arguments.context.dataModel['clientRecord'] = ({  });
  if ((getObjectProperty(___arguments.context.pageData, 'requesterId')) == null) {
    // If the requesterId isn't found then go to the generic form.
    ___arguments.context.dataModel['requesterRecord'] = ((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause('requesterId IS NULL').setPageSize(10)))[0]);
  } else {
    // Otherwise go to the form that matches the requesterId
    ___arguments.context.dataModel['requesterRecord'] = ((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause((['requesterId = \'',(getObjectProperty(___arguments.context.pageData, 'requesterId')),'\''].join(''))).setPageSize(10)))[0]);
  }
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.dataModel);
  ___arguments.context.dataModel['visibilityDataLoaded'] = true;
  console.log(___arguments.context.dataModel);

  },
  /* handler:onReset */
  /* content */
}))

define('./pages/transport-request-form/components/dcb599bc1b8d939435b499d545acf0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showDedicatedDriver'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), ({ [`isDedicatedDriver`]: true,[`isLocalArea`]: false,[`isCourtOrdered`]: false,[`isTruncatedSubmission`]: 0 }));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/transport-request-form/components/4e0fca413969e712e3dab4bf130cf236/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Match the object property to the UI state of the toggle
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord'))['isDedicatedDriver'] = ___arguments.value;
  // Recalculate truncated submission when any of the three
  // toggles are selected since we don't know which will be last.
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord'))['isTruncatedSubmission'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isDedicatedDriver')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isLocalArea')));
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-form/components/f17b520c533a32222e8e7bad03b62aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Match the object property to the UI state of the toggle
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord'))['isLocalArea'] = ___arguments.value;
  // Recalculated truncated submission when any of the three toggles
  // are selected since we don't know which will be clicked last
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord'))['isTruncatedSubmission'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isDedicatedDriver')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isLocalArea')));
  // Change the data object value for showCrisisResponse to be the
  // opposite of this toggle since this respondent does NOT get
  // the crisis response series when they are in local area.
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord'))['showCrisisResponse'] = (!___arguments.value);
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-form/components/c2bca489bcfa65b521f72f7a0d4cddbd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // match the data property value to the UI toggle state
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord'))['isCourtOrdered'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-request-form/components/34f73ec19f9d2aa2837d2a9d6c854c2e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isTruncatedSubmission')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/04c230e50a63f6ce6049e56f0bb41a48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isTruncatedSubmission'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), ({ [`isReturnTripNeeded`]: false }));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/transport-request-form/components/09ea8378809e0f4993122b136917df96/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/fe24de5c79f29a631ab7141b21cbc401/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/3e359357efd6d6ead00bad6643423706/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/98630c66c28ba928b18b4f882e3f57a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/26492c43b3cce0d45578fe3bd28b4494/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/040bac076cb5f844a3ef6621fdd356e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/7f037819deda2ba2ed6b44d83bd8308d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showJusticeInvolvement'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), ({ [`isTransportConfirmedWithStakeholders`]: false,[`isReferraltoMentalHealthServices`]: false,[`isCourtOrdered`]: false,[`isDREAMScourt`]: false,[`isDREAMScourtApproved`]: false,[`isDREAMSmhOrSaTreatment`]: false,[`isTransportFromJailOrDetentionCenter`]: false,[`isOKcountyTreatmentCourt`]: false }));
  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordState')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/transport-request-form/components/edadb59747ca9aefe9aa85499745577a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showCrisisResponse'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), ({ [`isMCTR`]: false,[`isTMTR`]: false,[`isReferralToNearestUrcOrCc`]: false }));
  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordState')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/transport-request-form/components/d6af25512d49129f5eb98d8118dc1a29/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), ({ [`isCOVID19Positive`]: false,[`isCOVID19TestPerformed`]: false,[`isCOVID19TestRequired`]: false }));
  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordState')));
  console.log('On Before Mount event in the Misc SEction');
  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showCOVIDquestions')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showChickasawSpecialty')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showFollowUpContact')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/3356a3bc533a9809d93cdfbdbecfd2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
  // Resetting the form clears the entire data model. Blinking the
  // visibility of the form afterward will ensure that the default
  // values for all the 'false' toggles and checkboxes are restored.
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fea7bd71964ac0c82cea059ece9506f6', false);
  await new Promise(r => setTimeout(r, 0 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fea7bd71964ac0c82cea059ece9506f6', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e8ab6bdeb1f94a8e3238dc7849241bf2')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-form/components/9d196f35fda327293e425637fb24ea4c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  while (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord'))) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), ({ [`isPickupPrivateResidence`]: false,[`isPickupSameInfoAsReferring`]: false,[`isEOD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showPresetPickupTimes')) ? false : true,[`isPrescheduled`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showPresetPickupTimes')) ? true : false,[`isDestinationPrivateResidence`]: false,[`isWarmHandOffNeeded`]: false,[`isReturnTripNeeded`]: false }));
  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordState')));
  console.log('On Mounted Event in blockTransportInfoRUC');
  console.log(JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')))));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.showPresetPickupTimes'));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/transport-request-form/components/cff43a8a31687edc6bdd6ae510b26aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord')), ({ [`isFedRecognizedTribal`]: false,[`isVeteran`]: false,[`hasHistoryOfViolence`]: false,[`isElopementRisk`]: false,[`hasSpecialPrecautionsOrMedicalNeeds`]: false,[`numberInsurancePolicies`]: 1 }));
  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord')), (getObjectProperty(___arguments.context.pageData, 'clientRecordState')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/transport-request-form/components/e004f1bad548c69e0774364cf335af15/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), ({ [`isClientFallRiskToday`]: false,[`isClientSuicideOrSelfHarmRiskToday`]: false,[`isRestrainingClientRequiredToday`]: false,[`isClientAggressiveOrViolentToday`]: false,[`isClientElopementRiskToday`]: false,[`isClientMedicallyClearedForTransportToday`]: false,[`isClientSpecialNeedsOrPrecautionsToday`]: false }));
  Object.assign((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord')), (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordState')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/transport-request-form/components/3aad0ffca40bdc679d9fcda97dcf4849/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, newTransportRequest, errors, durationRequestedTripLeadTime, millisecondsPerHour, timeToValidate, submitClientNotificationAddressList, submitNotificationAddressList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function validateTruncatedFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04c230e50a63f6ce6049e56f0bb41a48')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04c230e50a63f6ce6049e56f0bb41a48')));
    errors['nameLast'] = ['inputError'];
  }
  // Some clients don't have addresses so turning validation off for this field.
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord.city')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04c230e50a63f6ce6049e56f0bb41a48')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04c230e50a63f6ce6049e56f0bb41a48')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  // Some clients don't have addresses so turning validation off for this field.
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord.city')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04c230e50a63f6ce6049e56f0bb41a48')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04c230e50a63f6ce6049e56f0bb41a48')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.destinationContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04c230e50a63f6ce6049e56f0bb41a48')));
    errors['destinationContactName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.destinationLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04c230e50a63f6ce6049e56f0bb41a48')));
    errors['destinationLocationName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['errors'] = errors;
  }
}

/**
 * This function will check various fields of the form and
 * make sure that input is valid. If it is not, it will throw
 * and error and prevent the remainder of the submission.
 */
async function validateFullFormSubmission() {
  errors = ({  });
  // This checks date of birth to make sure it exists
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.dateOfBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['dateOfBirth'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.is18')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.emergencyContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['emergencyContactName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.is18')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.emergencyContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['emergencyContactPhone'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.SSN'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['SSN'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.assignedSexAtBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['assignedSexAtBirth'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.heightFt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['heightFt'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.heightIn'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['heightIn'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.weight'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['weight'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.tribeAffiliations'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['tribeAffiliations'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.tribeMemberZipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['clientRecord.tribeMemberZipcode'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.email')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.email'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['email'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.emailAlt')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.emailAlt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cff43a8a31687edc6bdd6ae510b26aa6')));
    errors['emailAlt'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isClientMedicallyClearedForTransportToday')) != true) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e004f1bad548c69e0774364cf335af15')));
    errors['isClientMedicallyClearedForTransportToday'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.referringEntityName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['referringEntityName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.referringContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['referringContactName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.referringContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['referringEntityContactPhone'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord')), 'city')) || !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord')), 'stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord')), 'zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord')), 'googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.pickupLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['pickupLocationName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.pickupContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['pickupContactName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.pickupContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['pickupContactPhone'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord')), 'city')) || !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord')), 'stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord')), 'zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord')), 'googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.destinationLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['destinationLocationName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.destinationContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['destinationContactName'] = ['inputError'];
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.destinationContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['destinationContactPhone'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isPrescheduled')) && !await validateTripTime((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.datetimeRequestedPickup')))) {
    console.log('Validating datetimeRequestedPickup');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['datetimeRequestedPickup'] = ['inputError'];
    (function (message) { alert(message) })('Please request a pickup time that is more than 30 minutes from now.');
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isReturnTripNeeded')) && !await validateTripTime((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.datetimeReturnTrip')))) {
    console.log('Validating datetimeReturnTrip');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d196f35fda327293e425637fb24ea4c')));
    errors['datetimeReturnTrip'] = ['inputError'];
    (function (message) { alert(message) })('Please request a return trip time that is more than four hours from now.');
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.typeCustodyExchange'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f037819deda2ba2ed6b44d83bd8308d')));
    errors['typeCustodyExchange'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.pickupConfirmationNumber'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f037819deda2ba2ed6b44d83bd8308d')));
    errors['pickupConfirmationNumber'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.detentionCenterPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f037819deda2ba2ed6b44d83bd8308d')));
    errors['detentionCenterPhone'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isCourtOrdered')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.nameCourtOrSystemOrJudge'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f037819deda2ba2ed6b44d83bd8308d')));
    errors['nameCourtOrSystemOrJudge'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isCOVID19TestRequired')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.destinationAcceptingProviderName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d6af25512d49129f5eb98d8118dc1a29')));
    errors['destinationAcceptingProviderName'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.followUpContactName')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.followUpContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d6af25512d49129f5eb98d8118dc1a29')));
    errors['followUpContactPhone'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')['errors'] = errors;
  }
}

/**
 * Returns TRUE if the datetimeRequestedPickup - NOW() is more than 4
 * hours (i.e. if the datetimeRequestedPickup is an allowed value.)
 */
async function validateTripTime(timeToValidate) {
  millisecondsPerHour = 3600000;
  if (timeToValidate == null) {
    console.log('Trip Time was NULL but was required.');
    return false;
  }
  try {
    durationRequestedTripLeadTime = ((timeToValidate.valueOf()) - ((new Date()).valueOf())) / millisecondsPerHour;
    console.log('validatePickupTime Function');
    console.log(durationRequestedTripLeadTime);
    console.log(durationRequestedTripLeadTime > 0.49);

  } catch (error) {
    console.log('Try/Catch Block in the validatePickupTime Function');
    console.log(error);

  }
  return durationRequestedTripLeadTime > 0.49
}

/**
 * Describe this function...
 */
async function sendSubmitSuccessEmail() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.nameFirst')).toLowerCase() == 'test') {
    submitNotificationAddressList = [null, 'jamesk+TEST@davidrobertsconsulting.com'];
    submitClientNotificationAddressList = 'jamesk+TEST@davidrobertsconsulting.com';
  } else {
    submitNotificationAddressList = ['transportation@okridecare.com', 'jamesk@davidrobertsconsulting.com', 'davidrobertsconsulting@gmail.com'];
    submitClientNotificationAddressList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterNotificationEmails')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterNotificationEmails')).split(',') : null;
  }
  console.log('Notification Email List for this Requester & Form Content (Internal Notification List, then Client Notification List):');
  console.log(submitNotificationAddressList);
  console.log(submitClientNotificationAddressList);
  ;(async () => {
      ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmailFromTemplate('New Submission Dispatch Notification', Backendless.EmailEnvelope.create({ addresses: submitNotificationAddressList, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`nameLast`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.nameLast')),[`clientDOB`]: ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.dateOfBirth')))).toDateString()),[`requesterEntityName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterEntityName')),[`isEOD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isEOD')),[`pickupAddress`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.pickupAddress')),[`destinationAddress`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.destinationAddress')),[`requesterDispatchInstructions`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterDispatchInstructions')) }), [(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/transport-request-form-submissions', error, 'Transport Request Successfully Submitted', 'Form Transport Request Data Container', ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))]));
    if (submitClientNotificationAddressList) {
      ___arguments.context.pageData['clientMessageResponse'] = (await Backendless.Messaging.sendEmailFromTemplate('New Submission Client Notification', Backendless.EmailEnvelope.create({ addresses: submitClientNotificationAddressList, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`nameLast`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.nameLast')),[`clientDOB`]: ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord.dateOfBirth')))).toDateString()),[`requesterEntityName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterEntityName')),[`isEOD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isEOD')),[`pickupAddress`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.pickupAddress')),[`destinationAddress`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.destinationAddress')) }), undefined));
    }
    await new Promise(r => setTimeout(r, 10000 || 0));
    console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));
    if (submitClientNotificationAddressList) {
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'clientMessageResponse.messageId'))));
    }

  })();
}


  console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('179f87a73e56ef869a2a2c86e3b3fe82');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord'));
  // first check whether it's a truncated submission. If so, skip validation
  // since we haven't built that yet. If not, then run normal validation.
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord.isTruncatedSubmission')) == true) {
    // Validate form submissions. Log to console and
    // proceed if the validation checks out. Close the
    // modal and stop execution if validation is failed.
    if (await validateTruncatedFormSubmission() == true) {
      console.log('Form submissions were validated.');
    } else {
      console.log('Truncated Form Validation Failed  in On Click Event');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('179f87a73e56ef869a2a2c86e3b3fe82');
      return ;
    }
  } else {
    // Validate form submissions. Log to console and
    // proceed if the validation checks out. Close the
    // modal and stop execution if validation is failed.
    if (await validateFullFormSubmission() == true) {
      console.log('Form submissions were validated.');
    } else {
      console.log('Full Form Validation Failed in On Click Event');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('179f87a73e56ef869a2a2c86e3b3fe82');
      return ;
    }
  }
  try {
    console.log('Start of Database Transaction.  Form Data, then Page Data:');
    console.log(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'));
    console.log(___arguments.context.pageData);
    newTransportRequest = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = newTransportRequest;

      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord'))['datetimeSubmission'] = (new Date());
      _uow.create('TransportRequest', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'transportRequestRecord'))).setOpResultId('createTransportRequest');
      _uow.create('Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'clientRecord'))).setOpResultId('createClient');
      if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord.objectId'))) {
        _uow.create('Facility', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord'))).setOpResultId('createPickupFacility');
      }
      if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord.objectId'))) {
        _uow.create('Facility', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord'))).setOpResultId('createDestinationFacility');
      }
      _uow.setRelation('TransportRequest', (newTransportRequest.getOpResultById('createTransportRequest')), 'rel_Client', (newTransportRequest.getOpResultById('createClient'))).setOpResultId('relateTransportRequestToClient');
      _uow.setRelation('TransportRequest', (newTransportRequest.getOpResultById('createTransportRequest')), 'rel_EntityRequestingTransport', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.objectId'))]).setOpResultId('relateTransportRequestToRequestingEntity');
      _uow.setRelation('TransportRequest', (newTransportRequest.getOpResultById('createTransportRequest')), 'relPickup_Facility', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord.objectId')) ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'pickupFacilityRecord.objectId'))] : (newTransportRequest.getOpResultById('createPickupFacility')))).setOpResultId('relateTransportRequestToPickupFacility');
      _uow.setRelation('TransportRequest', (newTransportRequest.getOpResultById('createTransportRequest')), 'relDestination_Facility', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord.objectId')) ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'destinationFacilityRecord.objectId'))] : (newTransportRequest.getOpResultById('createDestinationFacility')))).setOpResultId('relateTransportRequestToDestinationFacility');

    })();

    console.log((await newTransportRequest.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    console.log('Completed the transaction');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('179f87a73e56ef869a2a2c86e3b3fe82');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('f2c7923aded1089dda29860f9ee224b3');
    // Running this code asynchronously allows the rtupdate command
    // to run immediately. This wouldn't matter except for the
    // bug where it doesn't run for non-authenticated users.
    ;(async () => {
        await sendSubmitSuccessEmail();
      console.log('Modal Success Popup and Success Email Complete.');

    })();

  } catch (error) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3c3b00d90f47abc573b81daa06e70661');
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in Transport-Request-Form', new Backendless.Bodyparts({ textmessage: 'An error occurred in a client submission.' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/transport-request-form-errors', error, 'An Error Has Occurred in Transport-Request-Form', 'Form Transport Request Data Container', ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));
      return ;

    })();

  }
  try {
    await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('TransportRequest', (getObjectProperty(((newTransportRequest.getOpResultById('createTransportRequest')).getResult()), 'objectId')));
    console.log('Completed the rtReloadTableObject.');

  } catch (error) {
    console.log('Error seen in the rtReloadTableObject command.');
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An Error Has Occurred in the rtReloadTableObject Command of the Transport-Request-Form ', new Backendless.Bodyparts({ textmessage: 'An error occurred in the RT update after a client submission.' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/transport-request-form-errors', error, 'An Error Has Occurred in the rtReloadTableObject Command of the Transport-Request-Form ', 'Form Transport Request Data Container', ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();

  }
  console.log('END On Click Event for Transport Request Form Submission.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-form/components/c51df213b0330dbc5f3e8d48179dd043/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6')

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/e5ca6ddd883fc101cc1cbc13a991bcee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('f2c7923aded1089dda29860f9ee224b3');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fea7bd71964ac0c82cea059ece9506f6');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e8ab6bdeb1f94a8e3238dc7849241bf2')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-form/components/2f5292a98939e4676b5ad6872d14c3a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3c3b00d90f47abc573b81daa06e70661');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e8ab6bdeb1f94a8e3238dc7849241bf2')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-request-form/components/a771e2fd30ac399aacfbe6648dd47821/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Please submit this form to request transportation services from Ride Care.  ') + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterNotes')) == null ? '' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterNotes'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/798a03a3489ad2e7d6eb1c3f24d934b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterWarningNotes')) == null ? '' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea7bd71964ac0c82cea059ece9506f6'), 'requesterRecord.requesterWarningNotes'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/b0f3285439e2d71296044ba2644f7f3c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-requests', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      // Only show the 'back to ride care' button if the person is a logged in user.
  if (Backendless.getCurrentUserToken()) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-request-form/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'requesterId')) == 'STATE') {
    ___arguments.context.pageData['clientRecordState'] = (getObjectProperty(___arguments.context.pageData, 'clientRecord'));
    ___arguments.context.pageData['transportRequestRecordState'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecord'));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/transport-requests/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Transport Requests',[`pageName`]: 'transport-requests' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/transport-requests/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'showAllRecords')) == true)) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},
    	{
    	  "field": "isInformationVerified",
    	  "headerName": "",
    	  "headerTooltip": "Ready for Dispatch?",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxCheckmarkCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false,
    	  "filtering": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},
    	{
    	  "field": "isEOD",
    	  "headerName": "",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.stateCode",
    	  "headerName": "State",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "headerTooltip": "Date & Time when the transport request was received via ORC app form.",
    	  "type": "datetimeColumn",
    	  "cellRendererParams": {
    	    "dayjsFormat": "MM/DD/YYYY HH:mm",
    	    "withSeconds": false
    	  },
    	  "width": 155,
    	  "sortable": true,
    	  "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false,
    	  "wrapHeaderText": true,
    	  "autoHeaderHeight": true,
    	  "meta": { "align": "center" }
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "minWidth": 200,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "minWidth": 200,
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},

    	{
    	  "field": "isInformationVerified",
    	  "headerName": "",
    	  "headerTooltip": "Ready for Dispatch",
    	  "minWidth": 40,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxCheckmarkCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "isEOD",
    	  "headerName": "",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 20,
    	  "maxWidth": 55,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.stateCode",
    	  "headerName": "State",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  "editable": false
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, newTransportRequestRecord, submissionInfo, waitCount, intervalId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for use as both input forms and viewers.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'validateAndDispatchRecord') {
    console.log('Printing data containers at start of event validateAndDispatchRecord:');
    console.log(___arguments['recordItem']);
    console.log(___arguments.context.pageData);
    console.log(___arguments.context.layoutData);
    console.log(___arguments.context.appData);
    // Don't allow editing in the UI window if the record has already been dispatched, if the record is voided, or if another user is already editing it.
    // This was disabled when we made it so that transport requests could be edited after dispatch.  It can be removed at a later date.
    ___arguments.context.pageData['transportRequestRecordReusableData'] = ({ [`transportRequestRecord`]: ___arguments['recordItem'],[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`typeInsuranceList`]: (getObjectProperty(___arguments.context.pageData, 'typeInsuranceList')),[`pickupFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relPickup_Facility')),[`destinationFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relDestination_Facility')),[`requesterRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_EntityRequestingTransport')),[`selectExistingClientData`]: ({  }),[`isReadOnlyMode`]: false || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId')))) ? true : false });
    // This makes sure that the requester ID is present on page
    // Data here like it is on the Transport Request Form Page.
    ___arguments.context.pageData['requesterId'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterId'));
    console.log('Action Icon Click Event - PageData.requesterId:');
    console.log(getObjectProperty(___arguments.context.pageData, 'requesterId'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    // Only trigger the 'editing' command interval if the record is not read only.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == false) {
      try {

        ;(function() {
          const callback = async () => {
              await (getChannelInstance('default')).send('editing-table:TransportRequest', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

          };

          const timerId = 'transportRequestsVerifyAndDispatch';
          const timerDelay = 1000;

          runSetTimeout(timerId, callback, timerDelay)
        })()
        addItemToList((getObjectProperty(___arguments.context.appData, 'intervalIds')), 'transportRequestsVerifyAndDispatch');

      } catch (error) {
        console.log('An error was seen in the RT Channel Command for isReadOnlyMode');
        console.log(error);

      }
    }
  } else if (___arguments['eventName'] == 'voidRecord') {
    console.log(___arguments['recordItem']);
    // Don't allow voiding the record if it's in isReadOnlyMode
    // (i.e. if someone else is editing, if it's already
    // been dispatched, or if it's already been voided)
    if (((getObjectProperty(___arguments['recordItem'], 'isDispatched')) || (getObjectProperty(___arguments['recordItem'], 'isVoided')) || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId'))))) == true) {
      (function (message) { alert(message) })('This record is currently being edited by another user, or it has already been dispatched or voided.  It cannot be voided at this time.');
    } else {
      ___arguments['recordItem']['isVoided'] = true;
      // This is how we can save just a single property into
      // the database without updating the entire record.
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`isVoided`]: (getObjectProperty(___arguments['recordItem'], 'isVoided')),[`dispatchedBy`]: (getObjectProperty(___arguments.context.appData, 'currentUser.name')) }) );
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments['recordItem'], 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after voiding the record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    }
  } else if (___arguments['eventName'] == 'duplicateRecord') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a2d650eca1d6503c9121ca913c4c7045');
    console.log('!!!RECORD');
    console.log(___arguments['recordItem']);
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Duplicate operation timed out after 20s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a809fd2715c4f0babc542a2e8da9e97e');
      console.log('record1');
      console.log(___arguments['recordItem']);
      submissionInfo = ['THIS RECORD WAS DUPLICATED FROM TRANSPORT REQUEST #',(getObjectProperty(___arguments['recordItem'], 'submissionNumber')),'.'].join('');
      newTransportRequestRecord = (Object.assign(({  }), ___arguments['recordItem']));
      delete newTransportRequestRecord['objectId'];
      delete newTransportRequestRecord['created'];
      delete newTransportRequestRecord['updated'];
      delete newTransportRequestRecord['submissionNumber'];
      newTransportRequestRecord['submissionOtherInformation'] = submissionInfo;
      newTransportRequestRecord['isDispatched'] = false;
      newTransportRequestRecord['isVoided'] = false;
      newTransportRequestRecord['dispatchedBy'] = null;
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty((await Backendless.Data.of('TransportRequest').deepSave( newTransportRequestRecord )), 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after duplicating a transport request record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await new Promise(r => setTimeout(r, 200 || 0));
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
      // This wait is here to make sure that the relations data
      // arrives into the data grid before the waiting spinner closes.
      await new Promise(r => setTimeout(r, 1200 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a809fd2715c4f0babc542a2e8da9e97e');
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'delete') {
    await BackendlessUI.Functions.Custom['fn_58f43615b3a18b74c5b8d439a61e9b2d'](___arguments.context.pageData, 'TransportRequest', ___arguments['recordItem'], (await (async function() {
    	//"___arguments" is a specific property Backendless uses and in this case it contains the object for the modal itself.

    	return ___arguments
    })()));
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:editorInfoLogic */
  ['editorInfoLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo'))

  },
  /* handler:editorInfoLogic */
  /* content */
}))

define('./pages/transport-requests/components/ff57ab8eb9b2e5bf2f5ff0d6e6df5fcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var errors, error, durationRequestedTripLeadTime, millisecondsPerHour, timeToValidate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Validates the form submission, checking if the record has a client
 * first name, last name, pickup facility, destination facility, etc
 */
async function validateTruncatedFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationLocationName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * This function will check various fields of the form and
 * make sure that input is valid. If it is not, it will throw
 * and error and prevent the remainder of the submission.
 */
async function validateFullFormSubmission() {
  errors = ({  });
  if (!((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.objectId')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.objectId')))) {
    // This is asynch so that the RT command doesn't have to wait
    // on the email send. The RT command has to be at the end due
    // to the intermittent error seen for non-authenticated users.
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('A pickup or dropoff facility is missing ', new Backendless.Bodyparts({ textmessage: 'A pickup or dropoff facility is missing' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, 'A pickup or dropoff facility is missing', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'))))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.dateOfBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['dateOfBirth'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactPhone'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.SSN'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['SSN'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['assignedSexAtBirth'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightFt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightFt'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightIn'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightIn'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['weight'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeAffiliations'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['tribeAffiliations'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeMemberZipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['clientRecord.tribeMemberZipcode'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['email'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emailAlt'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientMedicallyClearedForTransportToday')) != true) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9b47fd8cdd2f04219a2f7997f9e7586')));
    errors['isClientMedicallyClearedForTransportToday'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['typeCustodyExchange'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['pickupConfirmationNumber'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.detentionCenterPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['detentionCenterPhone'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.isCourtOrdered')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.nameCourtOrSystemOrJudge'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['nameCourtOrSystemOrJudge'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19TestRequired')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationAcceptingProviderName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85042b9acde90c9937b6240f234825ac')));
    errors['destinationAcceptingProviderName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
  if (!((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.objectId')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.objectId')))) {
    // This is asynch so that the RT command doesn't have to wait
    // on the email send. The RT command has to be at the end due
    // to the intermittent error seen for non-authenticated users.
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('A pickup or dropoff facility is missing (Error#2, end of dispatch button)', new Backendless.Bodyparts({ textmessage: 'A pickup or dropoff facility is missing' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, 'A pickup or dropoff facility is missing', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'))))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
  }
}

/**
 * Describe this function...
 */
async function validateTripTime(timeToValidate) {
  millisecondsPerHour = 3600000;
  if (timeToValidate == null) {
    console.log('Trip Time was NULL but was required.');
    return false;
  }
  try {
    durationRequestedTripLeadTime = ((timeToValidate.valueOf()) - ((new Date()).valueOf())) / millisecondsPerHour;
    console.log('validatePickupTime Function');
    console.log(durationRequestedTripLeadTime);
    console.log(durationRequestedTripLeadTime > 4);

  } catch (error) {
    console.log('Try/Catch Block in the validatePickupTime Function');
    console.log(error);

  }
  return durationRequestedTripLeadTime > 4
}


  console.log(___arguments.context.pageData);
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) != true) {
    (function (message) { alert(message) })('You must check the box indicating you have verified all information before saving changes or dispatching transport.');
    return ;
  } else if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) {
    // first check whether it's a truncated submission. If so, skip validation
    // since we haven't built that yet. If not, then run normal validation.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) == true) {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateTruncatedFormSubmission() == true) {
        console.log('Truncated form submissions were validated.');
      } else {
        console.log('Else Block in Truncated Form Submission validation');
        return ;
      }
    } else {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateFullFormSubmission() == true) {
        console.log('Full form submissions were validated.');
      } else {
        console.log('Else Block in Full Form Submission validation');
        return ;
      }
    }
    console.log('ElseIf in On Click Event of the Dispatch button occurred.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('73b93b24382d41b884a9e1223fd5ceba');
    return ;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after cancel button click.');
    console.log(error);

  }
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  console.log('Page Data Cancel Button: ');
  console.log(___arguments.context.pageData);
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllRecords'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'2\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/8dad9c1d07152be824327a0a917b9be8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving edits to the record.');
    console.log(error);

  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/73b93b24382d41b884a9e1223fd5ceba/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var automaticTransportNotes, error, transportRecordObjectId, newTransport, samsaraRouteId, durationSubmissionToScheduledPickup, millisecondsPerHour, existingClients, whereClause, SSN, clientRecord, nameLast, dateOfBirth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function createTransportNotes() {
  automaticTransportNotes = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) ? 'Adult ' : 'Minor ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')) ? [' (',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')),') '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) + String(', ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) + String('lbs. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSuicideOrSelfHarmRiskToday')) == true ? 'SI/SH. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasHistoryOfViolence')) == true ? 'History of Violence. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientAggressiveOrViolentToday')) == true ? 'Aggressive or Violent Today. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isElopementRisk')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientElopementRiskToday')) == true ? 'Elopement Risk. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasSpecialPrecautionsOrMedicalNeeds')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSpecialNeedsOrPrecautionsToday')) == true ? ['Client has special precautions or medical needs: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) + String(' - ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) + String('"  ') : ''].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCourtOrdered')) ? 'Court Ordered Transport.  ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')) ? ['PU Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')) ? ['PU Confirmation #: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')) ? ['Destination Appt At: ',((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')))).toString()),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')) ? ['Destination Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isWarmHandOffNeeded')) == true ? 'Warm Hand Off Needed.' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19Positive')) == true ? 'Client is COVID19 Positive. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')) ? ['Other Client Notes: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')),'"'].join('') : ''].join('');
  return automaticTransportNotes
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function findExistingClients() {
  clientRecord = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'));
  existingClients = [];
  if (clientRecord) {
    SSN = (getObjectProperty(clientRecord, 'SSN'));
    dateOfBirth = (getObjectProperty(clientRecord, 'datestringDateOfBirth'));
    nameLast = (getObjectProperty(clientRecord, 'nameLast'));
    whereClause = (await (async function(dateOfBirth, nameLast, objectId, SSN) {
    	const conditions = [];

    	if (SSN && SSN !== '999999999') {
    	  conditions.push(`SSN = '${ SSN }'`);
    	}

    	if (dateOfBirth && nameLast) {
    	  conditions.push(`(datestringDateOfBirth = '${ dateOfBirth }' AND nameLast = '${ nameLast.replace(/'/g, "''") }')`);
    	}


    	let whereClause = conditions.length > 0 ? conditions.join(' OR ') : '';

    	if (whereClause) {
    	  whereClause = `(${ whereClause }) AND `;
    	}

    	whereClause += `objectId != '${ objectId }'`;

    	return whereClause;

    })(dateOfBirth, nameLast, (getObjectProperty(clientRecord, 'objectId')), SSN));
    console.log(whereClause);
    existingClients = (await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setPageSize(100)));
    console.log('ExistingClients');
    console.log(existingClients);
    if (existingClients.length > 0) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))['existingClients'] = existingClients;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    } else {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    }
  }
}


  console.log('Start On Submit Event for formValidateAndDispatch');
  console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
  ___arguments.context.pageData['transportRecord'] = ({ [`notesTransport`]: await createTransportNotes() });
  await findExistingClients();
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) == false) {
    console.log('Form submit mergeClientsReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit mergeClientsReady value false condition was triggered.  mergeClientsReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    return ;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isSamsaraDispatch')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0062b56bd89d616ff334fb58a079062c', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('471299f304aa4981e6d8acb7c65c9e9f', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8eab4df2633c49ad3de2fae1de2dc4d8', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86a866357db8ed92dd6132cb9135fe88', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('254f6d5df02ed53bc5adc766a34d843a', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9998a48fa9e749a68d3f445d116fd308', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('794cf9d1714e3a937fbda33b05b3330c', undefined);
    // We wait until finalDispatchReady takes a value, then proceed.
    while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) != null)) {
      await new Promise(r => setTimeout(r, 100 || 0));
    }
    // If the user cancels in the modalDispatchTransport finalDispatchReady
    // will go to FALSE and then we clean things up just before returning.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) == false) {
      console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
      console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value after cleanup:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0062b56bd89d616ff334fb58a079062c', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('471299f304aa4981e6d8acb7c65c9e9f', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8eab4df2633c49ad3de2fae1de2dc4d8', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86a866357db8ed92dd6132cb9135fe88', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('254f6d5df02ed53bc5adc766a34d843a', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9998a48fa9e749a68d3f445d116fd308', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('794cf9d1714e3a937fbda33b05b3330c', undefined);
      return ;
    }
    try {

    } catch (error) {
      console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).');
      console.log(error);
      // This is asynch so that the RT command doesn't have to wait
      // on the email send. The RT command has to be at the end due
      // to the intermittent error seen for non-authenticated users.
      ;(async () => {
          ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001a) An error occurred during the dispatch process.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001a) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
        await new Promise(r => setTimeout(r, 10000 || 0));
        console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

      })();
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
        stopSetTimeout('transportRequestsVerifyAndDispatch');

      } catch (error) {
        console.log('Error encountered in the RT Channel Command during cleanup after e001a.');
        console.log(error);
        await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001a.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

      }
      // Make sure the record doesn't get marked as dispatched if there was an error.
      Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
      (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001a).');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
      return ;

    }
    try {
      console.log('Calling getRouteId with the following Information:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude'));
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart'));
      samsaraRouteId = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) })), 'routeId'));
      console.log(samsaraRouteId);

    } catch (error) {
      console.log('Method getRouteId resulted in an error:');
      console.log(error);
      samsaraRouteId = null;

    }
    console.log('Starting to create the Transport record...');
    try {
      millisecondsPerHour = 3600000;
      if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')) == null) {
        (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['datetimeRequestedPickup'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission'));
      }
      durationSubmissionToScheduledPickup = (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour;
      // This assigns the values that define the transport record
      // or that need to be calculated in Codeless and that aren't
      // established in the modal popup or later through an API call.
      Object.assign((getObjectProperty(___arguments.context.pageData, 'transportRecord')), ({ [`datetimeDispatch`]: (new Date()),[`relDispatcher1_Employee`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.editorEmployeeObjectId')),[`durationSubmissionToScheduledPickup`]: durationSubmissionToScheduledPickup,[`durationRequestedTransportToScheduledPickup`]: (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')).valueOf())) / millisecondsPerHour,[`durationSubmissionToDispatch`]: (((new Date()).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour,[`isLongETA`]: durationSubmissionToScheduledPickup > 3,[`samsaraRouteId`]: samsaraRouteId,[`typeStatus`]: samsaraRouteId ? 'Dispatched' : null,[`billingEntityName`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_EntityRequestingTransport.requesterEntityName')),[`datetimeSubmission_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')),[`transportCode_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')) }));
      console.log('Saving the Transport record and it\'s relations to the DB');
      newTransport = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = newTransport;

        _uow.create('Transport', (getObjectProperty(___arguments.context.pageData, 'transportRecord'))).setOpResultId('createTransport');
        console.log('createTransport Completed');
        _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'rel_TransportRequest', [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))]).setOpResultId('relateTransportToTransportRequest');
        console.log('relateTransportToTransportRequest Completed');
        _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDispatcher1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee'))]).setOpResultId('relateTransportToDispatcher1');
        console.log('relateTransportToDispatcher1 Completed');
        _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDriver1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'))]).setOpResultId('relateTransportToDriver1');
        console.log('relateTransportToDriver1 Completed');
        _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relVehicle1_Vehicle', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle'))]).setOpResultId('relateTransportToVehicle1');
        console.log('relateTransportToVehicle1 Completed');

      })();

      console.log((await newTransport.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        })));
      transportRecordObjectId = (getObjectProperty(((newTransport.getOpResultById('createTransport')).getResult()), 'objectId'));
      try {
        await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', transportRecordObjectId);

      } catch (error) {
        console.log('Error encountered in the RT Channel Command after completion of the Transport Transaction.');
        console.log(error);
        await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of the Transport Transaction.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

      }

    } catch (error) {
      console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).');
      console.log(error);
      ;(async () => {
          ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001b) An error occurred during the dispatch process. (e001b)', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001b) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
        await new Promise(r => setTimeout(r, 10000 || 0));
        console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

      })();
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
        stopSetTimeout('transportRequestsVerifyAndDispatch');

      } catch (error) {
        console.log('Error encountered in the RT Channel Command during cleanup after e001b error.');
        console.log(error);
        await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001b error.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

      }
      // Make sure the record doesn't get marked as dispatched if there was an error.
      Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
      (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001b).');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
      return ;

    }
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command after completion of all other dispatch processes.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of all other dispatch processes.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Blink the data grid block in order to force a re-query,
    // which will in turn hide the recently dispatched record.
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('03e1b3340c8c321818aeed148cf13308');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  console.log('Just after opening modalDispatchTransport in form submit.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) == false) {
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
    return ;
  }
  try {
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFirst')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameLast')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionNumber'))].join(''),[`isDispatched`]: true,[`dispatchedBy`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName')) }));
    console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    console.log(getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName'));
    await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).');
    console.log(error);
    // This is asynch so that the RT command doesn't have to wait
    // on the email send. The RT command has to be at the end due
    // to the intermittent error seen for non-authenticated users.
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001a) An error occurred during the dispatch process.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001a) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001a.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001a.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001a).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    console.log('Calling getRouteId with the following Information:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart'));
    samsaraRouteId = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) })), 'routeId'));
    console.log(samsaraRouteId);

  } catch (error) {
    console.log('Method getRouteId resulted in an error:');
    console.log(error);
    samsaraRouteId = null;

  }
  console.log('Starting to create the Transport record...');
  try {
    millisecondsPerHour = 3600000;
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')) == null) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['datetimeRequestedPickup'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission'));
    }
    durationSubmissionToScheduledPickup = (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour;
    // This assigns the values that define the transport record
    // or that need to be calculated in Codeless and that aren't
    // established in the modal popup or later through an API call.
    Object.assign((getObjectProperty(___arguments.context.pageData, 'transportRecord')), ({ [`datetimeDispatch`]: (new Date()),[`relDispatcher1_Employee`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.editorEmployeeObjectId')),[`durationSubmissionToScheduledPickup`]: durationSubmissionToScheduledPickup,[`durationRequestedTransportToScheduledPickup`]: (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')).valueOf())) / millisecondsPerHour,[`durationSubmissionToDispatch`]: (((new Date()).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour,[`isLongETA`]: durationSubmissionToScheduledPickup > 3,[`samsaraRouteId`]: samsaraRouteId,[`typeStatus`]: samsaraRouteId ? 'Dispatched' : null,[`billingEntityName`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_EntityRequestingTransport.requesterEntityName')),[`datetimeSubmission_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')),[`transportCode_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')) }));
    console.log('Saving the Transport record and it\'s relations to the DB');
    newTransport = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = newTransport;

      _uow.create('Transport', (getObjectProperty(___arguments.context.pageData, 'transportRecord'))).setOpResultId('createTransport');
      console.log('createTransport Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'rel_TransportRequest', [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))]).setOpResultId('relateTransportToTransportRequest');
      console.log('relateTransportToTransportRequest Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDispatcher1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee'))]).setOpResultId('relateTransportToDispatcher1');
      console.log('relateTransportToDispatcher1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDriver1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'))]).setOpResultId('relateTransportToDriver1');
      console.log('relateTransportToDriver1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relVehicle1_Vehicle', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle'))]).setOpResultId('relateTransportToVehicle1');
      console.log('relateTransportToVehicle1 Completed');

    })();

    console.log((await newTransport.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    transportRecordObjectId = (getObjectProperty(((newTransport.getOpResultById('createTransport')).getResult()), 'objectId'));
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', transportRecordObjectId);

    } catch (error) {
      console.log('Error encountered in the RT Channel Command after completion of the Transport Transaction.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of the Transport Transaction.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).');
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001b) An error occurred during the dispatch process. (e001b)', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001b) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001b error.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001b error.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001b).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('Error encountered in the RT Channel Command after completion of all other dispatch processes.');
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of all other dispatch processes.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

  }
  // Blink the data grid block in order to force a re-query,
  // which will in turn hide the recently dispatched record.
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('03e1b3340c8c321818aeed148cf13308');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));

  },
  /* handler:onSubmit */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_b26ba78feceb903690c215dd3b5a4627']('.bl-form', 'novalidate', true);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_9339eea9fc6cd4337ba30a3da3c59d69']('.bl-form', 'novalidate');
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/transport-requests/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to return
  // all records. It is here so that an error won't occur
  // when we pair this query string with the test data flag.
  ___arguments.context.pageData['strWhereClauseBase'] = 'submissionNumber != \'\'';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = false;
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = false;
  ___arguments.context.pageData['transportRequesterOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause('').setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'requesterEntityName')),[`id`]: (getObjectProperty(item, 'requesterId')) });})));
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['currentEditorInfo'] = (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab'](null));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setSortBy('vehicleName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus=\'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')),[`samsaraDriverId`]: (getObjectProperty(item, 'samsaraDriverId')) });})));
  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  ___arguments.context.pageData['typeInsuranceList'] = (await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setSortBy('typeInsurance').setPageSize(100).setDistinct(true))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'typeInsurance')),[`label`]: (getObjectProperty(item, 'typeInsurance')) });})));

  },
  /* handler:onBeforeEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var intervalId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  if ((getObjectProperty(___arguments.context.appData, 'intervalIds')).length > 0) {
    var intervalId_list = (getObjectProperty(___arguments.context.appData, 'intervalIds'));
    for (var intervalId_index in intervalId_list) {
      intervalId = intervalId_list[intervalId_index];
      stopSetTimeout(intervalId);
    }
  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/transport-requests/components/61a2dbca36c2a1c4c3e90bc66884e70d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var matchedRequester, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  // If there is a selection in the selectRequestForm,
  // then find the item in transportRequesterOptions that
  // matches the selection. Otherwise, create a blank object.
  if (getObjectProperty(___arguments.context.pageData, 'manualRequestForm')) {
    matchedRequester = (await asyncListFind((getObjectProperty(___arguments.context.pageData, 'transportRequesterOptions')), async (item) => {
       if ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.pageData, 'manualRequestForm'))) {
        console.log('Match Found in If Statement.  Returning:  ');
        console.log(item);
        return item;
      }


     return ;
    }));
  } else {
    matchedRequester = ({  });
  }
  // General Submissions has a "null" ID.  Check for this, if it's null then leave requester out.  If it's not, then make a requester ID and append it to the URL.  Same is true if nothing is selected in the drop down and manualRequestForm is empty.
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ((getObjectProperty(matchedRequester, 'id')) ? ({ [`requesterId`]: (getObjectProperty(matchedRequester, 'id')) }) : null));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/798ae65f7a5c716c91b159a9fb871a51/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Data Model for Client Info RUC');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord'));

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests/components/d7a7974b30f168dcdeec7d77b0224b74/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'driverOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relDriver1_Employee'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['samsaraDriverId'] = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'driverOptions')), async (item) => {
     if ((getObjectProperty(item, 'value')) == ___arguments.value) {
      return item;
    }


   return ;
  })), 'samsaraDriverId'));
  console.log('Driver objectId and samsaraDriverId selected:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'));
  console.log('Full transportRecordReusableData at time of Selection:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/b2b30c2ba1897d0377e47dbaf0ed5a09/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vehicleOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relVehicle1_Vehicle'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/641efe0ed8775c4bb75880db2d67e3e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b9a7b642136d2dc472510391d36b61d1');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests/components/cdbf241e6dd778235203fa7c7be289bf/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-requests/components/4d1e20aa6af3ad57a1c9830180eb952b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-requests/components/c641e4df2187580bc22281aec10f30de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been
  // voided or already dispatched or is read only.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/e6d1ddba6d572196bbe314d2a7dfd02d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been voided or already dispatched.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/531427c425c186d9710f7c2e205ea7e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = false;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  console.log('On Click Event of Cancel button in modalDispatchTransport.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'finalDispatchReady'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/8d1ba8a68826d30c4e0bd759d24e0973/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/a23c7906b1c25649f56dff288e438d11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('03e1b3340c8c321818aeed148cf13308');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/6aafb61d42cb9872ae777823391ff04a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests/components/7f1913299f7463f4ff5d0517eebdcfdb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests/components/2c8f6c12129b3164aa7c7031326e8774/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', ({ [`strWhereClauseBase`]: ['&& rel_TransportRequest.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\''].join('') }));
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// This button only makes sense to show if the record has been dispatched.

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/d9594a32d6c5d23c1382b6998baef31c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  }
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/0c757ba64a75ec64a5c6cde4b0ccd4a2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['submissionOtherInformation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/a199ac635af14cb3e08dcd92469903e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/9de76a5a0ff5fd5d72cfe67da6067954/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['notesTransport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRecord.notesTransport'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-requests/components/a2d650eca1d6503c9121ca913c4c7045/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-requests/components/8f1bef3521655b340ea3405cb7f72754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  console.log('Printing data containers after close:');
  console.log(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'));
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.layoutData);
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/131e3b99f5866c255e6df08e6aab9f41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/7169de853e2f49f261a78b784938060f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/dd9f6fdc6541ad623fafe6d10422b8f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // If someone saves and closes then reset the 'isInformationVerified'
  // so that they always have to attest to that before dispatch
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isInformationVerified'] = false;
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving changes to the record.');
    console.log(error);

  }
  (function (message) { alert(message) })('Changes have been saved!');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// We show the save changes button anytime the record is not in read only mode.

  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/92916f6859815d21ebccc33ba547a5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'30\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/a3d1808a775455748ad8706c5c9fed92/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests/components/2fc510ebd655f892523b7bf476ab8a6b/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) : []).map(async item => {  label = ['Client Name: ',(getObjectProperty(item, 'nameFull')),', ','DoB: ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(item, 'dateOfBirth')))))),', ','SSN: ',(await (async function(SSN) {
  	if (!SSN || typeof SSN !== 'string') {
  	    return 'N/A'
  	}

  	if (!/^\d{9}$/.test(SSN)) {
  	  return SSN;
  	}

  	return `${SSN.slice(0, 3)}-${SSN.slice(3, 5)}-${SSN.slice(5, 9)}`;
  })((getObjectProperty(item, 'SSN')))),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','Object ID: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['selectedExistingClient'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/e6f4346a48f98663175a2f04d3970a94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['No matching Client was found in our records. This Transport Request will continue to use the new Client record created for client ',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.dateOfBirth')))))),'.'].join(''));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/2371be049f256a4bda2fbc6a45e12a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-requests/components/e0cd4d5ad60949056c2b8265fc369f8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/7c8af31888b5d78a223db642a1571502/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, result, mergeClientTx, j, transportRequestsToUpdate, retainCertainClientInfo, pageSize, offset, transportRequest, transportRequests, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = true;
  try {
    transportRequestsToUpdate = [];
    count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join('')))));
    offset = 0;
    pageSize = 100;
    while (offset < count) {
      transportRequests = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
      for (var transportRequest_index in transportRequests) {
        transportRequest = transportRequests[transportRequest_index];
        addItemToList(transportRequestsToUpdate, transportRequest);
      }
      offset = offset + pageSize;
    }
    transportRequestsToUpdate = (await (async function(arr) {
    	const seen = new Set()


    	return arr.filter(item => {
    	  const isDuplicate = seen.has(item.objectId)

    	  seen.add(item.objectId)

    	  return !isDuplicate
    	})

    })(transportRequestsToUpdate));
    console.log('%c>> 🔒 ' + 'TransportRequestsToUpdate:', 'color: #f06292', JSON.parse(JSON.stringify(transportRequestsToUpdate)));

  } catch (error) {
    console.log('%c>> 🔒 ' + 'Error:', 'color: #ef5350', JSON.parse(JSON.stringify(error)));
    (function (message) { alert(message) })(error);
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    return ;

  }
  console.log('%c>> 🔒 ' + 'selectedExistingClient', 'color: #4caf50', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))));
  try {
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #3f51b5', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    mergeClientTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    // This flag is used to determine whether the update operation
    // for selectedExistingClient needs to be added to the
    // transaction in order to preserve SSN or insurance information.
    retainCertainClientInfo = (await (async function(currentRecord, oldRecord) {
    	const emptyValues = ['999999999', '999-99-9999', '', null, undefined];
    	const skipFields = ['objectId', 'ownerId', 'created', 'updated', 'datestringDateOfBirth', 'height', 'nameFull', 'numberInsurancePolicies'];

    	let hasChanges = false;

    	  for (const key in currentRecord) {
    	    if (skipFields.includes(key)) continue;

    	    const currentValue = currentRecord[key];
    	    const oldValue = oldRecord[key];

    	    const shouldUpdate =
    	      (currentValue !== undefined && !emptyValues.includes(currentValue)) &&
    	      (oldValue === undefined || emptyValues.includes(oldValue));

    	    if (shouldUpdate) {
    	      oldRecord[key] = currentValue;
    	      hasChanges = true;
    	    }
    	  }
    	  console.log('hasChanges', hasChanges)
    	  return hasChanges
    })((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))));
    if (retainCertainClientInfo) {
      await ( async () => {
        const _uow = mergeClientTx;

        _uow.update('Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('UpdateClient: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.objectId'))));

      })();

    }
    if (transportRequestsToUpdate.length > 0) {
      for (var j_index in transportRequestsToUpdate) {
        j = transportRequestsToUpdate[j_index];
        await ( async () => {
          const _uow = mergeClientTx;

          _uow.setRelation('TransportRequest', j, 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(j, 'objectId'))));

        })();

      }
    }
    await ( async () => {
      const _uow = mergeClientTx;

      _uow.setRelation('TransportRequest', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')), 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))));
      _uow.delete('Client', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'))).setOpResultId((String('ClientObjectDelete: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId'))));

    })();

    result = (await mergeClientTx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));
    console.log(result);
    if (getObjectProperty(result, 'success')) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['clientRecord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['rel_Client'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
    }
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #f06292', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    await (getChannelInstance('default')).send((String('reload-table-records:') + String('TransportRequest')), ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['This Transport Request is now matched to existing client ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.dateOfBirth')))))),'.'].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  } catch (error) {
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    (function (message) { alert(message) })(error);
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests/components/af16da7891b50db1a92c72c3cb02852a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/752113b5eb5a9ee55c96c7dcad88256b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/613926da2f8c51cf8e42ba2f953ed245/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests/components/3d05686703fb302b56bc4968f8332998/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['isDriversLastRoute'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/7d0cc286017a265580b90576fa296c83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/cd416fb140f955bf17c52d7d4c9f7d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/33ef3456b45c06195036af6564a7ffd2/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, clientPasteDate, transportRequestPasteData, SpecialNeedsOrConcernsNotes, startNumber, listFromPaste, heightIn, heightFt, dateOfBirth, destinationLocationName, totalHeight, specialPrecautionso_MedicalConcerns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('No', 'g')), ''));
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('Yes', 'g')), 'TRUE'));
    listFromPaste = (getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).split(':');
    console.log('Value of #1 item on list');
    console.log(listFromPaste[0].trim());
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log(startNumber);
    console.log(listFromPaste[((startNumber + 32) - 1)]);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 32) - 1)].trim()) + String(':');
    console.log(SpecialNeedsOrConcernsNotes);
    specialPrecautionso_MedicalConcerns = subsequenceFirstFromEnd(listFromPaste[((startNumber + 29) - 1)], 19).trim();
    SpecialNeedsOrConcernsNotes = String(SpecialNeedsOrConcernsNotes) + String(String('  Special Precautions or Medical Concerns: ') + String(specialPrecautionso_MedicalConcerns));
    console.log('Special Precautions Notes');
    console.log(SpecialNeedsOrConcernsNotes);
    if ((specialPrecautionso_MedicalConcerns.indexOf('Suicide/Self Harm') !== -1) || (specialPrecautionso_MedicalConcerns.indexOf('Self-Harm Risk') !== -1)) {
      console.log('Suicide/Self Harm');
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Elopement Risk') !== -1) {
      console.log('Elopement Risk');
      ___arguments.context.dataModel['isElopementRisk'] = true;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isElopementRisk'] = false;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Disorganized Behavior') !== -1) {
      console.log('Disorganized Behavior');
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
    } else {
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Fall Risk') !== -1) {
      console.log('Fall Risk');
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
    }
    destinationLocationName = String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 23) - 1)], 20).trim()) + String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 24) - 1)], 28).trim());
    dateOfBirth = (new Date((new Date((subsequenceFirstFromEnd(listFromPaste[((startNumber + 9) - 1)], 10).trim()))).getTime() + ((19 * 3600) * 1000)));
    totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim();
    console.log('total height');
    console.log(totalHeight);
    if (totalHeight.indexOf('\'') !== -1) {
      totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim().split('\'');
      heightFt = totalHeight[0].trim();
      heightIn = totalHeight[1].trim().charAt(0);
    } else {
      heightFt = totalHeight;
      heightIn = 0;
    }
    console.log('listFromPaste');
    console.log(listFromPaste);
    transportRequestPasteData = ({ [`isContactedYMCR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 7) - 1)], 38).trim() == 'TRUE' ? true : false,[`isMCTR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 8) - 1)], 10).trim() == 'TRUE' ? true : false,[`isCOVID19Positive`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 14) - 1)], 24).trim() == 'TRUE' ? true : false,[`referringEntityName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 18) - 1)], 17).trim(),[`referringContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 19) - 1)], 30).trim(),[`referringContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 20) - 1)], 15).trim()).replace((new RegExp('-', 'g')), '')),[`pickupAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 21) - 1)], 66).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`isReferralToNearestUrcOrCc`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 22) - 1)], 14).trim() == 'TRUE' ? true : false,[`destinationLocationName`]: destinationLocationName,[`destinationAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 25) - 1)], 28).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`destinationContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 26) - 1)], 32).trim(),[`destinationContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 27) - 1)], 23).trim()).replace((new RegExp('-', 'g')), '')),[`isClientAggressiveOrViolentToday`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 31) - 1)], 22).trim() == 'TRUE' ? true : false,[`isClientElopementRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientElopementRiskToday')),[`isClientSuicideOrSelfHarmRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientSuicideOrSelfHarmRiskToday')),[`isClientFallRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientFallRiskToday')),[`stateSubmissionNumber`]: (getObjectProperty(___arguments.context.dataModel, 'stateSubmissionNumber')) });
    clientPasteDate = ({ [`nameFirst`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 5) - 1)], 19).trim(),[`is18`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 6) - 1)], 48).trim(),[`dateOfBirth`]: dateOfBirth,[`age`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 10) - 1)], 13).trim(),[`assignedSexAtBirth`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 11) - 1)], 13).trim(),[`heightFt`]: heightFt,[`heightIn`]: heightIn,[`weight`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 13) - 1)], 22).trim(),[`emergencyContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 15) - 1)], 31).trim(),[`emergencyContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 16) - 1)], 41).trim()).replace((new RegExp('-', 'g')), '')),[`hasHistoryOfViolence`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 30) - 1)], 28).trim() == 'TRUE' ? true : false,[`otherNotes`]: SpecialNeedsOrConcernsNotes,[`isElopementRisk`]: (getObjectProperty(___arguments.context.dataModel, 'isElopementRisk')),[`hasDisorganizedBehavior`]: (getObjectProperty(___arguments.context.dataModel, 'hasDisorganizedBehavior')) });
    console.log('Transport Request Data');
    console.log(transportRequestPasteData);
    console.log('Client Record Data');
    console.log(clientPasteDate);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ({ [`transportRequestRecord`]: transportRequestPasteData,[`clientRecord`]: clientPasteDate,[`requesterId`]: 'STATE' }));

  } catch (error) {
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An error occurred during the copy/paste of a submission record into the app.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the copy/paste of a submission record into the app.' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/copy-paste-errors', error, 'An error occurred during the copy/paste of a submission record into the app.', 'Form paste-state-submission Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));

    })();
    (function (message) { alert(message) })('We\'re sorry, there was an error when you attempted to copy/paste the record.  Please refresh your browser tab and try to copy/paste again.  Please be sure to paste from just before "RideCARE Submission Submission Date:" until the very end of the email after the "Special Needs/Concerns" section.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transport-requests/components/a781341ea971861568c9bd1b125a5683/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['State Submission #',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')),(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.usedEmailParser')) ? ' automatically parsed from email.' : ''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests/components/c5aeecbb7a7b29a5d767bc4a68e9c5a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['State Submission #',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')),(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.usedEmailParser')) ? ' automatically parsed from email.' : ''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/96375d9c8e896078c906901591a7205d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var endValid, startValid, SpecialNeedsOrConcernsNotes, firstListValue, error, startNumber, listFromPaste;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', false);
  try {
    listFromPaste = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33ef3456b45c06195036af6564a7ffd2'), 'textTransportPaste')).split(':');
    console.log('List From Paste');
    console.log(listFromPaste);
    firstListValue = listFromPaste[0].trim();
    console.log('Value of #1 item on list');
    console.log(firstListValue);
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log('Start Number = ');
    console.log(startNumber);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 31) - 1)].trim()) + String(':');
    console.log('Special Needs Or Concerns');
    console.log(SpecialNeedsOrConcernsNotes);

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', true);
    return ;

  }
  if ((firstListValue.indexOf('Name') !== -1) == true || (firstListValue.indexOf('Date') !== -1) == true) {
    startValid = true;
  } else {
    startValid = false;
  }
  if ((SpecialNeedsOrConcernsNotes.indexOf('Needs') !== -1) == true) {
    endValid = true;
  } else {
    endValid = false;
  }
  if (startValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', true);
    return ;
  } else if (endValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', true);
    return ;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/9476118d4077f7a10cb49bcb3cf3ca06/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = true;
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/f91e5188b16edf7dcaffed3466ff3187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests/components/8c99e5feb0d40b950d6ebea30d19ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFull'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests/components/c9a812f721adb279f32f508e2ffaf36b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Simply sets the isDriverLastRoute property to be true or
  // false based on the checkbox. This value is used in cloud code
  // timers in order to get the "fourth leg" odometer readings
  // of routes that occur before a driver ends their shift.
  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['isDriversLastRoute'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/01358cac7395efffbd25fc9a66d725e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Page Data');
  console.log(___arguments.context.pageData);
  console.log('Submission Code');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode'));
  try {
    await Backendless.Request.post(`${Backendless.appPath}/services/postNewRoute/postRoute`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeName': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')),'driverId': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'routeNotes': 'Notes for transport','stops': [({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'startingLocation.address')),[`address`]: (getObjectProperty(___arguments.context.pageData, 'startingLocation.address')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'startingLocation.latitude')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'startingLocation.longitude')),[`scheduled_arrival_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.0.scheduledArrival')),[`scheduled_departure_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.0.scheduledDeparture')),[`notes`]: 'Notes for stop 1' }), ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.googleName')),[`address`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.googleFormattedAddress')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.latitude')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.longitude')),[`scheduled_arrival_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledArrival')),[`scheduled_departure_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledDeparture')),[`notes`]: 'Notes for stop 2' }), ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.googleName')),[`address`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.googleFormattedAddress')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.latitude')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.longitude')),[`scheduled_arrival_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledArrival')),[`scheduled_departure_time`]: (getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledDeparture')),[`notes`]: 'Notes for stop 3' })] });
    await new Promise(r => setTimeout(r, 2000 || 0));
    // These set property blocks are here because the on change
    // event doesn't seem to be working for the datetime select
    // components. This ensures they are properly saved in transportRecord
    // since they need to be saved back to the database eventually
    (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrival')))).valueOf());
    // These set property blocks are here because the on change
    // event doesn't seem to be working for the datetime select
    // components. This ensures they are properly saved in transportRecord
    // since they need to be saved back to the database eventually
    (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = (new Date((getObjectProperty(___arguments.context.pageData, 'visibleScheduledPickup'))));
    // These set property blocks are here because the on change
    // event doesn't seem to be working for the datetime select
    // components. This ensures they are properly saved in transportRecord
    // since they need to be saved back to the database eventually
    (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickupDeparture'] = (new Date((getObjectProperty(___arguments.context.pageData, 'visibleScheduledPickupDeparture'))));
    // These set property blocks are here because the on change
    // event doesn't seem to be working for the datetime select
    // components. This ensures they are properly saved in transportRecord
    // since they need to be saved back to the database eventually
    (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = (new Date((getObjectProperty(___arguments.context.pageData, 'visibleScheduledDropoff'))));
    // These set property blocks are here because the on change
    // event doesn't seem to be working for the datetime select
    // components. This ensures they are properly saved in transportRecord
    // since they need to be saved back to the database eventually
    (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoffDeparture'] = (new Date((getObjectProperty(___arguments.context.pageData, 'visibleScheduledDropoffDeparture'))));
    await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = true;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b9a7b642136d2dc472510391d36b61d1');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'optimizedData')) == null)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests/components/8f8d5a83d40574cbd37a5dcd3d58859c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = false;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isSamsaraDispatch'] = false;
  console.log('On Click Event of Cancel button in davidDispatchBlock finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'finalDispatchReady'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests/components/ddb9a3cd09d5a9b16e834196629549c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Page Data: ');
  console.log(___arguments.context.pageData);
  console.log('driver Id:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log('samsaraVehicleId: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'samsaraVehicleId.samsaraVehicleId'));
  try {
    ___arguments.context.pageData['samsaraLoading'] = true;
    // Set serviceTimes property in Page Data. serviceTimes is an
    // array of numbers corresponding to the inputs of the service
    // time select components in the davidDispatchBlock UI.
    ___arguments.context.pageData['serviceTimes'] = [(Number((getObjectProperty(___arguments.context.pageData, 'startServiceTime')))), (Number((getObjectProperty(___arguments.context.pageData, 'pickupServiceTime')))), (Number((getObjectProperty(___arguments.context.pageData, 'dropoffServiceTime'))))];
    console.log('%c>> ' + 'stops Array:', 'color: null', (getObjectProperty(___arguments.context.pageData, 'serviceTimes')));
    // set property in Page Data optimzedData which contains an
    // array of three indexes, each index has information such
    // as the scheduled departure and arrival time of that stop.
    ___arguments.context.pageData['optimizedData'] = (await Backendless.Request.get(`${Backendless.appPath}/services/DistanceMatrixService/TravelTimesFromStops`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'transportRecord': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))),'driverId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'))),'vehicleId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'samsaraVehicleId.samsaraVehicleId'))),'serviceTimes': (await BackendlessUI.Functions.Custom['fn_be5159274106e4112278e8648d164788']((getObjectProperty(___arguments.context.pageData, 'serviceTimes')))),'manualLat': (getObjectProperty(___arguments.context.pageData, 'startingLocation.latitude')),'manualLng': (getObjectProperty(___arguments.context.pageData, 'startingLocation.longitude')),'visibleScheduledArrivalTimePicker': (getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrivalTimePicker')) }).send());
    if ((getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrivalTimePicker')) == null) {
      ___arguments.context.pageData['visibleScheduledArrival'] = (new Intl.DateTimeFormat('en-US', ({ [`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format((new Date((getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.0.scheduledArrival'))))));
      ___arguments.context.pageData['visibleScheduledArrivalTimePicker'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrival')))).valueOf());
    }
    ___arguments.context.pageData['visibleScheduledDeparture'] = (new Intl.DateTimeFormat('en-US', ({ [`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format((new Date((getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.0.scheduledDeparture'))))));
    ___arguments.context.pageData['visibleScheduledPickup'] = (new Intl.DateTimeFormat('en-US', ({ [`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format((new Date((getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledArrival'))))));
    ___arguments.context.pageData['visibleScheduledPickupDeparture'] = (new Intl.DateTimeFormat('en-US', ({ [`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format((new Date((getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.1.scheduledDeparture'))))));
    ___arguments.context.pageData['visibleScheduledDropoff'] = (new Intl.DateTimeFormat('en-US', ({ [`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format((new Date((getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledArrival'))))));
    ___arguments.context.pageData['visibleScheduledDropoffDeparture'] = (new Intl.DateTimeFormat('en-US', ({ [`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format((new Date((getObjectProperty(___arguments.context.pageData, 'optimizedData.travelTimes.2.scheduledDeparture'))))));
    console.log('optimizedData');
    console.log(getObjectProperty(___arguments.context.pageData, 'optimizedData'));
    console.log('Page data:');
    console.log(___arguments.context.pageData);

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['samsaraLoading'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'startingLocation')) == null)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests/components/3e1a376133bb8697886ab35f318cff73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['samsaraLoading'] = true;
    try {
      // This block creates a new property in Page Data which
      // holds a startingLocation object. This object contains the
      // address, latitude, and longitude of the starting location,
      // and these properties are used in other codeless blocks.
      ___arguments.context.pageData['startingLocation'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getRouteStartingLocation/StartingLocation`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'driverId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'))),'vehicleID': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'samsaraVehicleId.samsaraVehicleId'))) }).send());
      if ((getObjectProperty(___arguments.context.pageData, 'startingLocation.scheduledRouteEndTime')) != null) {
        ___arguments.context.pageData['visibleScheduledArrival'] = (new Date((getObjectProperty(___arguments.context.pageData, 'startingLocation.scheduledRouteEndTime'))));
        ___arguments.context.pageData['visibleScheduledArrivalTimePicker'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrival')))).valueOf());
      }

    } catch (error) {
      console.log(error);

    }
    console.log('starting location');
    console.log(getObjectProperty(___arguments.context.pageData, 'startingLocation'));
    // It is important to keep this wait block. The API service
    // called below "createRoute" creates an object for our google
    // map custom component. It needs to know the latitude and
    // longitude of the starting location, which is only available
    // upon the button press. Therefore, the wait ensures that the
    // startingLocation object has rendered to avoid race conditions.
    await new Promise(r => setTimeout(r, 2000 || 0));
    // Set a property in page data called routeForMap, which
    // will later be passed as the return for our custom google
    // map component. This creates a JSON object which can be
    // viewed under the route logic return in alex map test.
    ___arguments.context.pageData['routeForMap'] = (await Backendless.Request.post(`${Backendless.appPath}/services/createRoute/constructRouteForMap`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.latitude')),'lng1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.longitude')),'lat2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.latitude')),'lng2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.longitude')),'lat3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.latitude')),'lng3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.longitude')),'title1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.address')),'title2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.googleFormattedAddress')),'title3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.googleFormattedAddress')) }));

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['samsaraLoading'] = false;

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'samsaraVehicleId.samsaraVehicleId')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'))) == null)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests/components/a81aba8afd1edca9198be7e4692b28ed/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['notesTransport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRecord.notesTransport'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-requests/components/e09107225bf919e23cfbc2f289183686/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.googleFormattedAddress'))

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/transport-requests/components/60a567eeab448b48cf8a6649fb057d3f/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.googleFormattedAddress'))

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/transport-requests/components/60c38f877efd93bfd2dc985b1cf18424/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['manualStartingLocation'] = ___arguments.value;
  ___arguments.context.pageData['startingLocation'] = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.context.pageData, 'manualStartingLocation.place_id')), ['formatted_address', 'geometry']));
  (getObjectProperty(___arguments.context.pageData, 'startingLocation'))['latitude'] = (getObjectProperty(___arguments.context.pageData, 'startingLocation.location.lat'));
  (getObjectProperty(___arguments.context.pageData, 'startingLocation'))['longitude'] = (getObjectProperty(___arguments.context.pageData, 'startingLocation.location.lng'));
  (getObjectProperty(___arguments.context.pageData, 'startingLocation'))['address'] = (getObjectProperty(___arguments.context.pageData, 'startingLocation.formatted_address'));
  console.log('manualStartingLocation.place_id');
  console.log(getObjectProperty(___arguments.context.pageData, 'manualStartingLocation.place_id'));
  // Set a property in page data called routeForMap, which
  // will later be passed as the return for our custom google
  // map component. This creates a JSON object which can be
  // viewed under the route logic return in alex map test.
  ___arguments.context.pageData['routeForMap'] = (await Backendless.Request.post(`${Backendless.appPath}/services/createRoute/constructRouteForMap`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.latitude')),'lng1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.longitude')),'lat2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.latitude')),'lng2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.longitude')),'lat3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.latitude')),'lng3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.longitude')),'title1': (getObjectProperty(___arguments.context.pageData, 'startingLocation.address')),'title2': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.pickupFacilityRecord.googleFormattedAddress')),'title3': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.destinationFacilityRecord.googleFormattedAddress')) }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/d2b9b9acb77b6f7511ef57c40ae6d019/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  // This sets the property relDriver1_Employee of
  // transportRecord of Page Data to be the changed value,
  // which happens to be an ObjectId rather than a name.
  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relDriver1_Employee'] = ___arguments.value;
  // This sets the samsaraDriverId property which will need to be used
  // with a variety of Samsara API calls in other codeless blocks.
  // We go through driverOptions of page data and match the ID.
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['samsaraDriverId'] = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'driverOptions')), async (item) => {
     if ((getObjectProperty(item, 'value')) == ___arguments.value) {
      return item;
    }


   return ;
  })), 'samsaraDriverId'));
  console.log('Driver objectId and samsaraDriverId selected: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'));
  console.log('Full transportRecordReusableData at time of selection');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// Page Data contains a property called driverOptions, which can be used as the options logic for this select component.

  return (getObjectProperty(___arguments.context.pageData, 'driverOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/transport-requests/components/a0342c222b7e99b33a0ef1853a319984/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vehicleOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relVehicle1_Vehicle'] = ___arguments.value;
  ___arguments.context.pageData['samsaraVehicleId'] = ((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle')),'\''].join(''))).setProperties('samsaraVehicleId').setPageSize(10)))[0]);
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/dce8c5058982a41bdd98c1615518f2ed/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Changed Value: ');
  console.log(___arguments.value);
  ___arguments.context.pageData['visibleScheduledArrival'] = (new Intl.DateTimeFormat('en-US', ({ [`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format((new Date(___arguments.value))));
  ___arguments.context.pageData['visibleScheduledArrivalTimePicker'] = ___arguments.value;
  // These set property blocks are here because the on change
  // event doesn't seem to be working for the datetime select
  // components. This ensures they are properly saved in transportRecord
  // since they need to be saved back to the database eventually
  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrival')))).valueOf());
  console.log('Printing datetimeScheduledStart: ');
  console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRecord')), 'datetimeScheduledStart'));

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'visibleScheduledArrivalTimePicker', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrivalTimePicker')));

  return ((getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrivalTimePicker')) ? (getObjectProperty(___arguments.context.pageData, 'visibleScheduledArrivalTimePicker')) : null)

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-requests/components/7be95ac92f778304352e589b79fc715a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['startServiceTime'] = ___arguments.value;
  console.log('Page data:');
  console.log(___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/e5c7e03a15937cc291fb6a1e3d11b3b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['pickupServiceTime'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/64fd22ff869d8401447c0bb8f77aac4b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['dropoffServiceTime'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/40528ca5a234fa54bd4f40ace1b7a15b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Page Data: ');
  console.log(___arguments.context.pageData);
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isSamsaraDispatch'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests/components/41bf9d1f9418a07dab6ff20623f2e22f/bundle.js', [], () => ({
  /* content */
  /* handler:routeLogic */
  ['routeLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'routeForMap'))

  },
  /* handler:routeLogic */
  /* handler:trafficLogic */
  ['trafficLogic'](___arguments) {
      return true

  },
  /* handler:trafficLogic */
  /* handler:additionalMarkersLogic */
  ['additionalMarkersLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'driverAvailabilityForMap'))

  },
  /* handler:additionalMarkersLogic */
  /* content */
}))

define('./pages/transport-requests/components/254f6d5df02ed53bc5adc766a34d843a/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Create the submissionCode which is comprised of the
  // first 3 characters of clients first name, first 3
  // letters of clients last name, and the submissionNumber.
  // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
  Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFirst')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameLast')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionNumber'))].join(''),[`isDispatched`]: true,[`dispatchedBy`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName')) }));
  console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
  // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
  console.log(getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName'));
  console.log('Page Data');
  console.log(___arguments.context.pageData);
  console.log('Submission Code');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode'));
  console.log('starting location');
  console.log(getObjectProperty(___arguments.context.pageData, 'startingLocation'));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/transport-requests/components/934438248ebccdebce0170b5f7b1b646/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'samsaraLoading'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Transport Requests',[`pageName`]: 'transport-requests' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'showAllRecords')) == true)) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},
    	{
    	  "field": "isInformationVerified",
    	  "headerName": "",
    	  "headerTooltip": "Ready for Dispatch?",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxCheckmarkCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false,
    	  "filtering": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},
    	{
    	  "field": "isEOD",
    	  "headerName": "",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.stateCode",
    	  "headerName": "State",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "headerTooltip": "Date & Time when the transport request was received via ORC app form.",
    	  "type": "datetimeColumn",
    	  "cellRendererParams": {
    	    "dayjsFormat": "MM/DD/YYYY HH:mm",
    	    "withSeconds": false
    	  },
    	  "width": 155,
    	  "sortable": true,
    	  "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false,
    	  "wrapHeaderText": true,
    	  "autoHeaderHeight": true,
    	  "meta": { "align": "center" }
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "minWidth": 200,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "minWidth": 200,
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},

    	{
    	  "field": "isInformationVerified",
    	  "headerName": "",
    	  "headerTooltip": "Ready for Dispatch",
    	  "minWidth": 40,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxCheckmarkCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "isEOD",
    	  "headerName": "",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 20,
    	  "maxWidth": 55,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.stateCode",
    	  "headerName": "State",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  "editable": false
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, newTransportRequestRecord, submissionInfo, waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for use as both input forms and viewers.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'validateAndDispatchRecord') {
    console.log('Printing data containers at start of event validateAndDispatchRecord:');
    console.log(___arguments['recordItem']);
    console.log(___arguments.context.pageData);
    console.log(___arguments.context.layoutData);
    console.log(___arguments.context.appData);
    // Don't allow editing in the UI window if the record has already been dispatched, if the record is voided, or if another user is already editing it.
    // This was disabled when we made it so that transport requests could be edited after dispatch.  It can be removed at a later date.
    ___arguments.context.pageData['transportRequestRecordReusableData'] = ({ [`transportRequestRecord`]: ___arguments['recordItem'],[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`typeInsuranceList`]: (getObjectProperty(___arguments.context.pageData, 'typeInsuranceList')),[`pickupFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relPickup_Facility')),[`destinationFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relDestination_Facility')),[`requesterRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_EntityRequestingTransport')),[`selectExistingClientData`]: ({  }),[`isReadOnlyMode`]: false || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId')))) ? true : false });
    // This makes sure that the requester ID is present on page
    // Data here like it is on the Transport Request Form Page.
    ___arguments.context.pageData['requesterId'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterId'));
    console.log('Action Icon Click Event - PageData.requesterId:');
    console.log(getObjectProperty(___arguments.context.pageData, 'requesterId'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    // Only trigger the 'editing' command interval if the record is not read only.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == false) {
      try {

        ;(function() {
          const callback = async () => {
              await (getChannelInstance('default')).send('editing-table:TransportRequest', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

          };

          const timerId = 'transportRequestsVerifyAndDispatch';
          const timerDelay = 1000;

          runSetTimeout(timerId, callback, timerDelay)
        })()

      } catch (error) {
        console.log('An error was seen in the RT Channel Command for isReadOnlyMode');
        console.log(error);

      }
    }
  } else if (___arguments['eventName'] == 'voidRecord') {
    console.log(___arguments['recordItem']);
    // Don't allow voiding the record if it's in isReadOnlyMode
    // (i.e. if someone else is editing, if it's already
    // been dispatched, or if it's already been voided)
    if (((getObjectProperty(___arguments['recordItem'], 'isDispatched')) || (getObjectProperty(___arguments['recordItem'], 'isVoided')) || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId'))))) == true) {
      (function (message) { alert(message) })('This record is currently being edited by another user, or it has already been dispatched or voided.  It cannot be voided at this time.');
    } else {
      ___arguments['recordItem']['isVoided'] = true;
      // This is how we can save just a single property into
      // the database without updating the entire record.
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`isVoided`]: (getObjectProperty(___arguments['recordItem'], 'isVoided')),[`dispatchedBy`]: (getObjectProperty(___arguments.context.appData, 'currentUser.name')) }) );
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments['recordItem'], 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after voiding the record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    }
  } else if (___arguments['eventName'] == 'duplicateRecord') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a2d650eca1d6503c9121ca913c4c7045');
    console.log('!!!RECORD');
    console.log(___arguments['recordItem']);
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Duplicate operation timed out after 20s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a809fd2715c4f0babc542a2e8da9e97e');
      console.log('record1');
      console.log(___arguments['recordItem']);
      submissionInfo = ['THIS RECORD WAS DUPLICATED FROM TRANSPORT REQUEST #',(getObjectProperty(___arguments['recordItem'], 'submissionNumber')),'.'].join('');
      newTransportRequestRecord = (Object.assign(({  }), ___arguments['recordItem']));
      delete newTransportRequestRecord['objectId'];
      delete newTransportRequestRecord['created'];
      delete newTransportRequestRecord['updated'];
      delete newTransportRequestRecord['submissionNumber'];
      newTransportRequestRecord['submissionOtherInformation'] = submissionInfo;
      newTransportRequestRecord['isDispatched'] = false;
      newTransportRequestRecord['isVoided'] = false;
      newTransportRequestRecord['dispatchedBy'] = null;
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty((await Backendless.Data.of('TransportRequest').deepSave( newTransportRequestRecord )), 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after duplicating a transport request record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await new Promise(r => setTimeout(r, 200 || 0));
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
      // This wait is here to make sure that the relations data
      // arrives into the data grid before the waiting spinner closes.
      await new Promise(r => setTimeout(r, 1200 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a809fd2715c4f0babc542a2e8da9e97e');
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'delete') {
    await BackendlessUI.Functions.Custom['fn_58f43615b3a18b74c5b8d439a61e9b2d'](___arguments.context.pageData, 'TransportRequest', ___arguments['recordItem'], (await (async function() {
    	//"___arguments" is a specific property Backendless uses and in this case it contains the object for the modal itself.

    	return ___arguments
    })()));
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:editorInfoLogic */
  ['editorInfoLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo'))

  },
  /* handler:editorInfoLogic */
  /* content */
}))

define('./pages/transport-requests(2)/components/ff57ab8eb9b2e5bf2f5ff0d6e6df5fcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var errors, durationRequestedTripLeadTime, error, millisecondsPerHour, timeToValidate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function validateTruncatedFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationLocationName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * This function will check various fields of the form and
 * make sure that input is valid. If it is not, it will throw
 * and error and prevent the remainder of the submission.
 */
async function validateFullFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.dateOfBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['dateOfBirth'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactPhone'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.SSN'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['SSN'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['assignedSexAtBirth'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightFt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightFt'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightIn'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightIn'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['weight'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeAffiliations'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['tribeAffiliations'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeMemberZipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['clientRecord.tribeMemberZipcode'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['email'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emailAlt'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientMedicallyClearedForTransportToday')) != true) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9b47fd8cdd2f04219a2f7997f9e7586')));
    errors['isClientMedicallyClearedForTransportToday'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['typeCustodyExchange'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['pickupConfirmationNumber'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.detentionCenterPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['detentionCenterPhone'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.isCourtOrdered')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.nameCourtOrSystemOrJudge'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['nameCourtOrSystemOrJudge'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19TestRequired')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationAcceptingProviderName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85042b9acde90c9937b6240f234825ac')));
    errors['destinationAcceptingProviderName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * Describe this function...
 */
async function validateTripTime(timeToValidate) {
  millisecondsPerHour = 3600000;
  if (timeToValidate == null) {
    console.log('Trip Time was NULL but was required.');
    return false;
  }
  try {
    durationRequestedTripLeadTime = ((timeToValidate.valueOf()) - ((new Date()).valueOf())) / millisecondsPerHour;
    console.log('validatePickupTime Function');
    console.log(durationRequestedTripLeadTime);
    console.log(durationRequestedTripLeadTime > 4);

  } catch (error) {
    console.log('Try/Catch Block in the validatePickupTime Function');
    console.log(error);

  }
  return durationRequestedTripLeadTime > 4
}


  console.log(___arguments.context.pageData);
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) != true) {
    (function (message) { alert(message) })('You must check the box indicating you have verified all information before saving changes or dispatching transport.');
    return ;
  } else if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) {
    // first check whether it's a truncated submission. If so, skip validation
    // since we haven't built that yet. If not, then run normal validation.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) == true) {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateTruncatedFormSubmission() == true) {
        console.log('Truncated form submissions were validated.');
      } else {
        console.log('Else Block in Truncated Form Submission validation');
        return ;
      }
    } else {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateFullFormSubmission() == true) {
        console.log('Full form submissions were validated.');
      } else {
        console.log('Else Block in Full Form Submission validation');
        return ;
      }
    }
    console.log('ElseIf in On Click Event of the Dispatch button occurred.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('73b93b24382d41b884a9e1223fd5ceba');
    return ;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after cancel button click.');
    console.log(error);

  }
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  console.log('Page Data Cancel Button: ');
  console.log(___arguments.context.pageData);
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllRecords'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'2\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/8dad9c1d07152be824327a0a917b9be8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving edits to the record.');
    console.log(error);

  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/73b93b24382d41b884a9e1223fd5ceba/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var automaticTransportNotes, error, transportRecordObjectId, newTransport, samsaraRouteId, durationSubmissionToScheduledPickup, millisecondsPerHour, existingClients, whereClause, SSN, clientRecord, nameLast, dateOfBirth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function createTransportNotes() {
  automaticTransportNotes = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) ? 'Adult ' : 'Minor ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')) ? [' (',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')),') '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) + String(', ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) + String('lbs. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSuicideOrSelfHarmRiskToday')) == true ? 'SI/SH. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasHistoryOfViolence')) == true ? 'History of Violence. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientAggressiveOrViolentToday')) == true ? 'Aggressive or Violent Today. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isElopementRisk')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientElopementRiskToday')) == true ? 'Elopement Risk. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasSpecialPrecautionsOrMedicalNeeds')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSpecialNeedsOrPrecautionsToday')) == true ? ['Client has special precautions or medical needs: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) + String(' - ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) + String('"  ') : ''].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCourtOrdered')) ? 'Court Ordered Transport.  ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')) ? ['PU Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')) ? ['PU Confirmation #: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')) ? ['Destination Appt At: ',((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')))).toString()),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')) ? ['Destination Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isWarmHandOffNeeded')) == true ? 'Warm Hand Off Needed.' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19Positive')) == true ? 'Client is COVID19 Positive. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')) ? ['Other Client Notes: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')),'"'].join('') : ''].join('');
  return automaticTransportNotes
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function findExistingClients() {
  clientRecord = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'));
  existingClients = [];
  if (clientRecord) {
    SSN = (getObjectProperty(clientRecord, 'SSN'));
    dateOfBirth = (getObjectProperty(clientRecord, 'datestringDateOfBirth'));
    nameLast = (getObjectProperty(clientRecord, 'nameLast'));
    whereClause = (await (async function(dateOfBirth, nameLast, objectId, SSN) {
    	const conditions = [];

    	if (SSN && SSN !== '999999999') {
    	  conditions.push(`SSN = '${ SSN }'`);
    	}

    	if (dateOfBirth && nameLast) {
    	  conditions.push(`(datestringDateOfBirth = '${ dateOfBirth }' AND nameLast = '${ nameLast.replace(/'/g, "''") }')`);
    	}


    	let whereClause = conditions.length > 0 ? conditions.join(' OR ') : '';

    	if (whereClause) {
    	  whereClause = `(${ whereClause }) AND `;
    	}

    	whereClause += `objectId != '${ objectId }'`;

    	return whereClause;

    })(dateOfBirth, nameLast, (getObjectProperty(clientRecord, 'objectId')), SSN));
    console.log(whereClause);
    existingClients = (await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setPageSize(100)));
    console.log('ExistingClients');
    console.log(existingClients);
    if (existingClients.length > 0) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))['existingClients'] = existingClients;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    } else {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    }
  }
}


  console.log('Start On Submit Event for formValidateAndDispatch');
  console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
  ___arguments.context.pageData['transportRecord'] = ({ [`notesTransport`]: await createTransportNotes() });
  await findExistingClients();
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) == false) {
    console.log('Form submit mergeClientsReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit mergeClientsReady value false condition was triggered.  mergeClientsReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    return ;
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  console.log('Just after opening modalDispatchTransport in form submit.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) == false) {
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
    return ;
  }
  try {
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFirst')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameLast')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionNumber'))].join(''),[`isDispatched`]: true,[`dispatchedBy`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName')) }));
    console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    console.log(getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName'));
    await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).');
    console.log(error);
    // This is asynch so that the RT command doesn't have to wait
    // on the email send. The RT command has to be at the end due
    // to the intermittent error seen for non-authenticated users.
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001a) An error occurred during the dispatch process.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001a) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001a.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001a.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001a).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    console.log('Calling getRouteId with the following Information:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart'));
    samsaraRouteId = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) })), 'routeId'));
    console.log(samsaraRouteId);

  } catch (error) {
    console.log('Method getRouteId resulted in an error:');
    console.log(error);
    samsaraRouteId = null;

  }
  console.log('Starting to create the Transport record...');
  try {
    millisecondsPerHour = 3600000;
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')) == null) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['datetimeRequestedPickup'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission'));
    }
    durationSubmissionToScheduledPickup = (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour;
    // This assigns the values that define the transport record
    // or that need to be calculated in Codeless and that aren't
    // established in the modal popup or later through an API call.
    Object.assign((getObjectProperty(___arguments.context.pageData, 'transportRecord')), ({ [`datetimeDispatch`]: (new Date()),[`relDispatcher1_Employee`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.editorEmployeeObjectId')),[`durationSubmissionToScheduledPickup`]: durationSubmissionToScheduledPickup,[`durationRequestedTransportToScheduledPickup`]: (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')).valueOf())) / millisecondsPerHour,[`durationSubmissionToDispatch`]: (((new Date()).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour,[`isLongETA`]: durationSubmissionToScheduledPickup > 3,[`samsaraRouteId`]: samsaraRouteId,[`typeStatus`]: samsaraRouteId ? 'Dispatched' : null,[`billingEntityName`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_EntityRequestingTransport.requesterEntityName')),[`datetimeSubmission_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')),[`transportCode_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')) }));
    console.log('Saving the Transport record and it\'s relations to the DB');
    newTransport = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = newTransport;

      _uow.create('Transport', (getObjectProperty(___arguments.context.pageData, 'transportRecord'))).setOpResultId('createTransport');
      console.log('createTransport Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'rel_TransportRequest', [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))]).setOpResultId('relateTransportToTransportRequest');
      console.log('relateTransportToTransportRequest Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDispatcher1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee'))]).setOpResultId('relateTransportToDispatcher1');
      console.log('relateTransportToDispatcher1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDriver1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'))]).setOpResultId('relateTransportToDriver1');
      console.log('relateTransportToDriver1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relVehicle1_Vehicle', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle'))]).setOpResultId('relateTransportToVehicle1');
      console.log('relateTransportToVehicle1 Completed');

    })();

    console.log((await newTransport.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    transportRecordObjectId = (getObjectProperty(((newTransport.getOpResultById('createTransport')).getResult()), 'objectId'));
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', transportRecordObjectId);

    } catch (error) {
      console.log('Error encountered in the RT Channel Command after completion of the Transport Transaction.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of the Transport Transaction.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).');
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001b) An error occurred during the dispatch process. (e001b)', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001b) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001b error.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001b error.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001b).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('Error encountered in the RT Channel Command after completion of all other dispatch processes.');
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of all other dispatch processes.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

  }
  // Blink the data grid block in order to force a re-query,
  // which will in turn hide the recently dispatched record.
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('03e1b3340c8c321818aeed148cf13308');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));

  },
  /* handler:onSubmit */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_b26ba78feceb903690c215dd3b5a4627']('.bl-form', 'novalidate', true);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_9339eea9fc6cd4337ba30a3da3c59d69']('.bl-form', 'novalidate');
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/transport-requests(2)/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to return
  // all records. It is here so that an error won't occur
  // when we pair this query string with the test data flag.
  ___arguments.context.pageData['strWhereClauseBase'] = 'submissionNumber != \'\'';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = false;
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = false;
  ___arguments.context.pageData['transportRequesterOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause('').setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'requesterEntityName')),[`id`]: (getObjectProperty(item, 'requesterId')) });})));
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['currentEditorInfo'] = (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab'](null));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setSortBy('vehicleName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus=\'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')),[`samsaraDriverId`]: (getObjectProperty(item, 'samsaraDriverId')) });})));
  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  ___arguments.context.pageData['typeInsuranceList'] = (await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setSortBy('typeInsurance').setPageSize(100).setDistinct(true))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'typeInsurance')),[`label`]: (getObjectProperty(item, 'typeInsurance')) });})));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/transport-requests(2)/components/61a2dbca36c2a1c4c3e90bc66884e70d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var matchedRequester, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  // If there is a selection in the selectRequestForm,
  // then find the item in transportRequesterOptions that
  // matches the selection. Otherwise, create a blank object.
  if (getObjectProperty(___arguments.context.pageData, 'manualRequestForm')) {
    matchedRequester = (await asyncListFind((getObjectProperty(___arguments.context.pageData, 'transportRequesterOptions')), async (item) => {
       if ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.pageData, 'manualRequestForm'))) {
        console.log('Match Found in If Statement.  Returning:  ');
        console.log(item);
        return item;
      }


     return ;
    }));
  } else {
    matchedRequester = ({  });
  }
  // General Submissions has a "null" ID.  Check for this, if it's null then leave requester out.  If it's not, then make a requester ID and append it to the URL.  Same is true if nothing is selected in the drop down and manualRequestForm is empty.
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ((getObjectProperty(matchedRequester, 'id')) ? ({ [`requesterId`]: (getObjectProperty(matchedRequester, 'id')) }) : null));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/798ae65f7a5c716c91b159a9fb871a51/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Data Model for Client Info RUC');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord'));

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/d7a7974b30f168dcdeec7d77b0224b74/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'driverOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relDriver1_Employee'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['samsaraDriverId'] = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'driverOptions')), async (item) => {
     if ((getObjectProperty(item, 'value')) == ___arguments.value) {
      return item;
    }


   return ;
  })), 'samsaraDriverId'));
  console.log('Driver objectId and samsaraDriverId selected:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'));
  console.log('Full transportRecordReusableData at time of Selection:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests(2)/components/b2b30c2ba1897d0377e47dbaf0ed5a09/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vehicleOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relVehicle1_Vehicle'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests(2)/components/641efe0ed8775c4bb75880db2d67e3e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b9a7b642136d2dc472510391d36b61d1');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/cdbf241e6dd778235203fa7c7be289bf/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/4d1e20aa6af3ad57a1c9830180eb952b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/c641e4df2187580bc22281aec10f30de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been
  // voided or already dispatched or is read only.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/e6d1ddba6d572196bbe314d2a7dfd02d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been voided or already dispatched.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/531427c425c186d9710f7c2e205ea7e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = false;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  console.log('On Click Event of Cancel button in modalDispatchTransport.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'finalDispatchReady'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/8d1ba8a68826d30c4e0bd759d24e0973/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/a23c7906b1c25649f56dff288e438d11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('03e1b3340c8c321818aeed148cf13308');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/6aafb61d42cb9872ae777823391ff04a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/7f1913299f7463f4ff5d0517eebdcfdb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/2c8f6c12129b3164aa7c7031326e8774/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', ({ [`strWhereClauseBase`]: ['&& rel_TransportRequest.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\''].join('') }));
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// This button only makes sense to show if the record has been dispatched.

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/d9594a32d6c5d23c1382b6998baef31c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  }
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/0c757ba64a75ec64a5c6cde4b0ccd4a2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['submissionOtherInformation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests(2)/components/a199ac635af14cb3e08dcd92469903e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests(2)/components/9de76a5a0ff5fd5d72cfe67da6067954/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['notesTransport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRecord.notesTransport'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/a2d650eca1d6503c9121ca913c4c7045/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-requests(2)/components/8f1bef3521655b340ea3405cb7f72754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  console.log('Printing data containers after close:');
  console.log(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'));
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.layoutData);
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/131e3b99f5866c255e6df08e6aab9f41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/7169de853e2f49f261a78b784938060f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/dd9f6fdc6541ad623fafe6d10422b8f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // If someone saves and closes then reset the 'isInformationVerified'
  // so that they always have to attest to that before dispatch
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isInformationVerified'] = false;
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving changes to the record.');
    console.log(error);

  }
  (function (message) { alert(message) })('Changes have been saved!');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// We show the save changes button anytime the record is not in read only mode.

  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/92916f6859815d21ebccc33ba547a5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'30\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/a3d1808a775455748ad8706c5c9fed92/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/2fc510ebd655f892523b7bf476ab8a6b/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) : []).map(async item => {  label = ['Client Name: ',(getObjectProperty(item, 'nameFull')),', ','DoB: ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(item, 'dateOfBirth')))))),', ','SSN: ',(await (async function(SSN) {
  	if (!SSN || typeof SSN !== 'string') {
  	    return 'N/A'
  	}

  	if (!/^\d{9}$/.test(SSN)) {
  	  return SSN;
  	}

  	return `${SSN.slice(0, 3)}-${SSN.slice(3, 5)}-${SSN.slice(5, 9)}`;
  })((getObjectProperty(item, 'SSN')))),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','Object ID: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['selectedExistingClient'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests(2)/components/e6f4346a48f98663175a2f04d3970a94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['No matching Client was found in our records. This Transport Request will continue to use the new Client record created for client ',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.dateOfBirth')))))),'.'].join(''));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/2371be049f256a4bda2fbc6a45e12a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-requests(2)/components/e0cd4d5ad60949056c2b8265fc369f8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/7c8af31888b5d78a223db642a1571502/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, result, mergeClientTx, j, transportRequestsToUpdate, retainCertainClientInfo, pageSize, offset, transportRequest, transportRequests, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = true;
  try {
    transportRequestsToUpdate = [];
    count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join('')))));
    offset = 0;
    pageSize = 100;
    while (offset < count) {
      transportRequests = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
      for (var transportRequest_index in transportRequests) {
        transportRequest = transportRequests[transportRequest_index];
        addItemToList(transportRequestsToUpdate, transportRequest);
      }
      offset = offset + pageSize;
    }
    transportRequestsToUpdate = (await (async function(arr) {
    	const seen = new Set()


    	return arr.filter(item => {
    	  const isDuplicate = seen.has(item.objectId)

    	  seen.add(item.objectId)

    	  return !isDuplicate
    	})

    })(transportRequestsToUpdate));
    console.log('%c>> 🔒 ' + 'TransportRequestsToUpdate:', 'color: #f06292', JSON.parse(JSON.stringify(transportRequestsToUpdate)));

  } catch (error) {
    console.log('%c>> 🔒 ' + 'Error:', 'color: #ef5350', JSON.parse(JSON.stringify(error)));
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    return ;

  }
  console.log('%c>> 🔒 ' + 'selectedExistingClient', 'color: #4caf50', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))));
  try {
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #3f51b5', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    mergeClientTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    // This flag is used to determine whether the update operation
    // for selectedExistingClient needs to be added to the
    // transaction in order to preserve SSN or insurance information.
    retainCertainClientInfo = false;
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.SSN')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'))) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['SSN'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'));
      retainCertainClientInfo = true;
    }
    if (retainCertainClientInfo) {
      await ( async () => {
        const _uow = mergeClientTx;

        _uow.update('Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('UpdateClient: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.objectId'))));

      })();

    }
    if (transportRequestsToUpdate.length > 0) {
      for (var j_index in transportRequestsToUpdate) {
        j = transportRequestsToUpdate[j_index];
        await ( async () => {
          const _uow = mergeClientTx;

          _uow.setRelation('TransportRequest', j, 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(j, 'objectId'))));

        })();

      }
    }
    await ( async () => {
      const _uow = mergeClientTx;

      _uow.setRelation('TransportRequest', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')), 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))));
      _uow.delete('Client', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'))).setOpResultId((String('ClientObjectDelete: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId'))));

    })();

    result = (await mergeClientTx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));
    console.log(result);
    if (getObjectProperty(result, 'success')) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['clientRecord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['rel_Client'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
    }
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #f06292', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    await (getChannelInstance('default')).send((String('reload-table-records:') + String('TransportRequest')), ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['This Transport Request is now matched to existing client ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.dateOfBirth')))))),'.'].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  } catch (error) {
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/af16da7891b50db1a92c72c3cb02852a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/752113b5eb5a9ee55c96c7dcad88256b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/613926da2f8c51cf8e42ba2f953ed245/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/3d05686703fb302b56bc4968f8332998/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['isDriversLastRoute'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests(2)/components/7d0cc286017a265580b90576fa296c83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/cd416fb140f955bf17c52d7d4c9f7d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests(2)/components/33ef3456b45c06195036af6564a7ffd2/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, clientPasteDate, transportRequestPasteData, SpecialNeedsOrConcernsNotes, startNumber, listFromPaste, heightIn, heightFt, dateOfBirth, destinationLocationName, totalHeight, specialPrecautionso_MedicalConcerns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('No', 'g')), ''));
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('Yes', 'g')), 'TRUE'));
    listFromPaste = (getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).split(':');
    console.log('Value of #1 item on list');
    console.log(listFromPaste[0].trim());
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log(startNumber);
    console.log(listFromPaste[((startNumber + 32) - 1)]);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 32) - 1)].trim()) + String(':');
    console.log(SpecialNeedsOrConcernsNotes);
    specialPrecautionso_MedicalConcerns = subsequenceFirstFromEnd(listFromPaste[((startNumber + 29) - 1)], 19).trim();
    SpecialNeedsOrConcernsNotes = String(SpecialNeedsOrConcernsNotes) + String(String('  Special Precautions or Medical Concerns: ') + String(specialPrecautionso_MedicalConcerns));
    console.log('Special Precautions Notes');
    console.log(SpecialNeedsOrConcernsNotes);
    if ((specialPrecautionso_MedicalConcerns.indexOf('Suicide/Self Harm') !== -1) || (specialPrecautionso_MedicalConcerns.indexOf('Self-Harm Risk') !== -1)) {
      console.log('Suicide/Self Harm');
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Elopement Risk') !== -1) {
      console.log('Elopement Risk');
      ___arguments.context.dataModel['isElopementRisk'] = true;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isElopementRisk'] = false;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Disorganized Behavior') !== -1) {
      console.log('Disorganized Behavior');
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
    } else {
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Fall Risk') !== -1) {
      console.log('Fall Risk');
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
    }
    destinationLocationName = String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 23) - 1)], 20).trim()) + String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 24) - 1)], 28).trim());
    dateOfBirth = (new Date((new Date((subsequenceFirstFromEnd(listFromPaste[((startNumber + 9) - 1)], 10).trim()))).getTime() + ((19 * 3600) * 1000)));
    totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim();
    console.log('total height');
    console.log(totalHeight);
    if (totalHeight.indexOf('\'') !== -1) {
      totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim().split('\'');
      heightFt = totalHeight[0].trim();
      heightIn = totalHeight[1].trim().charAt(0);
    } else {
      heightFt = totalHeight;
      heightIn = 0;
    }
    console.log('listFromPaste');
    console.log(listFromPaste);
    transportRequestPasteData = ({ [`isContactedYMCR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 7) - 1)], 38).trim() == 'TRUE' ? true : false,[`isMCTR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 8) - 1)], 10).trim() == 'TRUE' ? true : false,[`isCOVID19Positive`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 14) - 1)], 24).trim() == 'TRUE' ? true : false,[`referringEntityName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 18) - 1)], 17).trim(),[`referringContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 19) - 1)], 30).trim(),[`referringContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 20) - 1)], 15).trim()).replace((new RegExp('-', 'g')), '')),[`pickupAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 21) - 1)], 66).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`isReferralToNearestUrcOrCc`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 22) - 1)], 14).trim() == 'TRUE' ? true : false,[`destinationLocationName`]: destinationLocationName,[`destinationAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 25) - 1)], 28).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`destinationContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 26) - 1)], 32).trim(),[`destinationContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 27) - 1)], 23).trim()).replace((new RegExp('-', 'g')), '')),[`isClientAggressiveOrViolentToday`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 31) - 1)], 22).trim() == 'TRUE' ? true : false,[`isClientElopementRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientElopementRiskToday')),[`isClientSuicideOrSelfHarmRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientSuicideOrSelfHarmRiskToday')),[`isClientFallRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientFallRiskToday')),[`stateSubmissionNumber`]: (getObjectProperty(___arguments.context.dataModel, 'stateSubmissionNumber')) });
    clientPasteDate = ({ [`nameFirst`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 5) - 1)], 19).trim(),[`is18`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 6) - 1)], 48).trim(),[`dateOfBirth`]: dateOfBirth,[`age`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 10) - 1)], 13).trim(),[`assignedSexAtBirth`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 11) - 1)], 13).trim(),[`heightFt`]: heightFt,[`heightIn`]: heightIn,[`weight`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 13) - 1)], 22).trim(),[`emergencyContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 15) - 1)], 31).trim(),[`emergencyContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 16) - 1)], 41).trim()).replace((new RegExp('-', 'g')), '')),[`hasHistoryOfViolence`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 30) - 1)], 28).trim() == 'TRUE' ? true : false,[`otherNotes`]: SpecialNeedsOrConcernsNotes,[`isElopementRisk`]: (getObjectProperty(___arguments.context.dataModel, 'isElopementRisk')),[`hasDisorganizedBehavior`]: (getObjectProperty(___arguments.context.dataModel, 'hasDisorganizedBehavior')) });
    console.log('Transport Request Data');
    console.log(transportRequestPasteData);
    console.log('Client Record Data');
    console.log(clientPasteDate);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ({ [`transportRequestRecord`]: transportRequestPasteData,[`clientRecord`]: clientPasteDate,[`requesterId`]: 'STATE' }));

  } catch (error) {
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An error occurred during the copy/paste of a submission record into the app.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the copy/paste of a submission record into the app.' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/copy-paste-errors', error, 'An error occurred during the copy/paste of a submission record into the app.', 'Form paste-state-submission Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));

    })();
    (function (message) { alert(message) })('We\'re sorry, there was an error when you attempted to copy/paste the record.  Please refresh your browser tab and try to copy/paste again.  Please be sure to paste from just before "RideCARE Submission Submission Date:" until the very end of the email after the "Special Needs/Concerns" section.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transport-requests(2)/components/a781341ea971861568c9bd1b125a5683/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['State Submission #',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')),(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.usedEmailParser')) ? ' automatically parsed from email.' : ''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/c5aeecbb7a7b29a5d767bc4a68e9c5a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['State Submission #',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')),(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.usedEmailParser')) ? ' automatically parsed from email.' : ''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/96375d9c8e896078c906901591a7205d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var endValid, startValid, SpecialNeedsOrConcernsNotes, firstListValue, error, startNumber, listFromPaste;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', false);
  try {
    listFromPaste = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33ef3456b45c06195036af6564a7ffd2'), 'textTransportPaste')).split(':');
    console.log('List From Paste');
    console.log(listFromPaste);
    firstListValue = listFromPaste[0].trim();
    console.log('Value of #1 item on list');
    console.log(firstListValue);
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log('Start Number = ');
    console.log(startNumber);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 31) - 1)].trim()) + String(':');
    console.log('Special Needs Or Concerns');
    console.log(SpecialNeedsOrConcernsNotes);

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', true);
    return ;

  }
  if ((firstListValue.indexOf('Name') !== -1) == true || (firstListValue.indexOf('Date') !== -1) == true) {
    startValid = true;
  } else {
    startValid = false;
  }
  if ((SpecialNeedsOrConcernsNotes.indexOf('Needs') !== -1) == true) {
    endValid = true;
  } else {
    endValid = false;
  }
  if (startValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', true);
    return ;
  } else if (endValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', true);
    return ;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests(2)/components/9476118d4077f7a10cb49bcb3cf3ca06/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = true;
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests(2)/components/f91e5188b16edf7dcaffed3466ff3187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Transport Requests',[`pageName`]: 'transport-requests' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'showAllRecords')) == true)) {
    // Deprecated 12/16/24 since On Before Page Load sets showAllRecords to false.
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},

    	{
    	  "field": "isEOD",
    	  "headerName": "Crisis?",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 40,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "headerTooltip": "Date & Time when the transport request was received via ORC app form.",
    	  "type": "datetimeColumn",
    	  "cellRendererParams": {
    	    "dayjsFormat": "MM/DD/YYYY HH:mm",
    	    "withSeconds": false
    	  },
    	  "width": 155,
    	  "sortable": true,
    	  "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false,
    	  "wrapHeaderText": true,
    	  "autoHeaderHeight": true,
    	  "meta": { "align": "center" }
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "minWidth": 200,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "minWidth": 200,
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},

    	{
    	  "field": "isEOD",
    	  "headerName": "Crisis?",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 40,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  "editable": false
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, newTransportRequestRecord, submissionInfo, waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for use as both input forms and viewers.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'validateAndDispatchRecord') {
    console.log('Printing data containers after close:');
    console.log(___arguments['recordItem']);
    console.log(___arguments.context.pageData);
    console.log(___arguments.context.layoutData);
    console.log(___arguments.context.appData);
    // Don't allow editing in the UI window if the record has already been dispatched, if the record is voided, or if another user is already editing it.
    // This was disabled when we made it so that transport requests could be edited after dispatch.  It can be removed at a later date.
    ___arguments.context.pageData['transportRequestRecordReusableData'] = ({ [`transportRequestRecord`]: ___arguments['recordItem'],[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`pickupFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relPickup_Facility')),[`destinationFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relDestination_Facility')),[`requesterRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_EntityRequestingTransport')),[`selectExistingClientData`]: ({  }),[`isReadOnlyMode`]: false || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId')))) ? true : false });
    // This makes sure that the requester ID is present on page
    // Data here like it is on the Transport Request Form Page.
    ___arguments.context.pageData['requesterId'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterId'));
    console.log('Action Icon Click Event - PageData.requesterId:');
    console.log(getObjectProperty(___arguments.context.pageData, 'requesterId'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    // Only trigger the 'editing' command interval if the record is not read only.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == false) {
      try {

        ;(function() {
          const callback = async () => {
              await (getChannelInstance('default')).send('editing-table:TransportRequest', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

          };

          const timerId = 'transportRequestsVerifyAndDispatch';
          const timerDelay = 1000;

          runSetTimeout(timerId, callback, timerDelay)
        })()

      } catch (error) {
        console.log('An error was seen in the RT Channel Command for isReadOnlyMode');
        console.log(error);

      }
    }
  } else if (___arguments['eventName'] == 'voidRecord') {
    console.log(___arguments['recordItem']);
    // Don't allow voiding the record if it's in isReadOnlyMode
    // (i.e. if someone else is editing, if it's already
    // been dispatched, or if it's already been voided)
    if (((getObjectProperty(___arguments['recordItem'], 'isDispatched')) || (getObjectProperty(___arguments['recordItem'], 'isVoided')) || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId'))))) == true) {
      (function (message) { alert(message) })('This record is currently being edited by another user, or it has already been dispatched or voided.  It cannot be voided at this time.');
    } else {
      ___arguments['recordItem']['isVoided'] = true;
      // This is how we can save just a single property into
      // the database without updating the entire record.
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`isVoided`]: (getObjectProperty(___arguments['recordItem'], 'isVoided')),[`dispatchedBy`]: (getObjectProperty(___arguments.context.appData, 'currentUser.name')) }) );
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments['recordItem'], 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after voiding the record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    }
  } else if (___arguments['eventName'] == 'duplicateRecord') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a2d650eca1d6503c9121ca913c4c7045');
    console.log('!!!RECORD');
    console.log(___arguments['recordItem']);
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Duplicate operation timed out after 20s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a809fd2715c4f0babc542a2e8da9e97e');
      console.log('record1');
      console.log(___arguments['recordItem']);
      submissionInfo = ['THIS RECORD WAS DUPLICATED FROM TRANSPORT REQUEST #',(getObjectProperty(___arguments['recordItem'], 'submissionNumber')),'.'].join('');
      newTransportRequestRecord = (Object.assign(({  }), ___arguments['recordItem']));
      delete newTransportRequestRecord['objectId'];
      delete newTransportRequestRecord['created'];
      delete newTransportRequestRecord['updated'];
      delete newTransportRequestRecord['submissionNumber'];
      newTransportRequestRecord['submissionOtherInformation'] = submissionInfo;
      newTransportRequestRecord['isDispatched'] = false;
      newTransportRequestRecord['isVoided'] = false;
      newTransportRequestRecord['dispatchedBy'] = null;
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty((await Backendless.Data.of('TransportRequest').deepSave( newTransportRequestRecord )), 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after duplicating a transport request record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await new Promise(r => setTimeout(r, 200 || 0));
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
      // This wait is here to make sure that the relations data
      // arrives into the data grid before the waiting spinner closes.
      await new Promise(r => setTimeout(r, 1200 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a809fd2715c4f0babc542a2e8da9e97e');
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'delete') {
    await BackendlessUI.Functions.Custom['fn_58f43615b3a18b74c5b8d439a61e9b2d'](___arguments.context.pageData, 'TransportRequest', ___arguments['recordItem'], (await (async function() {
    	//"___arguments" is a specific property Backendless uses and in this case it contains the object for the modal itself.

    	return ___arguments
    })()));
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:editorInfoLogic */
  ['editorInfoLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo'))

  },
  /* handler:editorInfoLogic */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/ff57ab8eb9b2e5bf2f5ff0d6e6df5fcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var errors, durationRequestedTripLeadTime, error, millisecondsPerHour, timeToValidate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function validateTruncatedFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationLocationName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * This function will check various fields of the form and
 * make sure that input is valid. If it is not, it will throw
 * and error and prevent the remainder of the submission.
 */
async function validateFullFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.dateOfBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['dateOfBirth'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactPhone'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.SSN'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['SSN'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['assignedSexAtBirth'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.typeInsurance'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['typeInsurance'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightFt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightFt'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightIn'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightIn'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['weight'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeAffiliations'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['tribeAffiliations'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeMemberZipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['clientRecord.tribeMemberZipcode'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['email'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emailAlt'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientMedicallyClearedForTransportToday')) != true) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9b47fd8cdd2f04219a2f7997f9e7586')));
    errors['isClientMedicallyClearedForTransportToday'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['typeCustodyExchange'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['pickupConfirmationNumber'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.detentionCenterPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['detentionCenterPhone'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.isCourtOrdered')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.nameCourtOrSystemOrJudge'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['nameCourtOrSystemOrJudge'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19TestRequired')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationAcceptingProviderName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85042b9acde90c9937b6240f234825ac')));
    errors['destinationAcceptingProviderName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * Describe this function...
 */
async function validateTripTime(timeToValidate) {
  millisecondsPerHour = 3600000;
  if (timeToValidate == null) {
    console.log('Trip Time was NULL but was required.');
    return false;
  }
  try {
    durationRequestedTripLeadTime = ((timeToValidate.valueOf()) - ((new Date()).valueOf())) / millisecondsPerHour;
    console.log('validatePickupTime Function');
    console.log(durationRequestedTripLeadTime);
    console.log(durationRequestedTripLeadTime > 4);

  } catch (error) {
    console.log('Try/Catch Block in the validatePickupTime Function');
    console.log(error);

  }
  return durationRequestedTripLeadTime > 4
}


  console.log(___arguments.context.pageData);
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) != true) {
    (function (message) { alert(message) })('You must check the box indicating you have verified all information before saving changes or dispatching transport.');
    return ;
  } else if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) {
    // first check whether it's a truncated submission. If so, skip validation
    // since we haven't built that yet. If not, then run normal validation.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) == true) {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateTruncatedFormSubmission() == true) {
        console.log('Truncated form submissions were validated.');
      } else {
        console.log('Else Block in Truncated Form Submission validation');
        return ;
      }
    } else {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateFullFormSubmission() == true) {
        console.log('Full form submissions were validated.');
      } else {
        console.log('Else Block in Full Form Submission validation');
        return ;
      }
    }
    console.log('ElseIf in On Click Event of the Dispatch button occurred.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('73b93b24382d41b884a9e1223fd5ceba');
    return ;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllRecords'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'2\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/8dad9c1d07152be824327a0a917b9be8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  // If someone saves and closes then reset the 'isInformationVerified'
  // so that they always have to attest to that before dispatch
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isInformationVerified'] = false;
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving edits to the record.');
    console.log(error);

  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/f8ebf058e8eb6ec9ce9672bd6caa3c0d/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified'))

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = ___arguments.value;
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/73b93b24382d41b884a9e1223fd5ceba/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var automaticTransportNotes, error, transportRecordObjectId, newTransport, samsaraRouteId, durationSubmissionToScheduledPickup, millisecondsPerHour, existingClients, whereClause, SSN, clientRecord, nameLast, dateOfBirth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function createTransportNotes() {
  automaticTransportNotes = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) ? 'Adult ' : 'Minor ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')) ? [' (',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')),') '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) + String(', ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) + String('lbs. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSuicideOrSelfHarmRiskToday')) == true ? 'SI/SH. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasHistoryOfViolence')) == true ? 'History of Violence. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientAggressiveOrViolentToday')) == true ? 'Aggressive or Violent Today. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isElopementRisk')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientElopementRiskToday')) == true ? 'Elopement Risk. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasSpecialPrecautionsOrMedicalNeeds')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSpecialNeedsOrPrecautionsToday')) == true ? ['Client has special precautions or medical needs: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) + String(' - ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) + String('"  ') : ''].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCourtOrdered')) ? 'Court Ordered Transport.  ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')) ? ['PU Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')) ? ['PU Confirmation #: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')) ? ['Destination Appt At: ',((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')))).toString()),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')) ? ['Destination Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isWarmHandOffNeeded')) == true ? 'Warm Hand Off Needed.' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19Positive')) == true ? 'Client is COVID19 Positive. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')) ? ['Other Client Notes: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')),'"'].join('') : ''].join('');
  return automaticTransportNotes
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function findExistingClients() {
  clientRecord = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'));
  existingClients = [];
  if (clientRecord) {
    SSN = (getObjectProperty(clientRecord, 'SSN'));
    dateOfBirth = (getObjectProperty(clientRecord, 'datestringDateOfBirth'));
    nameLast = (getObjectProperty(clientRecord, 'nameLast'));
    whereClause = (await (async function(dateOfBirth, nameLast, objectId, SSN) {
    	const conditions = [];

    	if (SSN && SSN !== '999999999') {
    	  conditions.push(`SSN = '${ SSN }'`);
    	}

    	if (dateOfBirth && nameLast) {
    	  conditions.push(`(datestringDateOfBirth = '${ dateOfBirth }' AND nameLast = '${ nameLast.replace(/'/g, "''") }')`);
    	}


    	let whereClause = conditions.length > 0 ? conditions.join(' OR ') : '';

    	if (whereClause) {
    	  whereClause = `(${ whereClause }) AND `;
    	}

    	whereClause += `objectId != '${ objectId }'`;

    	return whereClause;

    })(dateOfBirth, nameLast, (getObjectProperty(clientRecord, 'objectId')), SSN));
    console.log(whereClause);
    existingClients = (await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setPageSize(100)));
    console.log('ExistingClients');
    console.log(existingClients);
    if (existingClients.length > 0) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))['existingClients'] = existingClients;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    } else {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    }
  }
}


  console.log('Start On Submit Event for formValidateAndDispatch');
  ___arguments.context.pageData['transportRecord'] = ({ [`notesTransport`]: await createTransportNotes() });
  await findExistingClients();
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) == false) {
    console.log('Form submit mergeClientsReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit mergeClientsReady value false condition was triggered.  mergeClientsReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    return ;
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  console.log('Just after opening modalDispatchTransport in form submit.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) == false) {
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
    return ;
  }
  try {
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFirst')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameLast')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionNumber'))].join(''),[`isDispatched`]: true,[`dispatchedBy`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName')) }));
    console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    console.log(getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName'));
    await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).');
    console.log(error);
    // This is asynch so that the RT command doesn't have to wait
    // on the email send. The RT command has to be at the end due
    // to the intermittent error seen for non-authenticated users.
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001a) An error occurred during the dispatch process.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001a) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001a.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001a.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001a).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    console.log('Calling getRouteId with the following Information:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart'));
    samsaraRouteId = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) })), 'routeId'));
    console.log(samsaraRouteId);

  } catch (error) {
    console.log('Method getRouteId resulted in an error:');
    console.log(error);
    samsaraRouteId = null;

  }
  console.log('Starting to create the Transport record...');
  try {
    millisecondsPerHour = 3600000;
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')) == null) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['datetimeRequestedPickup'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission'));
    }
    durationSubmissionToScheduledPickup = (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour;
    // This assigns the values that define the transport record
    // or that need to be calculated in Codeless and that aren't
    // established in the modal popup or later through an API call.
    Object.assign((getObjectProperty(___arguments.context.pageData, 'transportRecord')), ({ [`datetimeDispatch`]: (new Date()),[`relDispatcher1_Employee`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.editorEmployeeObjectId')),[`durationSubmissionToScheduledPickup`]: durationSubmissionToScheduledPickup,[`durationRequestedTransportToScheduledPickup`]: (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')).valueOf())) / millisecondsPerHour,[`durationSubmissionToDispatch`]: (((new Date()).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour,[`isLongETA`]: durationSubmissionToScheduledPickup > 3,[`samsaraRouteId`]: samsaraRouteId,[`typeStatus`]: samsaraRouteId ? 'Dispatched' : null,[`billingEntityName`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_EntityRequestingTransport.requesterEntityName')),[`datetimeSubmission_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')),[`transportCode_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')) }));
    console.log('Saving the Transport record and it\'s relations to the DB');
    newTransport = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = newTransport;

      _uow.create('Transport', (getObjectProperty(___arguments.context.pageData, 'transportRecord'))).setOpResultId('createTransport');
      console.log('createTransport Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'rel_TransportRequest', [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))]).setOpResultId('relateTransportToTransportRequest');
      console.log('relateTransportToTransportRequest Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDispatcher1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee'))]).setOpResultId('relateTransportToDispatcher1');
      console.log('relateTransportToDispatcher1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDriver1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'))]).setOpResultId('relateTransportToDriver1');
      console.log('relateTransportToDriver1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relVehicle1_Vehicle', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle'))]).setOpResultId('relateTransportToVehicle1');
      console.log('relateTransportToVehicle1 Completed');

    })();

    console.log((await newTransport.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    transportRecordObjectId = (getObjectProperty(((newTransport.getOpResultById('createTransport')).getResult()), 'objectId'));
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', transportRecordObjectId);

    } catch (error) {
      console.log('Error encountered in the RT Channel Command after completion of the Transport Transaction.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of the Transport Transaction.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).');
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001b) An error occurred during the dispatch process. (e001b)', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001b) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001b error.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001b error.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001b).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('Error encountered in the RT Channel Command after completion of all other dispatch processes.');
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of all other dispatch processes.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

  }
  // Blink the data grid block in order to force a re-query,
  // which will in turn hide the recently dispatched record.
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('03e1b3340c8c321818aeed148cf13308');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));

  },
  /* handler:onSubmit */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_b26ba78feceb903690c215dd3b5a4627']('.bl-form', 'novalidate', true);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_9339eea9fc6cd4337ba30a3da3c59d69']('.bl-form', 'novalidate');
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to return
  // all records. It is here so that an error won't occur
  // when we pair this query string with the test data flag.
  ___arguments.context.pageData['strWhereClauseBase'] = 'submissionNumber != \'\'';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = false;
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = false;
  ___arguments.context.pageData['transportRequesterOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause('').setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'requesterEntityName')),[`id`]: (getObjectProperty(item, 'requesterId')) });})));
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['currentEditorInfo'] = (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab'](null));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setSortBy('vehicleName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus=\'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')),[`samsaraDriverId`]: (getObjectProperty(item, 'samsaraDriverId')) });})));
  console.log(___arguments.context.pageData);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/61a2dbca36c2a1c4c3e90bc66884e70d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var matchedRequester, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  // If there is a selection in the selectRequestForm,
  // then find the item in transportRequesterOptions that
  // matches the selection. Otherwise, create a blank object.
  if (getObjectProperty(___arguments.context.pageData, 'manualRequestForm')) {
    matchedRequester = (await asyncListFind((getObjectProperty(___arguments.context.pageData, 'transportRequesterOptions')), async (item) => {
       if ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.pageData, 'manualRequestForm'))) {
        console.log('Match Found in If Statement.  Returning:  ');
        console.log(item);
        return item;
      }


     return ;
    }));
  } else {
    matchedRequester = ({  });
  }
  // General Submissions has a "null" ID.  Check for this, if it's null then leave requester out.  If it's not, then make a requester ID and append it to the URL.  Same is true if nothing is selected in the drop down and manualRequestForm is empty.
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ((getObjectProperty(matchedRequester, 'id')) ? ({ [`requesterId`]: (getObjectProperty(matchedRequester, 'id')) }) : null));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/798ae65f7a5c716c91b159a9fb871a51/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Data Model for Client Info RUC');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord'));

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/d7a7974b30f168dcdeec7d77b0224b74/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'driverOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relDriver1_Employee'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['samsaraDriverId'] = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'driverOptions')), async (item) => {
     if ((getObjectProperty(item, 'value')) == ___arguments.value) {
      return item;
    }


   return ;
  })), 'samsaraDriverId'));
  console.log('Driver objectId and samsaraDriverId selected:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'));
  console.log('Full transportRecordReusableData at time of Selection:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/b2b30c2ba1897d0377e47dbaf0ed5a09/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vehicleOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relVehicle1_Vehicle'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/641efe0ed8775c4bb75880db2d67e3e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b9a7b642136d2dc472510391d36b61d1');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/cdbf241e6dd778235203fa7c7be289bf/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/4d1e20aa6af3ad57a1c9830180eb952b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/c641e4df2187580bc22281aec10f30de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been
  // voided or already dispatched or is read only.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/e6d1ddba6d572196bbe314d2a7dfd02d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been voided or already dispatched.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/531427c425c186d9710f7c2e205ea7e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = false;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  console.log('On Click Event of Cancel button in modalDispatchTransport.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'finalDispatchReady'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/8d1ba8a68826d30c4e0bd759d24e0973/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/a23c7906b1c25649f56dff288e438d11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('03e1b3340c8c321818aeed148cf13308');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/6aafb61d42cb9872ae777823391ff04a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/7f1913299f7463f4ff5d0517eebdcfdb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/2c8f6c12129b3164aa7c7031326e8774/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', ({ [`strWhereClauseBase`]: ['&& rel_TransportRequest.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\''].join('') }));
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// This button only makes sense to show if the record has been dispatched.

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/d9594a32d6c5d23c1382b6998baef31c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/0c757ba64a75ec64a5c6cde4b0ccd4a2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['submissionOtherInformation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/a199ac635af14cb3e08dcd92469903e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/9de76a5a0ff5fd5d72cfe67da6067954/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['notesTransport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRecord.notesTransport'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/a2d650eca1d6503c9121ca913c4c7045/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/8f1bef3521655b340ea3405cb7f72754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  console.log('Printing data containers after close:');
  console.log(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'));
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.layoutData);
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/131e3b99f5866c255e6df08e6aab9f41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/7169de853e2f49f261a78b784938060f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/dd9f6fdc6541ad623fafe6d10422b8f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // If someone saves and closes then reset the 'isInformationVerified'
  // so that they always have to attest to that before dispatch
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isInformationVerified'] = false;
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving changes to the record.');
    console.log(error);

  }
  (function (message) { alert(message) })('Changes have been saved!');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// We show the save changes button anytime the record is not in read only mode.

  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/92916f6859815d21ebccc33ba547a5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'30\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/a3d1808a775455748ad8706c5c9fed92/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/2fc510ebd655f892523b7bf476ab8a6b/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) : []).map(async item => {  label = ['Client Name: ',(getObjectProperty(item, 'nameFull')),', ','DoB: ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(item, 'dateOfBirth')))))),', ','SSN: ',(await (async function(SSN) {
  	if (!SSN || typeof SSN !== 'string') {
  	    return 'N/A'
  	}

  	if (!/^\d{9}$/.test(SSN)) {
  	  return SSN;
  	}

  	return `${SSN.slice(0, 3)}-${SSN.slice(3, 5)}-${SSN.slice(5, 9)}`;
  })((getObjectProperty(item, 'SSN')))),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','Object ID: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['selectedExistingClient'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/e6f4346a48f98663175a2f04d3970a94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['No matching Client was found in our records. This Transport Request will continue to use the new Client record created for client ',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.dateOfBirth')))))),'.'].join(''));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/2371be049f256a4bda2fbc6a45e12a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });
  console.log('%c>> ' + 'close', 'color: #ab47bc', undefined);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/e0cd4d5ad60949056c2b8265fc369f8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/7c8af31888b5d78a223db642a1571502/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var count, error, j, mergeClientTx, offset, pageSize, result, retainCertainClientInfo, transportRequest, transportRequests, transportRequestsToUpdate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = true;
  try {
    transportRequestsToUpdate = [];
    count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join('')))));
    offset = 0;
    pageSize = 100;
    while (offset < count) {
      transportRequests = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
      for (var transportRequest_index in transportRequests) {
        transportRequest = transportRequests[transportRequest_index];
        addItemToList(transportRequestsToUpdate, transportRequest);
      }
      offset = offset + pageSize;
    }
    transportRequestsToUpdate = (await (async function(arr) {
    	const seen = new Set()


    	return arr.filter(item => {
    	  const isDuplicate = seen.has(item.objectId)

    	  seen.add(item.objectId)

    	  return !isDuplicate
    	})

    })(transportRequestsToUpdate));
    console.log('%c>> 🔒 ' + 'TransportRequestsToUpdate:', 'color: #f06292', JSON.parse(JSON.stringify(transportRequestsToUpdate)));

  } catch (error) {
    console.log('%c>> 🔒 ' + 'Error:', 'color: #ef5350', JSON.parse(JSON.stringify(error)));
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    return ;

  }
  console.log('%c>> 🔒 ' + 'selectedExistingClient', 'color: #4caf50', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))));
  try {
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #3f51b5', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    mergeClientTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    // This flag is used to determine whether the update operation
    // for selectedExistingClient needs to be added to the
    // transaction in order to preserve SSN or insurance information.
    retainCertainClientInfo = false;
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.SSN')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'))) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['SSN'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'));
      retainCertainClientInfo = true;
    }
    // Check if any of Primary typeInsurance, insuranceProvider, or insurancePolicyNumber are present in the newer record but not in the older record.  If so, copy the three as a set from the new record to the existing one.
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.typeInsurance')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.typeInsurance')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.insuranceProvider')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.insuranceProvider')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.insurancePolicyNumber')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.insurancePolicyNumber'))) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['typeInsurance'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.typeInsurance'));
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['insuranceProvider'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.insuranceProvider'));
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['insurancePolicyNumber'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.insurancePolicyNumber'));
      retainCertainClientInfo = true;
    }
    if (retainCertainClientInfo) {
      await ( async () => {
        const _uow = mergeClientTx;

        _uow.update('Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('UpdateClient: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.objectId'))));

      })();

    }
    if (transportRequestsToUpdate.length > 0) {
      for (var j_index in transportRequestsToUpdate) {
        j = transportRequestsToUpdate[j_index];
        await ( async () => {
          const _uow = mergeClientTx;

          _uow.setRelation('TransportRequest', j, 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(j, 'objectId'))));

        })();

      }
    }
    await ( async () => {
      const _uow = mergeClientTx;

      _uow.setRelation('TransportRequest', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')), 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))));
      _uow.delete('Client', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'))).setOpResultId((String('ClientObjectDelete: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId'))));

    })();

    result = (await mergeClientTx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));
    console.log(result);
    if (getObjectProperty(result, 'success')) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['clientRecord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['rel_Client'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
    }
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #f06292', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    await (getChannelInstance('default')).send((String('reload-table-records:') + String('TransportRequest')), ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['This Transport Request is now matched to existing client ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.dateOfBirth')))))),'.'].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  } catch (error) {
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/af16da7891b50db1a92c72c3cb02852a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/752113b5eb5a9ee55c96c7dcad88256b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/613926da2f8c51cf8e42ba2f953ed245/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/3d05686703fb302b56bc4968f8332998/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['isDriversLastRoute'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/7d0cc286017a265580b90576fa296c83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/cd416fb140f955bf17c52d7d4c9f7d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/33ef3456b45c06195036af6564a7ffd2/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, clientPasteDate, transportRequestPasteData, SpecialNeedsOrConcernsNotes, startNumber, listFromPaste, heightIn, heightFt, dateOfBirth, destinationLocationName, totalHeight, specialPrecautionso_MedicalConcerns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('No', 'g')), ''));
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('Yes', 'g')), 'TRUE'));
    listFromPaste = (getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).split(':');
    console.log('Value of #1 item on list');
    console.log(listFromPaste[0].trim());
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log(startNumber);
    console.log(listFromPaste[((startNumber + 32) - 1)]);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 32) - 1)].trim()) + String(':');
    console.log(SpecialNeedsOrConcernsNotes);
    specialPrecautionso_MedicalConcerns = subsequenceFirstFromEnd(listFromPaste[((startNumber + 29) - 1)], 19).trim();
    SpecialNeedsOrConcernsNotes = String(SpecialNeedsOrConcernsNotes) + String(String('  Special Precautions or Medical Concerns: ') + String(specialPrecautionso_MedicalConcerns));
    console.log('Special Precautions Notes');
    console.log(SpecialNeedsOrConcernsNotes);
    if ((specialPrecautionso_MedicalConcerns.indexOf('Suicide/Self Harm') !== -1) || (specialPrecautionso_MedicalConcerns.indexOf('Self-Harm Risk') !== -1)) {
      console.log('Suicide/Self Harm');
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Elopement Risk') !== -1) {
      console.log('Elopement Risk');
      ___arguments.context.dataModel['isElopementRisk'] = true;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isElopementRisk'] = false;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Disorganized Behavior') !== -1) {
      console.log('Disorganized Behavior');
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
    } else {
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Fall Risk') !== -1) {
      console.log('Fall Risk');
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
    }
    destinationLocationName = String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 23) - 1)], 20).trim()) + String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 24) - 1)], 28).trim());
    dateOfBirth = (new Date((new Date((subsequenceFirstFromEnd(listFromPaste[((startNumber + 9) - 1)], 10).trim()))).getTime() + ((19 * 3600) * 1000)));
    totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim();
    console.log('total height');
    console.log(totalHeight);
    if (totalHeight.indexOf('\'') !== -1) {
      totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim().split('\'');
      heightFt = totalHeight[0].trim();
      heightIn = totalHeight[1].trim().charAt(0);
    } else {
      heightFt = totalHeight;
      heightIn = 0;
    }
    console.log('listFromPaste');
    console.log(listFromPaste);
    transportRequestPasteData = ({ [`isContactedYMCR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 7) - 1)], 38).trim() == 'TRUE' ? true : false,[`isMCTR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 8) - 1)], 10).trim() == 'TRUE' ? true : false,[`isCOVID19Positive`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 14) - 1)], 24).trim() == 'TRUE' ? true : false,[`referringEntityName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 18) - 1)], 17).trim(),[`referringContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 19) - 1)], 30).trim(),[`referringContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 20) - 1)], 15).trim()).replace((new RegExp('-', 'g')), '')),[`pickupAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 21) - 1)], 66).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`isReferralToNearestUrcOrCc`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 22) - 1)], 14).trim() == 'TRUE' ? true : false,[`destinationLocationName`]: destinationLocationName,[`destinationAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 25) - 1)], 28).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`destinationContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 26) - 1)], 32).trim(),[`destinationContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 27) - 1)], 23).trim()).replace((new RegExp('-', 'g')), '')),[`isClientAggressiveOrViolentToday`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 31) - 1)], 22).trim() == 'TRUE' ? true : false,[`isClientElopementRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientElopementRiskToday')),[`isClientSuicideOrSelfHarmRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientSuicideOrSelfHarmRiskToday')),[`isClientFallRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientFallRiskToday')),[`stateSubmissionNumber`]: (getObjectProperty(___arguments.context.dataModel, 'stateSubmissionNumber')) });
    clientPasteDate = ({ [`nameFirst`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 5) - 1)], 19).trim(),[`is18`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 6) - 1)], 48).trim(),[`dateOfBirth`]: dateOfBirth,[`age`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 10) - 1)], 13).trim(),[`assignedSexAtBirth`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 11) - 1)], 13).trim(),[`heightFt`]: heightFt,[`heightIn`]: heightIn,[`weight`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 13) - 1)], 22).trim(),[`emergencyContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 15) - 1)], 31).trim(),[`emergencyContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 16) - 1)], 41).trim()).replace((new RegExp('-', 'g')), '')),[`hasHistoryOfViolence`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 30) - 1)], 28).trim() == 'TRUE' ? true : false,[`otherNotes`]: SpecialNeedsOrConcernsNotes,[`isElopementRisk`]: (getObjectProperty(___arguments.context.dataModel, 'isElopementRisk')),[`hasDisorganizedBehavior`]: (getObjectProperty(___arguments.context.dataModel, 'hasDisorganizedBehavior')) });
    console.log('Transport Request Data');
    console.log(transportRequestPasteData);
    console.log('Client Record Data');
    console.log(clientPasteDate);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ({ [`transportRequestRecord`]: transportRequestPasteData,[`clientRecord`]: clientPasteDate,[`requesterId`]: 'STATE' }));

  } catch (error) {
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An error occurred during the copy/paste of a submission record into the app.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the copy/paste of a submission record into the app.' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/copy-paste-errors', error, 'An error occurred during the copy/paste of a submission record into the app.', 'Form paste-state-submission Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));

    })();
    (function (message) { alert(message) })('We\'re sorry, there was an error when you attempted to copy/paste the record.  Please refresh your browser tab and try to copy/paste again.  Please be sure to paste from just before "RideCARE Submission Submission Date:" until the very end of the email after the "Special Needs/Concerns" section.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/a781341ea971861568c9bd1b125a5683/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('State Submission #: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/c5aeecbb7a7b29a5d767bc4a68e9c5a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('State Submission #: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests-bkup241221/components/96375d9c8e896078c906901591a7205d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var endValid, startValid, SpecialNeedsOrConcernsNotes, firstListValue, error, startNumber, listFromPaste;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', false);
  try {
    listFromPaste = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33ef3456b45c06195036af6564a7ffd2'), 'textTransportPaste')).split(':');
    console.log('List From Paste');
    console.log(listFromPaste);
    firstListValue = listFromPaste[0].trim();
    console.log('Value of #1 item on list');
    console.log(firstListValue);
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log('Start Number = ');
    console.log(startNumber);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 31) - 1)].trim()) + String(':');
    console.log('Special Needs Or Concerns');
    console.log(SpecialNeedsOrConcernsNotes);

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', true);
    return ;

  }
  if ((firstListValue.indexOf('Name') !== -1) == true || (firstListValue.indexOf('Date') !== -1) == true) {
    startValid = true;
  } else {
    startValid = false;
  }
  if ((SpecialNeedsOrConcernsNotes.indexOf('Needs') !== -1) == true) {
    endValid = true;
  } else {
    endValid = false;
  }
  if (startValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', true);
    return ;
  } else if (endValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', true);
    return ;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests250124/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Transport Requests',[`pageName`]: 'transport-requests' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/transport-requests250124/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'showAllRecords')) == true)) {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},
    	{
    	  "field": "isInformationVerified",
    	  "headerName": "",
    	  "headerTooltip": "Ready for Dispatch?",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxCheckmarkCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false,
    	  "filtering": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},
    	{
    	  "field": "isEOD",
    	  "headerName": "",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.stateCode",
    	  "headerName": "State",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "headerTooltip": "Date & Time when the transport request was received via ORC app form.",
    	  "type": "datetimeColumn",
    	  "cellRendererParams": {
    	    "dayjsFormat": "MM/DD/YYYY HH:mm",
    	    "withSeconds": false
    	  },
    	  "width": 155,
    	  "sortable": true,
    	  "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false,
    	  "wrapHeaderText": true,
    	  "autoHeaderHeight": true,
    	  "meta": { "align": "center" }
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "minWidth": 200,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "minWidth": 200,
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  } else {
    return (await (async function(appData, pageData, ns) {
    	return [
    	 {
    	  "field": "actions",
    	  "headerName": "",
    	  "type": "actions",
    	  "width": 75,
    	  "minWidth": 75,
    	  "pinned": "left",
    	  meta: { align: "center" },
    	  "editable": false
    	},

    	{
    	  "field": "isInformationVerified",
    	  "headerName": "",
    	  "headerTooltip": "Ready for Dispatch",
    	  "minWidth": 40,
    	  "maxWidth": 75,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxCheckmarkCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "isEOD",
    	  "headerName": "",
    	  "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
    	  "minWidth": 20,
    	  "maxWidth": 55,
    	  "pinned": "left",
    	  "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
    	  meta: { align: "center" },
    	  "editable": false
    	 // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

    	},

    	{
    	  "field": "submissionNumber",
    	  "headerName": "Sub #",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  "pinned": "left",
    	  "sort": "asc",
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "rel_Client.nameFull",
    	  "headerName": "Client Name",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.requesterEntityName",
    	  "headerName": "Requester",
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "rel_EntityRequestingTransport.stateCode",
    	  "headerName": "State",
    	  "minWidth": 45,
    	  "maxWidth": 75,
    	  "sortable": false,
    	  "editable": false,
    	},

    	{
    	  "field": "datetimeSubmission",
    	  "headerName": "Submission Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  "editable": false
    	},

    	{
    	  "field": "datetimeRequestedPickup",
    	  "headerName": "Pickup Time",
    	  "sortable": true,
    	  "type": "datetimeColumn",
    	  "cellRendererParams": { "dayjsFormat": "MM/DD/YYYY HH:mm:ss", "withSeconds": true },
    	  // "editable": (params) => params.data.isDispatched == false
    	  "editable": false
    	},

    	{
    	  "field": "relPickup_Facility.formattedLocation",
    	  "headerName": "Pickup From...",
    	  "sortable": true,
    	  "width": 400,
    	  "editable": false
    	},

    	{
    	  "field": "relDestination_Facility.formattedLocation",
    	  "headerName": "Transport To...",
    	  "width": 400,
    	  "sortable": true,
    	  "editable": false
    	},

    	{
    	  "field": "dispatchedBy",
    	  "headerName": "Dispatched By",
    	  "headerTooltip": "Employee who dispatched or voided the transport request.",
    	  "sortable": true,
    	  "editable": "FALSE",
    	  "maxWidth": 120,
    	  "editable": false
    	},

    	{
    	  "field": "isDispatched",
    	  "headerName": "Dispatched?",
    	  "headerTooltip": "Dispatched?",
    	  "maxWidth": 120,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  "editable": false

    	},

    	{
    	  "field": "isVoided",
    	  "headerName": "Voided?",
    	  "maxWidth": 100,
    	  "minWidth": 40,
    	  meta: { align: "center" },
    	  "sortable": false,
    	  //"cellClass": "calculatedField",
    	  //"editable": (params) => params.data.isDispatched == false,
    	  "cellRenderer": ns.checkboxVoidCellRenderer,
    	  "editable": false
    	}

    	]
    })(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())));
  }

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, newTransportRequestRecord, submissionInfo, waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for use as both input forms and viewers.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'validateAndDispatchRecord') {
    console.log('Printing data containers at start of event validateAndDispatchRecord:');
    console.log(___arguments['recordItem']);
    console.log(___arguments.context.pageData);
    console.log(___arguments.context.layoutData);
    console.log(___arguments.context.appData);
    // Don't allow editing in the UI window if the record has already been dispatched, if the record is voided, or if another user is already editing it.
    // This was disabled when we made it so that transport requests could be edited after dispatch.  It can be removed at a later date.
    ___arguments.context.pageData['transportRequestRecordReusableData'] = ({ [`transportRequestRecord`]: ___arguments['recordItem'],[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`typeInsuranceList`]: (getObjectProperty(___arguments.context.pageData, 'typeInsuranceList')),[`pickupFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relPickup_Facility')),[`destinationFacilityRecord`]: (getObjectProperty(___arguments['recordItem'], 'relDestination_Facility')),[`requesterRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_EntityRequestingTransport')),[`selectExistingClientData`]: ({  }),[`isReadOnlyMode`]: false || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId')))) ? true : false });
    // This makes sure that the requester ID is present on page
    // Data here like it is on the Transport Request Form Page.
    ___arguments.context.pageData['requesterId'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterId'));
    console.log('Action Icon Click Event - PageData.requesterId:');
    console.log(getObjectProperty(___arguments.context.pageData, 'requesterId'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    // Only trigger the 'editing' command interval if the record is not read only.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == false) {
      try {

        ;(function() {
          const callback = async () => {
              await (getChannelInstance('default')).send('editing-table:TransportRequest', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

          };

          const timerId = 'transportRequestsVerifyAndDispatch';
          const timerDelay = 1000;

          runSetTimeout(timerId, callback, timerDelay)
        })()

      } catch (error) {
        console.log('An error was seen in the RT Channel Command for isReadOnlyMode');
        console.log(error);

      }
    }
  } else if (___arguments['eventName'] == 'voidRecord') {
    console.log(___arguments['recordItem']);
    // Don't allow voiding the record if it's in isReadOnlyMode
    // (i.e. if someone else is editing, if it's already
    // been dispatched, or if it's already been voided)
    if (((getObjectProperty(___arguments['recordItem'], 'isDispatched')) || (getObjectProperty(___arguments['recordItem'], 'isVoided')) || ((Object.keys((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getEditingItems() })('5ace80b8ec397e9c5c0b03221b61217d')))).includes((getObjectProperty(___arguments['recordItem'], 'objectId'))))) == true) {
      (function (message) { alert(message) })('This record is currently being edited by another user, or it has already been dispatched or voided.  It cannot be voided at this time.');
    } else {
      ___arguments['recordItem']['isVoided'] = true;
      // This is how we can save just a single property into
      // the database without updating the entire record.
      await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`isVoided`]: (getObjectProperty(___arguments['recordItem'], 'isVoided')),[`dispatchedBy`]: (getObjectProperty(___arguments.context.appData, 'currentUser.name')) }) );
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments['recordItem'], 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after voiding the record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    }
  } else if (___arguments['eventName'] == 'duplicateRecord') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a2d650eca1d6503c9121ca913c4c7045');
    console.log('!!!RECORD');
    console.log(___arguments['recordItem']);
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Duplicate operation timed out after 20s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a809fd2715c4f0babc542a2e8da9e97e');
      console.log('record1');
      console.log(___arguments['recordItem']);
      submissionInfo = ['THIS RECORD WAS DUPLICATED FROM TRANSPORT REQUEST #',(getObjectProperty(___arguments['recordItem'], 'submissionNumber')),'.'].join('');
      newTransportRequestRecord = (Object.assign(({  }), ___arguments['recordItem']));
      delete newTransportRequestRecord['objectId'];
      delete newTransportRequestRecord['created'];
      delete newTransportRequestRecord['updated'];
      delete newTransportRequestRecord['submissionNumber'];
      newTransportRequestRecord['submissionOtherInformation'] = submissionInfo;
      newTransportRequestRecord['isDispatched'] = false;
      newTransportRequestRecord['isVoided'] = false;
      newTransportRequestRecord['dispatchedBy'] = null;
      try {
        await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty((await Backendless.Data.of('TransportRequest').deepSave( newTransportRequestRecord )), 'objectId'))] }));

      } catch (error) {
        console.log('An error was seen in the RT Channel Command after duplicating a transport request record.');
        console.log(error);

      }
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      await new Promise(r => setTimeout(r, 200 || 0));
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
      // This wait is here to make sure that the relations data
      // arrives into the data grid before the waiting spinner closes.
      await new Promise(r => setTimeout(r, 1200 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a809fd2715c4f0babc542a2e8da9e97e');
    } else if ((getObjectProperty(___arguments.context.pageData, 'duplicateRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a2d650eca1d6503c9121ca913c4c7045');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['duplicateRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'delete') {
    await BackendlessUI.Functions.Custom['fn_58f43615b3a18b74c5b8d439a61e9b2d'](___arguments.context.pageData, 'TransportRequest', ___arguments['recordItem'], (await (async function() {
    	//"___arguments" is a specific property Backendless uses and in this case it contains the object for the modal itself.

    	return ___arguments
    })()));
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')) + String(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier')));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  relationsDepth: 1
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:editorInfoLogic */
  ['editorInfoLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo'))

  },
  /* handler:editorInfoLogic */
  /* content */
}))

define('./pages/transport-requests250124/components/ff57ab8eb9b2e5bf2f5ff0d6e6df5fcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var errors, durationRequestedTripLeadTime, error, millisecondsPerHour, timeToValidate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function validateTruncatedFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationLocationName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['destinationLocationName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * This function will check various fields of the form and
 * make sure that input is valid. If it is not, it will throw
 * and error and prevent the remainder of the submission.
 */
async function validateFullFormSubmission() {
  errors = ({  });
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.dateOfBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['dateOfBirth'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactName'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emergencyContactPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emergencyContactPhone'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameFirst'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameFirst'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.nameLast'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['nameLast'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.SSN'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['SSN'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['assignedSexAtBirth'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightFt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightFt'] = ['inputError'];
  }
  if (!(await (async function(value) {
  	return value != null && value !== '';
  })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.heightIn'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['heightIn'] = ['inputError'];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['weight'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeAffiliations'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['tribeAffiliations'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isFedRecognizedTribal')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.tribeMemberZipcode'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['clientRecord.tribeMemberZipcode'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.email'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['email'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt')) && !((new RegExp('^[\\w\\.-]+@[a-zA-Z\\d\\.-]+\\.[a-zA-Z]{2,}$', '')).test((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.emailAlt'))))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ca7fae5b9421000b26ca87a708b2f489')));
    errors['emailAlt'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientMedicallyClearedForTransportToday')) != true) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9b47fd8cdd2f04219a2f7997f9e7586')));
    errors['isClientMedicallyClearedForTransportToday'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'pickupFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacPickupLocation'] = ['inputError'];
  }
  // State form submissions that come through the parser will have googleName starting with TEMP.
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.city')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.stateCode')) || !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.zipcode')) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'destinationFacilityRecord.googleName')).startsWith('TEMP'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('713edecb76d304968b723d777617d9ec')));
    errors['gacDestinationLocation'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['typeCustodyExchange'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['pickupConfirmationNumber'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isTransportFromJailOrDetentionCenter')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.detentionCenterPhone'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['detentionCenterPhone'] = ['inputError'];
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.isCourtOrdered')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'), 'transportRequestRecord.nameCourtOrSystemOrJudge'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c54fcdb7378cb9783018ae723b2cba5')));
    errors['nameCourtOrSystemOrJudge'] = ['inputError'];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19TestRequired')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationAcceptingProviderName'))) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85042b9acde90c9937b6240f234825ac')));
    errors['destinationAcceptingProviderName'] = ['inputError'];
  }
  if ((Object.keys(errors)).length == 0) {
    return true;
  } else {
    console.log('Errors:');
    console.log(errors);
    // Replace commas with new lines
    // Remove brackets and quotes
    (function (message) { alert(message) })((['Please correct errors in the following fields: ','\n',(((JSON.stringify((Object.keys(errors)))).replace((new RegExp('[\\[\\]"]', 'g')), '')).replace((new RegExp(',\\s?', 'g')), '\n'))].join('')));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['errors'] = errors;
  }
}

/**
 * Describe this function...
 */
async function validateTripTime(timeToValidate) {
  millisecondsPerHour = 3600000;
  if (timeToValidate == null) {
    console.log('Trip Time was NULL but was required.');
    return false;
  }
  try {
    durationRequestedTripLeadTime = ((timeToValidate.valueOf()) - ((new Date()).valueOf())) / millisecondsPerHour;
    console.log('validatePickupTime Function');
    console.log(durationRequestedTripLeadTime);
    console.log(durationRequestedTripLeadTime > 4);

  } catch (error) {
    console.log('Try/Catch Block in the validatePickupTime Function');
    console.log(error);

  }
  return durationRequestedTripLeadTime > 4
}


  console.log(___arguments.context.pageData);
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) != true) {
    (function (message) { alert(message) })('You must check the box indicating you have verified all information before saving changes or dispatching transport.');
    return ;
  } else if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isInformationVerified')) {
    // first check whether it's a truncated submission. If so, skip validation
    // since we haven't built that yet. If not, then run normal validation.
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) == true) {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateTruncatedFormSubmission() == true) {
        console.log('Truncated form submissions were validated.');
      } else {
        console.log('Else Block in Truncated Form Submission validation');
        return ;
      }
    } else {
      // Validate form submissions. Log to console and
      // proceed if the validation checks out. Close the
      // modal and stop execution if validation is failed.
      if (await validateFullFormSubmission() == true) {
        console.log('Full form submissions were validated.');
      } else {
        console.log('Else Block in Full Form Submission validation');
        return ;
      }
    }
    console.log('ElseIf in On Click Event of the Dispatch button occurred.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('73b93b24382d41b884a9e1223fd5ceba');
    return ;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after cancel button click.');
    console.log(error);

  }
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  console.log('Page Data Cancel Button: ');
  console.log(___arguments.context.pageData);
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllRecords'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'2\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/8dad9c1d07152be824327a0a917b9be8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving edits to the record.');
    console.log(error);

  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  return ;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/73b93b24382d41b884a9e1223fd5ceba/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var automaticTransportNotes, error, transportRecordObjectId, newTransport, samsaraRouteId, durationSubmissionToScheduledPickup, millisecondsPerHour, existingClients, whereClause, SSN, clientRecord, nameLast, dateOfBirth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function createTransportNotes() {
  automaticTransportNotes = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.is18')) ? 'Adult ' : 'Minor ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.assignedSexAtBirth')) : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')) ? [' (',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.age')),') '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.height')) + String(', ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.weight')) + String('lbs. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSuicideOrSelfHarmRiskToday')) == true ? 'SI/SH. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasHistoryOfViolence')) == true ? 'History of Violence. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientAggressiveOrViolentToday')) == true ? 'Aggressive or Violent Today. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.isElopementRisk')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientElopementRiskToday')) == true ? 'Elopement Risk. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.hasSpecialPrecautionsOrMedicalNeeds')) == true || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isClientSpecialNeedsOrPrecautionsToday')) == true ? ['Client has special precautions or medical needs: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.specialPrecautionsOrMedicalNeeds')) + String(' - ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.notesClientSpecialNeedsOrPrecautionsToday')) + String('"  ') : ''].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCourtOrdered')) ? 'Court Ordered Transport.  ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')) ? ['PU Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')) ? ['PU Confirmation #: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.pickupConfirmationNumber')),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.typeCustodyExchange')) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')) ? ['Destination Appt At: ',((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.datetimeDestinationAppointment')))).toString()),'. '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')) ? ['Destination Contact: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactName')),' '].join('') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone')) ? String((await BackendlessUI.Functions.Custom['fn_454c6bd355d3e44aa4bcfde8e1611028']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.destinationContactPhone'))))) + String('. ') : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isWarmHandOffNeeded')) == true ? 'Warm Hand Off Needed.' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isCOVID19Positive')) == true ? 'Client is COVID19 Positive. ' : '',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')) ? ['Other Client Notes: "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'clientRecord.otherNotes')),'"'].join('') : ''].join('');
  return automaticTransportNotes
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function findExistingClients() {
  clientRecord = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'));
  existingClients = [];
  if (clientRecord) {
    SSN = (getObjectProperty(clientRecord, 'SSN'));
    dateOfBirth = (getObjectProperty(clientRecord, 'datestringDateOfBirth'));
    nameLast = (getObjectProperty(clientRecord, 'nameLast'));
    whereClause = (await (async function(dateOfBirth, nameLast, objectId, SSN) {
    	const conditions = [];

    	if (SSN && SSN !== '999999999') {
    	  conditions.push(`SSN = '${ SSN }'`);
    	}

    	if (dateOfBirth && nameLast) {
    	  conditions.push(`(datestringDateOfBirth = '${ dateOfBirth }' AND nameLast = '${ nameLast.replace(/'/g, "''") }')`);
    	}


    	let whereClause = conditions.length > 0 ? conditions.join(' OR ') : '';

    	if (whereClause) {
    	  whereClause = `(${ whereClause }) AND `;
    	}

    	whereClause += `objectId != '${ objectId }'`;

    	return whereClause;

    })(dateOfBirth, nameLast, (getObjectProperty(clientRecord, 'objectId')), SSN));
    console.log(whereClause);
    existingClients = (await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setPageSize(100)));
    console.log('ExistingClients');
    console.log(existingClients);
    if (existingClients.length > 0) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))['existingClients'] = existingClients;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    } else {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    }
  }
}


  console.log('Start On Submit Event for formValidateAndDispatch');
  console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
  ___arguments.context.pageData['transportRecord'] = ({ [`notesTransport`]: await createTransportNotes() });
  await findExistingClients();
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady')) == false) {
    console.log('Form submit mergeClientsReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit mergeClientsReady value false condition was triggered.  mergeClientsReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');
    return ;
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  console.log('Just after opening modalDispatchTransport in form submit.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
  // We wait until finalDispatchReady takes a value, then proceed.
  while (!((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) != null)) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  // If the user cancels in the modalDispatchTransport finalDispatchReady
  // will go to FALSE and then we clean things up just before returning.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady')) == false) {
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = null;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = null;
    console.log('Form submit finalDispatchReady value false condition was triggered.  finalDispatchReady value after cleanup:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.finalDispatchReady'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
    return ;
  }
  try {
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameFirst')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord.nameLast')).slice(0, 3),'.',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionNumber'))].join(''),[`isDispatched`]: true,[`dispatchedBy`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName')) }));
    console.log(JSON.parse((JSON.stringify(___arguments.context.pageData))));
    // The "name" field in the Users table is returned as "userName" by the getCurrentEditorInfo function.
    console.log(getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.userName'));
    await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).');
    console.log(error);
    // This is asynch so that the RT command doesn't have to wait
    // on the email send. The RT command has to be at the end due
    // to the intermittent error seen for non-authenticated users.
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001a) An error occurred during the dispatch process.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001a).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001a) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001a.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001a.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001a).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    console.log('Calling getRouteId with the following Information:');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude'));
    console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart'));
    samsaraRouteId = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) })), 'routeId'));
    console.log(samsaraRouteId);

  } catch (error) {
    console.log('Method getRouteId resulted in an error:');
    console.log(error);
    samsaraRouteId = null;

  }
  console.log('Starting to create the Transport record...');
  try {
    millisecondsPerHour = 3600000;
    if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')) == null) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['datetimeRequestedPickup'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission'));
    }
    durationSubmissionToScheduledPickup = (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour;
    // This assigns the values that define the transport record
    // or that need to be calculated in Codeless and that aren't
    // established in the modal popup or later through an API call.
    Object.assign((getObjectProperty(___arguments.context.pageData, 'transportRecord')), ({ [`datetimeDispatch`]: (new Date()),[`relDispatcher1_Employee`]: (getObjectProperty(___arguments.context.pageData, 'currentEditorInfo.editorEmployeeObjectId')),[`durationSubmissionToScheduledPickup`]: durationSubmissionToScheduledPickup,[`durationRequestedTransportToScheduledPickup`]: (((getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeRequestedPickup')).valueOf())) / millisecondsPerHour,[`durationSubmissionToDispatch`]: (((new Date()).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')).valueOf())) / millisecondsPerHour,[`isLongETA`]: durationSubmissionToScheduledPickup > 3,[`samsaraRouteId`]: samsaraRouteId,[`typeStatus`]: samsaraRouteId ? 'Dispatched' : null,[`billingEntityName`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_EntityRequestingTransport.requesterEntityName')),[`datetimeSubmission_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.datetimeSubmission')),[`transportCode_copy`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionCode')) }));
    console.log('Saving the Transport record and it\'s relations to the DB');
    newTransport = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = newTransport;

      _uow.create('Transport', (getObjectProperty(___arguments.context.pageData, 'transportRecord'))).setOpResultId('createTransport');
      console.log('createTransport Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'rel_TransportRequest', [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))]).setOpResultId('relateTransportToTransportRequest');
      console.log('relateTransportToTransportRequest Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDispatcher1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDispatcher1_Employee'))]).setOpResultId('relateTransportToDispatcher1');
      console.log('relateTransportToDispatcher1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relDriver1_Employee', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'))]).setOpResultId('relateTransportToDriver1');
      console.log('relateTransportToDriver1 Completed');
      _uow.setRelation('Transport', (newTransport.getOpResultById('createTransport')), 'relVehicle1_Vehicle', [(getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle'))]).setOpResultId('relateTransportToVehicle1');
      console.log('relateTransportToVehicle1 Completed');

    })();

    console.log((await newTransport.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    transportRecordObjectId = (getObjectProperty(((newTransport.getOpResultById('createTransport')).getResult()), 'objectId'));
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', transportRecordObjectId);

    } catch (error) {
      console.log('Error encountered in the RT Channel Command after completion of the Transport Transaction.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of the Transport Transaction.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }

  } catch (error) {
    console.log('An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).');
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('(e001b) An error occurred during the dispatch process. (e001b)', new Backendless.Bodyparts({ textmessage: 'An error occurred during the dispatch process.  Please try again.  If this error persists, please report a bug via the Feedback form and report error code (e001b).' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors', error, '(e001b) An error occurred during the dispatch process.', 'Form Validate And Dispatch Data Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));
      await new Promise(r => setTimeout(r, 10000 || 0));
      console.log(await Backendless.Messaging.getMessageStatus((getObjectProperty(___arguments.context.pageData, 'messageResponse.messageId'))));

    })();
    try {
      await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
      stopSetTimeout('transportRequestsVerifyAndDispatch');

    } catch (error) {
      console.log('Error encountered in the RT Channel Command during cleanup after e001b error.');
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command during cleanup after e001b error.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

    }
    // Make sure the record doesn't get marked as dispatched if there was an error.
    Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord')), ({ [`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }));
    await Backendless.Data.of('TransportRequest').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),[`submissionCode`]: null,[`isDispatched`]: false,[`dispatchedBy`]: null }) );
    (function (message) { alert(message) })('An error occurred in the Dispatch process.  Please try again.  If this error persists please submit a bug report in Feedback with error code (e001b).');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
    return ;

  }
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    stopSetTimeout('transportRequestsVerifyAndDispatch');

  } catch (error) {
    console.log('Error encountered in the RT Channel Command after completion of all other dispatch processes.');
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/dispatch-errors/RT-command-errors', error, 'Error encountered in the RT Channel Command after completion of all other dispatch processes.', 'Form Validate And Dispatch Data Container', ___arguments.context.dataModel, ___arguments.context.pageData, ___arguments.context.layoutData, ___arguments.context.appData, null, null, null, null, null, null);

  }
  // Blink the data grid block in order to force a re-query,
  // which will in turn hide the recently dispatched record.
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64b22f2e967708cd2f23f0118fe71b96', undefined);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b9a7b642136d2dc472510391d36b61d1');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('03e1b3340c8c321818aeed148cf13308');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));

  },
  /* handler:onSubmit */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    if (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isTruncatedSubmission')) {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_b26ba78feceb903690c215dd3b5a4627']('.bl-form', 'novalidate', true);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      await BackendlessUI.Functions.Custom['fn_9339eea9fc6cd4337ba30a3da3c59d69']('.bl-form', 'novalidate');
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/transport-requests250124/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to return
  // all records. It is here so that an error won't occur
  // when we pair this query string with the test data flag.
  ___arguments.context.pageData['strWhereClauseBase'] = 'submissionNumber != \'\'';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseBase'] = 'isDispatched = FALSE && isVoided = FALSE';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = false;
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = false;
  ___arguments.context.pageData['transportRequesterOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setWhereClause('').setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'requesterEntityName')),[`id`]: (getObjectProperty(item, 'requesterId')) });})));
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['currentEditorInfo'] = (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab'](null));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setSortBy('vehicleName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus=\'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')),[`samsaraDriverId`]: (getObjectProperty(item, 'samsaraDriverId')) });})));
  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  ___arguments.context.pageData['typeInsuranceList'] = (await Promise.all((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setSortBy('typeInsurance').setPageSize(100).setDistinct(true))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'typeInsurance')),[`label`]: (getObjectProperty(item, 'typeInsurance')) });})));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/transport-requests250124/components/61a2dbca36c2a1c4c3e90bc66884e70d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var matchedRequester, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  // If there is a selection in the selectRequestForm,
  // then find the item in transportRequesterOptions that
  // matches the selection. Otherwise, create a blank object.
  if (getObjectProperty(___arguments.context.pageData, 'manualRequestForm')) {
    matchedRequester = (await asyncListFind((getObjectProperty(___arguments.context.pageData, 'transportRequesterOptions')), async (item) => {
       if ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.pageData, 'manualRequestForm'))) {
        console.log('Match Found in If Statement.  Returning:  ');
        console.log(item);
        return item;
      }


     return ;
    }));
  } else {
    matchedRequester = ({  });
  }
  // General Submissions has a "null" ID.  Check for this, if it's null then leave requester out.  If it's not, then make a requester ID and append it to the URL.  Same is true if nothing is selected in the drop down and manualRequestForm is empty.
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ((getObjectProperty(matchedRequester, 'id')) ? ({ [`requesterId`]: (getObjectProperty(matchedRequester, 'id')) }) : null));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/798ae65f7a5c716c91b159a9fb871a51/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Data Model for Client Info RUC');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.clientRecord'));

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/d7a7974b30f168dcdeec7d77b0224b74/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'driverOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relDriver1_Employee'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['samsaraDriverId'] = (getObjectProperty((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'driverOptions')), async (item) => {
     if ((getObjectProperty(item, 'value')) == ___arguments.value) {
      return item;
    }


   return ;
  })), 'samsaraDriverId'));
  console.log('Driver objectId and samsaraDriverId selected:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.samsaraDriverId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee'));
  console.log('Full transportRecordReusableData at time of Selection:');
  console.log(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests250124/components/b2b30c2ba1897d0377e47dbaf0ed5a09/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vehicleOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['relVehicle1_Vehicle'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests250124/components/641efe0ed8775c4bb75880db2d67e3e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2c01c1b4a96838f2da19463ccb5a074a');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b9a7b642136d2dc472510391d36b61d1');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'transportRecord.relDriver1_Employee')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.relVehicle1_Vehicle')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledStart')) && (getObjectProperty(___arguments.context.pageData, 'transportRecord.datetimeScheduledPickup'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/cdbf241e6dd778235203fa7c7be289bf/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledPickup'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/4d1e20aa6af3ad57a1c9830180eb952b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledStart'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/c641e4df2187580bc22281aec10f30de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been
  // voided or already dispatched or is read only.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/e6d1ddba6d572196bbe314d2a7dfd02d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // Hide the panel with the
  // Dispatch button if the request has been voided or already dispatched.
  if ((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched')) == true || (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isVoided')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/531427c425c186d9710f7c2e205ea7e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['finalDispatchReady'] = false;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = null;
  console.log('On Click Event of Cancel button in modalDispatchTransport.  finalDispatchReady value:');
  console.log(getObjectProperty(___arguments.context.pageData, 'finalDispatchReady'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/8d1ba8a68826d30c4e0bd759d24e0973/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/a23c7906b1c25649f56dff288e438d11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('03e1b3340c8c321818aeed148cf13308');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/6aafb61d42cb9872ae777823391ff04a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/7f1913299f7463f4ff5d0517eebdcfdb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.requesterRecord.requesterEntityName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/2c8f6c12129b3164aa7c7031326e8774/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transports', ({ [`strWhereClauseBase`]: ['&& rel_TransportRequest.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\''].join('') }));
  stopSetTimeout('transportRequestsVerifyAndDispatch');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// This button only makes sense to show if the record has been dispatched.

  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.isDispatched'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/d9594a32d6c5d23c1382b6998baef31c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_Client.nameFirst != \'test\'';
  }
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/0c757ba64a75ec64a5c6cde4b0ccd4a2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['submissionOtherInformation'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests250124/components/a199ac635af14cb3e08dcd92469903e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (2629746000 * 1000)))

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (2629746000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['datetimeScheduledDropoff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests250124/components/9de76a5a0ff5fd5d72cfe67da6067954/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['notesTransport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRecord.notesTransport'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/a2d650eca1d6503c9121ca913c4c7045/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['duplicateRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-requests250124/components/8f1bef3521655b340ea3405cb7f72754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00b276c2b0c5baaa9282670dd683dc65')));
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')));
  if (getObjectProperty(___arguments.context.pageData, 'transportRecord')) {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.pageData, 'transportRecord')));
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', undefined);
  console.log('Printing data containers after close:');
  console.log(___arguments.context.getComponentDataStoreByUid('73b93b24382d41b884a9e1223fd5ceba'));
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.layoutData);
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/131e3b99f5866c255e6df08e6aab9f41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/7169de853e2f49f261a78b784938060f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/dd9f6fdc6541ad623fafe6d10422b8f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // If someone saves and closes then reset the 'isInformationVerified'
  // so that they always have to attest to that before dispatch
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['isInformationVerified'] = false;
  await Backendless.Data.of('TransportRequest').deepSave( (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')) );
  try {
    await (getChannelInstance('default')).send('reload-table-records:TransportRequest', ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));

  } catch (error) {
    console.log('An error was seen in the RT Channel Command after saving changes to the record.');
    console.log(error);

  }
  (function (message) { alert(message) })('Changes have been saved!');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


// We show the save changes button anytime the record is not in read only mode.

  return (!(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.isReadOnlyMode')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/92916f6859815d21ebccc33ba547a5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = 'datetimeSubmission >= DATESUB(NOW(), \'30\', \'DAY\')';
  // This is used to toggle some of the columns on
  // and off in addition to the change in query.
  ___arguments.context.pageData['showAllColumns'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/a3d1808a775455748ad8706c5c9fed92/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.selectExistingClientData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/2fc510ebd655f892523b7bf476ab8a6b/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'existingClients')) : []).map(async item => {  label = ['Client Name: ',(getObjectProperty(item, 'nameFull')),', ','DoB: ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(item, 'dateOfBirth')))))),', ','SSN: ',(await (async function(SSN) {
  	if (!SSN || typeof SSN !== 'string') {
  	    return 'N/A'
  	}

  	if (!/^\d{9}$/.test(SSN)) {
  	  return SSN;
  	}

  	return `${SSN.slice(0, 3)}-${SSN.slice(3, 5)}-${SSN.slice(5, 9)}`;
  })((getObjectProperty(item, 'SSN')))),', ','Created Date: ',((new Date((getObjectProperty(item, 'created')))).toLocaleString()),', ','Object ID: ',(getObjectProperty(item, 'objectId'))].join('');
; return ({ [`label`]: label,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['selectedExistingClient'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests250124/components/e6f4346a48f98663175a2f04d3970a94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['No matching Client was found in our records. This Transport Request will continue to use the new Client record created for client ',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.dateOfBirth')))))),'.'].join(''));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/2371be049f256a4bda2fbc6a45e12a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['selectExistingClientData'] = ({  });

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/transport-requests250124/components/e0cd4d5ad60949056c2b8265fc369f8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/7c8af31888b5d78a223db642a1571502/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, result, mergeClientTx, j, transportRequestsToUpdate, retainCertainClientInfo, pageSize, offset, transportRequest, transportRequests, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = true;
  try {
    transportRequestsToUpdate = [];
    count = (await Backendless.Data.of('TransportRequest').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join('')))));
    offset = 0;
    pageSize = 100;
    while (offset < count) {
      transportRequests = (await Backendless.Data.of('TransportRequest').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId')),'\'',' AND ','rel_Client.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(pageSize).setOffset(offset)));
      for (var transportRequest_index in transportRequests) {
        transportRequest = transportRequests[transportRequest_index];
        addItemToList(transportRequestsToUpdate, transportRequest);
      }
      offset = offset + pageSize;
    }
    transportRequestsToUpdate = (await (async function(arr) {
    	const seen = new Set()


    	return arr.filter(item => {
    	  const isDuplicate = seen.has(item.objectId)

    	  seen.add(item.objectId)

    	  return !isDuplicate
    	})

    })(transportRequestsToUpdate));
    console.log('%c>> 🔒 ' + 'TransportRequestsToUpdate:', 'color: #f06292', JSON.parse(JSON.stringify(transportRequestsToUpdate)));

  } catch (error) {
    console.log('%c>> 🔒 ' + 'Error:', 'color: #ef5350', JSON.parse(JSON.stringify(error)));
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    return ;

  }
  console.log('%c>> 🔒 ' + 'selectedExistingClient', 'color: #4caf50', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))));
  try {
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #3f51b5', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    mergeClientTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    // This flag is used to determine whether the update operation
    // for selectedExistingClient needs to be added to the
    // transaction in order to preserve SSN or insurance information.
    retainCertainClientInfo = false;
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.SSN')) && (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'))) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))['SSN'] = (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.SSN'));
      retainCertainClientInfo = true;
    }
    if (retainCertainClientInfo) {
      await ( async () => {
        const _uow = mergeClientTx;

        _uow.update('Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('UpdateClient: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.objectId'))));

      })();

    }
    if (transportRequestsToUpdate.length > 0) {
      for (var j_index in transportRequestsToUpdate) {
        j = transportRequestsToUpdate[j_index];
        await ( async () => {
          const _uow = mergeClientTx;

          _uow.setRelation('TransportRequest', j, 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(j, 'objectId'))));

        })();

      }
    }
    await ( async () => {
      const _uow = mergeClientTx;

      _uow.setRelation('TransportRequest', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord')), 'rel_Client', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'))).setOpResultId((String('TransportRequestsSetRelationClient: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))));
      _uow.delete('Client', (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client'))).setOpResultId((String('ClientObjectDelete: ') + String(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.rel_Client.objectId'))));

    })();

    result = (await mergeClientTx.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));
    console.log(result);
    if (getObjectProperty(result, 'success')) {
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['clientRecord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
      (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord'))['rel_Client'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient'));
    }
    console.log('%c>> 🔒 ' + 'transportRequestRecordReusableData', 'color: #f06292', JSON.parse(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')))));
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
    await (getChannelInstance('default')).send((String('reload-table-records:') + String('TransportRequest')), ({ [`ids`]: [(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.objectId'))] }));
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = true;
    (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsMessage'] = (['This Transport Request is now matched to existing client ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.nameFull')),', Date of Birth ',(new Intl.DateTimeFormat('en-US', undefined).format((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient.dateOfBirth')))))),'.'].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2371be049f256a4bda2fbc6a45e12a7e');

  } catch (error) {
    ___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92')['loading'] = false;
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'selectedExistingClient')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/af16da7891b50db1a92c72c3cb02852a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3d1808a775455748ad8706c5c9fed92'), 'loading')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/752113b5eb5a9ee55c96c7dcad88256b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData'))['mergeClientsReady'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/613926da2f8c51cf8e42ba2f953ed245/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.mergeClientsMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/3d05686703fb302b56bc4968f8332998/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'transportRecord'))['isDriversLastRoute'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests250124/components/7d0cc286017a265580b90576fa296c83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/cd416fb140f955bf17c52d7d4c9f7d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33ef3456b45c06195036af6564a7ffd2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transport-requests250124/components/33ef3456b45c06195036af6564a7ffd2/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, clientPasteDate, transportRequestPasteData, SpecialNeedsOrConcernsNotes, startNumber, listFromPaste, heightIn, heightFt, dateOfBirth, destinationLocationName, totalHeight, specialPrecautionso_MedicalConcerns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('No', 'g')), ''));
    ___arguments.context.dataModel['textTransportPaste'] = ((getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).replace((new RegExp('Yes', 'g')), 'TRUE'));
    listFromPaste = (getObjectProperty(___arguments.context.dataModel, 'textTransportPaste')).split(':');
    console.log('Value of #1 item on list');
    console.log(listFromPaste[0].trim());
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log(startNumber);
    console.log(listFromPaste[((startNumber + 32) - 1)]);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 32) - 1)].trim()) + String(':');
    console.log(SpecialNeedsOrConcernsNotes);
    specialPrecautionso_MedicalConcerns = subsequenceFirstFromEnd(listFromPaste[((startNumber + 29) - 1)], 19).trim();
    SpecialNeedsOrConcernsNotes = String(SpecialNeedsOrConcernsNotes) + String(String('  Special Precautions or Medical Concerns: ') + String(specialPrecautionso_MedicalConcerns));
    console.log('Special Precautions Notes');
    console.log(SpecialNeedsOrConcernsNotes);
    if ((specialPrecautionso_MedicalConcerns.indexOf('Suicide/Self Harm') !== -1) || (specialPrecautionso_MedicalConcerns.indexOf('Self-Harm Risk') !== -1)) {
      console.log('Suicide/Self Harm');
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientSuicideOrSelfHarmRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Elopement Risk') !== -1) {
      console.log('Elopement Risk');
      ___arguments.context.dataModel['isElopementRisk'] = true;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isElopementRisk'] = false;
      ___arguments.context.dataModel['isClientElopementRiskToday'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Disorganized Behavior') !== -1) {
      console.log('Disorganized Behavior');
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = true;
    } else {
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
      ___arguments.context.dataModel['hasDisorganizedBehavior'] = false;
    }
    if (specialPrecautionso_MedicalConcerns.indexOf('Fall Risk') !== -1) {
      console.log('Fall Risk');
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
      ___arguments.context.dataModel['isClientFallRiskToday'] = true;
    } else {
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
      ___arguments.context.dataModel['isClientFallRiskToday'] = false;
    }
    destinationLocationName = String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 23) - 1)], 20).trim()) + String(subsequenceFirstFromEnd(listFromPaste[((startNumber + 24) - 1)], 28).trim());
    dateOfBirth = (new Date((new Date((subsequenceFirstFromEnd(listFromPaste[((startNumber + 9) - 1)], 10).trim()))).getTime() + ((19 * 3600) * 1000)));
    totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim();
    console.log('total height');
    console.log(totalHeight);
    if (totalHeight.indexOf('\'') !== -1) {
      totalHeight = subsequenceFirstFromEnd(listFromPaste[((startNumber + 12) - 1)], 13).trim().split('\'');
      heightFt = totalHeight[0].trim();
      heightIn = totalHeight[1].trim().charAt(0);
    } else {
      heightFt = totalHeight;
      heightIn = 0;
    }
    console.log('listFromPaste');
    console.log(listFromPaste);
    transportRequestPasteData = ({ [`isContactedYMCR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 7) - 1)], 38).trim() == 'TRUE' ? true : false,[`isMCTR`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 8) - 1)], 10).trim() == 'TRUE' ? true : false,[`isCOVID19Positive`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 14) - 1)], 24).trim() == 'TRUE' ? true : false,[`referringEntityName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 18) - 1)], 17).trim(),[`referringContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 19) - 1)], 30).trim(),[`referringContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 20) - 1)], 15).trim()).replace((new RegExp('-', 'g')), '')),[`pickupAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 21) - 1)], 66).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`isReferralToNearestUrcOrCc`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 22) - 1)], 14).trim() == 'TRUE' ? true : false,[`destinationLocationName`]: destinationLocationName,[`destinationAddressString`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 25) - 1)], 28).trim()).replace((new RegExp('\\n', 'g')), ' ')),[`destinationContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 26) - 1)], 32).trim(),[`destinationContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 27) - 1)], 23).trim()).replace((new RegExp('-', 'g')), '')),[`isClientAggressiveOrViolentToday`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 31) - 1)], 22).trim() == 'TRUE' ? true : false,[`isClientElopementRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientElopementRiskToday')),[`isClientSuicideOrSelfHarmRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientSuicideOrSelfHarmRiskToday')),[`isClientFallRiskToday`]: (getObjectProperty(___arguments.context.dataModel, 'isClientFallRiskToday')),[`stateSubmissionNumber`]: (getObjectProperty(___arguments.context.dataModel, 'stateSubmissionNumber')) });
    clientPasteDate = ({ [`nameFirst`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 5) - 1)], 19).trim(),[`is18`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 6) - 1)], 48).trim(),[`dateOfBirth`]: dateOfBirth,[`age`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 10) - 1)], 13).trim(),[`assignedSexAtBirth`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 11) - 1)], 13).trim(),[`heightFt`]: heightFt,[`heightIn`]: heightIn,[`weight`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 13) - 1)], 22).trim(),[`emergencyContactName`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 15) - 1)], 31).trim(),[`emergencyContactPhone`]: ((subsequenceFirstFromEnd(listFromPaste[((startNumber + 16) - 1)], 41).trim()).replace((new RegExp('-', 'g')), '')),[`hasHistoryOfViolence`]: subsequenceFirstFromEnd(listFromPaste[((startNumber + 30) - 1)], 28).trim() == 'TRUE' ? true : false,[`otherNotes`]: SpecialNeedsOrConcernsNotes,[`isElopementRisk`]: (getObjectProperty(___arguments.context.dataModel, 'isElopementRisk')),[`hasDisorganizedBehavior`]: (getObjectProperty(___arguments.context.dataModel, 'hasDisorganizedBehavior')) });
    console.log('Transport Request Data');
    console.log(transportRequestPasteData);
    console.log('Client Record Data');
    console.log(clientPasteDate);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-request-form', ({ [`transportRequestRecord`]: transportRequestPasteData,[`clientRecord`]: clientPasteDate,[`requesterId`]: 'STATE' }));

  } catch (error) {
    console.log(error);
    ;(async () => {
        ___arguments.context.pageData['messageResponse'] = (await Backendless.Messaging.sendEmail('An error occurred during the copy/paste of a submission record into the app.', new Backendless.Bodyparts({ textmessage: 'An error occurred during the copy/paste of a submission record into the app.' }), ensureArray('jamesk@davidrobertsconsulting.com'), ensureArray([(await BackendlessUI.Functions.Custom['fn_3626f4a1aac8092dc66553f6b0eebbc8']((await BackendlessUI.Functions.Custom['fn_eede1373849ef1ddf61fa8d154f26d66']('/logging/copy-paste-errors', error, 'An error occurred during the copy/paste of a submission record into the app.', 'Form paste-state-submission Container', (JSON.parse((JSON.stringify(___arguments.context.dataModel)))), (JSON.parse((JSON.stringify(___arguments.context.pageData)))), (JSON.parse((JSON.stringify(___arguments.context.layoutData)))), (JSON.parse((JSON.stringify(___arguments.context.appData)))), null, null, null, null, null, null)), '/logging'))]).filter(item => !!item)));

    })();
    (function (message) { alert(message) })('We\'re sorry, there was an error when you attempted to copy/paste the record.  Please refresh your browser tab and try to copy/paste again.  Please be sure to paste from just before "RideCARE Submission Submission Date:" until the very end of the email after the "Special Needs/Concerns" section.');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('33ef3456b45c06195036af6564a7ffd2');

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transport-requests250124/components/a781341ea971861568c9bd1b125a5683/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['State Submission #',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')),(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.usedEmailParser')) ? ' automatically parsed from email.' : ''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/c5aeecbb7a7b29a5d767bc4a68e9c5a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['State Submission #',(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber')),(getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.usedEmailParser')) ? ' automatically parsed from email.' : ''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/96375d9c8e896078c906901591a7205d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var endValid, startValid, SpecialNeedsOrConcernsNotes, firstListValue, error, startNumber, listFromPaste;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', false);
  try {
    listFromPaste = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33ef3456b45c06195036af6564a7ffd2'), 'textTransportPaste')).split(':');
    console.log('List From Paste');
    console.log(listFromPaste);
    firstListValue = listFromPaste[0].trim();
    console.log('Value of #1 item on list');
    console.log(firstListValue);
    if ((listFromPaste[0].trim()).indexOf('Submission') !== -1) {
      startNumber = 0;
    } else if ((listFromPaste[0].trim()).indexOf('Client') !== -1) {
      startNumber = -3;
    }
    console.log('Start Number = ');
    console.log(startNumber);
    SpecialNeedsOrConcernsNotes = String(listFromPaste[((startNumber + 31) - 1)].trim()) + String(':');
    console.log('Special Needs Or Concerns');
    console.log(SpecialNeedsOrConcernsNotes);

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b6625064fa4cbb2707953e6ce458843', true);
    return ;

  }
  if ((firstListValue.indexOf('Name') !== -1) == true || (firstListValue.indexOf('Date') !== -1) == true) {
    startValid = true;
  } else {
    startValid = false;
  }
  if ((SpecialNeedsOrConcernsNotes.indexOf('Needs') !== -1) == true) {
    endValid = true;
  } else {
    endValid = false;
  }
  if (startValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca075dbbe9ede99c234dab1d381d1373', true);
    return ;
  } else if (endValid == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35bbcb97adc8112d1044970dc0cab329', true);
    return ;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30bae761946da4585eaabef1bb5cfe92', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transport-requests250124/components/9476118d4077f7a10cb49bcb3cf3ca06/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = true;
  console.log('Page Data: ');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transport-requests250124/components/f91e5188b16edf7dcaffed3466ff3187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord'))['isInformationVerified'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'transportRequestRecordReusableData')), 'transportRequestRecord.isInformationVerified')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [
	    { 
	      "type": "actions", 
	      "headerName": "",
	      "headerTooltip": "Actions",
	      "field": "actions", 
	      "width": pageData.showAllColumns == true ? 120 : 75, 
	      // "width" : 75,
	      "minWidth": 75, 
	      "pinned": "left", 
	      "meta": { "align": "center" },
	      // "hide": pageData.showAllColumns
	    },
	    { 
	      "field": "rel_TransportRequest.isEOD",
	      "headerName": "", 
	      "headerTooltip": "Crisis? Does this submission need immediate transportation?", 
	      "width": 50,
	      "minWidth": 50,
	      "pinned": "left", 
	      "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
	      "meta": { align: "center" }, 
	      "editable": false,
	      "filter": false,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true
	     // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }
	    },
	    
	
	    {
	      headerName: "Transport Status",
	      children: [
	        {
	          "field": "rel_TransportRequest.submissionCode",
	          "headerName": "Transport Code",
	          "headerTooltip": "HIPAA compliant transport reference.  [first three letters of client's first name].[first three letters of client last name].[submission number].", 
	          "pinned": "left", 
	          "width": 125, 
	          "minWidth": 75, 
	          "sortable": true,
	          "editable": false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	        {
	          "field": "samsaraRouteId",
	          "headerName": "Samsara Route ID",
	          "headerTooltip": "Route ID in the Samsara system",
	          "pinned": "left",
	          "columnGroupShow" : "open",
	          "width": 100,
	          "sortable": false,
	          "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8 ? true : false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "datetimeSubmission_copy",
	          "headerName": "Submission Time",
	          "headerTooltip": "Date & Time when the transport request was received via ORC app form. NOTE: Changes to this value will impact ETA calculations but WILL NOT be reflected in the Transport Request itself.  Submission Datetime must be changed on the Transport Request page separately.",
	          "type": "datetimeColumn",
	          "sort": "desc",
	          "pinned": "left",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 155,
	          "sortable": true,
	          "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	        {
	          "field": "typeStatus",
	          "headerName": "Status",
	          "headerTooltip": "Current status of the ride in Samsara.",
	          "pinned": "left",
	          "cellEditor": "agSelectCellEditor",
	          "cellEditorParams": {
	            "values": pageData.statusOptions || []
	          },
	          "width": 100,
	          "sortable": true,
	          "editable": true, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	      ]
	    },
	    
	
	    {
	      headerName: "Dispatch Information",
	      //"openByDefault": true,
	      children: [
	        {
	          "field": "relDispatcher1_Employee.nameFull",
	          "headerName": "Dispatcher",
	          "headerTooltip": "Name of Employee who dispatched the transport.",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "relDispatcher2_Employee.nameFull",
	          "headerName": "Alt. Dispatcher",
	          "headerTooltip": "Alternate dispatcher involved in the transport.  Use this when shifts change and someone takes over management of a ride.",
	          "columnGroupShow" : "open",
	          "width": 180,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "datetimeDispatch",
	          "headerName": "Dispatch Time",
	          "headerTooltip": "Date & Time the transport was dispatched.",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	        {
	          "field": "durationSubmissionToDispatch",
	          "headerName": "Time to Dispatch",
	          "headerTooltip": "Delay (hours:minutes) between submission time and dispatch time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "width": 100,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "relDriver1_Employee.nameFull",
	          "headerName": "Driver",
	          "headerTooltip": "Primary driver for the transport.",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "relVehicle1_Vehicle.vehicleName",
	          "headerName": "Vehicle",
	          "headerTooltip": "Primary vehicle for the transport.",
	          // "cellEditor": "agSelectCellEditor",
	          // "cellEditorParams": {
	            // "values": pageData.vehicleOptions || []
	          // },
	          "width": 100,
	          "sortable": true,
	          // "editable": true
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	      ]
	    },
	  
	
	    {
	      headerName: "Scheduling Information",
	      "openByDefault": true,
	      children: [
	        {
	          "field": "datetimeScheduledStart",
	          "headerName": "Scheduled Start Time",
	          "headerTooltip": "Date & Time the transport is scheduled to start.",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "datetimeScheduledPickup",
	          "headerName": "Scheduled Pickup Time",
	          "headerTooltip": "Date & Time the pickup is scheduled for.",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "durationResponseTime",
	          "headerName": "ETA (Response Time)",
	          "headerTooltip": "This is the response time (often referred to as ETA) between submission and pickup time.  It is estimated using the Scheduled Pickup Time initially but will automatically change to the Actual Response Time once an Actual Pickup Time is input.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "width": 120, 
	          "minWidth": 75, 
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "meta": { "align": "center" }
	        },
	        {
	          "field": "isLongETA_autoCalc",
	          "headerName": "Long ETA?",
	          "headerTooltip": "Is the Actual ETA (Response Time) greater than three hours?  This will use the Estimated ETA until the Actual Pickup Time is input and an Actual Response Time can be calculated.",
	          "type": "booleanColumn",
	          "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
	          "meta": { 
	            "align": "center" 
	          },
	          "width": 100,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "typeLongETAcause",
	          "headerName": "Long ETA Cause",
	          "headerTooltip": "What caused the long ETA",
	          "columnGroupShow" : "open",
	          "cellEditor": "agSelectCellEditor",
	          "cellEditorParams": {
	            "values": pageData.longETAcauseOptions || []
	          },
	          "width": 120,
	          "sortable": true,
	          "editable": true,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "datetimeScheduledDropoff",
	          "headerName": "Scheduled Dropoff Time",
	          "headerTooltip": "Date & Time when we expect the client to be dropped off at the destination.",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        { 
	          "field"             : "isDriversLastRoute",
	          "headerName"        : "Driver's Last Route?", 
	          "headerTooltip"     : "Was this the driver's last route of the day (i.e. they returned home after this route)?",
	          "columnGroupShow"   : "open",
	          "minWidth"          : 40,
	          "maxWidth"          : 90,
	          "cellRenderer"      : ns.checkboxCheckmarkCellRenderer,
	                                meta: { align: "center" }, 
	          "editable"          : true,
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },   
	        {
	          "field": "rel_TransportRequest.rel_EntityRequestingTransport.requesterEntityName",
	          "headerName": "Requester",
	          "headerTooltip": "This is the form that was used for the transport request.",
	          "columnGroupShow" : "open",
	          "width": 200, 
	          "minWidth": 75, 
	          "sortable": true,
	          "editable": false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "cellRendererParams": { "withChips": true },
	        },
	      ]
	    },
	    
	
	    {
	      headerName: "Client Information",
	      "openByDefault": true,
	      children: [
	        {
	          "field": "rel_TransportRequest.rel_Client.nameFull",
	          "headerName": "Client Name",
	          "headerTooltip": "Name of client being transported.",
	          "width": 120, 
	          "minWidth": 40, 
	          "sortable": true,
	          "editable": false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "rel_TransportRequest.rel_Client.dateOfBirth",
	          "headerName": "DOB",
	          "headerTooltip": "Date & Time the pickup is scheduled for.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY", 
	            "withSeconds": false
	          },
	          "width": 100,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "rel_TransportRequest.rel_Client.SSN",
	          "columnGroupShow" : "open",
	          "headerName": "SSN",
	          "headerTooltip": "Social Security Number of the client being transported.",
	          "width": 120, 
	          "minWidth": 40, 
	          "sortable": true,
	          "editable": true, 
	          "valueFormatter": ns.ssnValueFormatter,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        /*
	        {
	          "field": "rel_TransportRequest.rel_Client.typeInsurance",
	          "headerName": "Insurance Type",
	          "headerTooltip": "Type of primary insurance of the client being transported.",
	          "columnGroupShow" : "open",
	          "cellEditor": "agSelectCellEditor",
	          "cellEditorParams": {
	            "values": pageData.typeInsuranceOptions || []
	          },
	          "width": 100,
	          "sortable": true,
	          "editable": true, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" },
	        },
	        */
	        {
	          "field": "rel_TransportRequest.typeInsurance",
	          "headerName": "Insurance Type",
	          "headerTooltip": "Type of primary insurance of the client being transported.",
	          "cellEditor": "agSelectCellEditor",
	          "cellEditorParams": {
	            "values": pageData.typeInsuranceOptions || []
	          },
	          "width": 150,
	          "sortable": true,
	          "editable": true, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" },
	        },      
	        {
	          "field": "rel_TransportRequest.rel_Client.insuranceProvider",
	          "headerName": "[DEPRECATED] Insurance Provider",
	          "headerTooltip": "Primary insurance provider of the client being transported.",
	          "columnGroupShow" : "open",
	          "width": 120, 
	          "minWidth": 40, 
	          "sortable": true,
	          "editable": true, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        /*
	        {
	          "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumber",
	          "headerName"        : "Policy Number",
	          "headerTooltip"     : "Primary insurance policy number of the client being transported.",
	          "columnGroupShow"   : "open",
	          "width"             : 120, 
	          "minWidth"          : 40, 
	          "sortable"          : true,
	          "editable"          : true, 
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },
	        */
	        {
	          "field"             : "rel_TransportRequest.insurancePolicyNumber",
	          "headerName"        : "Policy Number",
	          "headerTooltip"     : "Primary insurance policy number of the client being transported.",
	          "columnGroupShow"   : "open",
	          "width"             : 120, 
	          "minWidth"          : 40, 
	          "sortable"          : true,
	          "editable"          : true, 
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },      
	        {
	          "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
	          "headerName"        : "Tribal?",
	          "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
	          "columnGroupShow"   : "open",
	          "width"             : 100, 
	          "minWidth"          : 40, 
	          "sortable"          : true,
	          "editable"          : true,
	          "meta"              : { "align": "center"},
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },
	        {
	          "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
	          "headerName"        : "Tribe Member Zipcode",
	          "headerTooltip"     : "Zipcode for the tribe member",
	          "columnGroupShow"   : "open",
	          "width"             : 100, 
	          "minWidth"          : 40, 
	          "sortable"          : true,
	          "editable"          : true, 
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },
	        {
	          "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
	          "headerName"        : "Tribes",
	          "headerTooltip"     : "Which tribes are this Client affiliated with?",
	          "columnGroupShow"   : "open",
	          "width"             : 150, 
	          "minWidth"          : 40, 
	          "sortable"          : false,
	          "editable"          : true, 
	          "type"              : "selectColumn",
	          "isMulti"           : true,
	          "cellRendererParams": { "withChips": true },
	          "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },
	      ]
	    },
	    
	    {
	      "field": "rel_TransportRequest.relPickup_Facility.formattedLocation",
	      "headerName": "Pickup Location",
	      "headerTooltip": "Location where the client will be picked up.",
	      "width": 400, 
	      "sortable": true,
	      "editable": false, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true
	    },
	    
	    {
	      "field": "rel_TransportRequest.relDestination_Facility.formattedLocation",
	      "headerName": "Destination Location",
	      "headerTooltip": "Location where the client will be dropped off.",
	      "width": 400, 
	      "sortable": true,
	      "editable": false, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true
	    },
	    
	    {
	      "field": "notesTransport",
	      "headerName": "Transport Notes",
	      "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
	      "type": "largeTextColumn",
	      "cellEditorParams": {
	        "maxLength": 2000, 
	        "rows": 10, 
	        "cols": 50,
	      },
	      "width": 400,
	      "sortable": false,
	      "editable": true,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true
	    },
	    
	    {
	      "field": "typeCancelationReason",
	      "headerName": "Cancelation Reason",
	      "headerTooltip": "Who is responsible for the cancelation?",
	      "cellEditor": "agSelectCellEditor",
	      "cellEditorParams": {
	        "values": pageData.typeCancelationReasonOptions || []
	      },
	      "width": 100,
	      "sortable": true,
	      "editable": true, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "meta": { "align": "center" }
	    },
	    
	    {
	      "field": "typeReviewStatus",
	      "headerName": "Review Status",
	      "headerTooltip": "Current status of whether the ride has been fully processed and is ready for billing.",
	      "cellEditor": "agSelectCellEditor",
	      "cellEditorParams": {
	        "values": pageData.typeReviewStatusOptions || []
	      },
	      "width": 100,
	      "sortable": true,
	      "editable": true, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "meta": { "align": "center" },
	      "hide": !pageData.showAllColumns
	    },
	    
	    {
	      "field": "billingEntityName",
	      "headerName": "Billing Entity",
	      "headerTooltip": "This is usually the form that was used for the transport request but can be manually selected.",
	      "type": "selectColumn",
	      "width": 200, 
	      "minWidth": 75, 
	      "sortable": true,
	      "editable": true, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "cellRendererParams": { "withChips": true },
	      "cellEditorParams"  : { "values": pageData.requesterEntityNameOptions || [] },
	      "hide": !pageData.showAllColumns
	    },
	
	    {
	      headerName: "Mileage & Distances",
	      "openByDefault": true,
	      children: [    
	        {
	          "field"                 : "mileageStart",
	          "headerName"            : "Mileage at Start",
	          "headerTooltip"         : "Vehicle odometer reading when the transport actually started according to Samsara.",
	          "filter"                : "agNumberColumnFilter",
	          "sortable"              : true,
	          "editable"              : true,
	          "meta"                  : { "align": "center" },
	          "wrapHeaderText"        : true,
	          "autoHeaderHeight"      : true,
	          "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
	          "width"                 : 120,
	          "hide"                  : !pageData.showAllColumns
	        },
	        {
	          "field": "mileagePickup",
	          "headerName": "Mileage at Pickup",
	          "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	          "width": 120,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "mileageDropoff",
	          "headerName": "Mileage at Dropoff",
	          "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	          "width": 120,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "mileageEndOfDay",
	          "headerName": "Mileage at End of Day",
	          "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	          "width": 120,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "distanceStartToPickup",
	          "headerName": "Start to Pickup Distance",
	          "headerTooltip": "This is distance in miles from start to pickup.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "distancePickupToDropoff",
	          "headerName": "Pickup to Dropoff Distance",
	          "headerTooltip": "This is distance in miles from pickup to dropoff.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "distanceStartToDropoff",
	          "headerName": "Start to Dropoff Distance",
	          "headerTooltip": "This is distance in miles from start to dropoff.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "distanceDropoffToEndOfRouteOrDay",
	          "headerName": "Dropoff to End Point Distance",
	          "headerTooltip": "This is distance in miles from dropoff to the end of the day location (i.e. driver's home).",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },            
	        {
	          "field": "distanceTotalTransport",
	          "headerName": "Total Transport Distance",
	          "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120, 
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "updated",
	          "headerName": "Record Updated Time",
	          "headerTooltip": "This is the last time this record was updated in the database.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "sort": "desc",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 155,
	          "sortable": true,
	          "editable": false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	      ]
	    },
	    
	    
	    {
	      headerName: "Datetimes & Durations",
	      "openByDefault": true,
	      children: [
	        {
	          "field": "datetimeActualStart",
	          "headerName": "Actual Start Time",
	          "headerTooltip": "Date & Time when the driver actually started the transport according to Samsara.",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "datetimeActualPickup",
	          "headerName": "Actual Pickup Time",
	          "headerTooltip": "Date & Time when the driver actually reached the client's location according to Samsara.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "datetimeActualPickupDeparture",
	          "headerName": "Actual Pickup Departure Time",
	          "headerTooltip": "Date & Time when the driver and the client departed their location according to Samsara.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "datetimeActualDropoff",
	          "headerName": "Actual Dropoff Time",
	          "headerTooltip": "Date & Time when the driver and the client reached the destination according to Samsara.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          // "field": "datetimeActualEndOfDay",
	          "field": "datetimeEndOfRouteOrDay",
	          "headerName": "Actual End of Route or Day Time",
	          "headerTooltip": "Date & Time when the route was completed.  If it was the last route of the day for a driver, this will instead show the Date & Time when the driver returned home.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "durationDispatchToScheduledStart",
	          "headerName": "Est. Time to Start",
	          "headerTooltip": "This is the time between the Dispatch Time and the Scheduled Start Time.",
	          "columnGroupShow" : "open",
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "valueGetter": ns.trimTimeStringValueGetter,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "durationDispatchToActualStart",
	          "headerName": "Actual Time to Start",
	          "headerTooltip": "This is the time between the Dispatch Time and the Actual Start Time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        /*  THESE AREN"T BEING CALCULATED RIGHT NOW AND HENCE DONT POPULATE
	        {
	          "field": "durationRequestedTransportToScheduledPickup",
	          "headerName": "Est. Pickup Delay vs. Request",
	          "headerTooltip": "This is the estimated delay between scheduled pickup and the requested pickup time, calculated as the requested transport time minus the scheduled pickup time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "durationRequestedTransportToActualPickup",
	          "headerName": "Actual Pickup Delay vs. Request",
	          "headerTooltip": "This is the actual delay between scheduled pickup and the requested pickup time, calculated as the requested transport time minus the scheduled pickup time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.stringToFixedValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        */
	        {
	          "field": "durationPickupWaitTime",
	          "headerName": "Pickup Duration",
	          "headerTooltip": "This is how long the driver stayed at the pickup location.  i.e. The time between arriving and departing the pickup location.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "durationStartToEndOfRouteOrDay",
	          "headerName": "Transport Duration",
	          "headerTooltip": "This is the total transport time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	      ]
	    },
	
	
	    {
	        headerName: "Driver Trip Log",
	        "openByDefault": false,
	        children: [    
	            {
	                "field": "tripLogTransportStatus",
	                "headerName": "Trip Log Transport Status",
	                "headerTooltip": "Current status of the ride per the Driver's trip log.",
	                "width": 125, 
	                "minWidth": 75, 
	                "sortable": true,
	                "editable": false, 
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "meta": { "align": "center" }
	            },
	            {
	                "field": "tripLogDatetimeActualStart",
	                "headerName": "Start Time",
	                "headerTooltip": "Date & Time when the driver started the transport according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogMilageStart",
	                "headerName": "Starting Mileage",
	                "headerTooltip": "Vehicle odometer reading at the start of the transport according to the driver.",
	                "columnGroupShow" : "open",
	                "filter": "agNumberColumnFilter",
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	                "width": 120,                
	            },
	            {
	                "field": "tripLogDatetimeActualPickup",
	                "headerName": "Pickup Arrival Time",
	                "headerTooltip": "Date & Time when the driver arrived at the pickup location according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogDatetimeActualPickupDeparture",
	                "headerName": "Pickup Departure Time",
	                "headerTooltip": "Date & Time when the driver departed the pickup location according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogMileagePickup",
	                "headerName": "Pickup Mileage",
	                "headerTooltip": "Vehicle odometer reading at the pickup location according to the driver.",
	                "columnGroupShow" : "open",
	                "filter": "agNumberColumnFilter",
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	                "width": 120,
	            },
	            {
	                "field": "tripLogDatetimeActualDropoff",
	                "headerName": "Dropoff Arrival Time",
	                "headerTooltip": "Date & Time when the driver arrived at the dropoff location according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogDatetimeActualDropoffDeparture",
	                "headerName": "Dropoff Departure Time",
	                "headerTooltip": "Date & Time when the driver departed the dropoff location according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogMileageDropoff",
	                "headerName": "Dropoff Mileage",
	                "headerTooltip": "Vehicle odometer reading at the dropoff location according to the driver.",
	                "columnGroupShow" : "open",
	                "filter": "agNumberColumnFilter",
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	                "width": 120,
	            },
	            {
	                "field": "tripLogDatetimeEndOfRouteOrDay",
	                "headerName": "End of Route or Day Time",
	                "headerTooltip": "Date & Time when the driver arrived home if it was their last ride of the day according to their records.  This will equal Dropoff Departure Time if it was the end of a route.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogMileageEndOfDay",
	                "headerName": "End of Day Mileage",
	                "headerTooltip": "Vehicle odometer reading at the end of the day according to the driver.",
	                "columnGroupShow" : "open",
	                "filter": "agNumberColumnFilter",
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	                "width": 120,
	            },
	            {
	                "field": "isTripLogPersonalItems",
	                "headerName": "Personal Items?", 
	                "headerTooltip": "Were personal items provided to the driver?", 
	                "columnGroupShow" : "open",
	                "width": 50,
	                "minWidth": 50,
	                "pinned": "left", 
	                "meta": { align: "center" }, 
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "filter": false,
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true
	            },
	            {
	                "field": "tripLogPersonalItemsNotes",
	                "headerName": "Personal Items",
	                "headerTooltip": "Description of personal items that were provided to the driver.",
	                "columnGroupShow" : "open",
	                "type": "largeTextColumn",
	                "cellEditorParams": {
	                    "maxLength": 2000, 
	                    "rows": 10, 
	                    "cols": 50,
	                },
	                "width": 400,
	                "sortable": false,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true
	            },
	            {
	                "field": "isTripLogPersonalItemsDelivered",
	                "headerName": "Delivered?", 
	                "headerTooltip": "Were personal items delivered to the destination contact?", 
	                "columnGroupShow" : "open",
	                "width": 50,
	                "minWidth": 50,
	                "pinned": "left", 
	                "meta": { align: "center" }, 
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "filter": false,
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true
	            },
	            {
	                "field": "tripLogPersonalItemsDeliveredNotes",
	                "headerName": "Delivered to",
	                "headerTooltip": "Notes on who the personal items were delivered to?",
	                "columnGroupShow" : "open",
	                "type": "largeTextColumn",
	                "cellEditorParams": {
	                    "maxLength": 2000, 
	                    "rows": 10, 
	                    "cols": 50,
	                },
	                "width": 400,
	                "sortable": false,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true
	            }
	        ]
	      }
	  ]

})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, samsaraRouteId, consoleError, errMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function handleErrorForGetMetrics(consoleError, errMessage) {
  if (errMessage != null) {
    (function (message) { alert(message) })('This route had over three stops in Samsara. We are not yet able to write data to the table automatically for these situations.  Please input these values manually.');
    return ;
  }
  if ((JSON.stringify(consoleError)).indexOf('e-grid-001') !== -1) {
    (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 1') !== -1) {
    (function (message) { alert(message) })('We were unable to get the vehicle assignments fo rthe route.  Please ensure the Driver and their Driver ID is valid.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 2') !== -1) {
    (function (message) { alert(message) })('We were unable to fetch the address details.  Please double check the pickup and drop off locations, particularly their latitude and longitude relative to the locations chosen in Samsara.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 3') !== -1) {
    console.log('Duplicate samsaraRouteId was detected.  Clearing the record.');
    console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'));
    (function (message) { alert(message) })(([consoleError,'\n\n','A duplicate Route ID already exists in the Transport table.  This usually occurs due to a data entry error in the driver or route start time.  Please take a close look at the details of this record and it\'s conflicting record and change whichever is incorrect.  Data for this record has been cleared to avoid any duplication. ',(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'))].join('')));
    try {
      ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: null,[`datetimeScheduledDropoff`]: null,[`datetimeActualStart`]: null,[`mileageStart`]: null,[`datetimeActualPickup`]: null,[`mileagePickup`]: null,[`datetimeActualPickupDeparture`]: null,[`datetimeActualDropoff`]: null,[`mileageDropoff`]: null,[`datetimeActualDropoffDeparture`]: null,[`datetimeEndOfRouteOrDay`]: null,[`mileageEndOfDay`]: null,[`errMessage`]: null });
      await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );

    } catch (error) {
      console.log('Error seen when trying to save blank values to the record item in the database in the duplicate record error handling block.');
      console.log(error);

    }
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen in the RT channel command in the get-metrics action when processing Voided.');
      console.log(error);

    }
    return ;
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 4') !== -1) {
    (function (message) { alert(message) })('This record is marked as Voided in the Transport table.  It\'s data has been cleared to avoid any duplication or confusion for the billing team.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 5') !== -1) {
    (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 7') !== -1) {
    (function (message) { alert(message) })('We were unable to get details for the route.  Please ensure that the Samsara Route Id is valid.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 8') !== -1) {
    (function (message) { alert(message) })('Failed to fetch the vehicles trip data for the specified time frame. Double check the vehicle that was assigned to the route, as well as the scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 9') !== -1) {
    (function (message) { alert(message) })('Failed to fetch driver vehicle assignments. Ensure that the driverId is valid and that the scheduled start is close to the actual route start time.');
  } else {
    (function (message) { alert(message) })((['Sorry, we were unable to retrieve the details for this route.  Please bear with us until we can pull all data automatically.  This route will need to be closed manually for now.  Console Error:','\n\n',consoleError].join('')));
  }
}


  console.log(___arguments.context.pageData);
  console.log(___arguments['recordItem']);
  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  if (___arguments['eventName'] == 'view-submission') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`transportRequestRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`typeInsuranceList`]: (getObjectProperty(___arguments.context.pageData, 'typeInsuranceList')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  } else if (___arguments['eventName'] == 'set-transporters') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
      addItemToList((getObjectProperty(___arguments.context.appData, 'intervalIds')), 'transportUpdateTransporters');
    }
  } else if (___arguments['eventName'] == 'get-metrics') {
    console.log('Print in the get-metrics On Action Item Click.  Record Item then getSamsaraRouteId return:');
    console.log(___arguments['recordItem']);
    console.log('Clearing / Initializing Page Data.');
    Object.assign(___arguments.context.pageData, ({ [`routeMetrics`]: null,[`routeInformation`]: null,[`transportRecordMetrics`]: null }));
    if ((getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) == 'Processed') {
      console.log('This route has already been processed.  Alerting User and returning.');
      (function (message) { alert(message) })('This record has already been processed.  Please change the Review Status and try again if you need to pull new data from Samsara.');
      return ;
    }
    // Check for voided status and clear the record if typeStatus=Voided
    if ((getObjectProperty(___arguments['recordItem'], 'typeStatus')) == 'Voided') {
      console.log('Voided status was detected.  Clearing the record.');
      (function (message) { alert(message) })('This record has been voided, which means it was canceled before the driver started the route.  We will remove all data for the row.');
      try {
        ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: null,[`datetimeScheduledDropoff`]: null,[`datetimeActualStart`]: null,[`mileageStart`]: null,[`datetimeActualPickup`]: null,[`mileagePickup`]: null,[`datetimeActualPickupDeparture`]: null,[`datetimeActualDropoff`]: null,[`mileageDropoff`]: null,[`datetimeActualDropoffDeparture`]: null,[`datetimeEndOfRouteOrDay`]: null,[`mileageEndOfDay`]: null,[`errMessage`]: null });
        await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );

      } catch (error) {
        console.log('Error seen when trying to save blank values to the record item in the database.');
        console.log(error);

      }
      try {
        await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

      } catch (error) {
        console.log('An error was seen in the RT channel command in the get-metrics action when processing Voided.');
        console.log(error);

      }
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('78bead46690fede9532b99d7ad3a2b24');
    if (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId')) {
      console.log('RouteId already exists in the record item.  Calling handleRouteStopArrival.');
      samsaraRouteId = (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId'));
      try {
        ___arguments.context.pageData['routeMetrics'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getFinalRouteMetrics/handleRouteStopArrival`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': samsaraRouteId,'isDriversLastRoute': (getObjectProperty(___arguments['recordItem'], 'isDriversLastRoute')) }));
        console.log('Full routeMetrics from getFinalRouteMetrics:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
        if ((getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) != null) {
          throw (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'))
        }

      } catch (error) {
        console.log('Error encountered in getFinalRouteMetrics.  Printing Error, then errMessage.');
        console.log(error);
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'));
        console.log('Full routeMetrics:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
        await handleErrorForGetMetrics(error, (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
        return ;

      }
    } else {
      console.log('RouteId needed to be found.  getRouteId returned:');
      try {
        ___arguments.context.pageData['routeInformation'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments['recordItem'], 'datetimeScheduledStart')),'pickupFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.googleFormattedAddress')),'destinationFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.googleFormattedAddress')) }));
        console.log('Full routeInformation from getRouteId:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));
        // Throw an error if routeInformation (and hence routeId) is not found
        if (!(getObjectProperty(___arguments.context.pageData, 'routeInformation'))) {
          throw (new Error('getRouteId returned null.  (e-grid-001)'))
        }
        samsaraRouteId = (getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'));
        console.log('samsaraRouteId:');
        console.log(samsaraRouteId);
        ___arguments.context.pageData['routeMetrics'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getFinalRouteMetrics/handleRouteStopArrival`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': samsaraRouteId,'isDriversLastRoute': (getObjectProperty(___arguments['recordItem'], 'isDriversLastRoute')) }));
        console.log('Full routeMetrics from getFinalRouteMetrics:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
        if ((getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) != null) {
          throw (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'))
        }

      } catch (error) {
        console.log('Error Encountered in getRouteId or getFinalRouteMetrics.  Printing error and triggering alert.');
        console.log(error);
        await handleErrorForGetMetrics(error, (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
        return ;

      } finally {
        console.log('getRouteId returned routeInformation:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));

      }
    }
    try {
      console.log('handleRouteStopArrival returned routeMetrics:');
      console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
      // If the departure datetime is present that means that the getMetrics function was able to pull a routeId and all available data for the route.  This means that it has been completed and the status can be changed to completed.  In all other cases, we defer to the manual typeStatus setting and make no change.
      //
      // NOTE: This is prebuilt to also check for a status of "Processed", which indicates that the record has been manually reviewed and finalized.  If this is the case we should not override the record.
      ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: samsaraRouteId,[`datetimeScheduledDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeScheduledDropoff')),[`datetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualStart')),[`mileageStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageStart')),[`datetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualPickup')),[`mileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileagePickup')),[`datetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualPickupDeparture')),[`datetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoff')),[`mileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageDropoff')),[`datetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoffDeparture')),[`datetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.actualRouteEndTime')),[`mileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageEndOfDay')),[`errMessage`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')),[`typeStatus`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoffDeparture')) && (getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) != 'Processed' && (getObjectProperty(___arguments['recordItem'], 'typeStatus')) != 'Canceled' && (getObjectProperty(___arguments['recordItem'], 'typeStatus')) != 'Voided' ? 'Completed' : (getObjectProperty(___arguments['recordItem'], 'typeStatus')) });
      await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );
      console.log('These metrics were saved to the Transport Table:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics'));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');

    } catch (error) {
      console.log('Error encountered when saving record to the database.  Printing Error, then errMessage.');
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
      return ;

    }
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen in the RT channel command in the get-metrics action');
      console.log(error);

    }
  } else if (___arguments['eventName'] == 'cancel-route') {
    console.log('cancelRouteEvent Started');
    console.log(___arguments['recordItem']);
    if ((getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) == 'Processed') {
      console.log('This route has already been processed.  Alerting User and returning.');
      (function (message) { alert(message) })('This record has already been processed.  Please change the Review Status and try again if you need to cancel the Route here and in Samsara.');
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('639baad5eb1fc95ea19b0b8932c3237e');
    if (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId')) {
      samsaraRouteId = (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId'));
      console.log('RouteId already exists in the record item.  Calling handleRouteStopArrival.');
    } else {
      try {
        ___arguments.context.pageData['routeInformation'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments['recordItem'], 'datetimeScheduledStart')),'pickupFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.googleFormattedAddress')),'destinationFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.googleFormattedAddress')) }));
        // Throw an error if routeInformation (and hence routeId) is not found
        if (!(getObjectProperty(___arguments.context.pageData, 'routeInformation'))) {
          throw (new Error('getRouteId returned null.  (e-grid-001)'))
        }

      } catch (error) {
        console.log('Error Encountered in getRouteId:');
        console.log(error);
        if ((JSON.stringify(error)).indexOf('e-grid-001') !== -1) {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 1') !== -1) {
          (function (message) { alert(message) })('We were unable to get the vehicle assignments fo rthe route.  Please ensure the Driver and their Driver ID is valid.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 2') !== -1) {
          (function (message) { alert(message) })('We were unable to fetch the address details.  Please double check the pickup and drop off locations, particularly their latitude and longitude relative to the locations chosen in Samsara.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 3') !== -1) {
          (function (message) { alert(message) })((String('A duplicate Route ID already exists in the Transport table.  Data for this record has been cleared to avoid any duplication.  Duplicate Route ID:  ') + String(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'))));
        } else if ((JSON.stringify(error)).indexOf('Errorcode 4') !== -1) {
          (function (message) { alert(message) })('This record is marked as Voided in the Transport table.  It\'s data has been cleared to avoid any duplication or confusion for the billing team.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 5') !== -1) {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        } else {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        }
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('639baad5eb1fc95ea19b0b8932c3237e');
        return ;

      } finally {
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));

      }
    }
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/cancelRoute/cancelAndUpdateRoute`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(samsaraRouteId));
      console.log('Route canceled in Samsara successfully.');

    } catch (error) {
      console.log('Printing Error:');
      console.log(error);
      if ((JSON.stringify(error)).indexOf('Errorcode 10') !== -1) {
        (function (message) { alert(message) })('We were unable to fetch route details for the route.  Double check that the routeID is valid and that Samsara data can be pulled automatically here.');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 11') !== -1) {
        (function (message) { alert(message) })('We were unable to update the route in Samsara to show it as cancelled.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 12') !== -1) {
        (function (message) { alert(message) })('We were unable to save data to the Transport table after the cancelation.  Please double check that the route was canceled in Samsara and then change the record here to be \'Canceled\'.');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 13') !== -1) {
        (function (message) { alert(message) })('We were unable to cancel the route.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      } else {
        (function (message) { alert(message) })('We were unable to cancel the route.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      }

    }
    console.log('Changing typeStatus to Canceled in Transport table.');
    ___arguments.context.pageData['transportStatusUpdate'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`typeStatus`]: 'Canceled' });
    await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportStatusUpdate')) );
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen with the RT Channel command in the Cancel Route function');
      console.log(error);

    }
    console.log('typeStatus was updated in the table successfully.');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportStatusUpdate'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('639baad5eb1fc95ea19b0b8932c3237e');
  } else if (___arguments['eventName'] == 'use-log-mileages') {
    try {
      ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: samsaraRouteId,[`datetimeScheduledDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeScheduledDropoff')),[`datetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogDatetimeActualStart')),[`mileageStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogMilageStart')),[`datetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogDatetimeActualPickup')),[`mileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogMileagePickup')),[`datetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogDatetimeActualPickupDeparture')),[`datetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogDatetimeActualDropoff')),[`mileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogMileageDropoff')),[`datetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogDatetimeActualDropoffDeparture')),[`datetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogDatetimeEndOfRouteOrDay')),[`mileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.tripLogMileageEndOfDay')),[`errMessage`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) });
      await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (['datetimeScheduledStart >= \'1719810000000\' ',(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')),(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier'))].join(''));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  //relationsDepth: 2
	  relations: ["rel_TransportRequest",
	              "relDispatcher1_Employee",
	              "relDispatcher2_Employee",
	              "relDriver1_Employee",
	              "relVehicle1_Vehicle",
	              "rel_TransportRequest.rel_EntityRequestingTransport",
	              "rel_TransportRequest.rel_Client",
	              "rel_TransportRequest.relPickup_Facility",
	              "rel_TransportRequest.relDestination_Facility"
	              ]
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:onCellDoubleClicked */
  async ['onCellDoubleClicked'](___arguments) {
    var setTranspotersFields;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  setTranspotersFields = ['relDispatcher1_Employee.nameFull', 'relDriver1_Employee.nameFull', 'relVehicle1_Vehicle.vehicleName', 'relDispatcher2_Employee.nameFull', 'relDriver2_Employee.nameFull', 'relVehicle2_Vehicle.vehicleName'];
  if (setTranspotersFields.includes((getObjectProperty(___arguments['columnDef'], 'field')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['rowData'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['rowData'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['rowData'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['rowData'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['rowData'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
      addItemToList((getObjectProperty(___arguments.context.appData, 'intervalIds')), 'transportUpdateTransporters');
    }
  }
  if ((getObjectProperty(___arguments['columnDef'], 'field')) == 'rel_TransportRequest.submissionCode') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`transportRequestRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  }

  },
  /* handler:onCellDoubleClicked */
  /* handler:actionsIconsLogic */
  async ['actionsIconsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'showAllColumns'))) {
    return (await (async function(appData, pageData) {
    	return [
    	  {
    	    "eventName":"view-submission",
    	    "icon":"assignment",
    	    "className":"view-submission",
    	    "title": "View Transport Request"
    	  },

    	  {
    	    "eventName":"set-transporters",
    	    "icon":"account_tree",
    	    "className":"set-transporters",
    	    "title": "Update Dispatcher(s), Drivers(s), or Vehicles(s)"
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData));
  } else {
    return (await (async function(appData, pageData) {
    	return [
    	  {
    	    "eventName":"view-submission",
    	    "icon":"assignment",
    	    "className":"view-submission",
    	    "title": "View Transport Request"
    	  },

    	  {
    	    "eventName":"set-transporters",
    	    "icon":"account_tree",
    	    "className":"set-transporters",
    	    "title": "Update Dispatcher(s), Drivers(s), or Vehicles(s)"
    	  },

    	  {
    	    "eventName":"get-metrics",
    	    "icon":"playlist_add_check",
    	    "className":"get-metrics",
    	    "title": "Get Route Metrics from Samsara.  NOTE: The Driver, Vehicle, Pickup Location, Drop off Location, and the Scheduled Start Datetime that are in this app record MUST match the route in Samsara for this method to work."
    	  },

    	  {
    	    "eventName":"cancel-route",
    	    "icon":"cancel",
    	    "className":"delete-icon",
    	    "title": "Cancel Route in App & Samsara"
    	  },
    	  /*
    	  {
    	    "eventName":"use-log-mileages",
    	    "icon":"read_more",
    	    "className":"use-log-mileages",
    	    "title": "Use the mileage and distance metrics from the Driver Transport Log for this ride instead of the data from Samsara"
    	  }
    	*/
    	]
    })(___arguments.context.appData, ___arguments.context.pageData));
  }

  },
  /* handler:actionsIconsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    
  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/transports/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  ___arguments.context.pageData['transportReusableData'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& (typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL)';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'2\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/64b22f2e967708cd2f23f0118fe71b96/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      // Need to initialize this so that we can set properties in
  // it later as part of Action Item clicks in the data grid
  ___arguments.context.pageData['recordPaths'] = ({  });

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/transports/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to
  // return all values. It is here so that no errors
  // will occur when we add in the test data flag query.
  ___arguments.context.pageData['strWhereClauseBase'] = '&& rel_TransportRequest.submissionNumber != \'\'';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    ___arguments.context.pageData['strWhereClauseBase'] = '&& (typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL)';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_TransportRequest.rel_Client.nameFirst != \'test\' ';
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['showAllColumns'] = true;
  ___arguments.context.pageData['showTestData'] = false;
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['dispatcherOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('LOWER(jobTitle) LIKE \'%dispatch%\' AND employmentStatus = \'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  // This one is only used in the data grid and we're not
  // establishing relations so we take only the value property.
  ___arguments.context.pageData['requesterEntityOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  // This one is only used in the data grid and we're not
  // establishing relations so we take only the value property.
  ___arguments.context.pageData['requesterEntityNameOptions'] = ((getObjectProperty(___arguments.context.pageData, 'requesterEntityOptions')).map(item => item['label']));
  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['longETAcauseOptions'] = [null, 'Facility', 'Prescheduled', 'Ride Care'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Facility', 'Client', 'Ride Care'];
  ___arguments.context.pageData['typeReviewStatusOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  ___arguments.context.pageData['statusOptionsFilter'] = ['Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['longETAcauseOptionsFilter'] = ['Facility', 'Prescheduled', 'Ride Care', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['typeCancelationReasonOptionsFilter'] = ['Facility', 'Client', 'Ride Care', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['typeReviewStatusOptionsFilter'] = ['Pending', 'Needs Attention', 'Processed', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['isReadOnlyMode'] = true;
  ___arguments.context.pageData['showDataQuery'] = true;
  ___arguments.context.pageData['showAdvancedFilters'] = false;
  ___arguments.context.pageData['typeInsuranceOptions'] = ((await Backendless.Data.of('Payer').find(Backendless.DataQueryBuilder.create().setWhereClause('typeInsurance IS NOT NULL').setPageSize(100).setDistinct(true))).map(item => item['typeInsurance']));
  // Send only the tribes since we're not establishing a relation here nor will we search on the lookup table.  The data binding will go off of logic and then technically the label is what gets stored in tribeAffiliations.
  ___arguments.context.pageData['typeInsuranceList'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeInsuranceOptions')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  console.log('On Before Page Enter print Page Data then App Data:');
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.appData);

  },
  /* handler:onBeforeEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var intervalId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  if ((getObjectProperty(___arguments.context.appData, 'intervalIds')).length > 0) {
    var intervalId_list = (getObjectProperty(___arguments.context.appData, 'intervalIds'));
    for (var intervalId_index in intervalId_list) {
      intervalId = intervalId_list[intervalId_index];
      stopSetTimeout(intervalId);
    }
  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/transports/components/89f36a5f06a88beb7a4168f8c62af8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showAllColumns'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/1c94c69498936d6389d94b712646580d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& isLongETA = TRUE';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/98a64a9922fd6a0fb02b2b1ca4e17e9f/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports/components/d3d664ba260c7449dd2c7b8510b7d64f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('d0542e2dcb86d77de41d3dad9db99522');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle1_Vehicle.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle2_Vehicle.objectId'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transports/components/d0542e2dcb86d77de41d3dad9db99522/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var relations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  relations = ({  });
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher1_Employee.objectId'))) {
    relations['relDispatcher1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDriver1_Employee.objectId'))) {
    relations['relDriver1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relVehicle1_Vehicle.objectId'))) {
    relations['relVehicle1_Vehicle'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher2_Employee.objectId'))) {
    relations['relDispatcher2_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) });
  }
  if ((Object.keys(relations)).length != 0) {
    await Backendless.Data.of('Transport').deepSave( (Object.assign(({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId')) }), relations)) );
    await (getChannelInstance('default')).send('reload-table-records:Transport', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId'))] }));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
    stopSetTimeout('transportUpdateTransporters');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', true);
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', false);
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transports/components/f013363f1862d6245c6531da6e1a2084/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
  stopSetTimeout('transportUpdateTransporters');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports/components/835cf0dfbd76bcd30477cd090c163ad1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_TransportRequest.rel_Client.nameFirst != \'test\'';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports/components/24fa74ce6999f63dead2abab11c8bf03/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transports/components/028571eba6567082fe2231fee0a1ce7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.pageData);
  console.log(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.objectId'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-requests', ({ [`strWhereClauseBase`]: ['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.objectId')),'\''].join('') }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/4226d63cdffccef288cb2f65bf76f254/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'30\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/376d2a86b3a13988f86809160d3fd53b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports/components/f7f2b5cd664bdecb5b97e80d13ee8895/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == true) {
    ___arguments.context.pageData['showDataQuery'] = false;
  } else {
    ___arguments.context.pageData['showDataQuery'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/d507be9497133c7612b96c6652567b07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function clearFilterForm() {
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['endDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOBReset'] = true;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('5167732fd546fa76851fc54a54383039', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('898fa3fe0e5217cf830fd3da08dfbbcd', null);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == true) {
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('38acd20ba9687798ff0b0da2b48be7ce', null);
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('a745e768e561369ac481cf94c5117b81', null);
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('40d5fefc505cf947ae7bbc5608aff6d7', null);
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientNameLast'] = null;
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOB'] = null;
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('e0af5b42fdc13722ba86ec8a620602f9', null);
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['tribalStatus'] = null;
  }
}


  await clearFilterForm();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/b842acfb7d1c2b2f9f61e7566fefee64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var whereClauseModifier, item, millisecondsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecondsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB'))).getMinutes()) * 60000;
  console.log('transport status');
  console.log(JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(item => item['value']))));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeDispatch >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeDispatch <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) != '') {
    if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(item => item['value'])))) == '["Is Blank"]') {
      whereClauseModifier = String(whereClauseModifier) + String('&& typeStatus IS NULL');
    } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(item => item['value'])))) == '["Is Not Blank"]') {
      whereClauseModifier = String(whereClauseModifier) + String('&& typeStatus IS NOT NULL');
    } else {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(async item => {; return (['typeStatus = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')) != '') {
    if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')).map(item => item['value'])))) == '["Is Blank"]') {
      whereClauseModifier = String(whereClauseModifier) + String('&& typeReviewStatus IS NULL');
    } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')).map(item => item['value'])))) == '["Is Not Blank"]') {
      whereClauseModifier = String(whereClauseModifier) + String('&& typeReviewStatus IS NOT NULL');
    } else {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')).map(async item => {; return (['typeReviewStatus = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == true) {
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')) != '') {
      if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')).map(item => item['value'])))) == '["Is Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& relDriver1_Employee.objectId IS NULL');
      } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')).map(item => item['value'])))) == '["Is Not Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& relDriver1_Employee.objectId IS NOT NULL');
      } else {
        whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')).map(async item => {; return (['relDriver1_Employee.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
      }
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')) != '') {
      if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')).map(item => item['value'])))) == '["Is Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& relDispatcher1_Employee.objectId IS NULL');
      } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')).map(item => item['value'])))) == '["Is Not Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& relDispatcher1_Employee.objectId IS NOT NULL');
      } else {
        whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')).map(async item => {; return (['relDispatcher1_Employee.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
      }
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')) != '') {
      if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')).map(item => item['value'])))) == '["Is Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& rel_TransportRequest.rel_EntityRequestingTransport.objectId IS NULL');
      } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')).map(item => item['value'])))) == '["Is Not Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& rel_TransportRequest.rel_EntityRequestingTransport.objectId IS NOT NULL');
      } else {
        whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')).map(async item => {; return (['rel_TransportRequest.rel_EntityRequestingTransport.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')),'%\' '].join(''));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth > \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) - millisecondsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth < \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) - millisecondsSinceDayStartDOB) + 86400000,'\' '].join(''));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'submissionCode')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'submissionCode')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.submissionCode LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'submissionCode')),'%\' '].join(''));
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')) != '') {
      if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')).map(item => item['value'])))) == '["Is Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& typeCancelationReason IS NULL');
      } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')).map(item => item['value'])))) == '["Is Not Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& typeCancelationReason IS NOT NULL');
      } else {
        whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')).map(async item => {; return (['typeCancelationReason = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')),' '].join(''));
    }
  }
  ___arguments.context.pageData['strWhereClauseBase'] = whereClauseModifier;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/973afdd6e8923de509b871483f0dda04/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transports/components/7bf48217c09c0cc64dcb4047fa78ffd7/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != null) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate'));
  }

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/transports/components/6deca5e7f5a5471641d333d5843ba6ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['driverOptions'] = (getObjectProperty(___arguments.context.pageData, 'driverOptions'));
  ___arguments.context.dataModel['dispatcherOptions'] = (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions'));
  ___arguments.context.dataModel['requesterEntityOptions'] = (getObjectProperty(___arguments.context.pageData, 'requesterEntityOptions'));
  ___arguments.context.dataModel['statusOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'statusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['typeReviewStatusOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeReviewStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['typeCancelationReasonOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeCancelationReasonOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['showAdvancedFilters'] = (getObjectProperty(___arguments.context.pageData, 'showAdvancedFilters'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/transports/components/d5d47e662f92bcdc1f590b2c2b4c2038/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transports/components/60f77747b19d02ce877cc733ca2c7651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'7\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/df9f74a5ce78df823282503827938f31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& hasNegativeMileage = TRUE && typeStatus != \'Voided\'';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/569a9e12f37c7374aa114b16b4d9d5aa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == false) {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['showAdvancedFilters'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['showAdvancedFilters'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/c9e8f827c11368a40251f3c1702bdfa4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports/components/01454469550a4e2baecc1e897a5b4b9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports/components/8afda726fb882bbc843259d6be38ddb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&&(hasMissingMilageOrActualDatetime = TRUE OR samsaraRouteId IS NULL) AND typeStatus != \'Voided\' AND (rel_Client.SSN IS NULL OR rel_Client.insurancePolicyNumber IS NULL OR (rel_Client.isFedRecognizedTribal = TRUE AND (rel_Client.tribeMemberZipcode IS NULL OR LENGTH(rel_Client.tribeMemberZipcode) != 5) OR (rel_Client.isFedRecognizedTribal IS NULL OR rel_Client.isFedRecognizedTribal IS FALSE) OR rel_Client.address IS NULL ) AND datetimeScheduledStart < DATESUB(NOW(), \'36\', \'HOUR\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/898fa3fe0e5217cf830fd3da08dfbbcd/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var list, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'typeReviewStatusOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/transports/components/d2212b04bb760b2996f552e354d7330a/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var item;


  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOB'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOBReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOBReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:overwriteLogic */
  ['overwriteLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) == null) {
    return null;
  }

  },
  /* handler:overwriteLogic */
  /* content */
}))

define('./pages/transports/components/5ea35ee7194f5caa4adfd883f03ce60e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('State Submission #: ') + String(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.stateSubmissionNumber')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transports/components/8bc1738908558a3c57afd297450ef6bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc1738908558a3c57afd297450ef6bb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ad85be5fcbe19daa6de41853e590ec5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('378c533830f7556430512b64fb8a53d7', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/1ad85be5fcbe19daa6de41853e590ec5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ad85be5fcbe19daa6de41853e590ec5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc1738908558a3c57afd297450ef6bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('378c533830f7556430512b64fb8a53d7', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/66e33d292e7d3a9ac72fef289d428299/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc1738908558a3c57afd297450ef6bb', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ad85be5fcbe19daa6de41853e590ec5', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('378c533830f7556430512b64fb8a53d7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/afa731d8ac44c36ed43468edfbbecddf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['datetimeStartDepartureToPatch'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/e60b357f056d03247946aed25011f2ea/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['datetimePickupStartToPatch'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/6a43e597b82be4fa59ef9d64ff6ed118/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['datetimePickupDepartureToPatch'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/7a88f94524cb694e69559ec91c0e4bea/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['datetimeDropoffStartToPatch'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/553844377d44726a4db86bec1aaf77ec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['datetimeDropoffDepartureToPatch'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/ec3662955f5fa354f5037b153ebe9e93/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['manualStartingLocationToPatch'] = ___arguments.value;
  ___arguments.context.pageData['startingLocationToPatch'] = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.context.pageData, 'manualStartingLocationToPatch.place_id')), ['formatted_address', 'geometry']));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/a6e3d51f2529eaab755842d55b0cf8bc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['manualPickupLocationToPatch'] = ___arguments.value;
  ___arguments.context.pageData['pickupLocationToPatch'] = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.context.pageData, 'manualStartingLocationToPatch.place_id')), ['formatted_address', 'geometry']));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/1d447a49873edf51d60118c50e6cf1c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['manualDropoffLocationToPatch'] = ___arguments.value;
  ___arguments.context.pageData['dropoffLocationToPatch'] = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.context.pageData, 'manualStartingLocationToPatch.place_id')), ['formatted_address', 'geometry']));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports/components/e6447b66a76a352e1481d2764309b6b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.Request.post(`${Backendless.appPath}/services/PatchRoute/patchRoute`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': (getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.samsaraRouteId')),'driverId': (getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.relDriver1_Employee.samsaraDriverId')),'stops': [({ [`scheduledDepartureTime`]: (getObjectProperty(___arguments.context.pageData, 'datetimeStartDepartureToPatch')),[`singleUseLocation`]: ({ [`address`]: (getObjectProperty(___arguments.context.pageData, 'startingLocationToPatch.address')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'startingLocationToPatch.location.lat')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'startingLocationToPatch.location.lng')) }) }), ({ [`scheduledArrivalTime`]: (getObjectProperty(___arguments.context.pageData, 'datetimePickupStartToPatch')),[`scheduledDepartureTime`]: (getObjectProperty(___arguments.context.pageData, 'datetimePickupDepartureToPatch')),[`singleUseLocation`]: ({ [`address`]: (getObjectProperty(___arguments.context.pageData, 'pickupLocationToPatch.address')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'pickupLocationToPatch.location.lng')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'pickupLocationToPatch.location.lng')) }) }), ({ [`scheduledArrivalTime`]: (getObjectProperty(___arguments.context.pageData, 'datetimeDropoffStartToPatch')),[`singleUseLocation`]: ({ [`address`]: (getObjectProperty(___arguments.context.pageData, 'dropoffLocationToPatch.address')),[`latitude`]: (getObjectProperty(___arguments.context.pageData, 'dropoffLocationToPatch.location.lat')),[`longitude`]: (getObjectProperty(___arguments.context.pageData, 'dropoffLocationToPatch.location.lng')) }) })] });

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports/components/9c8ed912a5b405d65bc50ca7848714ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
  stopSetTimeout('transportUpdateTransporters');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [
	    { 
	      "type": "actions", 
	      "headerName": "",
	      "headerTooltip": "Actions",
	      "field": "actions", 
	      "width": pageData.showAllColumns == true ? 120 : 75, 
	      // "width" : 75,
	      "minWidth": 75, 
	      "pinned": "left", 
	      "meta": { "align": "center" },
	      // "hide": pageData.showAllColumns
	    },
	    { 
	      "field": "rel_TransportRequest.isEOD",
	      "headerName": "", 
	      "headerTooltip": "Crisis? Does this submission need immediate transportation?", 
	      "width": 50,
	      "minWidth": 50,
	      "pinned": "left", 
	      "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
	      "meta": { align: "center" }, 
	      "editable": false,
	      "filter": false,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true
	     // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }
	    },
	    
	
	    {
	      headerName: "Transport Status",
	      children: [
	        {
	          "field": "rel_TransportRequest.submissionCode",
	          "headerName": "Transport Code",
	          "headerTooltip": "HIPAA compliant transport reference.  [first three letters of client's first name].[first three letters of client last name].[submission number].", 
	          "pinned": "left", 
	          "width": 125, 
	          "minWidth": 75, 
	          "sortable": true,
	          "editable": false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	        {
	          "field": "samsaraRouteId",
	          "headerName": "Samsara Route ID",
	          "headerTooltip": "Route ID in the Samsara system",
	          "pinned": "left",
	          "columnGroupShow" : "open",
	          "width": 100,
	          "sortable": false,
	          "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 8 ? true : false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "datetimeSubmission_copy",
	          "headerName": "Submission Time",
	          "headerTooltip": "Date & Time when the transport request was received via ORC app form. NOTE: Changes to this value will impact ETA calculations but WILL NOT be reflected in the Transport Request itself.  Submission Datetime must be changed on the Transport Request page separately.",
	          "type": "datetimeColumn",
	          "sort": "desc",
	          "pinned": "left",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 155,
	          "sortable": true,
	          "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	        {
	          "field": "typeStatus",
	          "headerName": "Status",
	          "headerTooltip": "Current status of the ride in Samsara.",
	          "pinned": "left",
	          "cellEditor": "agSelectCellEditor",
	          "cellEditorParams": {
	            "values": pageData.statusOptions || []
	          },
	          "width": 100,
	          "sortable": true,
	          "editable": true, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	      ]
	    },
	    
	
	    {
	      headerName: "Dispatch Information",
	      //"openByDefault": true,
	      children: [
	        {
	          "field": "relDispatcher1_Employee.nameFull",
	          "headerName": "Dispatcher",
	          "headerTooltip": "Name of Employee who dispatched the transport.",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "relDispatcher2_Employee.nameFull",
	          "headerName": "Alt. Dispatcher",
	          "headerTooltip": "Alternate dispatcher involved in the transport.  Use this when shifts change and someone takes over management of a ride.",
	          "columnGroupShow" : "open",
	          "width": 180,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "datetimeDispatch",
	          "headerName": "Dispatch Time",
	          "headerTooltip": "Date & Time the transport was dispatched.",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	        {
	          "field": "durationSubmissionToDispatch",
	          "headerName": "Time to Dispatch",
	          "headerTooltip": "Delay (hours:minutes) between submission time and dispatch time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "width": 100,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "relDriver1_Employee.nameFull",
	          "headerName": "Driver",
	          "headerTooltip": "Primary driver for the transport.",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "relVehicle1_Vehicle.vehicleName",
	          "headerName": "Vehicle",
	          "headerTooltip": "Primary vehicle for the transport.",
	          // "cellEditor": "agSelectCellEditor",
	          // "cellEditorParams": {
	            // "values": pageData.vehicleOptions || []
	          // },
	          "width": 100,
	          "sortable": true,
	          // "editable": true
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	      ]
	    },
	  
	
	    {
	      headerName: "Scheduling Information",
	      "openByDefault": true,
	      children: [
	        {
	          "field": "datetimeScheduledStart",
	          "headerName": "Scheduled Start Time",
	          "headerTooltip": "Date & Time the transport is scheduled to start.",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "datetimeScheduledPickup",
	          "headerName": "Scheduled Pickup Time",
	          "headerTooltip": "Date & Time the pickup is scheduled for.",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "durationResponseTime",
	          "headerName": "ETA (Response Time)",
	          "headerTooltip": "This is the response time (often referred to as ETA) between submission and pickup time.  It is estimated using the Scheduled Pickup Time initially but will automatically change to the Actual Response Time once an Actual Pickup Time is input.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "width": 120, 
	          "minWidth": 75, 
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "meta": { "align": "center" }
	        },
	        {
	          "field": "isLongETA_autoCalc",
	          "headerName": "Long ETA?",
	          "headerTooltip": "Is the Actual ETA (Response Time) greater than three hours?  This will use the Estimated ETA until the Actual Pickup Time is input and an Actual Response Time can be calculated.",
	          "type": "booleanColumn",
	          "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
	          "meta": { 
	            "align": "center" 
	          },
	          "width": 100,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "typeLongETAcause",
	          "headerName": "Long ETA Cause",
	          "headerTooltip": "What caused the long ETA",
	          "columnGroupShow" : "open",
	          "cellEditor": "agSelectCellEditor",
	          "cellEditorParams": {
	            "values": pageData.longETAcauseOptions || []
	          },
	          "width": 120,
	          "sortable": true,
	          "editable": true,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "datetimeScheduledDropoff",
	          "headerName": "Scheduled Dropoff Time",
	          "headerTooltip": "Date & Time when we expect the client to be dropped off at the destination.",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        { 
	          "field"             : "isDriversLastRoute",
	          "headerName"        : "Driver's Last Route?", 
	          "headerTooltip"     : "Was this the driver's last route of the day (i.e. they returned home after this route)?",
	          "columnGroupShow"   : "open",
	          "minWidth"          : 40,
	          "maxWidth"          : 90,
	          "cellRenderer"      : ns.checkboxCheckmarkCellRenderer,
	                                meta: { align: "center" }, 
	          "editable"          : true,
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },   
	        {
	          "field": "rel_TransportRequest.rel_EntityRequestingTransport.requesterEntityName",
	          "headerName": "Requester",
	          "headerTooltip": "This is the form that was used for the transport request.",
	          "columnGroupShow" : "open",
	          "width": 200, 
	          "minWidth": 75, 
	          "sortable": true,
	          "editable": false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "cellRendererParams": { "withChips": true },
	        },
	      ]
	    },
	    
	
	    {
	      headerName: "Client Information",
	      "openByDefault": true,
	      children: [
	        {
	          "field": "rel_TransportRequest.rel_Client.nameFull",
	          "headerName": "Client Name",
	          "headerTooltip": "Name of client being transported.",
	          "width": 120, 
	          "minWidth": 40, 
	          "sortable": true,
	          "editable": false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "rel_TransportRequest.rel_Client.dateOfBirth",
	          "headerName": "DOB",
	          "headerTooltip": "Date & Time the pickup is scheduled for.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY", 
	            "withSeconds": false
	          },
	          "width": 100,
	          "sortable": true,
	          "editable": false,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "rel_TransportRequest.rel_Client.SSN",
	          "columnGroupShow" : "open",
	          "headerName": "SSN",
	          "headerTooltip": "Social Security Number of the client being transported.",
	          "width": 120, 
	          "minWidth": 40, 
	          "sortable": true,
	          "editable": true, 
	          "valueFormatter": ns.ssnValueFormatter,
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field": "rel_TransportRequest.rel_Client.typeInsurance",
	          "headerName": "Insurance Type",
	          "headerTooltip": "Type of primary insurance of the client being transported.",
	          "columnGroupShow" : "open",
	          "cellEditor": "agSelectCellEditor",
	          "cellEditorParams": {
	            "values": pageData.typeInsuranceOptions || []
	          },
	          "width": 100,
	          "sortable": true,
	          "editable": true, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" },
	        },
	        {
	          "field": "rel_TransportRequest.rel_Client.insuranceProvider",
	          "headerName": "Insurance Provider",
	          "headerTooltip": "Primary insurance provider of the client being transported.",
	          "columnGroupShow" : "open",
	          "width": 120, 
	          "minWidth": 40, 
	          "sortable": true,
	          "editable": true, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true
	        },
	        {
	          "field"             : "rel_TransportRequest.rel_Client.insurancePolicyNumber",
	          "headerName"        : "Policy Number",
	          "headerTooltip"     : "Primary insurance policy number of the client being transported.",
	          "columnGroupShow"   : "open",
	          "width"             : 120, 
	          "minWidth"          : 40, 
	          "sortable"          : true,
	          "editable"          : true, 
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },
	        {
	          "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
	          "headerName"        : "Tribal?",
	          "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
	          "columnGroupShow"   : "open",
	          "width"             : 100, 
	          "minWidth"          : 40, 
	          "sortable"          : true,
	          "editable"          : true,
	          "meta"              : { "align": "center"},
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },
	        {
	          "field"             : "rel_TransportRequest.rel_Client.tribeMemberZipcode",
	          "headerName"        : "Tribe Member Zipcode",
	          "headerTooltip"     : "Zipcode for the tribe member",
	          "columnGroupShow"   : "open",
	          "width"             : 100, 
	          "minWidth"          : 40, 
	          "sortable"          : true,
	          "editable"          : true, 
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },
	        {
	          "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
	          "headerName"        : "Tribes",
	          "headerTooltip"     : "Which tribes are this Client affiliated with?",
	          "columnGroupShow"   : "open",
	          "width"             : 150, 
	          "minWidth"          : 40, 
	          "sortable"          : false,
	          "editable"          : true, 
	          "type"              : "selectColumn",
	          "isMulti"           : true,
	          "cellRendererParams": { "withChips": true },
	          "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
	          "wrapHeaderText"    : true,
	          "autoHeaderHeight"  : true
	        },
	      ]
	    },
	    
	    {
	      "field": "rel_TransportRequest.relPickup_Facility.formattedLocation",
	      "headerName": "Pickup Location",
	      "headerTooltip": "Location where the client will be picked up.",
	      "width": 400, 
	      "sortable": true,
	      "editable": false, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true
	    },
	    
	    {
	      "field": "rel_TransportRequest.relDestination_Facility.formattedLocation",
	      "headerName": "Destination Location",
	      "headerTooltip": "Location where the client will be dropped off.",
	      "width": 400, 
	      "sortable": true,
	      "editable": false, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true
	    },
	    
	    {
	      "field": "notesTransport",
	      "headerName": "Transport Notes",
	      "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
	      "type": "largeTextColumn",
	      "cellEditorParams": {
	        "maxLength": 2000, 
	        "rows": 10, 
	        "cols": 50,
	      },
	      "width": 400,
	      "sortable": false,
	      "editable": true,
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true
	    },
	    
	    {
	      "field": "typeCancelationReason",
	      "headerName": "Cancelation Reason",
	      "headerTooltip": "Who is responsible for the cancelation?",
	      "cellEditor": "agSelectCellEditor",
	      "cellEditorParams": {
	        "values": pageData.typeCancelationReasonOptions || []
	      },
	      "width": 100,
	      "sortable": true,
	      "editable": true, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "meta": { "align": "center" }
	    },
	    
	    {
	      "field": "typeReviewStatus",
	      "headerName": "Review Status",
	      "headerTooltip": "Current status of whether the ride has been fully processed and is ready for billing.",
	      "cellEditor": "agSelectCellEditor",
	      "cellEditorParams": {
	        "values": pageData.typeReviewStatusOptions || []
	      },
	      "width": 100,
	      "sortable": true,
	      "editable": true, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "meta": { "align": "center" },
	      "hide": !pageData.showAllColumns
	    },
	    
	    {
	      "field": "billingEntityName",
	      "headerName": "Billing Entity",
	      "headerTooltip": "This is usually the form that was used for the transport request but can be manually selected.",
	      "type": "selectColumn",
	      "width": 200, 
	      "minWidth": 75, 
	      "sortable": true,
	      "editable": true, 
	      "wrapHeaderText": true,
	      "autoHeaderHeight": true,
	      "cellRendererParams": { "withChips": true },
	      "cellEditorParams"  : { "values": pageData.requesterEntityNameOptions || [] },
	      "hide": !pageData.showAllColumns
	    },
	
	    {
	      headerName: "Mileage & Distances",
	      "openByDefault": true,
	      children: [    
	        {
	          "field"                 : "mileageStart",
	          "headerName"            : "Mileage at Start",
	          "headerTooltip"         : "Vehicle odometer reading when the transport actually started according to Samsara.",
	          "filter"                : "agNumberColumnFilter",
	          "sortable"              : true,
	          "editable"              : true,
	          "meta"                  : { "align": "center" },
	          "wrapHeaderText"        : true,
	          "autoHeaderHeight"      : true,
	          "valueGetter"           : params => ns.stringToFixedValueGetter(params, 0),
	          "width"                 : 120,
	          "hide"                  : !pageData.showAllColumns
	        },
	        {
	          "field": "mileagePickup",
	          "headerName": "Mileage at Pickup",
	          "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	          "width": 120,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "mileageDropoff",
	          "headerName": "Mileage at Dropoff",
	          "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	          "width": 120,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "mileageEndOfDay",
	          "headerName": "Mileage at End of Day",
	          "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	          "width": 120,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "distanceStartToPickup",
	          "headerName": "Start to Pickup Distance",
	          "headerTooltip": "This is distance in miles from start to pickup.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "distancePickupToDropoff",
	          "headerName": "Pickup to Dropoff Distance",
	          "headerTooltip": "This is distance in miles from pickup to dropoff.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "distanceStartToDropoff",
	          "headerName": "Start to Dropoff Distance",
	          "headerTooltip": "This is distance in miles from start to dropoff.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "distanceDropoffToEndOfRouteOrDay",
	          "headerName": "Dropoff to End Point Distance",
	          "headerTooltip": "This is distance in miles from dropoff to the end of the day location (i.e. driver's home).",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120,
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },            
	        {
	          "field": "distanceTotalTransport",
	          "headerName": "Total Transport Distance",
	          "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
	          "columnGroupShow" : "open",
	          "filter": "agNumberColumnFilter",
	          "width": 120, 
	          "sortable": true,
	          "editable": false,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "updated",
	          "headerName": "Record Updated Time",
	          "headerTooltip": "This is the last time this record was updated in the database.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "sort": "desc",
	          "cellRendererParams": { 
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 155,
	          "sortable": true,
	          "editable": false, 
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "meta": { "align": "center" }
	        },
	      ]
	    },
	    
	    
	    {
	      headerName: "Datetimes & Durations",
	      "openByDefault": true,
	      children: [
	        {
	          "field": "datetimeActualStart",
	          "headerName": "Actual Start Time",
	          "headerTooltip": "Date & Time when the driver actually started the transport according to Samsara.",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "datetimeActualPickup",
	          "headerName": "Actual Pickup Time",
	          "headerTooltip": "Date & Time when the driver actually reached the client's location according to Samsara.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "datetimeActualPickupDeparture",
	          "headerName": "Actual Pickup Departure Time",
	          "headerTooltip": "Date & Time when the driver and the client departed their location according to Samsara.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "datetimeActualDropoff",
	          "headerName": "Actual Dropoff Time",
	          "headerTooltip": "Date & Time when the driver and the client reached the destination according to Samsara.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          // "field": "datetimeActualEndOfDay",
	          "field": "datetimeEndOfRouteOrDay",
	          "headerName": "Actual End of Route or Day Time",
	          "headerTooltip": "Date & Time when the route was completed.  If it was the last route of the day for a driver, this will instead show the Date & Time when the driver returned home.",
	          "columnGroupShow" : "open",
	          "type": "datetimeColumn",
	          "cellRendererParams": {
	            "dayjsFormat": "MM/DD/YYYY HH:mm", 
	            "withSeconds": false
	          },
	          "width": 160,
	          "sortable": true,
	          "editable": true,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "durationDispatchToScheduledStart",
	          "headerName": "Est. Time to Start",
	          "headerTooltip": "This is the time between the Dispatch Time and the Scheduled Start Time.",
	          "columnGroupShow" : "open",
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "valueGetter": ns.trimTimeStringValueGetter,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "durationDispatchToActualStart",
	          "headerName": "Actual Time to Start",
	          "headerTooltip": "This is the time between the Dispatch Time and the Actual Start Time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          "hide": !pageData.showAllColumns
	        },
	        /*  THESE AREN"T BEING CALCULATED RIGHT NOW AND HENCE DONT POPULATE
	        {
	          "field": "durationRequestedTransportToScheduledPickup",
	          "headerName": "Est. Pickup Delay vs. Request",
	          "headerTooltip": "This is the estimated delay between scheduled pickup and the requested pickup time, calculated as the requested transport time minus the scheduled pickup time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "durationRequestedTransportToActualPickup",
	          "headerName": "Actual Pickup Delay vs. Request",
	          "headerTooltip": "This is the actual delay between scheduled pickup and the requested pickup time, calculated as the requested transport time minus the scheduled pickup time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.stringToFixedValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        */
	        {
	          "field": "durationPickupWaitTime",
	          "headerName": "Pickup Duration",
	          "headerTooltip": "This is how long the driver stayed at the pickup location.  i.e. The time between arriving and departing the pickup location.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	        {
	          "field": "durationStartToEndOfRouteOrDay",
	          "headerName": "Transport Duration",
	          "headerTooltip": "This is the total transport time.",
	          "columnGroupShow" : "open",
	          "valueGetter": ns.trimTimeStringValueGetter,
	          "sortable": true,
	          "editable": false,
	          "width": 120,
	          "meta": { "align": "center" },
	          "wrapHeaderText": true,
	          "autoHeaderHeight": true,
	          //"cellClass": "calculatedField",
	          "hide": !pageData.showAllColumns
	        },
	      ]
	    },
	
	
	    {
	        headerName: "Driver Trip Log",
	        "openByDefault": false,
	        children: [    
	            {
	                "field": "tripLogTransportStatus",
	                "headerName": "Trip Log Transport Status",
	                "headerTooltip": "Current status of the ride per the Driver's trip log.",
	                "width": 125, 
	                "minWidth": 75, 
	                "sortable": true,
	                "editable": false, 
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "meta": { "align": "center" }
	            },
	            {
	                "field": "tripLogDatetimeActualStart",
	                "headerName": "Start Time",
	                "headerTooltip": "Date & Time when the driver started the transport according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogMilageStart",
	                "headerName": "Starting Mileage",
	                "headerTooltip": "Vehicle odometer reading at the start of the transport according to the driver.",
	                "columnGroupShow" : "open",
	                "filter": "agNumberColumnFilter",
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	                "width": 120,                
	            },
	            {
	                "field": "tripLogDatetimeActualPickup",
	                "headerName": "Pickup Arrival Time",
	                "headerTooltip": "Date & Time when the driver arrived at the pickup location according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogDatetimeActualPickupDeparture",
	                "headerName": "Pickup Departure Time",
	                "headerTooltip": "Date & Time when the driver departed the pickup location according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogMileagePickup",
	                "headerName": "Pickup Mileage",
	                "headerTooltip": "Vehicle odometer reading at the pickup location according to the driver.",
	                "columnGroupShow" : "open",
	                "filter": "agNumberColumnFilter",
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	                "width": 120,
	            },
	            {
	                "field": "tripLogDatetimeActualDropoff",
	                "headerName": "Dropoff Arrival Time",
	                "headerTooltip": "Date & Time when the driver arrived at the dropoff location according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogDatetimeActualDropoffDeparture",
	                "headerName": "Dropoff Departure Time",
	                "headerTooltip": "Date & Time when the driver departed the dropoff location according to their records.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogMileageDropoff",
	                "headerName": "Dropoff Mileage",
	                "headerTooltip": "Vehicle odometer reading at the dropoff location according to the driver.",
	                "columnGroupShow" : "open",
	                "filter": "agNumberColumnFilter",
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	                "width": 120,
	            },
	            {
	                "field": "tripLogDatetimeEndOfRouteOrDay",
	                "headerName": "End of Route or Day Time",
	                "headerTooltip": "Date & Time when the driver arrived home if it was their last ride of the day according to their records.  This will equal Dropoff Departure Time if it was the end of a route.",
	                "columnGroupShow" : "open",
	                "type": "datetimeColumn",
	                "cellRendererParams": {
	                    "dayjsFormat": "MM/DD/YYYY HH:mm", 
	                    "withSeconds": false
	                },
	                "width": 160,
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	            },
	            {
	                "field": "tripLogMileageEndOfDay",
	                "headerName": "End of Day Mileage",
	                "headerTooltip": "Vehicle odometer reading at the end of the day according to the driver.",
	                "columnGroupShow" : "open",
	                "filter": "agNumberColumnFilter",
	                "sortable": true,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "meta": { "align": "center" },
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true,
	                "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	                "width": 120,
	            },
	            {
	                "field": "isTripLogPersonalItems",
	                "headerName": "Personal Items?", 
	                "headerTooltip": "Were personal items provided to the driver?", 
	                "columnGroupShow" : "open",
	                "width": 50,
	                "minWidth": 50,
	                "pinned": "left", 
	                "meta": { align: "center" }, 
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "filter": false,
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true
	            },
	            {
	                "field": "tripLogPersonalItemsNotes",
	                "headerName": "Personal Items",
	                "headerTooltip": "Description of personal items that were provided to the driver.",
	                "columnGroupShow" : "open",
	                "type": "largeTextColumn",
	                "cellEditorParams": {
	                    "maxLength": 2000, 
	                    "rows": 10, 
	                    "cols": 50,
	                },
	                "width": 400,
	                "sortable": false,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true
	            },
	            {
	                "field": "isTripLogPersonalItemsDelivered",
	                "headerName": "Delivered?", 
	                "headerTooltip": "Were personal items delivered to the destination contact?", 
	                "columnGroupShow" : "open",
	                "width": 50,
	                "minWidth": 50,
	                "pinned": "left", 
	                "meta": { align: "center" }, 
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "filter": false,
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true
	            },
	            {
	                "field": "tripLogPersonalItemsDeliveredNotes",
	                "headerName": "Delivered to",
	                "headerTooltip": "Notes on who the personal items were delivered to?",
	                "columnGroupShow" : "open",
	                "type": "largeTextColumn",
	                "cellEditorParams": {
	                    "maxLength": 2000, 
	                    "rows": 10, 
	                    "cols": 50,
	                },
	                "width": 400,
	                "sortable": false,
	                "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 3 ? true : false, 
	                "wrapHeaderText": true,
	                "autoHeaderHeight": true
	            }
	        ]
	      }
	  ]

})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, samsaraRouteId, consoleError, errMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function handleErrorForGetMetrics(consoleError, errMessage) {
  if (errMessage != null) {
    (function (message) { alert(message) })('This route had over three stops in Samsara. We are not yet able to write data to the table automatically for these situations.  Please input these values manually.');
    return ;
  }
  if ((JSON.stringify(consoleError)).indexOf('e-grid-001') !== -1) {
    (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 1') !== -1) {
    (function (message) { alert(message) })('We were unable to get the vehicle assignments fo rthe route.  Please ensure the Driver and their Driver ID is valid.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 2') !== -1) {
    (function (message) { alert(message) })('We were unable to fetch the address details.  Please double check the pickup and drop off locations, particularly their latitude and longitude relative to the locations chosen in Samsara.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 3') !== -1) {
    console.log('Duplicate samsaraRouteId was detected.  Clearing the record.');
    console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'));
    (function (message) { alert(message) })(([consoleError,'\n\n','A duplicate Route ID already exists in the Transport table.  This usually occurs due to a data entry error in the driver or route start time.  Please take a close look at the details of this record and it\'s conflicting record and change whichever is incorrect.  Data for this record has been cleared to avoid any duplication. ',(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'))].join('')));
    try {
      ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: null,[`datetimeScheduledDropoff`]: null,[`datetimeActualStart`]: null,[`mileageStart`]: null,[`datetimeActualPickup`]: null,[`mileagePickup`]: null,[`datetimeActualPickupDeparture`]: null,[`datetimeActualDropoff`]: null,[`mileageDropoff`]: null,[`datetimeActualDropoffDeparture`]: null,[`datetimeEndOfRouteOrDay`]: null,[`mileageEndOfDay`]: null,[`errMessage`]: null });
      await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );

    } catch (error) {
      console.log('Error seen when trying to save blank values to the record item in the database in the duplicate record error handling block.');
      console.log(error);

    }
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen in the RT channel command in the get-metrics action when processing Voided.');
      console.log(error);

    }
    return ;
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 4') !== -1) {
    (function (message) { alert(message) })('This record is marked as Voided in the Transport table.  It\'s data has been cleared to avoid any duplication or confusion for the billing team.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 5') !== -1) {
    (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 7') !== -1) {
    (function (message) { alert(message) })('We were unable to get details for the route.  Please ensure that the Samsara Route Id is valid.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 8') !== -1) {
    (function (message) { alert(message) })('Failed to fetch the vehicles trip data for the specified time frame. Double check the vehicle that was assigned to the route, as well as the scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 9') !== -1) {
    (function (message) { alert(message) })('Failed to fetch driver vehicle assignments. Ensure that the driverId is valid and that the scheduled start is close to the actual route start time.');
  } else {
    (function (message) { alert(message) })((['Sorry, we were unable to retrieve the details for this route.  Please bear with us until we can pull all data automatically.  This route will need to be closed manually for now.  Console Error:','\n\n',consoleError].join('')));
  }
}


  console.log(___arguments.context.pageData);
  console.log(___arguments['recordItem']);
  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  if (___arguments['eventName'] == 'view-submission') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`transportRequestRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  } else if (___arguments['eventName'] == 'set-transporters') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else if (___arguments['eventName'] == 'get-metrics') {
    console.log('Print in the get-metrics On Action Item Click.  Record Item then getSamsaraRouteId return:');
    console.log(___arguments['recordItem']);
    console.log('Clearing / Initializing Page Data.');
    Object.assign(___arguments.context.pageData, ({ [`routeMetrics`]: null,[`routeInformation`]: null,[`transportRecordMetrics`]: null }));
    if ((getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) == 'Processed') {
      console.log('This route has already been processed.  Alerting User and returning.');
      (function (message) { alert(message) })('This record has already been processed.  Please change the Review Status and try again if you need to pull new data from Samsara.');
      return ;
    }
    // Check for voided status and clear the record if typeStatus=Voided
    if ((getObjectProperty(___arguments['recordItem'], 'typeStatus')) == 'Voided') {
      console.log('Voided status was detected.  Clearing the record.');
      (function (message) { alert(message) })('This record has been voided, which means it was canceled before the driver started the route.  We will remove all data for the row.');
      try {
        ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: null,[`datetimeScheduledDropoff`]: null,[`datetimeActualStart`]: null,[`mileageStart`]: null,[`datetimeActualPickup`]: null,[`mileagePickup`]: null,[`datetimeActualPickupDeparture`]: null,[`datetimeActualDropoff`]: null,[`mileageDropoff`]: null,[`datetimeActualDropoffDeparture`]: null,[`datetimeEndOfRouteOrDay`]: null,[`mileageEndOfDay`]: null,[`errMessage`]: null });
        await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );

      } catch (error) {
        console.log('Error seen when trying to save blank values to the record item in the database.');
        console.log(error);

      }
      try {
        await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

      } catch (error) {
        console.log('An error was seen in the RT channel command in the get-metrics action when processing Voided.');
        console.log(error);

      }
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('78bead46690fede9532b99d7ad3a2b24');
    if (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId')) {
      console.log('RouteId already exists in the record item.  Calling handleRouteStopArrival.');
      samsaraRouteId = (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId'));
      try {
        ___arguments.context.pageData['routeMetrics'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getFinalRouteMetrics/handleRouteStopArrival`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': samsaraRouteId,'isDriversLastRoute': (getObjectProperty(___arguments['recordItem'], 'isDriversLastRoute')) }));
        console.log('Full routeMetrics from getFinalRouteMetrics:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
        if ((getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) != null) {
          throw (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'))
        }

      } catch (error) {
        console.log('Error encountered in getFinalRouteMetrics.  Printing Error, then errMessage.');
        console.log(error);
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'));
        console.log('Full routeMetrics:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
        await handleErrorForGetMetrics(error, (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
        return ;

      }
    } else {
      console.log('RouteId needed to be found.  getRouteId returned:');
      try {
        ___arguments.context.pageData['routeInformation'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments['recordItem'], 'datetimeScheduledStart')),'pickupFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.googleFormattedAddress')),'destinationFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.googleFormattedAddress')) }));
        console.log('Full routeInformation from getRouteId:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));
        // Throw an error if routeInformation (and hence routeId) is not found
        if (!(getObjectProperty(___arguments.context.pageData, 'routeInformation'))) {
          throw (new Error('getRouteId returned null.  (e-grid-001)'))
        }
        samsaraRouteId = (getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'));
        console.log('samsaraRouteId:');
        console.log(samsaraRouteId);
        ___arguments.context.pageData['routeMetrics'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getFinalRouteMetrics/handleRouteStopArrival`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': samsaraRouteId,'isDriversLastRoute': (getObjectProperty(___arguments['recordItem'], 'isDriversLastRoute')) }));
        console.log('Full routeMetrics from getFinalRouteMetrics:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
        if ((getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) != null) {
          throw (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'))
        }

      } catch (error) {
        console.log('Error Encountered in getRouteId or getFinalRouteMetrics.  Printing error and triggering alert.');
        console.log(error);
        await handleErrorForGetMetrics(error, (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
        return ;

      } finally {
        console.log('getRouteId returned routeInformation:');
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));

      }
    }
    try {
      console.log('handleRouteStopArrival returned routeMetrics:');
      console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
      // If the departure datetime is present that means that the getMetrics function was able to pull a routeId and all available data for the route.  This means that it has been completed and the status can be changed to completed.  In all other cases, we defer to the manual typeStatus setting and make no change.
      //
      // NOTE: This is prebuilt to also check for a status of "Processed", which indicates that the record has been manually reviewed and finalized.  If this is the case we should not override the record.
      ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: samsaraRouteId,[`datetimeScheduledDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeScheduledDropoff')),[`datetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualStart')),[`mileageStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageStart')),[`datetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualPickup')),[`mileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileagePickup')),[`datetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualPickupDeparture')),[`datetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoff')),[`mileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageDropoff')),[`datetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoffDeparture')),[`datetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.actualRouteEndTime')),[`mileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageEndOfDay')),[`errMessage`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')),[`typeStatus`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoffDeparture')) && (getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) != 'Processed' && (getObjectProperty(___arguments['recordItem'], 'typeStatus')) != 'Canceled' && (getObjectProperty(___arguments['recordItem'], 'typeStatus')) != 'Voided' ? 'Completed' : (getObjectProperty(___arguments['recordItem'], 'typeStatus')) });
      await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );
      console.log('These metrics were saved to the Transport Table:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics'));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');

    } catch (error) {
      console.log('Error encountered when saving record to the database.  Printing Error, then errMessage.');
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
      return ;

    }
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen in the RT channel command in the get-metrics action');
      console.log(error);

    }
  } else if (___arguments['eventName'] == 'cancel-route') {
    console.log('cancelRouteEvent Started');
    console.log(___arguments['recordItem']);
    if ((getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) == 'Processed') {
      console.log('This route has already been processed.  Alerting User and returning.');
      (function (message) { alert(message) })('This record has already been processed.  Please change the Review Status and try again if you need to cancel the Route here and in Samsara.');
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('639baad5eb1fc95ea19b0b8932c3237e');
    if (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId')) {
      samsaraRouteId = (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId'));
      console.log('RouteId already exists in the record item.  Calling handleRouteStopArrival.');
    } else {
      try {
        ___arguments.context.pageData['routeInformation'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments['recordItem'], 'datetimeScheduledStart')),'pickupFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.googleFormattedAddress')),'destinationFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.googleFormattedAddress')) }));
        // Throw an error if routeInformation (and hence routeId) is not found
        if (!(getObjectProperty(___arguments.context.pageData, 'routeInformation'))) {
          throw (new Error('getRouteId returned null.  (e-grid-001)'))
        }

      } catch (error) {
        console.log('Error Encountered in getRouteId:');
        console.log(error);
        if ((JSON.stringify(error)).indexOf('e-grid-001') !== -1) {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 1') !== -1) {
          (function (message) { alert(message) })('We were unable to get the vehicle assignments fo rthe route.  Please ensure the Driver and their Driver ID is valid.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 2') !== -1) {
          (function (message) { alert(message) })('We were unable to fetch the address details.  Please double check the pickup and drop off locations, particularly their latitude and longitude relative to the locations chosen in Samsara.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 3') !== -1) {
          (function (message) { alert(message) })((String('A duplicate Route ID already exists in the Transport table.  Data for this record has been cleared to avoid any duplication.  Duplicate Route ID:  ') + String(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'))));
        } else if ((JSON.stringify(error)).indexOf('Errorcode 4') !== -1) {
          (function (message) { alert(message) })('This record is marked as Voided in the Transport table.  It\'s data has been cleared to avoid any duplication or confusion for the billing team.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 5') !== -1) {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        } else {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        }
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('639baad5eb1fc95ea19b0b8932c3237e');
        return ;

      } finally {
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));

      }
    }
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/cancelRoute/cancelAndUpdateRoute`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(samsaraRouteId));
      console.log('Route canceled in Samsara successfully.');

    } catch (error) {
      console.log('Printing Error:');
      console.log(error);
      if ((JSON.stringify(error)).indexOf('Errorcode 10') !== -1) {
        (function (message) { alert(message) })('We were unable to fetch route details for the route.  Double check that the routeID is valid and that Samsara data can be pulled automatically here.');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 11') !== -1) {
        (function (message) { alert(message) })('We were unable to update the route in Samsara to show it as cancelled.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 12') !== -1) {
        (function (message) { alert(message) })('We were unable to save data to the Transport table after the cancelation.  Please double check that the route was canceled in Samsara and then change the record here to be \'Canceled\'.');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 13') !== -1) {
        (function (message) { alert(message) })('We were unable to cancel the route.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      } else {
        (function (message) { alert(message) })('We were unable to cancel the route.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      }

    }
    console.log('Changing typeStatus to Canceled in Transport table.');
    ___arguments.context.pageData['transportStatusUpdate'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`typeStatus`]: 'Canceled' });
    await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportStatusUpdate')) );
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen with the RT Channel command in the Cancel Route function');
      console.log(error);

    }
    console.log('typeStatus was updated in the table successfully.');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportStatusUpdate'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('639baad5eb1fc95ea19b0b8932c3237e');
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (['datetimeScheduledStart >= \'1719810000000\' ',(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')),(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier'))].join(''));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  //relationsDepth: 2
	  relations: ["rel_TransportRequest",
	              "relDispatcher1_Employee",
	              "relDispatcher2_Employee",
	              "relDriver1_Employee",
	              "relVehicle1_Vehicle",
	              "rel_TransportRequest.rel_EntityRequestingTransport",
	              "rel_TransportRequest.rel_Client",
	              "rel_TransportRequest.relPickup_Facility",
	              "rel_TransportRequest.relDestination_Facility"
	              ]
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:onCellDoubleClicked */
  async ['onCellDoubleClicked'](___arguments) {
    var setTranspotersFields;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  setTranspotersFields = ['relDispatcher1_Employee.nameFull', 'relDriver1_Employee.nameFull', 'relVehicle1_Vehicle.vehicleName', 'relDispatcher2_Employee.nameFull', 'relDriver2_Employee.nameFull', 'relVehicle2_Vehicle.vehicleName'];
  if (setTranspotersFields.includes((getObjectProperty(___arguments['columnDef'], 'field')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['rowData'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['rowData'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['rowData'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['rowData'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['rowData'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }
  if ((getObjectProperty(___arguments['columnDef'], 'field')) == 'rel_TransportRequest.submissionCode') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`transportRequestRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  }

  },
  /* handler:onCellDoubleClicked */
  /* handler:actionsIconsLogic */
  async ['actionsIconsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'showAllColumns'))) {
    return (await (async function(appData, pageData) {
    	return [
    	  {
    	    "eventName":"view-submission",
    	    "icon":"assignment",
    	    "className":"view-submission",
    	    "title": "View Transport Request"
    	  },

    	  {
    	    "eventName":"set-transporters",
    	    "icon":"account_tree",
    	    "className":"set-transporters",
    	    "title": "Update Dispatcher(s), Drivers(s), or Vehicles(s)"
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData));
  } else {
    return (await (async function(appData, pageData) {
    	return [
    	  {
    	    "eventName":"view-submission",
    	    "icon":"assignment",
    	    "className":"view-submission",
    	    "title": "View Transport Request"
    	  },

    	  {
    	    "eventName":"set-transporters",
    	    "icon":"account_tree",
    	    "className":"set-transporters",
    	    "title": "Update Dispatcher(s), Drivers(s), or Vehicles(s)"
    	  },

    	  {
    	    "eventName":"get-metrics",
    	    "icon":"playlist_add_check",
    	    "className":"get-metrics",
    	    "title": "Get Route Metrics from Samsara.  NOTE: The Driver, Vehicle, Pickup Location, Drop off Location, and the Scheduled Start Datetime that are in this app record MUST match the route in Samsara for this method to work."
    	  },

    	  {
    	    "eventName":"cancel-route",
    	    "icon":"cancel",
    	    "className":"delete-icon",
    	    "title": "Cancel Route in App & Samsara"
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData));
  }

  },
  /* handler:actionsIconsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    
  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/transports-bkup241221/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  ___arguments.context.pageData['transportReusableData'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& (typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL)';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'2\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/64b22f2e967708cd2f23f0118fe71b96/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      // Need to initialize this so that we can set properties in
  // it later as part of Action Item clicks in the data grid
  ___arguments.context.pageData['recordPaths'] = ({  });

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/transports-bkup241221/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to
  // return all values. It is here so that no errors
  // will occur when we add in the test data flag query.
  ___arguments.context.pageData['strWhereClauseBase'] = '&& rel_TransportRequest.submissionNumber != \'\'';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    ___arguments.context.pageData['strWhereClauseBase'] = '&& (typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL)';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_TransportRequest.rel_Client.nameFirst != \'test\' ';
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['showAllColumns'] = true;
  ___arguments.context.pageData['showTestData'] = false;
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['dispatcherOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('LOWER(jobTitle) LIKE \'%dispatch%\' AND employmentStatus = \'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  // This one is only used in the data grid and we're not
  // establishing relations so we take only the value property.
  ___arguments.context.pageData['requesterEntityOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  // This one is only used in the data grid and we're not
  // establishing relations so we take only the value property.
  ___arguments.context.pageData['requesterEntityNameOptions'] = ((getObjectProperty(___arguments.context.pageData, 'requesterEntityOptions')).map(item => item['label']));
  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['longETAcauseOptions'] = [null, 'Facility', 'Prescheduled', 'Ride Care'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Facility', 'Client', 'Ride Care'];
  ___arguments.context.pageData['typeReviewStatusOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare (XIX)', 'Medicaid (MCO)', 'Private Insurance', 'Department of Mental Health (DMH)', 'Medicare', 'Other'];
  ___arguments.context.pageData['statusOptionsFilter'] = ['Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['longETAcauseOptionsFilter'] = ['Facility', 'Prescheduled', 'Ride Care', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['typeCancelationReasonOptionsFilter'] = ['Facility', 'Client', 'Ride Care', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['typeReviewStatusOptionsFilter'] = ['Pending', 'Needs Attention', 'Processed', 'Is Blank', 'Is Not Blank'];
  ___arguments.context.pageData['isReadOnlyMode'] = true;
  ___arguments.context.pageData['showDataQuery'] = true;
  ___arguments.context.pageData['showAdvancedFilters'] = false;
  console.log('On Before Page Enter print Page Data then App Data:');
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.appData);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/transports-bkup241221/components/89f36a5f06a88beb7a4168f8c62af8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showAllColumns'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports-bkup241221/components/1c94c69498936d6389d94b712646580d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& isLongETA = TRUE';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/98a64a9922fd6a0fb02b2b1ca4e17e9f/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/d3d664ba260c7449dd2c7b8510b7d64f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('d0542e2dcb86d77de41d3dad9db99522');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle1_Vehicle.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle2_Vehicle.objectId'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/d0542e2dcb86d77de41d3dad9db99522/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var relations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  relations = ({  });
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher1_Employee.objectId'))) {
    relations['relDispatcher1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDriver1_Employee.objectId'))) {
    relations['relDriver1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relVehicle1_Vehicle.objectId'))) {
    relations['relVehicle1_Vehicle'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher2_Employee.objectId'))) {
    relations['relDispatcher2_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) });
  }
  if ((Object.keys(relations)).length != 0) {
    await Backendless.Data.of('Transport').deepSave( (Object.assign(({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId')) }), relations)) );
    await (getChannelInstance('default')).send('reload-table-records:Transport', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId'))] }));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
    stopSetTimeout('transportUpdateTransporters');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', true);
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', false);
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transports-bkup241221/components/f013363f1862d6245c6531da6e1a2084/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
  stopSetTimeout('transportUpdateTransporters');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/835cf0dfbd76bcd30477cd090c163ad1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_TransportRequest.rel_Client.nameFirst != \'test\'';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/24fa74ce6999f63dead2abab11c8bf03/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/028571eba6567082fe2231fee0a1ce7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.pageData);
  console.log(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.objectId'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-requests', ({ [`strWhereClauseBase`]: ['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.objectId')),'\''].join('') }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/4226d63cdffccef288cb2f65bf76f254/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'30\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/376d2a86b3a13988f86809160d3fd53b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/f7f2b5cd664bdecb5b97e80d13ee8895/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == true) {
    ___arguments.context.pageData['showDataQuery'] = false;
  } else {
    ___arguments.context.pageData['showDataQuery'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports-bkup241221/components/d507be9497133c7612b96c6652567b07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function clearFilterForm() {
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['endDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOBReset'] = true;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('5167732fd546fa76851fc54a54383039', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('898fa3fe0e5217cf830fd3da08dfbbcd', null);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == true) {
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('38acd20ba9687798ff0b0da2b48be7ce', null);
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('a745e768e561369ac481cf94c5117b81', null);
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('40d5fefc505cf947ae7bbc5608aff6d7', null);
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientNameLast'] = null;
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOB'] = null;
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('e0af5b42fdc13722ba86ec8a620602f9', null);
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['tribalStatus'] = null;
  }
}


  await clearFilterForm();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/b842acfb7d1c2b2f9f61e7566fefee64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var whereClauseModifier, item, millisecondsSinceDayStartDOB, millisecondsSinceDayStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  whereClauseModifier = '';
  millisecondsSinceDayStart = (new Date((new Date())).getHours()) * 3600000 + (new Date((new Date())).getMinutes()) * 60000;
  millisecondsSinceDayStartDOB = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB'))).getHours()) * 3600000 + (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB'))).getMinutes()) * 60000;
  console.log('transport status');
  console.log(JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(item => item['value']))));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeDispatch >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) - millisecondsSinceDayStart,'\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeDispatch <= \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')) - millisecondsSinceDayStart) + 86400000,'\' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) != '') {
    if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(item => item['value'])))) == '["Is Blank"]') {
      whereClauseModifier = String(whereClauseModifier) + String('&& typeStatus IS NULL');
    } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(item => item['value'])))) == '["Is Not Blank"]') {
      whereClauseModifier = String(whereClauseModifier) + String('&& typeStatus IS NOT NULL');
    } else {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(async item => {; return (['typeStatus = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')) != '') {
    if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')).map(item => item['value'])))) == '["Is Blank"]') {
      whereClauseModifier = String(whereClauseModifier) + String('&& typeReviewStatus IS NULL');
    } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')).map(item => item['value'])))) == '["Is Not Blank"]') {
      whereClauseModifier = String(whereClauseModifier) + String('&& typeReviewStatus IS NOT NULL');
    } else {
      whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')).map(async item => {; return (['typeReviewStatus = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == true) {
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')) != '') {
      if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')).map(item => item['value'])))) == '["Is Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& relDriver1_Employee.objectId IS NULL');
      } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')).map(item => item['value'])))) == '["Is Not Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& relDriver1_Employee.objectId IS NOT NULL');
      } else {
        whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')).map(async item => {; return (['relDriver1_Employee.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
      }
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')) != '') {
      if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')).map(item => item['value'])))) == '["Is Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& relDispatcher1_Employee.objectId IS NULL');
      } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')).map(item => item['value'])))) == '["Is Not Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& relDispatcher1_Employee.objectId IS NOT NULL');
      } else {
        whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')).map(async item => {; return (['relDispatcher1_Employee.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
      }
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')) != '') {
      if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')).map(item => item['value'])))) == '["Is Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& rel_TransportRequest.rel_EntityRequestingTransport.objectId IS NULL');
      } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')).map(item => item['value'])))) == '["Is Not Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& rel_TransportRequest.rel_EntityRequestingTransport.objectId IS NOT NULL');
      } else {
        whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')).map(async item => {; return (['rel_TransportRequest.rel_EntityRequestingTransport.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')),'%\' '].join(''));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth > \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) - millisecondsSinceDayStartDOB,'\' && rel_TransportRequest.rel_Client.dateOfBirth < \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) - millisecondsSinceDayStartDOB) + 86400000,'\' '].join(''));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'submissionCode')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'submissionCode')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.submissionCode LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'submissionCode')),'%\' '].join(''));
    }
    if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')) != '') {
      if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')).map(item => item['value'])))) == '["Is Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& typeCancelationReason IS NULL');
      } else if ((JSON.stringify(((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')).map(item => item['value'])))) == '["Is Not Blank"]') {
        whereClauseModifier = String(whereClauseModifier) + String('&& typeCancelationReason IS NOT NULL');
      } else {
        whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')).map(async item => {; return (['typeCancelationReason = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')) != '') {
      whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')),' '].join(''));
    }
  }
  ___arguments.context.pageData['strWhereClauseBase'] = whereClauseModifier;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/973afdd6e8923de509b871483f0dda04/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/7bf48217c09c0cc64dcb4047fa78ffd7/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != null) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate'));
  }

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/6deca5e7f5a5471641d333d5843ba6ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['driverOptions'] = (getObjectProperty(___arguments.context.pageData, 'driverOptions'));
  ___arguments.context.dataModel['dispatcherOptions'] = (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions'));
  ___arguments.context.dataModel['requesterEntityOptions'] = (getObjectProperty(___arguments.context.pageData, 'requesterEntityOptions'));
  ___arguments.context.dataModel['statusOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'statusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['typeReviewStatusOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeReviewStatusOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['typeCancelationReasonOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeCancelationReasonOptionsFilter')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['showAdvancedFilters'] = (getObjectProperty(___arguments.context.pageData, 'showAdvancedFilters'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/transports-bkup241221/components/d5d47e662f92bcdc1f590b2c2b4c2038/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/60f77747b19d02ce877cc733ca2c7651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'7\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/df9f74a5ce78df823282503827938f31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& hasNegativeMileage = TRUE && typeStatus != \'Voided\'';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/569a9e12f37c7374aa114b16b4d9d5aa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == false) {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['showAdvancedFilters'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['showAdvancedFilters'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports-bkup241221/components/c9e8f827c11368a40251f3c1702bdfa4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/01454469550a4e2baecc1e897a5b4b9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports-bkup241221/components/8afda726fb882bbc843259d6be38ddb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& (hasMissingMilageOrActualDatetime = TRUE OR samsaraRouteId = NULL) && typeStatus != \'Voided\'';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports-bkup241221/components/898fa3fe0e5217cf830fd3da08dfbbcd/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var list, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'typeReviewStatusOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/transports-bkup241221/components/d2212b04bb760b2996f552e354d7330a/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var item;


  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOB'] = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));

  },
  /* handler:onComplete */
  /* handler:initValueLogic */
  ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOBReset')) == true) {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOBReset'] = null;
    return null;
  }

  },
  /* handler:initValueLogic */
  /* handler:overwriteLogic */
  ['overwriteLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) == null) {
    return null;
  }

  },
  /* handler:overwriteLogic */
  /* content */
}))

define('./pages/transports-bkup241221/components/5ea35ee7194f5caa4adfd883f03ce60e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.stateSubmissionNumber'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('State Submission #: ') + String(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.stateSubmissionNumber')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData, ns) {
	return [
	  {
	    "type": "actions",
	    "headerName": "",
	    "headerTooltip": "Actions",
	    "field": "actions",
	    "width": pageData.showAllColumns == true ? 120 : 75,
	    // "width" : 75,
	    "minWidth": 75,
	    "pinned": "left",
	    "meta": { "align": "center" },
	    // "hide": pageData.showAllColumns
	  },


	  // {
	  //   "type": "actions",
	  //   "headerName": "",
	  //   "headerTooltip": "Actions",
	  //   "field": "actions",
	  //   "width": 120,
	  //   "minWidth": 120,
	  //   "pinned": "left",
	  //   "meta": { "align": "center" },
	  //   "hide": !pageData.showAllColumns
	  // },


	  {
	    "field": "rel_TransportRequest.isEOD",
	    "headerName": "Crisis?",
	    "headerTooltip": "Is this submission a crisis that needs immediate transportation?",
	    "minWidth": 40,
	    "maxWidth": 75,
	    "pinned": "left",
	    "cellRenderer": ns.checkboxExclamationCheckCellRenderer,
	    meta: { align: "center" },
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	   // "editable": (params) => { params.data.isDispatched == false , params.data.isVoided == false }

	  },

	  {
	    "field": "rel_TransportRequest.submissionCode",
	    "headerName": "Transport Code",
	    "headerTooltip": "HIPAA compliant transport reference.  [first three letters of client's first name].[first three letters of client last name].[submission number].",
	    "pinned": "left",
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },

	  {
	    // "field": "datetimeActualEndOfDay",
	    "field": "samsaraRouteId",
	    "headerName": "Samsara Route ID",
	    "headerTooltip": "Route ID in the Samsara system",
	    "pinned": "left",
	    "width": 100,
	    "sortable": false,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "datetimeSubmission_copy",
	    "headerName": "Submission Time",
	    "headerTooltip": "Date & Time when the transport request was received via ORC app form. NOTE: Changes to this value will impact ETA calculations but WILL NOT be reflected in the Transport Request itself.  Submission Datetime must be changed on the Transport Request page separately.",
	    "type": "datetimeColumn",
	    "sort": "desc",
	    "pinned": "left",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5 ? true : false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "typeStatus",
	    "headerName": "Status",
	    "headerTooltip": "Current status of the ride in Samsara.",
	    "pinned": "left",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.statusOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },
	  {
	    "field": "relDispatcher1_Employee.nameFull",
	    "headerName": "Dispatcher",
	    "headerTooltip": "Name of Employee who dispatched the transport.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.dispatcherOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "datetimeDispatch",
	    "headerName": "Dispatch Time",
	    "headerTooltip": "Date & Time the transport was dispatched.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5 ? true : false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "durationSubmissionToDispatch",
	    "headerName": "Time to Dispatch",
	    "headerTooltip": "Delay (hours:minutes) between submission time and dispatch time.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "width": 80,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "relDriver1_Employee.nameFull",
	    "headerName": "Driver",
	    "headerTooltip": "Primary driver for the transport.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.driverOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  {
	    "field": "relVehicle1_Vehicle.vehicleName",
	    "headerName": "Vehicle",
	    "headerTooltip": "Primary vehicle for the transport.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.vehicleOptions || []
	    // },
	    "width": 100,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "datetimeScheduledStart",
	    "headerName": "Scheduled Start Time",
	    "headerTooltip": "Date & Time the transport is scheduled to start.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "datetimeScheduledPickup",
	    "headerName": "Scheduled Pickup Time",
	    "headerTooltip": "Date & Time the pickup is scheduled for.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.dateOfBirth",
	    "headerName": "DOB",
	    "headerTooltip": "Date & Time the pickup is scheduled for.",
	    "type": "datetimeColumn",

	    "width": 160,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  /* REMOVED ONCE AUTOMATIC ETA CALCULATION WAS IN PLACE
	  {
	    "field": "durationSubmissionToScheduledPickup",
	    "headerName": "ETA (Est. Response Time)",
	    "headerTooltip": "This is the response time (often referred to as ETA) between submission and scheduled pickup time.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "meta": { "align": "center" }
	  },

	    {
	    "field": "isLongETA",
	    "headerName": "Long ETA?",
	    "headerTooltip": "Is the Est. Response Time (ETA) greater than three hours?",
	    "type": "booleanColumn",
	    "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
	    "meta": {
	      "align": "center"
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  */

	  {
	    "field": "durationResponseTime",
	    "headerName": "ETA (Response Time)",
	    "headerTooltip": "This is the response time (often referred to as ETA) between submission and pickup time.  It is estimated using the Scheduled Pickup Time initially but will automatically change to the Actual Response Time once an Actual Pickup Time is input.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "isLongETA_autoCalc",
	    "headerName": "Long ETA?",
	    "headerTooltip": "Is the Actual ETA (Response Time) greater than three hours?  This will use the Estimated ETA until the Actual Pickup Time is input and an Actual Response Time can be calculated.",
	    "type": "booleanColumn",
	    "cellRenderer": ns.checkboxWarningTriangleCellRenderer,
	    "meta": {
	      "align": "center"
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "typeLongETAcause",
	    "headerName": "Long ETA Cause",
	    "headerTooltip": "What caused the long ETA",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.longETAcauseOptions || []
	    },
	    "width": 120,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  {
	    "field": "datetimeScheduledDropoff",
	    "headerName": "Scheduled Dropoff Time",
	    "headerTooltip": "Date & Time when we expect the client to be dropped off at the destination.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_EntityRequestingTransport.requesterEntityName",
	    "headerName": "Requester",
	    "headerTooltip": "This is the form that was used for the transport request.",
	    "width": 200,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "cellRendererParams": { "withChips": true },
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.nameFull",
	    "headerName": "Client Name",
	    "headerTooltip": "Name of client being transported.",
	    "width": 120,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.SSN",
	    "headerName": "SSN",
	    "headerTooltip": "Social Security Number of the client being transported.",
	    "width": 120,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "valueFormatter": ns.ssnValueFormatter,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.typeInsurance",
	    "headerName": "Insurance Type",
	    "headerTooltip": "Type of primary insurance of the client being transported.",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.typeInsuranceOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" },
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.insuranceProvider",
	    "headerName": "Insurance Provider",
	    "headerTooltip": "Primary insurance provider of the client being transported.",
	    "width": 120,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.rel_Client.insurancePolicyNumber",
	    "headerName": "Policy Number",
	    "headerTooltip": "Primary insurance policy number of the client being transported.",
	    "width": 120,
	    "minWidth": 40,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field"             : "rel_TransportRequest.rel_Client.isFedRecognizedTribal",
	    "headerName"        : "Tribal?",
	    "headerTooltip"     : "Is this client a member of a Federally recognized Native American tribe?",
	    "width"             : 100,
	    "minWidth"          : 40,
	    "sortable"          : true,
	    "editable"          : true,
	    "meta"              : { "align": "center"},
	    "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true
	  },

	  {
	    "field"             : "rel_TransportRequest.rel_Client.tribeAffiliations",
	    "headerName"        : "Tribes",
	    "headerTooltip"     : "Which tribes are this Client affiliated with?",
	    "width"             : 120,
	    "minWidth"          : 40,
	    "sortable"          : false,
	    "editable"          : true,
	    "type"              : "selectColumn",
	    "isMulti"           : true,
	    "cellRendererParams": { "withChips": true },
	    "cellEditorParams"  : { "values": pageData.tribeOptionsForDatagrid || [] },
	    "wrapHeaderText"    : true,
	    "autoHeaderHeight"  : true
	  },

	  {
	    "field": "rel_TransportRequest.relPickup_Facility.formattedLocation",
	    "headerName": "Pickup Location",
	    "headerTooltip": "Location where the client will be picked up.",
	    "width": 400,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "rel_TransportRequest.relDestination_Facility.formattedLocation",
	    "headerName": "Destination Location",
	    "headerTooltip": "Location where the client will be dropped off.",
	    "width": 400,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "notesTransport",
	    "headerName": "Transport Notes",
	    "headerTooltip": "Notes regarding the transport request and events that may occur during the transport.",
	    "type": "largeTextColumn",
	    "cellEditorParams": {
	      "maxLength": 2000,
	      "rows": 10,
	      "cols": 50,
	    },
	    "width": 400,
	    "sortable": false,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "typeCancelationReason",
	    "headerName": "Cancelation Reason",
	    "headerTooltip": "Who is responsible for the cancelation?",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.typeCancelationReasonOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }
	  },

	  {
	    "field": "relDispatcher2_Employee.nameFull",
	    "headerName": "Alt. Dispatcher",
	    "headerTooltip": "Alternate dispatcher involved in the transport.  Use this when shifts change and someone takes over management of a ride.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.dispatcherOptions || []
	    // },
	    "width": 180,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  /*  ------- DEPRECATED WITH REMOVAL OF ALT VEHICLE AND DRIVER ------
	  {
	    "field": "relDriver2_Employee.nameFull",
	    "headerName": "Alt. Driver",
	    "headerTooltip": "Alternate driver assigned to the ride.  This is primarily for training situations, but could be needed in emergencies.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.driverOptions || []
	    // },
	    "width": 180,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },

	  {
	    "field": "relVehicle2_Vehicle.vehicleName",
	    "headerName": "Alt. Vehicle",
	    "headerTooltip": "Alternate vehicle used for the ride.  Used rarely, probably due to maintenance.  Often better to redispatch the transport request under the new vehicle than use this field.",
	    // "cellEditor": "agSelectCellEditor",
	    // "cellEditorParams": {
	      // "values": pageData.vehicleOptions || []
	    // },
	    "width": 120,
	    "sortable": true,
	    // "editable": true
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true
	  },
	  */

	    {
	    "field": "mileageStart",
	    "headerName": "Mileage at Start",
	    "headerTooltip": "Vehicle odometer reading when the transport actually started according to Samsara.",
	    "filter": "agNumberColumnFilter",
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	    "width": 120,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileagePickup",
	    "headerName": "Mileage at Pickup",
	    "headerTooltip": "Vehicle odometer reading at the pickup location according to Samsara.",
	    "filter": "agNumberColumnFilter",
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	    "width": 120,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileageDropoff",
	    "headerName": "Mileage at Dropoff",
	    "headerTooltip": "Vehicle odometer reading at the dropoff location according to Samsara.",
	    "filter": "agNumberColumnFilter",
	    "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	    "width": 120,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "mileageEndOfDay",
	    "headerName": "Mileage at End of Day",
	    "headerTooltip": "Vehicle odometer reading when the driver arrives home at the end of the day according to Samsara.",
	    "filter": "agNumberColumnFilter",
	    "valueGetter": params => ns.stringToFixedValueGetter(params, 0),
	    "width": 120,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    // "editable": false,
	    "hide": !pageData.showAllColumns
	  },

	{
	  "field"             : "isDriversLastRoute",
	  "headerName"        : "Driver's Last Route?",
	  "headerTooltip"     : "Was this the driver's last route of the day (i.e. they returned home after this route)?",
	  "minWidth"          : 40,
	  "maxWidth"          : 90,
	  "cellRenderer"      : ns.checkboxCheckmarkCellRenderer,
	                        meta: { align: "center" },
	  "editable"          : true,
	  "wrapHeaderText"    : true,
	  "autoHeaderHeight"  : true
	},

	  {
	    "field": "distanceStartToPickup",
	    "headerName": "Start to Pickup Distance",
	    "headerTooltip": "This is distance in miles from start to pickup.",
	    "filter": "agNumberColumnFilter",
	    "width": 120,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distancePickupToDropoff",
	    "headerName": "Pickup to Dropoff Distance",
	    "headerTooltip": "This is distance in miles from pickup to dropoff.",
	    "filter": "agNumberColumnFilter",
	    "width": 120,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distanceStartToDropoff",
	    "headerName": "Start to Dropoff Distance",
	    "headerTooltip": "This is distance in miles from start to dropoff.",
	    "filter": "agNumberColumnFilter",
	    "width": 120,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "distanceDropoffToEndOfRouteOrDay",
	    "headerName": "Dropoff to End Point Distance",
	    "headerTooltip": "This is distance in miles from dropoff to the end of the day location (i.e. driver's home).",
	    "filter": "agNumberColumnFilter",
	    "width": 120,
	    "sortable": true,
	    "editable": false,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	 {
	   "field": "distanceTotalTransport",
	   "headerName": "Total Transport Distance",
	   "headerTooltip": "This is the total distance for the transport, including a final leg home if present.",
	   "filter": "agNumberColumnFilter",
	   "width": 120,
	   "sortable": true,
	   "editable": false,
	   "meta": { "align": "center" },
	   "wrapHeaderText": true,
	   "autoHeaderHeight": true,
	   //"cellClass": "calculatedField",
	   "hide": !pageData.showAllColumns
	 },

	  {
	    "field": "datetimeActualStart",
	    "headerName": "Actual Start Time",
	    "headerTooltip": "Date & Time when the driver actually started the transport according to Samsara.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualPickup",
	    "headerName": "Actual Pickup Time",
	    "headerTooltip": "Date & Time when the driver actually reached the client's location according to Samsara.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualPickupDeparture",
	    "headerName": "Actual Pickup Departure Time",
	    "headerTooltip": "Date & Time when the driver and the client departed their location according to Samsara.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "datetimeActualDropoff",
	    "headerName": "Actual Dropoff Time",
	    "headerTooltip": "Date & Time when the driver and the client reached the destination according to Samsara.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },

	  {
	    // "field": "datetimeActualEndOfDay",
	    "field": "datetimeEndOfRouteOrDay",
	    "headerName": "Actual End of Route or Day Time",
	    "headerTooltip": "Date & Time when the route was completed.  If it was the last route of the day for a driver, this will instead show the Date & Time when the driver returned home.",
	    "type": "datetimeColumn",
	    "cellRendererParams": {
	      "dayjsFormat": "MM/DD/YYYY HH:mm",
	      "withSeconds": false
	    },
	    "width": 160,
	    "sortable": true,
	    "editable": true,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },

	  /* NO LONGER NEEDED SINCE WE MADE LongETA_AutoCalc and durationResponseTime
	  {
	    "field": "durationSubmissionToActualPickup",
	    "headerName": "Actual Response Time (ETA)",
	    "headerTooltip": "This is the actual time between when the driver arrived and when the transport request was submitted.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "valueGetter": ns.trimTimeStringValueGetter,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  */

	  {
	    "field": "durationDispatchToScheduledStart",
	    "headerName": "Est. Time to Start",
	    "headerTooltip": "This is the time between the Dispatch Time and the Scheduled Start Time.",
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "valueGetter": ns.trimTimeStringValueGetter,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationDispatchToActualStart",
	    "headerName": "Actual Time to Start",
	    "headerTooltip": "This is the time between the Dispatch Time and the Actual Start Time.",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "durationRequestedTransportToScheduledPickup",
	    "headerName": "Est. Pickup Delay vs. Request",
	    "headerTooltip": "This is the estimated delay between scheduled pickup and the requested pickup time, calculated as the requested transport time minus the scheduled pickup time.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "durationRequestedTransportToActualPickup",
	    "headerName": "Actual Pickup Delay vs. Request",
	    "headerTooltip": "This is the actual delay between scheduled pickup and the requested pickup time, calculated as the requested transport time minus the scheduled pickup time.",
	    "valueGetter": ns.stringToFixedValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "durationPickupWaitTime",
	    "headerName": "Pickup Duration",
	    "headerTooltip": "This is how long the driver stayed at the pickup location.  i.e. The time between arriving and departing the pickup location.",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },
	  {
	    "field": "durationStartToEndOfRouteOrDay",
	    "headerName": "Transport Duration",
	    "headerTooltip": "This is the total transport time.",
	    "valueGetter": ns.trimTimeStringValueGetter,
	    "sortable": true,
	    "editable": false,
	    "width": 120,
	    "meta": { "align": "center" },
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"cellClass": "calculatedField",
	    "hide": !pageData.showAllColumns
	  },

	  //***THIS IS LOWER PRIORITY.  MAY NOT BE NEEDED BY CLIENT.  ALSO REQUIRES CODELESS CALC AFTER SAMSARA DATA.
	  //{
	    //"field": "durationSubmissionToActualPickup",
	    //"headerName": "Actual Response Time",
	    //"sortable": true,
	    ////"cellClass": "calculatedField",
	    //"editable": false,
	    //"hide": !pageData.showAllColumns
	  //},

	  //***THIS IS LOWER PRIORITY.  MAY NOT BE NEEDED BY CLIENT.
	  //{
	    //"field": "durationDispatchToActualPickup",
	    //"headerName": "Actual Dispatch to Pickup Time",
	    //"sortable": true,
	    ////"cellClass": "calculatedField",
	    //"editable": false,
	    //"hide": !pageData.showAllColumns
	  //},

	  {
	    "field": "typeReviewStatus",
	    "headerName": "Review Status",
	    "headerTooltip": "Current status of whether the ride has been fully processed and is ready for billing.",
	    "cellEditor": "agSelectCellEditor",
	    "cellEditorParams": {
	      "values": pageData.typeReviewStatusOptions || []
	    },
	    "width": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" },
	    "hide": !pageData.showAllColumns
	  },

	  {
	    "field": "billingEntityName",
	    "headerName": "Billing Entity",
	    "headerTooltip": "This is usually the form that was used for the transport request but can be manually selected.",
	    "type": "selectColumn",
	    "width": 200,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "cellRendererParams": { "withChips": true },
	    "cellEditorParams"  : { "values": pageData.requesterEntityNameOptions || [] },
	    "hide": !pageData.showAllColumns
	  }

	  /*,
	  {
	    "field": "hasInvoiceBeenSent",
	    "headerName": "Invoiced?",
	    "headerTooltip": "Has the transport already been invoiced?.",
	    "type": "booleanColumn",
	    "cellRenderer": ns.checkboxCheckmarkCellRenderer,
	    "meta": {
	      "align": "center"
	    },
	    "width": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    //"editable": false
	  },
	  */
	]
})(___arguments.context.appData, ___arguments.context.pageData, (await BackendlessUI.Functions.Custom['fn_8a3a501e691a2d6b06396f7b66987467']())))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, samsaraRouteId, consoleError, errMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function handleErrorForGetMetrics(consoleError, errMessage) {
  if (errMessage != null) {
    (function (message) { alert(message) })('This route had over three stops in Samsara. We are not yet able to write data to the table automatically for these situations.  Please input these values manually.');
  }
  if ((JSON.stringify(consoleError)).indexOf('e-grid-001') !== -1) {
    (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 1') !== -1) {
    (function (message) { alert(message) })('We were unable to get the vehicle assignments fo rthe route.  Please ensure the Driver and their Driver ID is valid.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 2') !== -1) {
    (function (message) { alert(message) })('We were unable to fetch the address details.  Please double check the pickup and drop off locations, particularly their latitude and longitude relative to the locations chosen in Samsara.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 3') !== -1) {
    (function (message) { alert(message) })((String('A duplicate Route ID already exists in the Transport table.  This usually occurs due to a data entry error in the driver or route start time.  Please take a close look at the details of this record and it\'s conflicting record and change whichever is incorrect.  Data for this record has been cleared to avoid any duplication.  Duplicate Route ID:  ') + String(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'))));
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 4') !== -1) {
    (function (message) { alert(message) })('This record is marked as Voided in the Transport table.  It\'s data has been cleared to avoid any duplication or confusion for the billing team.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 5') !== -1) {
    (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 7') !== -1) {
    (function (message) { alert(message) })('We were unable to get details for the route.  Please ensure that the Samsara Route Id is valid.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 8') !== -1) {
    (function (message) { alert(message) })('Failed to fetch the vehicles trip data for the specified time frame. Double check the vehicle that was assigned to the route, as well as the scheduled start time.');
  } else if ((JSON.stringify(consoleError)).indexOf('Errorcode 9') !== -1) {
    (function (message) { alert(message) })('Failed to fetch driver vehicle assignments. Ensure that the driverId is valid and that the scheduled start is close to the actual route start time.');
  } else {
    (function (message) { alert(message) })('Sorry, we were unable to retrieve the details for this route.  Please bear with us until we can pull all data automatically.  This route will need to be closed manually for now.');
  }
}


  console.log(___arguments.context.pageData);
  console.log(___arguments['recordItem']);
  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  // If the record is viewed we save the chosen record to page data.  The reusable component data models will also need the relevant information for data binding.  We store the path to that data so that in the reusable component it can load the appropriate data into it's data container for data binding.  This is because the reusable components are designed for us as both input forms and viewers.
  if (___arguments['eventName'] == 'view-submission') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`transportRequestRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  } else if (___arguments['eventName'] == 'set-transporters') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['recordItem'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['recordItem'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['recordItem'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else if (___arguments['eventName'] == 'get-metrics') {
    console.log('Print in the get-metrics On Action Item Click.  Record Item then getSamsaraRouteId return:');
    console.log(___arguments['recordItem']);
    if ((getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) == 'Processed') {
      console.log('This route has already been processed.  Alerting User and returning.');
      (function (message) { alert(message) })('This record has already been processed.  Please change the Review Status and try again if you need to pull new data from Samsara.');
      return ;
    }
    // Check for voided status and clear the record if typeStatus=Voided
    if ((getObjectProperty(___arguments['recordItem'], 'typeStatus')) == 'Voided') {
      console.log('Voided status was detected.  Clearing the record.');
      (function (message) { alert(message) })('This record has been voided, which means it was canceled before the driver started the route.  We will remove all data for the row.');
      try {
        ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: null,[`datetimeScheduledDropoff`]: null,[`datetimeActualStart`]: null,[`mileageStart`]: null,[`datetimeActualPickup`]: null,[`mileagePickup`]: null,[`datetimeActualPickupDeparture`]: null,[`datetimeActualDropoff`]: null,[`mileageDropoff`]: null,[`datetimeActualDropoffDeparture`]: null,[`datetimeEndOfRouteOrDay`]: null,[`mileageEndOfDay`]: null,[`errMessage`]: null });
        await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );

      } catch (error) {
        console.log('Error seen when trying to save blank values to the record item in the database.');
        console.log(error);

      }
      try {
        await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

      } catch (error) {
        console.log('An error was seen in the RT channel command in the get-metrics action when processing Voided.');
        console.log(error);

      }
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('78bead46690fede9532b99d7ad3a2b24');
    if (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId')) {
      console.log('RouteId already exists in the record item.  Calling handleRouteStopArrival.');
      samsaraRouteId = (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId'));
      try {
        ___arguments.context.pageData['routeMetrics'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getFinalRouteMetrics/handleRouteStopArrival`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': samsaraRouteId,'isDriversLastRoute': (getObjectProperty(___arguments['recordItem'], 'isDriversLastRoute')) }));
        if ((getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) != null) {
          throw (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'))
        }

      } catch (error) {
        console.log('Error encountered in getFinalRouteMetrics.  Printing Error, then errMessage.');
        console.log(error);
        console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'));
        await handleErrorForGetMetrics(error, (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
        return ;

      }
    } else {
      console.log('RouteId needed to be found.  getRouteId returned:');
      try {
        ___arguments.context.pageData['routeInformation'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments['recordItem'], 'datetimeScheduledStart')),'pickupFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.googleFormattedAddress')),'destinationFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.googleFormattedAddress')) }));
        // Throw an error if routeInformation (and hence routeId) is not found
        if (!(getObjectProperty(___arguments.context.pageData, 'routeInformation'))) {
          throw (new Error('getRouteId returned null.  (e-grid-001)'))
        }
        samsaraRouteId = (getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'));
        console.log(samsaraRouteId);
        ___arguments.context.pageData['routeMetrics'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getFinalRouteMetrics/handleRouteStopArrival`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'routeId': samsaraRouteId,'isDriversLastRoute': (getObjectProperty(___arguments['recordItem'], 'isDriversLastRoute')) }));
        if ((getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')) != null) {
          throw (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage'))
        }

      } catch (error) {
        console.log('Error Encountered in getRouteId or getFinalRouteMetrics.  Printing error and triggering alert.');
        console.log(error);
        await handleErrorForGetMetrics(error, (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
        return ;

      } finally {
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));

      }
    }
    try {
      console.log('handleRouteStopArrival returned routeMetrics:');
      console.log(getObjectProperty(___arguments.context.pageData, 'routeMetrics'));
      // If the departure datetime is present that means that the getMetrics function was able to pull a routeId and all available data for the route.  This means that it has been completed and the status can be changed to completed.  In all other cases, we defer to the manual typeStatus setting and make no change.
      //
      // NOTE: This is prebuilt to also check for a status of "Processed", which indicates that the record has been manually reviewed and finalized.  If this is the case we should not override the record.
      ___arguments.context.pageData['transportRecordMetrics'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`samsaraRouteId`]: samsaraRouteId,[`datetimeScheduledDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeScheduledDropoff')),[`datetimeActualStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualStart')),[`mileageStart`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageStart')),[`datetimeActualPickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualPickup')),[`mileagePickup`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileagePickup')),[`datetimeActualPickupDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualPickupDeparture')),[`datetimeActualDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoff')),[`mileageDropoff`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageDropoff')),[`datetimeActualDropoffDeparture`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoffDeparture')),[`datetimeEndOfRouteOrDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.actualRouteEndTime')),[`mileageEndOfDay`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.mileageEndOfDay')),[`errMessage`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.errMessage')),[`typeStatus`]: (getObjectProperty(___arguments.context.pageData, 'routeMetrics.responseData.datetimeActualDropoffDeparture')) && (getObjectProperty(___arguments['recordItem'], 'typeStatus')) != 'Processed' ? 'Completed' : (getObjectProperty(___arguments['recordItem'], 'typeStatus')) });
      await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics')) );
      console.log('These metrics were saved to the Transport Table:');
      console.log(getObjectProperty(___arguments.context.pageData, 'transportRecordMetrics'));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');

    } catch (error) {
      console.log('Error encountered when saving record to the database.  Printing Error, then errMessage.');
      console.log(error);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('78bead46690fede9532b99d7ad3a2b24');
      return ;

    }
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen in the RT channel command in the get-metrics action');
      console.log(error);

    }
  } else if (___arguments['eventName'] == 'cancel-route') {
    console.log('cancelRouteEvent Started');
    console.log(___arguments['recordItem']);
    if ((getObjectProperty(___arguments['recordItem'], 'typeReviewStatus')) == 'Processed') {
      console.log('This route has already been processed.  Alerting User and returning.');
      (function (message) { alert(message) })('This record has already been processed.  Please change the Review Status and try again if you need to cancel the Route here and in Samsara.');
      return ;
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('639baad5eb1fc95ea19b0b8932c3237e');
    if (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId')) {
      samsaraRouteId = (getObjectProperty(___arguments['recordItem'], 'samsaraRouteId'));
      console.log('RouteId already exists in the record item.  Calling handleRouteStopArrival.');
    } else {
      try {
        ___arguments.context.pageData['routeInformation'] = (await Backendless.Request.post(`${Backendless.appPath}/services/getRouteId/fetchRoutesAndFindDetails`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverid': (getObjectProperty(___arguments['recordItem'], 'relDriver1_Employee.samsaraDriverId')),'pickupLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.latitude')),'pickupLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.longitude')),'destinationLatitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.latitude')),'destinationLongitude': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.longitude')),'scheduledStart': (getObjectProperty(___arguments['recordItem'], 'datetimeScheduledStart')),'pickupFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relPickup_Facility.googleFormattedAddress')),'destinationFormattedAddress': (getObjectProperty(___arguments['recordItem'], 'rel_TransportRequest.relDestination_Facility.googleFormattedAddress')) }));
        // Throw an error if routeInformation (and hence routeId) is not found
        if (!(getObjectProperty(___arguments.context.pageData, 'routeInformation'))) {
          throw (new Error('getRouteId returned null.  (e-grid-001)'))
        }

      } catch (error) {
        console.log('Error Encountered in getRouteId:');
        console.log(error);
        if ((JSON.stringify(error)).indexOf('e-grid-001') !== -1) {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 1') !== -1) {
          (function (message) { alert(message) })('We were unable to get the vehicle assignments fo rthe route.  Please ensure the Driver and their Driver ID is valid.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 2') !== -1) {
          (function (message) { alert(message) })('We were unable to fetch the address details.  Please double check the pickup and drop off locations, particularly their latitude and longitude relative to the locations chosen in Samsara.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 3') !== -1) {
          (function (message) { alert(message) })((String('A duplicate Route ID already exists in the Transport table.  Data for this record has been cleared to avoid any duplication.  Duplicate Route ID:  ') + String(getObjectProperty(___arguments.context.pageData, 'routeInformation.routeId'))));
        } else if ((JSON.stringify(error)).indexOf('Errorcode 4') !== -1) {
          (function (message) { alert(message) })('This record is marked as Voided in the Transport table.  It\'s data has been cleared to avoid any duplication or confusion for the billing team.');
        } else if ((JSON.stringify(error)).indexOf('Errorcode 5') !== -1) {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        } else {
          (function (message) { alert(message) })('We were unable to find a valid Route ID based on the provided information.  Please check the Driver, Driver ID, the pickup/dropoff locations, and scheduled start time.');
        }
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('639baad5eb1fc95ea19b0b8932c3237e');
        return ;

      } finally {
        console.log(getObjectProperty(___arguments.context.pageData, 'routeInformation'));

      }
    }
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/cancelRoute/cancelAndUpdateRoute`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(samsaraRouteId));
      console.log('Route canceled in Samsara successfully.');

    } catch (error) {
      console.log('Printing Error:');
      console.log(error);
      if ((JSON.stringify(error)).indexOf('Errorcode 10') !== -1) {
        (function (message) { alert(message) })('We were unable to fetch route details for the route.  Double check that the routeID is valid and that Samsara data can be pulled automatically here.');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 11') !== -1) {
        (function (message) { alert(message) })('We were unable to update the route in Samsara to show it as cancelled.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 12') !== -1) {
        (function (message) { alert(message) })('We were unable to save data to the Transport table after the cancelation.  Please double check that the route was canceled in Samsara and then change the record here to be \'Canceled\'.');
      } else if ((JSON.stringify(error)).indexOf('Errorcode 13') !== -1) {
        (function (message) { alert(message) })('We were unable to cancel the route.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      } else {
        (function (message) { alert(message) })('We were unable to cancel the route.  Please cancel the route manually in Samsara and then change the status here in the app to "Canceled".');
      }

    }
    console.log('Changing typeStatus to Canceled in Transport table.');
    ___arguments.context.pageData['transportStatusUpdate'] = ({ [`objectId`]: (getObjectProperty(___arguments['recordItem'], 'objectId')),[`typeStatus`]: 'Canceled' });
    await Backendless.Data.of('Transport').save( (getObjectProperty(___arguments.context.pageData, 'transportStatusUpdate')) );
    try {
      await BackendlessUI.Functions.Custom['fn_1267066de2422c12925c26939abeee74']('Transport', (getObjectProperty(___arguments['recordItem'], 'objectId')));

    } catch (error) {
      console.log('An error was seen with the RT Channel command in the Cancel Route function');
      console.log(error);

    }
    console.log('typeStatus was updated in the table successfully.');
    console.log(getObjectProperty(___arguments.context.pageData, 'transportStatusUpdate'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('639baad5eb1fc95ea19b0b8932c3237e');
  }

  },
  /* handler:onActionIconClick */
  /* handler:queryLogic */
  async ['queryLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['strWhereClause'] = (['datetimeScheduledStart >= \'1719810000000\' ',(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase')),(getObjectProperty(___arguments.context.pageData, 'strWhereClauseTestDataModifier'))].join(''));

  return (await (async function(pageData) {
	return {
	  where: pageData.strWhereClause,
	  //relationsDepth: 2
	  relations: ["rel_TransportRequest",
	              "relDispatcher1_Employee",
	              "relDispatcher2_Employee",
	              "relDriver1_Employee",
	              "relVehicle1_Vehicle",
	              "rel_TransportRequest.rel_EntityRequestingTransport",
	              "rel_TransportRequest.rel_Client",
	              "rel_TransportRequest.relPickup_Facility",
	              "rel_TransportRequest.relDestination_Facility"
	              ]
	}
})(___arguments.context.pageData))

  },
  /* handler:queryLogic */
  /* handler:onCellDoubleClicked */
  async ['onCellDoubleClicked'](___arguments) {
    var setTranspotersFields;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  setTranspotersFields = ['relDispatcher1_Employee.nameFull', 'relDriver1_Employee.nameFull', 'relVehicle1_Vehicle.vehicleName', 'relDispatcher2_Employee.nameFull', 'relDriver2_Employee.nameFull', 'relVehicle2_Vehicle.vehicleName'];
  if (setTranspotersFields.includes((getObjectProperty(___arguments['columnDef'], 'field')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522')), 'transportersData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
      stopSetTimeout('transportUpdateTransporters');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d0542e2dcb86d77de41d3dad9db99522'))['transportersData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`dispatcherOptions`]: (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions')),[`driverOptions`]: (getObjectProperty(___arguments.context.pageData, 'driverOptions')),[`vehicleOptions`]: (getObjectProperty(___arguments.context.pageData, 'vehicleOptions')),[`dispatcher`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher1_Employee.objectId')),[`dispatcherAlt`]: (getObjectProperty(___arguments['rowData'], 'relDispatcher2_Employee.objectId')),[`driver`]: (getObjectProperty(___arguments['rowData'], 'relDriver1_Employee.objectId')),[`driverAlt`]: (getObjectProperty(___arguments['rowData'], 'relDriver2_Employee.objectId')),[`vehicle`]: (getObjectProperty(___arguments['rowData'], 'relVehicle1_Vehicle.objectId')),[`vehicleAlt`]: (getObjectProperty(___arguments['rowData'], 'relVehicle2_Vehicle.objectId')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Transport', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['rowData'], 'objectId')))));

        };

        const timerId = 'transportUpdateTransporters';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }
  if ((getObjectProperty(___arguments['columnDef'], 'field')) == 'rel_TransportRequest.submissionCode') {
    if ((getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRecord.objectId')) == (getObjectProperty(___arguments['rowData'], 'objectId'))) {
      ___arguments.context.pageData['transportReusableData'] = null;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
    } else {
      ___arguments.context.pageData['transportReusableData'] = ({ [`transportRecord`]: ___arguments['rowData'],[`transportRequestRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest')),[`clientRecord`]: (getObjectProperty(___arguments['rowData'], 'rel_TransportRequest.rel_Client')),[`tribeOptions`]: (getObjectProperty(___arguments.context.pageData, 'tribeOptions')),[`isReadOnlyMode`]: true });
      ___arguments.context.pageData['isExistingRecordLoaded'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', true);
      await new Promise(r => setTimeout(r, 0 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73b93b24382d41b884a9e1223fd5ceba')));
    }
  }

  },
  /* handler:onCellDoubleClicked */
  /* handler:actionsIconsLogic */
  async ['actionsIconsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'showAllColumns'))) {
    return (await (async function(appData, pageData) {
    	return [
    	  {
    	    "eventName":"view-submission",
    	    "icon":"assignment",
    	    "className":"view-submission",
    	    "title": "View Transport Request"
    	  },

    	  {
    	    "eventName":"set-transporters",
    	    "icon":"account_tree",
    	    "className":"set-transporters",
    	    "title": "Update Dispatcher(s), Drivers(s), or Vehicles(s)"
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData));
  } else {
    return (await (async function(appData, pageData) {
    	return [
    	  {
    	    "eventName":"view-submission",
    	    "icon":"assignment",
    	    "className":"view-submission",
    	    "title": "View Transport Request"
    	  },

    	  {
    	    "eventName":"set-transporters",
    	    "icon":"account_tree",
    	    "className":"set-transporters",
    	    "title": "Update Dispatcher(s), Drivers(s), or Vehicles(s)"
    	  },

    	  {
    	    "eventName":"get-metrics",
    	    "icon":"playlist_add_check",
    	    "className":"get-metrics",
    	    "title": "Get Route Metrics from Samsara"
    	  },

    	  {
    	    "eventName":"cancel-route",
    	    "icon":"cancel",
    	    "className":"delete-icon",
    	    "title": "Cancel Route in App & Samsara"
    	  }
    	]
    })(___arguments.context.appData, ___arguments.context.pageData));
  }

  },
  /* handler:actionsIconsLogic */
  /* handler:onBeforeUpdate */
  ['onBeforeUpdate'](___arguments) {
    
  },
  /* handler:onBeforeUpdate */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/f7d776d506f6bb4eac2cc14b64bc5b12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73b93b24382d41b884a9e1223fd5ceba', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('73b93b24382d41b884a9e1223fd5ceba');
  ___arguments.context.pageData['transportReusableData'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/2025f53f5da5675c26a8e8e11efc0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& (typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL)';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/75a44ebac573dc9ecf412eefb85ccca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'2\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/64b22f2e967708cd2f23f0118fe71b96/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      // Need to initialize this so that we can set properties in
  // it later as part of Action Item clicks in the data grid
  ___arguments.context.pageData['recordPaths'] = ({  });

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/48b7e46b324c2222d75bceea68391448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // This is basically a dummy query string meant to
  // return all values. It is here so that no errors
  // will occur when we add in the test data flag query.
  ___arguments.context.pageData['strWhereClauseBase'] = 'rel_TransportRequest.submissionNumber != \'\'';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'strWhereClauseBase'))) {
    ___arguments.context.pageData['strWhereClauseBase'] = '&& (typeStatus = \'In Progress\' OR typeStatus = \'Dispatched\' OR typeStatus IS NULL)';
  }
  // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_TransportRequest.rel_Client.nameFirst != \'test\' ';
  ___arguments.context.pageData['strWhereClauseModifier'] = '';
  ___arguments.context.pageData['showTestData'] = false;
  await BackendlessUI.Functions.Custom['fn_dbb18f7b7e65bc5c2574571a1002ebaa'](___arguments.context.pageData);
  ___arguments.context.pageData['tribeOptionsForDatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'tribeOptions')).map(item => item['value']));
  ___arguments.context.pageData['dispatcherOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('LOWER(jobTitle) LIKE \'%dispatch%\' AND employmentStatus = \'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['driverOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['vehicleOptions'] = (await Promise.all((await Backendless.Data.of('Vehicle').find(Backendless.DataQueryBuilder.create().setWhereClause('status = \'In Service\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'vehicleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  // This one is only used in the data grid and we're not
  // establishing relations so we take only the value property.
  ___arguments.context.pageData['requesterEntityOptions'] = (await Promise.all((await Backendless.Data.of('EntityRequestingTransport').find(Backendless.DataQueryBuilder.create().setSortBy('requesterEntityName asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'requesterEntityName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  // This one is only used in the data grid and we're not
  // establishing relations so we take only the value property.
  ___arguments.context.pageData['requesterEntityNameOptions'] = ((getObjectProperty(___arguments.context.pageData, 'requesterEntityOptions')).map(item => item['label']));
  ___arguments.context.pageData['statusOptions'] = [null, 'Dispatched', 'In Progress', 'Completed', 'Canceled', 'Voided'];
  ___arguments.context.pageData['longETAcauseOptions'] = [null, 'Facility', 'Prescheduled', 'Ride Care'];
  ___arguments.context.pageData['typeCancelationReasonOptions'] = [null, 'Facility', 'Client', 'Ride Care'];
  ___arguments.context.pageData['typeReviewStatusOptions'] = [null, 'Pending', 'Needs Attention', 'Processed'];
  ___arguments.context.pageData['typeInsuranceOptions'] = [null, 'SoonerCare', 'Private Insurance', 'Medicare', 'Medicaid', 'Other'];
  ___arguments.context.pageData['isReadOnlyMode'] = true;
  ___arguments.context.pageData['showDataQuery'] = true;
  ___arguments.context.pageData['showAdvancedFilters'] = false;
  console.log('On Before Page Enter print Page Data then App Data:');
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.appData);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/89f36a5f06a88beb7a4168f8c62af8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['showAllColumns'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/1c94c69498936d6389d94b712646580d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& isLongETA = TRUE';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/98a64a9922fd6a0fb02b2b1ca4e17e9f/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/d3d664ba260c7449dd2c7b8510b7d64f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('d0542e2dcb86d77de41d3dad9db99522');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDispatcher2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driver')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver1_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.driverAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relDriver2_Employee.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle1_Vehicle.objectId')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.vehicleAlt')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0542e2dcb86d77de41d3dad9db99522'), 'transportersData.transportRecord.relVehicle2_Vehicle.objectId'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/d0542e2dcb86d77de41d3dad9db99522/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var relations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  relations = ({  });
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher1_Employee.objectId'))) {
    relations['relDispatcher1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcher')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDriver1_Employee.objectId'))) {
    relations['relDriver1_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.driver')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relVehicle1_Vehicle.objectId'))) {
    relations['relVehicle1_Vehicle'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.vehicle')) });
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) && (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) != (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.relDispatcher2_Employee.objectId'))) {
    relations['relDispatcher2_Employee'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.dispatcherAlt')) });
  }
  if ((Object.keys(relations)).length != 0) {
    await Backendless.Data.of('Transport').deepSave( (Object.assign(({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId')) }), relations)) );
    await (getChannelInstance('default')).send('reload-table-records:Transport', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'transportersData.transportRecord.objectId'))] }));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
    stopSetTimeout('transportUpdateTransporters');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', true);
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7592c3f42e211e7732ac731a6d83ccdd', false);
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/f013363f1862d6245c6531da6e1a2084/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0542e2dcb86d77de41d3dad9db99522', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('d0542e2dcb86d77de41d3dad9db99522');
  stopSetTimeout('transportUpdateTransporters');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/6399082b912811691448fd5b7a21bd32/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/f365f5cf35cc0a06a984919b6c5c8778/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/38d18874f73dfcca4eb9767316d5cf7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/2185cc4ac3bb10e38de389d390829fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/b22b2f973d1b4698a7c92c0e8d9d6324/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/835cf0dfbd76bcd30477cd090c163ad1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      // This just makes "Needs Dispatched" the default view
  ___arguments.context.pageData['showTestData'] = ___arguments.value;
  if (___arguments.value == true) {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = '';
  } else {
    // This just makes "Needs Dispatched" the default view
    ___arguments.context.pageData['strWhereClauseTestDataModifier'] = ' && rel_TransportRequest.rel_Client.nameFirst != \'test\'';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/24fa74ce6999f63dead2abab11c8bf03/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.submissionOtherInformation'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'transportReusableData.isReadOnlyMode'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/028571eba6567082fe2231fee0a1ce7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.pageData);
  console.log(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.objectId'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('transport-requests', ({ [`strWhereClauseBase`]: ['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'transportReusableData.transportRequestRecord.objectId')),'\''].join('') }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/4226d63cdffccef288cb2f65bf76f254/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'30\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/376d2a86b3a13988f86809160d3fd53b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/f7f2b5cd664bdecb5b97e80d13ee8895/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == true) {
    ___arguments.context.pageData['showDataQuery'] = false;
  } else {
    ___arguments.context.pageData['showDataQuery'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/d507be9497133c7612b96c6652567b07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function clearFilterForm() {
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['startDate'] = null;
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['endDate'] = null;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('38acd20ba9687798ff0b0da2b48be7ce', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('a745e768e561369ac481cf94c5117b81', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('40d5fefc505cf947ae7bbc5608aff6d7', null);
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientNameLast'] = null;
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['clientDOB'] = null;
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('5167732fd546fa76851fc54a54383039', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('898fa3fe0e5217cf830fd3da08dfbbcd', null);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setValue(value) })('e0af5b42fdc13722ba86ec8a620602f9', null);
  ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['tribalStatus'] = null;
}


  await clearFilterForm();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/b842acfb7d1c2b2f9f61e7566fefee64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var whereClauseModifier, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  whereClauseModifier = '';
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& datetimeDispatch >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'startDate')),'\' && datetimeDispatch <= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'endDate')),'\' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('38acd20ba9687798ff0b0da2b48be7ce')).map(async item => {; return (['relDriver1_Employee.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('a745e768e561369ac481cf94c5117b81')).map(async item => {; return (['relDispatcher1_Employee.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('40d5fefc505cf947ae7bbc5608aff6d7')).map(async item => {; return (['rel_TransportRequest.rel_EntityRequestingTransport.objectId = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.nameLast LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientNameLast')),'%\' '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.dateOfBirth > \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) - 43200000,'\' && rel_TransportRequest.rel_Client.dateOfBirth < \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'clientDOB')) + 43200000,'\' '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('5167732fd546fa76851fc54a54383039')).map(async item => {; return (['typeStatus = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('898fa3fe0e5217cf830fd3da08dfbbcd')).map(async item => {; return (['typeReviewStatus = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
  }
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')) != null && (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& (',(await Promise.all((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getValue() })('e0af5b42fdc13722ba86ec8a620602f9')).map(async item => {; return (['typeCancelationReason = \'',(getObjectProperty(item, 'value')),'\''].join(''));}))).join(' OR '),') '].join(''));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')) != '') {
    whereClauseModifier = String(whereClauseModifier) + String(['&& rel_TransportRequest.rel_Client.isFedRecognizedTribal = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'tribalStatus')),' '].join(''));
  }
  ___arguments.context.pageData['strWhereClauseBase'] = whereClauseModifier;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/973afdd6e8923de509b871483f0dda04/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/7bf48217c09c0cc64dcb4047fa78ffd7/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/6deca5e7f5a5471641d333d5843ba6ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['driverOptions'] = (getObjectProperty(___arguments.context.pageData, 'driverOptions'));
  ___arguments.context.dataModel['dispatcherOptions'] = (getObjectProperty(___arguments.context.pageData, 'dispatcherOptions'));
  ___arguments.context.dataModel['requesterEntityOptions'] = (getObjectProperty(___arguments.context.pageData, 'requesterEntityOptions'));
  ___arguments.context.dataModel['statusOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'statusOptions')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['typeReviewStatusOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeReviewStatusOptions')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['typeCancelationReasonOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeCancelationReasonOptions')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
  ___arguments.context.dataModel['showAdvancedFilters'] = (getObjectProperty(___arguments.context.pageData, 'showAdvancedFilters'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/d5d47e662f92bcdc1f590b2c2b4c2038/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/60f77747b19d02ce877cc733ca2c7651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& datetimeDispatch >= DATESUB(NOW(), \'7\', \'DAY\')';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/df9f74a5ce78df823282503827938f31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['strWhereClauseBase'] = '&& hasNegativeMileage = TRUE';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/569a9e12f37c7374aa114b16b4d9d5aa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce'), 'showAdvancedFilters')) == false) {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['showAdvancedFilters'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('6deca5e7f5a5471641d333d5843ba6ce')['showAdvancedFilters'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/transports_backup9_6_24/components/c9e8f827c11368a40251f3c1702bdfa4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showDataQuery')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-management/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'User Management',[`pageName`]: 'user-management' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/user-management/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      console.log(___arguments.context.appData);

  return (await (async function(appData, pageData) {
	return [
	  {"type":"actions", "field": "actions", "headerName": "", "width": 100, "minWidth": 80, "pinned": "left", meta: { align: "center"}},

	  {
	    "field": "nameFull",
	    "headerName": "Name",
	    "sort": "asc",
	    "flex": 1,
	    "headerTooltip": "Users Full Name",
	    "pinned": "left",
	    "width": 120,
	    "minWidth": 120,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "jobTitle",
	    "headerName":"Job Title",
	    "flex": 1,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5,
	    "headerTooltip": "Current Job Title",
	    "width": 120,
	    "minWidth": 120,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {"field": "relEmail_Users.email",
	  "headerName":"Email",
	  "sortable": true,
	  "flex": 1,
	  "headerTooltip": "Email Address",
	    "width": 180,
	    "minWidth": 180,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	 {
	    "field": "relManager_Employee.nameFull",
	    "headerName": "Manager",
	    "sortable": true,
	    "flex": 1,
	    "headerTooltip": "Manager Name",
	    "width": 120,
	    "minWidth": 120,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "dateStartString",
	    "headerName": "Start Date",
	    "sortable": true,
	    "flex": 1,
	    "headerTooltip": "Start Date",
	    "width": 100,
	    "minWidth": 100,
	    "sortable": true,
	    "editable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "samsaraDriverId",
	    "headerName":"Samsara Driver ID",
	    "sortable": true,
	    "flex": 1,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5,
	    "headerTooltip": "Samsara Driver ID",
	    "width": 100,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },


	  {
	    "field": "employmentStatus",
	    "headerName": "Employment Status",
	    "sortable": true,
	    "flex": 1,
	    "headerTooltip": "Employment Status",
	    "width": 250,
	    "minWidth": 250,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "relEmail_Users.userStatus",
	    "headerName": "User Status",
	    "sortable": true,
	    "flex": 1,
	    "headerTooltip": "User Status",
	    "width": 100,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	]


	/*

	"headerTooltip": "HIPAA compliant transport reference.  [first three letters of client's first name].[first three letters of client last name].[submission number].",
	    "pinned": "left",
	    "width": 120,
	    "minWidth": 75,
	    "sortable": true,
	    "editable": false,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "center" }

	    //Removed from table on 9.4.24

	    {"field": "phone",
	  "headerName":"Phone",
	  "sortable": true,
	  "flex": 1,
	  "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5,
	  "headerTooltip": "Phone Number",
	    "width": 120,
	    "minWidth": 120,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	 },


	  {"field": "standardHours",
	  "headerName":"Normal Hours",
	  "sortable": true,
	  "flex": 1,
	  "headerTooltip": "Work Hours",
	    "width": 160,
	    "minWidth": 160,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }

	  },

	  {"field": "city",
	  "headerName":"Location",
	  "sortable": true,
	  "flex": 1,
	    "headerTooltip": "Location",
	    "width": 100,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	  {
	    "field": "zipcode",
	    "headerName": "Zip Code",
	    "sortable": true,
	    "editable": appData.currentUser?.rideCareUserAttributes?.permissionLevel >= 5,
	    "flex": 1,
	    "headerTooltip": "Zip Code",
	    "width": 100,
	    "minWidth": 100,
	    "sortable": true,
	    "wrapHeaderText": true,
	    "autoHeaderHeight": true,
	    "meta": { "align": "left" }
	  },

	    */
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var error, waitCount, userObject, disableUser, resetPassword, intervalId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function resetUserPasswordTransaction() {
  try {
    resetPassword = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = resetPassword;

      ___arguments.context.pageData['tempPassword'] = (['temp',(getObjectProperty(___arguments['recordItem'], 'nameFirst')).charAt(0).toLowerCase(),(getObjectProperty(___arguments['recordItem'], 'nameLast')).toLowerCase()].join(''));
      console.log(getObjectProperty(___arguments.context.pageData, 'tempPassword'));
      console.log('Temp Pass Created');
      await Backendless.Request.post(`${Backendless.appPath}/services/UserService/assignTempPassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'identity': (getObjectProperty(___arguments['recordItem'], 'relEmail_Users.email')),'newPassword': (getObjectProperty(___arguments.context.pageData, 'tempPassword')) });
      console.log('Temp Pass Assigned to User');
      await Backendless.Request.post(`${Backendless.appPath}/services/UserService/sendPasswordReset`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments['recordItem'], 'relEmail_Users.email'))));
      console.log('Password Reset Email Sent');
      ___arguments.context.pageData[(getObjectProperty(___arguments.context.pageData, 'tempPassword'))] = null;

    })();

    ___arguments.context.pageData['modalTitle'] = 'Password Recovery Email Sent';
    ___arguments.context.pageData['modalContent'] = 'User has received an email with a link to reset their password.';
    ___arguments.context.pageData['modalSubmit'] = '';
    ___arguments.context.pageData['modalClose'] = '';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7de7c1b6277a740c35d8b1feab051014');
    await new Promise(r => setTimeout(r, 3500 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');
    console.log('Popup Closed');
    console.log('Reset Operation Complete');

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['modalTitle'] = 'Password Reset Failed!';
    ___arguments.context.pageData['modalContent'] = 'System Issue. Contact the System Admin!';
    ___arguments.context.pageData['modalSubmit'] = '';
    ___arguments.context.pageData['modalClose'] = '';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7de7c1b6277a740c35d8b1feab051014');
    await new Promise(r => setTimeout(r, 4000 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');

  } finally {
    ___arguments.context.pageData['confirmModalSubmit'] = null;

  }
}


  if (___arguments['eventName'] == 'viewProfile') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile', ({ [`selectedUser`]: ___arguments['recordItem'],[`viewAnotherUser`]: true }));
  } else if (___arguments['eventName'] == 'disableUser') {
  } else if (___arguments['eventName'] == 'resetPassword') {
    ___arguments.context.pageData['modalTitle'] = 'Confirm Password Reset';
    ___arguments.context.pageData['modalContent'] = '<p>Are you sure you would like to reset the password for this user?<p>  <p>**This action may refresh the webpage and require you to login again. This bug is currently being resolved.**<p>';
    ___arguments.context.pageData['modalSubmit'] = 'Reset Password';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7de7c1b6277a740c35d8b1feab051014');
    console.log('!!!Record');
    console.log(___arguments['recordItem']);
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'confirmModalSubmit')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'confirmModalSubmit')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Disable operation timed out after 20s.');
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'confirmModalSubmit')) == true) {
      console.log('Record 1');
      console.log(___arguments['recordItem']);
      await resetUserPasswordTransaction();
    } else if ((getObjectProperty(___arguments.context.pageData, 'confirmModalSubmit')) == false) {
      ___arguments.context.pageData['confirmModalSubmit'] = null;
    }
  } else if (___arguments['eventName'] == 'editUser') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('04aab01225a85ba385b19dbb9cfb268f');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('90412f7656387e796fdfd4df7aa2ccb6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('257b3f065bf11cf2f38a1e66930dcfee', true);
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['selectedUser'] = ___arguments['recordItem'];
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['managers'] = (getObjectProperty(___arguments.context.pageData, 'managers'));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['userRoles'] = (getObjectProperty(___arguments.context.pageData, 'userRoles'));
    if ((getObjectProperty(___arguments['recordItem'], 'employmentStatus')) == 'Employed') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['buttonUserStatus'] = 'Disable User';
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['displayActiveUser'] = true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['buttonUserStatus'] = 'Enable User';
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['displayInactiveUser'] = true;
    }
    ___arguments.context.pageData['currentManager'] = ((await Backendless.Data.of('Employee').loadRelations((getObjectProperty(___arguments['recordItem'], 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('relManager_Employee').setPageSize(10).setOffset(0).setProperties('nameFull')))[0]);
    ___arguments.context.pageData['currentUserRole'] = (await Backendless.Request.get(`${Backendless.appPath}/services/UserService/UserRolesById`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'userObjectId': JSON.stringify((getObjectProperty(___arguments['recordItem'], 'relEmail_Users.objectId'))) }).send());
    console.log('Current Manager!!!');
    console.log(getObjectProperty(___arguments.context.pageData, 'currentManager'));
    console.log('Current Role!!!');
    console.log(getObjectProperty(___arguments.context.pageData, 'currentUserRole'));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['currentManager'] = (getObjectProperty(___arguments.context.pageData, 'currentManager'));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('90412f7656387e796fdfd4df7aa2ccb6'))['currentUserRole'] = (getObjectProperty(___arguments.context.pageData, 'currentUserRole'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('257b3f065bf11cf2f38a1e66930dcfee', false);
    console.log('Record Item');
    console.log(___arguments['recordItem']);
    try {

      ;(function() {
        const callback = async () => {
            await (getChannelInstance('default')).send('editing-table:Employee', (await BackendlessUI.Functions.Custom['fn_c0ec24bc31d97a37ccf5fe7b144f4fab']((getObjectProperty(___arguments['recordItem'], 'objectId')))));

        };

        const timerId = 'userManagementEditUser';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
      addItemToList((getObjectProperty(___arguments.context.appData, 'intervalIds')), 'userManagementEditUser');

    } catch (error) {
      console.log('TR Channel Failed');
      console.log(error);

    }
  }

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/user-management/components/7de7c1b6277a740c35d8b1feab051014/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      ___arguments.context.pageData['confirmModalSubmit'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');

  },
  /* handler:onSubmit */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      ___arguments.context.pageData['confirmModalSubmit'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/user-management/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setUserRoleOptions() {
  if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) == 8) {
    ___arguments.context.pageData['userRoles'] = [({ [`label`]: 'Driver',[`value`]: 'Driver' }), ({ [`label`]: 'Dispatcher',[`value`]: 'Dispatcher' }), ({ [`label`]: 'Manager',[`value`]: 'Manager' }), ({ [`label`]: 'FleetManager',[`value`]: 'FleetManager' }), ({ [`label`]: 'HumanResources',[`value`]: 'HumanResources' }), ({ [`label`]: 'Accounting',[`value`]: 'Accounting' }), ({ [`label`]: 'Admin',[`value`]: 'Admin' }), ({ [`label`]: 'SuperAdmin',[`value`]: 'SuperAdmin' })];
  } else if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) == 7) {
    ___arguments.context.pageData['userRoles'] = [({ [`label`]: 'Driver',[`value`]: 'Driver' }), ({ [`label`]: 'Dispatcher',[`value`]: 'Dispatcher' }), ({ [`label`]: 'Manager',[`value`]: 'Manager' }), ({ [`label`]: 'FleetManager',[`value`]: 'FleetManager' }), ({ [`label`]: 'HumanResources',[`value`]: 'HumanResources' }), ({ [`label`]: 'Accounting',[`value`]: 'Accounting' }), ({ [`label`]: 'Admin',[`value`]: 'Admin' })];
  } else if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) == 6) {
    ___arguments.context.pageData['userRoles'] = [({ [`label`]: 'Driver',[`value`]: 'Driver' }), ({ [`label`]: 'Dispatcher',[`value`]: 'Dispatcher' }), ({ [`label`]: 'Manager',[`value`]: 'Manager' }), ({ [`label`]: 'FleetManager',[`value`]: 'FleetManager' }), ({ [`label`]: 'Accounting',[`value`]: 'Accounting' }), ({ [`label`]: 'Admin',[`value`]: 'Admin' })];
  } else if ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) == 5) {
    ___arguments.context.pageData['userRoles'] = [({ [`label`]: 'Driver',[`value`]: 'Driver' }), ({ [`label`]: 'Dispatcher',[`value`]: 'Dispatcher' }), ({ [`label`]: 'Manager',[`value`]: 'Manager' }), ({ [`label`]: 'FleetManager',[`value`]: 'FleetManager' }), ({ [`label`]: 'Admin',[`value`]: 'Admin' })];
  }
}


  ___arguments.context.pageData['jobTitleOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setPageSize(10).setDistinct(true))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'jobTitle')),[`value`]: (getObjectProperty(item, 'jobTitle')) });})));
  ___arguments.context.pageData['managers'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('isManager = TRUE && nameFull NOT LIKE \'%test%\' && employmentStatus = \'Employed\'').setRelated('relEmail_Users.email').setSortBy('nameFull asc').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: [(getObjectProperty(item, 'nameFull')), (getObjectProperty(item, 'objectId')), (getObjectProperty(item, 'relEmail_Users.email'))] });})));
  await setUserRoleOptions();
  console.log('Managers Values');
  console.log(getObjectProperty(___arguments.context.pageData, 'managers'));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    
  },
  /* handler:onEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var intervalId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  if ((getObjectProperty(___arguments.context.appData, 'intervalIds')).length > 0) {
    var intervalId_list = (getObjectProperty(___arguments.context.appData, 'intervalIds'));
    for (var intervalId_index in intervalId_list) {
      intervalId = intervalId_list[intervalId_index];
      stopSetTimeout(intervalId);
    }
  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/user-management/components/278f8d61e79781a8c016cc34146e2e11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('f0f986617b42b2b699e6666d640e1d53');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-management/components/93164d4ef5dde5c6e5cb57f18817dfc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('f0f986617b42b2b699e6666d640e1d53');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-management/components/2c5b2fafe94eb896eec3afc2d6ddc7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['testText'] = (getObjectProperty(___arguments.context.pageData, 'testText'));
  ___arguments.context.dataModel['jobTitleOptions'] = (getObjectProperty(___arguments.context.pageData, 'jobTitleOptions'));
  ___arguments.context.dataModel['userRoles'] = (getObjectProperty(___arguments.context.pageData, 'userRoles'));
  ___arguments.context.dataModel['managers'] = (getObjectProperty(___arguments.context.pageData, 'managers'));
  ___arguments.context.dataModel['userStartDate'] = (new Date());

  },
  /* handler:onBeforeMount */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, newEmployee, newUser, userCreation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d835d4b59e2d3711ab61b5147d300c', true);
  ___arguments.context.dataModel['tempPassword'] = (['temp',(getObjectProperty(___arguments.context.dataModel, 'nameFirst')).charAt(0).toLowerCase(),(getObjectProperty(___arguments.context.dataModel, 'nameLast')).toLowerCase()].join(''));
  ___arguments.context.dataModel['nameFull'] = ([(getObjectProperty(___arguments.context.dataModel, 'nameFirst')),' ',(getObjectProperty(___arguments.context.dataModel, 'nameLast'))].join(''));
  if ((getObjectProperty(___arguments.context.dataModel, 'userRoleValue')) == 'Driver' || (getObjectProperty(___arguments.context.dataModel, 'userRoleValue')) == 'Dispatcher') {
    ___arguments.context.dataModel['isManager'] = false;
  } else {
    ___arguments.context.dataModel['isManager'] = true;
  }
  console.log(getObjectProperty(___arguments.context.dataModel, 'nameFirst'));
  console.log(getObjectProperty(___arguments.context.dataModel, 'nameLast'));
  console.log(getObjectProperty(___arguments.context.dataModel, 'email'));
  console.log(getObjectProperty(___arguments.context.dataModel, 'jobTitleValue'));
  console.log(getObjectProperty(___arguments.context.dataModel, 'userStartDate'));
  console.log(getObjectProperty(___arguments.context.dataModel, 'managerValue.1'));
  console.log(getObjectProperty(___arguments.context.dataModel, 'samsaraId'));
  console.log(getObjectProperty(___arguments.context.dataModel, 'userRoleValue'));
  console.log(getObjectProperty(___arguments.context.dataModel, 'tempPassword'));
  try {
    userCreation = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = userCreation;

      newUser = (await Backendless.UserService.register( new Backendless.User({ 'email': (getObjectProperty(___arguments.context.dataModel, 'email')),'password': (getObjectProperty(___arguments.context.dataModel, 'tempPassword')) }) ));
      console.log('Register User Complete');
      console.log((await Backendless.Request.post(`${Backendless.appPath}/services/UserService/assignUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'user': (getObjectProperty(___arguments.context.dataModel, 'email')),'roleType': (getObjectProperty(___arguments.context.dataModel, 'userRoleValue')) })));
      console.log('Add Role to User Complete');
      console.log((await Backendless.UserService.update( new Backendless.User(({ [`objectId`]: (getObjectProperty(newUser, 'objectId')),[`name`]: (getObjectProperty(___arguments.context.dataModel, 'nameFull')) })) )));
      console.log('Add Name to User Complete');
      newEmployee = (await Backendless.Data.of('Employee').save( ({ [`nameFirst`]: (getObjectProperty(___arguments.context.dataModel, 'nameFirst')),[`nameLast`]: (getObjectProperty(___arguments.context.dataModel, 'nameLast')),[`emailAlt`]: (getObjectProperty(___arguments.context.dataModel, 'email')),[`dateStart`]: (getObjectProperty(___arguments.context.dataModel, 'userStartDate')),[`jobTitle`]: (getObjectProperty(___arguments.context.dataModel, 'jobTitleValue')),[`samsaraDriverId`]: (getObjectProperty(___arguments.context.dataModel, 'samsaraId')),[`employmentStatus`]: 'Employed',[`isManager`]: (getObjectProperty(___arguments.context.dataModel, 'isManager')) }) ));
      console.log('Create Employee Complete');
      console.log((await Backendless.Data.of('Employee').setRelation(({ [`objectId`]: (getObjectProperty(newEmployee, 'objectId')) }), 'relEmail_Users', (['objectId = \'',(getObjectProperty(newUser, 'objectId')),'\''].join('')))));
      console.log('Employee to User Relation Complete');
      console.log((await Backendless.Data.of('Employee').addRelation(({ [`objectId`]: (getObjectProperty(newEmployee, 'objectId')) }), 'relManager_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'managerValue.1')),'\''].join('')))));
      console.log('Employee to Manager Relation Complete');
      await Backendless.Messaging.sendEmailFromTemplate('Onboarding Email', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`nameFirst`]: (getObjectProperty(___arguments.context.dataModel, 'nameFirst')),[`email`]: (getObjectProperty(___arguments.context.dataModel, 'email')),[`tempPassword`]: (getObjectProperty(___arguments.context.dataModel, 'tempPassword')) }), undefined);
      console.log('New Acct Email Send');
      await Backendless.Messaging.sendEmailFromTemplate('Manager Notification_New User', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'managerValue.2')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`managerNameFull`]: (getObjectProperty(___arguments.context.dataModel, 'managerValue.0')),[`userNameFull`]: [(getObjectProperty(___arguments.context.dataModel, 'nameFirst')),' ',(getObjectProperty(___arguments.context.dataModel, 'nameLast'))].join(''),[`email`]: (getObjectProperty(___arguments.context.dataModel, 'email')),[`tempPassword`]: (getObjectProperty(___arguments.context.dataModel, 'tempPassword')) }), undefined);
      console.log('Manager Notification Email Send');

    })();

    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d835d4b59e2d3711ab61b5147d300c', false);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('f0f986617b42b2b699e6666d640e1d53');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7de7c1b6277a740c35d8b1feab051014');
    ___arguments.context.pageData['modalTitle'] = 'User Creation Successful ';
    ___arguments.context.pageData['modalContent'] = 'The new user will be notified by email with instructions to create their account.';
    ___arguments.context.pageData['modalSubmit'] = '';
    ___arguments.context.pageData['modalClose'] = '';
    await new Promise(r => setTimeout(r, 2500 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');
    await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d835d4b59e2d3711ab61b5147d300c', false);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('f0f986617b42b2b699e6666d640e1d53');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7de7c1b6277a740c35d8b1feab051014');
    ___arguments.context.pageData['modalTitle'] = 'User Creation Failed! ';
    ___arguments.context.pageData['modalContent'] = 'Please contact system admin';
    ___arguments.context.pageData['modalSubmit'] = '';
    ___arguments.context.pageData['modalClose'] = '';
    await new Promise(r => setTimeout(r, 4000 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/user-management/components/c07a11f48cce1b58068d03b895487033/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['firstName'] = (getObjectProperty(___arguments.context.pageData, 'firstName'));
  ___arguments.context.dataModel['lastName'] = (getObjectProperty(___arguments.context.pageData, 'lastName'));
  ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'objectId'));
  ___arguments.context.dataModel['currentManager'] = (getObjectProperty(___arguments.context.pageData, 'currentManager'));

  },
  /* handler:onVisibilityChange */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['managers'] = (getObjectProperty(___arguments.context.pageData, 'managers'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/user-management/components/eb792bb43758ee099a569edf17b6db57/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/user-management/components/39ea8c12cdeaa5df4854c8d3e61c25fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.Data.of('Employee').setRelation(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'objectId')) }), 'relManager_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c07a11f48cce1b58068d03b895487033'), 'managerValue')),'\''].join('')));
    console.log('Manager Successfully Updated ');
    ___arguments.context.pageData['modalTitle'] = 'Manager Update Successful';
    ___arguments.context.pageData['modalContent'] = 'The update operation has completed successfully.';
    ___arguments.context.pageData['modalSubmit'] = '';
    ___arguments.context.pageData['modalClose'] = '';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('eb792bb43758ee099a569edf17b6db57');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7de7c1b6277a740c35d8b1feab051014');
    await new Promise(r => setTimeout(r, 3500 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['modalTitle'] = 'Manager Update Failed';
    ___arguments.context.pageData['modalContent'] = 'Please contact the system admin.';
    ___arguments.context.pageData['modalSubmit'] = '';
    ___arguments.context.pageData['modalClose'] = '';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('eb792bb43758ee099a569edf17b6db57');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7de7c1b6277a740c35d8b1feab051014');
    await new Promise(r => setTimeout(r, 4000 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7de7c1b6277a740c35d8b1feab051014');

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-management/components/d8666ce1c0c2e4741837bee459c99a39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('eb792bb43758ee099a569edf17b6db57');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-management/components/90412f7656387e796fdfd4df7aa2ccb6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.dataModel, 'updatedManager.1')) || (getObjectProperty(___arguments.context.dataModel, 'updatedUserRole'))) != null) {
    console.log('Update Operation Needed');
    console.log(getObjectProperty(___arguments.context.dataModel, 'selectedUser.objectId'));
    console.log(getObjectProperty(___arguments.context.dataModel, 'updatedManager.1'));
    console.log('Selected User Email');
    console.log(getObjectProperty(___arguments.context.dataModel, 'selectedUser'));
    console.log(getObjectProperty(___arguments.context.dataModel, 'selectedUser.relEmail_Users.email'));
    console.log(getObjectProperty(___arguments.context.dataModel, 'updatedUserRole'));
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9c390f4c19477d49d5bb2f5a2bd0626', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('257b3f065bf11cf2f38a1e66930dcfee', true);
      if ((getObjectProperty(___arguments.context.dataModel, 'updatedManager.1')) != null) {
        await Backendless.Data.of('Employee').setRelation(({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'selectedUser.objectId')) }), 'relManager_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'updatedManager.1')),'\''].join('')));
        console.log('Manager Update Operation Finished');
        ___arguments.context.dataModel['currentManager.nameFull'] = (getObjectProperty(___arguments.context.dataModel, 'updatedManager.0'));
        console.log('"Current Manager" text updated');
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'updatedUserRole')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'updatedUserRole')) == 'Driver' || (getObjectProperty(___arguments.context.dataModel, 'updatedUserRole')) == 'Dispatcher') {
          ___arguments.context.dataModel['isManager'] = false;
        } else {
          ___arguments.context.dataModel['isManager'] = true;
        }
        if ((getObjectProperty(___arguments.context.dataModel, 'currentUserRole.1')) != null) {
          await Backendless.Request.post(`${Backendless.appPath}/services/UserService/removeUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'user': (getObjectProperty(___arguments.context.dataModel, 'selectedUser.relEmail_Users.email')),'roleType': (getObjectProperty(___arguments.context.dataModel, 'currentUserRole.1')) });
          console.log('Current User Role Removed');
        }
        await Backendless.Request.post(`${Backendless.appPath}/services/UserService/assignUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'user': (getObjectProperty(___arguments.context.dataModel, 'selectedUser.relEmail_Users.email')),'roleType': (getObjectProperty(___arguments.context.dataModel, 'updatedUserRole')) });
        console.log('UserRole Update Operation Finished');
        await Backendless.Data.of('Employee').bulkUpdate( (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'selectedUser.objectId')),'\''].join('')), ({ [`isManager`]: (getObjectProperty(___arguments.context.dataModel, 'isManager')) }) );
        console.log('isManager field updated in Employee database');
        ___arguments.context.dataModel['currentUserRole.1'] = (getObjectProperty(___arguments.context.dataModel, 'updatedUserRole'));
        console.log('"Current User Role" text updated');
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('257b3f065bf11cf2f38a1e66930dcfee', false);
      ___arguments.context.pageData['flagDelay'] = 1;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9c390f4c19477d49d5bb2f5a2bd0626', true);

    } catch (error) {
      console.log(error);
      console.log('Manager Update Operation Failed');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f11fecce822f0534f87c6b99e99b34b9', true);

    } finally {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c17b6cdc4712c942bba9d93ccbe53072', null);
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('b2765ac9d101d4b24ce4acbaee86f751', null);
      await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');
      console.log('Data Reloaded In Table');

    }
  } else {
    console.log('No Nothing');
  }

  },
  /* handler:onSubmit */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['userEditElements'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/user-management/components/c17b6cdc4712c942bba9d93ccbe53072/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-management/components/8c0c67bc8672ec65bbc387ee032417fa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f11fecce822f0534f87c6b99e99b34b9', false);
  console.log('Text Edit Failed');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9c390f4c19477d49d5bb2f5a2bd0626', false);
  console.log('Text Edit Successful');
  console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d')));
  console.log('Data Reloaded');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('04aab01225a85ba385b19dbb9cfb268f');
  console.log('Modal closed');
  stopSetTimeout('userManagementEditUser');
  console.log('RT Internal Stopped ');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-management/components/28131afc1999845eb391e9b5d72da151/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, userObject, enableUser, disableUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'userStatusActionReady')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'selectedUser.employmentStatus')) == 'Employed') {
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userStatusChangeElements'] = true;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userEditElements'] = false;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['selectUserStatus'] = true;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['headerUserStatus'] = 'Disable User Confirmation:';
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['buttonUserStatus'] = 'Disable User';
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['textUserStatusChange'] = 'Before disabling the user, please select if this employee should be re-hired in the future. ';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9268e5596a6b0e96834a945baa513c41', false);
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userStatusActionReady'] = 'Disable';
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'selectedUser.employmentStatus')) != 'Employed') {
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userStatusChangeElements'] = true;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userEditElements'] = false;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['selectUserStatus'] = false;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['headerUserStatus'] = 'Enable User Confirmation:';
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['buttonUserStatus'] = 'Yes, Enable User';
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['textUserStatusChange'] = 'Are you sure you would like to enable this user? They will regain access to the system and be able to login again.';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9268e5596a6b0e96834a945baa513c41', false);
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userStatusActionReady'] = 'Enable';
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'userStatusActionReady')) == 'Disable' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'newEmployeeStatus')) != null) {
    console.log('Selected User Values!!!');
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'selectedUser.objectId'));
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'selectedUser.relEmail_Users.email'));
    try {
      disableUser = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = disableUser;

        await Backendless.Data.of('Employee').bulkUpdate( (['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'selectedUser.objectId')),'\''].join('')), ({ [`employmentStatus`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'newEmployeeStatus')) }) );
        console.log('Employee Status Option Updated');
        userObject = (
            await (async function(userIdentity){
              var userColumns = await Backendless.UserService.describeUserClass()
              var identityColumn = userColumns.find(column => column.identity)
              var whereClause = `${identityColumn.name} = '${userIdentity}'`
              var query = Backendless.DataQueryBuilder.create().setWhereClause(whereClause)
              var users = await Backendless.Data.of(Backendless.User).find(query)

              return users[0]
           })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'selectedUser.relEmail_Users.email')))
        );
        console.log(userObject);
        await Backendless.Request.put(`${Backendless.appPath}/services/UserService/disableUser`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(userObject, 'objectId'))));
        console.log('User updated to "Disabled"');

      })();

      ___arguments.context.pageData['flagDelay'] = 1;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9c390f4c19477d49d5bb2f5a2bd0626', true);
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['selectedUser.employmentStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'newEmployeeStatus'));
      console.log('selected user updated to disabled');
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['buttonUserStatus'] = 'Enable User';
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['displayActiveUser'] = false;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['displayInactiveUser'] = true;

    } catch (error) {
      console.log(error);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f11fecce822f0534f87c6b99e99b34b9', true);

    } finally {
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userEditElements'] = true;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userStatusActionReady'] = null;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userStatusChangeElements'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9268e5596a6b0e96834a945baa513c41', true);

    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'userStatusActionReady')) == 'Enable') {
    try {
      enableUser = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = enableUser;

        await Backendless.Data.of('Employee').bulkUpdate( (['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'selectedUser.objectId')),'\''].join('')), ({ [`employmentStatus`]: 'Employed' }) );
        console.log('Employee Status Updated to Employed');
        userObject = (
            await (async function(userIdentity){
              var userColumns = await Backendless.UserService.describeUserClass()
              var identityColumn = userColumns.find(column => column.identity)
              var whereClause = `${identityColumn.name} = '${userIdentity}'`
              var query = Backendless.DataQueryBuilder.create().setWhereClause(whereClause)
              var users = await Backendless.Data.of(Backendless.User).find(query)

              return users[0]
           })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6'), 'selectedUser.relEmail_Users.email')))
        );
        console.log(userObject);
        await Backendless.Request.put(`${Backendless.appPath}/services/UserService/enableUser`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(userObject, 'objectId'))));
        console.log('User updated to "Enabled"');

      })();

      ___arguments.context.pageData['flagDelay'] = 1;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9c390f4c19477d49d5bb2f5a2bd0626', true);
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['buttonUserStatus'] = 'Disable User';
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['selectedUser.employmentStatus'] = 'Employed';
      console.log('selected user updated to employed');
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['displayActiveUser'] = true;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['displayInactiveUser'] = false;

    } catch (error) {
      console.log(error);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f11fecce822f0534f87c6b99e99b34b9', true);

    } finally {
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userEditElements'] = true;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userStatusActionReady'] = null;
      ___arguments.context.getComponentDataStoreByUid('90412f7656387e796fdfd4df7aa2ccb6')['userStatusChangeElements'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9268e5596a6b0e96834a945baa513c41', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28131afc1999845eb391e9b5d72da151', true);
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('5fcda5981254a53804fabe59aaabc5ae', null);

    }
  }
  await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).reloadData() })('5ace80b8ec397e9c5c0b03221b61217d');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-management/components/f9c390f4c19477d49d5bb2f5a2bd0626/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'flagDelay')) == 1) {
    ___arguments.context.pageData['flagDelay'] = 0;
    await new Promise(r => setTimeout(r, 3000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9c390f4c19477d49d5bb2f5a2bd0626', false);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/user-management/components/f11fecce822f0534f87c6b99e99b34b9/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/vehicles/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Vehicles',[`pageName`]: 'vehicles' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/vehicles/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData) {
	return [
	  {"type":"actions", "field": "actions", "width": 75, "minWidth": 75, "pinned": "left", meta: { align: "center"}},
	  {
	    "field": "vehicleName",
	    "headerName": "Vehicle Name",
	    "sort": "asc",
	    "sortable": true,
	    "width": 150,
	    "pinned": "left"
	  },
	  {"field": "relCurrentlyAssignedTo_Employee.nameFull", "headerName":"Assignee", "sortable": true, "width": 180, "editable": false},
	  {"field": "samsaraVehicleId", "headerName":"Samsara Vehicle Id", "sortable": true, "width": 160, "editable": true},
	  {
	    "cellEditor"      : "agSelectCellEditor",
	    "field"           : "status",
	    "headerName"      : "Status",
	    "editable"        : true,
	    "cellEditorParams": { "values": pageData.statusOptions || [] }
	  },
	  {
	    "type"              : "selectColumn",
	    "field"             : "type",
	    "headerName"        : "Type",
	    "isMulti"           : true,
	    "editable"          : true,
	    "cellRendererParams": { "withChips": true },
	    "cellEditorParams"  : { "values": pageData.typeOptions || [] }
	  },
	  {"field": "make", "headerName":"Make", "sortable": true, "width": 160, "editable": true},
	  {"field": "model", "headerName":"Model", "sortable": true, "width": 160, "editable": true},
	  {"field": "VIN", "headerName":"VIN", "sortable": true, "width": 160, "editable": true},
	  {"field": "vehicleServiceArea", "headerName":"Vehicle Service Area", "sortable": true, "width": 400, "editable": true},
	]
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var waitCount, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'updateVehicleInformation') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088')), 'vehicleRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
    } else {
      ___arguments['recordItem']['employee'] = (getObjectProperty(___arguments['recordItem'], 'relCurrentlyAssignedTo_Employee.objectId'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', true);
      // If the change address action is clicked then we show
      // the form to update the facility address and pass the
      // chosen item record over into the form's data container.
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088'))['vehicleRecord'] = ___arguments['recordItem'];
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    }
  } else if (___arguments['eventName'] == 'delete') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Delete operation timed out after 30s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      await Backendless.Data.of('Vehicle').remove( ___arguments['recordItem'] );
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    }
  } else if (___arguments['eventName'] == 'getSamsaraVehicleId') {
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/getVehicleId/matchVehicleToSamsara`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments['recordItem'], 'objectId'))));

    } catch (error) {
      console.log(error);
      (function (message) { alert(message) })(error);

    } finally {
      return ;

    }
  }

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/vehicles/components/45bee23a419ff7c9e93a5842096578f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehicles/components/f0b47b283a4ee883d73e9f978666c0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // Save the new facility into the Facility table and put
  // the returned objectId into the newFacility object
  (getObjectProperty(___arguments.context.dataModel, 'newVehicle'))['objectId'] = (getObjectProperty((await Backendless.Data.of('Vehicle').save( (getObjectProperty(___arguments.context.dataModel, 'newVehicle')) )), 'objectId'));
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Vehicle').setRelation((getObjectProperty(___arguments.context.dataModel, 'newVehicle')), 'relCurrentlyAssignedTo_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'newVehicle.employee')),'\''].join('')));
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'newVehicle.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/vehicles/components/4c44230b6b5983a3743bfdf3e943e3a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // Need to put this here since the submit button for the form is
  // set to default to avoid the 'submit on enter key press' issue.
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehicles/components/9ec5c52d7fa4ba838d0cdea8a1291ee3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehicles/components/87350f9abd387e213ce27961eb166986/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehicles/components/46868346d41eb8e9a1f7c20627239776/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehicles/components/00af44ca02488116c8749b36734af088/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  console.log(___arguments.context.dataModel);
  console.log(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord'));
  await Backendless.Data.of('Vehicle').save( (getObjectProperty(___arguments.context.dataModel, 'vehicleRecord')) );
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Vehicle').setRelation((getObjectProperty(___arguments.context.dataModel, 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord.employee')),'\''].join('')));
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);
  await new Promise(r => setTimeout(r, 5000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/vehicles/components/a5bd36dd116f46b49f03aaecf7e57d51/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/vehicles/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['employeeOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['statusOptions'] = ['In Service', 'In Maintenance', 'Decommissioned', 'Sold'];
  ___arguments.context.pageData['typeOptions'] = ['Caged', 'ADA Сompliant', 'Fortified', 'Large'];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vehicles/components/3daf61199bab46d90c369c21d968085f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vehicles/components/8b0a3cd24b587bf41911242b3303771c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vehicles/components/c32f417bdd5245a45ef5dbc53554d74e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'statusOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vehicles/components/e733f9d6b8371e62a95380a18b14ce7c/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['samsaraVehicleIdUnmasked'] = ___arguments['unmaskedValue'];
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['samsaraVehicleId'] = (___arguments['value'] == '____-___-___' ? '' : ___arguments['value']);

  },
  /* handler:onChangeValue */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* content */
}))

define('./pages/vehicles/components/e59bdb1229974e4dd2743d3649c6dec9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  await Backendless.Data.of('Vehicle').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee', [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee'))]);
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord.objectId'))] }));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['employee'] = null;
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['relCurrentlyAssignedTo_Employee'] = null;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', true);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', false);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord.relCurrentlyAssignedTo_Employee')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/vehicles/components/83d65071b39727b56fda392efeee9ba5/bundle.js', [], () => ({
  /* content */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['VIN'] = ___arguments['unmaskedValue'];

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/vehicles/components/e4a692caa25369e243a869b4927bf9f6/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(',');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['type'] = (value || null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vehicles/components/79ab6c2de1ff6ea8f7cdc907eab25915/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(',');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['type'] = (value || null);

  },
  /* handler:onChange */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle.type')) || (getObjectProperty(___arguments.context.pageData, 'typeOptions'))[0])

  },
  /* handler:valueLogic */
  /* content */
}))

define('./pages/vehtest/components/740edc770d55cacc04bbb8d920babc61/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
      return [({ [`label`]: 'Home',[`pageName`]: 'welcome' }), ({ [`label`]: 'Vehicles',[`pageName`]: 'vehicles' })]

  },
  /* handler:optionsLogic */
  /* handler:onItemClick */
  ['onItemClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(___arguments['pageName'], undefined);

  },
  /* handler:onItemClick */
  /* content */
}))

define('./pages/vehtest/components/5ace80b8ec397e9c5c0b03221b61217d/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  async ['columnDefsLogic'](___arguments) {
      return (await (async function(appData, pageData) {
	return [
	  {"type":"actions", "field": "actions", "width": 75, "minWidth": 75, "pinned": "left", meta: { align: "center"}},
	  {
	    "field": "vehicleName",
	    "headerName": "Vehicle Name",
	    "sort": "asc",
	    "sortable": true,
	    "width": 130,
	    "pinned": "left"
	  },
	  {"field": "relCurrentlyAssignedTo_Employee.nameFull", "headerName":"Assignee", "sortable": true, "width": 180, "editable": false},
	  {"field": "samsaraVehicleId", "headerName":"Samsara Vehicle Id", "sortable": true, "width": 160, "editable": true},
	  {
	    "cellEditor"      : "agSelectCellEditor",
	    "field"           : "status",
	    "headerName"      : "Status",
	    "editable"        : true,
	    "cellEditorParams": { "values": pageData.statusOptions || [] }
	  },
	  {
	    "type"              : "selectColumn",
	    "field"             : "type",
	    "headerName"        : "Type",
	    "isMulti"           : true,
	    "editable"          : true,
	    "cellRendererParams": { "withChips": true },
	    "cellEditorParams"  : { "values": pageData.typeOptions || [] }
	  },
	  {"field": "make", "headerName":"Make", "sortable": true, "width": 160, "editable": true},
	  {"field": "model", "headerName":"Model", "sortable": true, "width": 160, "editable": true},
	  {"field": "VIN", "headerName":"VIN", "sortable": true, "width": 160, "editable": true},
	  {"field": "vehicleServiceArea", "headerName":"Vehicle Service Area", "sortable": true, "width": 400, "editable": true},
	]
})(___arguments.context.appData, ___arguments.context.pageData))

  },
  /* handler:columnDefsLogic */
  /* handler:onActionIconClick */
  async ['onActionIconClick'](___arguments) {
    var waitCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // If they choose to delete a record, we popup a modal to confirm and use some logic along with a wait period to handle the deletion or abandonment.
  if (___arguments['eventName'] == 'updateVehicleInformation') {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088')), 'vehicleRecord.objectId')) == (getObjectProperty(___arguments['recordItem'], 'objectId'))) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
    } else {
      ___arguments['recordItem']['employee'] = (getObjectProperty(___arguments['recordItem'], 'relCurrentlyAssignedTo_Employee.objectId'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', true);
      // If the change address action is clicked then we show
      // the form to update the facility address and pass the
      // chosen item record over into the form's data container.
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('00af44ca02488116c8749b36734af088'))['vehicleRecord'] = ___arguments['recordItem'];
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    }
  } else if (___arguments['eventName'] == 'delete') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
    waitCount = 0;
    while ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null && waitCount <= 20) {
      await new Promise(r => setTimeout(r, 1000 || 0));
      waitCount = (typeof waitCount == 'number' ? waitCount : 0) + 1;
    }
    // This will happen if the modal times out or if they user clicks cancel.  The only way the deleteRecord flag turns true is if the user confirms the deletion.
    // We don't actually do anything here since the modal has already been closed.  Technically we don't need this elseIf block at all because we check for 'null' in the while loop.  Mainly putting this here for visibility.
    if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == null) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      if (waitCount >= 20) {
        (function (message) { alert(message) })('Delete operation timed out after 30s.');
      }
      return ;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == true) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      await Backendless.Data.of('Vehicle').remove( ___arguments['recordItem'] );
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    } else if ((getObjectProperty(___arguments.context.pageData, 'deleteRecord')) == false) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a5bd36dd116f46b49f03aaecf7e57d51');
      // Clear out the deleteRecord flag so that it's ready for subsequent deletions.
      ___arguments.context.pageData['deleteRecord'] = null;
    }
  }

  },
  /* handler:onActionIconClick */
  /* content */
}))

define('./pages/vehtest/components/45bee23a419ff7c9e93a5842096578f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehtest/components/f0b47b283a4ee883d73e9f978666c0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  // Save the new facility into the Facility table and put
  // the returned objectId into the newFacility object
  (getObjectProperty(___arguments.context.dataModel, 'newVehicle'))['objectId'] = (getObjectProperty((await Backendless.Data.of('Vehicle').save( (getObjectProperty(___arguments.context.dataModel, 'newVehicle')) )), 'objectId'));
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Vehicle').setRelation((getObjectProperty(___arguments.context.dataModel, 'newVehicle')), 'relCurrentlyAssignedTo_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'newVehicle.employee')),'\''].join('')));
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'newVehicle.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('748e6222bb6e762d965dd17667a8ad17', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/vehtest/components/4c44230b6b5983a3743bfdf3e943e3a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      // Need to put this here since the submit button for the form is
  // set to default to avoid the 'submit on enter key press' issue.
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehtest/components/9ec5c52d7fa4ba838d0cdea8a1291ee3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45bee23a419ff7c9e93a5842096578f2', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b47b283a4ee883d73e9f978666c0f9', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f0b47b283a4ee883d73e9f978666c0f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehtest/components/87350f9abd387e213ce27961eb166986/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehtest/components/46868346d41eb8e9a1f7c20627239776/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('00af44ca02488116c8749b36734af088');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vehtest/components/00af44ca02488116c8749b36734af088/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  console.log(___arguments.context.dataModel);
  console.log(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord'));
  await Backendless.Data.of('Vehicle').save( (getObjectProperty(___arguments.context.dataModel, 'vehicleRecord')) );
  // Set the relation in the region lookup table so that we can get the region later.
  // This is actually deployed by Backendless as a search of the related table treating this as a WHERE clause.  It goes and find the new relation that matches the clause.
  await Backendless.Data.of('Vehicle').setRelation((getObjectProperty(___arguments.context.dataModel, 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee', (['objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord.employee')),'\''].join('')));
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.dataModel, 'vehicleRecord.objectId'))] }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);
  await new Promise(r => setTimeout(r, 5000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/vehtest/components/a5bd36dd116f46b49f03aaecf7e57d51/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['deleteRecord'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/vehtest/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['employeeOptions'] = (await Promise.all((await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('samsaraDriverId IS NOT NULL AND samsaraDriverId != \'\' AND employmentStatus = \'Employed\'').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'nameFull')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['statusOptions'] = ['In Service', 'In Maintenance', 'Decommissioned', 'Sold'];
  ___arguments.context.pageData['typeOptions'] = ['Caged', 'ADA Сompliant', 'Fortified', 'Large'];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vehtest/components/3daf61199bab46d90c369c21d968085f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vehtest/components/8b0a3cd24b587bf41911242b3303771c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'employeeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vehtest/components/c32f417bdd5245a45ef5dbc53554d74e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'statusOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vehtest/components/e733f9d6b8371e62a95380a18b14ce7c/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['samsaraVehicleIdUnmasked'] = ___arguments['unmaskedValue'];
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['samsaraVehicleId'] = (___arguments['value'] == '____-___-___' ? '' : ___arguments['value']);

  },
  /* handler:onChangeValue */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* content */
}))

define('./pages/vehtest/components/e59bdb1229974e4dd2743d3649c6dec9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  await Backendless.Data.of('Vehicle').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee', [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord')), 'relCurrentlyAssignedTo_Employee'))]);
  await (getChannelInstance('default')).send('reload-table-records:Vehicle', ({ [`ids`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord.objectId'))] }));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['employee'] = null;
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['relCurrentlyAssignedTo_Employee'] = null;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('00af44ca02488116c8749b36734af088');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00af44ca02488116c8749b36734af088', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', true);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c31c1b154cad1a9d6aac04efad9022d', false);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord.relCurrentlyAssignedTo_Employee')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/vehtest/components/83d65071b39727b56fda392efeee9ba5/bundle.js', [], () => ({
  /* content */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['VIN'] = ___arguments['unmaskedValue'];

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./pages/vehtest/components/e4a692caa25369e243a869b4927bf9f6/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(',');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00af44ca02488116c8749b36734af088'), 'vehicleRecord'))['type'] = (value || null);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vehtest/components/79ab6c2de1ff6ea8f7cdc907eab25915/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'typeOptions')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(',');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle'))['type'] = (value || null);

  },
  /* handler:onChange */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f0b47b283a4ee883d73e9f978666c0f9'), 'newVehicle.type')) || (getObjectProperty(___arguments.context.pageData, 'typeOptions'))[0])

  },
  /* handler:valueLogic */
  /* content */
}))

define('./layouts/CoreDesktop/components/e05cfaa82063de982f79ab61a5c38781/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('welcome', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/CoreDesktop/components/root/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var employeeRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.appData);
  console.log(___arguments.context.layoutData);
  if (!(await BackendlessUI.Functions.Custom['fn_26770edb32d2692ee1c4754a799e58cf'](___arguments.context.appData))) {
    return ;
  }
  console.log('%c>>' + '', 'color: #26a69a', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('debugMode')));
  ___arguments.context.layoutData['debugMode'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('debugMode'));
  ___arguments.context.layoutData['navItems'] = [null, null, (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2 ? ({ [`navItemName`]: 'Transportation',[`navItemIcon`]: 'alt_route',[`navItemURL`]: undefined,[`navSubItems`]: [({ [`navSubItemName`]: 'Transport Requests',[`navSubItemURL`]: 'transport-requests' }), ({ [`navSubItemName`]: 'Transports',[`navSubItemURL`]: 'transports' }), null, null] }) : null, (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2 ? ({ [`navItemName`]: 'Vehicles',[`navItemIcon`]: 'directions_car',[`navItemURL`]: 'vehicles',[`navSubItems`]: undefined }) : null, (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2 ? ({ [`navItemName`]: 'Facilities',[`navItemIcon`]: 'house',[`navItemURL`]: 'facilities',[`navSubItems`]: undefined }) : null, (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2 ? ({ [`navItemName`]: 'Clients',[`navItemIcon`]: 'people_alt',[`navItemURL`]: 'clients',[`navSubItems`]: undefined }) : null, (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5 ? ({ [`navItemName`]: 'Reports',[`navItemIcon`]: 'insert_chart_outlined',[`navItemURL`]: undefined,[`navSubItems`]: [({ [`navSubItemName`]: 'Operations Report',[`navSubItemURL`]: 'operations-report' }), null] }) : null, (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 6 ? ({ [`navItemName`]: 'Billing',[`navItemIcon`]: 'attach_money',[`navItemURL`]: 'billing',[`navSubItems`]: [({ [`navSubItemName`]: 'Transactions',[`navSubItemURL`]: 'billing' }), ({ [`navSubItemName`]: 'Claims',[`navSubItemURL`]: 'claims' }), ({ [`navSubItemName`]: 'Payer List',[`navSubItemURL`]: 'payers' })] }) : null, (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 1 ? ({ [`navItemName`]: 'Driver Dashboard',[`navItemIcon`]: 'directions_car',[`navItemURL`]: 'driver-dashboard',[`navSubItems`]: [({ [`navSubItemName`]: 'Current Rides',[`navSubItemURL`]: 'current-rides' }), ({ [`navSubItemName`]: 'Past Rides',[`navSubItemURL`]: 'past-rides' })] }) : null, ({ [`navItemName`]: 'Directory',[`navItemIcon`]: 'person_search',[`navItemURL`]: 'directory',[`navSubItems`]: undefined }), (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 5 ? ({ [`navItemName`]: 'Admin Tools',[`navItemIcon`]: 'settings',[`navItemURL`]: undefined,[`navSubItems`]: [({ [`navSubItemName`]: 'User Management',[`navSubItemURL`]: 'user-management' }), ({ [`navSubItemName`]: 'Requester Mgmt.',[`navSubItemURL`]: 'requester-entity-mgmt' }), (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8 ? ({ [`navSubItemName`]: 'Data Xfer Util.',[`navSubItemURL`]: 'data-migration-tool' }) : null, (getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 8 ? ({ [`navSubItemName`]: 'PDF Trip Log Download',[`navSubItemURL`]: 'download-trip-logs' }) : null, null, null] }) : null];
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) && !(getObjectProperty(___arguments.context.layoutData, 'currentUserProfileImage'))) {
    employeeRecord = (await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause((['relEmail_Users.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.layoutData['currentUserProfileImage'] = (getObjectProperty(employeeRecord, 'profileImage'));
    console.log('Current User Profile Image');
    console.log(getObjectProperty(___arguments.context.layoutData, 'currentUserProfileImage'));
  }
  ___arguments.context.appData['currentEmployeeData'] = employeeRecord;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1023) {
    ___arguments.context.layoutData['menuVisability'] = false;
  } else {
    ___arguments.context.layoutData['menuVisability'] = true;
  }

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var command, usersOnline, userStatus, userMessages, chatUsers, pageSize, offset, records, count, tableData, employeeRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  ___arguments.context.appData['intervalIds'] = [];
  console.log('%c>> ' + 'AppData', 'color: #f06292', ___arguments.context.appData);

  ;(function() {
    const callback = async () => {
        if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'login' && !(await Backendless.UserService.isValidLogin())) {
      (function (message) { alert(message) })('You have been logged out due to inactivity.  You will be redirected to the login page.');
      ___arguments.context.appData['clearAllData'] = true;
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    }
    if (getObjectProperty(___arguments.context.appData, 'currentEmployeeData')) {
      await (getChannelInstance('userStatus')).send('status', (Object.assign((getObjectProperty(___arguments.context.appData, 'currentEmployeeData')), ({ [`lastUpdated`]: ((new Date()).valueOf()) }))));
    }
    if (getObjectProperty(___arguments.context.appData, 'usersStatus')) {
      console.log('%c>> ' + 'UPDATE', 'color: #ffee58', undefined);
      await (async function(usersStatus) {
      	const now = Date.now()
      	const timeoutLimit = 2 * 60 * 1000

      	for (const userId in usersStatus) {
      	  console.log('!!!', now - usersStatus[userId].lastUpdated)
      	  if (now - usersStatus[userId].lastUpdated > timeoutLimit) {
      	    console.log(`User ${usersStatus[userId].nameFull} is now offline`)
      	    delete usersStatus[userId]
      	  }
      	}
      })((getObjectProperty(___arguments.context.appData, 'usersStatus')));
    }

    };

    const timerId = 'userLogoutTimer';
    const timerDelay = 60000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  await new Promise(r => setTimeout(r, 3000 || 0));
  if (getObjectProperty(___arguments.context.appData, 'currentEmployeeData')) {
    console.log('%c>> ' + '!!!!', 'color: #4caf50', undefined);
    count = (await Backendless.Data.of('Chats').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['type = \'private\' AND (user1.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),'\' OR user2.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),'\')'].join('')))));
    pageSize = 100;
    offset = 0;
    tableData = [];
    userMessages = [];
    while (offset < count) {
      records = (await Backendless.Data.of('Chats').find(Backendless.DataQueryBuilder.create().setWhereClause((['type = \'private\' AND (user1.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),'\' OR user2.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),'\')'].join(''))).setProperties(['Messages[chatId].message', 'Messages[chatId].senderName', 'Messages[chatId].senderId', 'Messages[chatId].receiverId', 'Messages[chatId].created', 'objectId']).setPageSize(pageSize).setOffset(offset)));
      addItemToList(userMessages, records);
      offset = offset + pageSize;
    }
    userMessages = (await Backendless.Data.of('Chats').find(Backendless.DataQueryBuilder.create().setWhereClause((['type = \'private\' AND (user1.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),'\' OR user2.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),'\')'].join(''))).setProperties(['Messages[chatId].message', 'Messages[chatId].senderName', 'Messages[chatId].senderId', 'Messages[chatId].receiverId', 'Messages[chatId].created', 'objectId']).setPageSize(100)));
    chatUsers = (await Backendless.Data.of('Employee').find(Backendless.DataQueryBuilder.create().setWhereClause('employmentStatus = \'Employed\'').setRelationsDepth(1).setSortBy('nameFull').setPageSize(100)));
    ___arguments.context.appData['chatData'] = (await (async function(currentUserId, userMessages, chatUsers) {
    	    const result = {
    	        messages: {},
    	        usersStatus: [],
    	        selectedUser: "",
    	        selectedUserName: "",
    	        chatIds: {},
    	        notifications: {},
    	        chatUsers: []
    	    };

    	    userMessages.forEach(message => {
    	        const otherUserId = message.senderId === currentUserId
    	            ? message.receiverId
    	            : message.senderId;

    	        if (!result.messages[otherUserId]) {
    	            result.messages[otherUserId] = [];
    	        }


    	        result.messages[otherUserId].push(message);


    	        if (!result.chatIds[otherUserId]) {
    	            result.chatIds[otherUserId] = message.objectId || null;
    	        }
    	    });


    	    for (const userId in result.messages) {
    	        result.messages[userId].sort((a, b) => a.created - b.created);
    	    }

    	    if (chatUsers) {
    	      result.chatUsers = chatUsers
    	      .filter(user => user.relEmail_Users.objectId !== currentUserId)
    	      .map(item => {
    	        item.currentUserId = item.relEmail_Users.objectId;

    	        return item;
    	      }).sort((userA, userB) => {
    	    const messagesA = result.messages[userA.currentUserId] || [];
    	    const messagesB = result.messages[userB.currentUserId] || [];


    	    if (messagesA.length > 0 && messagesB.length === 0) return -1;
    	    if (messagesA.length === 0 && messagesB.length > 0) return 1;


    	    const lastMessageA = messagesA[messagesA.length - 1]?.created || 0;
    	    const lastMessageB = messagesB[messagesB.length - 1]?.created || 0;

    	    return lastMessageB - lastMessageA;
    	  })
    	    }

    	    return result;
    })((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')), userMessages, chatUsers));
  }

  ;(function() {
    const callback = async command => {
        console.log('%c>> ' + 'command', 'color: #f06292', command);
    userStatus = ({  });
    userStatus[(getObjectProperty(command, 'userId'))] = (getObjectProperty(command, 'data'));
    ___arguments.context.appData['usersStatus'] = (Object.assign(((getObjectProperty(___arguments.context.appData, 'usersStatus')) || ({  })), userStatus));
    usersOnline = (getObjectProperty(___arguments.context.appData, 'usersStatus')) ? (await (async function(currentUser, usersStatus) {

    	  return Object.entries(usersStatus)
    	    .filter(([key]) => key !== currentUser)
    	    .map(([key, value]) => ({
    	      ...value,
    	      currentUserId: key,
    	    }));

    })((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')), (getObjectProperty(___arguments.context.appData, 'usersStatus')))) : [];
    (getObjectProperty(___arguments.context.appData, 'chatData'))['usersOnline'] = usersOnline;

    };

    const channel = getChannelInstance('userStatus');

    channel.addCommandListener(callback);

    getRTSubscriptions().add('usersStatusListener', () => channel.removeCommandListener(callback));
  })();
  await new Promise(r => setTimeout(r, 3000 || 0));
  console.log('%c>> ' + 'channel', 'color: #ffee58', String('chat:') + String(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd4bfed7e1fa550ffe640f6fe429e855', []);

  ;(function() {
    const callback = async command => {
        console.log('%c>> ' + 'currentUser.objectId', 'color: #ffee58', (getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    console.log('%c>> ' + 'data.senderId', 'color: #ffee58', (getObjectProperty(command, 'data.senderId')));
    console.log('%c>> ' + 'data.receiverId', 'color: #ffee58', (getObjectProperty(command, 'data.receiverId')));
    if ((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) == (getObjectProperty(command, 'userId')) || (getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) == (getObjectProperty(command, 'data.receiverId'))) {
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) == (getObjectProperty(command, 'data.receiverId'))) {
        if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.messages')), (getObjectProperty(command, 'data.senderId')))) {
          addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.messages')), (getObjectProperty(command, 'data.senderId')))), (getObjectProperty(command, 'data')));
          console.log('%c>> ' + '444444', 'color: #26c6da', undefined);
        } else {
          console.log('%c>> ' + '11111111111', 'color: #26c6da', undefined);
          (getObjectProperty(___arguments.context.appData, 'chatData.messages'))[(getObjectProperty(command, 'data.senderId'))] = [(getObjectProperty(command, 'data'))];
          (getObjectProperty(___arguments.context.appData, 'chatData.chatIds'))[(getObjectProperty(command, 'data.senderId'))] = (getObjectProperty(command, 'data.chatId'));
        }
        (getObjectProperty(___arguments.context.appData, 'chatData'))['chatUsers'] = (await (async function(userId, chatUsers) {
        	const targetElement = chatUsers.find(item => item.currentUserId === userId);

        	  const filteredArray = chatUsers.filter(item => item.currentUserId !== userId);

        	  if (targetElement) {
        	    filteredArray.unshift(targetElement);
        	  }

        	  return filteredArray
        })((getObjectProperty(command, 'data.senderId')), (getObjectProperty(___arguments.context.appData, 'chatData.chatUsers'))));
        if (!(getObjectProperty(___arguments.context.appData, 'chatData.open')) || (getObjectProperty(___arguments.context.appData, 'chatData.selectedUser')) != (getObjectProperty(command, 'data.senderId'))) {
          (getObjectProperty(___arguments.context.appData, 'chatData.notifications'))[(getObjectProperty(command, 'data.senderId'))] = true;
        }
      } else {
        if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.messages')), (getObjectProperty(command, 'data.receiverId')))) {
          addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.messages')), (getObjectProperty(command, 'data.receiverId')))), (getObjectProperty(command, 'data')));
          console.log('%c>> ' + '33333', 'color: #26c6da', undefined);
        } else {
          console.log('%c>> ' + '2222222222', 'color: #26c6da', undefined);
          (getObjectProperty(___arguments.context.appData, 'chatData.messages'))[(getObjectProperty(command, 'data.receiverId'))] = [(getObjectProperty(command, 'data'))];
          (getObjectProperty(___arguments.context.appData, 'chatData.chatIds'))[(getObjectProperty(command, 'data.receiverId'))] = (getObjectProperty(command, 'data.chatId'));
        }
        (getObjectProperty(___arguments.context.appData, 'chatData'))['chatUsers'] = (await (async function(userId, chatUsers) {
        	const targetElement = chatUsers.find(item => item.currentUserId === userId);

        	  const filteredArray = chatUsers.filter(item => item.currentUserId !== userId);

        	  if (targetElement) {
        	    filteredArray.unshift(targetElement);
        	  }

        	  return filteredArray
        })((getObjectProperty(command, 'data.receiverId')), (getObjectProperty(___arguments.context.appData, 'chatData.chatUsers'))));
      }
    }
    console.log('%c>> ' + 'chatCommand', 'color: #26a69a', command);
    console.log('%c>> ' + 'repeaterData', 'color: #ffee58', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('dd4bfed7e1fa550ffe640f6fe429e855')));

    };

    const channel = getChannelInstance('chat');

    channel.addCommandListener(callback);

    getRTSubscriptions().add('chatListener', () => channel.removeCommandListener(callback));
  })();

  },
  /* handler:onEnter */
  /* content */
}))

define('./layouts/CoreDesktop/components/c6b526acb939610d3c346fd99f05727f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8403b0d1e64167b8da9adaa98f0a4a39', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/CoreDesktop/components/4a8187342a8a3cd9e54ac8337bc632b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('feedback', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/CoreDesktop/components/9ce9a7150095b3fccecd174ed054be8a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/042c6fcc18a9a6145fcdc88fceedcb9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234'](___arguments.context.pageData);
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('welcome', undefined);
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/CoreDesktop/components/00d42cb6b57da50cbf3247fbcd691eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/CoreDesktop/components/3551e1e7a158838d47a65cf31fd71bb8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      localStorage.setItem('debugMode', JSON.stringify(___arguments.value));
  ___arguments.context.layoutData['debugMode'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.layoutData, 'debugMode'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/0fff4b132d51bcf2e19df0dde42b1082/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) == 8)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/38ac27d280b1d4c622fe1592d6cef1c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cacb5b5c50e997f48e57db0e135abe7f')).indexOf('hidden') + 1 > 0) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cacb5b5c50e997f48e57db0e135abe7f')), 'hidden', '');
    (getObjectProperty(___arguments.context.appData, 'chatData'))['open'] = true;
  } else {
    if ('none' == (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cacb5b5c50e997f48e57db0e135abe7f')), 'style')), 'display'))) {
      (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cacb5b5c50e997f48e57db0e135abe7f')), 'style'))['display'] = 'flex';
      (getObjectProperty(___arguments.context.appData, 'chatData'))['open'] = true;
      delete (getObjectProperty(___arguments.context.appData, 'chatData.notifications'))[(getObjectProperty(___arguments.context.appData, 'chatData.selectedUser'))];
    } else {
      (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cacb5b5c50e997f48e57db0e135abe7f')), 'style'))['display'] = 'none';
      (getObjectProperty(___arguments.context.appData, 'chatData'))['open'] = false;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'chatData')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/28dac9eb29b723fe67293c8863b78e04/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var newMessage, messageText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  if (___arguments.keyCode == 13) {
    messageText = (getObjectProperty(___arguments.context.layoutData, 'message'));
    ___arguments.context.layoutData['message'] = '';
    await (getChannelInstance('chat')).send('msg', ({ [`chatId`]: (getObjectProperty(___arguments.context.appData, 'chatData.currentChatId')),[`senderId`]: (getObjectProperty(___arguments.context.appData, 'currentUser.objectId')),[`senderName`]: (getObjectProperty(___arguments.context.appData, 'currentEmployeeData.nameFull')),[`receiverId`]: (getObjectProperty(___arguments.context.appData, 'chatData.selectedUser')),[`message`]: messageText,[`created`]: ((new Date()).valueOf()) }));
    newMessage = (await Backendless.Data.of('Messages').save( ({ [`senderName`]: (getObjectProperty(___arguments.context.appData, 'currentEmployeeData.nameFull')),[`senderId`]: (getObjectProperty(___arguments.context.appData, 'currentUser.objectId')),[`receiverId`]: (getObjectProperty(___arguments.context.appData, 'chatData.selectedUser')),[`message`]: messageText }) ));
    await Backendless.Data.of('Messages').setRelation(newMessage, 'userId', [({ [`objectId`]: (getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')) })]);
    await Backendless.Data.of('Messages').setRelation(newMessage, 'chatId', [({ [`objectId`]: (getObjectProperty(___arguments.context.appData, 'chatData.currentChatId')) })]);
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'chatData.selectedUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/a4e4fb17f5e319fa2c02da7adf6f9b1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) && (getObjectProperty(___arguments.context.appData, 'chatData.usersOnline')) ? String('+') + String(((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 515 ? (await (async function(currentUser, usersStatus) {
	return Object.entries(usersStatus)
	  .filter(([key]) => key !== currentUser)
	  .map(([key, value]) => ({
	    ...value,
	    currentUserId: key,
	  }))

})((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')), (getObjectProperty(___arguments.context.appData, 'usersStatus')))).length - 4 : (await (async function(currentUser, usersStatus) {
	return Object.entries(usersStatus)
	  .filter(([key]) => key !== currentUser)
	  .map(([key, value]) => ({
	    ...value,
	    currentUserId: key,
	  }))

})((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')), (getObjectProperty(___arguments.context.appData, 'usersStatus')))).length) : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/1bf52b8a630605546a211db6ebb2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'usersStatus')) ? (await (async function(currentUser, usersStatus) {
	return Object.entries(usersStatus)
	  .filter(([key]) => key !== currentUser)
	  .map(([key, value]) => ({
	    ...value,
	    currentUserId: key,
	  }))

})((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')), (getObjectProperty(___arguments.context.appData, 'usersStatus')))).slice(0, 4) : [])

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 515)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/d91541dc7d0c1861b8e54decc12295e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) ? ((getObjectProperty(___arguments.context.appData, 'chatData.searchValue')) ? (await (async function(arr, inputValue) {
	    return arr.filter(item =>
	      item.nameFull.toLowerCase().includes(inputValue.toLowerCase())
	    );
})((getObjectProperty(___arguments.context.appData, 'chatData.chatUsers')), (getObjectProperty(___arguments.context.appData, 'chatData.searchValue')))) : (getObjectProperty(___arguments.context.appData, 'chatData.chatUsers'))) : [])

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/297635db679bc8032ca4b90cc96674e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var isChatExists, newChat;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData.selectedUser')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')) ? ['selected-user'] : ['userProfileImageChat'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/f3ecb9a364584ed1d8974ec16b8ae436/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('13e292f5adbba95bb80b59aaeb7f8637'), 'senderId')) ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('13e292f5adbba95bb80b59aaeb7f8637'), 'senderId')) == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) ? ['message-bubble-current'] : ['message-bubble']) : [])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/84ab0971f3f67df918aac796acc76467/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('13e292f5adbba95bb80b59aaeb7f8637'), 'senderId')) && (getObjectProperty(___arguments.context.appData, 'usersStatus')) && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'usersStatus')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('13e292f5adbba95bb80b59aaeb7f8637'), 'senderId')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'usersStatus')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('13e292f5adbba95bb80b59aaeb7f8637'), 'senderId')))), 'profileImage')) : null)

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/13e292f5adbba95bb80b59aaeb7f8637/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'senderId')) == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) ? ['message-wrapper-current'] : ['message-wrapper'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/1c61350bef334cc904e9423be2af5a49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) ? (Object.keys((getObjectProperty(___arguments.context.appData, 'chatData.notifications')))).length > 0 : null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/6b41dad8631eb87c40b340ea36ea8fa9/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('13e292f5adbba95bb80b59aaeb7f8637'), 'senderId')) == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) ? ['message-title-current'] : ['message-title'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/1ca5107ab415588af806515dfe6352d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.notifications')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')))) : null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/a5e448bb83d8d1b7aa11e94d21aaafd2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('308d1f3c63a8cf598d292d18d6ee7db4')), 'style'))['display'] = 'flex';
  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a5e448bb83d8d1b7aa11e94d21aaafd2')), 'style'))['display'] = 'none';
  (getObjectProperty(___arguments.context.appData, 'chatData'))['selectedUser'] = '';
  (getObjectProperty(___arguments.context.appData, 'chatData'))['selectedUserName'] = '';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData.selectedUser')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/2fed732d674aceff5dbe2bc9b32b0d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var lastMessage, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lastMessage = '';
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')) && (getObjectProperty(___arguments.context.appData, 'chatData'))) {
    if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.messages')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')))) {
      lastMessage = (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.messages')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')))).slice(-1)[0]), 'message'));
    }
  }

  return lastMessage

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/ef1443979135a8dc4d624b2e168f51c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var isChatExists, newChat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('308d1f3c63a8cf598d292d18d6ee7db4')), 'style'))['display'] = 'none';
  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a5e448bb83d8d1b7aa11e94d21aaafd2')), 'style'))['display'] = 'flex';
  (getObjectProperty(___arguments.context.appData, 'chatData'))['selectedUser'] = (getObjectProperty(___arguments.context.dataModel, 'currentUserId'));
  (getObjectProperty(___arguments.context.appData, 'chatData'))['selectedUserName'] = (getObjectProperty(___arguments.context.dataModel, 'nameFull'));
  (getObjectProperty(___arguments.context.appData, 'chatData'))['currentChatId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.chatIds')), (getObjectProperty(___arguments.context.dataModel, 'currentUserId'))));
  delete (getObjectProperty(___arguments.context.appData, 'chatData.notifications'))[(getObjectProperty(___arguments.context.dataModel, 'currentUserId'))];
  if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData')), 'messages')), (getObjectProperty(___arguments.context.dataModel, 'currentUserId')))) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd4bfed7e1fa550ffe640f6fe429e855', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData')), 'messages')), (getObjectProperty(___arguments.context.dataModel, 'currentUserId')))));
  } else {
    console.log('checkChat');
    if (!(getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.chatIds')), (getObjectProperty(___arguments.context.dataModel, 'currentUserId'))))) {
      isChatExists = (await Backendless.Data.of('Chats').find(Backendless.DataQueryBuilder.create().setWhereClause((['type = \'private\' AND (user1.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),'\' OR user1.objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'objectId')),'\') AND (user2.objectId = \'',(getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')),'\' OR user2.objectId = \'',(getObjectProperty(___arguments.context.dataModel, 'objectId')),'\')'].join(''))).setPageSize(10)));
      if (isChatExists.length == 0) {
        newChat = (await Backendless.Data.of('Chats').save( ({ [`permissionLevel`]: null,[`type`]: 'private' }) ));
        await Backendless.Data.of('Chats').setRelation(newChat, 'user1', [({ [`objectId`]: (getObjectProperty(___arguments.context.appData, 'currentEmployeeData.objectId')) })]);
        await Backendless.Data.of('Chats').setRelation(newChat, 'user2', [({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')) })]);
        (getObjectProperty(___arguments.context.appData, 'chatData'))['currentChatId'] = (getObjectProperty(newChat, 'objectId'));
        (getObjectProperty(___arguments.context.appData, 'chatData.chatIds'))[(getObjectProperty(___arguments.context.dataModel, 'currentUserId'))] = (getObjectProperty(newChat, 'objectId'));
      } else {
        (getObjectProperty(___arguments.context.appData, 'chatData'))['currentChatId'] = (getObjectProperty((isChatExists[0]), 'objectId'));
        (getObjectProperty(___arguments.context.appData, 'chatData.chatIds'))[(getObjectProperty(___arguments.context.dataModel, 'currentUserId'))] = (getObjectProperty((isChatExists[0]), 'objectId'));
      }
    }
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData')), 'messages'))[(getObjectProperty(___arguments.context.dataModel, 'currentUserId'))] = [({  })];
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd4bfed7e1fa550ffe640f6fe429e855', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData')), 'messages')), (getObjectProperty(___arguments.context.dataModel, 'currentUserId')))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/CoreDesktop/components/2d0e2b87c5b755140e62cb6f18da796e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) ? (getObjectProperty(___arguments.context.appData, 'chatData.selectedUserName')) : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/3dcba38993bcfbb677c24fbde4ae234d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cacb5b5c50e997f48e57db0e135abe7f')), 'style'))['display'] = 'none';
  (getObjectProperty(___arguments.context.appData, 'chatData'))['open'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/CoreDesktop/components/d20e1736c95463c70c96fde97e7cc77c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) && (getObjectProperty(___arguments.context.appData, 'chatData.usersOnline')) ? (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 515 ? (await (async function(currentUser, usersStatus) {
	return Object.entries(usersStatus)
	  .filter(([key]) => key !== currentUser)
	  .map(([key, value]) => ({
	    ...value,
	    currentUserId: key,
	  }))

})((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')), (getObjectProperty(___arguments.context.appData, 'usersStatus')))).length > 4 : (await (async function(currentUser, usersStatus) {
	return Object.entries(usersStatus)
	  .filter(([key]) => key !== currentUser)
	  .map(([key, value]) => ({
	    ...value,
	    currentUserId: key,
	  }))

})((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')), (getObjectProperty(___arguments.context.appData, 'usersStatus')))).length > 1) : null)

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) && (getObjectProperty(___arguments.context.appData, 'chatData.usersOnline')) ? (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 515 ? (await Promise.all((subsequenceFromStartLast((getObjectProperty(___arguments.context.appData, 'chatData.usersOnline')), 4)).map(async item => {; return (getObjectProperty(item, 'nameFull'));}))).join(', ') : (await Promise.all((getObjectProperty(___arguments.context.appData, 'chatData.usersOnline')).map(async item => {; return (getObjectProperty(item, 'nameFull'));}))).join(', ')) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/cc4c583b6c88f6f54d9db3298ab44477/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.appData, 'chatData'))['searchValue'] = '';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) ? (getObjectProperty(___arguments.context.appData, 'chatData.searchValue')) : null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/a12f81f136544447210a2bf7970d2cca/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'chatData')) ? (getObjectProperty(___arguments.context.appData, 'chatData.searchValue')) : '')

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.appData, 'chatData'))['searchValue'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./layouts/CoreDesktop/components/830e5645d3f7ac86888dc92bcb538cd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'usersStatus')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')) ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'usersStatus')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')))) : null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/4a08079f34550cc554319ada505953be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var messageDate, messageDateText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  messageDateText = '';
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('13e292f5adbba95bb80b59aaeb7f8637'), 'created')) {
    messageDate = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('13e292f5adbba95bb80b59aaeb7f8637'), 'created'))));
    messageDateText = messageDate ? ((new Date((new Date())).getDate()) == (new Date(messageDate).getDate()) && (new Date((new Date())).getMonth() + 1) == (new Date(messageDate).getMonth() + 1) && (new Date((new Date())).getFullYear()) == (new Date(messageDate).getFullYear()) ? (new Intl.DateTimeFormat('en-US', ({ [`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format(messageDate)) : (new Intl.DateTimeFormat('en-US', ({ [`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format(messageDate))) : '';
  }

  return messageDateText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/e2987c91e7b7890cc73d4d31add68c2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var messageDateText, messageDate, lastMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  messageDateText = '';
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')) && (getObjectProperty(___arguments.context.appData, 'chatData'))) {
    if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.messages')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')))) {
      lastMessage = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'chatData.messages')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ef1443979135a8dc4d624b2e168f51c7'), 'currentUserId')))).slice(-1)[0];
      if (getObjectProperty(lastMessage, 'created')) {
        messageDate = (new Date((getObjectProperty(lastMessage, 'created'))));
        messageDateText = messageDate ? ((new Date((new Date())).getDate()) == (new Date(messageDate).getDate()) && (new Date((new Date())).getMonth() + 1) == (new Date(messageDate).getMonth() + 1) && (new Date((new Date())).getFullYear()) == (new Date(messageDate).getFullYear()) ? (new Intl.DateTimeFormat('en-US', ({ [`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format(messageDate)) : (new Intl.DateTimeFormat('en-US', ({ [`month`]: '2-digit',[`day`]: '2-digit',[`timeZone`]: 'America/Chicago' })).format(messageDate))) : '';
      }
    }
  }

  return messageDateText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/65a99e4e4664a2e5f6362978e211b422/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/CoreDesktop/components/8234a3090e45ba6a08de5a38a5731804/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'currentUser.rideCareUserAttributes.permissionLevel')) >= 2)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8949b1e4679cfb3982db4f9a7b9fea41/logic/3fd88caa1f21a2bbcc6aa0e5c06debfe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('296ea19726628d7ca7839fc1917b5dc5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc43cde7178c58ba01b73b8837ec79fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fd88caa1f21a2bbcc6aa0e5c06debfe', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8949b1e4679cfb3982db4f9a7b9fea41/logic/bc43cde7178c58ba01b73b8837ec79fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('296ea19726628d7ca7839fc1917b5dc5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc43cde7178c58ba01b73b8837ec79fb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fd88caa1f21a2bbcc6aa0e5c06debfe', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8949b1e4679cfb3982db4f9a7b9fea41/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_8949b1e4679cfb3982db4f9a7b9fea41/logic/296ea19726628d7ca7839fc1917b5dc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'navSubItems'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_8949b1e4679cfb3982db4f9a7b9fea41/logic/23cf5615800ca65aff08db41e056bbbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.dataModel, 'navSubItemURL'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.dataModel, 'navSubItemURL')), undefined);
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1023) {
    ___arguments.context.layoutData['menuVisability'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`color`]: ((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == (getObjectProperty(___arguments.context.dataModel, 'navSubItemURL')) ? 'red' : 'green' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_8949b1e4679cfb3982db4f9a7b9fea41/logic/0159bfa388bdcdc94e8cb2ca813e10fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.rootComponentData, 'navItemURL')) != null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.rootComponentData, 'navItemURL')), undefined);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('296ea19726628d7ca7839fc1917b5dc5', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc43cde7178c58ba01b73b8837ec79fb', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fd88caa1f21a2bbcc6aa0e5c06debfe', undefined);
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1023) {
    ___arguments.context.layoutData['menuVisability'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8949b1e4679cfb3982db4f9a7b9fea41/logic/0911fc45139f78df6d247fe97e261ebb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'navSubItems')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/062fa30963b2fbdacbd8a4a1859fabf7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('355f774dd2e8cadbb81fa38c63e5e4ac', undefined);
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isReturnTripNeeded'] = ___arguments.value;
  if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['datetimeReturnTrip'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/280974f57ee5625b32f6668fdf11f27c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var nearbyExistingFacilities;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.gacPickupLocation')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['gacPickupLocation'];
  }
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')));
  ___arguments.context.rootComponentData['showNewPickUpFacilityMessage'] = false;
  ___arguments.context.rootComponentData['pickUpFacilityAddressMessage'] = null;
  ___arguments.context.rootComponentData['locationType'] = 'pickUp';
  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.rootComponentData, (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')));
  if (___arguments.value && (await BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord'))))) {
    nearbyExistingFacilities = (await BackendlessUI.Functions.Custom['fn_353440ef7fa2e9257227e5c5351d9062']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')), ___arguments.context.rootComponentData));
    ___arguments.context.rootComponentData['nearbyExistingFacilities'] = nearbyExistingFacilities;
    ___arguments.context.rootComponentData['selectedNearbyExistingFacility'] = ((Array.isArray((getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')))) ? (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities'))[0] : (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')));
    if (Array.isArray(nearbyExistingFacilities)) {
      if (nearbyExistingFacilities.length >= 1) {
        ___arguments.context.rootComponentData['showSelectExistingFacilityModal'] = true;
      } else {
        ___arguments.context.rootComponentData['showNewPickUpFacilityMessage'] = true;
        ___arguments.context.rootComponentData['pickUpFacilityAddressMessage'] = 'This address will be added to our Facility database.';
      }
    } else {
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')));
      Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
      ___arguments.context.rootComponentData['pickUpFacilityAddressMessage'] = 'We found an exact match to this facility in our records.';
    }
  }
  // THIS DB Record is redundant now that we're
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googleFormattedAddress'));
  // THIS DB Record is redundant now that we're fully merged to facilities table
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googleName'));
  // THIS DB Record is redundant now that we're fully merged to facilities table
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googlePlaceId'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isPickupPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.isPrivateResidence')) ? true : false);
  console.log(___arguments.context.rootComponentData);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/54ee890f50d9bd0ce5b2606992d73eca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var nearbyExistingFacilities;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.gacDestinationLocation')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['gacDestinationLocation'];
  }
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
  ___arguments.context.rootComponentData['showNewDestinationFacilityMessage'] = false;
  ___arguments.context.rootComponentData['destinationFacilityAddressMessage'] = null;
  ___arguments.context.rootComponentData['locationType'] = 'destination';
  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.rootComponentData, (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
  if (___arguments.value && (await BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord'))))) {
    nearbyExistingFacilities = (await BackendlessUI.Functions.Custom['fn_353440ef7fa2e9257227e5c5351d9062']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')), ___arguments.context.rootComponentData));
    ___arguments.context.rootComponentData['nearbyExistingFacilities'] = nearbyExistingFacilities;
    ___arguments.context.rootComponentData['selectedNearbyExistingFacility'] = ((Array.isArray((getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')))) ? (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities'))[0] : (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')));
    if (Array.isArray(nearbyExistingFacilities)) {
      if (nearbyExistingFacilities.length >= 1) {
        ___arguments.context.rootComponentData['showSelectExistingFacilityModal'] = true;
      } else {
        ___arguments.context.rootComponentData['showNewDestinationFacilityMessage'] = true;
        ___arguments.context.rootComponentData['destinationFacilityAddressMessage'] = 'This address will be added to our Facility database.';
      }
    } else {
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
      Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
      ___arguments.context.rootComponentData['destinationFacilityAddressMessage'] = 'We found an exact match to this facility in our records.';
    }
  }
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleFormattedAddress'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleName'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googlePlaceId'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isDestinationPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.isPrivateResidence')) ? true : false);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/fa7fc596fe223729ff353769b03dd6ec/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord')) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationContactPhone'] = ___arguments['unmaskedValue'];
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/ae1acbae501398b5603ccd7bce2ee279/bundle.js', [], () => ({
  /* content */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'showSelectExistingFacilityModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2bca3fcbfcf61fd799e8885f6b51eeb1'](___arguments.context.rootComponentData);

  },
  /* handler:onClose */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/4507a4962e250c4e7142660a4a8c97d1/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.rootComponentData

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/3cdd8b51ecdb89ace5aa6b5ae00db96f/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/2623352f6518486a9ff5f41fbdbf04fa/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/5c58f712881e07c2a4d4a11de7d1c17b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/22ea74b3638c31011d7921a364b47e53/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['nameFirst'] = (textToTitleCase(___arguments.value));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.nameFirst')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['nameFirst'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/003c11e5a42580d8540952a9f22699eb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['nameLast'] = (textToTitleCase(___arguments.value));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.nameLast')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['nameLast'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_253caf4ef7f8495256b5b4756b37c8e9/logic/b03ec976f35dffdaca162e434d76bc8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['nameFirst'] = (textToTitleCase(___arguments.value));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.destinationContactName')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['destinationContactName'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_e4aad6e4c9010c8202e26726fe73c6e7/logic/0aba91970b585d31ba7df10196f75215/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')) ? (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')) : []).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'googleName')),' - ',(getObjectProperty(item, 'googleFormattedAddress'))].join(''),[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.rootComponentData['selectedNearbyExistingFacility'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility'))

  },
  /* handler:valueLogic */
  /* content */
}))

define('./components/reusable/r_e4aad6e4c9010c8202e26726fe73c6e7/logic/5ee696aab4d25213e53e25c21b9f5dc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.rootComponentData, 'locationType')) == 'pickUp') {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')));
    Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
    // THIS DB Record is redundant now that we're
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googleFormattedAddress'));
    // THIS DB Record is redundant now that we're fully merged to facilities table
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googleName'));
    // THIS DB Record is redundant now that we're fully merged to facilities table
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googlePlaceId'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isPickupPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.isPrivateResidence')) ? true : false);
  }
  if ((getObjectProperty(___arguments.context.rootComponentData, 'locationType')) == 'destination') {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
    Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleFormattedAddress'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleName'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googlePlaceId'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isDestinationPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.isPrivateResidence')) ? true : false);
  }
  if ((getObjectProperty(___arguments.context.rootComponentData, 'locationType')) == 'newFacility') {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'newFacility')));
    Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'newFacility')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
  }
  ___arguments.context.rootComponentData['showSelectExistingFacilityModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e4aad6e4c9010c8202e26726fe73c6e7/logic/f95dbb8dca63a25af02861268e14e449/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2bca3fcbfcf61fd799e8885f6b51eeb1'](___arguments.context.rootComponentData);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ac59ef5a4d7b9c969a195c84ae16db9a/logic/fff15a7eb464ab67adb4779702cdc3ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['driverStatus'] = (await Backendless.Request.get(`${Backendless.appPath}/services/driverVehicleAwareness/DriverAvailability`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('21cf2052d10aa3916cc23e219ef6675b', (getObjectProperty(___arguments.context.pageData, 'driverStatus')));
  if (getObjectProperty(___arguments.context.pageData, 'startingLocation')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('21cf2052d10aa3916cc23e219ef6675b', (await Backendless.Request.post(`${Backendless.appPath}/services/sortDriverStatusTable/sortDriverTable`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'driverAvailability': (getObjectProperty(___arguments.context.pageData, 'driverStatus')),'startingLatitude': (getObjectProperty(___arguments.context.pageData, 'startingLocation.latitude')),'startingLongitude': (getObjectProperty(___arguments.context.pageData, 'startingLocation.longitude')) })));
  }
  ___arguments.context.pageData['driverAvailabilityForMap'] = (await Backendless.Request.post(`${Backendless.appPath}/services/createRoute/showDriverRoutesForMap`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'driverStatus')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ac59ef5a4d7b9c969a195c84ae16db9a/logic/0b0fd5c2b68f2af40121d669ae5da091/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('abc');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b43687895a795b645d5bd172153885a2'), 'scheduledArrivalTime'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b43687895a795b645d5bd172153885a2'), 'scheduledArrivalTime')) == null) {
    return ;
  }

  return (new Intl.DateTimeFormat('en-US', ({ [`year`]: 'numeric',[`month`]: '2-digit',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`hour12`]: true,[`timeZone`]: 'America/Chicago' })).format((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b43687895a795b645d5bd172153885a2'), 'scheduledArrivalTime'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/38ee6fd5a7ec9783965bf82d679a4481/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isCOVID19TestRequired'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/bfde8eb98458e42d3ff9d6f6bbac61bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isCOVID19Positive'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/606912ea0e136f5fc4f515dfbdf9f0df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showChickasawSpecialty'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/1f4dff82529c5d46014c5c4bb0018663/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showCOVIDquestions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/a4af2451ae87dd8fea14fe0aec6dfc25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showCOVIDquestions')) && !(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isCOVID19Positive')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/57cfd5957c78ba3517dc9adb7fb74aa3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showCOVIDquestions')) && !(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isCOVID19Positive')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/d086ab38d5dd2677920b2cb7dc4e8879/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showCOVIDquestions')) && (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isCOVID19TestRequired')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/60f909d9322fd93bc0932f598d7760c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showCOVIDquestions')) && (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isCOVID19TestRequired')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/10e464d50e7b5f0b7c1548763d8732fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showFollowUpContact'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b50616ffd98cae9816891407f4d8aa55/logic/01d93cad4df6f2540a57af53cfbbccb1/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.followUpContactPhone')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.followUpContactPhone'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['followUpContactPhone'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/38ee6fd5a7ec9783965bf82d679a4481/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isReferralToNearestUrcOrCc'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/bfde8eb98458e42d3ff9d6f6bbac61bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isTMTR'] = ___arguments.value;
  if (((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isMCTR')) || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isTMTR')) || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isContactedYMCR'))) == true) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['showNearestURCorCC'] = true;
  } else {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['showNearestURCorCC'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/55862b713f7f4f835b97802d85dfd8ef/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isMCTR'] = ___arguments.value;
  if (((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isMCTR')) || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isTMTR')) || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isContactedYMCR'))) == true) {
    (getObjectProperty(___arguments.context.rootComponentData, 'visibilityLogic'))['showNearestURCorCC'] = true;
  } else {
    (getObjectProperty(___arguments.context.rootComponentData, 'visibilityLogic'))['showNearestURCorCC'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/141dfb7beb1e0a6c41fc9217054271ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.showNearestURCorCC'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/cd56e03924c13b45cff60fa31cbeacd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.is18')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/f28e35d4ad857d547e4e8a01b8298647/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.is18')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/5b75645ec67eaabcf364ee469dafbd61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.showNearestURCorCC'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/37dafd9a169d3dd1e1b7f4eec33abb76/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isContactedYMCR'] = ___arguments.value;
  if (((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isMCTR')) || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isTMTR')) || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isContactedYMCR'))) == true) {
    (getObjectProperty(___arguments.context.rootComponentData, 'visibilityLogic'))['showNearestURCorCC'] = true;
  } else {
    (getObjectProperty(___arguments.context.rootComponentData, 'visibilityLogic'))['showNearestURCorCC'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_21f84a89e7cda6223b7a487877ba3bef/logic/2d77bbaf2af1bcb3d382dd7b7bfbdf11/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.rootComponentData, (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
  // THIS DB Record is redundant now that we're
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleFormattedAddress'));
  // THIS DB Record is redundant now that we're fully merged to facilities table
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleName'));
  // THIS DB Record is redundant now that we're fully merged to facilities table
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googlePlaceId'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isDestinationPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.isPrivateResidence')) ? true : false);
  console.log(___arguments.context.rootComponentData);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3ae82b25b4cddc01b29d8fb2dd5ce113/logic/a2fad2f355ee29ad10df385c73748238/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isDREAMScourt'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3ae82b25b4cddc01b29d8fb2dd5ce113/logic/38ee6fd5a7ec9783965bf82d679a4481/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36eeb221af78259329daf9aea049c773', undefined);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3ae82b25b4cddc01b29d8fb2dd5ce113/logic/37dafd9a169d3dd1e1b7f4eec33abb76/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isTransportFromJailOrDetentionCenter'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3ae82b25b4cddc01b29d8fb2dd5ce113/logic/bd735984f5167d7560f9f2b605e5a26d/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.detentionCenterPhone')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.detentionCenterPhone'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['detentionCenterPhone'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_3ae82b25b4cddc01b29d8fb2dd5ce113/logic/8a8f213eeaf60e8d883f6e667974b78b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isTransportFromJailOrDetentionCenter'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3ae82b25b4cddc01b29d8fb2dd5ce113/logic/0e7b465587ffb8cdb4f7617a7707abb1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isTransportFromJailOrDetentionCenter'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3ae82b25b4cddc01b29d8fb2dd5ce113/logic/2c81197bb639af4a1952744a1755d77f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1df496f854f881e705b867fccf99cd28', undefined);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/37dafd9a169d3dd1e1b7f4eec33abb76/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isEOD'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/062fa30963b2fbdacbd8a4a1859fabf7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isReturnTripNeeded'] = ___arguments.value;
  if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['datetimeReturnTrip'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/c394a2a418582eebdb47f96898b5e585/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isPickupSameInfoAsReferring'] = ___arguments.value;
  if (___arguments.value == true) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupContactName'] = (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.referringContactName'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupContactPhone'] = (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.referringContactPhone'));
    console.log(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.referringContactPhone'));
    console.log(___arguments.context.rootComponentData);
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupContactName'] = null;
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupContactPhone'] = null;
    console.log(___arguments.context.rootComponentData);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/2972b6028ea707bd7253fc7fee97a113/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.referringContactPhone')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.referringContactPhone'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['referringContactPhone'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/d397bbef6b9259c55ef42a81a05f2233/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.pickupContactPhone')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.pickupContactPhone'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupContactPhone'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/698d6f43d4a32d3d3e11aefac331e4bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.destinationContactPhone')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.destinationContactPhone'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationContactPhone'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/280974f57ee5625b32f6668fdf11f27c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var nearbyExistingFacilities;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.gacPickupLocation')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['gacPickupLocation'];
  }
  ___arguments.context.rootComponentData['showSpinner'] = true;
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')));
  ___arguments.context.rootComponentData['showNewPickUpFacilityMessage'] = false;
  ___arguments.context.rootComponentData['pickUpFacilityAddressMessage'] = null;
  ___arguments.context.rootComponentData['locationType'] = 'pickUp';
  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.rootComponentData, (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')));
  if (___arguments.value && (await BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord'))))) {
    nearbyExistingFacilities = (await BackendlessUI.Functions.Custom['fn_353440ef7fa2e9257227e5c5351d9062']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')), ___arguments.context.rootComponentData));
    ___arguments.context.rootComponentData['nearbyExistingFacilities'] = nearbyExistingFacilities;
    ___arguments.context.rootComponentData['selectedNearbyExistingFacility'] = ((Array.isArray((getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')))) ? (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities'))[0] : (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')));
    if (Array.isArray(nearbyExistingFacilities)) {
      if (nearbyExistingFacilities.length >= 1) {
        ___arguments.context.rootComponentData['showSelectExistingFacilityModal'] = true;
      } else {
        ___arguments.context.rootComponentData['showNewPickUpFacilityMessage'] = true;
        ___arguments.context.rootComponentData['pickUpFacilityAddressMessage'] = 'This address will be added to our Facility database.';
      }
    } else {
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')));
      Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
      ___arguments.context.rootComponentData['pickUpFacilityAddressMessage'] = 'We found an exact match to this facility in our records.';
    }
  }
  // THIS DB Record is redundant now that we're
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googleFormattedAddress'));
  // THIS DB Record is redundant now that we're fully merged to facilities table
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googleName'));
  // THIS DB Record is redundant now that we're fully merged to facilities table
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googlePlaceId'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isPickupPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.isPrivateResidence')) ? true : false);
  await new Promise(r => setTimeout(r, 300 || 0));
  ___arguments.context.rootComponentData['showSpinner'] = false;
  console.log('abc');
  console.log(___arguments.context.rootComponentData);

  },
  /* handler:onChange */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('280974f57ee5625b32f6668fdf11f27c', undefined, ({ [`country`]: 'us' }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/54ee890f50d9bd0ce5b2606992d73eca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var nearbyExistingFacilities;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.gacDestinationLocation')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['gacDestinationLocation'];
  }
  ___arguments.context.rootComponentData['showSpinner'] = true;
  await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
  ___arguments.context.rootComponentData['showNewDestinationFacilityMessage'] = false;
  ___arguments.context.rootComponentData['destinationFacilityAddressMessage'] = null;
  ___arguments.context.rootComponentData['locationType'] = 'destination';
  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.rootComponentData, (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
  if (___arguments.value && (await BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord'))))) {
    nearbyExistingFacilities = (await BackendlessUI.Functions.Custom['fn_353440ef7fa2e9257227e5c5351d9062']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')), ___arguments.context.rootComponentData));
    ___arguments.context.rootComponentData['nearbyExistingFacilities'] = nearbyExistingFacilities;
    ___arguments.context.rootComponentData['selectedNearbyExistingFacility'] = ((Array.isArray((getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')))) ? (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities'))[0] : (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')));
    if (Array.isArray(nearbyExistingFacilities)) {
      if (nearbyExistingFacilities.length >= 1) {
        ___arguments.context.rootComponentData['showSelectExistingFacilityModal'] = true;
      } else {
        ___arguments.context.rootComponentData['showNewDestinationFacilityMessage'] = true;
        ___arguments.context.rootComponentData['destinationFacilityAddressMessage'] = 'This address will be added to our Facility database.';
      }
    } else {
      await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
      Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
      ___arguments.context.rootComponentData['destinationFacilityAddressMessage'] = 'We found an exact match to this facility in our records.';
    }
  }
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleFormattedAddress'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleName'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googlePlaceId'));
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isDestinationPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.isPrivateResidence')) ? true : false);
  await new Promise(r => setTimeout(r, 300 || 0));
  ___arguments.context.rootComponentData['showSpinner'] = false;

  },
  /* handler:onChange */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('54ee890f50d9bd0ce5b2606992d73eca', undefined, ({ [`country`]: 'us' }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/65deb26957ff114c2e6d9a8629aae82d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b55642b9124eac0a8972e72447d592ca', undefined);
  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['datetimeRequestedPickup'] = ___arguments.value;
  if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['datetimeRequestedPickup'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/a7df05fa88c7b6395d7e36c8447adfac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isEOD')) && !(getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showPresetPickupTimes')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/f0a91f9c6a274f7fccfa7de24b4dfeca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.isEOD')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/3cdd8b51ecdb89ace5aa6b5ae00db96f/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datetimeSubmission')) {
    return (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datetimeSubmission'));
  } else {
    return (new Date());
  }

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/2623352f6518486a9ff5f41fbdbf04fa/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datetimeSubmission')) {
    return (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datetimeSubmission'));
  } else {
    return (new Date());
  }

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/5c58f712881e07c2a4d4a11de7d1c17b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datetimeSubmission')) {
    return (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datetimeSubmission'));
  } else {
    return (new Date());
  }

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/3e7875bfc3b27ce7b2c67ed348722c88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'isReadOnlyMode')) || (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.objectId')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/a70e5c8962f638f6b42bf739a51baecc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'isReadOnlyMode')) || (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.objectId')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/5329fad593236f91712384b6a1815871/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'isReadOnlyMode')) || (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.objectId')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/0a618f3c1a03ee77556e5f96a683af8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'isReadOnlyMode')) || (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.objectId')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/061a8c43bca291c227c9074cd778b804/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ___arguments.context.rootComponentData

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/e8ce028ff665d1298b936a2fda54c72b/bundle.js', [], () => ({
  /* content */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'showSelectExistingFacilityModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2bca3fcbfcf61fd799e8885f6b51eeb1'](___arguments.context.rootComponentData);

  },
  /* handler:onClose */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/cd56e03924c13b45cff60fa31cbeacd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showPresetPickupTimes')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/a2e996cde4c6ae9d169272959ea13ec9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.showPresetPickupTimes'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/d57929ab877f232d5ffa4fb6552aa9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(new Date(([((new Date(___arguments.value)).toDateString()),' ',(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.timePresetRequestedPickup'))].join(''))));
  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.timePresetRequestedPickup')) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['datetimeRequestedPickup'] = ((new Date(([((new Date(___arguments.value)).toDateString()),' ',(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.timePresetRequestedPickup'))].join('')))).valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/d2f582ec2aea5024677f1379b963018c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.rootComponentData, 'requesterRecord.presetPickupTimes')).split(',')).map(async item => {; return ({ [`label`]: item,[`value`]: item });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(new Date(([((new Date((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datePresetRequestedPickup')))).toDateString()),' ',___arguments.value].join(''))));
  if (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datePresetRequestedPickup')) {
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['datetimeRequestedPickup'] = ((new Date(([((new Date((getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.datePresetRequestedPickup')))).toDateString()),' ',___arguments.value].join('')))).valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/9a1c7cdceab432ed03e82dad60f20d93/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'pickUpFacilityAddressMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'pickUpFacilityAddressMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/54729205a4dd331fe3b9e88846d560b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityAddressMessage'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityAddressMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/003c11e5a42580d8540952a9f22699eb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['referringContactName'] = (textToTitleCase(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/65bb19b9c845b81d75a5887adf06fa36/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupContactName'] = (textToTitleCase(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/b03ec976f35dffdaca162e434d76bc8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationContactName'] = (textToTitleCase(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/0b6755e35a82126f71f41af6d5735d66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('State Submitted Pickup Address:   ') + String(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.pickupAddressString')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/367cbe1a86f5a9ce6adbae0808db1aa9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('State Submitted Dropoff Address:  ') + String(getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord.destinationAddressString')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/b6535ac97b15ae31d0a4fc7efa964b9a/bundle.js', [], () => ({
  /* content */
  /* handler:onCopy */
  async ['onCopy'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).copy() })('b6535ac97b15ae31d0a4fc7efa964b9a');

  },
  /* handler:onCopy */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/5c082327e921ee0bbf5cc079c9d8ea3d/bundle.js', [], () => ({
  /* content */
  /* handler:onCopy */
  async ['onCopy'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).copy() })('5c082327e921ee0bbf5cc079c9d8ea3d');

  },
  /* handler:onCopy */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/09e4fa161b1b40b8cac9842fd98ebe86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'requesterId')) == 'STATE') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_095c58b157be92b2268418f7df2b1ee5/logic/5c5e83f8ab55d933f2b55d3454166dce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'requesterId')) == 'STATE') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_4bbcd89a7529d7a9684967a82ac5e85e/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.rootComponentData['clientRecord'] = ({ [`isFedRecognizedTribal`]: false,[`isVeteran`]: false,[`hasHistoryOfViolence`]: false,[`isElopementRisk`]: false,[`hasSpecialPrecautionsOrMedicalNeeds`]: false });

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_4bbcd89a7529d7a9684967a82ac5e85e/logic/1cec4f2b2954d0b8ae8a1a822b8f018d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.isClientMedicallyClearedForTransportToday')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['isClientMedicallyClearedForTransportToday'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_4bbcd89a7529d7a9684967a82ac5e85e/logic/0c13f537cc34050d6535dcd61c5e4ee8/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.isClientMedicallyClearedForTransportToday')) {
    return [(getObjectProperty(___arguments.context.rootComponentData, 'errors.isClientMedicallyClearedForTransportToday')), 'toggleStyled'];
  } else {
    return ['toggleStyled'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_4bbcd89a7529d7a9684967a82ac5e85e/logic/d1029a988f248fd7fd3ca49d23f8abac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.isClientSuicideOrSelfHarmRiskToday')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['isClientSuicideOrSelfHarmRiskToday'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_4bbcd89a7529d7a9684967a82ac5e85e/logic/e774b157595a446f53de06cf8311a50a/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.isClientSuicideOrSelfHarmRiskToday')) {
    return [(getObjectProperty(___arguments.context.rootComponentData, 'errors.isClientSuicideOrSelfHarmRiskToday')), 'toggleStyled'];
  } else {
    return ['toggleStyled'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_4bbcd89a7529d7a9684967a82ac5e85e/logic/00fe2b362f177f24a0f2b7e929b96dce/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.isClientFallRiskToday')) {
    return [(getObjectProperty(___arguments.context.rootComponentData, 'errors.isClientFallRiskToday')), 'toggleStyled'];
  } else {
    return ['toggleStyled'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_4bbcd89a7529d7a9684967a82ac5e85e/logic/24c69964522548ac5c2eeeb218a9118b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'typeInsuranceList')) ? (getObjectProperty(___arguments.context.rootComponentData, 'typeInsuranceList')) : [])

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_4bbcd89a7529d7a9684967a82ac5e85e/logic/0a161aa4f64f6d262a45fa08db3351b7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['insurancePolicyNumber'] = (___arguments.value.toUpperCase());

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_aae26f2aa1173e73060940f378b5562c/logic/0aba91970b585d31ba7df10196f75215/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all(((getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')) ? (getObjectProperty(___arguments.context.rootComponentData, 'nearbyExistingFacilities')) : []).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'googleName')),' - ',(getObjectProperty(item, 'googleFormattedAddress'))].join(''),[`value`]: item });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.rootComponentData['selectedNearbyExistingFacility'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility'))

  },
  /* handler:valueLogic */
  /* content */
}))

define('./components/reusable/r_aae26f2aa1173e73060940f378b5562c/logic/5ee696aab4d25213e53e25c21b9f5dc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.rootComponentData, 'locationType')) == 'pickUp') {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')));
    Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
    // THIS DB Record is redundant now that we're
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googleFormattedAddress'));
    // THIS DB Record is redundant now that we're fully merged to facilities table
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googleName'));
    // THIS DB Record is redundant now that we're fully merged to facilities table
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['pickupLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.googlePlaceId'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isPickupPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'pickupFacilityRecord.isPrivateResidence')) ? true : false);
  }
  if ((getObjectProperty(___arguments.context.rootComponentData, 'locationType')) == 'destination') {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')));
    Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationAddress'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleFormattedAddress'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationName'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googleName'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['destinationLocationGooglePlaceId'] = (getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.googlePlaceId'));
    (getObjectProperty(___arguments.context.rootComponentData, 'transportRequestRecord'))['isDestinationPrivateResidence'] = ((getObjectProperty(___arguments.context.rootComponentData, 'destinationFacilityRecord.isPrivateResidence')) ? true : false);
  }
  if ((getObjectProperty(___arguments.context.rootComponentData, 'locationType')) == 'newFacility') {
    await BackendlessUI.Functions.Custom['fn_7255f85fc6a82072e01d2b1fe97e5234']((getObjectProperty(___arguments.context.rootComponentData, 'newFacility')));
    Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'newFacility')), (getObjectProperty(___arguments.context.rootComponentData, 'selectedNearbyExistingFacility')));
  }
  ___arguments.context.rootComponentData['showSelectExistingFacilityModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_aae26f2aa1173e73060940f378b5562c/logic/f95dbb8dca63a25af02861268e14e449/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2bca3fcbfcf61fd799e8885f6b51eeb1'](___arguments.context.rootComponentData);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/c74826f370a10ce5d1dec29594535005/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var errorMessage, emptyFields, zipcode, stateCode, city;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.googleFormattedAddress')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['googleFormattedAddress'];
  }
  await BackendlessUI.Functions.Custom['fn_ef8e0b29f86598cb7952fbb6554552da'](___arguments.value, ___arguments.context.rootComponentData, (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')));
  if (___arguments.value) {
    await BackendlessUI.Functions.Custom['fn_4cb910622f862deed7d75d5b7699dd27']((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')));
  }

  },
  /* handler:onChange */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('c74826f370a10ce5d1dec29594535005', undefined, ({ [`country`]: 'us' }), undefined, undefined, undefined, undefined, undefined, ['address'], undefined, undefined, undefined, undefined);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/12e551238b4c1be5464b3fa206699e75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['tribeAffiliations'] = ((await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(','));

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'tribeOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/cd13e9b493e3629a6791880fcfd763b1/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var millisecondsPerYear, age, clientDateOfBirth, monthDifference, timestampDateOfBirth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  timestampDateOfBirth = (await (async function(dateString) {
  	const dateParts = dateString.split('/');

  	const month = parseInt(dateParts[0], 10) - 1;
  	const day = parseInt(dateParts[1], 10);
  	const year = parseInt(dateParts[2], 10);

  	const date = new Date(year, month, day);

  	return date.getTime();
  })(___arguments['value']));
  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['dateOfBirth'] = timestampDateOfBirth;
  clientDateOfBirth = (new Date(timestampDateOfBirth));
  age = (new Date((new Date())).getUTCFullYear()) - (new Date(clientDateOfBirth).getUTCFullYear());
  monthDifference = (new Date((new Date())).getUTCMonth()) - (new Date(clientDateOfBirth).getUTCMonth());
  if (monthDifference < 0 || monthDifference == 0 && (new Date((new Date())).getUTCDate()) < (new Date(clientDateOfBirth).getUTCDate())) {
    age = age - 1;
  }
  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['age'] = age;
  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['is18'] = (age >= 18);
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.dateOfBirth')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['dateOfBirth'];
  }

  },
  /* handler:onComplete */
  /* handler:initValueLogic */
  async ['initValueLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(timestamp) {
	    if (!timestamp) {
	      return ''
	    }

	    const date = new Date(timestamp);

	    const month = date.getMonth() + 1;
	    const day = date.getDate();
	    const year = date.getFullYear();

	    const monthString = month < 10 ? '0' + month : month.toString();
	    const dayString = day < 10 ? '0' + day : day.toString();

	    return `${monthString}${dayString}${year}`;
})((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.dateOfBirth'))))

  },
  /* handler:initValueLogic */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/4fc1e97dfb079ee6830e58871a1baed2/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.phone')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.phone'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['phone'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/6e75cdf41de4bc4995c861e64fd4d4ad/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.phoneAlt')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.phoneAlt'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['phoneAlt'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/9b61dda6ab0a5d2b036bdd868573d971/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.emergencyContactPhone')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['emergencyContactPhone'];
  }
  if (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.emergencyContactPhone')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.emergencyContactPhone'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['emergencyContactPhone'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/d657d143c9a45549f23d499be2aac39b/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.emergencyContactPhoneAlt')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.emergencyContactPhoneAlt'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['emergencyContactPhoneAlt'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/03d6423ab8168bb5b2e9fa511976243c/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.soonerCareId')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.soonerCareId'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['soonerCareId'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/a88291e58444e72977d5a62bef83ee23/bundle.js', [], () => ({
  /* content */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      if (!((new RegExp('^[0-9a-zA-Z]+$', '')).test(___arguments['value']))) {
    return '';
  }

  return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.medicareId')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.medicareId'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['medicareId'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/22ea74b3638c31011d7921a364b47e53/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['nameFirst'] = (textToTitleCase(___arguments.value));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.nameFirst')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['nameFirst'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/c7fc650597d706880301a3fa20016861/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['nameLast'] = (textToTitleCase(___arguments.value));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.nameLast')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['nameLast'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/1bd5d9ec4ecddc7e73c7509a72c67574/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.heightFt')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['heightFt'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/442359d28e84ca2ddbf4f1ef66273c6b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.heightIn')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['heightIn'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/858fbc8a5f0d0fb72104f8b9b51201b7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.weight')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['weight'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/a4d35d1d19b895b84f34c102c94c4034/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['email'] = (___arguments.value.toLowerCase());
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.email')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['email'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/7d1bfbd5d4d819855bee4315b7694b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['emailAlt'] = (___arguments.value.toLowerCase());
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.emailAlt')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['emailAlt'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/999a754915b9e343e9dd9b4c19fb7303/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['assignedSexAtBirth'] = ((await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(','));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.assignedSexAtBirth')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['assignedSexAtBirth'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/179aba9d060af265ca45f46f0364bee2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['preferredPronouns'] = ((await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(','));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.preferredPronouns')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['preferredPronouns'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/a91587b27f16ea4dde6ebdddd86af98c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['genderIdentity'] = ((await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(','));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.genderIdentity')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['genderIdentity'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/5b6319c1faafe2443c68c6024c616f34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['sexualOrientation'] = ((await Promise.all(___arguments['selectValue'].map(async item => {; return (getObjectProperty(item, 'label'));}))).join(','));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.sexualOrientation')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['sexualOrientation'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/a1bcc8b3962449ac70f77d359263227a/bundle.js', [], () => ({
  /* content */
  /* handler:onChangeValue */
  ['onChangeValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')) {
    if (___arguments['unmaskedValue'] || (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.SSN')) && getValueLength((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.soonerCareId'))) == 1) {
      (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['SSN'] = ___arguments['unmaskedValue'];
    }
  }

  },
  /* handler:onChangeValue */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/79714b9fbc833f327addabcb52bf0ef3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['nickname'] = (textToTitleCase(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/9eb32dac54e1e64fa8d7c52ef1cf8c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['emergencyContactName'] = (textToTitleCase(___arguments.value));
  if (getObjectProperty(___arguments.context.rootComponentData, 'errors.emergencyContactName')) {
    delete (getObjectProperty(___arguments.context.rootComponentData, 'errors'))['emergencyContactName'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/5a5e02c2d9715004d4c2af4af7ed0077/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['emergencyContactNameAlt'] = (textToTitleCase(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/209da341adaab549d3970a0b1dd2ffec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9a61b10f85be1687f244350ab948fbc2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('209da341adaab549d3970a0b1dd2ffec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f566430f5e38bd6ad55bdcca10196661', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7104a42f77d9cb08a434fee3510e90ca', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fccbdff72041fea316cd40fd8e78bf79', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/f566430f5e38bd6ad55bdcca10196661/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9a61b10f85be1687f244350ab948fbc2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('209da341adaab549d3970a0b1dd2ffec', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f566430f5e38bd6ad55bdcca10196661', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7104a42f77d9cb08a434fee3510e90ca', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fccbdff72041fea316cd40fd8e78bf79', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/2fc1d985b99aa025d53b99cd51d62b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['numberInsurancePolicies'] = ((Number((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')))) + 1);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) < 3)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/b2b3295a8fc495630ddabad652da8fe3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['numberInsurancePolicies'] = ((Number((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')))) - 1);
  if ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) == 2) {
    Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')), ({ [`typeInsuranceTertiary`]: null,[`insuranceProviderTertiary`]: null,[`insurancePolicyNumberTertiary`]: null }));
  } else if ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) == 1) {
    Object.assign((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord')), ({ [`typeInsuranceTertiary`]: null,[`insuranceProviderTertiary`]: null,[`insurancePolicyNumberTertiary`]: null,[`typeInsuranceSecondary`]: null,[`insuranceProviderSecondary`]: null,[`insurancePolicyNumberSecondary`]: null }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) > 1)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/eb5b089da1f5dd4483ba1f3169c4efdf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) > 1)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/87b3ea6624d341330087a25a010367a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) > 2)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/0b5a6ecf063923a116a419035fb4879e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) < 2)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/44c5cec67925832a0db74294994c4d04/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) > 2)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/85326c2f2bf2acc8685fcbd11cd583b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.rootComponentData, 'clientRecord.numberInsurancePolicies')) == 2)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/cfc2bc414ae16a86847b20353b9a8643/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'SoonerCare (XIX)' || ___arguments.value == 'Medicare' || ___arguments.value == 'Medicaid (MCO)' || ___arguments.value == 'Dept. Mental Health (DMH)') {
    (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['insuranceProvider'] = ___arguments.value;
  } else {
    (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['insuranceProvider'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/207271b500976e943461e63680d7b3be/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'SoonerCare (XIX)' || ___arguments.value == 'Medicare' || ___arguments.value == 'Medicaid (MCO)' || ___arguments.value == 'Dept. Mental Health (DMH)') {
    (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['insuranceProviderSecondary'] = ___arguments.value;
  } else {
    (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['insuranceProviderSecondary'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/e7c337c95e63fa12f02afab43499be35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'SoonerCare (XIX)' || ___arguments.value == 'Medicare' || ___arguments.value == 'Medicaid (MCO)' || ___arguments.value == 'Dept. Mental Health (DMH)') {
    (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['insuranceProviderTertiary'] = ___arguments.value;
  } else {
    (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['insuranceProviderTertiary'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3e7e33dc03ee20effceca406deee9edd/logic/820aa0628ea95fc31aa5bbafbb475719/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.rootComponentData, 'clientRecord'))['SSN'] = '999999999';

  },
  /* handler:onClick */
  /* content */
}))

